// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
}

/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */
/* ================= YSABEAU OFFICE ================= */

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}

.social-smugmug:before,
.social-dribbble:before,
.social-youtube:before,
.social-vimeo:before,
.social-twitter:before,
.social-tumblr:before,
.social-pinterest:before,
.social-linkedin:before,
.social-instagram:before,
.social-google:before,
.social-foursquare:before,
.social-flickr:before,
.social-facebook:before,
.social-fivehundredpix:before,
.social-fivehundredpx:before,
.social-email:before,
.social-github:before,
.social-rss:before,
.social-spotify:before,
.social-soundcloud:before,
.social-itunes:before,
.social-googleplay:before,
.social-dropbox:before,
.social-bandsintown:before,
.social-behance:before,
.social-codepen:before,
.social-medium:before,
.social-rdio:before,
.social-squarespace:before,
.social-vine:before,
.social-yelp:before,
.social-vevo:before,
.social-meetup:before,
.social-twitch:before,
.social-vsco:before,
.social-smugmug-square:before,
.social-dribbble-square:before,
.social-youtube-square:before,
.social-vimeo-square:before,
.social-twitter-square:before,
.social-tumblr-square:before,
.social-pinterest-square:before,
.social-linkedin-square:before,
.social-instagram-square:before,
.social-google-square:before,
.social-foursquare-square:before,
.social-flickr-square:before,
.social-facebook-square:before,
.social-fivehundredpix-square:before,
.social-fivehundredpx-square:before,
.social-email-square:before,
.social-github-square:before,
.social-rss-square:before,
.social-spotify-square:before,
.social-soundcloud-square:before,
.social-itunes-square:before,
.social-googleplay-square:before,
.social-dropbox-square:before,
.social-bandsintown-square:before,
.social-behance-square:before,
.social-codepen-square:before,
.social-medium-square:before,
.social-rdio-square:before,
.social-squarespace-square:before,
.social-vine-square:before,
.social-yelp-square:before,
.social-vevo-square:before,
.social-meetup-square:before,
.social-twitch-square:before,
.social-vsco-square:before,
.social-smugmug-round:before,
.social-dribbble-round:before,
.social-youtube-round:before,
.social-vimeo-round:before,
.social-twitter-round:before,
.social-tumblr-round:before,
.social-pinterest-round:before,
.social-linkedin-round:before,
.social-instagram-round:before,
.social-google-round:before,
.social-foursquare-round:before,
.social-flickr-round:before,
.social-facebook-round:before,
.social-fivehundredpix-round:before,
.social-fivehundredpx-round:before,
.social-email-round:before,
.social-github-round:before,
.social-rss-round:before,
.social-spotify-round:before,
.social-soundcloud-round:before,
.social-itunes-round:before,
.social-googleplay-round:before,
.social-dropbox-round:before,
.social-bandsintown-round:before,
.social-behance-round:before,
.social-codepen-round:before,
.social-medium-round:before,
.social-rdio-round:before,
.social-squarespace-round:before,
.social-vine-round:before,
.social-yelp-round:before,
.social-vevo-round:before,
.social-meetup-round:before,
.social-twitch-round:before,
.social-vsco-round:before {
  font-family: "social-icon-font";
  speak: none;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.social-smugmug:before {
  content: "\\e600";
}

.social-icon-style-square .social-smugmug:before {
  content: "\\e601";
}

.social-icon-style-round .social-smugmug:before {
  content: "\\e602";
}

.social-dribbble:before {
  content: "\\e603";
}

.social-icon-style-square .social-dribbble:before {
  content: "\\e604";
}

.social-icon-style-round .social-dribbble:before {
  content: "\\e605";
}

.social-youtube:before {
  content: "\\e606";
}

.social-icon-style-square .social-youtube:before {
  content: "\\e607";
}

.social-icon-style-round .social-youtube:before {
  content: "\\e608";
}

.social-vimeo:before {
  content: "\\e609";
}

.social-icon-style-square .social-vimeo:before {
  content: "\\e60a";
}

.social-icon-style-round .social-vimeo:before {
  content: "\\e60b";
}

.social-twitter:before {
  content: "\\e60c";
}

.social-icon-style-square .social-twitter:before {
  content: "\\e60d";
}

.social-icon-style-round .social-twitter:before {
  content: "\\e60e";
}

.social-tumblr:before {
  content: "\\e60f";
}

.social-icon-style-square .social-tumblr:before {
  content: "\\e610";
}

.social-icon-style-round .social-tumblr:before {
  content: "\\e611";
}

.social-pinterest:before {
  content: "\\e612";
}

.social-icon-style-square .social-pinterest:before {
  content: "\\e613";
}

.social-icon-style-round .social-pinterest:before {
  content: "\\e614";
}

.social-linkedin:before {
  content: "\\e615";
}

.social-icon-style-square .social-linkedin:before {
  content: "\\e616";
}

.social-icon-style-round .social-linkedin:before {
  content: "\\e617";
}

.social-instagram:before {
  content: "\\e618";
}

.social-icon-style-square .social-instagram:before {
  content: "\\e619";
}

.social-icon-style-round .social-instagram:before {
  content: "\\e61a";
}

.social-foursquare:before {
  content: "\\e61e";
}

.social-icon-style-square .social-foursquare:before {
  content: "\\e61f";
}

.social-icon-style-round .social-foursquare:before {
  content: "\\e620";
}

.social-flickr:before {
  content: "\\e621";
}

.social-icon-style-square .social-flickr:before {
  content: "\\e622";
}

.social-icon-style-round .social-flickr:before {
  content: "\\e623";
}

.social-facebook:before {
  content: "\\e624";
}

.social-icon-style-square .social-facebook:before {
  content: "\\e625";
}

.social-icon-style-round .social-facebook:before {
  content: "\\e626";
}

.social-fivehundredpix:before {
  content: "\\e627";
}

.social-icon-style-square .social-fivehundredpix:before {
  content: "\\e628";
}

.social-icon-style-round .social-fivehundredpix:before {
  content: "\\e629";
}

.social-fivehundredpx:before {
  content: "\\e627";
}

.social-icon-style-square .social-fivehundredpx:before {
  content: "\\e628";
}

.social-icon-style-round .social-fivehundredpx:before {
  content: "\\e629";
}

.social-email:before {
  content: "\\e62a";
}

.social-icon-style-square .social-email:before {
  content: "\\e62b";
}

.social-icon-style-round .social-email:before {
  content: "\\e62c";
}

.social-github:before {
  content: "\\e62d";
}

.social-icon-style-square .social-github:before {
  content: "\\e62e";
}

.social-icon-style-round .social-github:before {
  content: "\\e62f";
}

.social-rss:before {
  content: "\\e630";
}

.social-icon-style-square .social-rss:before {
  content: "\\e631";
}

.social-icon-style-round .social-rss:before {
  content: "\\e632";
}

.social-spotify:before {
  content: "\\e633";
}

.social-icon-style-square .social-spotify:before {
  content: "\\e634";
}

.social-icon-style-round .social-spotify:before {
  content: "\\e635";
}

.social-soundcloud:before {
  content: "\\e636";
}

.social-icon-style-square .social-soundcloud:before {
  content: "\\e637";
}

.social-icon-style-round .social-soundcloud:before {
  content: "\\e638";
}

.social-itunes:before {
  content: "\\e639";
}

.social-icon-style-square .social-itunes:before {
  content: "\\e63a";
}

.social-icon-style-round .social-itunes:before {
  content: "\\e63b";
}

.social-googleplay:before {
  content: "\\e63c";
}

.social-icon-style-square .social-googleplay:before {
  content: "\\e63d";
}

.social-icon-style-round .social-googleplay:before {
  content: "\\e63e";
}

.social-dropbox:before {
  content: "\\e63f";
}

.social-icon-style-square .social-dropbox:before {
  content: "\\e640";
}

.social-icon-style-round .social-dropbox:before {
  content: "\\e641";
}

.social-bandsintown:before {
  content: "\\e642";
}

.social-icon-style-square .social-bandsintown:before {
  content: "\\e643";
}

.social-icon-style-round .social-bandsintown:before {
  content: "\\e644";
}

.social-behance:before {
  content: "\\e645";
}

.social-icon-style-square .social-behance:before {
  content: "\\e646";
}

.social-icon-style-round .social-behance:before {
  content: "\\e647";
}

.social-codepen:before {
  content: "\\e648";
}

.social-icon-style-square .social-codepen:before {
  content: "\\e649";
}

.social-icon-style-round .social-codepen:before {
  content: "\\e64a";
}

.social-medium:before {
  content: "\\e64b";
}

.social-icon-style-square .social-medium:before {
  content: "\\e64c";
}

.social-icon-style-round .social-medium:before {
  content: "\\e64d";
}

.social-rdio:before {
  content: "\\e64e";
}

.social-icon-style-square .social-rdio:before {
  content: "\\e64f";
}

.social-icon-style-round .social-rdio:before {
  content: "\\e650";
}

.social-squarespace:before {
  content: "\\e651";
}

.social-icon-style-square .social-squarespace:before {
  content: "\\e652";
}

.social-icon-style-round .social-squarespace:before {
  content: "\\e653";
}

.social-vine:before {
  content: "\\e654";
}

.social-icon-style-square .social-vine:before {
  content: "\\e655";
}

.social-icon-style-round .social-vine:before {
  content: "\\e656";
}

.social-yelp:before {
  content: "\\e657";
}

.social-icon-style-square .social-yelp:before {
  content: "\\e658";
}

.social-icon-style-round .social-yelp:before {
  content: "\\e659";
}

.social-meetup:before {
  content: "\\e65a";
}

.social-icon-style-square .social-meetup:before {
  content: "\\e65b";
}

.social-icon-style-round .social-meetup:before {
  content: "\\e65c";
}

.social-vevo:before {
  content: "\\e65d";
}

.social-icon-style-square .social-vevo:before {
  content: "\\e65e";
}

.social-icon-style-round .social-vevo:before {
  content: "\\e65f";
}

.social-twitch:before {
  content: "\\e660";
}

.social-icon-style-square .social-twitch:before {
  content: "\\e661";
}

.social-icon-style-round .social-twitch:before {
  content: "\\e662";
}

.social-vsco:before {
  content: "\\e663";
}

.social-icon-style-square .social-vsco:before {
  content: "\\e664";
}

.social-icon-style-round .social-vsco:before {
  content: "\\e665";
}


@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
nav,
section {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
  display: inline;
  zoom: 1;
}

audio:not([controls]) {
  display: none;
}

[hidden] {
  display: none;
}

html {
  font-size: 100%;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-size: 13px;
  line-height: 1.6em;
}

body,
button,
input,
select,
textarea {
  font-family: "Ysabeau Office", sans-serif;
  color: #222;
}

a {
  color: #0085bd;
}

a:hover {
  color: #60a5dd;
}

a:focus {
  outline: thin dotted;
}

a:hover,
a:active {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

blockquote {
  margin: 1em 40px;
}

dfn {
  font-style: italic;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

ins {
  background: inherit;
  color: #000;
  text-decoration: none;
}

mark {
  background: #ff0;
  color: #000;
  font-style: italic;
  font-weight: bold;
}

pre,
code,
kbd,
samp {
  font-family: monospace, monospace;
  _font-family: "courier new", monospace;
  font-size: 1em;
}

pre {
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
}

q {
  quotes: none;
}

q:before,
q:after {
  content: "";
  content: none;
}

small {
  font-size: 85%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

ul,
ol {
  margin: 1em 0;
  padding: 0 0 0 40px;
}

dd {
  margin: 0 0 0 40px;
}

nav ul,
nav ol {
  list-style: none;
  list-style-image: none;
  margin: 0;
  padding: 0;
}

img {
  border: 0;
  -ms-interpolation-mode: bicubic;
  vertical-align: middle;
}

img:not([src]) {
  visibility: hidden;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

form {
  margin: 0;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

label {
  cursor: pointer;
}

legend {
  border: 0;
  margin-left: -7px;
  padding: 0;
}

button,
input,
select,
textarea {
  font-size: 100%;
  margin: 0;
  vertical-align: baseline;
  vertical-align: middle;
}

button,
input {
  line-height: normal;
  overflow: visible;
}

table button,
table input {
  overflow: auto;
}

button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
  cursor: pointer;
  -webkit-appearance: button;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
}

input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
  resize: vertical;
}

input:invalid,
textarea:invalid {
  background-color: #f0dddd;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

td {
  vertical-align: top;
}

.clear:before,
.clear:after {
  content: "";
  display: table;
}

.clear:after {
  clear: both;
}

.clear {
  zoom: 1;
}

h1,
:-webkit-any(article, aside, nav, section) h1,
:-webkit-any(article, aside, nav, section)
  :-webkit-any(article, aside, nav, section)
  h1 {
  -webkit-margin-before: 0 !important;
}

/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */
.clear:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.v6-visually-hidden {
  position: absolute !important;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
}

.sqs-g {
  letter-spacing: -0.31em;
  text-rendering: optimizespeed;
}

.opera-only :-o-prefocus,
.sqs-g {
  word-spacing: -0.43em;
}

.yui3-u,
.sqs-u {
  display: inline-block;
  zoom: 1;
  letter-spacing: normal;
  word-spacing: normal;
  vertical-align: top;
  text-rendering: auto;
}

.sqs-u-1,
.sqs-u-1-2,
.sqs-u-1-3,
.sqs-u-2-3,
.sqs-u-1-4,
.sqs-u-3-4,
.sqs-u-1-5,
.sqs-u-2-5,
.sqs-u-3-5,
.sqs-u-4-5,
.sqs-u-1-6,
.sqs-u-5-6,
.sqs-u-1-8,
.sqs-u-3-8,
.sqs-u-5-8,
.sqs-u-7-8,
.sqs-u-1-12,
.sqs-u-5-12,
.sqs-u-7-12,
.sqs-u-11-12,
.sqs-u-1-24,
.sqs-u-5-24,
.sqs-u-7-24,
.sqs-u-11-24,
.sqs-u-13-24,
.sqs-u-17-24,
.sqs-u-19-24,
.sqs-u-23-24 {
  display: inline-block;
  zoom: 1;
  letter-spacing: normal;
  word-spacing: normal;
  vertical-align: top;
  text-rendering: auto;
}

.sqs-u-1 {
  display: block;
}

.sqs-u-1-2 {
  width: 50%;
}

.sqs-u-1-3 {
  width: 33.33333%;
}

.sqs-u-2-3 {
  width: 66.66666%;
}

.sqs-u-1-4 {
  width: 25%;
}

.sqs-u-3-4 {
  width: 75%;
}

.sqs-u-1-5 {
  width: 20%;
}

.sqs-u-2-5 {
  width: 40%;
}

.sqs-u-3-5 {
  width: 60%;
}

.sqs-u-4-5 {
  width: 80%;
}

.sqs-u-1-6 {
  width: 16.656%;
}

.sqs-u-5-6 {
  width: 83.33%;
}

.sqs-u-1-8 {
  width: 12.5%;
}

.sqs-u-3-8 {
  width: 37.5%;
}

.sqs-u-5-8 {
  width: 62.5%;
}

.sqs-u-7-8 {
  width: 87.5%;
}

.sqs-u-1-12 {
  width: 8.3333%;
}

.sqs-u-5-12 {
  width: 41.6666%;
}

.sqs-u-7-12 {
  width: 58.3333%;
}

.sqs-u-11-12 {
  width: 91.6666%;
}

.sqs-u-1-24 {
  width: 4.1666%;
}

.sqs-u-5-24 {
  width: 20.8333%;
}

.sqs-u-7-24 {
  width: 29.1666%;
}

.sqs-u-11-24 {
  width: 45.8333%;
}

.sqs-u-13-24 {
  width: 54.1666%;
}

.sqs-u-17-24 {
  width: 70.8333%;
}

.sqs-u-19-24 {
  width: 79.1666%;
}

.sqs-u-23-24 {
  width: 95.8333%;
}

#sqs-css-stamp.cssgrids {
  display: none;
}

.yui3-widget-hidden {
  display: none;
}

.yui3-widget-content {
  overflow: hidden;
}

.yui3-widget-content-expanded {
  box-sizing: border-box;
  height: 100%;
}

.yui3-widget-tmp-forcesize {
  overflow: hidden !important;
}

.sqs-panel {
  position: absolute;
}

.sqs-panel-hidden {
  visibility: hidden;
}

.sqs-widget-tmp-forcesize .sqs-panel-content {
  overflow: hidden !important;
}

.sqs-panel .sqs-widget-hd {
  position: relative;
}

.sqs-panel .sqs-widget-hd .sqs-widget-buttons {
  position: absolute;
  top: 0;
  right: 0;
}

.sqs-panel .sqs-widget-ft .sqs-widget-buttons {
  display: inline-block;
  zoom: 1;
}

.yui3-slider,
.yui3-slider-rail {
  display: -moz-inline-stack;
  display: inline-block;
  zoom: 1;
  vertical-align: middle;
}

.yui3-slider-content {
  position: relative;
  display: block;
}

.yui3-slider-rail {
  position: relative;
}

.yui3-slider-rail-cap-top,
.yui3-slider-rail-cap-left,
.yui3-slider-rail-cap-bottom,
.yui3-slider-rail-cap-right,
.yui3-slider-thumb,
.yui3-slider-thumb-image,
.yui3-slider-thumb-shadow {
  position: absolute;
}

.yui3-slider-thumb {
  overflow: hidden;
}

.sqs-aclist,
.yui3-aclist {
  position: absolute;
  z-index: 10;
}

.sqs-aclist-hidden,
.yui3-aclist-hidden {
  visibility: hidden;
}

.sqs-aclist-aria,
.yui3-aclist-aria {
  left: -9999px;
  position: absolute;
}

.sqs-aclist-list,
.yui3-aclist-list {
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
}

.sqs-aclist-item,
.yui3-aclist-item {
  cursor: pointer;
  list-style: none;
  padding: 2px 5px;
}

.sqs-aclist-item-active,
.yui3-aclist-item-active {
  outline: #afafaf dotted thin;
}

.sqs-cookie-banner-v2-enabled .sqs-cookie-banner-v2 {
  display: block;
}

body.sqs-cookie-banner-v2-top .sqs-announcement-bar-dropzone,
body.sqs-cookie-banner-v2-top
  .sqs-announcement-bar-dropzone.sqs-cookie-banner-v2-enabled {
  position: relative;
}

.sqs-cookie-banner-v2 {
  box-sizing: border-box;
  display: none;
  justify-content: space-between;
  align-items: center;
  z-index: 300000;
  padding: 10px;
  position: fixed;
}

.sqs-cookie-banner-v2 p,
.sqs-cookie-banner-v2 button {
  font-family: "Helvetica Neue", Helvetica, Sans-serif;
  font-size: 12px;
  line-height: 1.5em;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0.05em;
  margin: 10px !important;
}

.sqs-cookie-banner-v2 a {
  text-decoration: underline;
}

.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-text {
  max-height: calc(50vh);
}

.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-cta-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-cta {
  white-space: nowrap;
  background: transparent;
}

.sqs-announcement-bar-dropzone .sqs-cookie-banner-v2.TOP {
  position: relative;
}

body > .sqs-cookie-banner-v2.TOP {
  top: 0;
}

.sqs-cookie-banner-v2.BOTTOM {
  bottom: 0;
}

.sqs-cookie-banner-v2.TOP_LEFT {
  top: 20px;
  left: 20px;
}

.sqs-cookie-banner-v2.TOP_RIGHT {
  top: 20px;
  right: 20px;
}

.sqs-cookie-banner-v2.BOTTOM_LEFT {
  bottom: 20px;
  left: 20px;
}

.sqs-cookie-banner-v2.BOTTOM_RIGHT {
  bottom: 20px;
  right: 20px;
}

@media (max-width: 640px) {
  .sqs-cookie-banner-v2.TOP_LEFT,
  .sqs-cookie-banner-v2.TOP_RIGHT {
    top: 10px;
    margin-bottom: 10px;
    left: 10px;
    right: 10px;
  }

  .sqs-cookie-banner-v2.BOTTOM_LEFT,
  .sqs-cookie-banner-v2.BOTTOM_RIGHT {
    margin-top: 10px;
    bottom: 10px;
    left: 10px;
    right: 10px;
  }
}

.sqs-cookie-banner-v2.ICON {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-acceptWrapper {
  font-size: 0px;
  line-height: 1;
  text-align: right;
}

.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-accept {
  border: 0;
  padding: 5px 10px;
}

.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-accept:after {
  content: "×";
  font-family: "Helvetica Neue", Helvetica, Sans-serif;
  font-weight: 100;
  line-height: 0.5em;
  font-size: 35px;
}

.sqs-cookie-banner-v2.BAR {
  left: 0;
  right: 0;
}

@media (min-width: 640px) {
  .sqs-cookie-banner-v2.BAR {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .sqs-cookie-banner-v2.BAR p {
    margin-right: 2vw;
  }

  .sqs-cookie-banner-v2.BAR .sqs-cookie-banner-v2-cta-container {
    max-width: 50%;
    flex: 1 0 auto;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

@media (min-width: 640px) {
  .sqs-cookie-banner-v2.POPUP {
    width: 250px;
    margin: 20px;
  }

  .sqs-cookie-banner-v2.POPUP.OPT_IN_AND_OUT {
    width: auto;
    max-width: 500px;
  }

  .sqs-cookie-banner-v2.POPUP.OPT_IN_AND_OUT .sqs-cookie-banner-v2-text {
    max-width: 350px;
  }

  .sqs-cookie-banner-v2.POPUP.ICON {
    width: 350px;
    margin: 10px;
  }
}

.sqs-cookie-banner-v2.BUTTON .sqs-cookie-banner-v2-cta {
  padding: 1em 1.5em;
  letter-spacing: 0.1em;
  line-height: 1em;
}

.sqs-cookie-banner-v2.TEXT .sqs-cookie-banner-v2-cta {
  padding: 0;
  border: none;
  letter-spacing: 0.05em;
}

.sqs-cookie-banner-v2.DARK {
  background-color: #000;
}

.sqs-cookie-banner-v2.DARK p,
.sqs-cookie-banner-v2.DARK button,
.sqs-cookie-banner-v2.DARK a {
  color: #fff;
}

.sqs-cookie-banner-v2.DARK :focus {
  outline-color: #fff;
}

.sqs-cookie-banner-v2.DARK :focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-cookie-banner-v2.DARK.TEXT .sqs-cookie-banner-v2-cta {
  border-bottom: 1px solid #777;
}

.sqs-cookie-banner-v2.DARK.BUTTON .sqs-cookie-banner-v2-cta {
  border: 1px solid #fff;
}

.sqs-cookie-banner-v2.LIGHT {
  background-color: #eee;
}

.sqs-cookie-banner-v2.LIGHT p,
.sqs-cookie-banner-v2.LIGHT button,
.sqs-cookie-banner-v2.LIGHT a {
  color: #111;
}

.sqs-cookie-banner-v2.LIGHT :focus {
  outline-color: #111;
}

.sqs-cookie-banner-v2.LIGHT :focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-cookie-banner-v2.LIGHT.TEXT .sqs-cookie-banner-v2-cta {
  border-bottom: 1px solid #bbb;
}

.sqs-cookie-banner-v2.LIGHT.BUTTON .sqs-cookie-banner-v2-cta {
  border: 1px solid #444;
}

body.native-currency-code-usd .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-cad .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-cad .sqs-money-native:after {
  content: " CAD";
}

body.native-currency-code-gbp .sqs-money-native:before {
  content: "£";
}

body.native-currency-code-eur .sqs-money-native:before {
  content: "€";
}

body.native-currency-code-aud .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-aud .sqs-money-native:after {
  content: " AUD";
}

body.native-currency-code-chf .sqs-money-native:before {
  content: "CHF";
}

body.native-currency-code-nok .sqs-money-native:after {
  content: " kr";
}

body.native-currency-code-sek .sqs-money-native:after {
  content: " kr";
}

body.native-currency-code-dkk .sqs-money-native:after {
  content: " kr";
}

body.native-currency-code-nzd .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-sgd .sqs-money-native:before {
  content: "S\$";
}

body.native-currency-code-mxn .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-hkd .sqs-money-native:before {
  content: "HK\$";
}

body.native-currency-code-czk .sqs-money-native:after {
  content: " Kč";
}

body.native-currency-code-thb .sqs-money-native:before {
  content: "฿";
}

body.native-currency-code-myr .sqs-money-native:before {
  content: "RM";
}

body.native-currency-code-pln .sqs-money-native:after {
  content: " zł";
}

body.native-currency-code-ils .sqs-money-native:before {
  content: "₪ ";
}

body.native-currency-code-php .sqs-money-native:before {
  content: "Php";
}

body.native-currency-code-rub .sqs-money-native:after {
  content: " р.";
}

body.native-currency-code-brl .sqs-money-native:before {
  content: " R\$";
}

body.native-currency-code-ars .sqs-money-native:before {
  content: "\$";
}

body.native-currency-code-ars .sqs-money-native:after {
  content: " ARS";
}

body.native-currency-code-cop .sqs-money-native:before {
  content: "COL\$";
}

body.native-currency-code-idr .sqs-money-native:before {
  content: "Rp";
}

body.native-currency-code-inr .sqs-money-native:before {
  content: "₹";
}

body.native-currency-code-jpy .sqs-money-native:before {
  content: "¥";
}

body.native-currency-code-zar .sqs-money-native:before {
  content: "R";
}

.fadeable-plugged.display-status-hidden {
  display: none;
}

.sqs-image-zoom-dropzone {
  overflow: hidden;
}

.sqs-image-zoom-duplicate {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  transition: opacity 0.4s ease;
}

.is-zoomed .sqs-image-zoom-duplicate {
  opacity: 1;
}

.sqs-image-zoom--behavior-click {
  cursor: zoom-in !important;
}

.sqs-image-zoom--behavior-click.is-zoomed {
  cursor: zoom-out !important;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bounceOut {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    opacity: 0;
    transform: scale(0.3);
  }
}

@media screen and (max-width: 432px) {
  .mobile-hidden {
    display: none;
  }
}

@media screen and (max-width: 432px) {
  .subDesktop-hidden {
    display: none;
  }
}

@media screen and (min-width: 433px) {
  .desktop-hidden {
    display: none;
  }
}

.sqs-system-error {
  color: #3e3e3e !important;
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/error-dark.png")
    center center no-repeat; */
  background-position: 12px 12px;
}

@media (min-resolution: 1.5dppx) {
  .sqs-system-error {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/error-dark@2x.png"); */
    background-size: 44px;
  }
}

.sqs-system-error input {
  cursor: pointer;
  background: #3e3e3e;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
}

.sqs-system-error input,
.sqs-system-error input > * {
  color: #fff !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqs-system-error input:focus,
.sqs-system-error input > *:focus {
  outline-color: #fff;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqs-system-error input:focus:not(:focus-visible),
.sqs-system-error input > *:focus:not(:focus-visible) {
  outline: none;
}

.sqs-system-error input:hover {
  background-color: #000;
  box-shadow: none;
}

.sqs-system-error input.disabled {
  opacity: 0.3;
  cursor: default;
}

.sqs-system-error input.disabled > * {
  opacity: 0.5;
}

.sqs-system-error input.disabled:hover {
  background-color: #3e3e3e !important;
}

.sqs-system-error-overlay.dialog-screen-overlay {
  background: rgba(246, 246, 246, 0.98);
}

.sqs-video-wrapper .intrinsic {
  max-width: 100%;
}

.sqs-video-wrapper.video-none {
  position: relative;
}

.sqs-video-wrapper.video-fill {
  position: absolute;
  width: 100%;
  height: 100%;
}

.sqs-video-wrapper.video-fit {
  position: absolute;
  width: 100%;
}

.sqs-video-wrapper.video-fit .intrinsic {
  width: 100%;
}

.sqs-video-wrapper.video-fit .intrinsic-inner {
  position: relative;
}

.sqs-video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sqs-video-wrapper object,
.sqs-video-wrapper embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sqs-video-wrapper .sqs-video-overlay {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  color: #000;
  background-position: center center;
  background-repeat: no-repeat;
}

.sqs-video-wrapper .sqs-video-overlay .sqs-video-opaque {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0;
}

.sqs-video-wrapper .sqs-video-overlay.no-thumb .sqs-video-opaque {
  opacity: 1;
}

.sqs-video-wrapper .sqs-video-overlay .sqs-video-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/play-button.png")
    center center no-repeat; */
  height: 48px;
  width: 48px;
  margin-left: -24px;
  margin-top: -24px;
  cursor: pointer;
}

@media (min-resolution: 1.5dppx) {
  .sqs-video-wrapper .sqs-video-overlay .sqs-video-icon {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/play-button@2x.png"); */
    background-size: 33px;
  }
}

.sqs-video-wrapper.video-invalid {
  position: static !important;
  height: 48px !important;
}

.sqs-video-wrapper .sqs-video-invalid-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body.no-scroll {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.no-scroll {
  overflow: hidden !important;
}

.sqs-lightbox-overlay {
  position: fixed;
  opacity: 0;
  top: 0;
  left: 0;
  background: #000;
  height: 100%;
  width: 100%;
}

.sqs-lightbox-overlay.sqs-lightbox-overlay-style-orb {
  background: radial-gradient(circle at 50% 25%, rgba(0, 0, 0, 0.75), #000);
}

.sqs-lightbox-overlay.light {
  background: rgba(246, 246, 246, 0.98) !important;
  color: #3e3e3e;
}

.sqs-lightbox-overlay.white.sqs-lightbox-overlay-style-orb {
  background: radial-gradient(
    circle at 50% 25%,
    rgba(255, 255, 255, 0.96),
    #fff
  );
}

.sqsp-tooltip {
  color: inherit;
  background-color: #f6f6f6;
  padding: 22px 33px;
  box-shadow: 0 4px 33px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.04);
  position: absolute;
  overflow: hidden;
  text-align: left !important;
  max-width: 250px;
}

.sqsp-tooltip .title {
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 11px;
}

.sqsp-tooltip .description {
  margin: 11px 0;
}

.sqsp-tooltip .buttons {
  margin: 22px -33px -22px;
  border-top: 1px solid #e4e4e4;
  display: flex;
}

.sqsp-tooltip .buttons:empty {
  border-top: 0;
}

.sqsp-tooltip .buttons > * {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e4e4e4 !important;
}

.sqsp-tooltip .buttons > *:first-child {
  border-left: none !important;
}

.sqsp-tooltip .buttons input,
.sqsp-tooltip .buttons button {
  background: transparent;
}

.sqsp-tooltip .buttons a {
  border-bottom: none;
}

.sqsp-tooltip .buttons a:not(.reject) {
  cursor: pointer;
  background: #f6f6f6;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
}

.sqsp-tooltip .buttons a:not(.reject),
.sqsp-tooltip .buttons a:not(.reject) > * {
  color: #3e3e3e !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqsp-tooltip .buttons a:not(.reject):focus,
.sqsp-tooltip .buttons a:not(.reject) > *:focus {
  outline-color: #3e3e3e;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqsp-tooltip .buttons a:not(.reject):focus:not(:focus-visible),
.sqsp-tooltip .buttons a:not(.reject) > *:focus:not(:focus-visible) {
  outline: none;
}

.sqsp-tooltip .buttons a:not(.reject):hover {
  background-color: #fff;
  box-shadow: none;
}

.sqsp-tooltip .buttons a:not(.reject).disabled {
  opacity: 0.3;
  cursor: default;
}

.sqsp-tooltip .buttons a:not(.reject).disabled > * {
  opacity: 0.5;
}

.sqsp-tooltip .buttons a:not(.reject).disabled:hover {
  background-color: #f6f6f6 !important;
}

.sqsp-tooltip .buttons a:not(.reject).disabled {
  opacity: 0.5;
}

.sqsp-tooltip .buttons a.reject {
  cursor: pointer;
  background: #f6f6f6;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
}

.sqsp-tooltip .buttons a.reject,
.sqsp-tooltip .buttons a.reject > * {
  color: #3e3e3e !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqsp-tooltip .buttons a.reject:focus,
.sqsp-tooltip .buttons a.reject > *:focus {
  outline-color: #3e3e3e;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqsp-tooltip .buttons a.reject:focus:not(:focus-visible),
.sqsp-tooltip .buttons a.reject > *:focus:not(:focus-visible) {
  outline: none;
}

.sqsp-tooltip .buttons a.reject:hover {
  background-color: #000;
  box-shadow: none;
}

.sqsp-tooltip .buttons a.reject.disabled {
  opacity: 0.3;
  cursor: default;
}

.sqsp-tooltip .buttons a.reject.disabled > * {
  opacity: 0.5;
}

.sqsp-tooltip .buttons a.reject.disabled:hover {
  background-color: #f6f6f6 !important;
}

.sqsp-tooltip .buttons a.reject:hover {
  background-color: #f0523d;
}

.sqsp-tooltip .buttons a.reject:hover,
.sqsp-tooltip .buttons a.reject:hover * {
  color: #fff !important;
}

.sqs-action-overlay {
  position: absolute;
  top: 0;
  right: 0;
  white-space: nowrap;
  transition: opacity 0.1s ease-out;
  opacity: 0;
  background-color: #3e3e3e;
  overflow: hidden;
  z-index: 50;
  height: 32px;
  border-radius: 3px;
}

.sqs-action-overlay.loading {
  opacity: 1;
}

.sqs-action-overlay.bottom {
  top: auto;
  bottom: 0;
}

.sqs-action-overlay > div {
  display: inline-block;
  height: 32px;
  width: 33px;
  opacity: 0.3;
  cursor: pointer;
}

.sqs-action-overlay > div:hover {
  opacity: 0.9;
}

.sqs-action-overlay > div:active,
.sqs-action-overlay > div:focus {
  opacity: 1;
}

.sqs-action-overlay > div.edit-image,
.sqs-action-overlay > div.edit {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/edit-aviary-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.edit-image,
  .sqs-action-overlay > div.edit {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/edit-aviary-light@2x.png"); */
    background-size: 16px;
  }
}

.sqs-action-overlay > div.edit.loading {
  background: none;
}

.sqs-action-overlay > div.image-info {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/edit-info-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.image-info {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/edit-info-light@2x.png"); */
    background-size: 16px;
  }
}

.sqs-action-overlay > div.remove,
.sqs-action-overlay > div.remove-image {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png")
    center center no-repeat; */
  cursor: pointer;
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove,
  .sqs-action-overlay > div.remove-image {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.remove:hover,
.sqs-action-overlay > div.remove-image:hover {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-red.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove:hover,
  .sqs-action-overlay > div.remove-image:hover {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-red@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.remove:hover,
.sqs-action-overlay > div.remove-image:hover {
  /* background: #f0523d
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove:hover,
  .sqs-action-overlay > div.remove-image:hover {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.video-info {
  background: transparent
    /* url("//assets.squarespace.com/universal/images-v6/damask/edit-info-light.png") */
    center center no-repeat;
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.video-info {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/edit-info-light@2x.png"); */
    background-size: 16px;
  }
}

.sqs-action-overlay > div.getty {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/getty-16-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.getty {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/getty-32-light.png"); */
    background-size: 16px;
  }
}

.sqs-action-overlay > div.buy {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/shopping-cart-16-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.buy {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/shopping-cart-32-light.png"); */
    background-size: 16px;
  }
}

.sqs-action-overlay > div.remove-video {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png")
    center center no-repeat; */
  cursor: pointer;
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove-video {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.remove-video:hover {
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-red.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove-video:hover {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-red@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.remove-video:hover {
  /* background: #f0523d
    url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png")
    center center no-repeat; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-action-overlay > div.remove-video:hover {
    /* background-image: url("//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png"); */
    background-size: 9px 11px;
  }
}

.sqs-action-overlay > div.loading {
  background: none;
  position: relative;
  opacity: 1;
}

.sqs-action-overlay > div.loading .sqs-spin.default {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translatex(-50%) translatey(-50%);
}

.sqs-action-overlay-container:hover .sqs-action-overlay {
  opacity: 1;
}

.touch .sqs-action-overlay {
  opacity: 1;
}

.image-focal-point {
  border-radius: 14px;
  height: 14px;
  width: 14px;
  margin-left: -10px;
  margin-top: -10px;
  position: absolute;
  border: 3px solid rgba(255, 255, 255, 0.8);
  background: rgba(0, 0, 0, 0.2);
  cursor: move;
  opacity: 0;
}

.sqs-loading-overlay-node {
  background: rgba(255, 255, 255, 0.9);
}

.sqs-loading-overlay-node .sqs-spin {
  position: absolute;
  top: 50%;
  left: 50%;
}

.sqs-loading-overlay-node .sqs-spin.large {
  margin-top: -11px;
  margin-left: -11px;
}

.sqs-loading-overlay-node .sqs-spin.extra-large {
  margin-top: -20px;
  margin-left: -20px;
}

.sqs-loading-overlay-node.has-title .title {
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  margin-top: 22px;
  color: #999;
  font-size: 14px;
}

.sqs-loading-overlay-node.has-title .sqs-spin {
  margin-top: -22px;
}

body > .login-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 30100;
  transition: all 0.5s ease-in-out;
}

body > .login-wrapper.hidden {
  opacity: 0;
}

.sqs-follow-button-hidden {
  display: none;
}

.sqs-spin {
  background-color: transparent;
  border-radius: 150px;
  display: inline-block;
  vertical-align: middle;
  animation: sqs-spin 1s infinite linear;
}

.sqs-spin.light {
  border: 2px solid rgba(255, 255, 255, 0.7) !important;
  border-top-color: rgba(255, 255, 255, 0.15) !important;
  border-left-color: rgba(255, 255, 255, 0.15) !important;
}

.sqs-spin.dark {
  border: 2px solid rgba(0, 0, 0, 0.75) !important;
  border-top-color: rgba(0, 0, 0, 0.08) !important;
  border-left-color: rgba(0, 0, 0, 0.08) !important;
}

.sqs-spin.extra-small {
  width: 4px;
  height: 4px;
}

.sqs-spin.small {
  width: 8px;
  height: 8px;
}

.sqs-spin.default {
  width: 12px;
  height: 12px;
}

.sqs-spin.large {
  width: 22px;
  height: 22px;
}

.sqs-spin.extra-large {
  width: 40px;
  height: 40px;
}

.sqs-spin.xx-large {
  width: 80px;
  height: 80px;
}

.sqs-spin.degraded {
  border: 0px;
  border-radius: 0px;
  animation: none;
}

.sqs-spin.degraded img {
  width: 100%;
  height: 100%;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

@keyframes sqs-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.sqs-widgets-confirmation {
  color: #3e3e3e;
  z-index: 1000000;
  font-size: 12px;
}

@media screen and (max-width: 432px) {
  .sqs-widgets-confirmation {
    width: 300px !important;
  }
}

@media screen and (min-width: 433px) {
  .sqs-widgets-confirmation {
    position: absolute;
  }
}

.sqs-widgets-confirmation-content {
  color: inherit;
  padding: 22px 33px;
  text-align: center;
  background: #f6f6f6;
  box-shadow: 0 4px 33px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  overflow: hidden;
}

@media screen and (max-width: 432px) {
  .sqs-widgets-confirmation-content {
    padding: 22px;
  }
}

.sqs-widgets-confirmation-content > .title {
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 11px;
}

.sqs-widgets-confirmation-content .fields {
  margin-bottom: 11px;
}

.sqs-widgets-confirmation-content .fields .check-field-wrapper {
  padding: 0;
}

.sqs-widgets-confirmation-content
  .fields
  .check-field-wrapper
  .field-description {
  background: none;
}

.sqs-widgets-confirmation-content .buttons {
  border-top: 1px solid #e4e4e4;
  display: flex;
  margin: 22px -33px -22px;
}

.sqs-widgets-confirmation-content .buttons:empty {
  border-top: 0;
}

.sqs-widgets-confirmation-content .buttons > * {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e4e4e4 !important;
}

.sqs-widgets-confirmation-content .buttons > *:first-child {
  border-left: none !important;
}

.sqs-widgets-confirmation-content .buttons input,
.sqs-widgets-confirmation-content .buttons button {
  background: transparent;
}

.sqs-widgets-confirmation-content .buttons a {
  border-bottom: none;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button:not(.reject) {
  cursor: pointer;
  background: #f6f6f6;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
  line-height: 16px;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button:not(.reject),
.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject)
  > * {
  color: #3e3e3e !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject):focus,
.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject)
  > *:focus {
  outline-color: #3e3e3e;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject):focus:not(:focus-visible),
.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject)
  > *:focus:not(:focus-visible) {
  outline: none;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject):hover {
  background-color: #fff;
  box-shadow: none;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject).disabled {
  opacity: 0.3;
  cursor: default;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject).disabled
  > * {
  opacity: 0.5;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject).disabled:hover {
  background-color: #f6f6f6 !important;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:not(.reject).disabled {
  opacity: 0.5;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject {
  cursor: pointer;
  background: #f6f6f6;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
  line-height: 16px;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject,
.sqs-widgets-confirmation-content .buttons .confirmation-button.reject > * {
  color: #3e3e3e !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:focus,
.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject
  > *:focus {
  outline-color: #3e3e3e;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject:focus:not(:focus-visible),
.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject
  > *:focus:not(:focus-visible) {
  outline: none;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover {
  background-color: #000;
  box-shadow: none;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject.disabled {
  opacity: 0.3;
  cursor: default;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject.disabled
  > * {
  opacity: 0.5;
}

.sqs-widgets-confirmation-content
  .buttons
  .confirmation-button.reject.disabled:hover {
  background-color: #f6f6f6 !important;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover {
  background-color: #f0523d;
}

.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover,
.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover * {
  color: #fff !important;
}

.sqs-widgets-confirmation.sqs-widgets-data-confirmation
  .sqs-widgets-confirmation-content {
  text-align: left;
}

.sqs-widgets-confirmation.danger-zone .sqs-widgets-confirmation-content {
  color: #fff !important;
  background-color: #f0523d;
}

.sqs-widgets-confirmation.danger-zone
  .sqs-widgets-confirmation-content
  .buttons
  .confirmation-button {
  background-color: #f0523d;
  color: #fff !important;
}

.sqs-widgets-confirmation.danger-zone
  .sqs-widgets-confirmation-content
  .buttons
  .confirmation-button:hover {
  background-color: #e4351e;
}

.sqs-widgets-confirmation.dangerous-confirmation-button
  .sqs-widgets-confirmation-content
  .buttons
  .confirm:hover {
  background-color: #f0523d;
  color: #fff !important;
}

.sqs-widgets-confirmation.reject-warning
  .buttons
  .confirmation-button.reject:hover {
  background-color: #f0523d;
  color: #fff;
}

.sqs-widgets-confirmation.delete-collection .confirmation-button.confirm:hover {
  background-color: #f0523d;
  color: #fff !important;
}

.sqs-widgets-confirmation.with-media .title:empty,
.sqs-widgets-confirmation.with-media .message:empty {
  display: none;
}

.sqs-widgets-confirmation.with-media .title:empty + .message:empty + .media {
  margin-top: -22px;
}

.sqs-widgets-confirmation.with-media .media {
  display: block;
  position: relative;
  margin: 0px -33px;
}

.sqs-widgets-confirmation.with-media .media > * {
  display: block;
  position: relative;
  margin: 0 auto;
}

.sqs-widgets-confirmation.with-media .buttons {
  margin-top: 0px;
}

.sqs-widgets-confirmation.with-media .sqs-widgets-confirmation-content {
  background: #fff;
}

.sqs-widgets-confirmation.shown .media > * {
  width: 100%;
}

.sqs-widgets-confirmation {
  opacity: 0;
  transform: scale(0.96);
}

.sqs-widgets-confirmation.mobile {
  transform: translatey(-50%);
}

.sqs-widgets-confirmation.shown {
  opacity: 1;
  transform: scale(1);
  animation-name: show-confirmation;
  animation-iteration-count: 1;
  animation-duration: 0.3s;
}

.sqs-widgets-confirmation.shown.mobile {
  transform: translatey(0);
  animation-name: show-confirmation-mobile;
}

.sqs-widgets-confirmation.hiding {
  opacity: 0;
  animation-name: none;
  transition-property: all;
  transition-duration: 0.3s;
  transform: scale(0.96);
}

.sqs-widgets-confirmation.hiding.mobile {
  transform: translatey(-50%);
}

.sqs-widgets-confirmation-hidden {
  display: none;
}

@keyframes show-confirmation {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes show-confirmation-mobile {
  from {
    transform: translatey(-50%);
  }

  to {
    transform: translatey(0);
  }
}

.sqs-widgets-confirmation-overlay {
  display: block;
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  z-index: 999999;
}

@media screen and (max-width: 432px) {
  .sqs-widgets-confirmation-overlay {
    opacity: 0.4 !important;
    z-index: 999999 !important;
  }
}

/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */
.sqs-block.vsize-1 .sqs-block-content {
  height: 34px;
}

.sqs-block.vsize-2 .sqs-block-content {
  height: 68px;
}

.sqs-block.vsize-3 .sqs-block-content {
  height: 102px;
}

.sqs-block.vsize-4 .sqs-block-content {
  height: 136px;
}

.sqs-block.vsize-5 .sqs-block-content {
  height: 170px;
}

.sqs-block.vsize-6 .sqs-block-content {
  height: 204px;
}

.sqs-block.vsize-7 .sqs-block-content {
  height: 238px;
}

.sqs-block.vsize-8 .sqs-block-content {
  height: 272px;
}

.sqs-block.vsize-9 .sqs-block-content {
  height: 306px;
}

.sqs-block.vsize-10 .sqs-block-content {
  height: 340px;
}

.sqs-block.vsize-11 .sqs-block-content {
  height: 374px;
}

.sqs-block.vsize-12 .sqs-block-content {
  height: 408px;
}

.sqs-block.vsize-13 .sqs-block-content {
  height: 442px;
}

.sqs-block.vsize-14 .sqs-block-content {
  height: 476px;
}

.sqs-block.vsize-15 .sqs-block-content {
  height: 510px;
}

.sqs-block.vsize-16 .sqs-block-content {
  height: 544px;
}

.sqs-block.vsize-17 .sqs-block-content {
  height: 578px;
}

.sqs-block.vsize-18 .sqs-block-content {
  height: 612px;
}

.sqs-block.vsize-19 .sqs-block-content {
  height: 646px;
}

.sqs-block.vsize-20 .sqs-block-content {
  height: 680px;
}

.sqs-block.vsize-21 .sqs-block-content {
  height: 714px;
}

.sqs-block.vsize-22 .sqs-block-content {
  height: 748px;
}

.sqs-block.vsize-23 .sqs-block-content {
  height: 782px;
}

.sqs-block.vsize-24 .sqs-block-content {
  height: 816px;
}

.sqs-block.vsize-25 .sqs-block-content {
  height: 850px;
}

.sqs-block.vsize-26 .sqs-block-content {
  height: 884px;
}

.sqs-block.vsize-27 .sqs-block-content {
  height: 918px;
}

.sqs-block.vsize-28 .sqs-block-content {
  height: 952px;
}

.sqs-block.vsize-29 .sqs-block-content {
  height: 986px;
}

.sqs-block.vsize-30 .sqs-block-content {
  height: 1020px;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bounceOut {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    opacity: 0;
    transform: scale(0.3);
  }
}

@media screen and (max-width: 432px) {
  .mobile-hidden {
    display: none;
  }
}

@media screen and (max-width: 432px) {
  .subDesktop-hidden {
    display: none;
  }
}

@media screen and (min-width: 433px) {
  .desktop-hidden {
    display: none;
  }
}

.sqs-row {
  width: 100% !important;
}

.sqs-row:before,
.sqs-row:after {
  content: "";
  display: table;
}

.sqs-row:after {
  clear: both;
}

[class*="sqs-col"] {
  float: left;
}

[class*="sqs-col"] .sqs-block {
  /* padding-left: 25px;
  padding-right: 25px; */
}

[class*="sqs-col"]:last-child {
  padding-right: 0;
}

.sqs-col-12 {
  width: 100%;
}

.sqs-col-12 .sqs-col-12 {
  width: 100%;
}

.sqs-col-12 .sqs-col-11 {
  width: 91.6667%;
}

.sqs-col-12 .sqs-col-10 {
  width: 83.3333%;
}

.sqs-col-12 .sqs-col-9 {
  width: 75%;
}

.sqs-col-12 .sqs-col-8 {
  width: 66.6667%;
}

.sqs-col-12 .sqs-col-7 {
  width: 58.3333%;
}

.sqs-col-12 .sqs-col-6 {
  width: 50%;
}

.sqs-col-12 .sqs-col-5 {
  width: 41.6667%;
}

.sqs-col-12 .sqs-col-4 {
  width: 33.3333%;
}

.sqs-col-12 .sqs-col-3 {
  width: 25%;
}

.sqs-col-12 .sqs-col-2 {
  width: 16.6667%;
}

.sqs-col-12 .sqs-col-1 {
  width: 8.3333%;
}

.sqs-col-11 {
  width: 91.6667%;
}

.sqs-col-11 .sqs-col-11 {
  width: 100%;
}

.sqs-col-11 .sqs-col-10 {
  width: 90.9091%;
}

.sqs-col-11 .sqs-col-9 {
  width: 81.8182%;
}

.sqs-col-11 .sqs-col-8 {
  width: 72.7273%;
}

.sqs-col-11 .sqs-col-7 {
  width: 63.6364%;
}

.sqs-col-11 .sqs-col-6 {
  width: 54.5455%;
}

.sqs-col-11 .sqs-col-5 {
  width: 45.4545%;
}

.sqs-col-11 .sqs-col-4 {
  width: 36.3636%;
}

.sqs-col-11 .sqs-col-3 {
  width: 27.2727%;
}

.sqs-col-11 .sqs-col-2 {
  width: 18.1818%;
}

.sqs-col-11 .sqs-col-1 {
  width: 9.0909%;
}

.sqs-col-10 {
  width: 83.3333%;
}

.sqs-col-10 .sqs-col-10 {
  width: 100%;
}

.sqs-col-10 .sqs-col-9 {
  width: 90%;
}

.sqs-col-10 .sqs-col-8 {
  width: 80%;
}

.sqs-col-10 .sqs-col-7 {
  width: 70%;
}

.sqs-col-10 .sqs-col-6 {
  width: 60%;
}

.sqs-col-10 .sqs-col-5 {
  width: 50%;
}

.sqs-col-10 .sqs-col-4 {
  width: 40%;
}

.sqs-col-10 .sqs-col-3 {
  width: 30%;
}

.sqs-col-10 .sqs-col-2 {
  width: 20%;
}

.sqs-col-10 .sqs-col-1 {
  width: 10%;
}

.sqs-col-9 {
  width: 75%;
}

.sqs-col-9 .sqs-col-9 {
  width: 100%;
}

.sqs-col-9 .sqs-col-8 {
  width: 88.8889%;
}

.sqs-col-9 .sqs-col-7 {
  width: 77.7778%;
}

.sqs-col-9 .sqs-col-6 {
  width: 66.6667%;
}

.sqs-col-9 .sqs-col-5 {
  width: 55.5556%;
}

.sqs-col-9 .sqs-col-4 {
  width: 44.4444%;
}

.sqs-col-9 .sqs-col-3 {
  width: 33.3333%;
}

.sqs-col-9 .sqs-col-2 {
  width: 22.2222%;
}

.sqs-col-9 .sqs-col-1 {
  width: 11.1111%;
}

.sqs-col-8 {
  width: 66.6667%;
}

.sqs-col-8 .sqs-col-8 {
  width: 100%;
}

.sqs-col-8 .sqs-col-7 {
  width: 87.5%;
}

.sqs-col-8 .sqs-col-6 {
  width: 75%;
}

.sqs-col-8 .sqs-col-5 {
  width: 62.5%;
}

.sqs-col-8 .sqs-col-4 {
  width: 50%;
}

.sqs-col-8 .sqs-col-3 {
  width: 37.5%;
}

.sqs-col-8 .sqs-col-2 {
  width: 25%;
}

.sqs-col-8 .sqs-col-1 {
  width: 12.5%;
}

.sqs-col-7 {
  width: 58.3333%;
}

.sqs-col-7 .sqs-col-7 {
  width: 100%;
}

.sqs-col-7 .sqs-col-6 {
  width: 85.7143%;
}

.sqs-col-7 .sqs-col-5 {
  width: 71.4286%;
}

.sqs-col-7 .sqs-col-4 {
  width: 57.1429%;
}

.sqs-col-7 .sqs-col-3 {
  width: 42.8571%;
}

.sqs-col-7 .sqs-col-2 {
  width: 28.5714%;
}

.sqs-col-7 .sqs-col-1 {
  width: 14.2857%;
}

.sqs-col-6 {
  width: 50%;
}

.sqs-col-6 .sqs-col-6 {
  width: 100%;
}

.sqs-col-6 .sqs-col-5 {
  width: 83.3333%;
}

.sqs-col-6 .sqs-col-4 {
  width: 66.6667%;
}

.sqs-col-6 .sqs-col-3 {
  width: 50%;
}

.sqs-col-6 .sqs-col-2 {
  width: 33.3333%;
}

.sqs-col-6 .sqs-col-1 {
  width: 16.6667%;
}

.sqs-col-5 {
  width: 41.6667%;
}

.sqs-col-5 .sqs-col-5 {
  width: 100%;
}

.sqs-col-5 .sqs-col-4 {
  width: 80%;
}

.sqs-col-5 .sqs-col-3 {
  width: 60%;
}

.sqs-col-5 .sqs-col-2 {
  width: 40%;
}

.sqs-col-5 .sqs-col-1 {
  width: 20%;
}

.sqs-col-4 {
  width: 33.3333%;
}

.sqs-col-4 .sqs-col-4 {
  width: 100%;
}

.sqs-col-4 .sqs-col-3 {
  width: 75%;
}

.sqs-col-4 .sqs-col-2 {
  width: 50%;
}

.sqs-col-4 .sqs-col-1 {
  width: 25%;
}

.sqs-col-3 {
  width: 25%;
}

.sqs-col-3 .sqs-col-3 {
  width: 100%;
}

.sqs-col-3 .sqs-col-2 {
  width: 66.6667%;
}

.sqs-col-3 .sqs-col-1 {
  width: 33.3333%;
}

.sqs-col-2 {
  width: 16.6667%;
}

.sqs-col-2 .sqs-col-2 {
  width: 100%;
}

.sqs-col-2 .sqs-col-1 {
  width: 50%;
}

.sqs-col-1 {
  width: 8.3333%;
}

.sqs-col-1 .sqs-col-1 {
  width: 100%;
}

.sqs-layout:not(.sqs-editing)
  .sqs-row
  .sqs-block:not(.float):not(.sqs-feature-gated-wrapper):first-child {
  padding-top: 0;
}

.sqs-layout:not(.sqs-editing)
  .sqs-row
  .sqs-block:not(.float):not(
    .sqs-feature-gated-wrapper
  ):first-child:last-child {
  padding-bottom: 0;
}

.sqs-layout:not(.sqs-editing)
  .sqs-block
  + .sqs-row
  .sqs-block:not(.float):first-child {
  padding-top: 17px;
}

.sqs-layout:not(.sqs-editing)
  .sqs-block
  + .sqs-row
  .sqs-block:not(.float):first-child:last-child {
  padding-bottom: 17px;
}

.sqs-layout:not(.sqs-editing)
  .sqs-row
  + .sqs-row
  .sqs-block:not(.float):first-child {
  padding-top: 17px;
}

.sqs-layout:not(.sqs-editing)
  .sqs-row
  + .sqs-row
  .sqs-block:not(.float):first-child:last-child {
  padding-bottom: 17px;
}

.sqs-layout:not(.sqs-editing)
  > .sqs-row:first-child
  > [class*="sqs-col"]:first-child
  > .sqs-block:not(:first-child):last-child,
.sqs-layout:not(.sqs-editing)
  .sqs-block
  + .sqs-row
  .sqs-block:not(.float):last-child {
  padding-bottom: 17px;
}

.sqs-layout:not(.sqs-editing)
  .sqs-row
  + .sqs-row:not(:last-child)
  .sqs-block:last-child {
  padding-bottom: 17px;
}

.sqs-block.sized .sqs-block-content {
  overflow: hidden;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

.columns-1 [class*="sqs-col-"] {
  width: 100% !important;
}

.sqs-block .state-message,
.sqs-state-message {
  font: 400 normal 12px / 22px "Clarkson", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  letter-spacing: normal;
  padding: 19px;
  padding-left: 60px;
  color: #3e3e3e;
  position: relative;
  background-color: rgba(128, 128, 128, 0.15);
}

.sqs-block .state-message:after,
.sqs-state-message:after {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  width: 60px;
  /* background: transparent
    url(/universal/images-v6/icons/block-indicator-dark.png) no-repeat center; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-block .state-message:after,
  .sqs-state-message:after {
    /* background-image: url("/universal/images-v6/icons/block-indicator-dark@2x.png"); */
    background-size: 22px;
  }
}

.sqs-block .state-message.information,
.sqs-state-message.information {
  background: #222;
  padding: 30px 20px;
  text-align: center;
  color: #999;
  font-size: 11px;
}

.sqs-block .state-message .title,
.sqs-state-message .title {
  padding-bottom: 8px;
  font-size: 14px;
}

html.cameron .sqs-block .state-message .title,
html.cameron .sqs-state-message .title {
  color: #eee;
}

.sqs-block .state-message > .sqs-state-message-button,
.sqs-state-message > .sqs-state-message-button,
.sqs-block .state-message .sqs-state-message-buttons-wrapper,
.sqs-state-message .sqs-state-message-buttons-wrapper {
  margin-top: 19px;
  margin-left: -41px;
  display: block !important;
  position: relative;
}

.sqs-block .state-message .sqs-state-message-button,
.sqs-state-message .sqs-state-message-button {
  cursor: pointer;
  background: #3e3e3e;
  padding: 11px;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
  line-height: 22px;
  text-align: center;
  display: inline-block;
  position: relative;
}

.sqs-block .state-message .sqs-state-message-button,
.sqs-state-message .sqs-state-message-button,
.sqs-block .state-message .sqs-state-message-button > *,
.sqs-state-message .sqs-state-message-button > * {
  color: #fff !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
  font-weight: 500;
}

.sqs-block .state-message .sqs-state-message-button:focus,
.sqs-state-message .sqs-state-message-button:focus,
.sqs-block .state-message .sqs-state-message-button > *:focus,
.sqs-state-message .sqs-state-message-button > *:focus {
  outline-color: #fff;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;
}

.sqs-block .state-message .sqs-state-message-button:focus:not(:focus-visible),
.sqs-state-message .sqs-state-message-button:focus:not(:focus-visible),
.sqs-block
  .state-message
  .sqs-state-message-button
  > *:focus:not(:focus-visible),
.sqs-state-message .sqs-state-message-button > *:focus:not(:focus-visible) {
  outline: none;
}

.sqs-block .state-message .sqs-state-message-button:hover,
.sqs-state-message .sqs-state-message-button:hover {
  background-color: #000;
  box-shadow: none;
  -o-box-shadow: 0 0 5px 0 none;
  box-shadow: 0 0 5px 0 none;
}

.sqs-block .state-message .sqs-state-message-button.disabled,
.sqs-state-message .sqs-state-message-button.disabled {
  opacity: 0.3;
  cursor: default;
}

.sqs-block .state-message .sqs-state-message-button.disabled > *,
.sqs-state-message .sqs-state-message-button.disabled > * {
  opacity: 0.5;
}

.sqs-block .state-message .sqs-state-message-button.disabled:hover,
.sqs-state-message .sqs-state-message-button.disabled:hover {
  background-color: #3e3e3e !important;
}

.sqs-layout.sqs-editing
  .sqs-block
  .sqs-block
  .state-message
  .sqs-state-message-button,
.sqs-layout.sqs-editing
  .sqs-block
  .sqs-state-message
  .sqs-state-message-button {
  z-index: 1001;
}

.sqs-col-0 {
  width: 0;
  display: none;
}

html.squarespace-damask.is-expanded .sqs-block [data-block-state="invalid"] {
  display: none;
}

html.squarespace-damask.is-expanded
  .sqs-jacquard.sqs-is-page-editing
  .sqs-block
  [data-block-state="invalid"],
html.squarespace-damask.is-expanded
  .sqs-jacquard
  .sqs-catalog
  .sqs-block
  [data-block-state="invalid"] {
  display: block;
}

.sqs-blockStatus {
  display: none;
  position: relative;
  z-index: 1001;
}

html.squarespace-damask .sqs-blockStatus {
  display: block;
}

html.squarespace-damask.is-expanded .sqs-blockStatus {
  display: none;
}

.sqs-blockStatus-box {
  padding: 22px 72px 22px 22px;
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  color: #3e3e3e;
  font-family: "Clarkson", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1em;
  font-weight: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
  box-shadow: -2px 1px 6px 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

[data-state="invalid"] .sqs-blockStatus-box {
  border: 1px solid #f0523d;
}

.sqs-blockStatus-box-title {
  margin: 0 0 11px 0;
  font-size: 12px;
  line-height: 1.65em;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.sqs-blockStatus-box-message,
.sqs-blockStatus-box-kbArticleLink {
  font-size: 11px;
  line-height: 1.65em;
}

.sqs-blockStatus-box-message a:link,
.sqs-blockStatus-box-kbArticleLink a:link,
.sqs-blockStatus-box-message a:hover,
.sqs-blockStatus-box-kbArticleLink a:hover,
.sqs-blockStatus-box-message a:visited,
.sqs-blockStatus-box-kbArticleLink a:visited,
.sqs-blockStatus-box-message a:active,
.sqs-blockStatus-box-kbArticleLink a:active {
  color: #3e3e3e !important;
  border-bottom: 1px solid #3e3e3e !important;
  text-decoration: none !important;
}

.sqs-blockStatus-box-message a:link:hover,
.sqs-blockStatus-box-kbArticleLink a:link:hover,
.sqs-blockStatus-box-message a:hover:hover,
.sqs-blockStatus-box-kbArticleLink a:hover:hover,
.sqs-blockStatus-box-message a:visited:hover,
.sqs-blockStatus-box-kbArticleLink a:visited:hover,
.sqs-blockStatus-box-message a:active:hover,
.sqs-blockStatus-box-kbArticleLink a:active:hover {
  color: #797979 !important;
  border-color: #797979 !important;
}

.sqs-blockStatus-box-kbArticleLink {
  display: inline-block;
}

.fluid-engine.is-editing .sqs-blockStatus-box-kbArticleLink,
.sqs-editing .sqs-blockStatus-box-kbArticleLink {
  display: none;
}

.sqs-blockStatus-box-button {
  display: inline-block;
  margin-top: 11px;
  cursor: pointer;
  outline: none;
  background: #3e3e3e;
  padding: 11px;
  text-align: center;
  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  line-height: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: inherit;
  appearance: none;
}

.sqs-blockStatus-box-button,
.sqs-blockStatus-box-button > * {
  color: #fff !important;
  -webkit-appearance: none;
  border: 0;
  text-transform: uppercase;
  outline: none;
  font-size: 11px;
  font-weight: 500;
}

.sqs-blockStatus-box-button:hover {
  background-color: #000;
  box-shadow: none;
  -o-box-shadow: 0 0 5px 0 none;
  box-shadow: 0 0 5px 0 none;
}

.sqs-blockStatus-box-button.disabled {
  opacity: 0.3;
  cursor: default;
}

.sqs-blockStatus-box-button.disabled > * {
  opacity: 0.5;
}

.sqs-blockStatus-box-button.disabled:hover {
  background-color: #3e3e3e !important;
}

.sqs-blockStatus--overlayMode {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  background: transparent;
  border: 1px solid #ededed;
  pointer-events: none;
  box-sizing: border-box;
  z-index: 9000;
}

.sqs-blockStatus--overlayMode[data-state="invalid"] {
  opacity: 1;
  visibility: visible;
  border: 1px solid #f0523d;
}

.sqs-layout:not(.sqs-editing)
  > .sqs-row:first-child
  .sqs-block:not(.float):first-child
  .sqs-blockStatus--overlayMode {
  top: -25px;
}

.sqs-blockStatus--overlayMode .sqs-blockStatus-box {
  position: absolute;
  top: 6.25px;
  right: 6.25px;
  width: 380px;
  max-width: calc(100% - 12.5px);
  min-width: 320px;
  border: 1px solid #d0d0d0 !important;
  z-index: 1000;
  pointer-events: all;
  transition: opacity 0.2s ease-in;
  opacity: 0;
  visibility: hidden;
}

@media only screen and (pointer: coarse) and (orientation: portrait) and (max-device-height: 926px),
  only screen and (pointer: coarse) and (orientation: landscape) and (max-device-width: 926px) {
  .sqs-blockStatus--overlayMode .sqs-blockStatus-box {
    right: 0;
  }
}

.sqs-blockStatus[data-state="invalid"]
  .sqs-blockStatus-disclosure
  .sqs-blockStatus-alert-badge {
  color: #ce2c30;
  position: absolute;
  top: 11px;
  right: 11px;
  height: 22px;
  width: 22px;
  z-index: 1001;
  pointer-events: all;
}

.fluid-engine.is-editing
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure
  .sqs-blockStatus-alert-badge,
.fluid-engine.is-editing
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure:empty:after,
.sqs-editing
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure
  .sqs-blockStatus-alert-badge,
.sqs-editing
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure:empty:after {
  opacity: 0;
  visibility: hidden;
}

html.squarespace-damask
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure
  .sqs-blockStatus-alert-badge,
html.squarespace-damask
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure:empty:after {
  cursor: pointer;
}

html.squarespace-damask
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-disclosure:hover
  + .sqs-blockStatus-box,
html.squarespace-damask
  .sqs-blockStatus--overlayMode
  .sqs-blockStatus-box:hover {
  opacity: 1;
  visibility: visible;
}

.sqs-block-audio
  .sqs-audio-embed.sqs-block-is-placeholder
  .sqs-widgets-audio-player
  .action {
  cursor: default;
  pointer-events: none;
}

.sqs-block-audio
  .sqs-audio-embed.sqs-block-is-placeholder
  .sqs-widgets-audio-player
  .action
  .play {
  opacity: 0.1;
}

.sqs-block-newsletter.sqs-block-focused .sqs-blockStatus,
.sqs-block-form.sqs-block-focused .sqs-blockStatus,
.sqs-block-opentable.sqs-block-focused .sqs-blockStatus,
.sqs-block-newsletter.sqs-block-editing .sqs-blockStatus,
.sqs-block-form.sqs-block-editing .sqs-blockStatus,
.sqs-block-opentable.sqs-block-editing .sqs-blockStatus {
  opacity: 0;
  visibility: hidden;
}

.fluid-engine.is-editing
  .sqs-block-pricing-plan
  .sqs-blockStatus[data-state="invalid"]
  .sqs-blockStatus-alert-badge,
.sqs-editing
  .sqs-block-pricing-plan
  .sqs-blockStatus[data-state="invalid"]
  .sqs-blockStatus-alert-badge {
  opacity: 1;
  visibility: visible;
}

html.squarespace-damask.is-expanded
  .sqs-is-page-editing
  .sqs-block-newsletter
  [data-block-state="invalid"],
html.squarespace-damask.is-expanded
  .sqs-catalog
  .sqs-block-newsletter
  [data-block-state="invalid"],
html.squarespace-damask.is-expanded
  .sqs-is-page-editing
  .sqs-block-form
  [data-block-state="invalid"],
html.squarespace-damask.is-expanded
  .sqs-catalog
  .sqs-block-form
  [data-block-state="invalid"] {
  display: block;
}

.sqs-block-summary-v2:hover
  .sqs-block-is-placeholder[data-block-state="invalid"]
  .summary-heading {
  width: calc(100% - 80px);
}

.sqs-block-summary-v2:hover
  .sqs-block-is-placeholder[data-block-state="invalid"]
  .summary-carousel-pager {
  width: 80px;
  padding-right: 30px;
}

.sqs-block-summary-v2 .sqsSummaryBlockThumbnailPlaceholder {
  position: absolute;
  top: 0;
}

.sqs-block-twitter .tweet-list.sqs-block-is-placeholder .tweet-avatar {
  width: 48px;
  height: 48px;
}

.sqsSummaryBlockThumbnailPlaceholder {
  position: relative;
  width: 100%;
  height: auto;
  padding-bottom: 65%;
  background: #f6f6f6;
}

.sqsSummaryBlockThumbnailPlaceholder[data-block-state="invalid"] {
  display: none;
}

html.squarespace-damask
  .sqsSummaryBlockThumbnailPlaceholder[data-block-state="invalid"] {
  display: block;
}

html.squarespace-damask.is-expanded
  .sqsSummaryBlockThumbnailPlaceholder[data-block-state="invalid"] {
  display: none;
}

.sqsSummaryBlockThumbnailPlaceholder-play {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -41px;
  margin-left: -31px;
}

.sqsSummaryBlockThumbnailPlaceholder-timeline {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 50px;
  width: 100%;
  border-width: 23px 75px;
  border-style: solid;
  border-color: #e9e9e9;
  background: #b4b4b4;
  box-sizing: border-box;
}

.sqsSummaryBlockThumbnailPlaceholder-timeline:before,
.sqsSummaryBlockThumbnailPlaceholder-timeline:after {
  content: "";
  position: absolute;
  background: #fff;
}

.sqsSummaryBlockThumbnailPlaceholder-timeline:before {
  top: 0;
  left: 0;
  width: 50px;
  height: 100%;
}

.sqsSummaryBlockThumbnailPlaceholder-timeline:after {
  top: 50%;
  left: 48px;
  margin-top: -6px;
  height: 12px;
  width: 12px;
  border-radius: 100%;
}

.sqsSummaryBlockThumbnailPlaceholder + iframe {
  display: none;
}

.sqs-block-video-placeholder {
  padding-bottom: 65%;
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.4) 33%,
    rgba(0, 0, 0, 0) 100%
  );
  background-color: #313131;
  position: relative;
}

.sqs-block-video-placeholder + iframe {
  display: none;
}

.sqs-block-video-placeholder__ui {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sqs-block-video-placeholder--empty .sqs-block-video-placeholder__icon {
  width: 26px;
}

.sqs-block-video-placeholder--in-progress .sqs-block-video-placeholder__icon {
  background-color: transparent;
  width: 80px;
  height: 80px;
}

@keyframes loading-indicator-rotate-spinner {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-indicator-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}

.sqs-block-video-placeholder .loading-indicator {
  line-height: 0;
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 15px;
}

.sqs-block-video-placeholder .loading-indicator__spinner {
  animation: loading-indicator-rotate-spinner 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
}

.sqs-block-video-placeholder .loading-indicator__path {
  fill: transparent;
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  animation: loading-indicator-dash 1.5s ease-in-out infinite;
}

.sqs-block {
  position: relative;
  height: auto;
}

.sqs-block:not(.sqs-block-html):not(.sqs-block-markdown) {
  clear: both;
}

.sqs-block iframe.embedded-scripts-preview {
  display: block;
  position: relative;
  border: 0;
}

.sqs-block .removed-script {
  display: block;
  opacity: 0.6;
  font-style: italic;
}

.sqs-block-code img {
  max-width: 100%;
}

.sqs-block-code .gm-style img {
  max-width: none;
}

.sqs-block-hidden {
  height: 0;
  overflow: hidden;
}

.sqs-block[class*="float"] {
  z-index: 10 !important;
  box-sizing: border-box;
  clear: none;
}

.sqs-block[class*="float-left"] {
  float: left;
  margin-right: 25px;
}

.sqs-block[class*="float-left"] + .sqs-block[class*="float-left"] {
  clear: left;
}

.sqs-block[class*="float-right"] {
  float: right;
  margin-left: 25px;
}

.sqs-block[class*="float-right"] + .sqs-block[class*="float-right"] {
  clear: right;
}

.sqs-block .sqs-intrinsic {
  position: relative !important;
}

.sqs-block .sqs-intrinsic .sqs-intrinsic-content {
  position: absolute !important;
  top: 0;
  left: 0;
  height: 100%;
  max-width: none;
  width: 100%;
}

@media screen and (max-width: 767px) {
  .sqs-gallery-design-grid-slide {
    width: 50% !important;
    clear: none !important;
  }
}

body.squarespace-config .sqs-block-image .sqs-image-caption {
  color: #999;
}

body.squarespace-config .sqs-block-image .sqs-image-caption p {
  margin-bottom: 0;
}

body.squarespace-config
  .sqs-block-image
  .sqs-image-caption.sqs-placeholder-show {
  margin-top: 1em;
}

body.squarespace-config .sqs-block-image .sqs-image-caption .sqs-html-content {
  min-height: 23px;
}

.sqs-block-image .sqs-html {
  transition: max-height 0.3s ease-in-out, min-height 0.3s ease-in-out;
  margin: auto;
}

.sqs-block-image .sqs-html.sqs-empty {
  min-height: 0;
  max-height: 0;
  overflow: hidden;
}

.sqs-block-image.sqs-block-focused .sqs-html.sqs-empty {
  max-height: none;
  overflow: visible;
}

.sqs-block-image .sqs-editing-overlay {
  z-index: 1;
}

.sqs-block-image:not(.sqs-block-focused)
  .image-block-outer-wrapper.layout-caption-below
  .image-caption-wrapper.sqs-empty {
  padding-top: 0px;
}

.sqs-block-image .layout-caption-overlay .sqs-image-caption,
.sqs-block-image .layout-caption-overlay-hover .sqs-image-caption {
  z-index: 2;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper.sqs-html-focused {
  visibility: visible !important;
  opacity: 1 !important;
}

.sqs-block-image .rte .rte-placeholder {
  color: #999 !important;
}

[data-fluid-engine] {
  position: relative;
  height: 100%;
  width: 100%;
}

.fluid-engine .sqs-block {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
}

.dd-drag-hidden {
  display: none;
}

.dd-drag-grouped-item {
  position: absolute !important;
  top: 0;
  left: 0;
}

.yui3-dd-dragging {
  z-index: 1;
}

.dd-reorder-items-count {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0;
  right: 0;
  background: #d0d0d0;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  line-height: 22px;
  color: #fff;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}


.sqs-ui-font-family {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
}

[class^="sqs-ui-font-"]:before,
[class*=" sqs-ui-font-"]:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
}

[data-icon]:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: attr(data-icon);
}

.sqs-gallery-container iframe {
  width: 100%;
  height: 100%;
  background: transparent;
  display: block;
}

.sqs-gallery-controls .previous,
.sqs-gallery-controls .next {
  position: absolute;
  top: 50%;
  color: #fff !important;
  z-index: 999;
  font-size: 14px;
  line-height: 40px;
  margin-top: -30px;
  background-color: rgba(0, 0, 0, 0.12);
  display: inline-block;
  padding: 10px;
  transition: background-color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.sqs-gallery-controls .previous:hover,
.sqs-gallery-controls .next:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.sqs-gallery-controls .previous:focus:not([data-focus-visible-added]),
.sqs-gallery-controls .next:focus:not([data-focus-visible-added]) {
  outline: none;
}

.sqs-gallery-controls .previous {
  left: 0px;
}

.sqs-gallery-controls .previous:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02C";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-gallery-controls .previous:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.sqs-gallery-controls .next {
  right: 0px;
}

.sqs-gallery-controls .next:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02D";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-gallery-controls .next:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.sqs-gallery-controls .next:before,
.sqs-gallery-controls .previous:before {
  font-size: 24px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.sqs-gallery-design-stacked {
  position: relative;
  text-align: left;
}

.sqs-gallery-design-stacked-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sqs-gallery-design-stacked-slide img {
  box-shadow: #000 0em 0em 0em;
}

.sqs-gallery-design-stacked-slide.normal img {
  height: 100%;
}

.sqs-gallery-design-stacked-slide:only-child {
  cursor: default;
}

.sqs-gallery-design-stacked-scrollHorz,
.sqs-gallery-design-stacked-swipe {
  overflow: hidden;
}

.sqs-gallery-design-stacked-scrollHorz .sqs-gallery-design-stacked-slide,
.sqs-gallery-design-stacked-swipe .sqs-gallery-design-stacked-slide {
  position: relative;
  float: left;
}

.sqs-gallery-design-stacked-swipe-wrapper {
  overflow-x: scroll;
  -webkit-transform: translatez(0);
  -ms-overflow-style: none;
  -ms-scroll-chaining: none;
  -ms-scroll-snap-type: mandatory;
  -ms-scroll-snap-points-x: snapinterval(0%, 100%);
}

.sqs-gallery-design-strip {
  position: relative;
  overflow: hidden;
  height: 100%;
}

.sqs-gallery-design-strip .sqs-wrapper {
  position: relative;
  height: 100%;
}

.sqs-gallery-design-strip-slide {
  float: left;
  height: 100% !important;
  max-width: none !important;
  width: auto !important;
  cursor: pointer;
  position: relative;
}

.sqs-gallery-design-strip-slide img,
.sqs-gallery-design-strip-slide .sqs-video-wrapper {
  height: 100% !important;
}

.sqs-gallery-design-strip-slide:only-child {
  cursor: default;
}

.sqs-gallery-design-autocolumns {
  position: relative;
}

.sqs-gallery-design-autocolumns-slide {
  position: absolute;
}

.sqs-gallery-design-autocolumns-slide img {
  width: 100%;
  display: inline-block;
  transition: opacity 0.2s;
  opacity: 1;
}

.sqs-gallery-design-autocolumns-slide img.loading {
  opacity: 0;
}

.sqs-gallery-design-autocolumns-slide.content-fit img,
.sqs-gallery-design-autocolumns-slide .content-fit img {
  width: auto;
}

.sqs-gallery-design-autocolumns-slide.slide-stretched img {
  height: 100%;
}

.sqs-gallery-design-carousel .sqs-gallery-controls {
  overflow: hidden;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .next,
.sqs-gallery-design-carousel .sqs-gallery-controls .previous {
  display: block;
  float: right;
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  margin: 0 0 15px 0;
  padding: 0;
  background-color: transparent;
  color: inherit !important;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02D";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .previous {
  margin-right: 10px;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02C";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .sqs-disabled {
  cursor: default;
  opacity: 0.4;
}

.sqs-gallery-design-carousel .sqs-gallery-controls .sqs-hidden {
  display: none;
}

.sqs-gallery-design-carousel .sqs-gallery-container {
  width: 100%;
  overflow: hidden;
}

.sqs-gallery-design-carousel .sqs-gallery {
  margin: 0 0 0 -1%;
  white-space: nowrap;
  vertical-align: top;
  font-size: 0;
  transition: transform ease 0.4s;
}

.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide {
  display: inline-block;
  width: 33.66666667%;
  padding: 0 1%;
  white-space: nowrap;
  vertical-align: top;
  font-size: 0;
}

.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide img {
  width: 100%;
  height: auto;
}

.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide * {
  white-space: normal;
}

.sqs-gallery-design-list .sqs-gallery-design-list-slide {
  overflow: hidden;
  margin-bottom: 17px !important;
  padding-bottom: 17px !important;
}

.sqs-gallery-design-list .sqs-gallery-image-container {
  float: left;
  width: 25%;
  padding-right: 20px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.sqs-gallery-design-list .sqs-gallery-meta-container {
  float: left;
  width: 75%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.sqs-gallery-design-list
  .sqs-gallery-design-list-slide.no-image
  .sqs-gallery-image-container {
  width: 0 !important;
}

.sqs-gallery-design-list
  .sqs-gallery-design-list-slide.no-image
  .sqs-gallery-meta-container {
  width: 100% !important;
}

@media screen and (max-width: 480px) {
  .sqs-gallery-design-list
    .sqs-gallery-design-list-slide:not(.no-image)
    .sqs-gallery-image-container {
    width: 35% !important;
  }

  .sqs-gallery-design-list
    .sqs-gallery-design-list-slide:not(.no-image)
    .sqs-gallery-meta-container {
    width: 65% !important;
  }
}

.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide {
  float: left;
  cursor: pointer;
  overflow: hidden;
}

.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide img {
  height: 100%;
}

.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide .meta {
  display: none;
}

.sqs-gallery-design-autogrid {
  zoom: 1;
}

.sqs-gallery-design-autogrid:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-gallery-design-autogrid-slide {
  position: relative;
  float: left;
}

.sqs-gallery-design-autogrid-slide .img-wrapper {
  height: 0;
}

.sqs-gallery-design-autogrid-slide img {
  width: 100%;
}

.yui3-lightbox2 {
  -webkit-user-select: text;
  user-select: text;
}

.yui3-lightbox2 .yui3-lightbox2-content {
  height: 100%;
  left: 0;
  position: absolute;
  width: 100%;
  overflow: hidden;
}

.yui3-lightbox2 .sqs-lightbox-slideshow {
  height: 100%;
  opacity: 0;
  z-index: 100000001;
}

.yui3-lightbox2 .sqs-lightbox-slideshow .sqs-lightbox-padder {
  position: absolute;
  text-align: left;
  top: 2%;
  left: 2%;
  bottom: 2%;
  right: 2%;
}

.yui3-lightbox2 .sqs-lightbox-overlay {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  background: #000;
  height: 100%;
  width: 100%;
}

.yui3-lightbox2 .sqs-lightbox-meta {
  position: absolute;
  padding: 20px;
  color: #fff;
  z-index: 100000001;
  margin: 20px auto 0;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  opacity: 0;
  transition: opacity ease-out 0.2s;
}

.yui3-lightbox2 .sqs-lightbox-meta.overlay-description-visible {
  background: #000;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
  background: rgba(0, 0, 0, 0.7);
  opacity: 1 !important;
}

.yui3-lightbox2 .sqs-lightbox-meta p:first-child {
  margin-top: 0;
}

.yui3-lightbox2 .sqs-lightbox-meta p:last-child {
  margin-bottom: 0;
}

.yui3-lightbox2 .sqs-lightbox-meta h1 {
  font-size: 1em;
  color: #fff;
  margin: 0 0 10px;
}

.yui3-lightbox2 .sqs-lightbox-meta p a {
  color: #fff;
  text-decoration: underline;
}

.yui3-lightbox2 .sqs-lightbox-close,
.yui3-lightbox2 .sqs-lightbox-previous,
.yui3-lightbox2 .sqs-lightbox-next,
.yui3-lightbox2 .sqs-lightbox-meta-trigger {
  position: absolute;
  z-index: 100000002;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  height: 20px;
  width: 20px;
  font-size: 26px;
  cursor: pointer;
  outline-color: currentColor;
}

.yui3-lightbox2 .sqs-lightbox-next,
.yui3-lightbox2 .sqs-lightbox-previous {
  padding: 12px;
  opacity: 0;
  top: 50%;
  margin-top: -22px;
  transition: opacity 0.2s;
}

.yui3-lightbox2 .sqs-lightbox-next.mouseover,
.yui3-lightbox2 .sqs-lightbox-previous.mouseover,
.yui3-lightbox2 .sqs-lightbox-next:focus,
.yui3-lightbox2 .sqs-lightbox-previous:focus {
  opacity: 1;
}

.yui3-lightbox2 .sqs-lightbox-next {
  right: 2%;
}

.yui3-lightbox2 .sqs-lightbox-next:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02D";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.yui3-lightbox2 .sqs-lightbox-next:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.yui3-lightbox2 .sqs-lightbox-previous {
  left: 2%;
}

.yui3-lightbox2 .sqs-lightbox-previous:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02C";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.yui3-lightbox2 .sqs-lightbox-previous:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.yui3-lightbox2 .sqs-lightbox-next::before,
.yui3-lightbox2 .sqs-lightbox-previous::before {
  font-size: 22px;
}

.yui3-lightbox2 .sqs-lightbox-close {
  padding: 2px;
  right: 2%;
  top: 2%;
  text-align: right;
}

.yui3-lightbox2 .sqs-lightbox-close:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\E02E";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.yui3-lightbox2 .sqs-lightbox-close:before {
  font-size: 32px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.yui3-lightbox2 .sqs-lightbox-meta-trigger {
  bottom: 0;
  right: 0;
  padding: 2%;
  text-align: center;
  font-size: 26px;
  line-height: 0.5;
  text-align: right;
}

body.sqs-lightbox-open {
  position: static !important;
  overflow-y: hidden;
}

.sqs-gallery img:not([src]) {
  opacity: 0;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}


.sqs-ui-font-family {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
}

[class^="sqs-ui-font-"]:before,
[class*=" sqs-ui-font-"]:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
}

[data-icon]:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: attr(data-icon);
}

#list-paging a,
#item-paging a {
  text-decoration: none;
}

#list-paging a.newer .pagination-icon:before,
#item-paging a.newer .pagination-icon:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e000";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

#list-paging a.newer .pagination-icon:before,
#item-paging a.newer .pagination-icon:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

#list-paging a.newer .pagination-icon:before,
#item-paging a.newer .pagination-icon:before {
  font-size: inherit;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

#list-paging a.older .pagination-icon:after,
#item-paging a.older .pagination-icon:after {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e003";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

#list-paging a.older .pagination-icon:after,
#item-paging a.older .pagination-icon:after {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

#list-paging a.older .pagination-icon:after,
#item-paging a.older .pagination-icon:after {
  font-size: inherit;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

#list-paging,
#item-paging {
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  margin: 3em 0 0 0;
}

#list-paging a,
#item-paging a {
  padding: 1.5em 0;
  display: inline-block;
  width: 48%;
}

#list-paging a.newer .pagination-icon,
#item-paging a.newer .pagination-icon {
  margin-right: 0.5em;
}

#list-paging a.newer:after,
#item-paging a.newer:after {
  content: "Newer";
}

#list-paging a.older,
#item-paging a.older {
  float: right;
  text-align: right;
}

#list-paging a.older .pagination-icon,
#item-paging a.older .pagination-icon {
  margin-left: 0.5em;
}

#list-paging a.older:before,
#item-paging a.older:before {
  content: "Older";
}

#list-paging a.disabled,
#item-paging a.disabled {
  color: #ddd;
}

.like-share {
  float: right;
}

.like-share .sqs-simple-like {
  display: inline-block;
  margin-right: 0.5em;
}

.like-share .sqs-simple-like .like-icon {
  float: none;
  display: inline-block;
  vertical-align: middle;
}

.like-share .squarespace-social-buttons {
  display: inline-block;
  margin-right: 0.5em;
}

.like-share .squarespace-social-buttons .ss-social-button-icon {
  float: none;
  display: inline-block;
  vertical-align: middle;
}

.like-share.empty {
  display: none;
}

.sqs-audio-playlist {
  zoom: 1;
}

.sqs-audio-playlist.loading {
  visibility: hidden;
}

.sqs-audio-playlist:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-audio-playlist.hidden {
  display: none;
}

.sqs-audio-playlist .album-info {
  width: 33%;
  float: left;
  zoom: 1;
}

.sqs-audio-playlist .album-info:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-audio-playlist .album-cover-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
  margin-bottom: 30px;
}

.sqs-audio-playlist .album-controls {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.sqs-audio-playlist .album-controls .button {
  transition: 0.25s all linear;
  border-radius: 50%;
  position: absolute;
  bottom: 50%;
  left: 50%;
  display: block;
  width: 90px;
  height: 90px;
  margin-bottom: -45px;
  margin-left: -45px;
  background: #000;
}

.sqs-audio-playlist .album-controls .icon {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  margin-top: -20px;
  margin-left: -10px;
  width: 0px;
  height: 0px;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  border-left: 30px solid #fff;
  transform: translatez();
}

.sqs-audio-playlist .album-title {
  font-size: 1.5em;
  margin: 0;
}

.sqs-audio-playlist .album-title a {
  text-decoration: none;
}

.sqs-audio-playlist.playing .album-controls .button .icon {
  border-width: 0px;
  margin-top: -15px;
  margin-left: -13px;
}

.sqs-audio-playlist.playing .album-controls .button .icon,
.sqs-audio-playlist.playing .album-controls .button .icon:before {
  height: 30px;
  width: 10px;
  background-color: #fff;
}

.sqs-audio-playlist.playing .album-controls .button .icon:before {
  content: "";
  display: block;
  margin-left: 16px;
}

.sqs-audio-playlist.has-album-cover .album-cover-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  margin-bottom: 20px;
}

.sqs-audio-playlist.has-album-cover .album-cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.sqs-audio-playlist.has-album-cover .button {
  background: rgba(0, 0, 0, 0.7);
  opacity: 0.9;
}

.sqs-audio-playlist.has-album-cover:hover .button {
  background: rgba(0, 0, 0, 0.9);
}

.sqs-audio-playlist.has-album-cover.playing .album-controls .button {
  margin: -15px;
  bottom: 0;
  left: 0;
  transform: scale(0.4, 0.4);
}

.sqs-audio-playlist.has-album-cover.playing .album-controls .button .icon {
  border-width: 0px;
  margin-top: -15px;
  margin-left: -13px;
}

.sqs-audio-playlist.has-album-cover.playing .album-controls .button .icon,
.sqs-audio-playlist.has-album-cover.playing
  .album-controls
  .button
  .icon:before {
  height: 30px;
  width: 10px;
  background-color: #fff;
}

.sqs-audio-playlist.has-album-cover.playing
  .album-controls
  .button
  .icon:before {
  content: "";
  display: block;
  margin-left: 16px;
}

.sqs-audio-playlist.has-album-cover.playing .track {
  opacity: 0.4;
}

.sqs-audio-playlist.has-album-cover.playing .track:hover,
.sqs-audio-playlist.has-album-cover.playing .track.selected {
  opacity: 1;
}

.sqs-audio-playlist .tracks {
  float: right;
  width: 60%;
  margin: 0;
  padding: 0;
}

.sqs-audio-playlist .track {
  list-style-type: none;
  padding: 0;
  margin: 0 0 5%;
  cursor: pointer;
  zoom: 1;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0;
  text-transform: none;
  font-size: 13px;
  line-height: 1.4em;
}

.sqs-audio-playlist .track:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-audio-playlist .track-progress-bar {
  clear: both;
  height: 2px;
  position: relative;
  cursor: pointer;
  padding-bottom: 2.5%;
}

.sqs-audio-playlist .track-progress-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 2px;
  width: 0%;
}

.sqs-audio-playlist .track-progress-bar .bar.bg {
  width: 100%;
}

.sqs-audio-playlist .track-progress-bar .bar.play-bar {
  position: relative;
}

.sqs-audio-playlist .track-meta {
  float: right;
  text-align: right;
}

.sqs-audio-playlist .track-info .title a {
  font-size: 16px;
}

.sqs-audio-playlist.tablet .album-info,
.sqs-audio-playlist.tablet .tracks {
  width: 100%;
  float: none;
}

.sqs-audio-playlist.tablet .album-info {
  padding-bottom: 8%;
}

.sqs-audio-playlist.tablet .album-cover-wrapper {
  float: left;
  margin-right: 30px;
}

.sqs-audio-playlist.tablet.has-album-cover .album-cover-wrapper {
  width: 40%;
  padding-bottom: 40%;
}

.sqs-audio-playlist.tablet.no-main-image .album-description {
  margin-left: 120px;
}

.sqs-audio-playlist.phone .album-info,
.sqs-audio-playlist.phone .tracks {
  width: 100%;
  float: none;
}

.sqs-audio-playlist.phone .tracks {
  margin-top: 30px;
}

.sqs-audio-playlist.phone .tracks .track {
  margin-bottom: 10%;
}

.sqs-audio-playlist.phone .album-info {
  padding-bottom: 0;
}

.sqs-audio-playlist.phone .album-cover-wrapper {
  float: none;
  margin-right: 0;
  margin-bottom: 20px;
}

.sqs-audio-playlist.phone.has-album-cover .album-cover-wrapper {
  width: 100%;
  padding-bottom: 100%;
}

.sqs-audio-playlist.phone.no-main-image .album-description {
  margin-left: 0;
}

.sqs-audio-playlist .track-progress-bar {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);
}

.sqs-audio-playlist .track-progress-bar .bar {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);
}

.sqs-audio-playlist .track-progress-bar .bar.bg {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.sqs-audio-playlist .track-progress-bar .bar.load-bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.05);
}

.sqs-audio-playlist .track-progress-bar .bar.play-bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.8);
}

.sqs-audio-playlist .track-meta .track-time {
  color: #000;
  color: rgba(0, 0, 0, 0.5);
}

.sqs-audio-playlist .track-meta .actions {
  color: #000;
  color: rgba(0, 0, 0, 0.2);
}

.sqs-audio-playlist .track-meta .actions a {
  color: #000;
  color: rgba(0, 0, 0, 0.5);
}

.sqs-audio-playlist .track-meta .actions a:hover {
  color: #000;
  color: rgba(0, 0, 0, 0.8);
}

.sqs-audio-playlist .track-info .title a {
  color: #000;
  color: rgba(0, 0, 0, 0.85);
}

.sqs-audio-playlist .track-info .artist {
  color: #000;
  color: rgba(0, 0, 0, 0.5);
}

.hide-album-share-link .sqs-audio-playlist .squarespace-social-buttons {
  display: none;
}

body:not(.event-show-past-events) .eventlist.eventlist--past {
  display: none;
}

.eventlist-event {
  position: relative;
  margin: 68px 0 0 0;
  padding: 0;
}

.eventlist-event:first-of-type {
  margin: 0;
}

.eventlist-column-thumbnail {
  display: block;
  float: left;
  width: 35%;
  height: 0;
  padding-bottom: 23.33333333%;
  text-decoration: none !important;
  background: rgba(110, 110, 110, 0.05);
}

.eventlist-column-thumbnail img {
  transition: opacity 0.3s ease-in;
}

.eventlist-column-thumbnail img:not(.loaded) {
  opacity: 0;
}

body:not(.event-thumbnails) .eventlist-column-thumbnail {
  display: none;
}

.event-disable-item-pages .eventlist-column-thumbnail {
  cursor: default;
  pointer-events: none;
}

.event-thumbnail-size-11-square .eventlist-column-thumbnail {
  padding-bottom: 35%;
}

.event-thumbnail-size-32-standard .eventlist-column-thumbnail {
  padding-bottom: 23.33333333%;
}

.event-thumbnail-size-23-standard-vertical .eventlist-column-thumbnail {
  padding-bottom: 52.5%;
}

.event-thumbnail-size-43-four-thirds .eventlist-column-thumbnail {
  padding-bottom: 26.25%;
}

.event-thumbnail-size-169-widescreen .eventlist-column-thumbnail {
  padding-bottom: 19.6875%;
}

.event-thumbnail-size-2401-anamorphic-widescreen .eventlist-column-thumbnail {
  padding-bottom: 14.58333333%;
}

.eventlist-column-thumbnail:empty {
  height: auto;
  min-height: 100px;
  padding-bottom: 0 !important;
  background: transparent;
}

.eventlist-column-date {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 35%;
  margin: 0;
  padding: 0;
  color: #333 !important;
  text-decoration: none !important;
}

.event-disable-item-pages .eventlist-column-date {
  cursor: default;
  pointer-events: none;
}

body:not(.event-date-label) .eventlist-column-date {
  display: none;
}

body:not(.event-thumbnails) .eventlist-column-date {
  position: static;
  float: left;
  width: 70px;
}

.eventlist-datetag {
  display: table;
  position: absolute;
  top: 10px;
  right: 10px;
  height: auto;
  min-height: 70px;
  width: 70px;
  margin: 0;
  padding: 0;
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  box-sizing: border-box;
}

body:not(.event-thumbnails) .eventlist-datetag {
  position: static;
  background: #e8ecec;
}

.eventlist-event:not(.eventlist-event--hasimg) .eventlist-datetag {
  top: 0;
  background: #e8ecec;
}

.eventlist-datetag-inner {
  display: table-cell;
  vertical-align: middle;
  margin: 0;
  padding: 6px;
  color: inherit;
  font-size: 0;
  line-height: 0;
  letter-spacing: 0;
}

.eventlist-datetag-startdate--month,
.eventlist-datetag-startdate--day,
.eventlist-datetag-time,
.eventlist-datetag-enddate {
  margin: 3px 0;
  line-height: 1em;
  text-transform: uppercase;
  white-space: nowrap;
}

.eventlist-event--past .eventlist-datetag-startdate--month,
.eventlist-event--past .eventlist-datetag-startdate--day,
.eventlist-event--past .eventlist-datetag-time,
.eventlist-event--past .eventlist-datetag-enddate {
  opacity: 0.3;
}

.eventlist-datetag-time,
.eventlist-datetag-enddate {
  border-top: 1px solid #ddd;
  margin: 6px 0 0 0;
  padding-top: 6px;
  font-size: 11px;
}

.eventlist-datetag-startdate--month {
  font-size: 14px;
  margin-top: 6px;
}

.eventlist-datetag-startdate--day {
  font-size: 26px;
}

body:not(.event-date-label-time) .eventlist-datetag-time {
  display: none;
}

.eventlist-datetag-status {
  display: none;
  position: absolute;
  top: 0px;
  left: 35px;
  width: 1px;
  height: 70px;
  background: #000;
  transform: rotate(45deg);
}

.eventlist-event--past .eventlist-datetag-status {
  display: block;
}

.eventlist-event--past.eventlist-event--multiday .eventlist-datetag-status,
body.event-date-label-time .eventlist-event--past .eventlist-datetag-status {
  top: 0px;
  height: 85px;
  transform: rotate(38deg);
}

.eventlist-column-info {
  float: left;
  width: 65%;
  padding: 0 0 0 34px;
  box-sizing: border-box;
}

body:not(.event-thumbnails) .eventlist-column-info {
  width: calc(100% - 70px);
}

body:not(.event-thumbnails):not(.event-date-label) .eventlist-column-info {
  width: 100%;
  padding-left: 0;
}

.eventlist-cats {
  margin: 0 0 4.25px 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.4em;
}

.eventlist-cats a {
  color: inherit !important;
  text-decoration: none !important;
}

body:not(.event-list-show-cats) .eventlist-cats {
  display: none;
}

.eventlist-title {
  margin: 0 0 17px 0 !important;
  padding: 0 !important;
  font-size: 28px !important;
  line-height: 1.2em !important;
}

.eventlist-title .eventlist-title-link {
  margin: 0 !important;
  padding: 0 !important;
  color: inherit !important;
  text-decoration: none !important;
  font-size: inherit !important;
  line-height: inherit !important;
}

.event-disable-item-pages .eventlist-title .eventlist-title-link {
  cursor: default;
  pointer-events: none;
}

.eventlist-meta {
  list-style-type: none;
  margin: 0 0 17px 0;
  padding: 0;
}

.eventlist-meta-item {
  margin: 0;
  padding: 0;
  text-align: left;
}

.event-icons .eventlist-meta-item {
  position: relative;
  padding-left: 25.5px;
}

.event-icons .eventlist-meta-item:before {
  opacity: 0.5;
  position: absolute;
  top: 3px;
  left: -2px;
}

.event-icons .eventlist-meta-item.eventlist-meta-date:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e015";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.event-icons .eventlist-meta-item.eventlist-meta-date:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.event-icons .eventlist-meta-item.eventlist-meta-time:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e00c";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.event-icons .eventlist-meta-item.eventlist-meta-time:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.event-icons .eventlist-meta-item.eventlist-meta-address:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e02f";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.event-icons .eventlist-meta-item.eventlist-meta-address:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

body:not(.event-list-date) .eventlist-meta-date,
body:not(.event-list-time) .eventlist-meta-time,
body:not(.event-list-address) .eventlist-meta-address {
  display: none;
}

.event-list-time
  .eventlist-event--multiday
  .eventlist-meta-date
  .event-date:after {
  content: ", ";
}

.event-list-time .eventlist-event--multiday .eventlist-meta-time {
  display: inline-block;
}

.eventlist-meta-address-line:after {
  content: ", ";
}

.eventlist-meta-address-line:last-of-type:after {
  content: none;
}

body:not(.event-list-icalgcal-links) .eventlist-meta-export {
  display: none;
}

.eventlist-meta-export-divider {
  margin: 0 4px;
}

.eventlist-meta-export-divider:before {
  content: "\\00B7";
}

body:not(.event-excerpts) .eventlist-description,
body:not(.event-excerpts) .eventlist-excerpt {
  display: none;
}

.eventlist-excerpt {
  margin: 0 0 17px 0;
}

.eventlist a.eventlist-button {
  margin: 5.66666667px 0 25.5px 0;
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

body:not(.event-list-cta-button) .eventlist a.eventlist-button,
body.event-disable-item-pages .eventlist a.eventlist-button {
  display: none !important;
}

body:not(.event-list-like-and-share-buttons) .eventlist-actions {
  display: none;
}

.eventlist-actions .sqs-simple-like {
  line-height: inherit;
}

.eventlist-actions .sqs-simple-like .like-count {
  margin-right: 1.2em;
}

.eventlist-actions .sqs-simple-like .like-count:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e012";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.eventlist-actions .sqs-simple-like .like-count:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.eventlist-actions .sqs-simple-like .like-count:before {
  margin-right: 0.2em;
  position: relative;
  top: 0.13em;
  font-size: 1.2em;
  width: auto;
  height: auto;
  line-height: inherit;
  text-align: left;
  vertical-align: initial;
}

.eventlist-actions .sqs-simple-like .like-icon {
  display: none;
}

.eventlist-actions .ss-social-button:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e02b";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.eventlist-actions .ss-social-button:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.eventlist-actions .ss-social-button:before {
  margin-right: 0.4em;
  font-size: 0.85em;
  width: auto;
  height: auto;
  line-height: inherit;
  text-align: left;
  vertical-align: initial;
}

.eventlist-actions .ss-social-button div {
  display: inline-block;
}

.eventlist-actions .ss-social-button-icon {
  display: none !important;
}

.eventlist-filter {
  font-size: 18px;
  line-height: 1em;
  margin: 0 0 51px 0;
}

.eventlist-past-upcoming-divider {
  display: none;
  height: 0;
  border: none;
  border-top: 1px solid rgba(230, 230, 230, 0.8);
  font-size: 68px;
  line-height: 68px;
}

.eventlist--upcoming + .eventlist--past .eventlist-past-upcoming-divider {
  display: block;
}

.event-datetime-divider:before {
  content: " \\2013 ";
}

.eventitem-backlink {
  display: inline-block;
  margin: 0 0 51px 0;
  text-transform: uppercase;
}

.eventitem-backlink:before {
  content: "\\2190\\0020 ";
}

body:not(.event-item-back-link) .eventitem-backlink {
  display: none;
}

.eventitem {
  position: relative;
}

.eventitem-column-meta {
  float: left;
  width: 30%;
  box-sizing: border-box;
}

.eventitem-title {
  margin: 0 0 34px 0 !important;
  padding: 0 !important;
  font-size: 28px !important;
  line-height: 1.2em !important;
  word-break: break-word;
  word-wrap: break-word;
}

.eventitem-meta {
  list-style-type: none;
  margin: 0 0 17px 0;
  padding: 0;
}

.eventitem-meta-item {
  margin: 0;
  padding: 0;
  font-size: 0.9em;
  line-height: 1.6em;
}

.eventitem--multiday .eventitem-meta-date .event-date:after {
  content: ", ";
}

.eventitem--multiday .eventitem-meta-time {
  display: inline-block;
}

.eventitem-meta-address-line:after {
  content: ", ";
}

.eventitem-meta-address-line:last-of-type:after {
  content: none;
}

.eventitem-meta-address-line.eventitem-meta-address-line--title {
  display: block;
}

.eventitem-meta-address-line.eventitem-meta-address-line--title:after {
  content: none;
}

body:not(.event-icalgcal-links) .event-meta-addtocalendar-container {
  display: none;
}

.eventitem-meta-export-divider {
  margin: 0 4px;
}

.eventitem-meta-export-divider:before {
  content: "\\00B7";
}

.event-meta-socialicon-container .sqs-simple-like {
  line-height: inherit;
}

.event-meta-socialicon-container .sqs-simple-like .like-count {
  margin-right: 1.2em;
}

.event-meta-socialicon-container .sqs-simple-like .like-count:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e012";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.event-meta-socialicon-container .sqs-simple-like .like-count:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.event-meta-socialicon-container .sqs-simple-like .like-count:before {
  margin-right: 0.2em;
  position: relative;
  top: 0.13em;
  font-size: 1.2em;
  width: auto;
  height: auto;
  line-height: inherit;
  text-align: left;
  vertical-align: initial;
}

.event-meta-socialicon-container .sqs-simple-like .like-icon {
  display: none;
}

.event-meta-socialicon-container .ss-social-button:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e02b";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.event-meta-socialicon-container .ss-social-button:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.event-meta-socialicon-container .ss-social-button:before {
  margin-right: 0.4em;
  font-size: 0.85em;
  width: auto;
  height: auto;
  line-height: inherit;
  text-align: left;
  vertical-align: initial;
}

.event-meta-socialicon-container .ss-social-button div {
  display: inline-block;
}

.event-meta-socialicon-container .ss-social-button-icon {
  display: none !important;
}

body:not(.event-like-and-share-buttons) .event-meta-socialicon-container {
  display: none;
}

.eventitem-column-content {
  float: left;
  width: 70%;
  padding-left: 34px;
  box-sizing: border-box;
}

.eventitem-content-footer {
  margin: 17px 0 0 0;
}

.eventitem-content-footer .eventitem-sourceurl {
  margin: 0 0 8.5px 0;
}

.eventitem-content-footer .eventitem-meta {
  margin: 0 0 8.5px 0;
}

.eventitem-content-footer .eventitem-meta > * {
  font-size: inherit;
}

.eventitem-pager {
  margin: 170px 0 0 0;
}

.eventitem-pager-newer,
.eventitem-pager-older {
  float: left;
  display: inline-block;
  text-decoration: none;
  box-sizing: border-box;
}

.eventitem-pager-newer {
  float: right;
  text-align: right;
}

.eventitem-pager-disabled {
  opacity: 0.4;
}

.event-list-compact-view .eventlist-column-thumbnail,
.event-list-compact-view .eventlist-column-date,
.event-list-compact-view .eventlist-column-info {
  width: 100% !important;
}

.event-list-compact-view .eventlist-column-thumbnail:empty {
  min-height: 0;
}

.event-list-compact-view.event-thumbnail-size-11-square
  .eventlist-column-thumbnail {
  padding-bottom: 100%;
}

.event-list-compact-view.event-thumbnail-size-32-standard
  .eventlist-column-thumbnail {
  padding-bottom: 66.666%;
}

.event-list-compact-view.event-thumbnail-size-23-standard-vertical
  .eventlist-column-thumbnail {
  padding-bottom: 150%;
}

.event-list-compact-view.event-thumbnail-size-43-four-thirds
  .eventlist-column-thumbnail {
  padding-bottom: 75%;
}

.event-list-compact-view.event-thumbnail-size-169-widescreen
  .eventlist-column-thumbnail {
  padding-bottom: 56.25%;
}

.event-list-compact-view.event-thumbnail-size-2401-anamorphic-widescreen
  .eventlist-column-thumbnail {
  padding-bottom: 41.666%;
}

.event-list-compact-view .eventlist-datetag {
  left: 0;
  right: auto;
}

.event-list-compact-view.event-thumbnails
  .eventlist-event--hasimg
  .eventlist-datetag {
  left: 10px;
}

.event-list-compact-view.event-thumbnails
  .eventlist-event:not(.eventlist-event--hasimg)
  .eventlist-column-date {
  position: static;
  float: left;
  width: 70px;
}

.event-list-compact-view.event-thumbnails
  .eventlist-event:not(.eventlist-event--hasimg)
  .eventlist-column-date
  .eventlist-datetag {
  position: static;
}

.event-list-compact-view .eventlist-column-info {
  margin: 25.5px 0 0 0;
  padding: 0;
}

.event-list-compact-viewbody:not(.event-thumbnails):not(.event-date-label)
  .eventlist-event {
  margin-top: 34px;
}

.event-list-compact-viewbody:not(.event-thumbnails):not(.event-date-label)
  .eventlist-column-info {
  margin-top: 0;
}

.event-list-compact-view .eventitem-title {
  margin-bottom: 17px !important;
}

.event-list-compact-view .eventitem-column-meta {
  margin-bottom: 34px;
}

.event-list-compact-view .eventitem-column-meta,
.event-list-compact-view .eventitem-column-content {
  float: none;
  width: auto;
  padding: 0;
}

.event-item-compact-view .eventitem-title {
  margin-bottom: 17px !important;
}

.event-item-compact-view .eventitem-column-meta {
  margin-bottom: 34px;
}

.event-item-compact-view .eventitem-column-meta,
.event-item-compact-view .eventitem-column-content {
  float: none;
  width: auto;
  padding: 0;
}

@media only screen and (max-width: 639px) {
  .eventlist-column-thumbnail,
  .eventlist-column-date,
  .eventlist-column-info {
    width: 100% !important;
  }

  .eventlist-column-thumbnail:empty {
    min-height: 0;
  }

  .event-thumbnail-size-11-square .eventlist-column-thumbnail {
    padding-bottom: 100%;
  }

  .event-thumbnail-size-32-standard .eventlist-column-thumbnail {
    padding-bottom: 66.666%;
  }

  .event-thumbnail-size-23-standard-vertical .eventlist-column-thumbnail {
    padding-bottom: 150%;
  }

  .event-thumbnail-size-43-four-thirds .eventlist-column-thumbnail {
    padding-bottom: 75%;
  }

  .event-thumbnail-size-169-widescreen .eventlist-column-thumbnail {
    padding-bottom: 56.25%;
  }

  .event-thumbnail-size-2401-anamorphic-widescreen .eventlist-column-thumbnail {
    padding-bottom: 41.666%;
  }

  .eventlist-datetag {
    left: 0;
    right: auto;
  }

  .event-thumbnails .eventlist-event--hasimg .eventlist-datetag {
    left: 10px;
  }

  .event-thumbnails
    .eventlist-event:not(.eventlist-event--hasimg)
    .eventlist-column-date {
    position: static;
    float: left;
    width: 70px;
  }

  .event-thumbnails
    .eventlist-event:not(.eventlist-event--hasimg)
    .eventlist-column-date
    .eventlist-datetag {
    position: static;
  }

  .eventlist-column-info {
    margin: 25.5px 0 0 0;
    padding: 0;
  }

  body:not(.event-thumbnails):not(.event-date-label) .eventlist-event {
    margin-top: 34px;
  }

  body:not(.event-thumbnails):not(.event-date-label) .eventlist-column-info {
    margin-top: 0;
  }

  .eventitem-title {
    margin-bottom: 17px !important;
  }

  .eventitem-column-meta {
    margin-bottom: 34px;
  }

  .eventitem-column-meta,
  .eventitem-column-content {
    float: none;
    width: auto;
    padding: 0;
  }

  .eventitem-title {
    margin-bottom: 17px !important;
  }

  .eventitem-column-meta {
    margin-bottom: 34px;
  }

  .eventitem-column-meta,
  .eventitem-column-content {
    float: none;
    width: auto;
    padding: 0;
  }
}

.event-time-24hr {
  display: none;
}

.event-time-format .event-time-12hr {
  display: none;
}

.event-time-format .event-time-24hr {
  display: inline;
}

.collection-type-gallery:not(.gallery-design-grid)
  .arrow.previous-slide:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e000";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.collection-type-gallery:not(.gallery-design-grid)
  .arrow.previous-slide:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .arrow.previous-slide:before {
  font-size: 16px;
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e003";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {
  font-size: 16px;
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.collection-type-gallery.gallery-design-grid .dots,
.collection-type-gallery.gallery-design-grid .thumbnail-wrapper,
.collection-type-gallery.gallery-design-grid .circles,
.collection-type-gallery.gallery-design-grid .numbers,
.collection-type-gallery.gallery-design-grid .simple {
  display: none;
}

.collection-type-gallery.gallery-design-grid .slide {
  cursor: pointer;
}

.collection-type-gallery.gallery-design-grid .slide .slide-meta {
  display: none;
}

.collection-type-gallery.gallery-design-grid .slide > a {
  display: block;
  height: 100%;
}

.collection-type-gallery.gallery-design-grid.lightbox-style-light
  .yui3-lightbox2
  .sqs-lightbox-overlay {
  background: #fff;
}

.collection-type-gallery.gallery-design-grid.lightbox-style-light
  .yui3-lightbox2
  .sqs-lightbox-close,
.collection-type-gallery.gallery-design-grid.lightbox-style-light
  .yui3-lightbox2
  .sqs-lightbox-previous,
.collection-type-gallery.gallery-design-grid.lightbox-style-light
  .yui3-lightbox2
  .sqs-lightbox-next,
.collection-type-gallery.gallery-design-grid.lightbox-style-light
  .yui3-lightbox2
  .sqs-lightbox-meta-trigger {
  color: #111;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery {
  cursor: pointer;
  opacity: 0;
  zoom: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  transition: opacity 0.2s ease-out;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .arrow,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .icons
  span {
  -webkit-user-select: none;
  user-select: none;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .gallery-wrapper {
  position: relative;
  width: 100%;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .gallery-wrapper
  .slides {
  display: block;
  width: 100%;
  height: 100% !important;
  transition: opacity 0.2s ease-out;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .gallery-wrapper
  .slides
  .slide {
  opacity: 0;
  zoom: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  height: 100% !important;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .gallery-wrapper
  .slides
  .slide
  > a {
  display: block;
  height: 100%;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slides-controls {
  position: relative;
  z-index: 991;
  overflow: hidden;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .arrow {
  z-index: 997;
  position: absolute;
  width: 100%;
  height: 40px;
  margin-top: -20px;
  text-align: center;
  line-height: 40px;
  font-weight: bold;
  color: #fff;
  background: #222;
  transition: opacity 0.1s ease-in;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .arrow.previous-slide {
  left: 0;
  margin-left: 2%;
  width: 40px;
  height: 40px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .arrow.next-slide {
  right: 0;
  margin-right: 2%;
  float: right;
  width: 40px;
  height: 40px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .arrow.sqs-disabled {
  opacity: 0;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .dots,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .thumbnail-wrapper,
.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .circles,
.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .numbers,
.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .simple {
  display: none;
  margin: 20px 0;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .dots.sqs-gallery-controls-disabled,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .thumbnail-wrapper.sqs-gallery-controls-disabled,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .circles.sqs-gallery-controls-disabled,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .numbers.sqs-gallery-controls-disabled,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple.sqs-gallery-controls-disabled {
  display: none;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .dots {
  text-align: center;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .dots
  .dot {
  font-size: 30px;
  margin: 0 5px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .dots
  .dot:after {
  content: "·";
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .numbers {
  text-align: center;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .numbers
  .number {
  font-size: 12px;
  margin: 0 0.5em;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .circles {
  font-size: 0;
  position: absolute;
  bottom: 0;
  text-align: center;
  z-index: 999;
  width: 100%;
  height: 16px;
  margin: 40px 0;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .circles
  .circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #fff;
  margin: 0 5px;
  border-radius: 100%;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .circles
  .circle.sqs-active-slide {
  background: #fff;
}

.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .simple {
  text-align: center;
  font-size: 12px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .previous.sqs-disabled,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .next.sqs-disabled {
  opacity: 0.5;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .current-index {
  letter-spacing: 2px;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .current-index:after {
  content: " / ";
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .previous {
  float: left;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .previous
  .navigation-text {
  display: inline;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .next {
  float: right;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .simple
  .next
  .navigation-text {
  display: inline;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .next
  .navigation-text,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .previous
  .navigation-text {
  display: none;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .dots
  .dot,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .numbers
  .number,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .thumbnail-wrapper
  .thumbnail {
  opacity: 0.5;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .dots
  .dot.sqs-active-slide,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .numbers
  .number.sqs-active-slide,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .thumbnail-wrapper
  .thumbnail.sqs-active-slide {
  opacity: 1;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .thumbnail-wrapper
  .thumbnail {
  width: 100px !important;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta {
  display: none;
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 996;
  height: auto;
  background: rgba(0, 0, 0, 0.7);
  padding: 24px 0;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .title {
  margin: 0;
  font-size: 14px;
  color: #fff;
  padding: 0 2%;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .description {
  margin-top: 0.5em;
  display: inline-block;
  padding: 0 2%;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .description
  p,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .clickthrough
  a {
  font-size: 13px;
  line-height: 1.4em;
  color: #999;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .description
  p,
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .clickthrough {
  margin: 0;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .description
  p
  a {
  color: #999;
  text-decoration: underline;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .clickthrough {
  display: inline-block;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .clickthrough
  a {
  border-bottom: 1px solid;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery
  .slide-meta
  .clickthrough
  a:before {
  content: "Read more";
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-init {
  position: relative;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-init
  > * {
  display: none;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-ready {
  opacity: 0.01;
  opacity: 1;
  zoom: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=10)";
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-interaction
  .arrow {
  opacity: 0;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-interaction.sqs-system-gallery-hover-slides-left
  .arrow.previous-slide:not(.sqs-disabled),
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-video-iframe
  .arrow.previous-slide:not(.sqs-disabled) {
  opacity: 1;
}

.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-interaction.sqs-system-gallery-hover-slides-right
  .arrow.next-slide:not(.sqs-disabled),
.collection-type-gallery:not(.gallery-design-grid)
  .sqs-system-gallery.sqs-system-gallery-video-iframe
  .arrow.next-slide:not(.sqs-disabled) {
  opacity: 1;
}

.collection-type-gallery:not(.gallery-design-grid).dialog-open
  .arrow.previous-slide:not(.sqs-disabled) {
  opacity: 1;
}

.collection-type-gallery:not(.gallery-design-grid).dialog-open
  .arrow.next-slide:not(.sqs-disabled) {
  opacity: 1;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-thumbnails
  .sqs-system-gallery
  .thumbnail-wrapper {
  display: block;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-bullets
  .sqs-system-gallery
  .dots {
  display: block;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-numbers
  .sqs-system-gallery
  .numbers {
  display: block;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-circles
  .sqs-system-gallery
  .slide-meta {
  bottom: auto;
  top: 0;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-circles
  .sqs-system-gallery
  .circles {
  display: block;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-simple
  .sqs-system-gallery
  .simple {
  display: block;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-info-overlay-always-show
  .sqs-system-gallery
  .slide-meta.show {
  display: block;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-info-overlay-show-on-hover
  .slide:hover
  .slide-meta.show {
  display: block;
}

.collection-type-gallery:not(.gallery-design-grid):not(.gallery-show-arrows)
  .sqs-system-gallery
  .arrow {
  opacity: 0 !important;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-11-square
  .sqs-system-gallery.sqs-system-gallery-init {
  padding-bottom: 100%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-11-square
  .thumbnail-wrapper {
  height: 100px;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-32-standard
  .sqs-system-gallery.sqs-system-gallery-init {
  padding-bottom: 66.66%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-32-standard
  .thumbnail-wrapper {
  height: 66px;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-43-four-thirds
  .sqs-system-gallery.sqs-system-gallery-init {
  padding-bottom: 75%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-43-four-thirds
  .thumbnail-wrapper {
  height: 75px;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-169-widescreen
  .sqs-system-gallery.sqs-system-gallery-init {
  padding-bottom: 56.25%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-aspect-ratio-169-widescreen
  .thumbnail-wrapper {
  height: 56.25px;
}

.collection-type-gallery:not(.gallery-design-grid).gallery-arrow-style-circular
  .sqs-system-gallery
  .arrow {
  border-radius: 100%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-arrow-style-round-corners
  .sqs-system-gallery
  .arrow {
  border-radius: 10%;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-arrow-style-rectangular
  .sqs-system-gallery
  .arrow {
  border-radius: 0;
}

.collection-type-gallery:not(
    .gallery-design-grid
  ).gallery-arrow-style-no-background
  .sqs-system-gallery
  .arrow {
  border-radius: 0;
  background: none;
}

@media screen and (max-width: 480px) {
  .collection-type-gallery .sqs-system-gallery .slide-meta {
    display: none !important;
  }
}

.tweak-product-list-scarcity-font {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: none;
}

.tweak-product-details-scarcity-font {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 16px;
  letter-spacing: 1px;
  text-transform: none;
}

.tweak-product-details-restock-notification-font {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
  letter-spacing: 1px;
}

#productList {
  clear: both;
  margin-left: -3%;
  margin-top: -3%;
  width: 103%;
}

#productList .product {
  cursor: pointer;
  float: left;
  margin-left: 2.91262136%;
  margin-top: 3%;
  position: relative;
  width: 22.08737864%;
}

#productList .product .product-image {
  transition: opacity 0.14s ease-out;
}

#productList .product .product-image .intrinsic {
  padding-bottom: 100%;
  line-height: 0;
  position: relative;
  overflow: hidden;
}

#productList .product .product-image .intrinsic > div {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0);
}

#productList .product .product-image img {
  transition: opacity 0.3s ease-out;
}

#productList .product .product-mark {
  position: absolute;
  top: 15px;
  right: 0;
  background: #222;
  padding: 6px 8px;
  color: #fff;
  line-height: 1em;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
}

#productList .product .product-title {
  font-size: 15px;
  line-height: 1.5em;
  margin-top: 1em;
}

#productList .product .product-price {
  font-size: 12px;
  display: none;
  line-height: 1.5em;
}

#productList .product .product-price .original-price {
  text-decoration: line-through;
  opacity: 0.7;
  filter: alpha(opacity=70);
}

#productList .product .product-price .strikeout {
  text-decoration: line-through;
}

#productList .product .product-scarcity {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: none;
  color: #1d1d1d;
}

#productList .product .product-image img {
  will-change: opacity;
}

#productList .product:hover .product-image img {
  opacity: 0.8;
  filter: alpha(opacity=80);
}

#productList .product .product-quick-view-button-hover-zone {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
}

#productList .product:hover .product-quick-view-button-hover-zone {
  opacity: 1;
}

#productList .product .product-quick-view-button-container {
  position: absolute;
  top: auto;
  bottom: 10%;
  width: 100%;
  text-align: center;
}

#productList .product:nth-child(4n + 1) {
  clear: left;
}

#productList ul.pagination {
  clear: both;
  margin-top: 15px;
  margin-left: 2.91262136%;
}

#productList ul.pagination li {
  display: inline-block;
}

#productList ul.pagination li.previous-page {
  text-align: left;
}

#productList ul.pagination li.next-page {
  text-align: right;
}

.product-list-alignment-center #productList .product-title,
.product-list-alignment-center #productList .product-price,
.product-list-alignment-center #productList .product-scarcity {
  text-align: center;
}

.product-item-size-11-square #productList .product .product-image .intrinsic,
.product-item-size-11-square
  #productList
  .product
  .product-quick-view-button-hover-zone {
  padding-bottom: 100%;
}

.product-item-size-32-standard #productList .product .product-image .intrinsic,
.product-item-size-32-standard
  #productList
  .product
  .product-quick-view-button-hover-zone {
  padding-bottom: 66.666%;
}

.product-item-size-23-standard-vertical
  #productList
  .product
  .product-image
  .intrinsic,
.product-item-size-23-standard-vertical
  #productList
  .product
  .product-quick-view-button-hover-zone {
  padding-bottom: 150%;
}

.product-item-size-43-four-thirds
  #productList
  .product
  .product-image
  .intrinsic,
.product-item-size-43-four-thirds
  #productList
  .product
  .product-quick-view-button-hover-zone {
  padding-bottom: 75%;
}

.product-item-size-169-widescreen
  #productList
  .product
  .product-image
  .intrinsic,
.product-item-size-169-widescreen
  #productList
  .product
  .product-quick-view-button-hover-zone {
  padding-bottom: 56.25%;
}

@media only screen and (min-width: 700px) {
  .no-touch .product-list-titles-overlay #productList .product .product-image {
    margin: 0;
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product
    .product-overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.6);
    color: #fff;
    -webkit-font-smoothing: antialiased;
  }

  .no-touch .product-list-titles-overlay #productList .product .product-mark {
    font-size: 12px;
    line-height: normal;
  }

  .no-touch .product-list-titles-overlay #productList .product .product-meta {
    position: absolute;
    width: 80%;
    margin: 0 10%;
    top: 50%;
  }

  .no-touch .product-list-titles-overlay #productList .product .product-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5em;
    color: #000;
  }

  .no-touch .product-list-titles-overlay #productList .product .product-price {
    font-size: 13px;
    line-height: normal;
    color: #000;
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product
    .product-overlay {
    opacity: 0;
    transition: opacity 0.3s ease-out;
    filter: alpha(opacity=0);
  }

  .no-touch .product-list-titles-overlay #productList .product .product-mark {
    opacity: 1;
    transition: opacity 0.3s ease-out;
    filter: alpha(opacity=100);
  }

  .no-touch .product-list-titles-overlay #productList .product .product-meta {
    opacity: 0;
    transition: opacity 0.35s cubic-bezier(0, 0, 1, 1);
    filter: alpha(opacity=0);
  }

  .no-touch .product-list-titles-overlay #productList .product .product-title {
    margin-top: 5px;
    transition: margin 0.3s cubic-bezier(0, 0, 0.28, 1);
  }

  .no-touch .product-list-titles-overlay #productList .product .product-title,
  .no-touch .product-list-titles-overlay #productList .product .product-price {
    text-align: center;
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product:hover
    .product-overlay {
    opacity: 1;
    filter: alpha(opacity=100);
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product:hover
    .product-mark {
    opacity: 0;
    filter: alpha(opacity=0);
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product:hover
    .product-meta {
    opacity: 1;
    filter: alpha(opacity=100);
  }

  .no-touch
    .product-list-titles-overlay
    #productList
    .product:hover
    .product-title {
    margin-top: 0;
  }
}

.product-list-titles-under .product-meta {
  margin-top: 0 !important;
}

.show-product-price #productList .product .product-price {
  display: block;
}

.sqs-style-mode .product-overlay {
  opacity: 1 !important;
}

.sqs-style-mode .product-mark {
  opacity: 0 !important;
}

.sqs-style-mode .product-meta {
  opacity: 1 !important;
}

#productNav {
  text-transform: uppercase;
  margin-bottom: 30px;
  display: none;
}

.product-title.mobile {
  display: none;
}

#productDetails {
  position: relative;
  float: right;
  width: 48.5%;
}

#productDetails .product-title {
  margin: 0 0 0.5em;
}

#productDetails .product-mark {
  float: right;
  background: #222;
  padding: 6px 8px;
  color: #fff;
  line-height: 1em;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  font-size: 12px;
}

#productDetails .product-price {
  margin: 1em 0;
  font-size: 16px;
  line-height: 1.5em;
}

#productDetails .product-price input {
  width: 130px;
  height: 30px;
  padding-left: 5px;
}

#productDetails .product-price .minimum-price {
  margin-top: 3px;
  margin-left: 10px;
}

#productDetails .product-price .original-price {
  text-decoration: line-through;
  opacity: 0.7;
  filter: alpha(opacity=70);
}

#productDetails .product-price .strikeout {
  text-decoration: line-through;
}

#productDetails .product-variants .variant-option {
  margin: 1.2em 0;
}

#productDetails .product-variants .variant-option select {
  font-family: initial;
}

#productDetails .product-variants .variant-out-of-stock {
  color: #c00;
}

#productDetails .product-variants .variant-radiobtn-wrapper {
  display: none;
}

#productDetails .product-quantity-select {
  margin-top: 1.2em 0;
}

#productDetails .product-scarcity {
  margin-top: 1em;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 16px;
  letter-spacing: 1px;
  text-transform: none;
  color: #1d1d1d;
}

#productDetails .product-restock-notification:not([hidden]) {
  display: flex;
  flex-direction: column;
  margin-top: 1em;
  margin-bottom: 1em;
}

#productDetails
  .product-restock-notification:not([hidden])
  ~ .sqs-add-to-cart-button-wrapper {
  display: none;
}

#productDetails
  .product-restock-notification:not([hidden])
  .product-restock-cta {
  color: #1d1d1d;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
  letter-spacing: 1px;
}

#productDetails
  .product-restock-notification:not([hidden])
  .product-restock-form {
  display: flex;
}

#productDetails
  .product-restock-notification:not([hidden])
  .product-restock-form
  > input[type="text"] {
  margin-right: 22px;
}

#productDetails
  .product-restock-notification:not([hidden])
  .product-restock-form
  > input[type="submit"] {
  font-size: 13px;
}

#productDetails input:not([type="submit"]) {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.product-sharing {
  display: none;
}

.product-social-sharing .product-sharing {
  display: block;
}

#productGallery {
  width: 48.5%;
  float: left;
}

#productGallery .intrinsic {
  max-width: 100%;
}

#productGallery .wrapper {
  padding-bottom: 100%;
  position: relative;
}

#productGallery #productSlideshow {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
}

#productGallery #productSlideshow .slide {
  height: 100%;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

#productGallery #productThumbnails {
  margin-left: -5px;
  visibility: hidden;
  overflow: hidden;
}

#productGallery #productThumbnails .slide {
  width: 50px;
  height: 50px;
  margin: 5px 0 0 5px;
  font-size: 0;
  cursor: pointer;
  float: left;
  background-color: rgba(0, 0, 0, 0);
}

.product-gallery-size-11-square #productGallery .intrinsic .wrapper {
  padding-bottom: 100%;
}

.product-gallery-size-32-standard #productGallery .intrinsic .wrapper {
  padding-bottom: 66.666%;
}

.product-gallery-size-23-standard-vertical #productGallery .intrinsic .wrapper {
  padding-bottom: 150%;
}

.product-gallery-size-43-four-thirds #productGallery .intrinsic .wrapper {
  padding-bottom: 75%;
}

.product-gallery-size-169-widescreen #productGallery .intrinsic .wrapper {
  padding-bottom: 56.25%;
}

.product-description {
  clear: both;
  margin-top: 24px;
}

#productWrapper .ProductItem-relatedProducts-label {
  margin-top: 50px;
  margin-bottom: 22px;
}

#productWrapper .relatedProducts #productList {
  margin: 0 -50px -50px 0;
  width: calc(100% + -50px);
  display: flex;
}

#productWrapper .relatedProducts-item {
  position: relative;
  box-sizing: border-box;
  width: calc(33.33333333% - 50px);
  margin: 0 50px 0 0;
  cursor: pointer;
}

#productWrapper .relatedProducts-item:nth-child(n + 4) {
  display: none;
}

.tweak-v1-related-products-image-aspect-ratio-11-square
  #productWrapper
  .relatedProducts-item
  .intrinsic {
  padding-bottom: 100% !important;
}

.tweak-v1-related-products-image-aspect-ratio-32-standard
  #productWrapper
  .relatedProducts-item
  .intrinsic {
  padding-bottom: 66.666% !important;
}

.tweak-v1-related-products-image-aspect-ratio-23-standard-vertical
  #productWrapper
  .relatedProducts-item
  .intrinsic {
  padding-bottom: 150% !important;
}

.tweak-v1-related-products-image-aspect-ratio-43-four-three
  #productWrapper
  .relatedProducts-item
  .intrinsic {
  padding-bottom: 75% !important;
}

.tweak-v1-related-products-image-aspect-ratio-169-widescreen
  #productWrapper
  .relatedProducts-item
  .intrinsic {
  padding-bottom: 56.25% !important;
}

.tweak-v1-related-products-details-alignment-left
  #productWrapper
  .relatedProducts-item
  .product-meta
  > * {
  text-align: left;
}

.tweak-v1-related-products-details-alignment-center
  #productWrapper
  .relatedProducts-item
  .product-meta
  > * {
  text-align: center;
}

.show-product-item-nav #productWrapper #productNav {
  display: block;
}

.sqs-add-to-cart-button-wrapper {
  visibility: hidden;
}

.sqs-add-to-cart-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  font-size: 13px;
}

.sqs-add-to-cart-button-inner {
  position: relative;
}

.sqs-add-to-cart-button.cart-adding .sqs-spin {
  position: absolute;
  top: 50%;
  margin-top: -12px;
}

.sqs-add-to-cart-button.cart-adding .status-text {
  display: inline-block;
}

.sqs-add-to-cart-button.cart-added .status-text {
  margin-left: 0;
}

.collection-type-products .sqs-add-to-cart-button-wrapper {
  margin: 20px 0;
}

.collection-type-products .sqs-add-to-cart-button {
  padding: 1.5em 4em !important;
}

.sqs-donate-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

@media only screen and (max-width: 700px) {
  #productSummary .product-title {
    display: none;
  }

  #productSummary .product-title.mobile {
    display: block;
  }

  .product-meta {
    margin-top: 0 !important;
  }

  #productDetails,
  #productGallery {
    width: 100%;
    float: none;
  }

  #productList {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }

  #productList .product {
    float: left;
    margin-left: 0;
    margin-top: 0;
    width: 100%;
    cursor: pointer;
    margin-bottom: 3%;
  }

  #productList .product .product-image {
    margin-bottom: 3%;
  }

  #productList .product .product-image .content-fit {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  #productList .product .product-image img {
    transition: opacity 0.3s ease-out;
  }

  .product-quick-view {
    display: none;
  }
}

.captcha-container.rendered {
  margin-bottom: 24px;
  width: 304px;
}

.captcha-container.rendered.align-center {
  margin-left: auto;
  margin-right: auto;
}

.captcha-container.rendered.align-right {
  margin-left: auto;
}

.newsletter-block {
  transition: opacity 0.2s ease-out;
}

.newsletter-block * {
  box-sizing: border-box;
}

.newsletter-block:not(.rendered) {
  opacity: 0;
}

.newsletter-block .newsletter-form-wrapper {
  width: 100%;
  padding: 34px 34px;
  background: rgba(0, 0, 0, 0.05);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 15px;
}

.newsletter-block .newsletter-form-wrapper.hidden,
.newsletter-block .newsletter-form-wrapper .hidden {
  display: none;
}

.newsletter-block .newsletter-form {
  text-align: center;
}

.newsletter-block .newsletter-form-wrapper--alignLeft .newsletter-form {
  text-align: left;
}

.newsletter-block .newsletter-form-wrapper--alignRight .newsletter-form {
  text-align: right;
}

.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container,
.newsletter-block .newsletter-form-wrapper--layoutStack .newsletter-form-body {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container {
  margin-bottom: 12px;
  margin-top: 12px;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack
  .newsletter-form-button-wrapper.submit-wrapper {
  margin-top: 0;
  order: 999999;
}

.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container,
.newsletter-block .newsletter-form-wrapper--layoutStack .newsletter-form-body {
  align-items: center;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignLeft
  .captcha-container,
.newsletter-block
  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignLeft
  .newsletter-form-body {
  align-items: flex-start;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignRight
  .captcha-container,
.newsletter-block
  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignRight
  .newsletter-form-body {
  align-items: flex-end;
}

.newsletter-block
  .newsletter-form-wrapper--alignCenter.newsletter-form-wrapper {
  padding: 34px 17px;
}

.newsletter-block .newsletter-form-header {
  width: 85%;
  margin: 0 auto;
}

.newsletter-block .newsletter-form-wrapper--alignLeft .newsletter-form-header,
.newsletter-block .newsletter-form-wrapper--alignRight .newsletter-form-header {
  width: 100%;
  margin: 0;
}

.newsletter-block .newsletter-form-header-title {
  margin: 0 0 17px 0;
  padding: 0;
  color: #272727;
  font-size: 30px;
  line-height: 1.2em;
  text-align: inherit;
}

.newsletter-block .newsletter-form-header-title a {
  text-decoration: underline;
}

.newsletter-block .newsletter-form-header-description {
  color: #272727;
}

.newsletter-block .newsletter-form-header-description p {
  margin: 17px 0;
  padding: 0;
  font-size: 15px;
  line-height: 1.6em;
}

.newsletter-block .newsletter-form-header-description a {
  text-decoration: underline;
}

.newsletter-block .newsletter-form-body {
  padding: 0 0 12px 0;
}

.newsletter-block .newsletter-form-body > .field-error {
  display: block;
  max-width: 270px;
}

.newsletter-block .newsletter-form-fields-wrapper {
  display: inline-block;
  width: auto;
  margin: 12px 0 0 0;
}

.newsletter-block .newsletter-form-name-fieldset {
  display: inline-block;
  width: auto;
  margin: 0;
  padding: 0;
  border: none;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack
  .newsletter-form-name-fieldset {
  display: block;
  width: 100%;
  max-width: 250px;
}

.newsletter-block .newsletter-form-field-wrapper {
  display: inline-block;
  width: auto;
  min-width: 250px;
  padding: 6px 3px;
}

.newsletter-block
  .newsletter-form-wrapper--alignLeft
  .newsletter-form-field-wrapper {
  padding: 6px 3px 6px 0;
}

.newsletter-block
  .newsletter-form-wrapper--alignRight
  .newsletter-form-field-wrapper {
  padding: 6px 0 6px 3px;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack
  .newsletter-form-field-wrapper {
  display: block;
  width: 100%;
  max-width: 250px;
  padding: 6px 0;
}

.newsletter-block .newsletter-form-field-label {
  display: none;
}

.newsletter-block .newsletter-form-field-element {
  transition: "background 0.3s ease-out, border 0.3s ease-out";
  width: 100%;
  padding: 1em;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  font-family: inherit;
  font-size: 15px;
  line-height: normal;
  outline: none;
}

.newsletter-block .newsletter-form-field-element:focus {
  background: #fff;
}

.newsletter-block .newsletter-form-field-element::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.3);
}

.newsletter-block .newsletter-form-field-element:-moz-placeholder {
  color: rgba(0, 0, 0, 0.3);
}

.newsletter-block .newsletter-form-field-element::-moz-placeholder {
  color: rgba(0, 0, 0, 0.3);
}

.newsletter-block .newsletter-form-field-element:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.3);
}

.newsletter-block .newsletter-form-field-wrapper .field-error {
  display: block;
  margin-bottom: 12px;
  padding: 6px;
  background: #fed9db;
  color: #f23d3d;
  font-size: 12px;
  line-height: normal;
}

.newsletter-block .newsletter-form-button-wrapper {
  display: inline-block;
  width: auto;
  margin: 12px 0 0 0;
  padding: 6px 3px;
}

.newsletter-block
  .newsletter-form-wrapper--alignLeft
  .newsletter-form-button-wrapper {
  padding: 6px 3px 6px 0;
}

.newsletter-block
  .newsletter-form-wrapper--alignRight
  .newsletter-form-button-wrapper {
  padding: 6px 0 6px 3px;
}

.newsletter-block
  .newsletter-form-wrapper--layoutStack
  .newsletter-form-button-wrapper {
  display: block;
  padding: 6px 0;
}

.newsletter-block .newsletter-form-button {
  position: relative;
  width: auto;
  padding: 1em 2.25em;
  color: #fff;
  background-color: #272727;
  border: 1px solid #272727 !important;
  font-family: inherit;
  font-size: 15px;
  line-height: normal;
  font-weight: normal;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
}

.newsletter-block .newsletter-form-spinner.sqs-spin.light.large {
  visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 22px;
  width: 22px;
  margin-top: -11px;
  margin-left: -11px;
}

.newsletter-block
  .newsletter-form:not(.submitting)
  .newsletter-form-spinner.sqs-spin.light.large {
  animation: none;
}

.newsletter-block
  .newsletter-form.submitting
  .newsletter-form-spinner.sqs-spin.light.large {
  visibility: visible;
}

.newsletter-block .newsletter-form.submitting .newsletter-form-button-label {
  visibility: hidden;
}

.newsletter-block .newsletter-form-footnote {
  color: #272727;
}

.newsletter-block .newsletter-form-footnote p {
  opacity: 0.8;
  margin: 17px 0;
  padding: 0;
  font-size: 12px !important;
  line-height: normal;
}

.newsletter-block .newsletter-form-footnote p:last-child {
  margin-bottom: 0;
}

.newsletter-block .newsletter-form-footnote a {
  text-decoration: underline;
}

.newsletter-block .form-submission-text {
  color: #272727;
}

.newsletter-block .form-submission-text p {
  margin: 17px 0;
  padding: 0;
  font-size: 15px;
  line-height: 1.6em;
}

.newsletter-block .form-submission-text p:first-child {
  margin-top: 0;
}

.newsletter-block .form-submission-text p:last-child {
  margin-bottom: 0;
}

.newsletter-block .form-submission-text a {
  text-decoration: underline;
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper {
  padding: 0px;
  background: rgba(0, 0, 0, 0);
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper.newsletter-form-wrapper--alignCenter.newsletter-form-wrapper {
  padding: 0px 0px;
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .newsletter-form-header-title {
  color: #fff;
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .newsletter-form-header-description,
.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .newsletter-form-footnote,
.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .form-submission-text {
  color: #fff;
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .newsletter-form-field-element {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-wrapper
  .newsletter-form-button {
  color: #fff;
  background-color: #272727;
  border: 1px solid #272727 !important;
}

.newsletter-block .form-submission-text:focus:not(:focus-visible),
.newsletter-block .form-submission-html:focus:not(:focus-visible),
.newsletter-block .field-error:focus:not(:focus-visible) {
  outline: none;
}

.newsletter-style-dark .newsletter-block .newsletter-form-wrapper,
.newsletter-style-dark .newsletter-block .newsletter-form-header-title,
.newsletter-style-dark .newsletter-block .newsletter-form-header-description p,
.newsletter-style-dark .newsletter-block .newsletter-form-footnote p,
.newsletter-style-dark .newsletter-block .form-submission-text p {
  color: #272727;
}

.newsletter-style-dark .newsletter-block .newsletter-form-header-title a,
.newsletter-style-dark .newsletter-block .newsletter-form-header-description a,
.newsletter-style-dark .newsletter-block .newsletter-form-footnote a,
.newsletter-style-dark .newsletter-block .form-submission-text a {
  color: #272727;
}

.newsletter-style-light .newsletter-block .newsletter-form-wrapper,
.newsletter-style-light .newsletter-block .newsletter-form-header-title,
.newsletter-style-light .newsletter-block .newsletter-form-header-description p,
.newsletter-style-light .newsletter-block .newsletter-form-footnote p,
.newsletter-style-light .newsletter-block .form-submission-text p {
  color: #fff;
}

.newsletter-style-light .newsletter-block .newsletter-form-header-title a,
.newsletter-style-light .newsletter-block .newsletter-form-header-description a,
.newsletter-style-light .newsletter-block .newsletter-form-footnote a,
.newsletter-style-light .newsletter-block .form-submission-text a {
  color: #fff;
}

.newsletter-style-light .newsletter-block .newsletter-form-field-element {
  color: #272727;
}

.newsletter-form-small-mode .newsletter-form-header {
  width: 100%;
}

.newsletter-form-small-mode .newsletter-form-header-title {
  font-size: 27px !important;
  margin: 0 0 14px 0;
}

.newsletter-form-small-mode .newsletter-form-header-description p {
  margin: 0 0 14px 0;
  line-height: normal;
}

.newsletter-form-small-mode .newsletter-form-body {
  display: flex;
  flex-direction: column;
  padding: 0 0 6px 0;
}

.newsletter-form-small-mode .newsletter-form-fields-wrapper {
  display: block;
  order: 0;
}

.newsletter-form-small-mode .newsletter-form-name-fieldset {
  width: 100%;
}

.newsletter-form-small-mode .newsletter-form-field-wrapper,
.newsletter-form-small-mode .newsletter-form-button-wrapper {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 5px 0;
}

.newsletter-form-small-mode .newsletter-form-button-wrapper {
  margin: 6px 0 0 0;
}

.newsletter-form-small-mode .newsletter-form-button-wrapper {
  order: 2;
}

.newsletter-form-small-mode .newsletter-form-body .captcha-container.rendered {
  order: 1;
  margin-bottom: 0;
  width: auto;
}

.newsletter-form-small-mode .newsletter-form-footnote p {
  margin: 14px 0;
}

.newsletter-form-small-mode .newsletter-form-footnote p:last-child {
  margin-bottom: 0;
}

.newsletter-form-small-mode .disclaimer-container {
  font-size: 14px;
}

.newsletter-form-small-mode .form-submission-text p {
  margin: 14px 0;
  line-height: normal;
}

.newsletter-form-small-mode .form-submission-text p:first-child {
  margin-top: 0;
}

.newsletter-form-small-mode .form-submission-text p:last-child {
  margin-bottom: 0;
}

@media screen and (max-width: 320px) {
  .newsletter-block .newsletter-form-header {
    width: 100%;
  }

  .newsletter-block .newsletter-form-header-title {
    font-size: 27px !important;
    margin: 0 0 14px 0;
  }

  .newsletter-block .newsletter-form-header-description p {
    margin: 0 0 14px 0;
    line-height: normal;
  }

  .newsletter-block .newsletter-form-body {
    display: flex;
    flex-direction: column;
    padding: 0 0 6px 0;
  }

  .newsletter-block .newsletter-form-fields-wrapper {
    display: block;
    order: 0;
  }

  .newsletter-block .newsletter-form-name-fieldset {
    width: 100%;
  }

  .newsletter-block .newsletter-form-field-wrapper,
  .newsletter-block .newsletter-form-button-wrapper {
    display: block;
    width: 100%;
    min-width: 0;
    padding: 5px 0;
  }

  .newsletter-block .newsletter-form-button-wrapper {
    margin: 6px 0 0 0;
  }

  .newsletter-block .newsletter-form-button-wrapper {
    order: 2;
  }

  .newsletter-block .newsletter-form-body .captcha-container.rendered {
    order: 1;
    margin-bottom: 0;
    width: auto;
  }

  .newsletter-block .newsletter-form-footnote p {
    margin: 14px 0;
  }

  .newsletter-block .newsletter-form-footnote p:last-child {
    margin-bottom: 0;
  }

  .newsletter-block .disclaimer-container {
    font-size: 14px;
  }

  .newsletter-block .form-submission-text p {
    margin: 14px 0;
    line-height: normal;
  }

  .newsletter-block .form-submission-text p:first-child {
    margin-top: 0;
  }

  .newsletter-block .form-submission-text p:last-child {
    margin-bottom: 0;
  }
}

.newsletter-block.newsletter-form-has-small-container .newsletter-form-header {
  width: 100%;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-header-title {
  font-size: 27px !important;
  margin: 0 0 14px 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-header-description
  p {
  margin: 0 0 14px 0;
  line-height: normal;
}

.newsletter-block.newsletter-form-has-small-container .newsletter-form-body {
  display: flex;
  flex-direction: column;
  padding: 0 0 6px 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-fields-wrapper {
  display: block;
  order: 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-name-fieldset {
  width: 100%;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-field-wrapper,
.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-button-wrapper {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 5px 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-button-wrapper {
  margin: 6px 0 0 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-button-wrapper {
  order: 2;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-body
  .captcha-container.rendered {
  order: 1;
  margin-bottom: 0;
  width: auto;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-footnote
  p {
  margin: 14px 0;
}

.newsletter-block.newsletter-form-has-small-container
  .newsletter-form-footnote
  p:last-child {
  margin-bottom: 0;
}

.newsletter-block.newsletter-form-has-small-container .disclaimer-container {
  font-size: 14px;
}

.newsletter-block.newsletter-form-has-small-container .form-submission-text p {
  margin: 14px 0;
  line-height: normal;
}

.newsletter-block.newsletter-form-has-small-container
  .form-submission-text
  p:first-child {
  margin-top: 0;
}

.newsletter-block.newsletter-form-has-small-container
  .form-submission-text
  p:last-child {
  margin-bottom: 0;
}

.source-code {
  white-space: pre;
  overflow: auto;
}

.cm-keyword {
  color: #708;
}

.cm-atom {
  color: #219;
}

.cm-number {
  color: #164;
}

.cm-def {
  color: blue;
}

.cm-variable-2 {
  color: #05a;
}

.cm-variable-3 {
  color: #085;
}

.cm-comment {
  color: #aaa;
}

.cm-string {
  color: #1a1;
}

.cm-string-2 {
  color: #5f0;
}

.cm-meta {
  color: #555;
}

.cm-error {
  color: red;
}

.cm-qualifier {
  color: #555;
}

.cm-builtin {
  color: #30a;
}

.cm-bracket {
  color: #cc7;
}

.cm-tag {
  color: #170;
}

.cm-attribute {
  color: #00c;
}

.cm-header {
  color: #000;
}

.cm-quote {
  color: #900;
}

.cm-hr {
  color: #999;
}

.cm-link {
  color: #00c;
}

.dark .cm-comment {
  color: #75715e;
}

.dark .cm-atom {
  color: #ae81ff;
}

.dark .cm-number {
  color: #ae81ff;
}

.dark .cm-property,
.dark .cm-attribute {
  color: #a6e22e;
}

.dark .cm-keyword {
  color: #f92672;
}

.dark .cm-string {
  color: #e6db74;
}

.dark .cm-variable-2 {
  color: #9effff;
}

.dark .cm-def {
  color: #fd971f;
}

.dark .cm-error {
  background: #f92672;
  color: #f8f8f0;
}

.dark .cm-bracket {
  color: #f8f8f2;
}

.dark .cm-tag {
  color: #f92672;
}

.dark .cm-link {
  color: #ae81ff;
}

.code-block .state-message:not(:last-child) {
  margin-bottom: 10px;
}

.foursquare-block ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  line-height: 1.4em;
}

.foursquare-block ul .foursquare-checkin {
  margin-bottom: 12px;
}

.foursquare-block ul .foursquare-checkin a {
  border: 0;
}

.foursquare-block ul .foursquare-checkin .foursquare-icon-wrapper {
  float: left;
}

.foursquare-block ul .foursquare-checkin .foursquare-text {
  margin-left: 42px;
  font-size: 12px;
}

.foursquare-block ul .foursquare-checkin .foursquare-venue {
  font-weight: bold;
}

.foursquare-block ul .foursquare-checkin .foursquare-location {
  display: inline-block;
  padding-left: 4px;
}

.foursquare-block ul .foursquare-checkin .foursquare-timestamp {
  font-size: 10px;
}

.sqs-block-soundcloud .sqs-intrinsic iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

@media screen and (max-width: 640px) {
  .sqs-block-soundcloud.isPlaylist .sqs-intrinsic {
    padding-bottom: 0 !important;
    height: 400px !important;
  }
}

.sqs-block-opentable-hidden {
  display: none !important;
}

.sqs-block-opentable-hide-title .OT_title {
  display: none;
}

.sqs-block-opentable iframe {
  visibility: hidden;
  position: absolute;
}

.sqs-block-opentable * {
  box-sizing: border-box;
}

.sqs-block-opentable #OT_form {
  padding: 0;
  margin: 0;
  width: 165px;
  width: auto;
}

.sqs-block-opentable .OT_wrapper {
  border: none;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.5);
  font-family: inherit;
  width: 100%;
  margin: 0;
  padding: 34px 17px 40px;
  background: rgba(0, 0, 0, 0.5);
  color: #272727;
  font-size: 15px;
  line-height: 1em;
  text-align: center;
  position: relative;
}

.sqs-block-opentable .OT_header {
  width: 85%;
  margin: 0 auto;
  position: relative;
}

.sqs-block-opentable .OT_title {
  position: relative;
  width: 100%;
  margin: 0 0 17px 0;
  padding: 0;
  font-size: 30px;
  color: #272727;
  color: rgba(0, 0, 0, 0.95);
  font-weight: normal;
  text-align: center;
  line-height: 1em;
}

.sqs-block-opentable .OT_subtitle {
  margin: 0;
  padding: 0;
  font-size: 10px;
  letter-spacing: 0.15em;
  color: #272727;
  color: rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
  font-weight: normal;
  white-space: nowrap;
  width: auto;
  line-height: 1em;
}

.sqs-block-opentable .OT_list {
  list-style: none;
  margin: 28px 0 0 0;
  padding: 0;
  width: auto;
  display: inline-block;
  line-height: 1em;
}

.sqs-block-opentable .OT_day,
.sqs-block-opentable .OT_time,
.sqs-block-opentable .OT_party {
  margin: 0 12px;
  padding: 6px 0 6px 35px;
  height: auto;
  /* background-image: url("/universal/images-v6/icons/opentable-icons.svg"); */
  background-repeat: no-repeat;
  background-position: 0 0;
  width: 33%;
  min-width: 150px;
  max-width: 180px;
  position: relative;
  border: none !important;
  list-style: none;
  display: inline-block;
  line-height: 1em;
}

.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_day,
.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_time,
.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_party {
  display: none;
}

.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_submit {
  margin: 0;
}

.sqs-block-opentable .OT_day {
  margin: 0 12px;
  padding: 6px 0 6px 35px;
  background-position: -18px -7px;
  border: none;
  list-style: none;
  background-size: 123px;
}

.sqs-block-opentable .OT_time {
  background-position: -18px -55px;
  border: none;
}

.sqs-block-opentable .OT_party {
  background-position: -18px -102px;
  border: none;
}

.sqs-block-opentable .OT_searchTimeField,
.sqs-block-opentable .OT_searchDateField,
.sqs-block-opentable .OT_searchPartyField {
  font-family: inherit;
  /* background: #fff url("/universal/images-v6/icons/opentable-icons.svg")
    no-repeat; */
  color: #272727;
  font-weight: normal;
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 100%;
  height: auto;
  font-size: 13px;
  font-style: normal;
  padding: 0.7em 1.1em;
  border-radius: 0px;
  cursor: pointer;
  line-height: normal;
  outline: none;
  background-position: right -14px top -75px;
  background-size: 43px;
  background-clip: padding-box;
}

.sqs-block-opentable #OT_timeList,
.sqs-block-opentable #OT_partyList {
  max-height: 195px;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  position: absolute;
  width: auto;
  top: 100%;
  left: 35px;
  right: 0;
  display: none;
  margin-top: -7px;
  text-align: left;
  background-clip: padding-box;
}

.sqs-block-opentable .OT_navList {
  list-style: none;
  padding: 0;
  margin: -6px 0 0 0;
  float: none;
  position: absolute;
  background-color: #fff;
  z-index: 200;
  width: auto;
  top: 100%;
  left: 35px;
  right: 0;
}

.sqs-block-opentable .OT_navListItem {
  padding: 0;
  margin: 0;
  position: relative;
  float: none;
  line-height: 1em;
  width: auto;
  list-style: none;
}

.sqs-block-opentable #OT_timeList .OT_navListItem,
.sqs-block-opentable #OT_partyList .OT_navListItem {
  width: auto;
}

.sqs-block-opentable #OT_timeList li a.OT_navLink,
.sqs-block-opentable #OT_partyList li a.OT_navLink {
  border: 0;
  width: auto;
}

.sqs-block-opentable a.OT_navLink:link,
.sqs-block-opentable a.OT_navLink:visited,
.sqs-block-opentable a.OT_navLink:hover,
.sqs-block-opentable a.OT_navLink:active {
  font-family: inherit;
  color: #272727;
  text-decoration: none;
  font-size: 13px;
  line-height: 1em;
  width: auto;
  display: block;
  padding: 0.7em 1.1em;
  border: none;
}

.sqs-block-opentable a.OT_navLink:hover,
.sqs-block-opentable a.OT_navLink.selected,
.sqs-block-opentable a.OT_navLink:active {
  background-color: rgba(0, 0, 0, 0.05);
  color: #272727;
  opacity: 1;
}

.sqs-block-opentable a.OT_navLink.selected,
.sqs-block-opentable a.OT_navLink:active {
  background-color: rgba(0, 0, 0, 0.12);
}

.sqs-block-opentable .OT_submit {
  margin: 24px 0 0 0;
  padding: 0;
  width: auto;
  height: auto;
  list-style: none;
  display: block;
}

.sqs-block-opentable .OTButton,
.sqs-block-opentable #OTButton {
  width: auto;
  text-align: center;
  margin: 0;
  padding: 0;
}

.sqs-block-opentable a.OT_Find_a_Table:link,
.sqs-block-opentable a.OT_Find_a_Table:visited,
.sqs-block-opentable a.OT_Find_a_Table:hover,
.sqs-block-opentable a.OT_Find_a_Table:active {
  background-image: none;
  background-repeat: repeat;
  background-position: 0 0;
  background-color: #272727;
  background-color: rgba(0, 0, 0, 0.95);
  font-family: inherit;
  font-size: 13px;
  font-weight: normal;
  text-decoration: none;
  color: #fff;
  text-align: center;
  height: auto;
  display: inline-block;
  padding: 1.1em 2.3em;
  line-height: normal;
  text-shadow: none;
  opacity: 0.8;
  position: relative;
  width: auto;
  border: none;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  transition: opacity 0.3s ease-out, background 0.3s ease-out;
}

.opentable-style-light .OT_wrapper {
  color: #fff;
}

.opentable-style-light .OT_title {
  color: #fff;
}

.opentable-style-light .OT_subtitle {
  color: #fff;
}

.opentable-style-light a.OT_Find_a_Table:link,
.opentable-style-light a.OT_Find_a_Table:visited,
.opentable-style-light a.OT_Find_a_Table:hover,
.opentable-style-light a.OT_Find_a_Table:active {
  background-color: #272727;
  background-color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.5);
}

.opentable-style-light a.OT_Find_a_Table:link:hover,
.opentable-style-light a.OT_Find_a_Table:visited:hover,
.opentable-style-light a.OT_Find_a_Table:hover:hover,
.opentable-style-light a.OT_Find_a_Table:active:hover {
  background-color: #272727;
  background-color: rgba(0, 0, 0, 0.8);
  background: rgba(0, 0, 0, 0.5);
}

.opentable-style-light .OT_day {
  background-position: -80px -7px;
}

.opentable-style-light .OT_time {
  background-position: -80px -55px;
}

.opentable-style-light .OT_party {
  background-position: -80px -102px;
}

.hide-opentable-icons .OT_day,
.hide-opentable-icons .OT_time,
.hide-opentable-icons .OT_party {
  margin: 0;
  padding: 6px;
  background: none;
}

.hide-opentable-icons #OT_timeList,
.hide-opentable-icons #OT_partyList,
.hide-opentable-icons .OT_navList {
  left: 6px;
  right: 6px;
}

.no-svg .OT_day,
.no-svg .OT_time,
.no-svg .OT_party,
.no-svg .OT_searchTimeField,
.no-svg .OT_searchDateField,
.no-svg .OT_searchPartyField {
  /* background-image: url("/universal/images-v6/icons/opentable-icons.png"); */
}

.small-button-block-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.medium-button-block-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.large-button-block-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.sqs-block-button.sqs-stretched .sqs-block-content,
.sqs-block-button.sqs-stretched .sqs-block-button-element {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 100%;
  display: flex;
}

.sqs-block-button.sqs-stretched .sqs-block-button-container {
  flex: 1 1;
}

.sqs-block-button.sqs-stretched .sqs-block-button-element {
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
}

.sqs-block-button .sqs-block-button-container--left {
  text-align: left;
}

.sqs-block-button .sqs-block-button-container--center {
  text-align: center;
}

.sqs-block-button .sqs-block-button-container--right {
  text-align: right;
}

.sqs-block-button .sqs-block-button-element {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  line-height: normal;
}

.sqs-block-button .sqs-block-button-element:hover {
  opacity: 1;
}

.sqs-block-button .sqs-block-button-element--small {
  padding: 13px 26px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small {
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.sqs-block-button .sqs-block-button-element--medium {
  padding: 21px 34px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium {
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.sqs-block-button .sqs-block-button-element--large {
  padding: 25px 46px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large {
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

.small-button-style-solid .sqs-block-button .sqs-block-button-element--small,
.medium-button-style-solid .sqs-block-button .sqs-block-button-element--medium,
.large-button-style-solid .sqs-block-button .sqs-block-button-element--large {
  transition: 0.1s opacity linear;
  -webkit-backface-visibility: hidden;
}

.small-button-style-solid
  .sqs-block-button
  .sqs-block-button-element--small:hover,
.medium-button-style-solid
  .sqs-block-button
  .sqs-block-button-element--medium:hover,
.large-button-style-solid
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  opacity: 0.8;
}

.small-button-style-outline .sqs-block-button .sqs-block-button-element--small,
.medium-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--medium,
.large-button-style-outline .sqs-block-button .sqs-block-button-element--large,
.small-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small,
.medium-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium,
.large-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large {
  border-width: 2px;
  border-style: solid;
  background-color: transparent;
  transition: 0.1s background-color linear, 0.1s color linear;
}

.small-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--small:hover,
.medium-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--medium:hover,
.large-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--large:hover,
.small-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small:hover,
.medium-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium:hover,
.large-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  color: #fff;
}

.small-button-style-outline .sqs-block-button .sqs-block-button-element--small {
  color: #272727;
}

.small-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--small:hover {
  background-color: #272727;
  color: #fff;
}

.small-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small {
  color: #272727;
}

.small-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small:hover {
  background-color: #272727;
  color: #fff;
}

.medium-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--medium {
  color: #272727;
}

.medium-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--medium:hover {
  background-color: #272727;
  color: #fff;
}

.medium-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium {
  color: #272727;
}

.medium-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium:hover {
  background-color: #272727;
  color: #fff;
}

.large-button-style-outline .sqs-block-button .sqs-block-button-element--large {
  color: #272727;
}

.large-button-style-outline
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  background-color: #272727;
  color: #fff;
}

.large-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large {
  color: #272727;
}

.large-button-style-outline
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  background-color: #272727;
  color: #fff;
}

.small-button-style-raised .sqs-block-button .sqs-block-button-element--small,
.medium-button-style-raised .sqs-block-button .sqs-block-button-element--medium,
.large-button-style-raised .sqs-block-button .sqs-block-button-element--large {
  position: relative;
  transition: 0.1s background-color linear;
}

.small-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--small:active,
.medium-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--medium:active,
.large-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--large:active {
  top: 1px;
}

.small-button-style-raised .sqs-block-button .sqs-block-button-element--small {
  box-shadow: 0 2px 0 0 #131313;
}

.small-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--small:hover {
  background-color: #2f2f2f;
}

.small-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--small:active {
  box-shadow: 0 1px 0 0 #131313;
}

.small-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small {
  box-shadow: 0 2px 0 0 #131313;
}

.small-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small:hover {
  background-color: #2f2f2f;
}

.small-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--small:active {
  box-shadow: 0 1px 0 0 #131313;
}

.medium-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--medium {
  box-shadow: 0 2px 0 0 #131313;
}

.medium-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--medium:hover {
  background-color: #2f2f2f;
}

.medium-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--medium:active {
  box-shadow: 0 1px 0 0 #131313;
}

.medium-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium {
  box-shadow: 0 2px 0 0 #131313;
}

.medium-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium:hover {
  background-color: #2f2f2f;
}

.medium-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--medium:active {
  box-shadow: 0 1px 0 0 #131313;
}

.large-button-style-raised .sqs-block-button .sqs-block-button-element--large {
  box-shadow: 0 3px 0 0 #131313;
}

.large-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  background-color: #2f2f2f;
}

.large-button-style-raised
  .sqs-block-button
  .sqs-block-button-element--large:active {
  top: 2px;
  box-shadow: 0 1px 0 0 #131313;
}

.large-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large {
  box-shadow: 0 3px 0 0 #131313;
}

.large-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large:hover {
  background-color: #2f2f2f;
}

.large-button-style-raised
  .sqs-alternate-block-style-container
  .sqs-block-button
  .sqs-block-button-element--large:active {
  top: 2px;
  box-shadow: 0 1px 0 0 #131313;
}

.small-button-shape-rounded .sqs-block-button .sqs-block-button-element--small,
.medium-button-shape-rounded
  .sqs-block-button
  .sqs-block-button-element--medium,
.large-button-shape-rounded .sqs-block-button .sqs-block-button-element--large {
  border-radius: 3px;
}

.small-button-shape-pill .sqs-block-button .sqs-block-button-element--small,
.medium-button-shape-pill .sqs-block-button .sqs-block-button-element--medium,
.large-button-shape-pill .sqs-block-button .sqs-block-button-element--large {
  border-radius: 300px;
}

@media screen and (max-width: 640px) {
  .sqs-block-button .sqs-block-button-element--large {
    padding: 21px 34px;
    font-size: 15px;
  }
}

.sqs-search-ui-button-wrapper {
  position: relative;
}

.sqs-search-ui-button-wrapper.color-dark .search-input {
  /* background-image: url(/universal/images-v6/icons/icon-searchqueries-20-dark.png); */
  border: 1px solid #aaa;
}

.sqs-search-ui-button-wrapper.color-dark::-webkit-input-placeholder {
  color: #666;
}

.sqs-search-ui-button-wrapper.color-dark:-moz-placeholder {
  color: #666;
}

.sqs-search-ui-button-wrapper.color-dark::-moz-placeholder {
  color: #666;
}

.sqs-search-ui-button-wrapper.color-dark:-ms-input-placeholder {
  color: #666;
}

.sqs-search-ui-button-wrapper.color-light .search-input {
  /* background-image: url(/universal/images-v6/icons/icon-searchqueries-20-light.png); */
  color: #f7f7f7;
  border: 1px solid #eee;
}

.sqs-search-ui-button-wrapper.color-light::-webkit-input-placeholder {
  color: #ddd;
}

.sqs-search-ui-button-wrapper.color-light:-moz-placeholder {
  color: #ddd;
}

.sqs-search-ui-button-wrapper.color-light::-moz-placeholder {
  color: #ddd;
}

.sqs-search-ui-button-wrapper.color-light:-ms-input-placeholder {
  color: #ddd;
}

.sqs-search-ui-button-wrapper .search-input {
  opacity: 0.7;
  transition: opacity 0.2s ease-out;
  transition: background-image 0.2s ease-out;
  padding: 12px 12px 12px 45px;
  background: no-repeat 15px 50%;
  width: 100%;
  min-height: 20px;
  display: block;
  box-sizing: border-box;
}

.sqs-search-ui-button-wrapper .search-input.loading {
  background-image: none;
}

.sqs-search-ui-button-wrapper .search-input.disabled {
  cursor: pointer;
}

.sqs-search-ui-button-wrapper .search-input.hover-effect:hover,
.sqs-search-ui-button-wrapper .search-input.hover-effect:focus {
  opacity: 1;
}

.sqs-search-ui-button-wrapper .search-input:hover::-webkit-input-placeholder {
  font-style: normal;
}

.sqs-search-ui-button-wrapper .search-input:hover:-moz-placeholder {
  font-style: normal;
}

.sqs-search-ui-button-wrapper .search-input:hover::-moz-placeholder {
  font-style: normal;
}

.sqs-search-ui-button-wrapper .search-input:hover:-ms-input-placeholder {
  font-style: normal;
}

.sqs-search-ui-button-wrapper .spinner-wrapper {
  position: absolute;
  top: 50%;
  transform: translatey(-50%);
  left: 18px;
}

.sqs-search-ui-button-wrapper .spinner-wrapper .sqs-spin {
  display: block;
  vertical-align: middle;
}

.sqs-search-preview-ui {
  position: absolute;
  top: 100%;
  z-index: 999999;
  background-color: #fff;
  width: 100%;
}

.sqs-search-preview-ui .sqs-search-ui-result {
  border-top: none;
  /* border: 1px solid #ddd; */
}

.sqs-search-preview-ui .sqs-search-ui-result .search-result-notice {
  background-color: #fff;
  font-weight: 200;
  font-size: 12px;
  padding: 6px 12px;
}

.sqs-search-preview-ui .sqs-search-ui-result .search-result-notice.hide {
  display: none;
}

.sqs-search-preview-ui .sqs-search-ui-result .sqs-search-ui-list {
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result {
  padding: 16px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s ease-out;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result:last-child {
  border-bottom: none;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result.selected,
.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result:hover {
  background-color: #f5f5f5;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result.selected {
  outline-color: #333;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item {
  border-top: none;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  em {
  color: #222;
  font-style: italic;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  .sqs-main-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  .sqs-main-image-container {
  width: 50px;
  float: right;
  margin-left: 5px;
  box-shadow: #ddd 1px -1px 5px;
  -o-box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;
  box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  .sqs-main-image-intrinsic {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  .sqs-title {
  font-size: 16px;
  line-height: 1.2em;
  margin-bottom: 0.5em;
  color: #333;
}

.sqs-search-preview-ui
  .sqs-search-ui-result
  .sqs-search-ui-list
  .search-result
  .sqs-search-ui-item
  .sqs-content {
  font-size: 12px;
  line-height: 1.4em;
}

.sqs-search-preview-ui.no-image .sqs-main-image-container {
  display: none;
}

.twitter-block .tweet-list {
  list-style-type: none;
  margin: 0 0 2.2em 0;
  padding: 0;
}

.twitter-block .tweet {
  margin: 0 0 2.2em 0;
}

.twitter-block .tweet a {
  border: 0;
}

.twitter-block .tweet .tweet-avatar-wrapper {
  float: left;
}

.twitter-block .tweet .tweet-avatar {
  border-radius: 2px;
}

.twitter-block .tweet .tweet-text-wrapper {
  margin-left: 60px;
}

.twitter-block .tweet.no-avatar .tweet-text-wrapper {
  margin-left: 0px;
}

.twitter-block .tweet .tweet-from {
  font-size: 1.1em;
  margin: 0 0 0.5em 0;
  line-height: 1em;
  font-weight: bold;
}

.twitter-block .tweet .tweet-timestamp a {
  font-size: 0.8em;
}

.sqs-block-quote figure {
  margin: 1em 0;
}

.sqs-block-quote blockquote {
  margin: 0;
}

.sqs-block-quote .source {
  text-align: right;
}

.sqs-block-quote .sqs-block-content .block-animation.animation-disabled,
.sqs-block-quote .sqs-block-content .block-animation.animation-loaded {
  transform: translatez(0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-fade-in,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-fade-in {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-fade-in.animation-loaded,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-fade-in.animation-loaded,
.sqs-block-quote .sqs-block-content .block-animation-fade-in.animation-loaded {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-slide-up,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-slide-up {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 20);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-slide-up.animation-loaded,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-slide-up.animation-loaded,
.sqs-block-quote .sqs-block-content .block-animation-slide-up.animation-loaded {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-reveal,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-reveal {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-reveal.animation-loaded,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-reveal.animation-loaded,
.sqs-block-quote .sqs-block-content .block-animation-reveal.animation-loaded {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-focus-in,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-focus-in {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0, 0, 0.92, 0, 0);
}

:not(.sqs-edit-mode)
  .sqs-block-quote
  .sqs-block-content
  .block-animation-focus-in.animation-loaded,
.sqs-edit-mode.sqs-edit-mode-active
  .sqs-block-quote
  .sqs-block-content
  .block-animation-focus-in.animation-loaded,
.sqs-block-quote .sqs-block-content .block-animation-focus-in.animation-loaded {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.sqs-block-quote .sqs-block-content .block-animation.animation-disabled {
  transition: none !important;
}

.rss-block .social-rss:before,
.rss-block .social-rss-square:before,
.rss-block .social-rss-round:before {
  font-family: "social-icon-font";
  speak: none;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  position: relative;
  top: 0;
  margin-right: 10px;
  font-size: 0.7em;
}

.rss-block .social-rss:before {
  content: "\\e630";
  position: relative;
  top: -0.05em;
  margin-right: 0.4em;
  font-size: 0.7em;
}

.rss-block .sqs-blockStatus + .social-rss {
  display: none;
}

.sqs-block-zola .sqs-block-content {
  transition: opacity 0.3s ease-in;
}

.sqs-block-zola .sqs-block-content.is-rendering {
  opacity: 0.1;
}

.sqs-block-zola .zola-block-wrapper {
  background: #fff;
}

.sqs-block-zola .zola-block-wrapper.zola-block-setting-inset {
  padding: 0 20px;
}

.sqs-block-acuity .sqs-block-content {
  transition: opacity 0.3s ease-in;
}

.sqs-block-acuity .sqs-block-content.is-rendering {
  opacity: 0.1;
}

.sqs-block-acuity .sqs-block-content iframe {
  min-height: 1000px;
}

.sqs-block-acuity .sqs-block-content iframe[style] {
  min-height: 0;
}

.tock-flex-container {
  display: flex;
  flex-direction: row;
}

.tock-align-left {
  justify-content: flex-start;
}

.tock-align-center {
  justify-content: center;
}

.tock-align-right {
  justify-content: flex-end;
}

.hide-tock-logo
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockLogo-container,
.hide-tock-logo
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockSearchBar-tockIcon {
  display: none;
}

.sqs-use--icon,
.sqs-use--mask {
  fill: transparent;
  transition: fill 170ms ease-in-out;
}

.sqs-svg-icon--wrapper {
  display: inline-block;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 170ms ease-in-out;
  z-index: 0;
}

.sqs-svg-icon--wrapper > div,
.sqs-svg-icon--wrapper svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.social-icons-shape-circle .sqs-svg-icon--wrapper {
  border-radius: 50%;
}

.social-icons-shape-rounded .sqs-svg-icon--wrapper {
  border-radius: 15%;
}

.social-icons-style-border .sqs-svg-icon--wrapper {
  border: 2px solid;
  box-sizing: border-box;
}

.social-icons-style-regular .sqs-svg-icon--wrapper {
  border-radius: 0;
}

.social-icons-style-regular .sqs-svg-icon--wrapper > div {
  transform: scale(2);
}

.social-icons-size-extra-small.social-icons-style-regular
  .sqs-svg-icon--wrapper {
  width: 16px;
  height: 16px;
}

.social-icons-size-small.social-icons-style-regular .sqs-svg-icon--wrapper {
  width: 20px;
  height: 20px;
}

.social-icons-size-medium.social-icons-style-regular .sqs-svg-icon--wrapper,
.social-icons-size-extra-small:not(.social-icons-style-regular)
  .sqs-svg-icon--wrapper {
  width: 24px;
  height: 24px;
}

.social-icons-size-large.social-icons-style-regular .sqs-svg-icon--wrapper,
.social-icons-size-small:not(.social-icons-style-regular)
  .sqs-svg-icon--wrapper {
  width: 28px;
  height: 28px;
}

.social-icons-size-extra-large.social-icons-style-regular
  .sqs-svg-icon--wrapper,
.social-icons-size-medium:not(.social-icons-style-regular)
  .sqs-svg-icon--wrapper {
  width: 32px;
  height: 32px;
}

.social-icons-size-large:not(.social-icons-style-regular)
  .sqs-svg-icon--wrapper {
  width: 36px;
  height: 36px;
}

.social-icons-size-extra-large:not(.social-icons-style-regular)
  .sqs-svg-icon--wrapper {
  width: 48px;
  height: 48px;
}

.social-icon-alignment-left .sqs-svg-icon--list {
  text-align: left;
}

.social-icon-alignment-right .sqs-svg-icon--list {
  text-align: right;
}

.social-icon-alignment-center .sqs-svg-icon--list {
  text-align: center;
}

.social-icons-size-extra-small.social-icon-alignment-left
  .sqs-svg-icon--wrapper {
  margin: 0 6px 0 0;
}

.social-icons-size-extra-small.social-icon-alignment-right
  .sqs-svg-icon--wrapper {
  margin: 0 0 0 6px;
}

.social-icons-size-extra-small.social-icon-alignment-center
  .sqs-svg-icon--wrapper {
  margin: 0 3px;
}

.social-icons-size-small.social-icon-alignment-left .sqs-svg-icon--wrapper {
  margin: 0 8px 0 0;
}

.social-icons-size-small.social-icon-alignment-right .sqs-svg-icon--wrapper {
  margin: 0 0 0 8px;
}

.social-icons-size-small.social-icon-alignment-center .sqs-svg-icon--wrapper {
  margin: 0 4px;
}

.social-icons-size-medium.social-icon-alignment-left .sqs-svg-icon--wrapper {
  margin: 0 8px 0 0;
}

.social-icons-size-medium.social-icon-alignment-right .sqs-svg-icon--wrapper {
  margin: 0 0 0 8px;
}

.social-icons-size-medium.social-icon-alignment-center .sqs-svg-icon--wrapper {
  margin: 0 4px;
}

.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-left
  .sqs-svg-icon--wrapper,
.social-icons-size-large.social-icon-alignment-left .sqs-svg-icon--wrapper {
  margin: 0 10px 0 0;
}

.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-right
  .sqs-svg-icon--wrapper,
.social-icons-size-large.social-icon-alignment-right .sqs-svg-icon--wrapper {
  margin: 0 0 0 10px;
}

.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-center
  .sqs-svg-icon--wrapper,
.social-icons-size-large.social-icon-alignment-center .sqs-svg-icon--wrapper {
  margin: 0 5px;
}

.social-icons-size-small.social-icons-style-regular.social-icon-alignment-left
  .sqs-svg-icon--wrapper,
.social-icons-size-extra-large.social-icon-alignment-left
  .sqs-svg-icon--wrapper {
  margin: 0 12px 0 0;
}

.social-icons-size-small.social-icons-style-regular.social-icon-alignment-right
  .sqs-svg-icon--wrapper,
.social-icons-size-extra-large.social-icon-alignment-right
  .sqs-svg-icon--wrapper {
  margin: 0 0 0 12px;
}

.social-icons-size-small.social-icons-style-regular.social-icon-alignment-center
  .sqs-svg-icon--wrapper,
.social-icons-size-extra-large.social-icon-alignment-center
  .sqs-svg-icon--wrapper {
  margin: 0 6px;
}

.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-left
  .sqs-svg-icon--wrapper {
  margin: 0 14px 0 0;
}

.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-right
  .sqs-svg-icon--wrapper {
  margin: 0 0 0 14px;
}

.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-center
  .sqs-svg-icon--wrapper {
  margin: 0 7px;
}

.social-icons-size-large.social-icons-style-regular.social-icon-alignment-left
  .sqs-svg-icon--wrapper {
  margin: 0 16px 0 0;
}

.social-icons-size-large.social-icons-style-regular.social-icon-alignment-right
  .sqs-svg-icon--wrapper {
  margin: 0 0 0 16px;
}

.social-icons-size-large.social-icons-style-regular.social-icon-alignment-center
  .sqs-svg-icon--wrapper {
  margin: 0 8px;
}

.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-left
  .sqs-svg-icon--wrapper {
  margin: 0 18px 0 0;
}

.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-right
  .sqs-svg-icon--wrapper {
  margin: 0 0 0 18px;
}

.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-center
  .sqs-svg-icon--wrapper {
  margin: 0 9px;
}

.social-icons-color-black.social-icons-style-regular .sqs-use--icon {
  fill: #222;
}

.social-icons-color-black.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .sqs-use--icon {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-black.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #222;
}

.social-icons-color-black.social-icons-style-border .sqs-svg-icon--wrapper {
  border-color: #222;
}

.social-icons-color-black.social-icons-style-border .sqs-use--icon {
  fill: #222;
}

.social-icons-color-black.social-icons-style-border
  .sqs-svg-icon--wrapper:hover {
  background-color: #222;
}

.social-icons-color-black.social-icons-style-border
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-black.social-icons-style-knockout .sqs-use--mask {
  fill: #222;
}

.social-icons-color-black.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-black.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--mask {
  fill: #222;
}

.social-icons-color-black.social-icons-style-solid .sqs-svg-icon--wrapper {
  background-color: #222;
}

.social-icons-color-black.social-icons-style-solid .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-black.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-black.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-use--icon {
  fill: rgba(255, 255, 255, 0.4);
}

.social-icons-color-black.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover {
  background-color: #222;
}

.social-icons-color-black.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-regular .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .sqs-use--icon {
  fill: rgba(255, 255, 255, 0.4);
}

.social-icons-color-white.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-border .sqs-svg-icon--wrapper {
  border-color: #fff;
}

.social-icons-color-white.social-icons-style-border .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-border
  .sqs-svg-icon--wrapper:hover {
  background-color: #fff;
}

.social-icons-color-white.social-icons-style-border
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #222;
}

.social-icons-color-white.social-icons-style-knockout .sqs-use--mask {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .sqs-use--mask {
  fill: rgba(255, 255, 255, 0.4);
}

.social-icons-color-white.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--mask {
  fill: #fff;
}

.social-icons-color-white.social-icons-style-solid .sqs-svg-icon--wrapper {
  background-color: #fff;
}

.social-icons-color-white.social-icons-style-solid .sqs-use--icon {
  fill: #222;
}

.social-icons-color-white.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper {
  background-color: rgba(255, 255, 255, 0.4);
}

.social-icons-color-white.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-use--icon {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-white.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover {
  background-color: #fff;
}

.social-icons-color-white.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #222;
}

.social-icons-color-standard.social-icons-style-border
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--wrapper
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-svg-icon--wrapper:hover
  .sqs-use--icon {
  fill: #fff;
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .sqs-use--icon {
  fill: rgba(255, 255, 255, 0.4);
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--wrapper
  .sqs-use--mask,
.social-icons-color-standard.social-icons-style-border
  .sqs-svg-icon--wrapper
  .sqs-use--mask,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--wrapper
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--wrapper
  .sqs-use--mask {
  fill: transparent;
}

.social-icons-color-standard.social-icons-style-regular .sqs-svg-icon--wrapper,
.social-icons-color-standard.social-icons-style-knockout .sqs-svg-icon--wrapper,
.social-icons-color-standard.social-icons-style-border
  .sqs-svg-icon--wrapper:not(:hover) {
  background-color: transparent;
}

.social-icons-color-standard .applepodcast .sqs-use--icon,
.social-icons-color-standard .applepodcast .sqs-use--mask {
  fill: #000;
}

.social-icons-color-standard .applepodcast {
  border-color: #000;
  background-color: #000;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .applepodcast:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .applepodcast:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 0, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .applepodcast:not(:hover) {
  background-color: rgba(0, 0, 0, 0.4);
}

.social-icons-color-standard .bandsintown .sqs-use--icon,
.social-icons-color-standard .bandsintown .sqs-use--mask {
  fill: #00b4b3;
}

.social-icons-color-standard .bandsintown {
  border-color: #00b4b3;
  background-color: #00b4b3;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .bandsintown:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .bandsintown:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 180, 179, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .bandsintown:not(:hover) {
  background-color: rgba(0, 180, 179, 0.4);
}

.social-icons-color-standard .behance .sqs-use--icon,
.social-icons-color-standard .behance .sqs-use--mask {
  fill: #1769ff;
}

.social-icons-color-standard .behance {
  border-color: #1769ff;
  background-color: #1769ff;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .behance:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .behance:not(:hover)
  .sqs-use--mask {
  fill: rgba(23, 105, 255, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .behance:not(:hover) {
  background-color: rgba(23, 105, 255, 0.4);
}

.social-icons-color-standard .chownow .sqs-use--icon,
.social-icons-color-standard .chownow .sqs-use--mask {
  fill: #dc5d54;
}

.social-icons-color-standard .chownow {
  border-color: #dc5d54;
  background-color: #dc5d54;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .chownow:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .chownow:not(:hover)
  .sqs-use--mask {
  fill: rgba(220, 93, 84, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .chownow:not(:hover) {
  background-color: rgba(220, 93, 84, 0.4);
}

.social-icons-color-standard .codepen .sqs-use--icon,
.social-icons-color-standard .codepen .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .codepen {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .codepen:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .codepen:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .codepen:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .dribbble .sqs-use--icon,
.social-icons-color-standard .dribbble .sqs-use--mask {
  fill: #ea4c89;
}

.social-icons-color-standard .dribbble {
  border-color: #ea4c89;
  background-color: #ea4c89;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .dribbble:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .dribbble:not(:hover)
  .sqs-use--mask {
  fill: rgba(234, 76, 137, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .dribbble:not(:hover) {
  background-color: rgba(234, 76, 137, 0.4);
}

.social-icons-color-standard .dropbox .sqs-use--icon,
.social-icons-color-standard .dropbox .sqs-use--mask {
  fill: #007ee5;
}

.social-icons-color-standard .dropbox {
  border-color: #007ee5;
  background-color: #007ee5;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .dropbox:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .dropbox:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 126, 229, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .dropbox:not(:hover) {
  background-color: rgba(0, 126, 229, 0.4);
}

.social-icons-color-standard .email .sqs-use--icon,
.social-icons-color-standard .email .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .email {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .email:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .email:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .email:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .facebook .sqs-use--icon,
.social-icons-color-standard .facebook .sqs-use--mask {
  fill: #3b5998;
}

.social-icons-color-standard .facebook {
  border-color: #3b5998;
  background-color: #3b5998;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .facebook:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .facebook:not(:hover)
  .sqs-use--mask {
  fill: rgba(59, 89, 152, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .facebook:not(:hover) {
  background-color: rgba(59, 89, 152, 0.4);
}

.social-icons-color-standard .facebook-unauth .sqs-use--icon,
.social-icons-color-standard .facebook-unauth .sqs-use--mask {
  fill: #3b5998;
}

.social-icons-color-standard .facebook-unauth {
  border-color: #3b5998;
  background-color: #3b5998;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .facebook-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .facebook-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(59, 89, 152, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .facebook-unauth:not(:hover) {
  background-color: rgba(59, 89, 152, 0.4);
}

.social-icons-color-standard .fivehundredpix .sqs-use--icon,
.social-icons-color-standard .fivehundredpix .sqs-use--mask {
  fill: #0099e5;
}

.social-icons-color-standard .fivehundredpix {
  border-color: #0099e5;
  background-color: #0099e5;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .fivehundredpix:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .fivehundredpix:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 153, 229, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .fivehundredpix:not(:hover) {
  background-color: rgba(0, 153, 229, 0.4);
}

.social-icons-color-standard .fivehundredpix-unauth .sqs-use--icon,
.social-icons-color-standard .fivehundredpix-unauth .sqs-use--mask {
  fill: #0099e5;
}

.social-icons-color-standard .fivehundredpix-unauth {
  border-color: #0099e5;
  background-color: #0099e5;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .fivehundredpix-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .fivehundredpix-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 153, 229, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .fivehundredpix-unauth:not(:hover) {
  background-color: rgba(0, 153, 229, 0.4);
}

.social-icons-color-standard .flickr .sqs-use--icon,
.social-icons-color-standard .flickr .sqs-use--mask {
  fill: #0063dc;
}

.social-icons-color-standard .flickr {
  border-color: #0063dc;
  background-color: #0063dc;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .flickr:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .flickr:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 99, 220, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .flickr:not(:hover) {
  background-color: rgba(0, 99, 220, 0.4);
}

.social-icons-color-standard .flickr-unauth .sqs-use--icon,
.social-icons-color-standard .flickr-unauth .sqs-use--mask {
  fill: #0063dc;
}

.social-icons-color-standard .flickr-unauth {
  border-color: #0063dc;
  background-color: #0063dc;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .flickr-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .flickr-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 99, 220, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .flickr-unauth:not(:hover) {
  background-color: rgba(0, 99, 220, 0.4);
}

.social-icons-color-standard .foursquare .sqs-use--icon,
.social-icons-color-standard .foursquare .sqs-use--mask {
  fill: #f94877;
}

.social-icons-color-standard .foursquare {
  border-color: #f94877;
  background-color: #f94877;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .foursquare:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .foursquare:not(:hover)
  .sqs-use--mask {
  fill: rgba(249, 72, 119, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .foursquare:not(:hover) {
  background-color: rgba(249, 72, 119, 0.4);
}

.social-icons-color-standard .foursquare-unauth .sqs-use--icon,
.social-icons-color-standard .foursquare-unauth .sqs-use--mask {
  fill: #f94877;
}

.social-icons-color-standard .foursquare-unauth {
  border-color: #f94877;
  background-color: #f94877;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .foursquare-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .foursquare-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(249, 72, 119, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .foursquare-unauth:not(:hover) {
  background-color: rgba(249, 72, 119, 0.4);
}

.social-icons-color-standard .github .sqs-use--icon,
.social-icons-color-standard .github .sqs-use--mask {
  fill: #4183c4;
}

.social-icons-color-standard .github {
  border-color: #4183c4;
  background-color: #4183c4;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .github:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .github:not(:hover)
  .sqs-use--mask {
  fill: rgba(65, 131, 196, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .github:not(:hover) {
  background-color: rgba(65, 131, 196, 0.4);
}

.social-icons-color-standard .github-unauth .sqs-use--icon,
.social-icons-color-standard .github-unauth .sqs-use--mask {
  fill: #4183c4;
}

.social-icons-color-standard .github-unauth {
  border-color: #4183c4;
  background-color: #4183c4;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .github-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .github-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(65, 131, 196, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .github-unauth:not(:hover) {
  background-color: rgba(65, 131, 196, 0.4);
}

.social-icons-color-standard .goodreads .sqs-use--icon,
.social-icons-color-standard .goodreads .sqs-use--mask {
  fill: #382110;
}

.social-icons-color-standard .goodreads {
  border-color: #382110;
  background-color: #382110;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .goodreads:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .goodreads:not(:hover)
  .sqs-use--mask {
  fill: rgba(56, 33, 16, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .goodreads:not(:hover) {
  background-color: rgba(56, 33, 16, 0.4);
}

.social-icons-color-standard .googleplay .sqs-use--icon,
.social-icons-color-standard .googleplay .sqs-use--mask {
  fill: #5adfcb;
}

.social-icons-color-standard .googleplay {
  border-color: #5adfcb;
  background-color: #5adfcb;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .googleplay:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .googleplay:not(:hover)
  .sqs-use--mask {
  fill: rgba(90, 223, 203, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .googleplay:not(:hover) {
  background-color: rgba(90, 223, 203, 0.4);
}

.social-icons-color-standard .google .sqs-use--icon,
.social-icons-color-standard .google .sqs-use--mask {
  fill: #dc4e41;
}

.social-icons-color-standard .google {
  border-color: #dc4e41;
  background-color: #dc4e41;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .google:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .google:not(:hover)
  .sqs-use--mask {
  fill: rgba(220, 78, 65, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .google:not(:hover) {
  background-color: rgba(220, 78, 65, 0.4);
}

.social-icons-color-standard .houzz .sqs-use--icon,
.social-icons-color-standard .houzz .sqs-use--mask {
  fill: #7ac143;
}

.social-icons-color-standard .houzz {
  border-color: #7ac143;
  background-color: #7ac143;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .houzz:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .houzz:not(:hover)
  .sqs-use--mask {
  fill: rgba(122, 193, 67, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .houzz:not(:hover) {
  background-color: rgba(122, 193, 67, 0.4);
}

.social-icons-color-standard .imdb .sqs-use--icon,
.social-icons-color-standard .imdb .sqs-use--mask {
  fill: #e6b91e;
}

.social-icons-color-standard .imdb {
  border-color: #e6b91e;
  background-color: #e6b91e;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .imdb:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .imdb:not(:hover)
  .sqs-use--mask {
  fill: rgba(230, 185, 30, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .imdb:not(:hover) {
  background-color: rgba(230, 185, 30, 0.4);
}

.social-icons-color-standard .instagram .sqs-use--icon,
.social-icons-color-standard .instagram .sqs-use--mask {
  fill: #e4405f;
}

.social-icons-color-standard .instagram {
  border-color: #e4405f;
  background-color: #e4405f;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .instagram:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .instagram:not(:hover)
  .sqs-use--mask {
  fill: rgba(228, 64, 95, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .instagram:not(:hover) {
  background-color: rgba(228, 64, 95, 0.4);
}

.social-icons-color-standard .instagram-unauth .sqs-use--icon,
.social-icons-color-standard .instagram-unauth .sqs-use--mask {
  fill: #e4405f;
}

.social-icons-color-standard .instagram-unauth {
  border-color: #e4405f;
  background-color: #e4405f;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .instagram-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .instagram-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(228, 64, 95, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .instagram-unauth:not(:hover) {
  background-color: rgba(228, 64, 95, 0.4);
}

.social-icons-color-standard .itunes .sqs-use--icon,
.social-icons-color-standard .itunes .sqs-use--mask {
  fill: #ec4652;
}

.social-icons-color-standard .itunes {
  border-color: #ec4652;
  background-color: #ec4652;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .itunes:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .itunes:not(:hover)
  .sqs-use--mask {
  fill: rgba(236, 70, 82, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .itunes:not(:hover) {
  background-color: rgba(236, 70, 82, 0.4);
}

.social-icons-color-standard .linkedin .sqs-use--icon,
.social-icons-color-standard .linkedin .sqs-use--mask {
  fill: #0976b4;
}

.social-icons-color-standard .linkedin {
  border-color: #0976b4;
  background-color: #0976b4;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .linkedin:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .linkedin:not(:hover)
  .sqs-use--mask {
  fill: rgba(9, 118, 180, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .linkedin:not(:hover) {
  background-color: rgba(9, 118, 180, 0.4);
}

.social-icons-color-standard .linkedin-unauth .sqs-use--icon,
.social-icons-color-standard .linkedin-unauth .sqs-use--mask {
  fill: #0976b4;
}

.social-icons-color-standard .linkedin-unauth {
  border-color: #0976b4;
  background-color: #0976b4;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .linkedin-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .linkedin-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(9, 118, 180, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .linkedin-unauth:not(:hover) {
  background-color: rgba(9, 118, 180, 0.4);
}

.social-icons-color-standard .medium .sqs-use--icon,
.social-icons-color-standard .medium .sqs-use--mask {
  fill: #00ab6c;
}

.social-icons-color-standard .medium {
  border-color: #00ab6c;
  background-color: #00ab6c;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .medium:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .medium:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 171, 108, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .medium:not(:hover) {
  background-color: rgba(0, 171, 108, 0.4);
}

.social-icons-color-standard .meetup .sqs-use--icon,
.social-icons-color-standard .meetup .sqs-use--mask {
  fill: #e0393e;
}

.social-icons-color-standard .meetup {
  border-color: #e0393e;
  background-color: #e0393e;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .meetup:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .meetup:not(:hover)
  .sqs-use--mask {
  fill: rgba(224, 57, 62, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .meetup:not(:hover) {
  background-color: rgba(224, 57, 62, 0.4);
}

.social-icons-color-standard .pinterest .sqs-use--icon,
.social-icons-color-standard .pinterest .sqs-use--mask {
  fill: #cc2127;
}

.social-icons-color-standard .pinterest {
  border-color: #cc2127;
  background-color: #cc2127;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .pinterest:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .pinterest:not(:hover)
  .sqs-use--mask {
  fill: rgba(204, 33, 39, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .pinterest:not(:hover) {
  background-color: rgba(204, 33, 39, 0.4);
}

.social-icons-color-standard .pinterest-unauth .sqs-use--icon,
.social-icons-color-standard .pinterest-unauth .sqs-use--mask {
  fill: #cc2127;
}

.social-icons-color-standard .pinterest-unauth {
  border-color: #cc2127;
  background-color: #cc2127;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .pinterest-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .pinterest-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(204, 33, 39, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .pinterest-unauth:not(:hover) {
  background-color: rgba(204, 33, 39, 0.4);
}

.social-icons-color-standard .rdio .sqs-use--icon,
.social-icons-color-standard .rdio .sqs-use--mask {
  fill: #006ed2;
}

.social-icons-color-standard .rdio {
  border-color: #006ed2;
  background-color: #006ed2;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .rdio:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .rdio:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 110, 210, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .rdio:not(:hover) {
  background-color: rgba(0, 110, 210, 0.4);
}

.social-icons-color-standard .reddit .sqs-use--icon,
.social-icons-color-standard .reddit .sqs-use--mask {
  fill: #ff4500;
}

.social-icons-color-standard .reddit {
  border-color: #ff4500;
  background-color: #ff4500;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .reddit:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .reddit:not(:hover)
  .sqs-use--mask {
  fill: rgba(255, 69, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .reddit:not(:hover) {
  background-color: rgba(255, 69, 0, 0.4);
}

.social-icons-color-standard .rss .sqs-use--icon,
.social-icons-color-standard .rss .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .rss {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .rss:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .rss:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .rss:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .smugmug .sqs-use--icon,
.social-icons-color-standard .smugmug .sqs-use--mask {
  fill: #7dbb00;
}

.social-icons-color-standard .smugmug {
  border-color: #7dbb00;
  background-color: #7dbb00;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .smugmug:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .smugmug:not(:hover)
  .sqs-use--mask {
  fill: rgba(125, 187, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .smugmug:not(:hover) {
  background-color: rgba(125, 187, 0, 0.4);
}

.social-icons-color-standard .smugmug-unauth .sqs-use--icon,
.social-icons-color-standard .smugmug-unauth .sqs-use--mask {
  fill: #7dbb00;
}

.social-icons-color-standard .smugmug-unauth {
  border-color: #7dbb00;
  background-color: #7dbb00;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .smugmug-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .smugmug-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(125, 187, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .smugmug-unauth:not(:hover) {
  background-color: rgba(125, 187, 0, 0.4);
}

.social-icons-color-standard .snapchat .sqs-use--icon,
.social-icons-color-standard .snapchat .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .snapchat {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .snapchat:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .snapchat:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .snapchat:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .soundcloud .sqs-use--icon,
.social-icons-color-standard .soundcloud .sqs-use--mask {
  fill: #f60;
}

.social-icons-color-standard .soundcloud {
  border-color: #f60;
  background-color: #f60;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .soundcloud:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .soundcloud:not(:hover)
  .sqs-use--mask {
  fill: rgba(255, 102, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .soundcloud:not(:hover) {
  background-color: rgba(255, 102, 0, 0.4);
}

.social-icons-color-standard .soundcloud-unauth .sqs-use--icon,
.social-icons-color-standard .soundcloud-unauth .sqs-use--mask {
  fill: #f60;
}

.social-icons-color-standard .soundcloud-unauth {
  border-color: #f60;
  background-color: #f60;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .soundcloud-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .soundcloud-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(255, 102, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .soundcloud-unauth:not(:hover) {
  background-color: rgba(255, 102, 0, 0.4);
}

.social-icons-color-standard .spotify .sqs-use--icon,
.social-icons-color-standard .spotify .sqs-use--mask {
  fill: #84bd00;
}

.social-icons-color-standard .spotify {
  border-color: #84bd00;
  background-color: #84bd00;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .spotify:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .spotify:not(:hover)
  .sqs-use--mask {
  fill: rgba(132, 189, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .spotify:not(:hover) {
  background-color: rgba(132, 189, 0, 0.4);
}

.social-icons-color-standard .spotify-unauth .sqs-use--icon,
.social-icons-color-standard .spotify-unauth .sqs-use--mask {
  fill: #84bd00;
}

.social-icons-color-standard .spotify-unauth {
  border-color: #84bd00;
  background-color: #84bd00;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .spotify-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .spotify-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(132, 189, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .spotify-unauth:not(:hover) {
  background-color: rgba(132, 189, 0, 0.4);
}

.social-icons-color-standard .squarespace .sqs-use--icon,
.social-icons-color-standard .squarespace .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .squarespace {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .squarespace:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .squarespace:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .squarespace:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .stitcher .sqs-use--icon,
.social-icons-color-standard .stitcher .sqs-use--mask {
  fill: #1ea9e1;
}

.social-icons-color-standard .stitcher {
  border-color: #1ea9e1;
  background-color: #1ea9e1;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .stitcher:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .stitcher:not(:hover)
  .sqs-use--mask {
  fill: rgba(30, 169, 225, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .stitcher:not(:hover) {
  background-color: rgba(30, 169, 225, 0.4);
}

.social-icons-color-standard .stumbleupon .sqs-use--icon,
.social-icons-color-standard .stumbleupon .sqs-use--mask {
  fill: #eb4924;
}

.social-icons-color-standard .stumbleupon {
  border-color: #eb4924;
  background-color: #eb4924;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .stumbleupon:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .stumbleupon:not(:hover)
  .sqs-use--mask {
  fill: rgba(235, 73, 36, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .stumbleupon:not(:hover) {
  background-color: rgba(235, 73, 36, 0.4);
}

.social-icons-color-standard .thedots .sqs-use--icon,
.social-icons-color-standard .thedots .sqs-use--mask {
  fill: #8c8070;
}

.social-icons-color-standard .thedots {
  border-color: #8c8070;
  background-color: #8c8070;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .thedots:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .thedots:not(:hover)
  .sqs-use--mask {
  fill: rgba(140, 128, 112, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .thedots:not(:hover) {
  background-color: rgba(140, 128, 112, 0.4);
}

.social-icons-color-standard .tidal .sqs-use--icon,
.social-icons-color-standard .tidal .sqs-use--mask {
  fill: #222;
}

.social-icons-color-standard .tidal {
  border-color: #222;
  background-color: #222;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .tidal:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .tidal:not(:hover)
  .sqs-use--mask {
  fill: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .tidal:not(:hover) {
  background-color: rgba(34, 34, 34, 0.4);
}

.social-icons-color-standard .tripadvisor .sqs-use--icon,
.social-icons-color-standard .tripadvisor .sqs-use--mask {
  fill: #00b087;
}

.social-icons-color-standard .tripadvisor {
  border-color: #00b087;
  background-color: #00b087;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .tripadvisor:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .tripadvisor:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 176, 135, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .tripadvisor:not(:hover) {
  background-color: rgba(0, 176, 135, 0.4);
}

.social-icons-color-standard .tumblr .sqs-use--icon,
.social-icons-color-standard .tumblr .sqs-use--mask {
  fill: #35465d;
}

.social-icons-color-standard .tumblr {
  border-color: #35465d;
  background-color: #35465d;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .tumblr:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .tumblr:not(:hover)
  .sqs-use--mask {
  fill: rgba(53, 70, 93, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .tumblr:not(:hover) {
  background-color: rgba(53, 70, 93, 0.4);
}

.social-icons-color-standard .tumblr-unauth .sqs-use--icon,
.social-icons-color-standard .tumblr-unauth .sqs-use--mask {
  fill: #35465d;
}

.social-icons-color-standard .tumblr-unauth {
  border-color: #35465d;
  background-color: #35465d;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .tumblr-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .tumblr-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(53, 70, 93, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .tumblr-unauth:not(:hover) {
  background-color: rgba(53, 70, 93, 0.4);
}

.social-icons-color-standard .twitch .sqs-use--icon,
.social-icons-color-standard .twitch .sqs-use--mask {
  fill: #6441a5;
}

.social-icons-color-standard .twitch {
  border-color: #6441a5;
  background-color: #6441a5;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .twitch:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .twitch:not(:hover)
  .sqs-use--mask {
  fill: rgba(100, 65, 165, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .twitch:not(:hover) {
  background-color: rgba(100, 65, 165, 0.4);
}

.social-icons-color-standard .twitter .sqs-use--icon,
.social-icons-color-standard .twitter .sqs-use--mask {
  fill: #55acee;
}

.social-icons-color-standard .twitter {
  border-color: #55acee;
  background-color: #55acee;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .twitter:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .twitter:not(:hover)
  .sqs-use--mask {
  fill: rgba(85, 172, 238, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .twitter:not(:hover) {
  background-color: rgba(85, 172, 238, 0.4);
}

.social-icons-color-standard .twitter-unauth .sqs-use--icon,
.social-icons-color-standard .twitter-unauth .sqs-use--mask {
  fill: #55acee;
}

.social-icons-color-standard .twitter-unauth {
  border-color: #55acee;
  background-color: #55acee;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .twitter-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .twitter-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(85, 172, 238, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .twitter-unauth:not(:hover) {
  background-color: rgba(85, 172, 238, 0.4);
}

.social-icons-color-standard .url .sqs-use--icon,
.social-icons-color-standard .url .sqs-use--mask {
  fill: #000;
}

.social-icons-color-standard .url {
  border-color: #000;
  background-color: #000;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .url:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .url:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 0, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .url:not(:hover) {
  background-color: rgba(0, 0, 0, 0.4);
}

.social-icons-color-standard .vevo .sqs-use--icon,
.social-icons-color-standard .vevo .sqs-use--mask {
  fill: #ff0031;
}

.social-icons-color-standard .vevo {
  border-color: #ff0031;
  background-color: #ff0031;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .vevo:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .vevo:not(:hover)
  .sqs-use--mask {
  fill: rgba(255, 0, 49, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .vevo:not(:hover) {
  background-color: rgba(255, 0, 49, 0.4);
}

.social-icons-color-standard .vimeo .sqs-use--icon,
.social-icons-color-standard .vimeo .sqs-use--mask {
  fill: #1ab7ea;
}

.social-icons-color-standard .vimeo {
  border-color: #1ab7ea;
  background-color: #1ab7ea;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .vimeo:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .vimeo:not(:hover)
  .sqs-use--mask {
  fill: rgba(26, 183, 234, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .vimeo:not(:hover) {
  background-color: rgba(26, 183, 234, 0.4);
}

.social-icons-color-standard .vimeo-unauth .sqs-use--icon,
.social-icons-color-standard .vimeo-unauth .sqs-use--mask {
  fill: #1ab7ea;
}

.social-icons-color-standard .vimeo-unauth {
  border-color: #1ab7ea;
  background-color: #1ab7ea;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .vimeo-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .vimeo-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(26, 183, 234, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .vimeo-unauth:not(:hover) {
  background-color: rgba(26, 183, 234, 0.4);
}

.social-icons-color-standard .vine .sqs-use--icon,
.social-icons-color-standard .vine .sqs-use--mask {
  fill: #00b488;
}

.social-icons-color-standard .vine {
  border-color: #00b488;
  background-color: #00b488;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .vine:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .vine:not(:hover)
  .sqs-use--mask {
  fill: rgba(0, 180, 136, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .vine:not(:hover) {
  background-color: rgba(0, 180, 136, 0.4);
}

.social-icons-color-standard .vsco .sqs-use--icon,
.social-icons-color-standard .vsco .sqs-use--mask {
  fill: #ae995a;
}

.social-icons-color-standard .vsco {
  border-color: #ae995a;
  background-color: #ae995a;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .vsco:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .vsco:not(:hover)
  .sqs-use--mask {
  fill: rgba(174, 153, 90, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .vsco:not(:hover) {
  background-color: rgba(174, 153, 90, 0.4);
}

.social-icons-color-standard .yelp .sqs-use--icon,
.social-icons-color-standard .yelp .sqs-use--mask {
  fill: #c41200;
}

.social-icons-color-standard .yelp {
  border-color: #c41200;
  background-color: #c41200;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .yelp:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .yelp:not(:hover)
  .sqs-use--mask {
  fill: rgba(196, 18, 0, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .yelp:not(:hover) {
  background-color: rgba(196, 18, 0, 0.4);
}

.social-icons-color-standard .youtube .sqs-use--icon,
.social-icons-color-standard .youtube .sqs-use--mask {
  fill: #e52d27;
}

.social-icons-color-standard .youtube {
  border-color: #e52d27;
  background-color: #e52d27;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .youtube:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .youtube:not(:hover)
  .sqs-use--mask {
  fill: rgba(229, 45, 39, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .youtube:not(:hover) {
  background-color: rgba(229, 45, 39, 0.4);
}

.social-icons-color-standard .youtube-unauth .sqs-use--icon,
.social-icons-color-standard .youtube-unauth .sqs-use--mask {
  fill: #e52d27;
}

.social-icons-color-standard .youtube-unauth {
  border-color: #e52d27;
  background-color: #e52d27;
}

.social-icons-color-standard.social-icons-style-regular
  .sqs-svg-icon--list:hover
  .youtube-unauth:not(:hover)
  .sqs-use--icon,
.social-icons-color-standard.social-icons-style-knockout
  .sqs-svg-icon--list:hover
  .youtube-unauth:not(:hover)
  .sqs-use--mask {
  fill: rgba(229, 45, 39, 0.4);
}

.social-icons-color-standard.social-icons-style-solid
  .sqs-svg-icon--list:hover
  .youtube-unauth:not(:hover) {
  background-color: rgba(229, 45, 39, 0.4);
}

.sqs-block-markdown {
  clear: none;
}

.sqs-block-markdown .sqs-block-content {
  position: relative;
}

.sqs-block-markdown .sqs-block-content *:first-child {
  margin-top: 0;
}

.sqs-block-markdown .sqs-block-content *:last-child {
  margin-bottom: 0;
}

.sqs-block-markdown .sqs-placeholder {
  color: #999;
}

.sqs-block-markdown .sqs-editing-overlay {
  display: none;
}

.sqs-block-markdown hr {
  border: none;
  border-bottom: 1px solid #ccc;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.sqs-block-markdown textarea {
  position: absolute;
  top: 17px;
  bottom: 0;
  left: 25px;
  right: 25px;
  width: calc(100% - 50px);
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  outline: none;
  resize: none;
  overflow: hidden;
  color: #333;
}

.sqs-block-markdown .textarea-clone {
  margin: 0;
  min-height: 18px;
  visibility: hidden;
}

.sqs-block-markdown textarea,
.sqs-block-markdown .textarea-clone {
  font: 15px/18px "Courier New", monospace !important;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.sqs-block-markdown img {
  max-width: 100%;
  height: auto;
}

.donation-block .sqs-donate-button-wrapper {
  display: block;
}

.donation-block .sqs-donate-button-wrapper--align-left {
  text-align: left;
}

.donation-block .sqs-donate-button-wrapper--align-center {
  text-align: center;
}

.donation-block .sqs-donate-button-wrapper--align-right {
  text-align: right;
}

.donation-block .sqs-donate-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

.sqs-block-html {
  clear: none;
}

.sqs-block-html .sqs-block-content,
.sqs-block-html .sqs-html-content {
  outline: none;
}

.sqs-block-html .sqs-block-content *:not(h1):not(h2):not(h3),
.sqs-block-html .sqs-html-content *:not(h1):not(h2):not(h3) {
  word-wrap: break-word;
}

.sqs-block-html .sqs-block-content > *:first-child,
.sqs-block-html .sqs-html-content > *:first-child {
  margin-top: 0;
}

.sqs-block-html .sqs-block-content > *:last-child,
.sqs-block-html .sqs-html-content > *:last-child {
  margin-bottom: 0;
}

.sqs-block-html
  .sqs-block-content.sqs-background-enabled
  .sqs-block-content
  > *:nth-last-child(2),
.sqs-block-html
  .sqs-html-content.sqs-background-enabled
  .sqs-block-content
  > *:nth-last-child(2) {
  margin-bottom: 0;
}

.sqs-block-html .sqs-block-content .sqsrte-scaled-text-container,
.sqs-block-html .sqs-html-content .sqsrte-scaled-text-container {
  height: auto;
}

.sqs-block-html .sqs-block-content .sqsrte-scaled-text-container:not(.loaded) *,
.sqs-block-html .sqs-html-content .sqsrte-scaled-text-container:not(.loaded) * {
  white-space: normal !important;
  transform: none !important;
  max-width: none !important;
  height: auto !important;
}

.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h1,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h1,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h2,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h2,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h3,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h3,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h4,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  h4,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  p,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  p,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  a,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  a,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  pre,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  pre,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  code,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container.loaded
  .sqsrte-scaled-text
  code {
  position: relative;
  left: initial;
  white-space: nowrap !important;
  margin: 0;
}

.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text {
  transform-origin: 0 0;
  position: relative;
  display: inline-block;
  word-break: break-all;
  margin: 0;
  padding: 0;
  position: absolute;
  left: -10000px;
}

.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  a,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  a {
  display: inline-block;
}

.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h1,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h1,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h2,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h2,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h3,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h3,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h4,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  h4,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  p,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  p,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  a,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  a,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  pre,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  pre,
.sqs-block-html
  .sqs-block-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  code,
.sqs-block-html
  .sqs-html-content
  .sqsrte-scaled-text-container
  > .sqsrte-scaled-text
  code {
  margin: 0;
  padding: 0;
  line-height: 1;
  font-size: inherit !important;
}

.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:link,
.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:link,
.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:visited,
.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:visited,
.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:hover,
.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:hover,
.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:active,
.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:active {
  text-decoration: none;
  background-image: none;
}

.sqs-block-html .TextShape {
  text-decoration: none !important;
}

.sqs-block-html .TextShape-node {
  --stroke: currentcolor;
  --stroke-width: 1px;
  --stroke-linecap: square;
  --stroke-linejoin: square;
  --opacity: 1;
  --blend: none;
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
  user-select: none;
  -webkit-user-select: none;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.25s ease-out, visibility 0.25s ease-out;
  mix-blend-mode: var(--blend);
}

.sqs-block-html .TextShape-node[data-is-front="true"] {
  z-index: 1;
}

.sqs-block-html .TextShape-node svg {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  stroke: var(--stroke);
  stroke-width: var(--stroke-width);
  stroke-width: max(1px, var(--stroke-width));
  stroke-linecap: var(--stroke-linecap);
  stroke-linejoin: var(--stroke-linejoin);
  fill: none;
  opacity: var(--opacity);
}

.embed-block .intrinsic,
.video-block .intrinsic,
.embed-block .sqs-block-content .intrinsic,
.video-block .sqs-block-content .intrinsic {
  position: relative;
}

.embed-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),
.video-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),
.embed-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),
.video-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud) {
  position: relative;
}

.embed-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .sqs-video-wrapper,
.video-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .sqs-video-wrapper,
.embed-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .sqs-video-wrapper,
.video-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .sqs-video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.embed-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  iframe,
.video-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  iframe,
.embed-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  iframe,
.video-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.embed-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .flickr-oembed,
.video-block
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .flickr-oembed,
.embed-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .flickr-oembed,
.video-block
  .sqs-block-content
  .intrinsic
  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)
  .flickr-oembed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.embed-block .intrinsic .embed-block-provider-SoundCloud,
.video-block .intrinsic .embed-block-provider-SoundCloud,
.embed-block .sqs-block-content .intrinsic .embed-block-provider-SoundCloud,
.video-block .sqs-block-content .intrinsic .embed-block-provider-SoundCloud {
  padding-bottom: 0 !important;
}

.embed-block .intrinsic .embed-block-provider-SoundCloud iframe,
.video-block .intrinsic .embed-block-provider-SoundCloud iframe,
.embed-block
  .sqs-block-content
  .intrinsic
  .embed-block-provider-SoundCloud
  iframe,
.video-block
  .sqs-block-content
  .intrinsic
  .embed-block-provider-SoundCloud
  iframe {
  width: 100%;
}

.sqs-stretched.sqs-block-audio .sqs-block-content,
.sqs-stretched.sqs-block-audio .sqs-block-audio-content,
.sqs-stretched.sqs-block-audio .sqs-audio-embed,
.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player,
.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player-content,
.sqs-stretched.sqs-block-audio .player {
  height: 100%;
}

.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player .player .play {
  display: flex;
  align-items: center;
}

.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player.playing .player .play {
  display: none;
}

.sqs-stretched.sqs-block-audio
  .sqs-widgets-audio-player.playing
  .player
  .pause {
  display: block;
}

.fluid-engine .sqs-block-map.vsize-12 .sqs-block-content {
  height: 100%;
}

.sqs-block-map .sqs-block-map-content {
  position: relative;
}

.sqs-block-map .sqs-block-map-content .sqs-map-wrapper {
  position: absolute !important;
  top: 0;
  left: 0;
  height: 100%;
  max-width: none;
  width: 100%;
}

.sqs-gallery-block-stacked {
  padding: 0;
  margin: 0;
}

.sqs-gallery-block-stacked a {
  border: 0;
}

.sqs-gallery-block-stacked .image-wrapper {
  margin: 0 0 1px 0;
  line-height: 1px;
}

.sqs-gallery-block-stacked .image-wrapper img {
  width: 100%;
}

.sqs-gallery-block-stacked .meta {
  display: none;
}

.sqs-gallery-block-stacked.sqs-gallery-block-show-meta .meta {
  display: block;
}

.sqs-gallery-block-stacked .meta-inside {
  margin-bottom: 28px;
  margin-top: 14px;
}

.sqs-gallery-block-stacked .meta-title {
  margin-bottom: 0.3em;
}

.sqs-gallery-block-stacked .meta-description {
  font-size: 0.9em;
  line-height: 1.5em;
}

.sqs-gallery-block-stacked .meta-description p {
  margin-bottom: 0;
  margin-top: 0;
}

.sqs-gallery-block-slideshow {
  position: relative;
  background-color: rgba(175, 175, 175, 0.1);
}

.sqs-gallery-block-slideshow.sqs-gallery-transparent-background {
  background-color: transparent;
}

.sqs-gallery-block-slideshow .slide > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.sqs-gallery-block-slideshow .slide .meta {
  opacity: 0;
}

.sqs-gallery-block-slideshow .meta {
  position: absolute;
  opacity: 0;
  background-color: #111;
  background-color: rgba(0, 0, 0, 0.3);
}

.sqs-gallery-block-slideshow .meta .meta-title {
  color: #fff;
}

.sqs-gallery-block-slideshow .meta .meta-title {
  font-size: 18px;
  line-height: 1.2em;
  letter-spacing: 1px;
}

.sqs-gallery-block-slideshow .meta .meta-title + .meta-description {
  margin-top: 0.3em;
}

.sqs-gallery-block-slideshow .meta .meta-description,
.sqs-gallery-block-slideshow .meta .meta-description p {
  color: #ddd;
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  line-height: 1.5em;
}

.sqs-gallery-block-slideshow .meta .meta-description strong {
  color: inherit;
}

.sqs-gallery-block-slideshow .meta .meta-description *:first-child {
  margin-top: 0;
}

.sqs-gallery-block-slideshow .meta .meta-description *:last-child {
  margin-bottom: 0;
}

.sqs-gallery-block-slideshow .meta-inside {
  padding: 25px;
}

.sqs-gallery-block-slideshow .meta a,
.sqs-gallery-block-slideshow .meta a:hover {
  color: #fff;
  text-decoration: underline;
}

.sqs-gallery-block-slideshow .meta.overflow {
  overflow-y: auto;
}

.sqs-gallery-block-slideshow .slide.loaded .meta {
  opacity: 1;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover .meta {
  opacity: 0 !important;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover .slide:hover .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover
  .slide
  :focus
  ~ .meta {
  opacity: 1 !important;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
}

.sqs-gallery-block-slideshow .meta {
  display: none;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .sqs-active-slide
  .meta {
  display: block;
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  > a {
  line-height: 0;
  height: auto;
  position: static;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .sqs-video-wrapper {
  position: static;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta {
  background-color: transparent;
  color: inherit;
  padding: 20px 0 10px 0;
  margin: 0;
  max-width: none !important;
  opacity: 1 !important;
  position: static !important;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-inside {
  padding: 0;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-title,
.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-description,
.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-description
  p {
  color: inherit;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-title {
  font-size: 0.9em;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-description {
  font-size: 0.9em;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta
  .mobile-view
  .slide.loaded
  .meta
  .meta-description
  p {
  font-size: 1em;
  line-height: 1.3em;
}

.sqs-gallery-block-slideshow .slide.video-playing .meta {
  display: none;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-left .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-right .meta {
  top: 0px;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-left .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-right .meta {
  max-width: 50%;
  margin: 20px;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-center .meta {
  max-width: 50%;
  top: 50%;
  left: 50%;
  text-align: center;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-left .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-right
  .meta {
  bottom: 0px;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom .meta {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(30, 30, 30, 0.3) 100%
  );
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom
  .meta-inside {
  padding: 30px 20px 15px;
}

.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-left .meta,
.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-right
  .meta {
  max-width: 50%;
  margin: 20px;
}

.sqs-gallery-block-slider {
  position: relative;
  height: 100%;
}

.sqs-gallery-block-grid {
  overflow: hidden;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-1
  .sqs-gallery-design-grid-slide {
  width: 100% !important;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-1
  .sqs-gallery-design-grid-slide:nth-child(1n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-2
  .sqs-gallery-design-grid-slide {
  width: 50%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-2
  .sqs-gallery-design-grid-slide:nth-child(2n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-3
  .sqs-gallery-design-grid-slide {
  width: 33.33333333%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-3
  .sqs-gallery-design-grid-slide:nth-child(3n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-4
  .sqs-gallery-design-grid-slide {
  width: 25%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-4
  .sqs-gallery-design-grid-slide:nth-child(4n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-5
  .sqs-gallery-design-grid-slide {
  width: 20%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-5
  .sqs-gallery-design-grid-slide:nth-child(5n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-6
  .sqs-gallery-design-grid-slide {
  width: 16.66666667%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-6
  .sqs-gallery-design-grid-slide:nth-child(6n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-7
  .sqs-gallery-design-grid-slide {
  width: 14.28571429%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-7
  .sqs-gallery-design-grid-slide:nth-child(7n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-8
  .sqs-gallery-design-grid-slide {
  width: 12.5%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-8
  .sqs-gallery-design-grid-slide:nth-child(8n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-9
  .sqs-gallery-design-grid-slide {
  width: 11.11111111%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-9
  .sqs-gallery-design-grid-slide:nth-child(9n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-10
  .sqs-gallery-design-grid-slide {
  width: 10%;
}

.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-10
  .sqs-gallery-design-grid-slide:nth-child(10n + 1) {
  clear: left;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 100%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 66.666%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 150%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 75%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 133.333%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 56.25%;
}

.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen
  .slide
  .margin-wrapper
  a.image-slide-anchor,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen
  .slide
  .margin-wrapper
  .content-wrapper,
.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  padding-bottom: 41.666%;
}

.sqs-gallery-block-grid .slide {
  float: left;
  width: 25%;
}

.sqs-gallery-block-grid .slide .margin-wrapper {
  position: relative;
}

.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor {
  padding-bottom: 100%;
  width: 100%;
  height: 0;
  display: block;
  cursor: default;
  border-bottom: none;
}

.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor img {
  display: inline-block;
}

.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor[href] img {
  cursor: pointer;
}

.sqs-gallery-block-grid .slide .margin-wrapper .content-wrapper {
  padding-bottom: 100%;
  width: 100%;
  display: block;
}

.sqs-gallery-block-grid
  .slide
  .margin-wrapper
  .content-wrapper.content-fill
  .sqs-video-wrapper {
  height: 0;
  padding-bottom: 100%;
}

.sqs-gallery-block-grid
  .slide
  .margin-wrapper
  .content-wrapper.video-lightbox-wrapper {
  cursor: pointer;
}

.sqs-gallery-block-grid
  .slide
  .margin-wrapper
  .content-wrapper.video-lightbox-wrapper
  .sqs-video-wrapper
  .intrinsic {
  pointer-events: none;
}

.sqs-gallery-block-grid .slide .margin-wrapper .image-slide-title {
  text-align: center;
  display: none;
}

.sqs-gallery-block-grid .slide .meta {
  position: relative;
}

.sqs-gallery-block-grid .slide .meta h1 {
  font-size: 12px;
  letter-spacing: normal;
  margin: 0;
}

.sqs-gallery-block-grid.sqs-gallery-block-meta-only-title
  .margin-wrapper
  .image-slide-title {
  display: block;
  text-align: center;
  font-size: 14px;
  margin-top: 0.5em;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sqs-block .sqs-gallery-thumbnails .sqs-video-thumbnail {
  position: relative;
}

.sqs-block .sqs-gallery-thumbnails .sqs-video-thumbnail img {
  height: 100%;
}

.sqs-block
  .sqs-gallery-thumbnails
  .sqs-video-thumbnail
  .sqs-video-thumbnail-icon {
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  /* background-image: url("//assets.squarespace.com/universal/images-v6/icons/icon-video-24-light-solid.png"); */
  background-position: center center;
  height: 24px;
  width: 24px;
  margin-left: -12px;
  margin-top: -12px;
}

.sqs-block
  .sqs-gallery-thumbnails
  .sqs-video-thumbnail.no-image
  .sqs-video-thumbnail-inner {
  /* background-image: url("//assets.squarespace.com/universal/images-v6/icons/icon-video-24-light-solid.png"); */
  background-position: center center;
  background-repeat: no-repeat;
}

.sqs-block
  .sqs-gallery-thumbnails
  .sqs-video-thumbnail:not(.no-image).loading
  .sqs-video-thumbnail-icon {
  opacity: 0;
}

.sqs-block
  .sqs-gallery-thumbnails
  .sqs-video-thumbnail
  .sqs-video-thumbnail-inner {
  height: 100%;
  background: #000;
}

.sqs-block .sqs-gallery-thumbnails .sqs-gallery-design-strip-slide {
  opacity: 0.5;
}

.sqs-block
  .sqs-gallery-thumbnails
  .sqs-gallery-design-strip-slide.sqs-active-slide {
  opacity: 1;
}

.sqs-gallery-design-strip-slide img,
.sqs-gallery-design-strip-slide .sqs-video-wrapper {
  width: auto;
  height: 100%;
}

.sqs-gallery-block-stacked .image-wrapper img {
  width: 100%;
  height: auto;
}

.sqs-gallery-block-grid img {
  transition: opacity 1s;
}

.sqs-gallery-block-grid img:not(.loaded) {
  opacity: 0;
}

.sqs-gallery-block-grid img.loaded {
  opacity: 1 !important;
}

@media only screen and (max-width: 480px) {
  .sqs-gallery-block-slideshow .meta {
    display: none !important;
  }
}

@media only screen and (device-width: 768px) {
  .sqs-gallery-block-slideshow.sqs-gallery-block-show-meta .meta {
    opacity: 1 !important;
  }
}

.sqs-block.gallery-block .sqs-helper .sqs-handle-bottom {
  display: none;
}

.sqs-block.gallery-block.sized .sqs-helper .sqs-handle-bottom {
  display: block;
}

.sqs-layout.editing
  .sqs-block.gallery-block:hover
  .sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover
  .meta {
  opacity: 1 !important;
}

.sqs-gallery-dummy-images {
  background-color: transparent;
}

.sqs-gallery-dummy-images img,
.sqs-gallery-dummy-images + .sqs-gallery-thumbnails img {
  background-color: rgba(0, 0, 0, 0.03);
}

/*! WARNING: block .less requested, but unable to resolve css from system cache: calendar */
.summary-block ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.summary-block .summary-item:not(:last-child) {
  margin-bottom: 24px;
}

.summary-block .summary-collection-title {
  display: none;
}

.summary-block .summary-thumbnail {
  overflow: hidden;
  height: 150px;
}

.summary-block .summary-title {
  font-size: 1.2em;
}

.summary-block .summary-content-below-thumbnail .summary-title {
  margin: 1em 0 0 0;
}

.summary-block .summary-excerpt {
  margin: 0.75em 0;
}

.summary-block .summary-excerpt p {
  font-size: 0.9em;
}

.summary-block .timestamp {
  display: block;
  font-size: 0.8em;
  text-transform: uppercase;
}

.summary-block .summary-more-link {
  display: none;
  margin-left: 3px;
}

.sqs-block-horizontalrule hr {
  border: none;
  color: #bbb;
  background-color: #bbb;
  height: 1px;
}

.sqs-block-image .sqs-block-image-figure {
  margin: 0;
}

.sqs-block-image .sqs-block-image-link {
  display: block;
}

.sqs-block-image .sqs-block-image-button {
  display: block;
  width: 100%;
  border: none;
  padding: 0;
  background: none;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 {
  position: relative;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 p {
  font-size: inherit;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .intrinsic {
  position: relative;
  max-width: initial !important;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-inset {
  position: relative;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .intrinsic img {
  display: block;
  width: 100%;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .sqs-image-content::after,
.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-overlay {
  content: "";
  display: block;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card-wrapper {
  z-index: 2;
  pointer-events: none;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card {
  pointer-events: auto;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a {
  display: inline;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a,
.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a:hover {
  text-decoration: none;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .image-card
  .sqs-editing {
  pointer-events: auto;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 a.image-inset,
.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  a.image-title-wrapper {
  display: block;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 a.image-inset:hover,
.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  a.image-title-wrapper:hover {
  text-decoration: none;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-title p,
.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-subtitle p {
  white-space: pre-wrap;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-title p {
  display: inline;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-subtitle p {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .image-subtitle
  p:first-child {
  margin-top: 0;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .image-subtitle
  p:last-child {
  margin-bottom: 0;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .sqs-image.stretch {
  margin: 0 !important;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  + .image-caption-wrapper,
.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .image-caption-wrapper {
  display: none;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2
  .sqs-editing-overlay {
  z-index: 1;
}

.sqs-block-image .image-block-outer-wrapper.image-block-v2 .upload-indicator {
  display: none !important;
}

.sqs-block-image
  .image-block-outer-wrapper.image-block-v2:not(.design-layout-poster)
  ~ .yui3-resize-handles-wrapper {
  display: none;
}

.sqs-image-min-height {
  min-height: 1px;
}

.sqs-block-image .design-layout-poster .image-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.sqs-block-image .design-layout-poster .image-card-wrapper,
.sqs-block-image .design-layout-poster .image-card {
  pointer-events: none !important;
}

.sqs-block-image .design-layout-poster .image-card-wrapper a {
  pointer-events: auto;
  display: inline-block;
}

.sqs-block-image .design-layout-poster .intrinsic img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.sqs-block-image .design-layout-poster .image-card {
  width: 75%;
}

.sqs-block-image .design-layout-poster .sqs-image-content::after,
.sqs-block-image .design-layout-poster .image-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}

.sqs-block-image .design-layout-poster .image-title a,
.sqs-block-image .design-layout-poster .image-subtitle a {
  color: #fff;
}

.sqs-block-image .design-layout-poster .image-title a:hover,
.sqs-block-image .design-layout-poster .image-subtitle a:hover {
  opacity: 0.8;
}

.sqs-block-image .design-layout-poster .image-title p {
  color: #fff;
  background-color: rgba(255, 255, 255, 0);
  box-shadow: 0.25em 0 0 rgba(255, 255, 255, 0),
    -0.25em 0 0 rgba(255, 255, 255, 0);
}

.sqs-block-image .design-layout-poster .image-subtitle p {
  color: #fff;
}

.sqs-block-image
  .design-layout-poster
  .image-title-wrapper
  + .image-subtitle-wrapper
  .image-subtitle {
  margin-top: 3%;
}

.sqs-block-image .design-layout-card .sqs-image-content::after,
.sqs-block-image .design-layout-card .image-overlay {
  background-color: rgba(0, 0, 0, 0);
}

.sqs-block-image .design-layout-card .image-card-wrapper {
  background-color: #fff;
}

.sqs-block-image .design-layout-card .image-card {
  padding: 10% 0;
}

.sqs-block-image .design-layout-card .image-title-wrapper,
.sqs-block-image .design-layout-card .image-subtitle-wrapper,
.sqs-block-image .design-layout-card .image-button-wrapper {
  padding: 0 10%;
}

.sqs-block-image .design-layout-card .image-title-wrapper a,
.sqs-block-image .design-layout-card .image-subtitle-wrapper a {
  color: #000;
}

.sqs-block-image .design-layout-card .image-title-wrapper a:hover,
.sqs-block-image .design-layout-card .image-subtitle-wrapper a:hover {
  opacity: 0.8;
}

.sqs-block-image .design-layout-card .image-title p {
  background-color: rgba(255, 255, 255, 0);
  color: #000;
  box-shadow: 0.5em 0 0 rgba(255, 255, 255, 0),
    -0.5em 0 0 rgba(255, 255, 255, 0);
}

.sqs-block-image .design-layout-card .image-subtitle p {
  color: #000;
}

.sqs-block-image
  .design-layout-card
  .image-title-wrapper
  + .image-subtitle-wrapper
  .image-subtitle {
  margin-top: 4%;
}

.sqs-block-image .design-layout-card.sqs-narrow-width .image-card-wrapper {
  margin-top: 2%;
}

.sqs-block-image .design-layout-card:not(.sqs-narrow-width) {
  display: flex;
  justify-content: space-between;
}

.sqs-block-image
  .design-layout-card:not(.sqs-narrow-width).image-position-right {
  flex-direction: row-reverse;
}

.sqs-block-image .design-layout-card:not(.sqs-narrow-width) > :first-child {
  width: calc(50% - 1%);
}

.sqs-block-image
  .design-layout-card:not(.sqs-narrow-width)
  .image-card-wrapper {
  position: relative;
  width: calc(50% - 1%);
}

.sqs-block-image
  .design-layout-card:not(.sqs-narrow-width)
  .image-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.sqs-block-image .design-layout-card:not(.sqs-narrow-width) .image-card {
  position: relative;
  width: 100%;
}

.sqs-block-image
  .design-layout-card:not(.sqs-narrow-width).image-position-left
  .image-card-wrapper {
  margin-left: 2%;
}

.sqs-block-image
  .design-layout-card:not(.sqs-narrow-width).image-position-right
  .image-card-wrapper {
  margin-right: 2%;
}

.sqs-block-image .design-layout-card:not(.sqs-narrow-width):after {
  content: "";
  display: block;
  clear: both;
}

.sqs-block-image .design-layout-overlap .sqs-image-content::after,
.sqs-block-image .design-layout-overlap .image-overlay {
  background-color: rgba(150, 150, 150, 0);
}

.sqs-block-image .design-layout-overlap .image-card-wrapper {
  position: relative;
}

.sqs-block-image .design-layout-overlap .image-title a,
.sqs-block-image .design-layout-overlap .image-subtitle a {
  color: #000;
}

.sqs-block-image .design-layout-overlap .image-title a:hover,
.sqs-block-image .design-layout-overlap .image-subtitle a:hover {
  opacity: 0.8;
}

.sqs-block-image .design-layout-overlap .image-title p {
  color: #000;
  background-color: #fff;
  box-shadow: 0.2em 0 0 #fff, -0.2em 0 0 #fff;
}

.sqs-block-image .design-layout-overlap .image-subtitle p {
  color: #000;
  text-align: left;
  margin-bottom: 0;
}

.sqs-block-image
  .design-layout-overlap
  .image-title-wrapper
  + .image-subtitle-wrapper
  .image-subtitle {
  margin-top: 4%;
}

.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-card-wrapper {
  padding: 0 4%;
}

.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-card {
  width: 75%;
}

.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-title {
  margin-top: calc(-1em - 2%);
}

.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-title-wrapper,
.sqs-block-image
  .design-layout-overlap.sqs-narrow-width
  .image-subtitle-wrapper {
  width: 133.33333333%;
}

.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) {
  display: flex;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-card-wrapper,
.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) > :first-child {
  width: 50%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-right {
  flex-direction: row-reverse;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-right
  .image-card-wrapper {
  justify-content: flex-start;
}

.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) .image-card {
  width: 100%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-left
  .image-card {
  margin-left: -100%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-right
  .image-card {
  margin-right: -100%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-title-wrapper,
.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-subtitle-wrapper,
.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-button-wrapper {
  box-sizing: border-box;
  padding: 0 5%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-subtitle-wrapper {
  padding-top: 0;
}

.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) .image-subtitle {
  width: 100%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  > :first-child
  > * {
  width: 100%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width)
  .image-title-wrapper {
  width: 150%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-left
  .image-title-wrapper {
  margin-left: -50%;
}

.sqs-block-image
  .design-layout-overlap:not(.sqs-narrow-width).image-position-right
  > :first-child
  > * {
  left: 0%;
}

.sqs-block-image .design-layout-collage .sqs-image-content::after,
.sqs-block-image .design-layout-collage .image-overlay {
  background-color: rgba(0, 0, 0, 0);
}

.sqs-block-image .design-layout-collage .image-card {
  background-color: #000;
  padding: 10%;
  box-sizing: border-box;
}

.sqs-block-image .design-layout-collage .image-title a,
.sqs-block-image .design-layout-collage .image-subtitle a {
  color: #fff;
}

.sqs-block-image .design-layout-collage .image-title a:hover,
.sqs-block-image .design-layout-collage .image-subtitle a:hover {
  opacity: 0.8;
}

.sqs-block-image .design-layout-collage .image-title p {
  color: #fff;
}

.sqs-block-image .design-layout-collage .image-subtitle-wrapper {
  width: 100%;
}

.sqs-block-image .design-layout-collage .image-subtitle p {
  color: #9b9b9b;
}

.sqs-block-image
  .design-layout-collage
  .image-title-wrapper
  + .image-subtitle-wrapper
  .image-subtitle {
  margin-top: 4%;
}

.sqs-block-image .design-layout-collage.sqs-narrow-width .intrinsic {
  width: 90%;
}

.sqs-block-image .design-layout-collage.sqs-narrow-width .image-card-wrapper {
  width: 90%;
  margin-top: calc(-10% - 10%);
  position: relative;
}

.sqs-block-image
  .design-layout-collage.sqs-narrow-width.image-position-left:after {
  content: " ";
  display: block;
  clear: both;
}

.sqs-block-image
  .design-layout-collage.sqs-narrow-width.image-position-left
  .image-card-wrapper {
  float: right;
}

.sqs-block-image
  .design-layout-collage.sqs-narrow-width.image-position-right
  .intrinsic {
  left: 10%;
}

.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) {
  display: flex;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width).image-position-right {
  flex-direction: row-reverse;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width)
  .image-card-wrapper,
.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) > :first-child {
  width: 50%;
}

.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .intrinsic {
  overflow: visible;
}

.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .sqs-intrinsic {
  width: 100%;
}

.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .image-inset,
.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width)
  .sqs-image-content {
  position: relative !important;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width)
  .image-card-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.image-block-collage-content-position-top
  .sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width)
  .image-card {
  margin-top: 10%;
}

.image-block-collage-content-position-bottom
  .sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width)
  .image-card {
  margin-bottom: 10%;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width).image-position-left
  > :first-child
  > * {
  width: 140%;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width).image-position-left
  .image-card {
  width: 90%;
  margin-left: 10%;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width).image-position-right
  > :first-child
  > * {
  width: 140%;
  left: -40%;
}

.sqs-block-image
  .design-layout-collage:not(.sqs-narrow-width).image-position-right
  .image-card {
  width: 90%;
  margin-right: 10%;
}

.sqs-block-image .design-layout-stack .intrinsic img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.sqs-block-image .design-layout-stack .sqs-image-content::after,
.sqs-block-image .design-layout-stack .image-overlay {
  background-color: rgba(255, 255, 255, 0);
}

.sqs-block-image .design-layout-stack .image-card-wrapper {
  background-color: rgba(255, 255, 255, 0);
  margin-top: 5%;
}

.sqs-block-image .design-layout-stack .image-title a,
.sqs-block-image .design-layout-stack .image-subtitle a {
  color: #000;
}

.sqs-block-image .design-layout-stack .image-title a:hover,
.sqs-block-image .design-layout-stack .image-subtitle a:hover {
  opacity: 0.8;
}

.sqs-block-image .design-layout-stack .image-card {
  padding: 0px;
}

.sqs-block-image .design-layout-stack .image-title p {
  color: #000;
}

.sqs-block-image .design-layout-stack .image-subtitle p {
  color: #000;
}

.sqs-block-image
  .design-layout-stack
  .image-title-wrapper
  + .image-subtitle-wrapper
  .image-subtitle {
  margin-top: 4%;
}

.sqs-block-image .design-layout-card .intrinsic img,
.sqs-block-image .design-layout-overlap .intrinsic img,
.sqs-block-image .design-layout-collage .intrinsic img,
.sqs-block-image .design-layout-stack .intrinsic img {
  width: 100% !important;
  height: auto !important;
  position: static !important;
}

.sqs-block-image
  .design-layout-card
  .sqs-image:not(.sqs-empty)
  .sqs-image-content,
.sqs-block-image
  .design-layout-overlap
  .sqs-image:not(.sqs-empty)
  .sqs-image-content,
.sqs-block-image
  .design-layout-collage
  .sqs-image:not(.sqs-empty)
  .sqs-image-content,
.sqs-block-image
  .design-layout-stack
  .sqs-image:not(.sqs-empty)
  .sqs-image-content {
  padding-bottom: 0 !important;
}

.image-block-outer-wrapper.animation-disabled,
.image-block-outer-wrapper.animation-loaded {
  transform: translatez(0);
}

.image-block-outer-wrapper.animation-disabled .image-inset,
.image-block-outer-wrapper.animation-disabled .image-block-wrapper,
.image-block-outer-wrapper.animation-disabled .sqs-image-content,
.image-block-outer-wrapper.animation-disabled .image-caption-wrapper,
.image-block-outer-wrapper.animation-disabled .sqs-dynamic-text-container {
  transition: none !important;
}

.image-block-outer-wrapper.combination-animation-fade-in .image-inset,
.image-block-outer-wrapper.combination-animation-fade-in .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-fade-in .sqs-image-content,
.image-block-outer-wrapper.combination-animation-fade-in .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-fade-in
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-slide-up .image-inset,
.image-block-outer-wrapper.combination-animation-slide-up .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-slide-up .sqs-image-content,
.image-block-outer-wrapper.combination-animation-slide-up
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-slide-up
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 20);
}

.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-horizontal-clip .image-inset,
.image-block-outer-wrapper.combination-animation-horizontal-clip
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-horizontal-clip
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-horizontal-clip
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-horizontal-clip
  .sqs-dynamic-text-container {
  transition: clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: -webkit-clip-path, clip-path;
  clip-path: polygon(
    0% 50%,
    0% 100%,
    0% 100%,
    0% 50%,
    100% 50%,
    100% 0%,
    100% 0%,
    100% 50%,
    100% 50%,
    100% 50%
  );
}

.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  clip-path: polygon(
    0% 50%,
    0% 100%,
    100% 100%,
    100% 50%,
    100% 50%,
    100% 0%,
    0% 0%,
    0% 50%,
    100% 50%,
    100% 50%
  );
}

.image-block-outer-wrapper.combination-animation-vertical-clip .image-inset,
.image-block-outer-wrapper.combination-animation-vertical-clip
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-vertical-clip
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-vertical-clip
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-vertical-clip
  .sqs-dynamic-text-container {
  transition: clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: -webkit-clip-path, clip-path;
  clip-path: polygon(
    50% 0%,
    100% 0%,
    100% 0%,
    50% 0%,
    50% 100%,
    0% 100%,
    0% 100%,
    50% 100%,
    50% 100%,
    50% 100%
  );
}

.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  clip-path: polygon(
    50% 0%,
    100% 0%,
    100% 100%,
    50% 100%,
    50% 100%,
    0% 100%,
    0% 0%,
    50% 0%,
    50% 100%,
    50% 100%
  );
}

.image-block-outer-wrapper.combination-animation-tilt-up .image-inset,
.image-block-outer-wrapper.combination-animation-tilt-up .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-up .sqs-image-content,
.image-block-outer-wrapper.combination-animation-tilt-up .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-up
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0.03, 0, 0.92, 0, 20);
}

.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-tilt-down .image-inset,
.image-block-outer-wrapper.combination-animation-tilt-down .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-down .sqs-image-content,
.image-block-outer-wrapper.combination-animation-tilt-down
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-down
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, -0.03, 0, 0.92, 0, 20);
}

.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-collide .image-inset,
.image-block-outer-wrapper.combination-animation-collide .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-collide .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-collide .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-collide
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-collide.image-position-right
  .image-inset,
.image-block-outer-wrapper.combination-animation-collide.image-position-right
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-collide.image-position-right
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-collide.image-position-right
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-collide.image-position-right
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-collide.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-collide.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-collide.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-collide.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-collide.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-reveal .image-inset,
.image-block-outer-wrapper.combination-animation-reveal .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-reveal .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-reveal .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-reveal
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-reveal.image-position-right
  .image-inset,
.image-block-outer-wrapper.combination-animation-reveal.image-position-right
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-reveal.image-position-right
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-reveal.image-position-right
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-reveal.image-position-right
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-reveal.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-reveal.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-reveal.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-reveal.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-reveal.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-focus-in .image-inset,
.image-block-outer-wrapper.combination-animation-focus-in .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-focus-in .sqs-image-content,
.image-block-outer-wrapper.combination-animation-focus-in
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-focus-in
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0, 0, 0.92, 0, 0);
}

.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded
  .sqs-image-content,
.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom {
  transform: translatez(0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, -20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip
  .sqs-image-content {
  transition: clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: -webkit-clip-path, clip-path;
  clip-path: polygon(
    0% 50%,
    0% 100%,
    0% 100%,
    0% 50%,
    100% 50%,
    100% 0%,
    100% 0%,
    100% 50%,
    100% 50%,
    100% 50%
  );
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded
  .sqs-image-content {
  clip-path: polygon(
    0% 50%,
    0% 100%,
    100% 100%,
    100% 50%,
    100% 50%,
    100% 0%,
    0% 0%,
    0% 50%,
    100% 50%,
    100% 50%
  );
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip
  .sqs-image-content {
  transition: clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: -webkit-clip-path, clip-path;
  clip-path: polygon(
    50% 0%,
    100% 0%,
    100% 0%,
    50% 0%,
    50% 100%,
    0% 100%,
    0% 100%,
    50% 100%,
    50% 100%,
    50% 100%
  );
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded
  .sqs-image-content {
  clip-path: polygon(
    50% 0%,
    100% 0%,
    100% 100%,
    50% 100%,
    50% 100%,
    0% 100%,
    0% 0%,
    50% 0%,
    50% 100%,
    50% 100%
  );
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, -0.03, 0, 0.92, 0, 20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0.03, 0, 0.92, 0, 20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in
  .sqs-image-content {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0, 0, 0.92, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded
  .image-inset,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded
  .image-block-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded
  .sqs-image-content {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, 20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 0, -20);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, -20, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 20, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in
  .sqs-dynamic-text-container {
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  opacity: 0;
  transform: matrix(0.92, 0, 0, 0.92, 0, 0);
}

.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in.animation-loaded
  .image-caption-wrapper,
.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in.animation-loaded.sqs-text-ready
  .sqs-dynamic-text-container {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}

.image-block-poster-text-alignment-left
  .sqs-block-image
  .design-layout-poster
  .image-card
  > * {
  text-align: left !important;
}

.image-block-poster-text-alignment-center
  .sqs-block-image
  .design-layout-poster
  .image-card
  > * {
  text-align: center !important;
}

.image-block-poster-text-alignment-right
  .sqs-block-image
  .design-layout-poster
  .image-card
  > *,
.image-block-poster-text-alignment-match
  .sqs-block-image
  .design-layout-poster.image-position-right
  .image-card
  > *,
.image-block-poster-text-alignment-opposite
  .sqs-block-image
  .design-layout-poster.image-position-left
  .image-card
  > * {
  text-align: right !important;
}

.image-block-card-text-alignment-left
  .sqs-block-image
  .design-layout-card
  .image-card
  > * {
  text-align: left !important;
}

.image-block-card-text-alignment-center
  .sqs-block-image
  .design-layout-card
  .image-card
  > * {
  text-align: center !important;
}

.image-block-card-text-alignment-right
  .sqs-block-image
  .design-layout-card
  .image-card
  > *,
.image-block-card-text-alignment-match
  .sqs-block-image
  .design-layout-card.image-position-right
  .image-card
  > *,
.image-block-card-text-alignment-opposite
  .sqs-block-image
  .design-layout-card.image-position-left
  .image-card
  > * {
  text-align: right !important;
}

.image-block-overlap-text-alignment-left
  .sqs-block-image
  .design-layout-overlap
  .image-card
  > * {
  text-align: left !important;
}

.image-block-overlap-text-alignment-center
  .sqs-block-image
  .design-layout-overlap
  .image-card
  > * {
  text-align: center !important;
}

.image-block-overlap-text-alignment-right
  .sqs-block-image
  .design-layout-overlap
  .image-card
  > *,
.image-block-overlap-text-alignment-match
  .sqs-block-image
  .design-layout-overlap.image-position-right
  .image-card
  > *,
.image-block-overlap-text-alignment-opposite
  .sqs-block-image
  .design-layout-overlap.image-position-left
  .image-card
  > * {
  text-align: right !important;
}

.image-block-collage-text-alignment-left
  .sqs-block-image
  .design-layout-collage
  .image-card
  > * {
  text-align: left !important;
}

.image-block-collage-text-alignment-center
  .sqs-block-image
  .design-layout-collage
  .image-card
  > * {
  text-align: center !important;
}

.image-block-collage-text-alignment-right
  .sqs-block-image
  .design-layout-collage
  .image-card
  > *,
.image-block-collage-text-alignment-match
  .sqs-block-image
  .design-layout-collage.image-position-right
  .image-card
  > *,
.image-block-collage-text-alignment-opposite
  .sqs-block-image
  .design-layout-collage.image-position-left
  .image-card
  > * {
  text-align: right !important;
}

.image-block-stack-text-alignment-left
  .sqs-block-image
  .design-layout-stack
  .image-card
  > * {
  text-align: left !important;
}

.image-block-stack-text-alignment-center
  .sqs-block-image
  .design-layout-stack
  .image-card
  > * {
  text-align: center !important;
}

.image-block-stack-text-alignment-right
  .sqs-block-image
  .design-layout-stack
  .image-card
  > *,
.image-block-stack-text-alignment-match
  .sqs-block-image
  .design-layout-stack.image-position-right
  .image-card
  > *,
.image-block-stack-text-alignment-opposite
  .sqs-block-image
  .design-layout-stack.image-position-left
  .image-card
  > * {
  text-align: right !important;
}

.sqs-dynamic-text {
  min-width: 100%;
  line-height: 1em;
}

.min-font-set,
.min-font-set ~ * {
  font-size: 13px !important;
}

.image-block-v2:not([class*="-animation-"]) {
  opacity: 0;
  transition: opacity 1s ease-out;
  transition-delay: 1s;
}

.sqs-text-ready .image-block-v2:not([class*="-animation-"]),
.sqs-text-ready.image-block-v2:not([class*="-animation-"]) {
  opacity: 1;
}

.image-block-card-content-position-top
  .sqs-block-image
  .design-layout-card
  .image-card-wrapper {
  align-items: flex-start;
}

.image-block-card-content-position-center
  .sqs-block-image
  .design-layout-card
  .image-card-wrapper {
  align-items: center;
}

.image-block-card-content-position-bottom
  .sqs-block-image
  .design-layout-card
  .image-card-wrapper {
  align-items: flex-end;
}

.image-block-overlap-content-position-top
  .sqs-block-image
  .design-layout-overlap
  .image-card-wrapper {
  align-items: flex-start;
}

.image-block-overlap-content-position-center
  .sqs-block-image
  .design-layout-overlap
  .image-card-wrapper {
  align-items: center;
}

.image-block-overlap-content-position-bottom
  .sqs-block-image
  .design-layout-overlap
  .image-card-wrapper {
  align-items: flex-end;
}

.image-block-collage-content-position-top
  .sqs-block-image
  .design-layout-collage
  .image-card-wrapper {
  align-items: flex-start;
}

.image-block-collage-content-position-center
  .sqs-block-image
  .design-layout-collage
  .image-card-wrapper {
  align-items: center;
}

.image-block-collage-content-position-bottom
  .sqs-block-image
  .design-layout-collage
  .image-card-wrapper {
  align-items: flex-end;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-poster
  .image-button-wrapper {
  margin-top: 6%;
  font-size: 2.25vw;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-poster
  .image-button
  a {
  display: inline-block;
  padding: 0.7em 1.75em;
  border: 0px solid #fff;
  background-color: #fff;
  font-family: Arial;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
  font-size: inherit !important;
  color: #000;
  border-radius: 5em;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-poster
  .image-button
  a:hover {
  opacity: 0.8;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-card
  .image-button-wrapper {
  margin-top: 6%;
  font-size: 4vw;
}

.sqs-block-image .image-block-outer-wrapper.design-layout-card .image-button a {
  display: inline-block;
  padding: 1em 2.5em;
  border: 0px solid #000;
  background-color: #000;
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  line-height: 1.1em;
  text-transform: none;
  color: #fff;
  border-radius: 0.2em;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-card
  .image-button
  a:hover {
  opacity: 0.8;
}

body.image-block-card-dynamic-font-sizing
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-card
  a {
  font-size: inherit !important;
}

body:not(.image-block-card-dynamic-font-sizing)
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-card
  .sqs-dynamic-text {
  font-size: initial !important;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-overlap
  .image-button-wrapper {
  margin-top: 5%;
  font-size: 3.6vw;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-overlap
  .image-button
  a {
  display: inline-block;
  padding: 0.7em 1.75em;
  border: 0px solid #000;
  background-color: #000;
  font-family: Arial;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
  color: #fff;
  border-radius: 0em;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-overlap
  .image-button
  a:hover {
  opacity: 0.8;
}

body.image-block-overlap-dynamic-font-sizing
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-overlap
  a {
  font-size: inherit !important;
}

body:not(.image-block-overlap-dynamic-font-sizing)
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-overlap
  .sqs-dynamic-text {
  font-size: initial !important;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-collage
  .image-button-wrapper {
  margin-top: 6%;
  font-size: 4vw;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-collage
  .image-button-wrapper
  .image-button
  a {
  display: inline-block;
  padding: 1em 2.5em;
  border: 0px solid #fff;
  background-color: #fff;
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
  color: #000;
  border-radius: 0em;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-collage
  .image-button-wrapper
  .image-button
  a:hover {
  opacity: 0.8;
}

body.image-block-collage-dynamic-font-sizing
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-collage
  .image-button-wrapper
  a {
  font-size: inherit !important;
}

body:not(.image-block-collage-dynamic-font-sizing)
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-collage
  .image-button-wrapper
  .sqs-dynamic-text {
  font-size: initial !important;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-stack
  .image-button-wrapper {
  margin-top: 4%;
  font-size: 2.25vw;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-stack
  .image-button-wrapper
  .image-button
  a {
  display: inline-block;
  padding: 1em 2.5em;
  border: 0px solid #000;
  background-color: #000;
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  line-height: 1.1em;
  text-transform: none;
  color: #fff;
  border-radius: 5em;
}

.sqs-block-image
  .image-block-outer-wrapper.design-layout-stack
  .image-button-wrapper
  .image-button
  a:hover {
  opacity: 0.8;
}

body.image-block-stack-dynamic-font-sizing
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-stack
  .image-button-wrapper
  a {
  font-size: inherit !important;
}

body:not(.image-block-stack-dynamic-font-sizing)
  .sqs-block-image
  .image-block-outer-wrapper.design-layout-stack
  .image-button-wrapper
  .sqs-dynamic-text {
  font-size: initial !important;
}

.image-block-outer-wrapper:not(.sqs-text-ready) .sqs-dynamic-text {
  visibility: hidden;
}

.sqs-block-image .design-layout-poster .image-title-wrapper {
  font-size: 11vw;
}

.sqs-block-image .design-layout-poster .image-title p {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.image-block-card-dynamic-font-sizing
  .sqs-block-image
  .design-layout-card
  .image-title-wrapper {
  font-size: 10vw;
}

.image-block-card-dynamic-font-sizing
  .sqs-block-image
  .design-layout-card
  .image-title
  p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.1em;
}

body:not(.image-block-card-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-card
  .sqs-dynamic-text {
  font-size: initial !important;
}

body:not(.image-block-card-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-card
  .image-title
  p {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.1em;
}

.sqs-block-image .design-layout-overlap .image-title-wrapper {
  font-size: 9vw;
}

.sqs-block-image .design-layout-overlap .image-title p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-overlap-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-overlap
  .sqs-dynamic-text {
  font-size: initial !important;
}

body:not(.image-block-overlap-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-overlap
  .image-title
  p {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 40px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.sqs-block-image .design-layout-collage .image-title-wrapper {
  font-size: 12vw;
}

.sqs-block-image .design-layout-collage .image-title p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-collage-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-collage
  .sqs-dynamic-text {
  font-size: initial !important;
}

body:not(.image-block-collage-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-collage
  .image-title
  p {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 50px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.sqs-block-image .design-layout-stack .image-title-wrapper {
  font-size: 3.75vw;
}

.sqs-block-image .design-layout-stack .image-title p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-stack-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-stack
  .sqs-dynamic-text {
  font-size: initial !important;
}

body:not(.image-block-stack-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-stack
  .image-title
  p {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.sqs-block-image .design-layout-poster .image-subtitle-wrapper {
  font-size: 3.75vw;
}

.sqs-block-image .design-layout-poster .image-subtitle p {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.image-block-card-dynamic-font-sizing
  .sqs-block-image
  .design-layout-card
  .image-subtitle-wrapper {
  font-size: 3.2vw;
}

.image-block-card-dynamic-font-sizing
  .sqs-block-image
  .design-layout-card
  .image-subtitle
  p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-card-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-card
  .image-subtitle
  p {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.sqs-block-image .design-layout-overlap .image-subtitle-wrapper {
  font-size: 3.2vw;
}

.sqs-block-image .design-layout-overlap .image-subtitle p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-overlap-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-overlap
  .image-subtitle
  p {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 20px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.sqs-block-image .design-layout-collage .image-subtitle-wrapper {
  font-size: 3.2vw;
}

.sqs-block-image .design-layout-collage .image-subtitle p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-collage-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-collage
  .image-subtitle
  p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  font-size: 22px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.sqs-block-image .design-layout-stack .image-subtitle-wrapper {
  font-size: 2vw;
}

.sqs-block-image .design-layout-stack .image-subtitle p {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.image-block-stack-dynamic-font-sizing)
  .sqs-block-image
  .design-layout-stack
  .image-subtitle
  p {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 25px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-poster-title-font {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 88px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.tweak-image-block-poster-subtitle-font {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 30px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-poster-button-font {
  font-family: Arial;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
}

.tweak-image-block-card-title-font {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.1em;
}

.tweak-image-block-card-subtitle-font {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-card-button-font {
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  line-height: 1.1em;
  text-transform: none;
}

.tweak-image-block-overlap-title-font {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 40px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.tweak-image-block-overlap-subtitle-font {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 20px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-overlap-button-font {
  font-family: Arial;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
}

.tweak-image-block-collage-title-font {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 50px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.tweak-image-block-collage-subtitle-font {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  font-size: 22px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-collage-button-font {
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 1.1em;
  text-transform: none;
}

.tweak-image-block-stack-title-font {
  font-family: Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  letter-spacing: 0em;
  text-transform: none;
  line-height: 1.2em;
}

.tweak-image-block-stack-subtitle-font {
  font-family: Arial;
  font-weight: 500;
  font-style: normal;
  font-size: 25px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.5em;
}

.tweak-image-block-stack-button-font {
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0em;
  line-height: 1.1em;
  text-transform: none;
}

.sqs-block-image .sqs-image-caption p,
.sqs-block-image .image-caption p {
  font-size: 12px;
  line-height: 1.68em;
}

.sqs-block-image .sqs-image-caption p:first-child,
.sqs-block-image .image-caption p:first-child {
  margin-top: 0;
}

.sqs-block-image .sqs-image-caption p a,
.sqs-block-image .image-caption p a {
  display: inline;
}

.sqs-block-image:not(.sqs-block-focused)
  .sqs-image-caption.sqs-placeholder-show {
  display: none;
}

.sqs-block-image .sqs-placeholder p {
  margin: 0;
  margin-top: 0.7em;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper
  img {
  max-width: none;
}

.sqs-block-image .image-block-lightbox {
  cursor: pointer;
  display: block;
}

.sqs-block-image .lightbox img {
  cursor: pointer;
}

.sqs-block-image.sized
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper {
  overflow: hidden;
  padding-bottom: inherit !important;
}

.sqs-block-image.sized
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper
  img {
  text-align: inherit;
  max-width: none;
}

.sqs-block-image img {
  display: block;
}

.sqs-block-image .image-block-wrapper.sqs-default-image {
  text-align: center;
}

.sqs-block-image .image-block-wrapper.sqs-default-image img {
  display: inline-block;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-card-wrapper {
  display: none;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-below
  .image-caption-wrapper {
  padding-top: 18px;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-hidden
  .image-caption-wrapper {
  height: 0;
  overflow: hidden;
}

.sqs-block-image .image-block-outer-wrapper.layout-caption-overlay .intrinsic,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .intrinsic {
  position: relative;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper {
  position: absolute;
  top: auto;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 18px;
  background: rgba(0, 0, 0, 0.7);
  max-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  h1,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  h1,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  h2,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  h2,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  h3,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  h3,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  strong,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  strong {
  color: #eee;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  p,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  p {
  color: #bbb;
  line-height: 1.68em;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay
  .image-caption-wrapper
  p
  a,
.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper
  p
  a {
  color: #bbb;
  text-decoration: underline;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover:hover
  .image-caption-wrapper {
  max-height: 75%;
  opacity: 1;
  visibility: visible;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption-wrapper {
  opacity: 0;
  transition: opacity 0.1s ease-out;
  visibility: hidden;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover:hover
  .image-caption {
  margin-bottom: 0;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-caption-overlay-hover
  .image-caption {
  transition: margin-bottom 0.1s ease-out;
  margin-bottom: -5px;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-left {
  zoom: 1;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-left:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-block-image .image-block-outer-wrapper.layout-image-left:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-left
  .image-block-wrapper {
  float: left;
  width: 50%;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-left
  .image-caption-wrapper {
  float: left;
  width: 50%;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-left .image-caption {
  padding-left: 15px;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-left
  .image-caption
  h1 {
  font-size: 18px;
  line-height: 24px;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-right {
  zoom: 1;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-right:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-block-image .image-block-outer-wrapper.layout-image-right:after {
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  clear: both;
  content: ".";
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-right
  .image-block-wrapper {
  float: right;
  width: 50%;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-right
  .image-caption-wrapper {
  float: right;
  width: 50%;
  text-align: right;
}

.sqs-block-image .image-block-outer-wrapper.layout-image-right .image-caption {
  padding-right: 15px;
}

.sqs-block-image
  .image-block-outer-wrapper.layout-image-right
  .image-caption
  h1 {
  font-size: 18px;
  line-height: 24px;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper {
  line-height: 0;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper
  img {
  max-width: 100%;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper
  img.block-stretch {
  width: 100%;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .image-block-wrapper.float-right
  .image-block-wrapper {
  text-align: right;
}

.sqs-block-image .image-block-outer-wrapper:not(.image-block-v2) .intrinsic {
  margin: auto;
}

.sqs-block-image
  .image-block-outer-wrapper:not(.image-block-v2)
  .intrinsic
  .image-block-wrapper
  img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: none;
  width: 100%;
}

.sqs-block-image .sqs-action-overlay {
  z-index: 1000;
}

.sqs-block-image .processing {
  background: #ccc;
  text-align: center;
}

.sqs-block-image .processing .progress-container {
  background: #ccc;
  top: 15px;
}

.sqs-block-image .processing-failed {
  background: #ccc;
  text-align: center;
  position: relative;
  height: 100%;
}

.sqs-block-image .sqs-empty .sqs-image-content {
  padding-bottom: 75%;
  background: rgba(62, 62, 62, 0.06);
}

.sqs-block-image .sqs-empty .sqs-image-content:empty::before {
  content: "";
  width: 64px;
  height: 56px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -28px;
  margin-left: -32px;
  /* background: url("/universal/images-v6/damask/image-inside-64-dark.png")
    no-repeat center; */
}

@media (min-resolution: 1.5dppx) {
  .sqs-block-image .sqs-empty .sqs-image-content:empty::before {
    /* background-image: url("/universal/images-v6/damask/image-inside-128-dark.png"); */
    background-size: 64px;
  }
}

.sqs-block-image.vsize-1 .image-block-wrapper {
  height: 34px;
}

.sqs-block-image.vsize-2 .image-block-wrapper {
  height: 68px;
}

.sqs-block-image.vsize-3 .image-block-wrapper {
  height: 102px;
}

.sqs-block-image.vsize-4 .image-block-wrapper {
  height: 136px;
}

.sqs-block-image.vsize-5 .image-block-wrapper {
  height: 170px;
}

.sqs-block-image.vsize-6 .image-block-wrapper {
  height: 204px;
}

.sqs-block-image.vsize-7 .image-block-wrapper {
  height: 238px;
}

.sqs-block-image.vsize-8 .image-block-wrapper {
  height: 272px;
}

.sqs-block-image.vsize-9 .image-block-wrapper {
  height: 306px;
}

.sqs-block-image.vsize-10 .image-block-wrapper {
  height: 340px;
}

.sqs-block-image.vsize-11 .image-block-wrapper {
  height: 374px;
}

.sqs-block-image.vsize-12 .image-block-wrapper {
  height: 408px;
}

.sqs-block-image.vsize-13 .image-block-wrapper {
  height: 442px;
}

.sqs-block-image.vsize-14 .image-block-wrapper {
  height: 476px;
}

.sqs-block-image.vsize-15 .image-block-wrapper {
  height: 510px;
}

.sqs-block-image.vsize-16 .image-block-wrapper {
  height: 544px;
}

.sqs-block-image.vsize-17 .image-block-wrapper {
  height: 578px;
}

.sqs-block-image.vsize-18 .image-block-wrapper {
  height: 612px;
}

.sqs-block-image.vsize-19 .image-block-wrapper {
  height: 646px;
}

.sqs-block-image.vsize-20 .image-block-wrapper {
  height: 680px;
}

.sqs-block-image.vsize-21 .image-block-wrapper {
  height: 714px;
}

.sqs-block-image.vsize-22 .image-block-wrapper {
  height: 748px;
}

.sqs-block-image.vsize-23 .image-block-wrapper {
  height: 782px;
}

.sqs-block-image.vsize-24 .image-block-wrapper {
  height: 816px;
}

.sqs-block-image.vsize-25 .image-block-wrapper {
  height: 850px;
}

.sqs-block-image.vsize-26 .image-block-wrapper {
  height: 884px;
}

.sqs-block-image.vsize-27 .image-block-wrapper {
  height: 918px;
}

.sqs-block-image.vsize-28 .image-block-wrapper {
  height: 952px;
}

.sqs-block-image.vsize-29 .image-block-wrapper {
  height: 986px;
}

.sqs-block-image.vsize-30 .image-block-wrapper {
  height: 1020px;
}

.sqs-block-image[class*="vsize-"] .sqs-block-content {
  height: auto;
  overflow: visible;
}

.product-block .image-container {
  position: relative;
  display: block;
  width: 100%;
}

.product-block .image-container a {
  display: block;
  width: 100%;
  line-height: 0;
}

.product-block .image-container img {
  width: 100%;
  max-width: 100%;
}

.product-block
  .image-container
  img:not(.loaded)
  .sqs-product-mark-wrapper
  .sqs-product-quick-view-button-wrapper {
  opacity: 0 !important;
}

.product-block .image-container .product-mark {
  position: absolute;
  top: 15px;
  right: 0;
  background: #222;
  padding: 6px 8px;
  color: #fff;
  line-height: 1em;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
}

.product-block .image-container .sqs-product-block-variant-image {
  display: none;
  width: 100%;
  line-height: 0;
}

.product-block .image-container .sqs-product-block-variant-image.shown {
  display: block;
}

.product-block
  .image-container
  .sqs-product-block-variant-image.shown
  ~ .sqs-product-block-main-image {
  display: none;
}

.sqs-style-mode-active
  .product-block.is-product-quick-view-enabled.is-first-product-block
  .sqs-product-quick-view-button-wrapper {
  opacity: 1;
}

.sqs-style-mode-active
  .product-block.is-product-quick-view-enabled.is-first-product-block
  .sqs-product-mark-wrapper {
  opacity: 0;
}

.product-block .productDetails.center {
  text-align: center;
}

.product-block .productDetails.center .sqs-add-to-cart-button-wrapper {
  margin-left: auto;
  margin-right: auto;
}

.product-block .productDetails.right {
  text-align: right;
}

.product-block .productDetails.right .sqs-add-to-cart-button-wrapper {
  margin-left: auto;
}

.product-block .productDetails .product-title {
  font-size: 1.3em;
  line-height: 1em;
  margin: 1em 0 0.2em 0;
  display: inline-block;
}

.product-block .productDetails .product-price {
  font-size: 1.1em;
  margin: 0 0 1em 0;
}

.product-block .productDetails .product-price input {
  width: 130px;
  height: 30px;
  padding-left: 5px;
}

.product-block .productDetails .product-price .minimum-price {
  margin-top: 3px;
  margin-left: 10px;
}

.product-block .productDetails .product-price .original-price {
  text-decoration: line-through;
  opacity: 0.7;
  filter: alpha(opacity=70);
}

.product-block .productDetails .product-price .strikeout {
  text-decoration: line-through;
}

.product-block .productDetails .product-variants .variant-option {
  margin: 0 0 1em 0;
}

.product-block .productDetails .product-variants .variant-out-of-stock {
  color: #c00;
  margin-top: 8px;
}

.product-block .productDetails .product-variants .variant-radiobtn-wrapper {
  display: none;
}

.product-block .productDetails .product-quantity-input input {
  background-color: #fff;
  color: #222;
}

.product-block .productDetails .product-scarcity {
  margin-top: 1em;
  font-size: 1.1em;
  color: #000;
}

.product-block .buy-button,
.product-block .sqs-add-to-cart-button-wrapper {
  margin: 20px 0;
  display: block;
}

.product-block .buy-button:hover,
.product-block .sqs-add-to-cart-button-wrapper:hover {
  opacity: 1;
}

.product-block .sqs-add-to-cart-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

.product-block .sqs-amazon-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  text-transform: none;
}

.product-block .center .sqs-amazon-button {
  text-align: center;
}

.product-block .right .sqs-amazon-button {
  text-align: right;
}

.sqs-block-accordion .accordion-items-container {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.sqs-block-accordion .accordion-item {
  padding: 0;
  margin: 0;
  position: relative;
}

.sqs-block-accordion .accordion-divider {
  background-color: currentColor;
}

.sqs-block-accordion
  .accordion-items-container:not([data-is-last-divider-visible="true"])
  .accordion-item:last-of-type
  .accordion-divider {
  display: none;
}

.sqs-block-accordion .accordion-item__title-wrapper {
  margin: 0;
  padding: 0;
}

.sqs-block-accordion .accordion-item__title {
  flex: 1 1;
}

.sqs-block-accordion
  [data-accordion-title-alignment="center"]
  .accordion-item__title {
  text-align: center;
}

.sqs-block-accordion
  [data-accordion-title-alignment="right"]
  .accordion-item__title {
  text-align: right;
}

.sqs-block-accordion .accordion-item__click-target {
  box-sizing: border-box;
  width: 100%;
  background: transparent;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  -webkit-appearance: none;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  font-style: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  color: inherit;
  touch-action: manipulation;
}

.sqs-block-accordion
  [data-accordion-icon-placement="left"]
  .accordion-item__click-target {
  flex-direction: row-reverse;
}

.sqs-block-accordion .accordion-item__click-target > * {
  margin: 0;
}

.sqs-block-accordion .accordion-item__dropdown {
  box-sizing: border-box;
  display: none;
  overflow: hidden;
}

.sqs-block-accordion .accordion-item__dropdown--pre-open {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  visibility: hidden;
  width: 100%;
  transition: none;
  height: auto;
}

.sqs-block-accordion .accordion-item__dropdown--open {
  display: block;
}

.sqs-block-accordion .accordion-item__description {
  box-sizing: border-box;
}

.sqs-block-accordion
  [data-accordion-description-placement="center"]
  .accordion-item__description {
  margin-left: auto;
  margin-right: auto;
}

.sqs-block-accordion
  [data-accordion-description-placement="right"]
  .accordion-item__description {
  margin-left: auto;
}

.sqs-block-accordion
  [data-accordion-description-alignment="center"]
  .accordion-item__description {
  text-align: center;
}

.sqs-block-accordion
  [data-accordion-description-alignment="right"]
  .accordion-item__description {
  text-align: right;
}

.sqs-block-accordion .accordion-item__title > :first-of-type,
.sqs-block-accordion .accordion-item__description > :first-of-type {
  margin-top: 0;
}

.sqs-block-accordion .accordion-item__title > :last-of-type,
.sqs-block-accordion .accordion-item__description > :last-of-type {
  margin-bottom: 0;
}

.sqs-block-accordion .accordion-icon-container {
  position: relative;
}

.sqs-block-accordion .accordion-icon-container > * {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sqs-block-accordion .plus__horizontal-line,
.sqs-block-accordion .plus__vertical-line {
  display: block;
  width: 100%;
  background-color: currentColor;
  transition: transform 0.2s;
  position: absolute;
}

.sqs-block-accordion .plus__vertical-line {
  transform: rotate(90deg);
}

.sqs-block-accordion .accordion-item[data-is-open="true"] .plus__vertical-line {
  transform: rotate(0deg);
}

.sqs-block-accordion .arrow-container {
  transition: transform 0.2s;
}

.sqs-block-accordion .accordion-item[data-is-open="true"] .arrow-container {
  transform: rotate(-180deg);
}

.sqs-block-accordion .arrow {
  border-color: currentColor;
  border-style: solid;
  border-top: none;
  border-left: none;
  box-sizing: border-box;
  transform: translatey(-25%) rotate(45deg);
  width: 70.71067%;
  height: 70.71067%;
}

@media (prefers-reduced-motion: reduce) {
  .sqs-block-accordion .accordion-item__dropdown,
  .sqs-block-accordion .plus__vertical-line,
  .sqs-block-accordion .arrow-container {
    transition: none !important;
  }
}

.sqs-block-archive .archive-group-list,
.sqs-block-archive .archive-item-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.sqs-block-archive .archive-group-count::before {
  content: "(";
}

.sqs-block-archive .archive-group-count::after {
  content: ")";
}

.sqs-block-archive
  .archive-block-setting-layout-list.archive-block-setting-text-alignment-center,
.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-text-alignment-center {
  text-align: center;
}

.sqs-block-archive
  .archive-block-setting-layout-list.archive-block-setting-text-alignment-right,
.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-text-alignment-right {
  text-align: right;
}

.sqs-block-archive
  .archive-block-setting-layout-list.archive-block-setting-multicolumns
  .archive-group-list {
  columns: 140px;
  column-gap: 60px;
}

.sqs-block-archive
  .archive-block-setting-layout-index
  .archive-group-name-link {
  font-size: 1.4em;
  line-height: 1.4em;
  text-decoration: none;
}

.sqs-block-archive .archive-block-setting-layout-index .archive-item-list {
  display: block;
  margin: 1.4em 0 2.8em 0;
  font-size: 1em;
  line-height: 1.4em;
}

.sqs-block-archive .archive-block-setting-layout-index .archive-item {
  margin: 0 0 0.7em 0;
}

.sqs-block-archive
  .archive-block-setting-layout-index
  .archive-item.archive-item--show-date {
  margin: 0 0 1.4em 0;
}

.sqs-block-archive
  .archive-block-setting-layout-index
  .archive-item-date-before {
  display: none;
  opacity: 0.7;
  margin-right: 5px;
}

.sqs-block-archive .archive-block-setting-layout-index .archive-item-link {
  display: block;
  margin-right: 5px;
  color: inherit !important;
}

.sqs-block-archive
  .archive-block-setting-layout-index
  .archive-item-link--untitled::before {
  content: "Untitled";
}

.sqs-block-archive
  .archive-block-setting-layout-index
  .archive-item-date-after {
  display: block;
  opacity: 0.7;
}

.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-group-list {
  columns: 200px;
  column-gap: 60px;
}

.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-group {
  page-break-inside: avoid;
  break-inside: avoid;
  display: block;
  overflow: hidden;
}

.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-group-name-link {
  display: block;
}

.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-group-name-list {
  display: inline-block;
}

.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-group-name-link,
.sqs-block-archive
  .archive-block-setting-layout-index.archive-block-setting-multicolumns
  .archive-item-list {
  min-width: 225px;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown.archive-block-wrapper {
  max-width: 300px;
  background: rgba(110, 110, 110, 0.05);
  border-radius: 1px;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-label {
  display: block;
  padding: 12px 18px;
  font-size: 1em;
  line-height: 1.6em;
  cursor: pointer;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  list-style: none;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-label::-webkit-details-marker {
  display: none;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-title {
  float: left;
  width: 90%;
  padding-right: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-icon {
  position: relative;
  bottom: 1px;
  float: right;
  width: 10%;
  text-align: right;
  box-sizing: border-box;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-icon:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e009";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-icon:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-dropdown-toggle-icon:before {
  font-size: 1em;
  width: 1em;
  height: 1em;
  line-height: 1em;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown[open]
  .archive-dropdown-toggle-icon:before {
  font-family: "squarespace-ui-font";
  font-style: normal;
  speak: none;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  content: "\\e006";
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown[open]
  .archive-dropdown-toggle-icon:before {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.sqs-block-archive .archive-block-setting-layout-dropdown .archive-group-list {
  padding: 0 18px 12px;
}

.sqs-block-archive
  .archive-block-setting-layout-dropdown
  .archive-group-name-link {
  text-decoration: none;
}

@media only screen and (max-width: 400px) {
  .sqs-block-archive
    .archive-block-setting-layout-dropdown.archive-block-wrapper {
    max-width: none;
  }
}

.sqs-block-archive.sqs-edit-dialog-open .sqs-editing-overlay,
.sqs-block-archive.sqs-edit-dialog-open .sqs-block-editor-button-container {
  z-index: 1;
}

.sqs-block-archive.sqs-edit-dialog-open .sqs-block-archive-content {
  position: relative;
  z-index: 1000;
}

.sqs-block-archive.sqs-edit-dialog-open .archive-group-list {
  pointer-events: none;
}

.tagcloud-block ul {
  list-style-type: none;
  margin: 0;
  padding-left: 0;
}

.tagcloud-block ul li {
  display: inline-block;
}

.sqs-block-shape .sqs-block-content,
.sqs-block-shape .sqs-block-alignment-wrapper {
  height: 100%;
}

.sqs-block-shape .sqs-block-alignment-wrapper {
  display: flex;
}

.sqs-block-shape .sqs-shape {
  display: block;
  position: absolute;
  overflow: visible;
}

.sqs-block-shape .sqs-shape-block-container {
  position: relative;
}

/*! WARNING: block .less requested, but unable to resolve css from system cache: album */
.sqs-block-postsbycategory ul,
.sqs-block-postsbyauthor ul,
.sqs-block-postsbytag ul,
.sqs-block-postsbymonth ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.sqs-block-postsbycategory ul li,
.sqs-block-postsbyauthor ul li,
.sqs-block-postsbytag ul li,
.sqs-block-postsbymonth ul li {
  margin: 0 0 1rem 0;
  padding: 0;
}

.sqs-block-postsbycategory ul {
  display: grid;
  gap: 1.35rem 1rem;
  grid-auto-rows: 1fr;
}

.sqs-block-postsbycategory ul li {
  min-height: 100px;
}

.sqs-block-postsbycategory ul li a {
  height: 100%;
  /* border: 1px solid #15508a; */
}

.sqs-block-postsbycategory ul li a div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}

.sqs-block-postsbycategory ul li a div img {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
}

.sqs-block-postsbycategory ul li a div div {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.sqs-block-postsbycategory .count,
.sqs-block-postsbyauthor .count,
.sqs-block-postsbytag .count,
.sqs-block-postsbymonth .count {
  display: none;
}

.Marquee {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  z-index: auto;
  background-color: transparent;
}

.Marquee h1,
.Marquee p {
  margin: 0;
  min-height: 0;
  line-height: 1.4 !important;
}

.Marquee-svg {
  display: block;
  width: 100%;
  font-size: inherit;
}

.Marquee-hitbox {
  position: relative;
  display: block;
  width: 100%;
}

.Marquee-hitbox:focus .Marquee-path-hitbox-focus-outline {
  stroke: currentColor;
}

.Marquee-hitbox:focus:not(:focus-visible) .Marquee-path-hitbox-focus-outline {
  stroke: initial;
}

.Marquee-display {
  flex-grow: 1;
  flex-shrink: 0;
}

.Marquee-display.fade-edges {
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    #000 15%,
    #000 85%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    #000 15%,
    #000 85%,
    transparent 100%
  );
}

.Marquee-measure {
  display: inline-flex;
  align-items: center;
  width: max-content;
  min-height: 1em;
  visibility: hidden;
  position: absolute;
}

.Marquee-group {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
}

.Marquee-measure,
.Marquee-group {
  min-width: 50px;
}

.Marquee-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
}

.Marquee-track {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.Marquee-track {
  pointer-events: none;
}

.Marquee-track .Marquee-track-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}

.Marquee-track-item .Marquee-item {
  padding: 0;
  transform: translate3d(-50%, calc(-50% - 0.4em), 0);
}

.menu-block .menu-selector {
  margin-bottom: 3em;
}

.menu-block .menu-selector label {
  display: inline-block;
  padding: 0 0.5em;
  font-size: 1.1em;
  cursor: pointer;
}

.menu-block .menu-selector label.menu-select-labels--active {
  text-decoration: underline;
}

.menu-block .menu-select-button {
  display: none;
}

.menu-block .menus--has-multiple .menu {
  display: none;
}

.menu-block .menu-header {
  margin-bottom: 3em;
}

.menu-block .menu-section {
  margin-top: 1em;
}

.menu-block .menu-section + .menu-section {
  margin-top: 5em;
}

.menu-block .menu-section-header {
  margin-bottom: 2em;
  padding-bottom: 1em;
}

.menu-block .menu-section-title {
  font-size: 1.5em;
}

.menu-block .menu-section-description {
  font-size: 0.85em;
  line-height: 1.4em;
}

.menu-block .menu-item {
  margin-bottom: 0;
  padding-bottom: 2em;
  margin-top: 0;
  line-height: 1.2em;
}

.menu-block .menu-item-title {
  font-size: 1.1em;
  font-weight: 700;
  line-height: 1.2em;
}

.menu-block .menu-item-description {
  line-height: 1.3em;
  margin-top: 5px;
}

.menu-block .menu-item-price-bottom {
  margin: 0.5em 0;
}

.menu-block .menu-item-option {
  font-size: 0.8em;
  font-style: italic;
}

.menu-block .menu-style-classic .menu-selector,
.menu-block .menu-style-classic .menu-header,
.menu-block .menu-style-classic .menu-section-title,
.menu-block .menu-style-classic .menu-section-description {
  text-align: center;
}

.menu-block .menu-style-classic .menu-items {
  column-width: 18em;
  column-gap: 3em;
}

.menu-block .menu-style-classic .menu-item {
  page-break-inside: avoid;
  break-inside: avoid;
  width: 100%;
}

.menu-block .menu-style-classic .menu-item-description {
  margin-right: 3em;
}

.menu-block .menu-style-classic .menu-item-price-top {
  float: right;
  padding-left: 20px;
}

.menu-block .menu-style-classic .menu-item-price-bottom {
  display: none;
}

.menu-block .menu-style-simple .menu-selector,
.menu-block .menu-style-simple .menu {
  text-align: center;
}

.menu-block .menu-style-simple .menu-item-price-top {
  display: none;
}

.pricing-plan-block {
  min-height: 44px;
}

.pricing-plan-block .sqs-editable-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

.pricing-plan-block .pricing-plan-pricing-toggle-wrapper {
  display: flex;
  justify-content: flex-start;
}

.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.hide {
  display: none;
}

.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-left {
  justify-content: flex-start;
}

.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-center {
  justify-content: center;
}

.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-right {
  justify-content: flex-end;
}

.pricing-plan-block .pricing-plan-pricing-options {
  display: grid;
  display: -ms-grid;
  grid-template-columns: repeat(2, 1fr);
  -ms-grid-columns: 1fr 1fr;
  list-style-type: none;
  padding: 0px;
  margin: 0px;
}

.pricing-plan-block
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  width: 100%;
  height: 100%;
  padding: 0.6em 1.1em !important;
  text-align: center;
  border-radius: 0px;
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

@media (hover: hover) {
  .pricing-plan-block
    .pricing-plan-pricing-options
    .sqs-editable-button.pricing-plan-pricing-option-button:hover {
    opacity: 1;
    color: #fff;
    background-color: #272727;
  }
}

.pricing-plan-block
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-selected {
  color: #fff;
  background-color: #272727;
}

.pricing-plan-block .pricing-plan-pricing-options .left-option {
  -ms-grid-column: 1;
}

.pricing-plan-block .pricing-plan-pricing-options .right-option {
  -ms-grid-column: 2;
}

.pricing-plan-block .hide,
.pricing-plan-block .join-button.hide {
  display: none;
}

.pricing-plan-block .below-pricing-toggle {
  margin-top: 33px;
}

body
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.left-button {
  border-radius: 300px 0px 0px 300px;
}

body
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.right-button {
  border-radius: 0px 300px 300px 0px;
}

.primary-button-style-outline
  .sqs-block-pricing-plan
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  border-width: 2px;
}

.product-block .productDetails div.product-title.pricing-plan-title {
  font-size: 1.5em;
  margin-top: 33px;
  margin-bottom: 11px;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  line-height: normal;
}

.pricing-plan-price-amount {
  font-size: 2em;
  margin-top: 11px;
  line-height: 90%;
}

.pricing-plan-price-billing-period {
  font-size: 1em;
  opacity: 0.75;
  margin-bottom: 22px;
  margin-top: 11px;
}

.product-block .productDetails .product-price.pricing-plan-product-price {
  margin: 0 0 12px 0;
  line-height: normal;
}

.product-block
  .productDetails
  .product-price.pricing-plan-product-price.below-pricing-toggle {
  margin-top: 33px;
}

.pricing-plan-description {
  margin: 0 0 22px 0;
  line-height: normal;
  font-size: 1em;
}

.pricing-plan-benefits-divider {
  margin-top: 22px;
  margin-bottom: 22px;
}

.pricing-plan-benefit-description:not(:last-child) {
  margin-bottom: 6px;
}

.sqs-block-summary-v2 * {
  box-sizing: border-box;
}

.sqs-block-summary-v2 .summary-thumbnail-outer-container {
  position: relative;
}

.sqs-block-summary-v2 .summary-heading {
  display: none;
  margin: 0 0 15px 0;
  padding-right: 10px;
  font-size: 14px;
  line-height: normal;
}

.sqs-block-summary-v2 .summary-carousel-pager {
  display: none;
}

.sqs-block-summary-v2 .summary-item-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.sqs-block-summary-v2 .summary-item {
  visibility: hidden;
  overflow: hidden;
}

.sqs-block-summary-v2 .summary-item.positioned {
  visibility: visible;
}

.sqs-style-mode-active
  .sqs-block-summary-v2
  .is-product-quick-view-enabled
  .summary-item:first-child
  .sqs-product-quick-view-button-wrapper {
  opacity: 1;
}

.sqs-style-mode-active
  .sqs-block-summary-v2
  .is-product-quick-view-enabled
  .summary-item:first-child
  .sqs-product-mark-wrapper {
  opacity: 0;
}

.sqs-block-summary-v2 .summary-thumbnail-container {
  position: relative;
  display: block;
}

.sqs-block-summary-v2 .summary-thumbnail-container:hover {
  opacity: 1 !important;
}

.sqs-block-summary-v2 .img-wrapper,
.sqs-block-summary-v2 .sqs-video-wrapper {
  position: relative;
  width: 100%;
  height: auto;
}

.sqs-block-summary-v2 .img-wrapper img,
.sqs-block-summary-v2 .sqs-video-wrapper img {
  opacity: 0;
  display: block;
  width: 100%;
  height: auto;
  font-size: 13px;
  line-height: normal;
  transition: 0.6s opacity;
}

.sqs-block-summary-v2 .img-wrapper img.loaded,
.sqs-block-summary-v2 .sqs-video-wrapper img.loaded {
  opacity: 1;
}

.sqs-block-summary-v2
  .img-wrapper
  img:not(.loaded)
  .sqs-product-mark-wrapper
  .sqs-product-quick-view-button-wrapper,
.sqs-block-summary-v2
  .sqs-video-wrapper
  img:not(.loaded)
  .sqs-product-mark-wrapper
  .sqs-product-quick-view-button-wrapper {
  opacity: 0 !important;
}

.sqs-block-summary-v2 .summary-product-status .product-mark {
  position: absolute;
  top: 15px;
  right: 0;
  padding: 6px 8px;
  background: #222;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
  box-sizing: content-box;
}

.sqs-block-summary-v2 .summary-thumbnail-event-date {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  height: 50px;
  width: 50px;
  padding: 3px;
  background: #fff;
  text-align: center;
  box-sizing: content-box;
}

.sqs-block-summary-v2 .summary-thumbnail-event-date-inner {
  display: table-cell;
  vertical-align: middle;
}

.sqs-block-summary-v2 .summary-thumbnail-event-date-month {
  display: block;
  color: #333;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
}

.sqs-block-summary-v2 .summary-thumbnail-event-date-day {
  display: block;
  color: #333;
  font-size: 26px;
  line-height: 26px;
}

.sqs-block-summary-v2 .summary-content {
  text-align: left;
}

.sqs-block-summary-v2 .summary-title {
  margin: 0 0 10px 0;
  font-size: 20px;
  line-height: 1.2em;
  text-align: left;
}

.sqs-block-summary-v2 .summary-price {
  margin: 0 0 10px 0;
}

.sqs-block-summary-v2 .summary-price .product-price {
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

.sqs-block-summary-v2 .summary-price .product-price .original-price {
  opacity: 0.7;
  filter: alpha(opacity=70);
  text-decoration: line-through;
}

.sqs-block-summary-v2 .product-scarcity {
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin: 0 0 10px 0;
  color: #000;
}

.sqs-block-summary-v2 .summary-excerpt {
  margin: 0 0 10px 0;
}

.sqs-block-summary-v2 .summary-excerpt p,
.sqs-block-summary-v2 .summary-excerpt ul,
.sqs-block-summary-v2 .summary-excerpt li {
  font-size: 14px;
  line-height: 1.4em;
  margin: 0 0 10px 0;
  text-align: left;
}

.sqs-block-summary-v2 .summary-excerpt p:first-of-type,
.sqs-block-summary-v2 .summary-excerpt ul:first-of-type,
.sqs-block-summary-v2 .summary-excerpt li:first-of-type {
  margin-top: 0 !important;
}

.sqs-block-summary-v2 .summary-excerpt p:last-of-type,
.sqs-block-summary-v2 .summary-excerpt ul:last-of-type,
.sqs-block-summary-v2 .summary-excerpt li:last-of-type {
  margin-bottom: 0 !important;
}

.sqs-block-summary-v2 .summary-excerpt > blockquote p {
  font-size: inherit;
  line-height: inherit;
  margin: inherit;
  text-align: inherit;
}

.sqs-block-summary-v2 .summary-excerpt > blockquote p:first-of-type {
  margin-top: inherit;
}

.sqs-block-summary-v2 .summary-excerpt > blockquote p:last-of-type {
  margin-bottom: inherit;
}

.sqs-block-summary-v2 .summary-block-collection-type-lessons .summary-excerpt {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.sqs-block-summary-v2 .summary-read-more-link {
  display: none;
  margin: 0 0 10px 0;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

.sqs-block-summary-v2 .summary-metadata-container {
  display: none;
  font-size: 13px;
  line-height: normal;
}

.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title
  .summary-metadata-container--above-title,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title
  .summary-metadata-container--below-title,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-content
  .summary-metadata-container--below-content {
  display: block;
}

.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata-container {
  margin: 0 0 10px 0;
}

.sqs-block-summary-v2 .summary-metadata {
  display: none;
}

.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-date
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-event-time
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata--primary,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata--primary {
  display: inline-block;
}

.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-date
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-event-time
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata--secondary,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata--secondary {
  display: inline-block;
}

.sqs-block-summary-v2 .summary-metadata-item {
  display: none;
  opacity: 0.7;
  margin: 0;
  font-size: 13px;
  line-height: 1.4em;
  text-transform: none;
}

.sqs-block-summary-v2 .summary-metadata-item a,
.sqs-block-summary-v2 .summary-metadata-item a:hover {
  opacity: 1;
  text-decoration: none;
}

.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-date
  .summary-metadata--primary
  .summary-metadata-item--date,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-event-time
  .summary-metadata--primary
  .summary-metadata-item--event-time,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata--primary
  .summary-metadata-item--cats,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata--primary
  .summary-metadata-item--tags,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata--primary
  .summary-metadata-item--author,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata--primary
  .summary-metadata-item--comments,
.sqs-block-summary-v2
  .summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata--primary
  .summary-metadata-item--location {
  display: inline-block;
}

.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-date
  .summary-metadata--secondary
  .summary-metadata-item--date,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-event-time
  .summary-metadata--secondary
  .summary-metadata-item--event-time,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata--secondary
  .summary-metadata-item--cats,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata--secondary
  .summary-metadata-item--tags,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata--secondary
  .summary-metadata-item--author,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata--secondary
  .summary-metadata-item--comments,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata--secondary
  .summary-metadata-item--location {
  display: inline-block;
}

.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-date
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-event-time
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata--primary
  .summary-metadata-item:after,
.sqs-block-summary-v2
  .summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata--primary
  .summary-metadata-item:after {
  content: " ·";
  margin: 0 0.3em;
}

.sqs-block-summary-v2
  .summary-block-setting-text-size-extralarge
  .summary-title {
  font-size: 54px;
}

.sqs-block-summary-v2
  .summary-block-setting-text-size-extralarge
  .summary-excerpt
  p {
  font-size: 16px;
}

.sqs-block-summary-v2 .summary-block-setting-text-size-large .summary-title {
  font-size: 30px;
}

.sqs-block-summary-v2 .summary-block-setting-text-size-medium .summary-title {
  font-size: 20px;
}

.sqs-block-summary-v2 .summary-block-setting-text-size-small .summary-title {
  font-size: 14px;
}

.sqs-block-summary-v2 .summary-block-setting-text-align-center .summary-title,
.sqs-block-summary-v2
  .summary-block-setting-text-align-center
  .summary-price
  .product-price,
.sqs-block-summary-v2
  .summary-block-setting-text-align-center
  .summary-excerpt
  p,
.sqs-block-summary-v2
  .summary-block-setting-text-align-center
  .summary-read-more-link,
.sqs-block-summary-v2
  .summary-block-setting-text-align-center
  .summary-content {
  text-align: center;
}

.sqs-block-summary-v2 .summary-block-setting-text-align-right .summary-title,
.sqs-block-summary-v2
  .summary-block-setting-text-align-right
  .summary-price
  .product-price,
.sqs-block-summary-v2
  .summary-block-setting-text-align-right
  .summary-excerpt
  p,
.sqs-block-summary-v2
  .summary-block-setting-text-align-right
  .summary-read-more-link,
.sqs-block-summary-v2 .summary-block-setting-text-align-right .summary-content {
  text-align: right;
}

.sqs-block-summary-v2 .summary-item-record-type-text .summary-read-more-link {
  display: block;
}

.sqs-block-summary-v2
  .summary-item-record-type-event
  .summary-thumbnail-event-date {
  display: table;
}

.sqs-block-summary-v2 .event-time-localized {
  display: none;
}

.sqs-block-summary-v2 .summary-thumbnail-container {
  margin: 0;
}

.sqs-block-summary-v2
  .summary-block-setting-show-title
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-setting-show-price
  .summary-item-record-type-store-item
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-setting-show-excerpt
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(.summary-block-setting-primary-metadata-none)
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(.summary-block-setting-secondary-metadata-none)
  .summary-thumbnail-container {
  margin: 0 0 15px 0;
}

.sqs-block-summary-v2
  .summary-block-wrapper:not(.summary-block-setting-show-excerpt)
  .summary-title,
.sqs-block-summary-v2
  .summary-block-wrapper:not(.summary-block-setting-show-excerpt)
  .summary-price {
  margin: 0 0 2px 0;
}

.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-date
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-event-time
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-cats
  .summary-item-has-cats
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-tags
  .summary-item-has-tags
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-author
  .summary-item-has-author
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-comments
  .summary-item-has-comments-enabled
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata-container,
.sqs-block-summary-v2
  .summary-block-wrapper:not(
    .summary-block-setting-show-excerpt
  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-location
  .summary-item-has-location
  .summary-metadata-container {
  margin: 0 0 2px 0;
}

.sqs-block-summary-v2 .summary-block-setting-design-list .summary-item {
  visibility: visible !important;
  margin-bottom: 17px !important;
  padding-bottom: 17px !important;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item.summary-item-show-thumbnail {
  margin-bottom: 17px !important;
  padding-bottom: 17px !important;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item
  .summary-thumbnail-container {
  margin: 0 !important;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item:not(.summary-item-record-type-video)
  .summary-thumbnail-container {
  width: 100% !important;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item.summary-item-record-type-video
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-thumbnail-outer-container {
  float: left;
}

@media screen and (max-width: 480px) {
  .sqs-block-summary-v2
    .summary-block-setting-design-list
    .summary-item.summary-item-record-type-video
    .summary-thumbnail-container,
  .sqs-block-summary-v2
    .summary-block-setting-design-list
    .summary-thumbnail-outer-container {
    width: 35% !important;
  }
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item
  .summary-thumbnail-container
  .sqs-video-wrapper
  img {
  max-width: 100%;
  object-fit: contain;
  position: static !important;
}

@media screen and (max-width: 480px) {
  .sqs-block-summary-v2
    .summary-block-setting-design-list
    .summary-item
    .summary-thumbnail-container
    .sqs-video-wrapper
    img {
    height: auto;
    position: static;
    width: 100% !important;
    width: auto;
  }
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .sqs-product-quick-view-button-wrapper {
  padding-right: 20px;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right
  .summary-item-record-type-video
  .summary-thumbnail-container,
.sqs-block-summary-v2
  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right
  .summary-thumbnail-outer-container {
  float: right;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right
  .summary-thumbnail-container {
  padding: 0 0 0 20px;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right
  .sqs-product-quick-view-button-wrapper {
  padding-left: 20px;
  padding-right: 0px;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right
  .summary-item-record-type-store-item
  .product-mark {
  right: 0;
  left: auto;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item-record-type-store-item
  .product-mark {
  left: 0;
  right: auto;
}

.sqs-block-summary-v2
  .summary-block-setting-design-list
  .summary-item-record-type-event
  .summary-thumbnail-event-date {
  display: none;
}

.sqs-block-summary-v2
  .summary-block-setting-design-carousel
  .summary-carousel-pager {
  display: flex;
  justify-content: flex-end;
}

.sqs-block-summary-v2
  .summary-block-setting-design-carousel
  .summary-block-header {
  overflow: hidden;
}

.sqs-block-summary-v2 .summary-block-setting-design-carousel .summary-heading {
  display: block;
  float: left;
  width: calc(100% - 50px);
}

.sqs-block-summary-v2
  .summary-block-setting-design-carousel
  .summary-collection-title {
  display: none;
}

.sqs-block-summary-v2
  .summary-block-setting-design-carousel
  .summary-carousel-pager {
  float: right;
  width: 50px;
}

.sqs-block-summary-v2
  .summary-block-setting-design-carousel
  .summary-item:not(.positioned) {
  visibility: visible;
}

@media only screen and (max-width: 700px) {
  .sqs-block-summary-v2 .summary-product-quick-view {
    display: none;
  }
}

div.sqs-block-opentable-v2 {
  word-wrap: break-word;
}

div.sqs-block-opentable-v2 .ot-dtp-picker {
  margin: auto;
  width: auto;
  background: none;
}

div.sqs-block-opentable-v2 .ot-dtp-picker-selector {
  background: rgba(0, 0, 0, 0.12);
  border: none;
}

div.sqs-block-opentable-v2 .ot-dtp-picker-selector,
div.sqs-block-opentable-v2 .ot-dtp-picker-button {
  width: 100% !important;
  max-width: 200px;
}

div.sqs-block-opentable-v2 .ot-dtp-picker form.ot-dtp-picker-form {
  border: none;
  background: none;
  height: auto !important;
}

div.sqs-block-opentable-v2 .ot-dtp-picker.wide {
  margin: auto;
  width: auto;
}

div.sqs-block-opentable-v2 .ot-dtp-picker.wide .ot-powered-by {
  background-size: contain;
  background-position: center;
  margin: 20px 0 0;
}

div.sqs-block-opentable-v2 .ot-dtp-picker-selector-link {
  background: #fff;
  color: #000;
  overflow: hidden;
  white-space: nowrap;
}

div.sqs-block-opentable-v2 .oc-loading {
  text-align: center;
  font-family: sans-serif;
  line-height: 180px;
}

div.sqs-block-opentable-v2 a {
  text-decoration: none !important;
}

div.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper {
  background: rgba(153, 153, 153, 0.15);
  padding: 30px;
  opacity: 0;
  transition: opacity 0.3s ease-out;
}

div.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper iframe {
  display: block;
  margin: 0 auto;
}

div.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper h1 {
  font-weight: normal;
  text-align: center;
  line-height: 1em;
  margin: 0;
}

div.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper.loading {
  min-height: 270px;
}

div.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper.loaded {
  opacity: 1;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-button-wrapper
  .ot-dtp-picker-button {
  color: #fff;
  background: #000;
}

div.sqs-block-opentable-v2 h1 {
  color: #111;
}

div.sqs-block-opentable-v2 .squarespace-opentable-picker-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 10px 0;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-picker-wrapper
  .ot-dtp-picker-selector {
  margin: 10px;
  border-left: none !important;
}

@media only screen and (max-width: 650px) {
  div.sqs-block-opentable-v2 .squarespace-opentable-picker-wrapper {
    display: block;
    margin: 0;
  }

  div.sqs-block-opentable-v2
    .squarespace-opentable-picker-wrapper
    .ot-dtp-picker-selector {
    margin: 20px auto;
    float: none !important;
  }
}

div.sqs-block-opentable-v2 .squarespace-opentable-button-wrapper {
  text-align: center;
  display: block;
}

div.sqs-block-opentable-v2 .squarespace-opentable-button-wrapper .ot-button {
  float: none !important;
  line-height: 1em;
  display: inline;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-button-wrapper
  .ot-dtp-picker-button {
  border-radius: 0px !important;
  box-shadow: none;
  border: none;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-new-age-wrapper.opentable-block-hide-icons
  .ot-dtp-picker-selector-link {
  padding-left: 0.875rem;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-new-age-wrapper.opentable-block-hide-icons
  .ot-dtp-picker-selector-link:before {
  display: none;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-new-age-wrapper.opentable-block-hide-title
  .squarespace-ot-title {
  display: none !important;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-new-age-wrapper.opentable-block-hide-title
  .squarespace-opentable-picker-wrapper {
  margin-top: -10px;
}

div.sqs-block-opentable-v2
  .squarespace-opentable-new-age-wrapper.opentable-block-hide-logo
  .ot-powered-by {
  display: none;
}

.field-error {
  border-radius: 2px;
  background: #cc3b3b
    /* url("//assets.squarespace.com/universal/images-v6/standard/icon_close_7_light.png") */
    no-repeat 9px 50%;
  color: #fff;
  display: inline-block;
  font-size: 13px;
  line-height: 23px;
  margin: 12px 0;
  padding: 5px 15px 3px 25px;
}

.form-wrapper .form-submission-text:focus:not(:focus-visible),
.form-wrapper .form-submission-html:focus:not(:focus-visible),
.form-wrapper .field-error:focus:not(:focus-visible) {
  outline: none;
}

.form-wrapper .field-list {
  line-height: normal;
}

.form-wrapper .field-list fieldset,
.form-wrapper .field-list legend {
  margin: 0;
  padding: 0;
  border: 0;
}

.form-wrapper .field-list textarea {
  min-height: 100px;
  resize: vertical;
}

.form-wrapper .field-list textarea.medium {
  min-height: 200px;
}

.form-wrapper .field-list textarea.large {
  min-height: 300px;
}

.form-wrapper .field-list .section {
  margin: 2em 0;
  padding-bottom: 0.3em;
  font-size: 0.9em;
}

.form-wrapper .field-list .section.underline {
  border-bottom: 1px solid #999;
}

.form-wrapper .field-list .section:nth-child(1) {
  margin: 0 0 2em 0;
}

.form-wrapper .field-list .title {
  display: block;
}

.form-wrapper .field-list .description {
  padding: 0.5em 0 0.5em;
  font-size: 12px;
  opacity: 0.7;
  display: block;
  white-space: pre-wrap;
}

.form-wrapper .field-list .field {
  position: relative;
  margin: 0 0 24px;
}

.form-wrapper .field-list .field .caption {
  font-size: 12px;
}

.form-wrapper .field-list .field .caption .field-element {
  font-size: 14px;
}

.form-wrapper .field-list .field .field-element {
  width: 100%;
  padding: 12px;
  margin: 6px 0 4px;
  border: 1px solid #ccc;
  background: #fafafa;
  color: #000;
  font-family: sans-serif;
  font-size: 12px;
  line-height: normal;
  box-sizing: border-box;
  border-radius: 2px;
}

.form-wrapper .field-list .field .field-element:focus {
  background: #fff;
  transition: background 0.1s ease-in;
}

.form-wrapper .field-list .field select {
  margin: 6px 0 4px;
  max-width: 100%;
}

.form-wrapper .field-list .field .prefix {
  position: absolute;
  bottom: 16px;
  left: 8px;
  color: #aaa;
  font-family: sans-serif;
  font-size: 13px;
  line-height: 16px;
}

.form-wrapper .field-list .field.twitter .field-element {
  padding-left: 22px;
}

.form-wrapper .field-list .field.currency.hassymbol .field-element {
  padding-left: 20px;
}

.form-wrapper .field-list .field.website .field-element {
  padding-left: 45px;
}

.form-wrapper .field-list .field.checkbox label,
.form-wrapper .field-list .field.radio label {
  cursor: pointer;
}

.form-wrapper .field-list .field.checkbox input,
.form-wrapper .field-list .field.radio input {
  margin-right: 5px;
}

.form-wrapper .field-list .field .option {
  margin: 6px 0 4px;
  font-size: 13px;
}

.form-wrapper .field-list .field.likert .item {
  margin: 1.6em 0 1.6em 0;
}

.form-wrapper .field-list .field.likert .question {
  margin: 0 0 0.5em 0;
  font-size: 0.9em;
}

.form-wrapper .field-list .field.likert .option {
  width: 20%;
  float: left;
  text-align: left;
  border-top: 1px solid #ddd;
}

.form-wrapper .field-list .field.likert .option label {
  margin: 0;
  padding: 0 0 0 1px;
  font-size: 0.9em;
  display: block;
  cursor: pointer;
}

.form-wrapper .field-list .field.likert .option input {
  margin: 10px 0;
  display: block;
}

.form-wrapper .field-list .field.likert .option:last-of-type {
  border-right: none;
}

.form-wrapper .field-list .fields {
  margin: 0 0 0 -2%;
}

.form-wrapper .field-list .fields .title,
.form-wrapper .field-list .fields .description,
.form-wrapper .field-list .fields .field,
.form-wrapper .field-list .fields .field-error {
  margin-left: 2%;
}

.form-wrapper .field-list .fields .field {
  float: left;
}

.form-wrapper .field-list .fields .field.two-digits {
  width: 3.5em;
}

.form-wrapper .field-list .fields .field.three-digits {
  width: 4.2em;
}

.form-wrapper .field-list .fields .field.four-digits {
  width: 4.8em;
}

.form-wrapper .field-list .fields .field.ampm {
  width: 4.5em;
}

.form-wrapper .field-list .fields.name .field {
  width: 48%;
}

.form-wrapper .field-list .fields.address .field.address1,
.form-wrapper .field-list .fields.address .field.address2 {
  width: 98%;
}

.form-wrapper .field-list .fields.address .field.city {
  width: 70%;
}

.form-wrapper .field-list .fields.address .field.state-province {
  width: 26%;
}

.form-wrapper .field-list .fields.address .field.zip {
  width: 36%;
}

.form-wrapper .field-list .fields.address .field.country {
  width: 98%;
}

.form-wrapper .field-list .fields.payment .field.card-expiry-month {
  width: 40%;
}

.form-wrapper .field-list .fields.payment .field.card-expiry-year {
  width: 40%;
}

.form-wrapper .field-list .form-item.error,
.form-wrapper .field-list .form-item.error .caption,
.form-wrapper .field-list .form-item.error .title,
.form-wrapper .field-list .form-item.error .description {
  color: #bd0000;
}

.form-wrapper .field-list .form-item.error input,
.form-wrapper .field-list .form-item.error textarea {
  border: 1px solid #e99292;
}

.form-wrapper .form-button-wrapper--align-left {
  text-align: left;
}

.form-wrapper .form-button-wrapper--align-center {
  text-align: center;
}

.form-wrapper .form-button-wrapper--align-right {
  text-align: right;
}

.form-wrapper input[type="submit"] {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  font-size: 14px;
  text-transform: none;
}

.form-wrapper .form-submission-text {
  margin-top: 20px;
}

.form-wrapper .field .field-error {
  margin-bottom: 0.5em;
}

.form-wrapper .submitting .field-list {
  opacity: 0.7;
}

.form-wrapper .hidden,
.form-wrapper.hidden {
  display: none;
}

.form-block .lightbox-handle-wrapper--align-left {
  text-align: left;
}

.form-block .lightbox-handle-wrapper--align-center {
  text-align: center;
}

.form-block .lightbox-handle-wrapper--align-right {
  text-align: right;
}

.form-block .lightbox-handle {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  font-size: 14px;
  text-transform: none;
}

.sqs-modal-lightbox {
  width: 100%;
  font-size: 14px;
  text-transform: none;
  font-style: normal;
  text-decoration: none;
}

.sqs-modal-lightbox-content {
  z-index: 100000000;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
}

.sqs-modal-lightbox-content .lightbox-background {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
}

.sqs-modal-lightbox-content .lightbox-inner {
  position: fixed;
  overflow: auto;
  width: 100%;
  height: 100%;
  top: 0;
}

.sqs-modal-lightbox-content .lightbox-inner .lightbox-content {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  padding: 40px;
  background: #fff;
}

.sqs-modal-lightbox-content .lightbox-inner .lightbox-content .form-wrapper {
  color: #222;
  font-family: inherit;
}

.sqs-modal-lightbox-content
  .lightbox-inner
  .lightbox-content
  .form-wrapper
  .form-title {
  font-size: 22px;
  line-height: 1.2em;
  margin-right: 22px;
  color: #333;
}

.sqs-modal-lightbox-content
  .lightbox-inner
  .lightbox-content
  .form-wrapper
  .form-inner-wrapper
  form {
  margin-top: 55px;
}

.sqs-modal-lightbox-content
  .lightbox-inner
  .lightbox-content
  .form-wrapper
  .form-inner-wrapper
  form
  .radio
  .option {
  margin-left: 1px;
}

.sqs-modal-lightbox-content .lightbox-inner .lightbox-content .lightbox-close {
  position: absolute;
  color: #333;
  font-size: 22px;
  font-family: Arial, Helvetica, sans-serif;
  font-style: normal;
  width: 22px;
  line-height: 22px;
  top: 40px;
  right: 40px;
  text-align: center;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .sqs-modal-lightbox .sqs-modal-lightbox-content {
    height: 100vh;
  }

  .sqs-modal-lightbox .lightbox-inner {
    background: #fff;
  }

  .sqs-modal-lightbox .lightbox-inner .lightbox-content {
    margin-top: 0 !important;
  }

  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper input,
  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper select,
  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper textarea {
    font-size: 16px !important;
    font-size: max(16px, 1rem) !important;
  }
}

html.sqs-modal-lightbox-open,
html.sqs-modal-lightbox-open body {
  overflow: hidden;
}

.sqs-block-accordion .accordion-divider {
  color: #000;
}

.sqs-block-accordion .accordion-icon-container {
  color: #000;
}

.sqs-block-collectionlink .collectionlink-thumbnail,
.link-block .collectionlink-thumbnail {
  overflow: hidden;
  height: 150px;
}

.sqs-block-collectionlink .collectionlink-thumbnail a,
.link-block .collectionlink-thumbnail a {
  display: block;
  height: 100%;
}

.sqs-block-collectionlink .collectionlink-title,
.link-block .collectionlink-title {
  font-size: 1.2em;
}

.sqs-block-collectionlink .collectionlink-title a,
.link-block .collectionlink-title a {
  display: block;
}

.sqs-block-collectionlink
  .collectionlink-content-below-thumbnail
  .collectionlink-title,
.link-block .collectionlink-content-below-thumbnail .collectionlink-title {
  margin: 1em 0 0 0;
}

.sqs-block-collectionlink .collectionlink-description,
.link-block .collectionlink-description {
  margin: 0.75em 0;
}

.sqs-block-collectionlink .collectionlink-description p,
.link-block .collectionlink-description p {
  font-size: 0.9em;
}

.sqs-block-collectionlink .collection-more-link,
.link-block .collection-more-link {
  display: none;
  margin-left: 3px;
}

.sqs-block-collectionlink .sqs-blockStatus + .collectionlink-content,
.link-block .sqs-blockStatus + .collectionlink-content {
  display: none;
}

.sqs-block-tourdates .sqs-spin {
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -15px;
}

.sqs-widget.sqs-tourdates-bandsintown-list.loading .sqs-tourdates {
  min-height: 150px;
}

.sqs-tourdates__item:not(:last-of-type) {
  border-bottom: 1px solid rgba(130, 130, 130, 0.15);
}

.sqs-tourdates__item {
  padding: 17px 0;
}

.sqs-tourdates__item:first-of-type {
  padding-top: 0;
}

.sqs-tourdates__item,
.sqs-tourdates__venuelocation {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.sqs-tourdates--info--column .sqs-tourdates__info,
.sqs-tourdates--venuelocation--column .sqs-tourdates__venuelocation {
  flex-direction: column;
}

.sqs-tourdates__info {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
}

.sqs-tourdates__timeframe,
.sqs-tourdates__venue,
.sqs-tourdates__location {
  box-sizing: border-box;
  padding-right: 1em;
}

.sqs-tourdates__date {
  margin-right: 5px;
}

.sqs-tourdates__timeframe {
  min-width: 9em;
}

.sqs-tourdates__venuelocation {
  flex-grow: 1;
  flex-wrap: wrap;
  min-width: 10em;
}

.sqs-tourdates__venue,
.sqs-tourdates__location {
  min-width: 50%;
}

.sqs-tourdates__venueLink {
  display: block;
}

.sqs-tourdates {
  font-size: 16px;
  line-height: 28px;
}

.sqs-tourdates__timeframe {
  white-space: nowrap;
  font-size: 13px !important;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.sqs-tourdates__date,
.sqs-tourdates__weekday {
  display: inline-block;
  text-transform: uppercase;
}

.sqs-tourdates__venue-link,
.sqs-tourdates__location-link {
  color: inherit !important;
  text-decoration: none !important;
}

.sqs-tourdates__lineup {
  font-size: 14px;
  line-height: 18px;
  margin-right: 1em;
  margin-top: 2px;
  opacity: 0.6;
}

.sqs-tourdates__lineup-item {
  display: inline;
}

.sqs-tourdates__lineup-item:first-child::before {
  content: "w/ ";
}

.sqs-tourdates__lineup-item:not(:last-of-type):after {
  content: ", ";
}

.sqs-tourdates__actions {
  min-width: 150px;
  text-align: right;
  white-space: nowrap;
}

.sqs-tourdates__button {
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  display: inline-block;
  padding: 0 12px !important;
  font-size: 11px !important;
  line-height: 28px;
}

.sqs-tourdates__button:empty {
  display: none;
}

.sqs-tourdates__button--disabled.sqs-tourdates__button,
.sqs-tourdates__button--soldout.sqs-tourdates__button,
.sqs-tourdates__button--disabled.sqs-tourdates__button:hover,
.sqs-tourdates__button--soldout.sqs-tourdates__button:hover {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.social-summary-block .state-message.synchronizing {
  background-image: none;
  padding-left: 15px;
}

.social-summary-block .state-message.synchronizing .sync-text {
  float: left;
  margin-left: 10px;
}

.social-summary-block .state-message.synchronizing .spinner {
  float: left;
  /* background: transparent
    url("//assets.squarespace.com/universal/images-v6/icons/icon-settings-16-light.png")
    center center no-repeat; */
  height: 19px;
  width: 19px;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-name: spin-frames;
}

.sqs-block-spacer .sqs-block-content {
  visibility: hidden;
}

h1[data-rte-preserve-empty]:empty::before,
h2[data-rte-preserve-empty]:empty::before,
h3[data-rte-preserve-empty]:empty::before,
h4[data-rte-preserve-empty]:empty::before,
h5[data-rte-preserve-empty]:empty::before,
h6[data-rte-preserve-empty]:empty::before,
p[data-rte-preserve-empty]:empty::before {
  content: "";
  display: inline-block;
}

ol[data-rte-list] li {
  counter-increment: rte-list;
}

ol[data-rte-list] li:first-child {
  counter-reset: rte-list;
}

ul[data-rte-list] li,
ol[data-rte-list] li {
  list-style-type: none;
}

ul[data-rte-list] li > *,
ol[data-rte-list] li > * {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

ul[data-rte-list] li > *:first-child::before,
ol[data-rte-list] li > *:first-child::before {
  display: inline-block;
  margin-left: -40px;
  min-width: 40px;
  text-align: right;
  box-sizing: border-box;
}

li > *:first-child::before {
  white-space: pre;
}

ol[data-rte-list] li > *:first-child::before {
  content: "  " counter(rte-list) ". ";
}

ol[data-rte-list="upper-roman"] li > *:first-child::before {
  content: "  " counter(rte-list, upper-roman) ". ";
}

ol[data-rte-list="upper-alpha"] li > *:first-child::before {
  content: "  " counter(rte-list, upper-alpha) ". ";
}

ol[data-rte-list="lower-alpha"] li > *:first-child::before {
  content: "  " counter(rte-list, lower-alpha) ". ";
}

ol[data-rte-list="lower-roman"] li > *:first-child::before {
  content: "  " counter(rte-list, lower-roman) ". ";
}

ol[data-rte-list="decimal"] li > *:first-child::before {
  content: "  " counter(rte-list, decimal) ". ";
}

ul[data-rte-list] li > *:first-child::before {
  padding-right: 10px;
  content: "\\2022";
}

ul[data-rte-list="disc"] li > *:first-child::before {
  content: "\\2022";
}

ul[data-rte-list="circle"] li > *:first-child::before,
ul[data-rte-list] ul[data-rte-list="default"] li > *:first-child::before {
  content: "\\25CB";
}

ul[data-rte-list="square"] li > *:first-child::before,
ul[data-rte-list]
  ul[data-rte-list]
  ul[data-rte-list="default"]
  li
  > *:first-child::before {
  content: "\\25A0";
}

ul[data-rte-list="dash"] li > *:first-child::before {
  content: "-";
}

.system-button-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

body:not(.button-style-default) .sqs-editable-button,
body:not(.button-style-default) .sqs-editable-button-layout {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  border-width: 0;
  text-align: center;
  cursor: pointer;
  outline: none;
  appearance: none;
}

body:not(.button-style-default) .sqs-editable-button:hover,
body:not(.button-style-default) .sqs-editable-button-layout:hover {
  opacity: 1;
}

body:not(.button-style-default) .sqs-editable-button,
body:not(.button-style-default) .sqs-editable-button-color,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  color: #fff;
  background-color: #f0b128;
  border-color: #f0b128;
}

body:not(.button-style-default)
  .sqs-alternate-block-style-container
  .sqs-editable-button,
body:not(.button-style-default)
  .sqs-alternate-block-style-container
  .sqs-editable-button-color,
body:not(.button-style-default)
  .sqs-alternate-block-style-container
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  color: #fff;
  background-color: #272727;
  border-color: #272727;
}

body:not(.button-style-default) .sqs-editable-button,
body:not(.button-style-default) .sqs-editable-button-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: proxima-nova;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

body:not(.button-style-default).button-style-solid .sqs-editable-button,
body:not(.button-style-default).button-style-solid .sqs-editable-button-style,
body:not(.button-style-default).button-style-solid
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  transition: 0.1s opacity linear;
  -webkit-backface-visibility: hidden;
}

body:not(.button-style-default).button-style-solid .sqs-editable-button:hover,
body:not(.button-style-default).button-style-solid
  .sqs-editable-button-style:hover,
body:not(.button-style-default).button-style-solid
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:hover {
  opacity: 0.8;
}

body:not(.button-style-default).button-style-outline .sqs-editable-button,
body:not(.button-style-default).button-style-outline .sqs-editable-button-style,
body:not(.button-style-default).button-style-outline
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  border-width: 2px;
  border-style: solid;
  transition: 0.1s background-color linear, 0.1s color linear;
}

body:not(.button-style-default).button-style-outline .sqs-editable-button,
body:not(.button-style-default).button-style-outline .sqs-editable-button-color,
body:not(.button-style-default).button-style-outline
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  background-color: transparent;
  color: #f0b128;
}

body:not(.button-style-default).button-style-outline .sqs-editable-button:hover,
body:not(.button-style-default).button-style-outline
  .sqs-editable-button-color:hover,
body:not(.button-style-default).button-style-outline
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:hover {
  background-color: #f0b128;
  color: #1d1d1d;
  color: #fff;
}

body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .sqs-editable-button,
body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .sqs-editable-button-color {
  color: #272727;
}

body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .sqs-editable-button:hover,
body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .sqs-editable-button-color:hover {
  background-color: #272727;
  color: #fff;
}

body:not(.button-style-default).button-style-raised .sqs-editable-button,
body:not(.button-style-default).button-style-raised .sqs-editable-button-style,
body:not(.button-style-default).button-style-raised
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  position: relative;
  transition: 0.1s background-color linear;
}

body:not(.button-style-default).button-style-raised .sqs-editable-button:active,
body:not(.button-style-default).button-style-raised
  .sqs-editable-button-style:active,
body:not(.button-style-default).button-style-raised
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:active {
  top: 1px;
}

body:not(.button-style-default).button-style-raised .sqs-editable-button,
body:not(.button-style-default).button-style-raised .sqs-editable-button-color,
body:not(.button-style-default).button-style-raised
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  box-shadow: 0 2px 0 0 #e09e10;
}

body:not(.button-style-default).button-style-raised .sqs-editable-button:hover,
body:not(.button-style-default).button-style-raised
  .sqs-editable-button-color:hover,
body:not(.button-style-default).button-style-raised
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:hover {
  background-color: #f1b636;
}

body:not(.button-style-default).button-style-raised .sqs-editable-button:active,
body:not(.button-style-default).button-style-raised
  .sqs-editable-button-color:active,
body:not(.button-style-default).button-style-raised
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:active {
  box-shadow: 0 1px 0 0 #e09e10;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button-color,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  box-shadow: 0 2px 0 0 #131313;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button:hover,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button-color:hover,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:hover {
  background-color: #2f2f2f;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button:active,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .sqs-editable-button-color:active,
body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue:active {
  box-shadow: 0 1px 0 0 #131313;
}

body:not(.button-style-default).button-corner-style-square .sqs-editable-button,
body:not(.button-style-default).button-corner-style-square
  .sqs-editable-button-shape,
body:not(.button-style-default).button-corner-style-square
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  border-radius: 0;
}

body:not(.button-style-default).button-corner-style-rounded
  .sqs-editable-button,
body:not(.button-style-default).button-corner-style-rounded
  .sqs-editable-button-shape,
body:not(.button-style-default).button-corner-style-rounded
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  border-radius: 3px;
}

body:not(.button-style-default).button-corner-style-pill .sqs-editable-button,
body:not(.button-style-default).button-corner-style-pill
  .sqs-editable-button-shape,
body:not(.button-style-default).button-corner-style-pill
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  border-radius: 300px;
}

body:not(.button-style-default).button-style-outline
  .newsletter-block
  .newsletter-form-button {
  border-width: 1px;
  box-shadow: inset 0px 0px 0px 1px #272727;
  background: transparent;
  color: #272727;
}

body:not(.button-style-default).button-style-outline
  .newsletter-block
  .newsletter-form-button:hover {
  background-color: #272727;
  color: #fff;
}

body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-button {
  box-shadow: inset 0px 0px 0px 1px #272727;
  color: #272727;
}

body:not(.button-style-default).button-style-outline
  .sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-button:hover {
  background-color: #272727;
  color: #fff;
}

body:not(.button-style-default).button-style-raised
  .newsletter-block
  .newsletter-form-button {
  border-width: 0 !important;
  top: -1px;
  box-shadow: 0 2px 0 0 #131313;
}

body:not(.button-style-default).button-style-raised
  .newsletter-block
  .newsletter-form-button:hover {
  background-color: #2f2f2f;
}

body:not(.button-style-default).button-style-raised
  .newsletter-block
  .newsletter-form-button:active {
  top: 0px;
  box-shadow: 0 1px 0 0 #131313;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-button {
  box-shadow: 0 2px 0 0 #131313;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-button:hover {
  background-color: #2f2f2f;
}

body:not(.button-style-default).button-style-raised
  .sqs-alternate-block-style-container
  .newsletter-block
  .newsletter-form-button:active {
  box-shadow: 0 1px 0 0 #131313;
}

body:not(.button-style-default) .opentable-block .OT_Find_a_Table {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: proxima-nova;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

body:not(.button-style-default).button-corner-style-rounded
  .opentable-block
  .OT_Find_a_Table {
  border-radius: 3px;
}

body:not(.button-style-default).button-corner-style-pill
  .opentable-block
  .OT_Find_a_Table {
  border-radius: 300px;
}

body:not(.button-style-default) #productDetails .ProductItem-view-cart a,
body:not(.button-style-default) .productDetails .ProductItem-view-cart a {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: proxima-nova;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: block !important;
  border: none !important;
}

body:not(.button-style-default) #productDetails .ProductItem-view-cart a,
body:not(.button-style-default) .productDetails .ProductItem-view-cart a {
  color: #fff !important;
  background-color: rgba(240, 177, 40, 0.5) !important;
}

body:not(.button-style-default) #productDetails .ProductItem-view-cart a:hover,
body:not(.button-style-default) .productDetails .ProductItem-view-cart a:hover {
  opacity: 0.8;
}

body:not(.button-style-default) #productDetails .ProductItem-view-cart,
body:not(.button-style-default) .productDetails .ProductItem-view-cart {
  display: block !important;
  opacity: 0;
  max-height: 0;
  transition: opacity 0.5s ease-out, max-height 0.5s ease-out,
    margin 0.25s ease-out;
}

body:not(.button-style-default)
  #productDetails
  .cart-added
  + .ProductItem-view-cart,
body:not(.button-style-default)
  .productDetails
  .cart-added
  + .ProductItem-view-cart {
  margin-top: 10px;
  opacity: 1;
  max-height: 200px;
}

body:not(.button-style-default)
  .sqs-alternate-block-style-container
  .ProductItem-view-cart
  a {
  color: #fff !important;
  background-color: rgba(39, 39, 39, 0.1) !important;
  color: #272727 !important;
}

body:not(.button-style-default).button-corner-style-rounded
  #productDetails
  .ProductItem-view-cart
  a,
body:not(.button-style-default).button-corner-style-rounded
  .productDetails
  .ProductItem-view-cart
  a {
  border-radius: 3px;
}

body:not(.button-style-default).button-corner-style-pill
  #productDetails
  .ProductItem-view-cart
  a,
body:not(.button-style-default).button-corner-style-pill
  .productDetails
  .ProductItem-view-cart
  a {
  border-radius: 300px;
}

body:not(.button-style-default)
  .ma-pricing-toggle-wrapper
  .ma-pricing-options
  .left-button {
  border-radius: 300px 0px 0px 300px;
}

body:not(.button-style-default)
  .ma-pricing-toggle-wrapper
  .ma-pricing-options
  .right-button {
  border-radius: 0px 300px 300px 0px;
}

body:not(.button-style-default)
  .ma-pricing-toggle-wrapper
  .ma-pricing-options
  .sqs-editable-button.ma-pricing-option-button {
  color: #f0b128;
  border: 1px solid #f0b128;
  background-color: transparent;
}

@media (hover: hover) {
  body:not(.button-style-default)
    .ma-pricing-toggle-wrapper
    .ma-pricing-options
    .sqs-editable-button.ma-pricing-option-button:hover {
    color: #fff;
    background-color: #f0b128;
  }
}

body:not(.button-style-default)
  .ma-pricing-toggle-wrapper
  .ma-pricing-options
  .sqs-editable-button.ma-pricing-option-selected {
  color: #fff;
  background-color: #f0b128;
}

body:not(.button-style-default).button-style-outline
  .ma-pricing-toggle-wrapper
  .ma-pricing-options
  .sqs-editable-button.ma-pricing-option-button {
  border-width: 2px;
}

body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockButton-blue {
  border-width: 0;
}

body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .InlineWidgetDropDown-option,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .InlineWidgetDropDown-optionLabel,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .InlineWidgetDropDown-sectionDropdownContent
  span,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .InlineWidgetDropDown-span,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .MainLabelSpan,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .TockWidget-B2,
body:not(.button-style-default)
  .tock-block
  div#Tock_widget_container
  > div.TockWidgetWrapper
  .InlineWidgetConsumerCalendar-monthHeadingSpan {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-family: proxima-nova !important;
  font-weight: 600 !important;
  font-style: normal !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
}

body:not(.button-style-default)
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .left-button {
  border-radius: 300px 0px 0px 300px;
}

body:not(.button-style-default)
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .right-button {
  border-radius: 0px 300px 300px 0px;
}

body:not(.button-style-default)
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  color: #f0b128;
  border: 1px solid #f0b128;
  background-color: transparent;
}

@media (hover: hover) {
  body:not(.button-style-default)
    .pricing-plan-pricing-toggle-wrapper
    .pricing-plan-pricing-options
    .sqs-editable-button.pricing-plan-pricing-option-button:hover {
    color: #fff;
    background-color: #f0b128;
  }
}

body:not(.button-style-default)
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-selected {
  color: #fff;
  background-color: #f0b128;
}

body:not(.button-style-default).button-style-outline
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  border-width: 2px;
}

.announcement-bar-font {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 300;
  font-style: normal;
  letter-spacing: 1px;
  text-transform: none;
}

.sqs-announcement-bar {
  position: relative;
  top: 0;
  left: 0;
  z-index: 10000;
  text-align: center;
}

.sqs-announcement-bar-url {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sqs-announcement-bar-text {
  padding: 0.8em 3em;
}

.sqs-announcement-bar-text p {
  margin: 0;
}

.sqs-announcement-bar-text a {
  position: relative;
  text-decoration: underline !important;
}

.sqs-announcement-bar-close {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  width: 2.8em;
  height: 2.78em;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
}

.sqs-announcement-bar-close:after {
  content: "×";
  display: block;
  font-family: helvetica, arial, sans-serif;
  font-size: 1em;
  font-weight: 100;
  line-height: 2.7em;
  letter-spacing: normal;
  padding: 0;
}

.sqs-announcement-bar-hidden {
  display: none;
}

body:not(.sqs-seven-one) .sqs-announcement-bar {
  background: #222;
}

body:not(.sqs-seven-one) .sqs-announcement-bar-text {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: "proxima-nova", arial, sans-serif;
  font-size: 13px;
  font-weight: 300;
  font-style: normal;
  letter-spacing: 1px;
  text-transform: none;
  line-height: 1.2em;
}

body:not(.sqs-seven-one) .sqs-announcement-bar-text a {
  color: #fff !important;
}

body:not(.sqs-seven-one) .sqs-announcement-bar-text p {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: "proxima-nova", arial, sans-serif;
  font-size: 13px;
  font-weight: 300;
  font-style: normal;
  letter-spacing: 1px;
  text-transform: none;
  color: #fff;
  line-height: inherit;
}

body:not(.sqs-seven-one) .sqs-announcement-bar-close {
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
}

@media screen and (max-width: 1024px) {
  .sqs-announcement-bar-text,
  .sqs-announcement-bar-text p {
    font-size: 13px;
  }
}

html.touch .sqs-product-quick-view-button-wrapper {
  display: none !important;
}

.sqs-product-quick-view-button-wrapper {
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: auto;
  box-sizing: border-box;
}

.tweak-product-quick-view-button-position-top
  .sqs-product-quick-view-button-wrapper {
  align-items: flex-start;
  justify-content: center;
}

.tweak-product-quick-view-button-position-center
  .sqs-product-quick-view-button-wrapper {
  align-items: center;
  justify-content: center;
}

.tweak-product-quick-view-button-position-bottom
  .sqs-product-quick-view-button-wrapper {
  align-items: flex-end;
  justify-content: center;
  bottom: -1px;
}

.tweak-product-quick-view-button-style-floating.tweak-product-quick-view-button-position-top
  .sqs-product-quick-view-button-wrapper {
  padding-top: 1em;
}

.tweak-product-quick-view-button-style-floating.tweak-product-quick-view-button-position-bottom
  .sqs-product-quick-view-button-wrapper {
  padding-bottom: 1em;
}

.no-touch
  .sqs-product-quick-view-button-hover-area:hover
  .sqs-product-quick-view-button-wrapper
  .sqs-product-quick-view-button {
  opacity: 1;
}

.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button {
  opacity: 0;
  display: inline-block;
  position: relative;
  z-index: 6;
  width: auto;
  height: auto;
  padding: 1.5em;
  color: #fff;
  background-color: #1d1d1d;
  border-width: 0;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: opacity 0.3s ease-in;
}

.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button:focus {
  opacity: 1;
}

.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button:focus {
  outline-offset: -4px;
  outline-color: #fff;
}

.sqs-product-quick-view-button-wrapper
  .sqs-product-quick-view-button:focus:not(:focus-visible) {
  outline-color: transparent;
}

.tweak-product-quick-view-button-style-bar
  .sqs-product-quick-view-button-wrapper
  .sqs-product-quick-view-button {
  width: 100%;
}

.sqs-product-quick-view-lightbox .sqs-product-quick-view-content {
  padding: 15px;
}

.tweak-product-item-gallery-position-left
  .sqs-product-quick-view-lightbox
  .sqs-product-quick-view-content
  .ProductItem-details {
  padding: 30px 30px 30px 45px;
}

.tweak-product-item-gallery-position-right
  .sqs-product-quick-view-lightbox
  .sqs-product-quick-view-content
  .ProductItem-details {
  padding: 30px 45px 30px 30px;
}

.sqs-product-quick-view-lightbox .ProductItem-gallery {
  width: 60%;
}

.sqs-product-quick-view-lightbox .ProductItem-details {
  width: 40%;
}

.sqs-product-quick-view-lightbox a.ProductItem-details-title-link {
  border: none;
  color: inherit;
  text-decoration: none;
}

.tweak-product-quick-view-lightbox-excerpt-display-hide
  .sqs-product-quick-view-lightbox
  .ProductItem-details-excerpt {
  display: none;
}

.sqs-product-quick-view-lightbox-next-button,
.sqs-product-quick-view-lightbox-prev-button,
.sqs-product-quick-view-lightbox-close-button {
  display: block;
  border: none;
  padding: 0;
  background-color: transparent;
  position: fixed;
  width: 25px;
  height: 25px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sqs-product-quick-view-lightbox-next-button svg,
.sqs-product-quick-view-lightbox-prev-button svg,
.sqs-product-quick-view-lightbox-close-button svg {
  width: 100%;
  height: 100%;
}

.sqs-product-quick-view-lightbox-next-button line,
.sqs-product-quick-view-lightbox-prev-button line,
.sqs-product-quick-view-lightbox-close-button line,
.sqs-product-quick-view-lightbox-next-button polyline,
.sqs-product-quick-view-lightbox-prev-button polyline,
.sqs-product-quick-view-lightbox-close-button polyline {
  stroke: #1d1d1d;
}

.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-next-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-prev-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-close-button
  polyline {
  stroke-width: 2;
}

.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-next-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-prev-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-close-button
  polyline {
  stroke-width: 4;
}

.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-next-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-prev-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-close-button
  polyline {
  stroke-width: 6;
}

.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-next-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-prev-button
  polyline,
.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-close-button
  polyline {
  stroke-width: 8;
}

.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-next-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-prev-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-hairline
  .sqs-product-quick-view-lightbox-close-button
  line {
  stroke-width: 0.83333333;
}

.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-next-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-prev-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-light
  .sqs-product-quick-view-lightbox-close-button
  line {
  stroke-width: 1.66666667;
}

.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-next-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-prev-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-medium
  .sqs-product-quick-view-lightbox-close-button
  line {
  stroke-width: 2.5;
}

.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-next-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-prev-button
  line,
.tweak-product-quick-view-lightbox-controls-weight-heavy
  .sqs-product-quick-view-lightbox-close-button
  line {
  stroke-width: 3.33333333;
}

.sqs-product-quick-view-lightbox-next-button {
  top: 50%;
  transform: translatey(-50%);
  right: 12.5px;
}

body:not(.tweak-product-quick-view-lightbox-show-arrows)
  .sqs-product-quick-view-lightbox-next-button {
  opacity: 0;
}

.sqs-product-quick-view-lightbox-prev-button {
  top: 50%;
  transform: translatey(-50%);
  left: 12.5px;
}

body:not(.tweak-product-quick-view-lightbox-show-arrows)
  .sqs-product-quick-view-lightbox-prev-button {
  opacity: 0;
}

.sqs-product-quick-view-lightbox-close-button {
  top: 12.5px;
  right: 12.5px;
  width: 25px;
  z-index: 100000001;
}

.sqs-product-quick-view-lightbox-close-button svg {
  width: 80%;
  height: 80%;
}

body:not(.tweak-product-quick-view-lightbox-show-close-button)
  .sqs-product-quick-view-lightbox-close-button {
  opacity: 0;
}

.sqs-product-quick-view-lightbox-element-hidden {
  opacity: 0;
  visibility: hidden;
  cursor: default;
}

.sqs-style-mode-active
  .sqs-product-quick-view-lightbox
  .sqs-product-quick-view {
  pointer-events: none;
  cursor: not-allowed;
  cursor: no-drop;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox {
  visibility: visible;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox
  .sqs-modal-lightbox-content
  .lightbox-background {
  background: rgba(240, 240, 240, 0.6) !important;
  opacity: 1;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox
  .sqs-modal-lightbox-content
  .lightbox-inner
  .lightbox-content {
  width: 85%;
  max-width: 900px;
  padding: 0px;
  background: #fff !important;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox
  .sqs-modal-lightbox-content
  .lightbox-inner
  .lightbox-content
  .lightbox-close {
  display: none;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox
  ~ .sqs-widgets-confirmation {
  z-index: 100000001;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox[hidden] {
  visibility: hidden;
  display: block !important;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox[hidden]
  .sqs-modal-lightbox-content {
  left: -9999px;
  opacity: 0;
  transition: none;
}

.sqs-product-quick-view-lightbox.sqs-modal-lightbox
  .sqs-modal-lightbox-content {
  transition: opacity 0.15s ease-out;
}

.sqs-layout .html-block.sqs-block img {
  max-width: 100%;
  height: auto;
}

.sqs-layout .html-block.sqs-block img[align="left"] {
  margin-right: 50px;
}

.sqs-layout .html-block.sqs-block img[align="right"] {
  margin-left: 50px;
}

.sqs-layout .html-block.sqs-block img[align="top"] {
  vertical-align: top;
}

.sqs-layout .html-block.sqs-block img[align="middle"] {
  vertical-align: middle;
}

.sqs-layout .html-block.sqs-block img[align="bottom"] {
  vertical-align: bottom;
}

.sqs-layout .html-block.sqs-block .full-image-float-left,
.sqs-layout .html-block.sqs-block .thumbnail-image-float-left {
  float: left;
  margin-right: 50px;
}

.sqs-layout .html-block.sqs-block .full-image-float-right,
.sqs-layout .html-block.sqs-block .thumbnail-image-float-right {
  float: right;
  margin-left: 50px;
}

.sqs-layout .html-block.sqs-block .full-image-block {
  display: block;
  margin-bottom: 34px;
}

.sqs-layout .html-block.sqs-block div[data-src="v5"] img {
  max-width: 100%;
}

.sqs-layout .html-block.sqs-block .thumbnail-caption {
  display: block;
}

.sqs-layout .html-block.sqs-block .entry-content img {
  margin: 0 0 34px 0;
}

.sqs-layout .html-block.sqs-block .alignleft,
.sqs-layout .html-block.sqs-block img.alignleft {
  margin-right: 50px;
  display: inline;
  float: left;
  width: auto;
}

.sqs-layout .html-block.sqs-block .alignright,
.sqs-layout .html-block.sqs-block img.alignright {
  margin-left: 50px;
  display: inline;
  float: right;
  width: auto;
}

.sqs-layout .html-block.sqs-block .aligncenter,
.sqs-layout .html-block.sqs-block img.aligncenter {
  margin-right: auto;
  margin-left: auto;
  display: block;
  clear: both;
  width: auto;
}

.sqs-layout .html-block.sqs-block blockquote.left {
  margin-right: 50px;
  text-align: right;
  margin-left: 0;
  width: 33%;
  float: left;
}

.sqs-layout .html-block.sqs-block blockquote.right {
  margin-left: 50px;
  text-align: left;
  margin-right: 0;
  width: 33%;
  float: right;
}

[data-test="paywall-page-root"] {
  text-align: center;
  margin: auto;
}

[data-test="paywall-page-root"] .paywall-preview-hidden {
  visibility: hidden;
}

[data-test="paywall-page-root"] #headline {
  margin: 11px;
  overflow-wrap: break-spaces;
}

[data-test="paywall-page-root"] #description {
  margin: 0;
}

[data-test="paywall-page-root"] #error {
  margin-top: 44px;
}

[data-test="paywall-page-root"] .product-blocks-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 28px;
}

[data-test="paywall-page-root"] .product-blocks-container:has(> :nth-child(4)) {
  justify-content: flex-start;
}

[data-test="paywall-page-root"] .product-blocks-container .product-block {
  min-height: 44px;
  width: 380px;
  margin: 16px;
  padding: 22px;
  border: 1px solid;
  border-radius: 10px;
}

[data-test="paywall-page-root"] .product-blocks-container .product-block .hide,
[data-test="paywall-page-root"]
  .product-blocks-container
  .product-block
  .join-button.hide {
  display: none;
}

[data-test="paywall-page-root"] .see-more-text,
[data-test="paywall-page-root"] .see-less-text {
  text-align: left;
  display: none;
  cursor: pointer;
  text-decoration: underline;
}

[data-test="paywall-page-root"] .see-more-node .see-more-text,
[data-test="paywall-page-root"] .see-less-node .see-less-text {
  display: block;
}

[data-test="paywall-page-root"] .sign-in-button {
  display: inline-block;
  margin: 11px 0 5px 0;
  cursor: pointer;
  border: none;
  padding: 0;
  color: inherit;
  background-color: transparent;
}

[data-test="paywall-page-root"] .pricing-plan-pricing-toggle-wrapper {
  display: flex;
  justify-content: center;
}

[data-test="paywall-page-root"] .pricing-plan-pricing-options {
  display: grid;
  display: -ms-grid;
  grid-template-columns: repeat(2, 1fr);
  -ms-grid-columns: 1fr 1fr;
  list-style-type: none;
  padding: 0px;
  margin: 0px;
}

[data-test="paywall-page-root"]
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  width: 100%;
  height: 100%;
  padding: 0.6em 1.1em !important;
  text-align: center;
  border-radius: 0px;
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

@media (hover: hover) {
  [data-test="paywall-page-root"]
    .pricing-plan-pricing-options
    .sqs-editable-button.pricing-plan-pricing-option-button:hover {
    opacity: 1;
    color: #fff;
    background-color: #272727;
  }
}

[data-test="paywall-page-root"]
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-selected {
  color: #fff;
  background-color: #272727;
}

[data-test="paywall-page-root"] .pricing-plan-pricing-options .left-option {
  -ms-grid-column: 1;
}

[data-test="paywall-page-root"] .pricing-plan-pricing-options .right-option {
  -ms-grid-column: 2;
}

[data-test="paywall-page-root"] .below-pricing-toggle {
  margin-top: 33px;
}

[data-test="paywall-page-root"] .pricing-plan-benefits-divider {
  margin-top: 22px;
  margin-bottom: 22px;
}

[data-test="paywall-page-root"]
  .pricing-plan-benefit-description:not(:last-child) {
  margin-bottom: 6px;
}

[data-test="paywall-page-root"]
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.left-button {
  border-radius: 300px 0px 0px 300px;
}

[data-test="paywall-page-root"]
  .pricing-plan-pricing-toggle-wrapper
  .pricing-plan-pricing-options
  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.right-button {
  border-radius: 0px 300px 300px 0px;
}

[data-test="paywall-page-root"]
  .primary-button-style-outline
  .sqs-block-pricing-plan
  .pricing-plan-pricing-options
  .sqs-editable-button.pricing-plan-pricing-option-button {
  border-width: 2px;
}

[data-test="paywall-page-root"]
  .productDetails
  div.product-title.pricing-plan-title {
  font-size: 1.5em;
  margin-top: 0;
  margin-bottom: 11px;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  line-height: normal;
}

[data-test="paywall-page-root"]
  .paywall-pricing-aligner
  .no-pricing-options-aligner {
  height: 48px;
}

[data-test="paywall-page-root"]
  .paywall-pricing-aligner
  .productDetails
  div.product-title.pricing-plan-title {
  margin-top: 33px;
}

[data-test="paywall-page-root"] .pricing-plan-price-amount {
  font-size: 2em;
  margin-top: 11px;
  line-height: 90%;
}

[data-test="paywall-page-root"] .pricing-plan-price-amount.non-paywalled {
  margin-bottom: 61px;
}

[data-test="paywall-page-root"] .pricing-plan-price-billing-period {
  font-size: 1em;
  opacity: 0.75;
  margin-bottom: 22px;
  margin-top: 11px;
}

[data-test="paywall-page-root"]
  .product-block
  .productDetails
  .product-price.pricing-plan-product-price {
  margin: 0 0 12px 0;
  line-height: normal;
}

[data-test="paywall-page-root"]
  .product-block
  .productDetails
  .product-price.pricing-plan-product-price.below-pricing-toggle {
  margin-top: 33px;
}

[data-test="paywall-page-root"] .pricing-plan-description {
  margin: 22px 0 0 0;
  line-height: normal;
  font-size: 1em;
  text-align: left;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

[data-test="paywall-page-root"] .see-less-node .pricing-plan-description {
  -webkit-line-clamp: inherit;
  display: block;
}

.product-block .sqs-editable-button {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 1em 2.5em;
  color: #fff;
  background-color: #272727;
  border-width: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1em;
  font-weight: normal;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
}

@media all and (max-width: 414px) {
  [data-test="paywall-page-root"] {
    width: 350px;
  }
}
@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Ysabeau Office";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
  font-display: swap;
}


.social-smugmug:before,
.social-dribbble:before,
.social-youtube:before,
.social-vimeo:before,
.social-twitter:before,
.social-tumblr:before,
.social-pinterest:before,
.social-linkedin:before,
.social-instagram:before,
.social-google:before,
.social-foursquare:before,
.social-flickr:before,
.social-facebook:before,
.social-fivehundredpix:before,
.social-fivehundredpx:before,
.social-email:before,
.social-github:before,
.social-rss:before,
.social-spotify:before,
.social-soundcloud:before,
.social-itunes:before,
.social-googleplay:before,
.social-dropbox:before,
.social-dropbox2017:before,
.social-bandsintown:before,
.social-behance:before,
.social-codepen:before,
.social-medium:before,
.social-rdio:before,
.social-squarespace:before,
.social-vine:before,
.social-yelp:before,
.social-vevo:before,
.social-meetup:before,
.social-twitch:before,
.social-vsco:before,
.social-smugmug-square:before,
.social-dribbble-square:before,
.social-youtube-square:before,
.social-vimeo-square:before,
.social-twitter-square:before,
.social-tumblr-square:before,
.social-pinterest-square:before,
.social-linkedin-square:before,
.social-instagram-square:before,
.social-google-square:before,
.social-foursquare-square:before,
.social-flickr-square:before,
.social-facebook-square:before,
.social-fivehundredpix-square:before,
.social-fivehundredpx-square:before,
.social-email-square:before,
.social-github-square:before,
.social-rss-square:before,
.social-spotify-square:before,
.social-soundcloud-square:before,
.social-itunes-square:before,
.social-googleplay-square:before,
.social-dropbox-square:before,
.social-dropbox2017-square:before,
.social-bandsintown-square:before,
.social-behance-square:before,
.social-codepen-square:before,
.social-medium-square:before,
.social-rdio-square:before,
.social-squarespace-square:before,
.social-vine-square:before,
.social-yelp-square:before,
.social-vevo-square:before,
.social-meetup-square:before,
.social-twitch-square:before,
.social-vsco-square:before,
.social-smugmug-round:before,
.social-dribbble-round:before,
.social-youtube-round:before,
.social-vimeo-round:before,
.social-twitter-round:before,
.social-tumblr-round:before,
.social-pinterest-round:before,
.social-linkedin-round:before,
.social-instagram-round:before,
.social-google-round:before,
.social-foursquare-round:before,
.social-flickr-round:before,
.social-facebook-round:before,
.social-fivehundredpix-round:before,
.social-fivehundredpx-round:before,
.social-email-round:before,
.social-github-round:before,
.social-rss-round:before,
.social-spotify-round:before,
.social-soundcloud-round:before,
.social-itunes-round:before,
.social-googleplay-round:before,
.social-dropbox-round:before,
.social-dropbox2017-round:before,
.social-bandsintown-round:before,
.social-behance-round:before,
.social-codepen-round:before,
.social-medium-round:before,
.social-rdio-round:before,
.social-squarespace-round:before,
.social-vine-round:before,
.social-yelp-round:before,
.social-vevo-round:before,
.social-meetup-round:before,
.social-twitch-round:before,
.social-vsco-round:before {
  font-family: "social-icon-font";
  speak: none;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.social-smugmug:before {
  content: "\\e600";
}

.social-icon-style-square .social-smugmug:before {
  content: "\\e601";
}

.social-icon-style-round .social-smugmug:before {
  content: "\\e602";
}

.social-dribbble:before {
  content: "\\e603";
}

.social-icon-style-square .social-dribbble:before {
  content: "\\e604";
}

.social-icon-style-round .social-dribbble:before {
  content: "\\e605";
}

.social-youtube:before {
  content: "\\e606";
}

.social-icon-style-square .social-youtube:before {
  content: "\\e607";
}

.social-icon-style-round .social-youtube:before {
  content: "\\e608";
}

.social-vimeo:before {
  content: "\\e609";
}

.social-icon-style-square .social-vimeo:before {
  content: "\\e60a";
}

.social-icon-style-round .social-vimeo:before {
  content: "\\e60b";
}

.social-twitter:before {
  content: "\\e60c";
}

.social-icon-style-square .social-twitter:before {
  content: "\\e60d";
}

.social-icon-style-round .social-twitter:before {
  content: "\\e60e";
}

.social-tumblr:before {
  content: "\\e60f";
}

.social-icon-style-square .social-tumblr:before {
  content: "\\e610";
}

.social-icon-style-round .social-tumblr:before {
  content: "\\e611";
}

.social-pinterest:before {
  content: "\\e612";
}

.social-icon-style-square .social-pinterest:before {
  content: "\\e613";
}

.social-icon-style-round .social-pinterest:before {
  content: "\\e614";
}

.social-linkedin:before {
  content: "\\e615";
}

.social-icon-style-square .social-linkedin:before {
  content: "\\e616";
}

.social-icon-style-round .social-linkedin:before {
  content: "\\e617";
}

.social-instagram:before {
  content: "\\e618";
}

.social-icon-style-square .social-instagram:before {
  content: "\\e619";
}

.social-icon-style-round .social-instagram:before {
  content: "\\e61a";
}

.social-foursquare:before {
  content: "\\e61e";
}

.social-icon-style-square .social-foursquare:before {
  content: "\\e61f";
}

.social-icon-style-round .social-foursquare:before {
  content: "\\e620";
}

.social-flickr:before {
  content: "\\e621";
}

.social-icon-style-square .social-flickr:before {
  content: "\\e622";
}

.social-icon-style-round .social-flickr:before {
  content: "\\e623";
}

.social-facebook:before {
  content: "\\e624";
}

.social-icon-style-square .social-facebook:before {
  content: "\\e625";
}

.social-icon-style-round .social-facebook:before {
  content: "\\e626";
}

.social-fivehundredpix:before {
  content: "\\e627";
}

.social-icon-style-square .social-fivehundredpix:before {
  content: "\\e628";
}

.social-icon-style-round .social-fivehundredpix:before {
  content: "\\e629";
}

.social-fivehundredpx:before {
  content: "\\e627";
}

.social-icon-style-square .social-fivehundredpx:before {
  content: "\\e628";
}

.social-icon-style-round .social-fivehundredpx:before {
  content: "\\e629";
}

.social-email:before {
  content: "\\e62a";
}

.social-icon-style-square .social-email:before {
  content: "\\e62b";
}

.social-icon-style-round .social-email:before {
  content: "\\e62c";
}

.social-github:before {
  content: "\\e62d";
}

.social-icon-style-square .social-github:before {
  content: "\\e62e";
}

.social-icon-style-round .social-github:before {
  content: "\\e62f";
}

.social-rss:before {
  content: "\\e630";
}

.social-icon-style-square .social-rss:before {
  content: "\\e631";
}

.social-icon-style-round .social-rss:before {
  content: "\\e632";
}

.social-spotify:before {
  content: "\\e633";
}

.social-icon-style-square .social-spotify:before {
  content: "\\e634";
}

.social-icon-style-round .social-spotify:before {
  content: "\\e635";
}

.social-soundcloud:before {
  content: "\\e636";
}

.social-icon-style-square .social-soundcloud:before {
  content: "\\e637";
}

.social-icon-style-round .social-soundcloud:before {
  content: "\\e638";
}

.social-itunes:before {
  content: "\\e639";
}

.social-icon-style-square .social-itunes:before {
  content: "\\e63a";
}

.social-icon-style-round .social-itunes:before {
  content: "\\e63b";
}

.social-googleplay:before {
  content: "\\e63c";
}

.social-icon-style-square .social-googleplay:before {
  content: "\\e63d";
}

.social-icon-style-round .social-googleplay:before {
  content: "\\e63e";
}

.social-dropbox:before {
  content: "\\e63f";
}

.social-icon-style-square .social-dropbox:before {
  content: "\\e640";
}

.social-icon-style-round .social-dropbox:before {
  content: "\\e641";
}

.social-dropbox2017:before {
  content: "\\e63f";
}

.social-icon-style-square .social-dropbox2017:before {
  content: "\\e640";
}

.social-icon-style-round .social-dropbox2017:before {
  content: "\\e641";
}

.social-bandsintown:before {
  content: "\\e642";
}

.social-icon-style-square .social-bandsintown:before {
  content: "\\e643";
}

.social-icon-style-round .social-bandsintown:before {
  content: "\\e644";
}

.social-behance:before {
  content: "\\e645";
}

.social-icon-style-square .social-behance:before {
  content: "\\e646";
}

.social-icon-style-round .social-behance:before {
  content: "\\e647";
}

.social-codepen:before {
  content: "\\e648";
}

.social-icon-style-square .social-codepen:before {
  content: "\\e649";
}

.social-icon-style-round .social-codepen:before {
  content: "\\e64a";
}

.social-medium:before {
  content: "\\e64b";
}

.social-icon-style-square .social-medium:before {
  content: "\\e64c";
}

.social-icon-style-round .social-medium:before {
  content: "\\e64d";
}

.social-rdio:before {
  content: "\\e64e";
}

.social-icon-style-square .social-rdio:before {
  content: "\\e64f";
}

.social-icon-style-round .social-rdio:before {
  content: "\\e650";
}

.social-squarespace:before {
  content: "\\e651";
}

.social-icon-style-square .social-squarespace:before {
  content: "\\e652";
}

.social-icon-style-round .social-squarespace:before {
  content: "\\e653";
}

.social-vine:before {
  content: "\\e654";
}

.social-icon-style-square .social-vine:before {
  content: "\\e655";
}

.social-icon-style-round .social-vine:before {
  content: "\\e656";
}

.social-yelp:before {
  content: "\\e657";
}

.social-icon-style-square .social-yelp:before {
  content: "\\e658";
}

.social-icon-style-round .social-yelp:before {
  content: "\\e659";
}

.social-meetup:before {
  content: "\\e65a";
}

.social-icon-style-square .social-meetup:before {
  content: "\\e65b";
}

.social-icon-style-round .social-meetup:before {
  content: "\\e65c";
}

.social-vevo:before {
  content: "\\e65d";
}

.social-icon-style-square .social-vevo:before {
  content: "\\e65e";
}

.social-icon-style-round .social-vevo:before {
  content: "\\e65f";
}

.social-twitch:before {
  content: "\\e660";
}

.social-icon-style-square .social-twitch:before {
  content: "\\e661";
}

.social-icon-style-round .social-twitch:before {
  content: "\\e662";
}

.social-vsco:before {
  content: "\\e663";
}

.social-icon-style-square .social-vsco:before {
  content: "\\e664";
}

.social-icon-style-round .social-vsco:before {
  content: "\\e665";
}

.tweak-product-quick-view-button-font {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.sqs-product-quick-view-button-wrapper {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.logo-font {
  font-family: "Droid Serif", georgia, serif;
  font-size: 50px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1em;
  text-align: center;
  text-transform: none;
}

.site-tagline-font {
  font-family: georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1em;
  text-align: center;
  text-transform: none;
}

.nav-font {
  font-family: "Varela";
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 2px;
  line-height: 5em;
  text-align: center;
  text-transform: uppercase;
}

.header-bg {
  background-image: url("http://static.squarespace.com/static/508475bee4b0f4598aa96c7c/t/5182d0e6e4b065e39b3b546a/1367527654606/devlin-header.jpg");
  background-position: top center;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.h1-font {
  font-family: "Droid Serif", georgia, serif;
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1.25em;
  text-transform: none;
}

.h2-font {
  font-family: "Droid Serif", georgia, serif;
  font-size: 21px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1.25em;
  text-transform: none;
}

.h3-font {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1.25em;
  text-transform: none;
}

.body-font {
  font-family: georgia, serif;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 2em;
  text-align: left;
  text-transform: none;
}

.quote-font {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1.75em;
  text-transform: none;
}

.summary-heading-font {
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.antialiased {
  -moz-font-smoothing: antialiased;
  -o-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
}

.beat-none {
  -moz-animation: none;
  -moz-animation-timing-function: none;
  -o-animation: none;
  -o-animation-timing-function: none;
  -webkit-animation: none;
  -webkit-animation-timing-function: none;
  animation: none;
  animation-timing-function: none;
}

.box-shadow-none {
  -o-box-shadow: none;
  box-shadow: none;
}

.display-inline-block {
  display: inline-block;
  display: inline;
  zoom: 1;
}

.ease-dropdown {
  transition: max-height 0.1s ease-in;
}

.ease-none {
  transition: none;
}

.flip-horizontal {
  transform: scalex(-1);
  filter: fliph;
}

.form-font {
  font-family: verdana, helvetica, arial, sans-serif;
}

.radius-none {
  border-radius: 0;
}

.txtarea {
  border-radius: 0;
  font-family: georgia, serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 2em;
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
  -o-box-shadow: none;
  box-shadow: none;
  padding: 8px;
  border: 1px solid #f0b128;
}

body {
  font-family: georgia, serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 2em;
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
  color: #666;
}

body .standard-dialog-wrapper,
body .font-family-list-container {
  text-align: left;
}

body.no-scroll {
  width: 100%;
}

#header > .wrapper {
  position: relative;
}

#header > .wrapper .primary-image {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -1px;
  left: 0;
  z-index: -1;
  background-color: #333;
}

#header > .wrapper .primary-image.default {
  background-image: url("http://static.squarespace.com/static/508475bee4b0f4598aa96c7c/t/5182d0e6e4b065e39b3b546a/1367527654606/devlin-header.jpg");
  background-position: top center;
  background-repeat: no-repeat;
  background-image: url("https://static.squarespace.com/static/5416a926e4b09de8832655bc/t/5453261fe4b00dd647c7386b/1414735391913/Wafer1-Wide-Grey.png");
  background-position: center center;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: repeat;
}

#header #logo {
  display: block;
  padding: 46px 50px;
  margin: 0 auto;
  max-width: 1020px;
}

#header #logo h1.site-title {
  margin-bottom: 0;
  text-align: center;
}

#header #logo .site-title-border {
  height: 10px;
}

#header #logo .site-title-span {
  border-top: 6px solid rgba(0, 0, 0, 0);
  color: #fff;
  display: inline-block;
  font-family: "Droid Serif", georgia, serif;
  font-size: 50px;
  font-weight: normal;
  letter-spacing: 0px;
  text-transform: none;
  font-family: Raleway;
  font-size: 100px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 4px;
  line-height: 1em;
  text-align: center;
  text-transform: uppercase;
}

#header #logo .site-title-span:hover {
  color: #f4f4f3;
}

#header #logo .site-tagline h2 {
  font-family: georgia, serif;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0px;
  font-family: Raleway;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1em;
  text-align: center;
  text-transform: none;
  color: #fff;
  margin-bottom: 0;
}

#header #logo .site-tagline .spacer {
  height: 18px;
}

#header #logo.logo-image .site-title-span {
  display: none;
}

#header #logo.logo-image img {
  height: 55px;
  line-height: 0;
}

.mobile-nav,
.show-nav {
  display: none;
}

.primary-nav {
  background-color: #fff;
}

.primary-nav .nav {
  font-family: "Varela";
  font-size: 12px;
  font-weight: normal;
  line-height: 5em;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 2px;
  line-height: 3.4em;
  text-align: center;
  text-transform: uppercase;
  margin: 0 auto;
  padding: 0 50px;
  max-width: 1020px;
}

.primary-nav .nav li {
  display: inline-block;
  display: inline;
  position: relative;
  zoom: 1;
  margin: 0 12px;
}

.primary-nav .nav li a {
  color: #636363;
  font-weight: 400;
}

.primary-nav .nav li a:hover {
  color: #27c7ff;
}

.primary-nav .nav li a.active {
  color: #27c7ff;
}

.primary-nav .folder-wrapper {
  cursor: pointer;
}

.primary-nav .folder-links-wrapper {
  transition: max-height 0.1s ease-in;
  top: -18px;
  left: 0;
  overflow: hidden;
  position: absolute;
  max-height: 0;
  padding: 0 2em;
  margin: 3.4em 0 0 -2em;
  background-color: #fff;
  z-index: 9999;
}

.primary-nav .folder-links-wrapper li {
  display: block;
  text-align: left;
  line-height: 1em;
  margin: 0;
  padding-bottom: 2em;
}

.primary-nav .folder-links-wrapper li:first-child {
  padding-top: 1em;
}

.primary-nav .folder-wrapper:hover .folder-links-wrapper,
.primary-nav .folder-wrapper:active .folder-links-wrapper {
  max-height: 9999px;
}

.mobile-nav .folder-links-wrapper {
  display: none;
}

.folder-nav,
.category-nav {
  background-color: #f5f5f5;
}

.folder-nav .nav,
.category-nav .nav {
  font-family: "Varela";
  font-size: 12px;
  font-weight: normal;
  line-height: 5em;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 2px;
  line-height: 3.4em;
  text-align: center;
  text-transform: uppercase;
  margin: 0 auto;
  padding: 0 50px;
  max-width: 1020px;
}

.folder-nav .nav li,
.category-nav .nav li {
  display: inline-block;
  display: inline;
  zoom: 1;
  margin: 0 12px;
}

.folder-nav .nav li a,
.category-nav .nav li a {
  color: #000;
  font-weight: 400;
}

.folder-nav .nav li a:hover,
.category-nav .nav li a:hover {
  color: #15508a;
}

.folder-nav .nav li a.active,
.category-nav .nav li a.active {
  color: #27c7ff;
}

#site {
  background-color: #fff;
  padding: 25px 0;
}

#site > .wrapper {
  max-width: 1020px;
  padding: 0 50px;
  margin: 0 auto;
  position: relative;
}

a {
  text-decoration: none;
}

a:link,
a:visited {
  color: #15508a;
}

a:hover {
  color: #555;
}

b,
strong {
  font-weight: 600;
}

blockquote,
.quote-block blockquote {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-weight: normal;
  line-height: 1.75em;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.4px;
  text-transform: none;
  color: #777;
  padding: 0 0 0 50px;
  margin: 50px 0;
  border-left: 1px solid #f0b128;
}

blockquote span,
.quote-block blockquote span {
  display: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 0 0.5em;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
  font-weight: normal;
}

h1 {
   font-family: "Ysabeau Office", sans-serif;
  font-size: 24px;
  font-weight: normal;
  line-height: 1.25em;
  font-size: 30px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.2em;
  text-transform: none;
  color: #000;
}

h2 {
  font-family: "Ysabeau Office", sans-serif;
  font-size: 21px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1.25em;
  text-transform: none;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1em;
  text-transform: uppercase;
  color: #f0b128;
}

h3,
h4,
h5,
h6 {
   font-family: "Ysabeau Office", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.25em;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.4em;
  text-transform: none;
  color: #444;
}

ul,
ol {
  margin-bottom: 1em;
}

ul li,
ol li {
  margin-left: 30px;
}

.homepage .sqs-block.image-block .image-caption-wrapper p {
  font-size: 17px;
}

.homepage .sqs-block.image-block .sqs-block-content a {
  color: #666;
}

.homepage
  .sqs-block.image-block
  .image-block-outer-wrapper.layout-caption-below
  .image-caption-wrapper {
  margin: 1em 0 0;
}

.calendar-block .date-has-event {
  color: #15508a;
}

.sqs-block-horizontalrule hr {
  border-style: none;
  border-width: 0;
  border-top: 1px solid #f0b128;
  background-color: transparent;
  height: 0;
}

.image-block {
  position: relative;
}

.image-block .image-caption-wrapper p {
  font-size: 15px;
  line-height: 1.5em;
}

.quote-block blockquote {
  padding: 0;
  margin: 0;
  border-left: 0;
}

.quote-block .source {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-weight: normal;
  line-height: 1.75em;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.4px;
  text-transform: none;
  margin: 0;
  text-align: right;
}

.link-block .sqs-link a,
.postsbytag-block li a,
.postsbymonth-block li a,
.postsbyauthor-block li a,
.postsbycategory-block li a,
.collectionlink-block .collectionlink-title a {
  padding: 0.25rem 0.4rem;
  display: block;
  line-height: 2.5em;
  font-size: 15px;
  border-bottom: 1px solid #e3e3e3;
}

li.gridRendering {
  border: 1px solid #aaa;
}

li.gridRendering div.name {
  line-height: 1.4em;
}

.link-block .sqs-link a:hover,
.postsbytag-block li a:hover,
.postsbymonth-block li a:hover,
.postsbyauthor-block li a:hover,
.postsbycategory-block li a:hover,
.collectionlink-block .collectionlink-title a:hover,
li.gridRendering a:hover {
  border: 1px solid #f7f7f7;
  background-color: #e0e0e0;
  color: #555;
}

.collectionlink-block .collectionlink-title {
  font-family: Bitter;
  margin-bottom: 0;
  border-bottom: 1px solid #f0b128;
}

.collectionlink-block .collectionlink-title a {
  font-weight: 600;
  line-height: 1.5em;
}

.collectionlink-block .collectionlink-title:hover {
  border-color: #f7f7f7;
  background-color: #f7f7f7;
}

.collectionlink-block .collectionlink-title:hover a {
  color: #555;
}

.postsbytag-block li a {
  text-transform: lowercase;
}

.postsbytag-block li a:before {
  content: "#";
}

.summary-block .summary-item {
  margin-bottom: 36px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0b128;
}

.summary-block .summary-item:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
  border-bottom: none;
}

.summary-block .summary-title {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.25em;
  font-family: "Georgia", "serif";
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.4em;
  text-transform: none;
}

.summary-block .timestamp {
  font-size: 14px;
  text-transform: none;
}

.tagcloud-block ul li {
  margin-left: 0;
  margin-right: 1em;
}

.tagcloud-block ul li a {
  font-weight: normal;
  font-weight: 400;
}

.category-nav {
  display: none;
}

.collection-type-products.show-products-category-navigation .category-nav {
  display: block;
}

.absolute-cart-box {
  top: auto;
  right: 15px;
  bottom: 75px;
}

.absolute-cart-box .sqs-pill-shopping-cart .cart {
  min-width: 200px;
}

#productNav {
  text-transform: capitalize;
  margin-bottom: 1em;
}

.sqs-pill-shopping-cart-content {
  text-align: left;
}

#productList .product .product-title {
  font-size: inherit;
}

.collection-type-blog h1.post-title {
  margin-bottom: 1em;
}

.collection-type-blog h1.post-title a {
  color: #f0b128;
  font-weight: 500;
}

.collection-type-blog .item .entry {
  padding-bottom: 50px;
}

.collection-type-blog .list .entry {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #f0b128;
}

.collection-type-blog .list .entry:last-of-type {
  margin-bottom: 0;
  border-bottom: none;
}

.collection-type-blog .list.no-pagination .entry:last-of-type {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.collection-type-blog .entry-content {
  clear: both;
}

.collection-type-blog .entry-source {
  margin-top: 1em;
}

.collection-type-blog .entry .details {
  color: #999;
}

.collection-type-blog .entry .details a:link,
.collection-type-blog .entry .details a:visited {
  color: #999;
}

.collection-type-blog .entry .details a:hover {
  color: #555;
}

.collection-type-blog .entry .details .post-tags a {
  text-transform: lowercase;
}

.collection-type-blog .entry .details .post-tags a:before {
  content: "#";
}

.collection-type-blog .entry .details .social {
  vertical-align: middle;
  margin-top: 10px;
}

.collection-type-blog .entry .details .sqs-simple-like {
  font-family: georgia, serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 2em;
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
}

.collection-type-blog .entry .details .sqs-simple-like .like-icon {
  transition: none;
  border-radius: 0;
  width: auto;
  height: auto;
  background-image: none;
  background-color: rgba(0, 0, 0, 0);
}

.collection-type-blog .entry .details .sqs-simple-like .like-icon:before {
  font-family: FontAwesome;
  font-size: 18px;
  line-height: 18px;
  content: "\\f08a";
}

.collection-type-blog .entry .details .sqs-simple-like:hover .like-icon,
.collection-type-blog .entry .details .sqs-simple-like.clicked .like-icon {
  -moz-animation: none;
  -moz-animation-timing-function: none;
  -o-animation: none;
  -o-animation-timing-function: none;
  -webkit-animation: none;
  -webkit-animation-timing-function: none;
  animation: none;
  animation-timing-function: none;
  transition: none;
}

.collection-type-blog
  .entry
  .details
  .squarespace-social-buttons.inline-style
  .ss-social-button-icon {
  display: none;
}

.collection-type-blog .sqs-simple-like.float {
  display: none !important;
}

.collection-type-blog .filter {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.25em;
  font-family: "Georgia", "serif";
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.4em;
  text-transform: none;
  margin-bottom: 30px;
  padding-bottom: 50px;
  border-bottom: 1px solid #f0b128;
}

.collection-type-blog .credit:before,
.collection-type-blog .sqs-comments:before,
.collection-type-blog .ss-social-button:before {
  content: "";
  margin-left: 7.5px;
  padding-left: 7.5px;
  border-left: 1px solid #f0b128;
}

.entry-injection {
  clear: both;
}

.pagination {
  padding: 1.5em 0.5em;
  border-top: 1px solid #f0b128;
  border-bottom: 1px solid #f0b128;
  color: #999;
}

.pagination a {
  color: #666;
}

.list .pagination .index {
  float: right;
  width: 50%;
  text-align: right;
  color: #999;
}

.squarespace-comments {
  clear: both;
  margin: 0;
  padding-top: 50px;
}

.squarespace-comments .header-controls .controls .comment-count {
  font-size: 15px;
}

.squarespace-comments .new-comment-area {
  border-radius: 0;
  font-family: georgia, serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 2em;
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
  -o-box-shadow: none;
  box-shadow: none;
  padding: 8px;
  border: 1px solid #f0b128;
}

.squarespace-comments .new-comment-area .input form.comment-form textarea {
  font-family: georgia, serif;
  font-size: 13px;
  font-weight: normal;
  line-height: 2em;
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
}

.squarespace-comments .new-comment-area .input,
.squarespace-comments .new-comment-area input,
.squarespace-comments .new-comment-area textarea {
  border-radius: 0;
  border: none;
  background-color: rgba(0, 0, 0, 0);
}

.squarespace-comments .new-comment-area .comment-btn-wrapper {
  border-radius: 0;
  border: none;
}

.squarespace-comments .comments-content .comment-list .comment {
  margin: 0 10px;
  padding: 0;
  border-top: 1px solid #f0b128;
}

.squarespace-comments .comments-content .comment-list .comment:first-child {
  border-top: none;
}

.squarespace-comments
  .comments-content
  .comment-list
  .comment:first-child
  .comment-header {
  border-top: none;
}

.squarespace-comments .comments-content .comment-list .comment .comment-header {
  min-height: 15px;
  overflow: visible;
  padding: 62.5px 0 0 55px;
}

.squarespace-comments
  .comments-content
  .comment-list
  .comment
  .comment-header
  .user-info
  .avatar {
  width: 40px;
  height: 40px;
  margin-top: 3.75px;
  margin-left: -55px;
}

.squarespace-comments
  .comments-content
  .comment-list
  .comment
  .comment-header
  .user-info
  .author {
  font-size: 15px;
  margin-right: 0;
  line-height: 1em;
}

.squarespace-comments
  .comments-content
  .comment-list
  .comment
  .comment-header
  .user-info
  .date {
  font-size: 15px;
  line-height: 1em;
}

.squarespace-comments
  .comments-content
  .comment-list
  .comment
  .comment-header
  .user-info
  .date:before {
  content: "wrote, ";
}

.squarespace-comments .comments-content .comment-list .comment .comment-body {
  padding: 1em 0 62.5px 55px;
  color: grey;
}

.squarespace-comments .comments-content .comment-list .comment[data-depth="1"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="2"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="3"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="4"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="5"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="6"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="7"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="8"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="9"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="10"],
.squarespace-comments .comments-content .comment-list .comment[data-depth="11"],
.squarespace-comments
  .comments-content
  .comment-list
  .comment[data-depth="12"] {
  margin-left: 70px;
}

.squarespace-comments .comments-content .comment-list .reply-area-wrapper {
  margin-left: 70px;
}

.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="1"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="2"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="3"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="4"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="5"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="6"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="7"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="8"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="9"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="10"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="11"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="12"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="13"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="14"],
.squarespace-comments
  .comments-content
  .comment-list
  .reply-area-wrapper[data-depth="15"] {
  margin-left: 125px;
}

.collection-type-album {
  text-align: left;
}

#footer {
  margin-top: auto;
  clear: both;
  border-top: 1px solid rgba(0, 0, 0, 0);
  background-color: #131313;
}

#footer > .wrapper {
  color: #ccc;
  padding: 45px 50px;
  max-width: 1020px;
  margin: 0 auto;
}

#footer a:link,
#footer a:visited {
  color: rgba(240, 177, 40, 0.78);
}

#footer a:hover {
  color: #f0b128;
}

#footer .sqs-block-horizontalrule hr {
  border-color: #202020;
}

#footer h1,
#footer h2,
#footer h3,
#footer h4,
#footer h5,
#footer h6 {
  color: #b8b8b8;
}

.hide-blog-post-author .post-author {
  display: none !important;
}

#site .ls #content {
  max-width: 740px;
  margin-left: 280px;
}

#site .ls #sidebar {
  float: left;
  left: 50px;
}

#site .rs #sidebar {
  float: right;
  right: 50px;
}

#site .ls #sidebar,
#site .rs #sidebar {
  width: 220px;
  position: absolute;
  top: 3px;
}

#site .ls #sidebar h1,
#site .rs #sidebar h1,
#site .ls #sidebar h2,
#site .rs #sidebar h2,
#site .ls #sidebar h3,
#site .rs #sidebar h3,
#site .ls #sidebar h4,
#site .rs #sidebar h4,
#site .ls #sidebar h5,
#site .rs #sidebar h5,
#site .ls #sidebar h6,
#site .rs #sidebar h6 {
  margin-bottom: 0.5em;
}

#site .ls #sidebar .form-block .sqs-block-content,
#site .rs #sidebar .form-block .sqs-block-content {
  margin-right: 0;
}

#site .ls #sidebar .form-block .form-wrapper .field-list .section .title,
#site .rs #sidebar .form-block .form-wrapper .field-list .section .title {
  font-family: "Droid Serif", georgia, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.25em;
  font-family: "Georgia", "serif";
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.4em;
  text-transform: none;
  color: #444;
}

#site .ls #sidebar .image-block .sqs-block-content,
#site .rs #sidebar .image-block .sqs-block-content {
  padding-bottom: 0;
  border-bottom: none;
}

#header .sqs-frontend-edit {
  top: 0 !important;
  right: 0;
}

#logo .sqs-frontend-edit {
  top: -25px !important;
  right: 0;
}

.nav .sqs-frontend-edit {
  right: -25px !important;
}

.sqs-block-summary-v2 .summary-title,
.sqs-block-summary-v2 .summary-heading {
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-family: Bitter;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: capitalize;
  color: #154f8a;
}

.sqs-block-summary-v2 .summary-title a,
.sqs-block-summary-v2 .summary-heading a,
.sqs-block-summary-v2 .summary-title a:link,
.sqs-block-summary-v2 .summary-heading a:link,
.sqs-block-summary-v2 .summary-title a:visited,
.sqs-block-summary-v2 .summary-heading a:visited {
  color: #154f8a;
}

.sqs-block-summary-v2 .summary-title a:hover,
.sqs-block-summary-v2 .summary-heading a:hover,
.sqs-block-summary-v2 .summary-title a:link:hover,
.sqs-block-summary-v2 .summary-heading a:link:hover,
.sqs-block-summary-v2 .summary-title a:visited:hover,
.sqs-block-summary-v2 .summary-heading a:visited:hover {
  color: #555;
}

.sqs-block-summary-v2 a,
.sqs-block-summary-v2 a:link,
.sqs-block-summary-v2 a:visited {
  color: #15508a;
}

.sqs-block-summary-v2 a:hover,
.sqs-block-summary-v2 a:link:hover,
.sqs-block-summary-v2 a:visited:hover {
  color: #555;
}

.sqs-block-summary-v2 .summary-metadata-item {
  color: rgba(102, 102, 102, 0.7);
}

.sqs-block-summary-v2 .summary-metadata-item a,
.sqs-block-summary-v2 .summary-metadata-item a:link,
.sqs-block-summary-v2 .summary-metadata-item a:visited {
  color: rgba(102, 102, 102, 0.7);
}

.sqs-block-summary-v2 .summary-metadata-item a:hover,
.sqs-block-summary-v2 .summary-metadata-item a:link:hover,
.sqs-block-summary-v2 .summary-metadata-item a:visited:hover {
  color: #555;
}

.full-width {
  width: 100%;
  padding: 0;
  margin: 0;
}

.mob-width {
  width: auto;
  padding: 40px;
  margin: 0;
}

@media all and (max-width: 640px) {
  body,
  #site,
  #header,
  #footer {
    padding: 0;
  }

  h1 {
    font-size: 30px;
    line-height: 1.25em;
  }

  h2 {
    font-size: 22.5px;
    line-height: 1.25em;
  }

  h3 {
    font-size: 18.75px;
    line-height: 1.25em;
  }

  #site > .wrapper,
  #footer > .wrapper {
    width: auto;
    padding: 1rem;
    margin: 0;
  }

  .sqs-layout [class*="sqs-col"] {
    float: none !important;
    width: auto !important;
  }

  .sqs-layout .spacer-block {
    display: none;
  }

  .sqs-layout .sqs-row .sqs-block:first-child {
    padding-top: 17px !important;
  }

  .sqs-layout .sqs-row .sqs-block:last-child {
    padding-bottom: 17px !important;
  }

  .sqs-layout .sqs-row + .sqs-row,
  .sqs-layout .sqs-row + .sqs-block {
    margin-top: 0 !important;
  }

  .sqs-gallery-design-grid-slide {
    width: 50% !important;
    clear: none !important;
  }

  .sqsp-chrome-badge {
    display: none !important;
  }

  .folder-nav,
  .primary-nav {
    display: none;
  }

  .mobile-nav {
    width: 100%;
    padding: 0;
    margin: 0;
    display: block;
    font-size: 1em;
    line-height: 2em;
    background-color: #fff;
  }

  .mobile-nav .show-nav {
    font-family: "Varela";
    font-size: 12px;
    font-weight: normal;
    line-height: 5em;
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 3.4em;
    text-align: center;
    text-transform: uppercase;
    text-align: left;
    display: block;
    padding: 1em 40px;
    color: #666;
    cursor: pointer;
    border-bottom: 1px solid #e8e8e8;
  }

  .mobile-nav .show-nav:before {
    content: "Menu";
  }

  .mobile-nav .show-nav:after {
    position: absolute;
    top: 1em;
    right: 40px;
    content: "+";
  }

  .mobile-nav .nav {
    font-family: "Varela";
    font-size: 12px;
    font-weight: normal;
    line-height: 5em;
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 3.4em;
    text-align: center;
    text-transform: uppercase;
    transition: padding 0.1s ease-in, max-height 0.1s ease-in;
    text-align: left;
    padding: 0;
    margin: 0;
    max-height: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .mobile-nav .nav li {
    margin: 0;
    display: block;
    padding: 1em 40px;
    text-decoration: none;
    border-bottom: 1px solid #e8e8e8;
  }

  .mobile-nav .nav li a:link,
  .mobile-nav .nav li a:visited,
  .mobile-nav .nav li a:hover {
    color: #666;
    background-color: transparent;
    font-weight: 400;
  }

  .mobile-nav .nav .folder-links-wrapper {
    transition: padding-bottom 0.1s ease-in, max-height 0.1s ease-in;
    margin: 0;
    padding: 0;
    /* max-height: 0; */
    overflow: hidden;
  }

  .mobile-nav .nav .folder-links-wrapper li {
    margin: 1em 0 0 1em;
    padding: 0;
    border-bottom: none;
  }

  .mobile-nav .nav .folder-links-wrapper li a {
    margin: 0;
    padding: 0;
  }

  .mobile-nav .nav .folder-wrapper > a {
    display: block;
    position: relative;
    border-bottom: none;
    cursor: pointer;
    color: #666;
    background-color: transparent;
  }

  .mobile-nav .nav .folder-wrapper > a:after {
    position: absolute;
    top: 0px;
    right: 0px;
    content: "+";
  }

  .mobile-nav .nav .folder-wrapper.show .show-folder:after {
    content: "-";
  }

  .mobile-nav .nav .folder-wrapper.show .folder-links-wrapper {
    max-height: 9999px;
    padding-bottom: 1.5em;
  }

  .mobile-nav.show .nav {
    max-height: 9999px;
  }

  .mobile-nav.show .show-nav:before {
    opacity: 0.5;
  }

  .mobile-nav.show .show-nav:after {
    opacity: 0.5;
    content: "-";
  }

  #header {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  #header #logo {
    width: auto;
    padding: 40px;
    margin: 0;
  }

  #header #logo.logo-image img {
    max-width: 100%;
    height: auto;
  }

  #site .ls,
  #site .rs {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  #site .ls #content,
  #site .rs #content {
    width: auto;
    padding: 1rem;
    margin: 0;
  }

  #site .ls #sidebar,
  #site .rs #sidebar {
    width: auto;
    padding: 40px;
    margin: 0;
    float: none;
    top: auto;
    right: auto;
    left: auto;
    position: static;
    border-top: 1px dotted #f0b128;
  }

  #site .ls #sidebar .sqs-layout > .sqs-row,
  #site .rs #sidebar .sqs-layout > .sqs-row {
    margin-right: -15px;
  }

  .collection-type-blog #site > .wrapper {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .collection-type-blog #site .ls #content,
  .collection-type-blog #site .rs #content {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .collection-type-blog .entry {
    width: auto;
    padding: 40px;
    margin: 0;
  }

  .collection-type-blog .list .entry {
    margin-bottom: 0;
    padding-bottom: 40px;
  }

  .collection-type-blog .list.no-pagination .entry:last-of-type {
    padding-bottom: 40px;
  }

  .collection-type-blog h1.post-title {
    margin-bottom: 15px;
    font-size: 30px;
    line-height: 1.25em;
  }

  .collection-type-blog .pagination {
    width: auto;
    padding: 40px;
    margin: 0;
    border-top: none;
    border-bottom: none;
  }

  .collection-type-blog .squarespace-comments {
    padding-top: 40px;
  }

  .collection-type-blog .squarespace-comments .avatar,
  .collection-type-blog .squarespace-comments .header-controls {
    display: none;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .top-level-comment-area {
    margin-bottom: 40px;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment {
    margin: 0 -5% 40px;
    padding: 40px 5% 0;
    border-top: 1px dotted #f0b128;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-header {
    padding: 0;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-header
    .controls {
    display: none !important;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-header
    .user-info {
    margin-right: 0;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-header
    .user-info
    .date {
    display: inline;
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-header
    .user-info
    .date:after {
    content: " :";
  }

  .collection-type-blog
    .squarespace-comments
    .comments-content
    .comment-list
    .comment
    .comment-body {
    padding: 0;
  }
}

.logo-font {
  font-family: Raleway;
  font-size: 100px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 4px;
  line-height: 1em;
  text-align: center;
  text-transform: uppercase;
}

.site-tagline-font {
  font-family: Raleway;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1em;
  text-align: center;
  text-transform: none;
}

.nav-font {
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 2px;
  line-height: 3.4em;
  text-align: center;
  text-transform: uppercase;
}

.header-bg {
  background-image: url("https://static.squarespace.com/static/5416a926e4b09de8832655bc/t/5453261fe4b00dd647c7386b/1414735391913/Wafer1-Wide-Grey.png");
  background-position: center center;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: repeat;
}

.h1-font {
  font-family: Raleway;
  font-size: 30px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.2em;
  text-transform: none;
}

.h2-font {
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1em;
  text-transform: uppercase;
}

.h3-font {
  font-family: "Georgia", "serif";
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.4em;
  text-transform: none;
}

.body-font {
  font-family: Bitter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 1.5em;
  text-align: left;
  text-transform: none;
}

.quote-font {
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.4px;
  text-transform: none;
}

.summary-heading-font {
  font-family: Bitter;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: capitalize;
}

.small-button-block-font {
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.medium-button-block-font {
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.large-button-block-font {
  font-family: "proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.system-button-font {
  font-family: proxima-nova;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.announcement-bar-font {
  font-family: "proxima-nova", arial, sans-serif;
  font-size: 13px;
  font-weight: 300;
  font-style: normal;
  letter-spacing: 1px;
  text-transform: none;
}

/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */
h2 a {
  color: #f0b128 !important;
}

h2 a:hover {
  color: #555 !important;
}

.folder-links-wrapper a {
  border-bottom: solid 1px #ccc;
  font-size: 14px !important;
}

#logo {
  padding: 80px;
}

.collection-type-products #logo {
  padding: 30px;
}

.collection-type-blog #logo div {
  display: none;
}

.collection-type-blog #logo h1 {
  display: none;
}

[class*="sqs-col"] .sqs-block {
  /* padding: 4px 17px 7px 17px; */
}

#collection-5429503be4b0e1ecd7f5fd93 input {
  line-height: 2;
}

.folder-nav .nav {
  font-size: 14px;
}

.folder-nav .nav li a {
  font-weight: 500;
  color: #777;
}

.folder-nav .nav li a.active {
  font-weight: 600;
}

.category-nav {
  background-color: #27c7ff;
}

.category-nav .nav {
  font-size: 14px;
}

.category-nav .nav li a {
  color: #fff;
  font-weight: 500;
}

.category-nav .nav li a.active {
  color: #15508a;
  font-weight: 600;
}

.product-price {
  display: none !important;
}

.product-variants {
  display: none !important;
}

.product-quantity-input {
  display: none !important;
}

.sqs-add-to-cart-button-wrapper {
  display: none !important;
}

.product-sharing {
  display: none !important;
}

#productSummary {
  border-bottom: solid 1px #f0b128;
}

.collection-type-blog #block-98725074aa7bcf225f98,
.collection-type-blog #block-yui_3_17_2_10_1413534870359_9006,
.collection-type-blog #block-yui_3_17_2_10_1413534870359_21920,
.collection-type-blog #block-8822b803a555c7d462ad,
.collection-type-blog #block-20b5f3143d3fcdf61862,
.collection-type-blog #block-yui_3_17_2_1_1413532087177_7402,
.collection-type-blog #block-161688358dde6a56e873 {
  display: none;
}

.collection-type-products #block-yui_3_17_2_16_1416047625247_27154,
.collection-type-products #block-yui_3_17_2_15_1416047625247_7606,
.collection-type-products #block-yui_3_17_2_15_1416047625247_17455,
.collection-type-products #block-yui_3_17_2_15_1416047625247_8203,
.collection-type-products #block-yui_3_17_2_15_1416047625247_18341,
.collection-type-products #block-yui_3_17_2_15_1416047625247_10272,
.collection-type-products #block-yui_3_17_2_15_1416047625247_8567,
.collection-type-products #block-yui_3_17_2_15_1416047625247_18545,
.collection-type-products #block-yui_3_17_2_15_1416047625247_10893,
.collection-type-products #block-yui_3_17_2_15_1416047625247_8933,
.collection-type-products #block-yui_3_17_2_15_1416047625247_18735 {
  display: none;
}

.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_16_1416047625247_27154,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_7606,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_17455,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8203,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18341,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_10272,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8567,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18545,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_10893,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8933,
.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18735 {
  display: none;
}

.collection-type-blog .social {
  display: none;
}

.collection-type-blog h1 a {
  color: #15508a !important;
}

.collection-type-blog h1 a:hover {
  color: #555 !important;
}

#block-yui_3_17_2_16_1416047625247_27154 {
  background-color: #444;
  padding-top: 15px;
}

#block-yui_3_17_2_15_1416047625247_7606 {
  background-color: #444;
  padding-bottom: 15px;
}

#block-yui_3_17_2_15_1416047625247_17455 {
  background-color: #ffff8c;
  padding-top: 15px;
}

#block-yui_3_17_2_15_1416047625247_8203 {
  background-color: #ffff8c;
  padding-bottom: 15px;
}

#block-yui_3_17_2_15_1416047625247_10272 {
  background-color: #abff93;
  padding-top: 15px;
}

#block-yui_3_17_2_15_1416047625247_8567 {
  background-color: #abff93;
  padding-bottom: 15px;
}

#block-yui_3_17_2_15_1416047625247_10893 {
  background-color: #e88c8a;
  padding-top: 15px;
}

#block-yui_3_17_2_15_1416047625247_8933 {
  background-color: #e88c8a;
  padding-bottom: 15px;
}

#block-yui_3_17_2_42_1414753045025_4291 {
  display: none;
}

.primary-nav .sqs-block-search {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.primary-nav .search-input {
  max-width: 200px;
}

.primary-nav .sqs-search-ui-button-wrapper.color-dark .search-input {
  border: none !important;
  border-bottom: solid 2px #888 !important;
  height: 35px;
}

#mobile-navigation > ul > li:nth-last-child(1) a:before {
  /* content: url(/universal/images-v6/icons/icon-searchqueries-20-light.png); */
  vertical-align: -15%;
}

#mobile-navigation ul > li:nth-last-child(1) a {
  margin-left: -5px;
}

#mobile-navigation ul li {
  vertical-align: middle;
}

.primary-nav li {
  vertical-align: middle;
}

.sqs-block-summary-v2 .summary-title,
.sqs-block-summary-v2 .summary-heading {
  letter-spacing: 0px;
  text-transform: capitalize;
}

/* // here */

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  to {
    transform: scale(1);
  }
}

@keyframes bounceOut {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  to {
    opacity: 0;
    transform: scale(0.3);
  }
}

@media screen and (max-width: 432px) {
  .mobile-hidden,
  .subDesktop-hidden {
    display: none;
  }
}

@media screen and (min-width: 433px) {
  .desktop-hidden {
    display: none;
  }
}

.sqs-licensed-asset-preview-bar {
  background-color: #3e3e3e;
  bottom: 0;
  color: #fff;
  height: 88px;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 9999;
}

.sqs-licensed-asset-preview-bar-content {
  box-sizing: border-box;
  padding: 11px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}

.sqs-licensed-asset-preview-bar-content span {
  font-family: helvetica, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.squarespace-damask .sqs-mobile-info-bar a[href*="tel"] {
  pointer-events: none;
}

.sqs-mobile-info-bar-triggers {
  font-size: 0;
  padding: 0 20px;
  text-align: center;
  white-space: nowrap;
}

.sqs-mobile-info-bar {
  background: #ebebeb;
  bottom: 0;
  left: 0;
  position: fixed;
  transition: all 0.2s cubic-bezier(0.23, 0.47, 0.32, 1);
  width: 100%;
  z-index: 10000;
}

.sqs-mobile-info-bar :focus {
  outline-color: #222;
}

.sqs-mobile-info-bar :focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-mobile-info-bar-content {
  -webkit-backface-visibility: hidden;
}

.sqs-mobile-info-bar-trigger {
  cursor: pointer;
  display: inline-block;
  padding: 15px 0;
  text-align: center;
  width: 25%;
}

.sqs-mobile-info-bar-trigger a {
  display: block;
}

.sqs-mobile-info-bar-trigger-icon {
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  height: 16px;
  margin: 0 auto 8px;
  width: 16px;
}

.sqs-mobile-info-bar-trigger-label {
  color: #222;
  display: block;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 10px;
  letter-spacing: 0.5px;
  line-height: 1em;
  text-transform: uppercase;
}

.sqs-mobile-info-bar-trigger[data-type="location"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/map.png);
}

.sqs-mobile-info-bar-trigger[data-type="contactEmail"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/email.png);
}

.sqs-mobile-info-bar-trigger[data-type="contactPhoneNumber"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/call.png);
}

.sqs-mobile-info-bar-trigger[data-type="businessHours"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/hours.png);
}

.sqs-mobile-info-bar-overlay {
  align-items: center;
  background: #ebebeb;
  color: #222;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: opacity 0.2s cubic-bezier(0.23, 0.47, 0.32, 1);
  visibility: hidden;
  width: 100%;
}

.sqs-mobile-info-bar-overlay-content {
  margin: auto;
  width: 100%;
  z-index: 1;
}

.sqs-mobile-info-bar-overlay-content > div {
  display: none;
}

.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map {
  flex: auto;
}

.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map :focus {
  outline-color: #000;
}

.sqs-mobile-info-bar-overlay-content
  .sqs-mobile-info-bar-map
  :focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-address {
  background: #ebebeb;
  box-sizing: border-box;
  color: #aaa;
  flex: none;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 12px;
  height: auto;
  line-height: 19px;
  padding: 20px;
  position: relative;
  width: 100%;
}

.sqs-mobile-info-bar-overlay-content
  .sqs-mobile-info-bar-address
  [data-type="addressTitle"] {
  color: #222;
  font-size: 14px;
  line-height: 14px;
  margin: 2px 0 7px;
}

.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-address-link {
  background: url(//assets.squarespace.com/universal/images-v6/icons/icon-external-link-18-dark.png)
    no-repeat;
  height: 18px;
  margin-top: -9px;
  position: absolute;
  right: 20px;
  top: 50%;
  width: 18px;
}

.sqs-mobile-info-bar-overlay-close {
  background: #ebebeb;
  cursor: pointer;
  padding: 13px;
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 2;
}

.sqs-mobile-info-bar-overlay-close:after {
  color: #222;
  content: "×";
  display: block;
  font-family: helvetica, arial, sans-serif;
  font-size: 19px;
  font-weight: 100;
  line-height: 15px;
  padding: 0;
}

.sqs-mobile-info-bar-show-overlay {
  z-index: 12000;
}

.sqs-mobile-info-bar-show-overlay .sqs-mobile-info-bar-overlay {
  opacity: 1;
  visibility: visible;
}

.sqs-mobile-info-bar-dark {
  background: #222;
}

.sqs-mobile-info-bar-dark :focus {
  outline-color: #fff;
}

.sqs-mobile-info-bar-dark :focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay {
  background: #222;
  color: #fff;
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-address {
  background: #222;
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-address
  [data-type="addressTitle"] {
  color: #fff;
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-address-link {
  background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-external-link-18-light.png);
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-trigger-label {
  color: #fff;
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-trigger[data-type="location"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/map-light.png);
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-trigger[data-type="contactEmail"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/email-light.png);
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-trigger[data-type="contactPhoneNumber"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/call-light.png);
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-trigger[data-type="businessHours"]
  .sqs-mobile-info-bar-trigger-icon {
  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/hours-light.png);
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close,
.sqs-mobile-info-bar-overlay-close-dark {
  background: #222;
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close:focus,
.sqs-mobile-info-bar-overlay-close-dark:focus {
  outline-color: #fff;
}

.sqs-mobile-info-bar-dark
  .sqs-mobile-info-bar-overlay-close:focus:not(:focus-visible),
.sqs-mobile-info-bar-overlay-close-dark:focus:not(:focus-visible) {
  outline-color: transparent;
}

.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close:after,
.sqs-mobile-info-bar-overlay-close-dark:after {
  color: #fff;
}

.sqs-mobile-info-bar-hide,
.sqs-style-mode .sqs-mobile-info-bar {
  transform: translate3d(0, 100px, 0);
}

.sqs-business-hours {
  margin-left: auto;
  margin-right: auto;
}

.sqs-business-hours-day {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  letter-spacing: 1px;
  line-height: 1.4;
  margin: 0.5em 0;
}

.sqs-business-hours-day-label {
  color: #aaa;
  float: left;
  font-size: 13px;
  letter-spacing: 0.5px;
  margin-right: 10%;
  position: relative;
  text-align: right;
  text-transform: uppercase;
  top: 2px;
  width: 35%;
}

.sqs-business-hours-day-hours {
  float: right;
  width: 55%;
}

.sqs-business-hours-day .closed {
  color: #999;
}

.sqs-business-hours-day:after {
  clear: both;
  content: ".";
  display: block;
  font-size: 0;
  height: 0;
  visibility: hidden;
}

.sqs-business-hours-store {
  color: #aaa;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.65;
  margin: 1em 0 3em;
  text-align: center;
}

.sqs-business-hours-store span {
  color: #222;
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.sqs-business-hours-dark .sqs-business-hours-store span {
  color: #fff;
}

.sqs-ss-badge {
  background: #000;
  border-radius: 44px;
  cursor: pointer;
  height: 44px;
  opacity: 0;
  overflow: hidden;
  position: fixed;
  width: 44px;
  z-index: 10001;
}

.sqs-ss-badge-content {
  white-space: nowrap;
}

.sqs-ss-badge .badge-closed,
.sqs-ss-badge .badge-open {
  display: inline-block;
  height: 44px;
  transform: scale(1) translatez(0);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  vertical-align: top;
}

.sqs-ss-badge .badge-closed {
  background: transparent
    url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-16-light.png?20170201)
    50% no-repeat;
  width: 44px;
}

.sqs-ss-badge .badge-open {
  opacity: 0;
  width: 0;
}

.sqs-ss-badge .badge-open .badge-open-inner {
  white-space: nowrap;
}

.sqs-ss-badge .badge-open .badge-open-inner h2 {
  color: #e2e2e2 !important;
  font: 300 10px proxima-nova, HelveticaNeue-Light, Helvetica Neue Light,
    Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif !important;
  letter-spacing: 0.75px;
  line-height: 44px !important;
  margin: 0 !important;
  text-transform: uppercase;
}

.sqs-ss-badge[data-position="top-left"] {
  left: 22px;
  top: 44px;
}

.sqs-ss-badge[data-position="top-center"] {
  left: 0;
  margin: auto;
  right: 0;
  top: 44px;
}

.sqs-ss-badge[data-position="top-right"] {
  right: 22px;
  top: 44px;
}

.sqs-ss-badge[data-position="bottom-left"] {
  bottom: 22px;
  left: 22px;
}

.sqs-ss-badge[data-position="bottom-center"] {
  bottom: 20px;
  left: 0;
  margin: auto;
  right: 0;
}

.sqs-ss-badge[data-position="bottom-right"] {
  bottom: 22px;
  right: 22px;
}

.sqs-ss-badge.badge-auto-hide[data-position="top-center"],
.sqs-ss-badge.badge-auto-hide[data-position="top-left"],
.sqs-ss-badge.badge-auto-hide[data-position="top-right"] {
  transform: translatey(-88px);
  transition: opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}

.sqs-ss-badge.badge-auto-hide[data-position="bottom-center"],
.sqs-ss-badge.badge-auto-hide[data-position="bottom-left"],
.sqs-ss-badge.badge-auto-hide[data-position="bottom-right"] {
  transform: translatey(88px);
  transition: opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}

.sqs-ss-badge.is-mobile[data-devices="desktop-only"] {
  display: none;
}

.sqs-ss-badge[data-type="white"] {
  background: #fff;
}

.sqs-ss-badge[data-type="white"] .badge-open .badge-open-inner h2 {
  color: #111 !important;
}

.sqs-ss-badge[data-type="white"] .badge-closed {
  background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-16-dark.png?20170201);
}

.sqs-ss-badge.badge-visible {
  opacity: 1;
  transform: translate3d(0, -22px, 0) !important;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}

.sqs-ss-badge:not(.is-mobile):hover {
  border-radius: 0;
  width: 220px;
}

.sqs-ss-badge:not(.is-mobile):hover .badge-open {
  opacity: 1;
  transform: none;
}

.sqs-ss-badge-mobile-info-bar-present[data-position="bottom-center"],
.sqs-ss-badge-mobile-info-bar-present[data-position="bottom-left"],
.sqs-ss-badge-mobile-info-bar-present[data-position="bottom-right"] {
  bottom: 72px;
}

.sqs-ss-badge:not(.is-mobile):hover + .sqs-ss-badge-cover {
  opacity: 1;
  visibility: visible;
}

.sqs-ss-badge[data-position="top-left"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at top left,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.sqs-ss-badge[data-position="top-center"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at top center,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.sqs-ss-badge[data-position="top-right"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at top right,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.sqs-ss-badge[data-position="bottom-left"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at bottom left,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.sqs-ss-badge[data-position="bottom-center"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at bottom center,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

.sqs-ss-badge[data-position="bottom-right"] + .sqs-ss-badge-cover {
  background: radial-gradient(
    circle at bottom right,
    rgba(0, 0, 0, 0.1) 0,
    rgba(0, 0, 0, 0.5) 100%
  );
}

body.sqs-style-mode[data-position="top-left"] {
  left: 242px;
  top: 22px;
}

body.sqs-style-mode[data-position="bottom-left"] {
  bottom: 22px;
  left: 242px;
}

@media (min-resolution: 192dppx) {
  .sqs-ss-badge .badge-closed {
    background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-32-light.png?20170201);
    background-size: 16px;
  }

  .sqs-ss-badge[data-type="white"] .badge-closed {
    background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-32-dark.png?20170201);
  }
}

.sqs-ss-badge-cover {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: all 0.3s ease;
  visibility: hidden;
  width: 100%;
  z-index: 10000;
}

.sqs-block.html-block.sqs-block-html {
  padding: 0;
}

@media (min-width: 480px) {
  .sqs-block-postsbycategory ul,
  .sqs-block-postsbycategory #homeUL {
    grid-template-columns: repeat(2, 1fr);
  }

  .sqs-search-preview-ui {
    top: 100%;
  }
}

@media (min-width: 640px) {
  .sqs-search-preview-ui {
    top: 100%;
  }
}

@media (min-width: 648px) {
  .sqs-block-postsbycategory ul {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 900px) {
  .sqs-block-postsbycategory ul {
    grid-template-columns: repeat(4, 1fr);
  }
}

#typeGridDiv {
  margin-top: 4rem;
}

.sqs-block-postsbycategory #homeUL li {
  border: 1px solid #aaa;
}

.remove-scrolling {
  height: 100%;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/cssTakenfromCdilWebsite.css"],"names":[],"mappings":"AAAA;AACA;;AAEA,2DAA2D;AAC3D,uDAAuD;;AAEvD;EACE,6BAA6B;EAC7B,+DAAmG;EACnG,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA0G;EAC1G,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyGE,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,6BAA6B;EAC7B,+DAAmG;EACnG,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA0G;EAC1G,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,eAAe;EACf,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,iCAAiC;GACjC,qCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;;EAIE,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAG7B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;;;;;EAKE,mCAAmC;AACrC;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,OAAO;EACP,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,qBAAqB;EACrB,OAAO;EACP,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,OAAO;AACT;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;EACrB,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;;IAEE,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,QAAQ;AACV;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB;;8BAE4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE;IACE,oGAAoG;IACpG,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT;;8BAE4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,qGAAqG;IACrG,qBAAqB;EACvB;AACF;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yEAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;EACnB,iCAAiC;EACjC,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE;;8BAE4B;AAC9B;;AAEA;EACE;;IAEE,2GAA2G;IAC3G,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;8BAE4B;AAC9B;;AAEA;EACE;IACE,yGAAyG;IACzG,qBAAqB;EACvB;AACF;;AAEA;;EAEE;;8BAE4B;EAC5B,eAAe;AACjB;;AAEA;EACE;;IAEE,uGAAuG;IACvG,yBAAyB;EAC3B;AACF;;AAEA;;EAEE;;8BAE4B;AAC9B;;AAEA;EACE;;IAEE,qGAAqG;IACrG,yBAAyB;EAC3B;AACF;;AAEA;;EAEE;;8BAE4B;AAC9B;;AAEA;EACE;;IAEE,uGAAuG;IACvG,yBAAyB;EAC3B;AACF;;AAEA;EACE;;2BAEyB;AAC3B;;AAEA;EACE;IACE,yGAAyG;IACzG,qBAAqB;EACvB;AACF;;AAEA;EACE;;8BAE4B;AAC9B;;AAEA;EACE;IACE,qGAAqG;IACrG,qBAAqB;EACvB;AACF;;AAEA;EACE;;8BAE4B;AAC9B;;AAEA;EACE;IACE,6GAA6G;IAC7G,qBAAqB;EACvB;AACF;;AAEA;EACE;;8BAE4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,uGAAuG;IACvG,yBAAyB;EAC3B;AACF;;AAEA;EACE;;8BAE4B;AAC9B;;AAEA;EACE;IACE,qGAAqG;IACrG,yBAAyB;EAC3B;AACF;;AAEA;EACE;;8BAE4B;AAC9B;;AAEA;EACE;IACE,uGAAuG;IACvG,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,sDAAsD;EACtD,uDAAuD;AACzD;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;EACzE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA,2DAA2D;AAC3D;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;wBACsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;;;;;EAQE,oBAAoB;AACtB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;cACY;EACZ,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX;gFAC8E;AAChF;;AAEA;EACE;;IAEE,qFAAqF;IACrF,qBAAqB;EACvB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uEAAuE;EACvE,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAEhB,6BAA6B;EAE7B,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;;;;;;EASE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,uEAAuE;EACvE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EAEzB,iBAAiB;EACjB,+CAA+C;EAE/C,4DAA4D;EAE5D,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uEAAuE;EACvE,iBAAiB;EACjB,yBAAyB;EAEzB,iBAAiB;EACjB,oBAAoB;EAEpB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAEhB,6BAA6B;EAE7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE;IACE,QAAQ;EACV;AACF;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;EAcE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;;EAOE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;;EAME,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB;;;;;GAKC;EACD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8DAA8D;EAC9D,YAAY;EACZ,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,+DAAmG;EACnG,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA0G;EAC1G,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,uEAAuE;AACzE;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EAEZ,+BAA+B;AAEjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,qBAAqB;EACvB;;EAEA;;;IAGE,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gEAAgE;EAChE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iEAAiE;EACjE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,+DAAmG;EACnG,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA0G;EAC1G,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,QAAQ;EACR,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;;EAEA;;;;IAIE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;;;;;EAKE,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;;;EAKE,UAAU;EACV,OAAO;EACP,gEAAgE;EAChE,uBAAuB;AACzB;;AAEA;;;;;;EAME,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;EAGE,OAAO;EACP,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;;;;EAOE,aAAa;EACb,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;EAeE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,aAAa;AACf;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;;;;;;;;;EAYE,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;;EAIE,SAAS;EACT,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;;;;EAIE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;;EASE,SAAS;AACX;;AAEA;;;;;;EAME,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,UAAU;EACV,OAAO;EACP,iEAAiE;AACnE;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,MAAM;AACR;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,oBAAoB;AACtB;;AAEA;;;;;;;;;EASE,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;;;;IAKE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,oCAAoC;IACpC,WAAW;IACX,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;;;IAKE,UAAU;IACV,iCAAiC;IACjC,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,kDAAkD;IAClD,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,mDAAmD;EACrD;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;;;;IAKE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;;;;IAKE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;;;;;IAKE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;;;;IAKE,aAAa;EACf;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;;;EAIE,WAAW;EACX,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,QAAQ;AACV;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;;EAGE,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,6EAA6E;EAC7E,4BAA4B;EAC5B,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB;gBACc;EACd,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qBAAqB;EAErB,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAEhB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;;;;EAIE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;EAGE,qCAAqC;EACrC,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,6EAA6E;AAC/E;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;EACf,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;EACf,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;EACf,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;EAiBE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;;;;;;;;;;;;;;;;;;;;;EAqBE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;;;;;;;EASE,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sFAAsF;EACtF,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAE7B,0CAA0C;EAE1C,uCAAuC;AACzC;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;;;;;;EAME,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;;;;EAME,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;;;;EASE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;;;;EASE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;;;;;;;;EASE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;;;;;;EAUE,UAAU;AACZ;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;AACnB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,4BAA4B;AAC9B;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,mDAAmD;EACnD,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwFE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;;;;;;EAQE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgFE,SAAS;EACT,UAAU;EACV,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;EACrC,uCAAuC;EACvC,UAAU;EACV,uBAAuB;AACzB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;EAcE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;;;;;EAKE,qBAAqB;EACrB,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,gEAAgE;AAClE;;AAEA;;;EAGE,cAAc;EACd,UAAU;EACV,iEAAiE;AACnE;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE;;;;GAIC;AACH;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;;;;;;;EAaE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;EAaE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;EAaE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;EAaE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;EAaE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;EAaE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;EAaE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;AAChB;;AAEA;;;;;EAKE,SAAS;EACT,oBAAoB;AACtB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+GAA+G;EAC/G,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,+GAA+G;EAC/G,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,2FAA2F;AAC3F;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC;sCACoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX;qCACmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;;EAIE,QAAQ;AACV;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,UAAU;AACZ;;AAEA;;;EAGE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;;;EAgBE,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;EAOE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,wDAC8C;EAC9C,yCAAyC;EAazC;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;;;;;EAsBE;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;;;;EASE,wDAC8C;EAC9C,yCAAyC;EAazC;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;;;;;EAsBE;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,6CAA6C;AAC/C;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;EAOE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,8CAA8C;AAChD;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;EAGE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;EAGE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;EAGE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;EAGE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;;EAOE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME,wDAC8C;EAC9C,yCAAyC;EAazC;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;EAkBE;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;EAME,wDAC8C;EAC9C,yCAAyC;EAazC;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;EAkBE;;;;;;;;;;;GAWC;AACH;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,8CAA8C;AAChD;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,6CAA6C;AAC/C;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;;EAME;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;;;;;EAME,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;EAIE;gDAC8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,cAAc;AAChB;;AAEA;;;;;EAKE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;EAKE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;;;EAIE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,WAAW;AACb;;AAEA;;;;;;;;EAQE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;EAGE,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,YAAY;EACZ,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB;uBACqB;AACvB;;AAEA;EACE;IACE,oFAAoF;IACpF,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAIE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EAEzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wFAAwF;AACxF;;;;EAIE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;EACT,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;;;;;;GAMC;EACD;;;;;;GAMC;AACH;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,UAAU;IACV,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwGE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;EAeE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgKE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;EAGE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE;;;;;;;IAOE,qBAAqB;EACvB;AACF;;AAEA;;;;;;EAME,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;;;;;;IAME,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,QAAQ;EACR,UAAU;AACZ;;AAEA;;;;EAIE,OAAO;EACP,WAAW;AACb;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;;;IAGE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB;;qBAEmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;;;EAKE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,0BAA0B;IAC1B,qCAAqC;EACvC;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX;;8BAE4B;EAC5B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EAEb,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;EAOE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,2DAA2D;EAC3D,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;EAOE,iBAAiB;EACjB,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;;;;;;;EAOE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;;;;;;EAQE,QAAQ;AACV;;AAEA;;;;;;;EAOE,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;EAYE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;EAYE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,oBAAoB;AACtB;;AAEA;;;EAGE,iBAAiB;EACjB,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,0BAA0B;EAC1B,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,2DAA2D;EAC3D,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,2DAA2D;EAC3D,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb;yBACuB;AACzB;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;;EAIE,sBAAsB;EACtB,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,oBAAoB;AACtB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;;;;IAIE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,sEAAsE;EACtE,oCAAoC;EACpC,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;;;;IAIE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;EAC3D,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EAEzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;;;;;;EASE,eAAe;AACjB;;AAEA;;;;;;;;;EASE,eAAe;AACjB;;AAEA;;;;;;;;;EASE,eAAe;AACjB;;AAEA;;;;;;;;;EASE,eAAe;AACjB;;AAEA;;;;;;;;;EASE,wBAAwB;AAC1B;;AAEA;;;;;;;;;EASE,wBAAwB;AAC1B;;AAEA;;;;;;;;;EASE,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,UAAU;IACV,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,6BAA6B;EAC7B,+DAAmG;EACnG,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA0G;EAC1G,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4GE,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iJAAiJ;EACjJ,+BAA+B;EAC/B,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EAEE,mBAAmB;EAEnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,OAAO;AACT;;AAEA;EAIE,mCAAmC;AACrC;;AAEA;EAIE,gBAAgB;AAClB;;AAEA;EAIE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EAIE,gBAAgB;AAClB;;AAEA;EAIE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EAEpB,mBAAmB;EAEnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iJAAiJ;EACjJ,+BAA+B;EAC/B,4BAA4B;EAC5B,qJAAqJ;EACrJ,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,mCAAmC;EACnC,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,OAAO;EACP,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;GACG,yCAAyC;EAC1C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;GAIG,yCAAyC;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;EAME,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EAIE,gBAAgB;EAIhB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,+BAA+B;EAI/B,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAIE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EAEpB,mBAAmB;EAEnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAME,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EAIE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;EAeE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4DE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;;;;;;;;EAYE,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2EAA2E;EAC3E,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE;;;;IAIE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;IACV,SAAS;IACT,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IAIzB,yDAAyD;IACzD,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;;;IAGE,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IAIE,gEAAgE;IAChE,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,SAAS;IACT,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;;IAIE,mBAAmB;EACrB;;EAEA;;;;;IAKE,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;;;;;;IAME,UAAU;EACZ;;EAEA;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;;;;;;;IAOE,eAAe;EACjB;;EAEA;;;;;;;;IAQE,eAAe;EACjB;;EAEA;;;;;;;;IAQE,aAAa;EACf;;EAEA;;;;;;IAME,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qJAAqJ;EACrJ,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;;;;;;EAWE,aAAa;AACf;;AAEA;;;;;;;;;;;EAWE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,8EAA8E;EAC9E,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,YAAY;;AAEZ;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,eAAe;EACf,sDAAsD;EACtD,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yDAAyD;EACzD,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,2FAA2F;AAC7F;;AAEA;;EAEE,6FAA6F;AAC/F;;AAEA;;EAEE,4FAA4F;AAC9F;;AAEA;;EAEE,6FAA6F;AAC/F;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,UAAU;EACV,eAAe;EACf,MAAM;EACN,0DAA0D;EAC1D,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,yDAAyD;EACzD,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;aACW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,yGAAyG;AAC3G;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,iGAAiG;AACnG;;AAEA;;;EAGE,mGAAmG;AACrG;;AAEA;;;EAGE,kGAAkG;AACpG;;AAEA;;;EAGE,mGAAmG;AACrG;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,iCAAiC;EACjC,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE;;iBAEe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB;0EACwE;EACxE,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,4BAA4B;EAC5B;iDAC+C;AACjD;;AAEA;;;EAGE,2BAA2B;EAC3B;iDAC+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+GAA+G;AACjH;;AAEA;EACE,UAAU;EACV,8CAA8C;EAC9C,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,gHAAgH;IAChH,qBAAqB;EACvB;;EAEA;IACE,+GAA+G;EACjH;AACF;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,OAAO;EACP,UAAU;EACV,eAAe;EACf,MAAM;EACN,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[":root {\n}\n\n/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */\n/* ================= YSABEAU OFFICE ================= */\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n.social-smugmug:before,\n.social-dribbble:before,\n.social-youtube:before,\n.social-vimeo:before,\n.social-twitter:before,\n.social-tumblr:before,\n.social-pinterest:before,\n.social-linkedin:before,\n.social-instagram:before,\n.social-google:before,\n.social-foursquare:before,\n.social-flickr:before,\n.social-facebook:before,\n.social-fivehundredpix:before,\n.social-fivehundredpx:before,\n.social-email:before,\n.social-github:before,\n.social-rss:before,\n.social-spotify:before,\n.social-soundcloud:before,\n.social-itunes:before,\n.social-googleplay:before,\n.social-dropbox:before,\n.social-bandsintown:before,\n.social-behance:before,\n.social-codepen:before,\n.social-medium:before,\n.social-rdio:before,\n.social-squarespace:before,\n.social-vine:before,\n.social-yelp:before,\n.social-vevo:before,\n.social-meetup:before,\n.social-twitch:before,\n.social-vsco:before,\n.social-smugmug-square:before,\n.social-dribbble-square:before,\n.social-youtube-square:before,\n.social-vimeo-square:before,\n.social-twitter-square:before,\n.social-tumblr-square:before,\n.social-pinterest-square:before,\n.social-linkedin-square:before,\n.social-instagram-square:before,\n.social-google-square:before,\n.social-foursquare-square:before,\n.social-flickr-square:before,\n.social-facebook-square:before,\n.social-fivehundredpix-square:before,\n.social-fivehundredpx-square:before,\n.social-email-square:before,\n.social-github-square:before,\n.social-rss-square:before,\n.social-spotify-square:before,\n.social-soundcloud-square:before,\n.social-itunes-square:before,\n.social-googleplay-square:before,\n.social-dropbox-square:before,\n.social-bandsintown-square:before,\n.social-behance-square:before,\n.social-codepen-square:before,\n.social-medium-square:before,\n.social-rdio-square:before,\n.social-squarespace-square:before,\n.social-vine-square:before,\n.social-yelp-square:before,\n.social-vevo-square:before,\n.social-meetup-square:before,\n.social-twitch-square:before,\n.social-vsco-square:before,\n.social-smugmug-round:before,\n.social-dribbble-round:before,\n.social-youtube-round:before,\n.social-vimeo-round:before,\n.social-twitter-round:before,\n.social-tumblr-round:before,\n.social-pinterest-round:before,\n.social-linkedin-round:before,\n.social-instagram-round:before,\n.social-google-round:before,\n.social-foursquare-round:before,\n.social-flickr-round:before,\n.social-facebook-round:before,\n.social-fivehundredpix-round:before,\n.social-fivehundredpx-round:before,\n.social-email-round:before,\n.social-github-round:before,\n.social-rss-round:before,\n.social-spotify-round:before,\n.social-soundcloud-round:before,\n.social-itunes-round:before,\n.social-googleplay-round:before,\n.social-dropbox-round:before,\n.social-bandsintown-round:before,\n.social-behance-round:before,\n.social-codepen-round:before,\n.social-medium-round:before,\n.social-rdio-round:before,\n.social-squarespace-round:before,\n.social-vine-round:before,\n.social-yelp-round:before,\n.social-vevo-round:before,\n.social-meetup-round:before,\n.social-twitch-round:before,\n.social-vsco-round:before {\n  font-family: \"social-icon-font\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.social-smugmug:before {\n  content: \"\\e600\";\n}\n\n.social-icon-style-square .social-smugmug:before {\n  content: \"\\e601\";\n}\n\n.social-icon-style-round .social-smugmug:before {\n  content: \"\\e602\";\n}\n\n.social-dribbble:before {\n  content: \"\\e603\";\n}\n\n.social-icon-style-square .social-dribbble:before {\n  content: \"\\e604\";\n}\n\n.social-icon-style-round .social-dribbble:before {\n  content: \"\\e605\";\n}\n\n.social-youtube:before {\n  content: \"\\e606\";\n}\n\n.social-icon-style-square .social-youtube:before {\n  content: \"\\e607\";\n}\n\n.social-icon-style-round .social-youtube:before {\n  content: \"\\e608\";\n}\n\n.social-vimeo:before {\n  content: \"\\e609\";\n}\n\n.social-icon-style-square .social-vimeo:before {\n  content: \"\\e60a\";\n}\n\n.social-icon-style-round .social-vimeo:before {\n  content: \"\\e60b\";\n}\n\n.social-twitter:before {\n  content: \"\\e60c\";\n}\n\n.social-icon-style-square .social-twitter:before {\n  content: \"\\e60d\";\n}\n\n.social-icon-style-round .social-twitter:before {\n  content: \"\\e60e\";\n}\n\n.social-tumblr:before {\n  content: \"\\e60f\";\n}\n\n.social-icon-style-square .social-tumblr:before {\n  content: \"\\e610\";\n}\n\n.social-icon-style-round .social-tumblr:before {\n  content: \"\\e611\";\n}\n\n.social-pinterest:before {\n  content: \"\\e612\";\n}\n\n.social-icon-style-square .social-pinterest:before {\n  content: \"\\e613\";\n}\n\n.social-icon-style-round .social-pinterest:before {\n  content: \"\\e614\";\n}\n\n.social-linkedin:before {\n  content: \"\\e615\";\n}\n\n.social-icon-style-square .social-linkedin:before {\n  content: \"\\e616\";\n}\n\n.social-icon-style-round .social-linkedin:before {\n  content: \"\\e617\";\n}\n\n.social-instagram:before {\n  content: \"\\e618\";\n}\n\n.social-icon-style-square .social-instagram:before {\n  content: \"\\e619\";\n}\n\n.social-icon-style-round .social-instagram:before {\n  content: \"\\e61a\";\n}\n\n.social-foursquare:before {\n  content: \"\\e61e\";\n}\n\n.social-icon-style-square .social-foursquare:before {\n  content: \"\\e61f\";\n}\n\n.social-icon-style-round .social-foursquare:before {\n  content: \"\\e620\";\n}\n\n.social-flickr:before {\n  content: \"\\e621\";\n}\n\n.social-icon-style-square .social-flickr:before {\n  content: \"\\e622\";\n}\n\n.social-icon-style-round .social-flickr:before {\n  content: \"\\e623\";\n}\n\n.social-facebook:before {\n  content: \"\\e624\";\n}\n\n.social-icon-style-square .social-facebook:before {\n  content: \"\\e625\";\n}\n\n.social-icon-style-round .social-facebook:before {\n  content: \"\\e626\";\n}\n\n.social-fivehundredpix:before {\n  content: \"\\e627\";\n}\n\n.social-icon-style-square .social-fivehundredpix:before {\n  content: \"\\e628\";\n}\n\n.social-icon-style-round .social-fivehundredpix:before {\n  content: \"\\e629\";\n}\n\n.social-fivehundredpx:before {\n  content: \"\\e627\";\n}\n\n.social-icon-style-square .social-fivehundredpx:before {\n  content: \"\\e628\";\n}\n\n.social-icon-style-round .social-fivehundredpx:before {\n  content: \"\\e629\";\n}\n\n.social-email:before {\n  content: \"\\e62a\";\n}\n\n.social-icon-style-square .social-email:before {\n  content: \"\\e62b\";\n}\n\n.social-icon-style-round .social-email:before {\n  content: \"\\e62c\";\n}\n\n.social-github:before {\n  content: \"\\e62d\";\n}\n\n.social-icon-style-square .social-github:before {\n  content: \"\\e62e\";\n}\n\n.social-icon-style-round .social-github:before {\n  content: \"\\e62f\";\n}\n\n.social-rss:before {\n  content: \"\\e630\";\n}\n\n.social-icon-style-square .social-rss:before {\n  content: \"\\e631\";\n}\n\n.social-icon-style-round .social-rss:before {\n  content: \"\\e632\";\n}\n\n.social-spotify:before {\n  content: \"\\e633\";\n}\n\n.social-icon-style-square .social-spotify:before {\n  content: \"\\e634\";\n}\n\n.social-icon-style-round .social-spotify:before {\n  content: \"\\e635\";\n}\n\n.social-soundcloud:before {\n  content: \"\\e636\";\n}\n\n.social-icon-style-square .social-soundcloud:before {\n  content: \"\\e637\";\n}\n\n.social-icon-style-round .social-soundcloud:before {\n  content: \"\\e638\";\n}\n\n.social-itunes:before {\n  content: \"\\e639\";\n}\n\n.social-icon-style-square .social-itunes:before {\n  content: \"\\e63a\";\n}\n\n.social-icon-style-round .social-itunes:before {\n  content: \"\\e63b\";\n}\n\n.social-googleplay:before {\n  content: \"\\e63c\";\n}\n\n.social-icon-style-square .social-googleplay:before {\n  content: \"\\e63d\";\n}\n\n.social-icon-style-round .social-googleplay:before {\n  content: \"\\e63e\";\n}\n\n.social-dropbox:before {\n  content: \"\\e63f\";\n}\n\n.social-icon-style-square .social-dropbox:before {\n  content: \"\\e640\";\n}\n\n.social-icon-style-round .social-dropbox:before {\n  content: \"\\e641\";\n}\n\n.social-bandsintown:before {\n  content: \"\\e642\";\n}\n\n.social-icon-style-square .social-bandsintown:before {\n  content: \"\\e643\";\n}\n\n.social-icon-style-round .social-bandsintown:before {\n  content: \"\\e644\";\n}\n\n.social-behance:before {\n  content: \"\\e645\";\n}\n\n.social-icon-style-square .social-behance:before {\n  content: \"\\e646\";\n}\n\n.social-icon-style-round .social-behance:before {\n  content: \"\\e647\";\n}\n\n.social-codepen:before {\n  content: \"\\e648\";\n}\n\n.social-icon-style-square .social-codepen:before {\n  content: \"\\e649\";\n}\n\n.social-icon-style-round .social-codepen:before {\n  content: \"\\e64a\";\n}\n\n.social-medium:before {\n  content: \"\\e64b\";\n}\n\n.social-icon-style-square .social-medium:before {\n  content: \"\\e64c\";\n}\n\n.social-icon-style-round .social-medium:before {\n  content: \"\\e64d\";\n}\n\n.social-rdio:before {\n  content: \"\\e64e\";\n}\n\n.social-icon-style-square .social-rdio:before {\n  content: \"\\e64f\";\n}\n\n.social-icon-style-round .social-rdio:before {\n  content: \"\\e650\";\n}\n\n.social-squarespace:before {\n  content: \"\\e651\";\n}\n\n.social-icon-style-square .social-squarespace:before {\n  content: \"\\e652\";\n}\n\n.social-icon-style-round .social-squarespace:before {\n  content: \"\\e653\";\n}\n\n.social-vine:before {\n  content: \"\\e654\";\n}\n\n.social-icon-style-square .social-vine:before {\n  content: \"\\e655\";\n}\n\n.social-icon-style-round .social-vine:before {\n  content: \"\\e656\";\n}\n\n.social-yelp:before {\n  content: \"\\e657\";\n}\n\n.social-icon-style-square .social-yelp:before {\n  content: \"\\e658\";\n}\n\n.social-icon-style-round .social-yelp:before {\n  content: \"\\e659\";\n}\n\n.social-meetup:before {\n  content: \"\\e65a\";\n}\n\n.social-icon-style-square .social-meetup:before {\n  content: \"\\e65b\";\n}\n\n.social-icon-style-round .social-meetup:before {\n  content: \"\\e65c\";\n}\n\n.social-vevo:before {\n  content: \"\\e65d\";\n}\n\n.social-icon-style-square .social-vevo:before {\n  content: \"\\e65e\";\n}\n\n.social-icon-style-round .social-vevo:before {\n  content: \"\\e65f\";\n}\n\n.social-twitch:before {\n  content: \"\\e660\";\n}\n\n.social-icon-style-square .social-twitch:before {\n  content: \"\\e661\";\n}\n\n.social-icon-style-round .social-twitch:before {\n  content: \"\\e662\";\n}\n\n.social-vsco:before {\n  content: \"\\e663\";\n}\n\n.social-icon-style-square .social-vsco:before {\n  content: \"\\e664\";\n}\n\n.social-icon-style-round .social-vsco:before {\n  content: \"\\e665\";\n}\n\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nnav,\nsection {\n  display: block;\n}\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  display: inline;\n  zoom: 1;\n}\n\naudio:not([controls]) {\n  display: none;\n}\n\n[hidden] {\n  display: none;\n}\n\nhtml {\n  font-size: 100%;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6em;\n}\n\nbody,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: \"Ysabeau Office\", sans-serif;\n  color: #222;\n}\n\na {\n  color: #0085bd;\n}\n\na:hover {\n  color: #60a5dd;\n}\n\na:focus {\n  outline: thin dotted;\n}\n\na:hover,\na:active {\n  outline: 0;\n}\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\nblockquote {\n  margin: 1em 40px;\n}\n\ndfn {\n  font-style: italic;\n}\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #ccc;\n  margin: 1em 0;\n  padding: 0;\n}\n\nins {\n  background: inherit;\n  color: #000;\n  text-decoration: none;\n}\n\nmark {\n  background: #ff0;\n  color: #000;\n  font-style: italic;\n  font-weight: bold;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  _font-family: \"courier new\", monospace;\n  font-size: 1em;\n}\n\npre {\n  white-space: pre;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\nq {\n  quotes: none;\n}\n\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\nsmall {\n  font-size: 85%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nul,\nol {\n  margin: 1em 0;\n  padding: 0 0 0 40px;\n}\n\ndd {\n  margin: 0 0 0 40px;\n}\n\nnav ul,\nnav ol {\n  list-style: none;\n  list-style-image: none;\n  margin: 0;\n  padding: 0;\n}\n\nimg {\n  border: 0;\n  -ms-interpolation-mode: bicubic;\n  vertical-align: middle;\n}\n\nimg:not([src]) {\n  visibility: hidden;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nfigure {\n  margin: 0;\n}\n\nform {\n  margin: 0;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\nlabel {\n  cursor: pointer;\n}\n\nlegend {\n  border: 0;\n  margin-left: -7px;\n  padding: 0;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%;\n  margin: 0;\n  vertical-align: baseline;\n  vertical-align: middle;\n}\n\nbutton,\ninput {\n  line-height: normal;\n  overflow: visible;\n}\n\ntable button,\ntable input {\n  overflow: auto;\n}\n\nbutton,\ninput[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  cursor: pointer;\n  -webkit-appearance: button;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\ninput:invalid,\ntextarea:invalid {\n  background-color: #f0dddd;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n\ntd {\n  vertical-align: top;\n}\n\n.clear:before,\n.clear:after {\n  content: \"\";\n  display: table;\n}\n\n.clear:after {\n  clear: both;\n}\n\n.clear {\n  zoom: 1;\n}\n\nh1,\n:-webkit-any(article, aside, nav, section) h1,\n:-webkit-any(article, aside, nav, section)\n  :-webkit-any(article, aside, nav, section)\n  h1 {\n  -webkit-margin-before: 0 !important;\n}\n\n/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */\n.clear:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.v6-visually-hidden {\n  position: absolute !important;\n  clip: rect(1px, 1px, 1px, 1px);\n  padding: 0 !important;\n  border: 0 !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden;\n}\n\n.sqs-g {\n  letter-spacing: -0.31em;\n  text-rendering: optimizespeed;\n}\n\n.opera-only :-o-prefocus,\n.sqs-g {\n  word-spacing: -0.43em;\n}\n\n.yui3-u,\n.sqs-u {\n  display: inline-block;\n  zoom: 1;\n  letter-spacing: normal;\n  word-spacing: normal;\n  vertical-align: top;\n  text-rendering: auto;\n}\n\n.sqs-u-1,\n.sqs-u-1-2,\n.sqs-u-1-3,\n.sqs-u-2-3,\n.sqs-u-1-4,\n.sqs-u-3-4,\n.sqs-u-1-5,\n.sqs-u-2-5,\n.sqs-u-3-5,\n.sqs-u-4-5,\n.sqs-u-1-6,\n.sqs-u-5-6,\n.sqs-u-1-8,\n.sqs-u-3-8,\n.sqs-u-5-8,\n.sqs-u-7-8,\n.sqs-u-1-12,\n.sqs-u-5-12,\n.sqs-u-7-12,\n.sqs-u-11-12,\n.sqs-u-1-24,\n.sqs-u-5-24,\n.sqs-u-7-24,\n.sqs-u-11-24,\n.sqs-u-13-24,\n.sqs-u-17-24,\n.sqs-u-19-24,\n.sqs-u-23-24 {\n  display: inline-block;\n  zoom: 1;\n  letter-spacing: normal;\n  word-spacing: normal;\n  vertical-align: top;\n  text-rendering: auto;\n}\n\n.sqs-u-1 {\n  display: block;\n}\n\n.sqs-u-1-2 {\n  width: 50%;\n}\n\n.sqs-u-1-3 {\n  width: 33.33333%;\n}\n\n.sqs-u-2-3 {\n  width: 66.66666%;\n}\n\n.sqs-u-1-4 {\n  width: 25%;\n}\n\n.sqs-u-3-4 {\n  width: 75%;\n}\n\n.sqs-u-1-5 {\n  width: 20%;\n}\n\n.sqs-u-2-5 {\n  width: 40%;\n}\n\n.sqs-u-3-5 {\n  width: 60%;\n}\n\n.sqs-u-4-5 {\n  width: 80%;\n}\n\n.sqs-u-1-6 {\n  width: 16.656%;\n}\n\n.sqs-u-5-6 {\n  width: 83.33%;\n}\n\n.sqs-u-1-8 {\n  width: 12.5%;\n}\n\n.sqs-u-3-8 {\n  width: 37.5%;\n}\n\n.sqs-u-5-8 {\n  width: 62.5%;\n}\n\n.sqs-u-7-8 {\n  width: 87.5%;\n}\n\n.sqs-u-1-12 {\n  width: 8.3333%;\n}\n\n.sqs-u-5-12 {\n  width: 41.6666%;\n}\n\n.sqs-u-7-12 {\n  width: 58.3333%;\n}\n\n.sqs-u-11-12 {\n  width: 91.6666%;\n}\n\n.sqs-u-1-24 {\n  width: 4.1666%;\n}\n\n.sqs-u-5-24 {\n  width: 20.8333%;\n}\n\n.sqs-u-7-24 {\n  width: 29.1666%;\n}\n\n.sqs-u-11-24 {\n  width: 45.8333%;\n}\n\n.sqs-u-13-24 {\n  width: 54.1666%;\n}\n\n.sqs-u-17-24 {\n  width: 70.8333%;\n}\n\n.sqs-u-19-24 {\n  width: 79.1666%;\n}\n\n.sqs-u-23-24 {\n  width: 95.8333%;\n}\n\n#sqs-css-stamp.cssgrids {\n  display: none;\n}\n\n.yui3-widget-hidden {\n  display: none;\n}\n\n.yui3-widget-content {\n  overflow: hidden;\n}\n\n.yui3-widget-content-expanded {\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.yui3-widget-tmp-forcesize {\n  overflow: hidden !important;\n}\n\n.sqs-panel {\n  position: absolute;\n}\n\n.sqs-panel-hidden {\n  visibility: hidden;\n}\n\n.sqs-widget-tmp-forcesize .sqs-panel-content {\n  overflow: hidden !important;\n}\n\n.sqs-panel .sqs-widget-hd {\n  position: relative;\n}\n\n.sqs-panel .sqs-widget-hd .sqs-widget-buttons {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.sqs-panel .sqs-widget-ft .sqs-widget-buttons {\n  display: inline-block;\n  zoom: 1;\n}\n\n.yui3-slider,\n.yui3-slider-rail {\n  display: -moz-inline-stack;\n  display: inline-block;\n  zoom: 1;\n  vertical-align: middle;\n}\n\n.yui3-slider-content {\n  position: relative;\n  display: block;\n}\n\n.yui3-slider-rail {\n  position: relative;\n}\n\n.yui3-slider-rail-cap-top,\n.yui3-slider-rail-cap-left,\n.yui3-slider-rail-cap-bottom,\n.yui3-slider-rail-cap-right,\n.yui3-slider-thumb,\n.yui3-slider-thumb-image,\n.yui3-slider-thumb-shadow {\n  position: absolute;\n}\n\n.yui3-slider-thumb {\n  overflow: hidden;\n}\n\n.sqs-aclist,\n.yui3-aclist {\n  position: absolute;\n  z-index: 10;\n}\n\n.sqs-aclist-hidden,\n.yui3-aclist-hidden {\n  visibility: hidden;\n}\n\n.sqs-aclist-aria,\n.yui3-aclist-aria {\n  left: -9999px;\n  position: absolute;\n}\n\n.sqs-aclist-list,\n.yui3-aclist-list {\n  list-style: none;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n}\n\n.sqs-aclist-item,\n.yui3-aclist-item {\n  cursor: pointer;\n  list-style: none;\n  padding: 2px 5px;\n}\n\n.sqs-aclist-item-active,\n.yui3-aclist-item-active {\n  outline: #afafaf dotted thin;\n}\n\n.sqs-cookie-banner-v2-enabled .sqs-cookie-banner-v2 {\n  display: block;\n}\n\nbody.sqs-cookie-banner-v2-top .sqs-announcement-bar-dropzone,\nbody.sqs-cookie-banner-v2-top\n  .sqs-announcement-bar-dropzone.sqs-cookie-banner-v2-enabled {\n  position: relative;\n}\n\n.sqs-cookie-banner-v2 {\n  box-sizing: border-box;\n  display: none;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 300000;\n  padding: 10px;\n  position: fixed;\n}\n\n.sqs-cookie-banner-v2 p,\n.sqs-cookie-banner-v2 button {\n  font-family: \"Helvetica Neue\", Helvetica, Sans-serif;\n  font-size: 12px;\n  line-height: 1.5em;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0.05em;\n  margin: 10px !important;\n}\n\n.sqs-cookie-banner-v2 a {\n  text-decoration: underline;\n}\n\n.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-text {\n  max-height: calc(50vh);\n}\n\n.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-cta-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.sqs-cookie-banner-v2 .sqs-cookie-banner-v2-cta {\n  white-space: nowrap;\n  background: transparent;\n}\n\n.sqs-announcement-bar-dropzone .sqs-cookie-banner-v2.TOP {\n  position: relative;\n}\n\nbody > .sqs-cookie-banner-v2.TOP {\n  top: 0;\n}\n\n.sqs-cookie-banner-v2.BOTTOM {\n  bottom: 0;\n}\n\n.sqs-cookie-banner-v2.TOP_LEFT {\n  top: 20px;\n  left: 20px;\n}\n\n.sqs-cookie-banner-v2.TOP_RIGHT {\n  top: 20px;\n  right: 20px;\n}\n\n.sqs-cookie-banner-v2.BOTTOM_LEFT {\n  bottom: 20px;\n  left: 20px;\n}\n\n.sqs-cookie-banner-v2.BOTTOM_RIGHT {\n  bottom: 20px;\n  right: 20px;\n}\n\n@media (max-width: 640px) {\n  .sqs-cookie-banner-v2.TOP_LEFT,\n  .sqs-cookie-banner-v2.TOP_RIGHT {\n    top: 10px;\n    margin-bottom: 10px;\n    left: 10px;\n    right: 10px;\n  }\n\n  .sqs-cookie-banner-v2.BOTTOM_LEFT,\n  .sqs-cookie-banner-v2.BOTTOM_RIGHT {\n    margin-top: 10px;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n  }\n}\n\n.sqs-cookie-banner-v2.ICON {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-acceptWrapper {\n  font-size: 0px;\n  line-height: 1;\n  text-align: right;\n}\n\n.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-accept {\n  border: 0;\n  padding: 5px 10px;\n}\n\n.sqs-cookie-banner-v2.ICON .sqs-cookie-banner-v2-accept:after {\n  content: \"×\";\n  font-family: \"Helvetica Neue\", Helvetica, Sans-serif;\n  font-weight: 100;\n  line-height: 0.5em;\n  font-size: 35px;\n}\n\n.sqs-cookie-banner-v2.BAR {\n  left: 0;\n  right: 0;\n}\n\n@media (min-width: 640px) {\n  .sqs-cookie-banner-v2.BAR {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 15px;\n  }\n\n  .sqs-cookie-banner-v2.BAR p {\n    margin-right: 2vw;\n  }\n\n  .sqs-cookie-banner-v2.BAR .sqs-cookie-banner-v2-cta-container {\n    max-width: 50%;\n    flex: 1 0 auto;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n}\n\n@media (min-width: 640px) {\n  .sqs-cookie-banner-v2.POPUP {\n    width: 250px;\n    margin: 20px;\n  }\n\n  .sqs-cookie-banner-v2.POPUP.OPT_IN_AND_OUT {\n    width: auto;\n    max-width: 500px;\n  }\n\n  .sqs-cookie-banner-v2.POPUP.OPT_IN_AND_OUT .sqs-cookie-banner-v2-text {\n    max-width: 350px;\n  }\n\n  .sqs-cookie-banner-v2.POPUP.ICON {\n    width: 350px;\n    margin: 10px;\n  }\n}\n\n.sqs-cookie-banner-v2.BUTTON .sqs-cookie-banner-v2-cta {\n  padding: 1em 1.5em;\n  letter-spacing: 0.1em;\n  line-height: 1em;\n}\n\n.sqs-cookie-banner-v2.TEXT .sqs-cookie-banner-v2-cta {\n  padding: 0;\n  border: none;\n  letter-spacing: 0.05em;\n}\n\n.sqs-cookie-banner-v2.DARK {\n  background-color: #000;\n}\n\n.sqs-cookie-banner-v2.DARK p,\n.sqs-cookie-banner-v2.DARK button,\n.sqs-cookie-banner-v2.DARK a {\n  color: #fff;\n}\n\n.sqs-cookie-banner-v2.DARK :focus {\n  outline-color: #fff;\n}\n\n.sqs-cookie-banner-v2.DARK :focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-cookie-banner-v2.DARK.TEXT .sqs-cookie-banner-v2-cta {\n  border-bottom: 1px solid #777;\n}\n\n.sqs-cookie-banner-v2.DARK.BUTTON .sqs-cookie-banner-v2-cta {\n  border: 1px solid #fff;\n}\n\n.sqs-cookie-banner-v2.LIGHT {\n  background-color: #eee;\n}\n\n.sqs-cookie-banner-v2.LIGHT p,\n.sqs-cookie-banner-v2.LIGHT button,\n.sqs-cookie-banner-v2.LIGHT a {\n  color: #111;\n}\n\n.sqs-cookie-banner-v2.LIGHT :focus {\n  outline-color: #111;\n}\n\n.sqs-cookie-banner-v2.LIGHT :focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-cookie-banner-v2.LIGHT.TEXT .sqs-cookie-banner-v2-cta {\n  border-bottom: 1px solid #bbb;\n}\n\n.sqs-cookie-banner-v2.LIGHT.BUTTON .sqs-cookie-banner-v2-cta {\n  border: 1px solid #444;\n}\n\nbody.native-currency-code-usd .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-cad .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-cad .sqs-money-native:after {\n  content: \" CAD\";\n}\n\nbody.native-currency-code-gbp .sqs-money-native:before {\n  content: \"£\";\n}\n\nbody.native-currency-code-eur .sqs-money-native:before {\n  content: \"€\";\n}\n\nbody.native-currency-code-aud .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-aud .sqs-money-native:after {\n  content: \" AUD\";\n}\n\nbody.native-currency-code-chf .sqs-money-native:before {\n  content: \"CHF\";\n}\n\nbody.native-currency-code-nok .sqs-money-native:after {\n  content: \" kr\";\n}\n\nbody.native-currency-code-sek .sqs-money-native:after {\n  content: \" kr\";\n}\n\nbody.native-currency-code-dkk .sqs-money-native:after {\n  content: \" kr\";\n}\n\nbody.native-currency-code-nzd .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-sgd .sqs-money-native:before {\n  content: \"S$\";\n}\n\nbody.native-currency-code-mxn .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-hkd .sqs-money-native:before {\n  content: \"HK$\";\n}\n\nbody.native-currency-code-czk .sqs-money-native:after {\n  content: \" Kč\";\n}\n\nbody.native-currency-code-thb .sqs-money-native:before {\n  content: \"฿\";\n}\n\nbody.native-currency-code-myr .sqs-money-native:before {\n  content: \"RM\";\n}\n\nbody.native-currency-code-pln .sqs-money-native:after {\n  content: \" zł\";\n}\n\nbody.native-currency-code-ils .sqs-money-native:before {\n  content: \"₪ \";\n}\n\nbody.native-currency-code-php .sqs-money-native:before {\n  content: \"Php\";\n}\n\nbody.native-currency-code-rub .sqs-money-native:after {\n  content: \" р.\";\n}\n\nbody.native-currency-code-brl .sqs-money-native:before {\n  content: \" R$\";\n}\n\nbody.native-currency-code-ars .sqs-money-native:before {\n  content: \"$\";\n}\n\nbody.native-currency-code-ars .sqs-money-native:after {\n  content: \" ARS\";\n}\n\nbody.native-currency-code-cop .sqs-money-native:before {\n  content: \"COL$\";\n}\n\nbody.native-currency-code-idr .sqs-money-native:before {\n  content: \"Rp\";\n}\n\nbody.native-currency-code-inr .sqs-money-native:before {\n  content: \"₹\";\n}\n\nbody.native-currency-code-jpy .sqs-money-native:before {\n  content: \"¥\";\n}\n\nbody.native-currency-code-zar .sqs-money-native:before {\n  content: \"R\";\n}\n\n.fadeable-plugged.display-status-hidden {\n  display: none;\n}\n\n.sqs-image-zoom-dropzone {\n  overflow: hidden;\n}\n\n.sqs-image-zoom-duplicate {\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  transition: opacity 0.4s ease;\n}\n\n.is-zoomed .sqs-image-zoom-duplicate {\n  opacity: 1;\n}\n\n.sqs-image-zoom--behavior-click {\n  cursor: -webkit-zoom-in !important;\n  cursor: zoom-in !important;\n}\n\n.sqs-image-zoom--behavior-click.is-zoomed {\n  cursor: -webkit-zoom-out !important;\n  cursor: zoom-out !important;\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n\n  70% {\n    transform: scale(0.9);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes bounceOut {\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(0.95);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .mobile-hidden {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .subDesktop-hidden {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 433px) {\n  .desktop-hidden {\n    display: none;\n  }\n}\n\n.sqs-system-error {\n  color: #3e3e3e !important;\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/error-dark.png\")\n    center center no-repeat; */\n  background-position: 12px 12px;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-system-error {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/error-dark@2x.png\"); */\n    background-size: 44px;\n  }\n}\n\n.sqs-system-error input {\n  cursor: pointer;\n  background: #3e3e3e;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.sqs-system-error input,\n.sqs-system-error input > * {\n  color: #fff !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqs-system-error input:focus,\n.sqs-system-error input > *:focus {\n  outline-color: #fff;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqs-system-error input:focus:not(:focus-visible),\n.sqs-system-error input > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqs-system-error input:hover {\n  background-color: #000;\n  box-shadow: none;\n}\n\n.sqs-system-error input.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqs-system-error input.disabled > * {\n  opacity: 0.5;\n}\n\n.sqs-system-error input.disabled:hover {\n  background-color: #3e3e3e !important;\n}\n\n.sqs-system-error-overlay.dialog-screen-overlay {\n  background: rgba(246, 246, 246, 0.98);\n}\n\n.sqs-video-wrapper .intrinsic {\n  max-width: 100%;\n}\n\n.sqs-video-wrapper.video-none {\n  position: relative;\n}\n\n.sqs-video-wrapper.video-fill {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-video-wrapper.video-fit {\n  position: absolute;\n  width: 100%;\n}\n\n.sqs-video-wrapper.video-fit .intrinsic {\n  width: 100%;\n}\n\n.sqs-video-wrapper.video-fit .intrinsic-inner {\n  position: relative;\n}\n\n.sqs-video-wrapper iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-video-wrapper object,\n.sqs-video-wrapper embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-video-wrapper .sqs-video-overlay {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  color: #000;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.sqs-video-wrapper .sqs-video-overlay .sqs-video-opaque {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0;\n}\n\n.sqs-video-wrapper .sqs-video-overlay.no-thumb .sqs-video-opaque {\n  opacity: 1;\n}\n\n.sqs-video-wrapper .sqs-video-overlay .sqs-video-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/play-button.png\")\n    center center no-repeat; */\n  height: 48px;\n  width: 48px;\n  margin-left: -24px;\n  margin-top: -24px;\n  cursor: pointer;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-video-wrapper .sqs-video-overlay .sqs-video-icon {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/play-button@2x.png\"); */\n    background-size: 33px;\n  }\n}\n\n.sqs-video-wrapper.video-invalid {\n  position: static !important;\n  height: 48px !important;\n}\n\n.sqs-video-wrapper .sqs-video-invalid-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody.no-scroll {\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.no-scroll {\n  overflow: hidden !important;\n}\n\n.sqs-lightbox-overlay {\n  position: fixed;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  background: #000;\n  height: 100%;\n  width: 100%;\n}\n\n.sqs-lightbox-overlay.sqs-lightbox-overlay-style-orb {\n  background: radial-gradient(circle at 50% 25%, rgba(0, 0, 0, 0.75), #000);\n}\n\n.sqs-lightbox-overlay.light {\n  background: rgba(246, 246, 246, 0.98) !important;\n  color: #3e3e3e;\n}\n\n.sqs-lightbox-overlay.white.sqs-lightbox-overlay-style-orb {\n  background: radial-gradient(\n    circle at 50% 25%,\n    rgba(255, 255, 255, 0.96),\n    #fff\n  );\n}\n\n.sqsp-tooltip {\n  color: inherit;\n  background-color: #f6f6f6;\n  padding: 22px 33px;\n  box-shadow: 0 4px 33px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  position: absolute;\n  overflow: hidden;\n  text-align: left !important;\n  max-width: 250px;\n}\n\n.sqsp-tooltip .title {\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  margin-bottom: 11px;\n}\n\n.sqsp-tooltip .description {\n  margin: 11px 0;\n}\n\n.sqsp-tooltip .buttons {\n  margin: 22px -33px -22px;\n  border-top: 1px solid #e4e4e4;\n  display: flex;\n}\n\n.sqsp-tooltip .buttons:empty {\n  border-top: 0;\n}\n\n.sqsp-tooltip .buttons > * {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #e4e4e4 !important;\n}\n\n.sqsp-tooltip .buttons > *:first-child {\n  border-left: none !important;\n}\n\n.sqsp-tooltip .buttons input,\n.sqsp-tooltip .buttons button {\n  background: transparent;\n}\n\n.sqsp-tooltip .buttons a {\n  border-bottom: none;\n}\n\n.sqsp-tooltip .buttons a:not(.reject) {\n  cursor: pointer;\n  background: #f6f6f6;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.sqsp-tooltip .buttons a:not(.reject),\n.sqsp-tooltip .buttons a:not(.reject) > * {\n  color: #3e3e3e !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqsp-tooltip .buttons a:not(.reject):focus,\n.sqsp-tooltip .buttons a:not(.reject) > *:focus {\n  outline-color: #3e3e3e;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqsp-tooltip .buttons a:not(.reject):focus:not(:focus-visible),\n.sqsp-tooltip .buttons a:not(.reject) > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqsp-tooltip .buttons a:not(.reject):hover {\n  background-color: #fff;\n  box-shadow: none;\n}\n\n.sqsp-tooltip .buttons a:not(.reject).disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqsp-tooltip .buttons a:not(.reject).disabled > * {\n  opacity: 0.5;\n}\n\n.sqsp-tooltip .buttons a:not(.reject).disabled:hover {\n  background-color: #f6f6f6 !important;\n}\n\n.sqsp-tooltip .buttons a:not(.reject).disabled {\n  opacity: 0.5;\n}\n\n.sqsp-tooltip .buttons a.reject {\n  cursor: pointer;\n  background: #f6f6f6;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.sqsp-tooltip .buttons a.reject,\n.sqsp-tooltip .buttons a.reject > * {\n  color: #3e3e3e !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqsp-tooltip .buttons a.reject:focus,\n.sqsp-tooltip .buttons a.reject > *:focus {\n  outline-color: #3e3e3e;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqsp-tooltip .buttons a.reject:focus:not(:focus-visible),\n.sqsp-tooltip .buttons a.reject > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqsp-tooltip .buttons a.reject:hover {\n  background-color: #000;\n  box-shadow: none;\n}\n\n.sqsp-tooltip .buttons a.reject.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqsp-tooltip .buttons a.reject.disabled > * {\n  opacity: 0.5;\n}\n\n.sqsp-tooltip .buttons a.reject.disabled:hover {\n  background-color: #f6f6f6 !important;\n}\n\n.sqsp-tooltip .buttons a.reject:hover {\n  background-color: #f0523d;\n}\n\n.sqsp-tooltip .buttons a.reject:hover,\n.sqsp-tooltip .buttons a.reject:hover * {\n  color: #fff !important;\n}\n\n.sqs-action-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  white-space: nowrap;\n  transition: opacity 0.1s ease-out;\n  opacity: 0;\n  background-color: #3e3e3e;\n  overflow: hidden;\n  z-index: 50;\n  height: 32px;\n  border-radius: 3px;\n}\n\n.sqs-action-overlay.loading {\n  opacity: 1;\n}\n\n.sqs-action-overlay.bottom {\n  top: auto;\n  bottom: 0;\n}\n\n.sqs-action-overlay > div {\n  display: inline-block;\n  height: 32px;\n  width: 33px;\n  opacity: 0.3;\n  cursor: pointer;\n}\n\n.sqs-action-overlay > div:hover {\n  opacity: 0.9;\n}\n\n.sqs-action-overlay > div:active,\n.sqs-action-overlay > div:focus {\n  opacity: 1;\n}\n\n.sqs-action-overlay > div.edit-image,\n.sqs-action-overlay > div.edit {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/edit-aviary-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.edit-image,\n  .sqs-action-overlay > div.edit {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/edit-aviary-light@2x.png\"); */\n    background-size: 16px;\n  }\n}\n\n.sqs-action-overlay > div.edit.loading {\n  background: none;\n}\n\n.sqs-action-overlay > div.image-info {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/edit-info-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.image-info {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/edit-info-light@2x.png\"); */\n    background-size: 16px;\n  }\n}\n\n.sqs-action-overlay > div.remove,\n.sqs-action-overlay > div.remove-image {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png\")\n    center center no-repeat; */\n  cursor: pointer;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove,\n  .sqs-action-overlay > div.remove-image {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.remove:hover,\n.sqs-action-overlay > div.remove-image:hover {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-red.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove:hover,\n  .sqs-action-overlay > div.remove-image:hover {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-red@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.remove:hover,\n.sqs-action-overlay > div.remove-image:hover {\n  /* background: #f0523d\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove:hover,\n  .sqs-action-overlay > div.remove-image:hover {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.video-info {\n  background: transparent\n    /* url(\"//assets.squarespace.com/universal/images-v6/damask/edit-info-light.png\") */\n    center center no-repeat;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.video-info {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/edit-info-light@2x.png\"); */\n    background-size: 16px;\n  }\n}\n\n.sqs-action-overlay > div.getty {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/getty-16-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.getty {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/getty-32-light.png\"); */\n    background-size: 16px;\n  }\n}\n\n.sqs-action-overlay > div.buy {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/shopping-cart-16-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.buy {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/shopping-cart-32-light.png\"); */\n    background-size: 16px;\n  }\n}\n\n.sqs-action-overlay > div.remove-video {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png\")\n    center center no-repeat; */\n  cursor: pointer;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove-video {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.remove-video:hover {\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-red.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove-video:hover {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-red@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.remove-video:hover {\n  /* background: #f0523d\n    url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light.png\")\n    center center no-repeat; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-action-overlay > div.remove-video:hover {\n    /* background-image: url(\"//assets.squarespace.com/universal/images-v6/damask/trash-9-light@2x.png\"); */\n    background-size: 9px 11px;\n  }\n}\n\n.sqs-action-overlay > div.loading {\n  background: none;\n  position: relative;\n  opacity: 1;\n}\n\n.sqs-action-overlay > div.loading .sqs-spin.default {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translatex(-50%) translatey(-50%);\n}\n\n.sqs-action-overlay-container:hover .sqs-action-overlay {\n  opacity: 1;\n}\n\n.touch .sqs-action-overlay {\n  opacity: 1;\n}\n\n.image-focal-point {\n  border-radius: 14px;\n  height: 14px;\n  width: 14px;\n  margin-left: -10px;\n  margin-top: -10px;\n  position: absolute;\n  border: 3px solid rgba(255, 255, 255, 0.8);\n  background: rgba(0, 0, 0, 0.2);\n  cursor: move;\n  opacity: 0;\n}\n\n.sqs-loading-overlay-node {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.sqs-loading-overlay-node .sqs-spin {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.sqs-loading-overlay-node .sqs-spin.large {\n  margin-top: -11px;\n  margin-left: -11px;\n}\n\n.sqs-loading-overlay-node .sqs-spin.extra-large {\n  margin-top: -20px;\n  margin-left: -20px;\n}\n\n.sqs-loading-overlay-node.has-title .title {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  margin-top: 22px;\n  color: #999;\n  font-size: 14px;\n}\n\n.sqs-loading-overlay-node.has-title .sqs-spin {\n  margin-top: -22px;\n}\n\nbody > .login-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 30100;\n  transition: all 0.5s ease-in-out;\n}\n\nbody > .login-wrapper.hidden {\n  opacity: 0;\n}\n\n.sqs-follow-button-hidden {\n  display: none;\n}\n\n.sqs-spin {\n  background-color: transparent;\n  border-radius: 150px;\n  display: inline-block;\n  vertical-align: middle;\n  animation: sqs-spin 1s infinite linear;\n}\n\n.sqs-spin.light {\n  border: 2px solid rgba(255, 255, 255, 0.7) !important;\n  border-top-color: rgba(255, 255, 255, 0.15) !important;\n  border-left-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.sqs-spin.dark {\n  border: 2px solid rgba(0, 0, 0, 0.75) !important;\n  border-top-color: rgba(0, 0, 0, 0.08) !important;\n  border-left-color: rgba(0, 0, 0, 0.08) !important;\n}\n\n.sqs-spin.extra-small {\n  width: 4px;\n  height: 4px;\n}\n\n.sqs-spin.small {\n  width: 8px;\n  height: 8px;\n}\n\n.sqs-spin.default {\n  width: 12px;\n  height: 12px;\n}\n\n.sqs-spin.large {\n  width: 22px;\n  height: 22px;\n}\n\n.sqs-spin.extra-large {\n  width: 40px;\n  height: 40px;\n}\n\n.sqs-spin.xx-large {\n  width: 80px;\n  height: 80px;\n}\n\n.sqs-spin.degraded {\n  border: 0px;\n  border-radius: 0px;\n  animation: none;\n}\n\n.sqs-spin.degraded img {\n  width: 100%;\n  height: 100%;\n  border: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\n@keyframes sqs-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.sqs-widgets-confirmation {\n  color: #3e3e3e;\n  z-index: 1000000;\n  font-size: 12px;\n}\n\n@media screen and (max-width: 432px) {\n  .sqs-widgets-confirmation {\n    width: 300px !important;\n  }\n}\n\n@media screen and (min-width: 433px) {\n  .sqs-widgets-confirmation {\n    position: absolute;\n  }\n}\n\n.sqs-widgets-confirmation-content {\n  color: inherit;\n  padding: 22px 33px;\n  text-align: center;\n  background: #f6f6f6;\n  box-shadow: 0 4px 33px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n@media screen and (max-width: 432px) {\n  .sqs-widgets-confirmation-content {\n    padding: 22px;\n  }\n}\n\n.sqs-widgets-confirmation-content > .title {\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  margin-bottom: 11px;\n}\n\n.sqs-widgets-confirmation-content .fields {\n  margin-bottom: 11px;\n}\n\n.sqs-widgets-confirmation-content .fields .check-field-wrapper {\n  padding: 0;\n}\n\n.sqs-widgets-confirmation-content\n  .fields\n  .check-field-wrapper\n  .field-description {\n  background: none;\n}\n\n.sqs-widgets-confirmation-content .buttons {\n  border-top: 1px solid #e4e4e4;\n  display: flex;\n  margin: 22px -33px -22px;\n}\n\n.sqs-widgets-confirmation-content .buttons:empty {\n  border-top: 0;\n}\n\n.sqs-widgets-confirmation-content .buttons > * {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #e4e4e4 !important;\n}\n\n.sqs-widgets-confirmation-content .buttons > *:first-child {\n  border-left: none !important;\n}\n\n.sqs-widgets-confirmation-content .buttons input,\n.sqs-widgets-confirmation-content .buttons button {\n  background: transparent;\n}\n\n.sqs-widgets-confirmation-content .buttons a {\n  border-bottom: none;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button:not(.reject) {\n  cursor: pointer;\n  background: #f6f6f6;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n  line-height: 16px;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button:not(.reject),\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject)\n  > * {\n  color: #3e3e3e !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject):focus,\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject)\n  > *:focus {\n  outline-color: #3e3e3e;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject):focus:not(:focus-visible),\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject)\n  > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject):hover {\n  background-color: #fff;\n  box-shadow: none;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject).disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject).disabled\n  > * {\n  opacity: 0.5;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject).disabled:hover {\n  background-color: #f6f6f6 !important;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:not(.reject).disabled {\n  opacity: 0.5;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject {\n  cursor: pointer;\n  background: #f6f6f6;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n  line-height: 16px;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject,\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject > * {\n  color: #3e3e3e !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:focus,\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject\n  > *:focus {\n  outline-color: #3e3e3e;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject:focus:not(:focus-visible),\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject\n  > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover {\n  background-color: #000;\n  box-shadow: none;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject.disabled\n  > * {\n  opacity: 0.5;\n}\n\n.sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button.reject.disabled:hover {\n  background-color: #f6f6f6 !important;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover {\n  background-color: #f0523d;\n}\n\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover,\n.sqs-widgets-confirmation-content .buttons .confirmation-button.reject:hover * {\n  color: #fff !important;\n}\n\n.sqs-widgets-confirmation.sqs-widgets-data-confirmation\n  .sqs-widgets-confirmation-content {\n  text-align: left;\n}\n\n.sqs-widgets-confirmation.danger-zone .sqs-widgets-confirmation-content {\n  color: #fff !important;\n  background-color: #f0523d;\n}\n\n.sqs-widgets-confirmation.danger-zone\n  .sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button {\n  background-color: #f0523d;\n  color: #fff !important;\n}\n\n.sqs-widgets-confirmation.danger-zone\n  .sqs-widgets-confirmation-content\n  .buttons\n  .confirmation-button:hover {\n  background-color: #e4351e;\n}\n\n.sqs-widgets-confirmation.dangerous-confirmation-button\n  .sqs-widgets-confirmation-content\n  .buttons\n  .confirm:hover {\n  background-color: #f0523d;\n  color: #fff !important;\n}\n\n.sqs-widgets-confirmation.reject-warning\n  .buttons\n  .confirmation-button.reject:hover {\n  background-color: #f0523d;\n  color: #fff;\n}\n\n.sqs-widgets-confirmation.delete-collection .confirmation-button.confirm:hover {\n  background-color: #f0523d;\n  color: #fff !important;\n}\n\n.sqs-widgets-confirmation.with-media .title:empty,\n.sqs-widgets-confirmation.with-media .message:empty {\n  display: none;\n}\n\n.sqs-widgets-confirmation.with-media .title:empty + .message:empty + .media {\n  margin-top: -22px;\n}\n\n.sqs-widgets-confirmation.with-media .media {\n  display: block;\n  position: relative;\n  margin: 0px -33px;\n}\n\n.sqs-widgets-confirmation.with-media .media > * {\n  display: block;\n  position: relative;\n  margin: 0 auto;\n}\n\n.sqs-widgets-confirmation.with-media .buttons {\n  margin-top: 0px;\n}\n\n.sqs-widgets-confirmation.with-media .sqs-widgets-confirmation-content {\n  background: #fff;\n}\n\n.sqs-widgets-confirmation.shown .media > * {\n  width: 100%;\n}\n\n.sqs-widgets-confirmation {\n  opacity: 0;\n  transform: scale(0.96);\n}\n\n.sqs-widgets-confirmation.mobile {\n  transform: translatey(-50%);\n}\n\n.sqs-widgets-confirmation.shown {\n  opacity: 1;\n  transform: scale(1);\n  animation-name: show-confirmation;\n  animation-iteration-count: 1;\n  animation-duration: 0.3s;\n}\n\n.sqs-widgets-confirmation.shown.mobile {\n  transform: translatey(0);\n  animation-name: show-confirmation-mobile;\n}\n\n.sqs-widgets-confirmation.hiding {\n  opacity: 0;\n  animation-name: none;\n  transition-property: all;\n  transition-duration: 0.3s;\n  transform: scale(0.96);\n}\n\n.sqs-widgets-confirmation.hiding.mobile {\n  transform: translatey(-50%);\n}\n\n.sqs-widgets-confirmation-hidden {\n  display: none;\n}\n\n@keyframes show-confirmation {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes show-confirmation-mobile {\n  from {\n    transform: translatey(-50%);\n  }\n\n  to {\n    transform: translatey(0);\n  }\n}\n\n.sqs-widgets-confirmation-overlay {\n  display: block;\n  background: #000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.4;\n  z-index: 999999;\n}\n\n@media screen and (max-width: 432px) {\n  .sqs-widgets-confirmation-overlay {\n    opacity: 0.4 !important;\n    z-index: 999999 !important;\n  }\n}\n\n/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */\n.sqs-block.vsize-1 .sqs-block-content {\n  height: 34px;\n}\n\n.sqs-block.vsize-2 .sqs-block-content {\n  height: 68px;\n}\n\n.sqs-block.vsize-3 .sqs-block-content {\n  height: 102px;\n}\n\n.sqs-block.vsize-4 .sqs-block-content {\n  height: 136px;\n}\n\n.sqs-block.vsize-5 .sqs-block-content {\n  height: 170px;\n}\n\n.sqs-block.vsize-6 .sqs-block-content {\n  height: 204px;\n}\n\n.sqs-block.vsize-7 .sqs-block-content {\n  height: 238px;\n}\n\n.sqs-block.vsize-8 .sqs-block-content {\n  height: 272px;\n}\n\n.sqs-block.vsize-9 .sqs-block-content {\n  height: 306px;\n}\n\n.sqs-block.vsize-10 .sqs-block-content {\n  height: 340px;\n}\n\n.sqs-block.vsize-11 .sqs-block-content {\n  height: 374px;\n}\n\n.sqs-block.vsize-12 .sqs-block-content {\n  height: 408px;\n}\n\n.sqs-block.vsize-13 .sqs-block-content {\n  height: 442px;\n}\n\n.sqs-block.vsize-14 .sqs-block-content {\n  height: 476px;\n}\n\n.sqs-block.vsize-15 .sqs-block-content {\n  height: 510px;\n}\n\n.sqs-block.vsize-16 .sqs-block-content {\n  height: 544px;\n}\n\n.sqs-block.vsize-17 .sqs-block-content {\n  height: 578px;\n}\n\n.sqs-block.vsize-18 .sqs-block-content {\n  height: 612px;\n}\n\n.sqs-block.vsize-19 .sqs-block-content {\n  height: 646px;\n}\n\n.sqs-block.vsize-20 .sqs-block-content {\n  height: 680px;\n}\n\n.sqs-block.vsize-21 .sqs-block-content {\n  height: 714px;\n}\n\n.sqs-block.vsize-22 .sqs-block-content {\n  height: 748px;\n}\n\n.sqs-block.vsize-23 .sqs-block-content {\n  height: 782px;\n}\n\n.sqs-block.vsize-24 .sqs-block-content {\n  height: 816px;\n}\n\n.sqs-block.vsize-25 .sqs-block-content {\n  height: 850px;\n}\n\n.sqs-block.vsize-26 .sqs-block-content {\n  height: 884px;\n}\n\n.sqs-block.vsize-27 .sqs-block-content {\n  height: 918px;\n}\n\n.sqs-block.vsize-28 .sqs-block-content {\n  height: 952px;\n}\n\n.sqs-block.vsize-29 .sqs-block-content {\n  height: 986px;\n}\n\n.sqs-block.vsize-30 .sqs-block-content {\n  height: 1020px;\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n\n  70% {\n    transform: scale(0.9);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes bounceOut {\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(0.95);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .mobile-hidden {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .subDesktop-hidden {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 433px) {\n  .desktop-hidden {\n    display: none;\n  }\n}\n\n.sqs-row {\n  width: 100% !important;\n}\n\n.sqs-row:before,\n.sqs-row:after {\n  content: \"\";\n  display: table;\n}\n\n.sqs-row:after {\n  clear: both;\n}\n\n[class*=\"sqs-col\"] {\n  float: left;\n}\n\n[class*=\"sqs-col\"] .sqs-block {\n  /* padding-left: 25px;\n  padding-right: 25px; */\n}\n\n[class*=\"sqs-col\"]:last-child {\n  padding-right: 0;\n}\n\n.sqs-col-12 {\n  width: 100%;\n}\n\n.sqs-col-12 .sqs-col-12 {\n  width: 100%;\n}\n\n.sqs-col-12 .sqs-col-11 {\n  width: 91.6667%;\n}\n\n.sqs-col-12 .sqs-col-10 {\n  width: 83.3333%;\n}\n\n.sqs-col-12 .sqs-col-9 {\n  width: 75%;\n}\n\n.sqs-col-12 .sqs-col-8 {\n  width: 66.6667%;\n}\n\n.sqs-col-12 .sqs-col-7 {\n  width: 58.3333%;\n}\n\n.sqs-col-12 .sqs-col-6 {\n  width: 50%;\n}\n\n.sqs-col-12 .sqs-col-5 {\n  width: 41.6667%;\n}\n\n.sqs-col-12 .sqs-col-4 {\n  width: 33.3333%;\n}\n\n.sqs-col-12 .sqs-col-3 {\n  width: 25%;\n}\n\n.sqs-col-12 .sqs-col-2 {\n  width: 16.6667%;\n}\n\n.sqs-col-12 .sqs-col-1 {\n  width: 8.3333%;\n}\n\n.sqs-col-11 {\n  width: 91.6667%;\n}\n\n.sqs-col-11 .sqs-col-11 {\n  width: 100%;\n}\n\n.sqs-col-11 .sqs-col-10 {\n  width: 90.9091%;\n}\n\n.sqs-col-11 .sqs-col-9 {\n  width: 81.8182%;\n}\n\n.sqs-col-11 .sqs-col-8 {\n  width: 72.7273%;\n}\n\n.sqs-col-11 .sqs-col-7 {\n  width: 63.6364%;\n}\n\n.sqs-col-11 .sqs-col-6 {\n  width: 54.5455%;\n}\n\n.sqs-col-11 .sqs-col-5 {\n  width: 45.4545%;\n}\n\n.sqs-col-11 .sqs-col-4 {\n  width: 36.3636%;\n}\n\n.sqs-col-11 .sqs-col-3 {\n  width: 27.2727%;\n}\n\n.sqs-col-11 .sqs-col-2 {\n  width: 18.1818%;\n}\n\n.sqs-col-11 .sqs-col-1 {\n  width: 9.0909%;\n}\n\n.sqs-col-10 {\n  width: 83.3333%;\n}\n\n.sqs-col-10 .sqs-col-10 {\n  width: 100%;\n}\n\n.sqs-col-10 .sqs-col-9 {\n  width: 90%;\n}\n\n.sqs-col-10 .sqs-col-8 {\n  width: 80%;\n}\n\n.sqs-col-10 .sqs-col-7 {\n  width: 70%;\n}\n\n.sqs-col-10 .sqs-col-6 {\n  width: 60%;\n}\n\n.sqs-col-10 .sqs-col-5 {\n  width: 50%;\n}\n\n.sqs-col-10 .sqs-col-4 {\n  width: 40%;\n}\n\n.sqs-col-10 .sqs-col-3 {\n  width: 30%;\n}\n\n.sqs-col-10 .sqs-col-2 {\n  width: 20%;\n}\n\n.sqs-col-10 .sqs-col-1 {\n  width: 10%;\n}\n\n.sqs-col-9 {\n  width: 75%;\n}\n\n.sqs-col-9 .sqs-col-9 {\n  width: 100%;\n}\n\n.sqs-col-9 .sqs-col-8 {\n  width: 88.8889%;\n}\n\n.sqs-col-9 .sqs-col-7 {\n  width: 77.7778%;\n}\n\n.sqs-col-9 .sqs-col-6 {\n  width: 66.6667%;\n}\n\n.sqs-col-9 .sqs-col-5 {\n  width: 55.5556%;\n}\n\n.sqs-col-9 .sqs-col-4 {\n  width: 44.4444%;\n}\n\n.sqs-col-9 .sqs-col-3 {\n  width: 33.3333%;\n}\n\n.sqs-col-9 .sqs-col-2 {\n  width: 22.2222%;\n}\n\n.sqs-col-9 .sqs-col-1 {\n  width: 11.1111%;\n}\n\n.sqs-col-8 {\n  width: 66.6667%;\n}\n\n.sqs-col-8 .sqs-col-8 {\n  width: 100%;\n}\n\n.sqs-col-8 .sqs-col-7 {\n  width: 87.5%;\n}\n\n.sqs-col-8 .sqs-col-6 {\n  width: 75%;\n}\n\n.sqs-col-8 .sqs-col-5 {\n  width: 62.5%;\n}\n\n.sqs-col-8 .sqs-col-4 {\n  width: 50%;\n}\n\n.sqs-col-8 .sqs-col-3 {\n  width: 37.5%;\n}\n\n.sqs-col-8 .sqs-col-2 {\n  width: 25%;\n}\n\n.sqs-col-8 .sqs-col-1 {\n  width: 12.5%;\n}\n\n.sqs-col-7 {\n  width: 58.3333%;\n}\n\n.sqs-col-7 .sqs-col-7 {\n  width: 100%;\n}\n\n.sqs-col-7 .sqs-col-6 {\n  width: 85.7143%;\n}\n\n.sqs-col-7 .sqs-col-5 {\n  width: 71.4286%;\n}\n\n.sqs-col-7 .sqs-col-4 {\n  width: 57.1429%;\n}\n\n.sqs-col-7 .sqs-col-3 {\n  width: 42.8571%;\n}\n\n.sqs-col-7 .sqs-col-2 {\n  width: 28.5714%;\n}\n\n.sqs-col-7 .sqs-col-1 {\n  width: 14.2857%;\n}\n\n.sqs-col-6 {\n  width: 50%;\n}\n\n.sqs-col-6 .sqs-col-6 {\n  width: 100%;\n}\n\n.sqs-col-6 .sqs-col-5 {\n  width: 83.3333%;\n}\n\n.sqs-col-6 .sqs-col-4 {\n  width: 66.6667%;\n}\n\n.sqs-col-6 .sqs-col-3 {\n  width: 50%;\n}\n\n.sqs-col-6 .sqs-col-2 {\n  width: 33.3333%;\n}\n\n.sqs-col-6 .sqs-col-1 {\n  width: 16.6667%;\n}\n\n.sqs-col-5 {\n  width: 41.6667%;\n}\n\n.sqs-col-5 .sqs-col-5 {\n  width: 100%;\n}\n\n.sqs-col-5 .sqs-col-4 {\n  width: 80%;\n}\n\n.sqs-col-5 .sqs-col-3 {\n  width: 60%;\n}\n\n.sqs-col-5 .sqs-col-2 {\n  width: 40%;\n}\n\n.sqs-col-5 .sqs-col-1 {\n  width: 20%;\n}\n\n.sqs-col-4 {\n  width: 33.3333%;\n}\n\n.sqs-col-4 .sqs-col-4 {\n  width: 100%;\n}\n\n.sqs-col-4 .sqs-col-3 {\n  width: 75%;\n}\n\n.sqs-col-4 .sqs-col-2 {\n  width: 50%;\n}\n\n.sqs-col-4 .sqs-col-1 {\n  width: 25%;\n}\n\n.sqs-col-3 {\n  width: 25%;\n}\n\n.sqs-col-3 .sqs-col-3 {\n  width: 100%;\n}\n\n.sqs-col-3 .sqs-col-2 {\n  width: 66.6667%;\n}\n\n.sqs-col-3 .sqs-col-1 {\n  width: 33.3333%;\n}\n\n.sqs-col-2 {\n  width: 16.6667%;\n}\n\n.sqs-col-2 .sqs-col-2 {\n  width: 100%;\n}\n\n.sqs-col-2 .sqs-col-1 {\n  width: 50%;\n}\n\n.sqs-col-1 {\n  width: 8.3333%;\n}\n\n.sqs-col-1 .sqs-col-1 {\n  width: 100%;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-row\n  .sqs-block:not(.float):not(.sqs-feature-gated-wrapper):first-child {\n  padding-top: 0;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-row\n  .sqs-block:not(.float):not(\n    .sqs-feature-gated-wrapper\n  ):first-child:last-child {\n  padding-bottom: 0;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-block\n  + .sqs-row\n  .sqs-block:not(.float):first-child {\n  padding-top: 17px;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-block\n  + .sqs-row\n  .sqs-block:not(.float):first-child:last-child {\n  padding-bottom: 17px;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-row\n  + .sqs-row\n  .sqs-block:not(.float):first-child {\n  padding-top: 17px;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-row\n  + .sqs-row\n  .sqs-block:not(.float):first-child:last-child {\n  padding-bottom: 17px;\n}\n\n.sqs-layout:not(.sqs-editing)\n  > .sqs-row:first-child\n  > [class*=\"sqs-col\"]:first-child\n  > .sqs-block:not(:first-child):last-child,\n.sqs-layout:not(.sqs-editing)\n  .sqs-block\n  + .sqs-row\n  .sqs-block:not(.float):last-child {\n  padding-bottom: 17px;\n}\n\n.sqs-layout:not(.sqs-editing)\n  .sqs-row\n  + .sqs-row:not(:last-child)\n  .sqs-block:last-child {\n  padding-bottom: 17px;\n}\n\n.sqs-block.sized .sqs-block-content {\n  overflow: hidden;\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.text-align-right {\n  text-align: right;\n}\n\n.columns-1 [class*=\"sqs-col-\"] {\n  width: 100% !important;\n}\n\n.sqs-block .state-message,\n.sqs-state-message {\n  font: 400 normal 12px / 22px \"Clarkson\", \"Helvetica Neue\", Helvetica, Arial,\n    sans-serif;\n  letter-spacing: normal;\n  padding: 19px;\n  padding-left: 60px;\n  color: #3e3e3e;\n  position: relative;\n  background-color: rgba(128, 128, 128, 0.15);\n}\n\n.sqs-block .state-message:after,\n.sqs-state-message:after {\n  content: \" \";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 60px;\n  width: 60px;\n  /* background: transparent\n    url(/universal/images-v6/icons/block-indicator-dark.png) no-repeat center; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-block .state-message:after,\n  .sqs-state-message:after {\n    /* background-image: url(\"/universal/images-v6/icons/block-indicator-dark@2x.png\"); */\n    background-size: 22px;\n  }\n}\n\n.sqs-block .state-message.information,\n.sqs-state-message.information {\n  background: #222;\n  padding: 30px 20px;\n  text-align: center;\n  color: #999;\n  font-size: 11px;\n}\n\n.sqs-block .state-message .title,\n.sqs-state-message .title {\n  padding-bottom: 8px;\n  font-size: 14px;\n}\n\nhtml.cameron .sqs-block .state-message .title,\nhtml.cameron .sqs-state-message .title {\n  color: #eee;\n}\n\n.sqs-block .state-message > .sqs-state-message-button,\n.sqs-state-message > .sqs-state-message-button,\n.sqs-block .state-message .sqs-state-message-buttons-wrapper,\n.sqs-state-message .sqs-state-message-buttons-wrapper {\n  margin-top: 19px;\n  margin-left: -41px;\n  display: block !important;\n  position: relative;\n}\n\n.sqs-block .state-message .sqs-state-message-button,\n.sqs-state-message .sqs-state-message-button {\n  cursor: pointer;\n  background: #3e3e3e;\n  padding: 11px;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n  line-height: 22px;\n  text-align: center;\n  display: inline-block;\n  position: relative;\n}\n\n.sqs-block .state-message .sqs-state-message-button,\n.sqs-state-message .sqs-state-message-button,\n.sqs-block .state-message .sqs-state-message-button > *,\n.sqs-state-message .sqs-state-message-button > * {\n  color: #fff !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqs-block .state-message .sqs-state-message-button:focus,\n.sqs-state-message .sqs-state-message-button:focus,\n.sqs-block .state-message .sqs-state-message-button > *:focus,\n.sqs-state-message .sqs-state-message-button > *:focus {\n  outline-color: #fff;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n}\n\n.sqs-block .state-message .sqs-state-message-button:focus:not(:focus-visible),\n.sqs-state-message .sqs-state-message-button:focus:not(:focus-visible),\n.sqs-block\n  .state-message\n  .sqs-state-message-button\n  > *:focus:not(:focus-visible),\n.sqs-state-message .sqs-state-message-button > *:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.sqs-block .state-message .sqs-state-message-button:hover,\n.sqs-state-message .sqs-state-message-button:hover {\n  background-color: #000;\n  box-shadow: none;\n  -moz-box-shadow: 0 0 5px 0 none;\n  -o-box-shadow: 0 0 5px 0 none;\n  -webkit-box-shadow: 0 0 5px 0 none;\n  box-shadow: 0 0 5px 0 none;\n}\n\n.sqs-block .state-message .sqs-state-message-button.disabled,\n.sqs-state-message .sqs-state-message-button.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqs-block .state-message .sqs-state-message-button.disabled > *,\n.sqs-state-message .sqs-state-message-button.disabled > * {\n  opacity: 0.5;\n}\n\n.sqs-block .state-message .sqs-state-message-button.disabled:hover,\n.sqs-state-message .sqs-state-message-button.disabled:hover {\n  background-color: #3e3e3e !important;\n}\n\n.sqs-layout.sqs-editing\n  .sqs-block\n  .sqs-block\n  .state-message\n  .sqs-state-message-button,\n.sqs-layout.sqs-editing\n  .sqs-block\n  .sqs-state-message\n  .sqs-state-message-button {\n  z-index: 1001;\n}\n\n.sqs-col-0 {\n  width: 0;\n  display: none;\n}\n\nhtml.squarespace-damask.is-expanded .sqs-block [data-block-state=\"invalid\"] {\n  display: none;\n}\n\nhtml.squarespace-damask.is-expanded\n  .sqs-jacquard.sqs-is-page-editing\n  .sqs-block\n  [data-block-state=\"invalid\"],\nhtml.squarespace-damask.is-expanded\n  .sqs-jacquard\n  .sqs-catalog\n  .sqs-block\n  [data-block-state=\"invalid\"] {\n  display: block;\n}\n\n.sqs-blockStatus {\n  display: none;\n  position: relative;\n  z-index: 1001;\n}\n\nhtml.squarespace-damask .sqs-blockStatus {\n  display: block;\n}\n\nhtml.squarespace-damask.is-expanded .sqs-blockStatus {\n  display: none;\n}\n\n.sqs-blockStatus-box {\n  padding: 22px 72px 22px 22px;\n  background: #fff;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  color: #3e3e3e;\n  font-family: \"Clarkson\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  line-height: 1em;\n  font-weight: normal;\n  letter-spacing: normal;\n  text-align: left;\n  cursor: default;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-shadow: -2px 1px 6px 1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);\n  -o-box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 5px 0 -2px 1px 6px 1px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n[data-state=\"invalid\"] .sqs-blockStatus-box {\n  border: 1px solid #f0523d;\n}\n\n.sqs-blockStatus-box-title {\n  margin: 0 0 11px 0;\n  font-size: 12px;\n  line-height: 1.65em;\n  font-weight: 500;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.sqs-blockStatus-box-message,\n.sqs-blockStatus-box-kbArticleLink {\n  font-size: 11px;\n  line-height: 1.65em;\n}\n\n.sqs-blockStatus-box-message a:link,\n.sqs-blockStatus-box-kbArticleLink a:link,\n.sqs-blockStatus-box-message a:hover,\n.sqs-blockStatus-box-kbArticleLink a:hover,\n.sqs-blockStatus-box-message a:visited,\n.sqs-blockStatus-box-kbArticleLink a:visited,\n.sqs-blockStatus-box-message a:active,\n.sqs-blockStatus-box-kbArticleLink a:active {\n  color: #3e3e3e !important;\n  border-bottom: 1px solid #3e3e3e !important;\n  text-decoration: none !important;\n}\n\n.sqs-blockStatus-box-message a:link:hover,\n.sqs-blockStatus-box-kbArticleLink a:link:hover,\n.sqs-blockStatus-box-message a:hover:hover,\n.sqs-blockStatus-box-kbArticleLink a:hover:hover,\n.sqs-blockStatus-box-message a:visited:hover,\n.sqs-blockStatus-box-kbArticleLink a:visited:hover,\n.sqs-blockStatus-box-message a:active:hover,\n.sqs-blockStatus-box-kbArticleLink a:active:hover {\n  color: #797979 !important;\n  border-color: #797979 !important;\n}\n\n.sqs-blockStatus-box-kbArticleLink {\n  display: inline-block;\n}\n\n.fluid-engine.is-editing .sqs-blockStatus-box-kbArticleLink,\n.sqs-editing .sqs-blockStatus-box-kbArticleLink {\n  display: none;\n}\n\n.sqs-blockStatus-box-button {\n  display: inline-block;\n  margin-top: 11px;\n  cursor: pointer;\n  outline: none;\n  background: #3e3e3e;\n  padding: 11px;\n  text-align: center;\n  transition: background-color 0.1s ease-in-out, opacity 0.1s ease-in-out;\n  line-height: 22px;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.sqs-blockStatus-box-button,\n.sqs-blockStatus-box-button > * {\n  color: #fff !important;\n  -webkit-appearance: none;\n  border: 0;\n  text-transform: uppercase;\n  outline: none;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.sqs-blockStatus-box-button:hover {\n  background-color: #000;\n  box-shadow: none;\n  -moz-box-shadow: 0 0 5px 0 none;\n  -o-box-shadow: 0 0 5px 0 none;\n  -webkit-box-shadow: 0 0 5px 0 none;\n  box-shadow: 0 0 5px 0 none;\n}\n\n.sqs-blockStatus-box-button.disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.sqs-blockStatus-box-button.disabled > * {\n  opacity: 0.5;\n}\n\n.sqs-blockStatus-box-button.disabled:hover {\n  background-color: #3e3e3e !important;\n}\n\n.sqs-blockStatus--overlayMode {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: auto;\n  height: auto;\n  background: transparent;\n  border: 1px solid #ededed;\n  pointer-events: none;\n  box-sizing: border-box;\n  z-index: 9000;\n}\n\n.sqs-blockStatus--overlayMode[data-state=\"invalid\"] {\n  opacity: 1;\n  visibility: visible;\n  border: 1px solid #f0523d;\n}\n\n.sqs-layout:not(.sqs-editing)\n  > .sqs-row:first-child\n  .sqs-block:not(.float):first-child\n  .sqs-blockStatus--overlayMode {\n  top: -25px;\n}\n\n.sqs-blockStatus--overlayMode .sqs-blockStatus-box {\n  position: absolute;\n  top: 6.25px;\n  right: 6.25px;\n  width: 380px;\n  max-width: calc(100% - 12.5px);\n  min-width: 320px;\n  border: 1px solid #d0d0d0 !important;\n  z-index: 1000;\n  pointer-events: all;\n  transition: opacity 0.2s ease-in;\n  opacity: 0;\n  visibility: hidden;\n}\n\n@media only screen and (pointer: coarse) and (orientation: portrait) and (max-device-height: 926px),\n  only screen and (pointer: coarse) and (orientation: landscape) and (max-device-width: 926px) {\n  .sqs-blockStatus--overlayMode .sqs-blockStatus-box {\n    right: 0;\n  }\n}\n\n.sqs-blockStatus[data-state=\"invalid\"]\n  .sqs-blockStatus-disclosure\n  .sqs-blockStatus-alert-badge {\n  color: #ce2c30;\n  position: absolute;\n  top: 11px;\n  right: 11px;\n  height: 22px;\n  width: 22px;\n  z-index: 1001;\n  pointer-events: all;\n}\n\n.fluid-engine.is-editing\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure\n  .sqs-blockStatus-alert-badge,\n.fluid-engine.is-editing\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure:empty:after,\n.sqs-editing\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure\n  .sqs-blockStatus-alert-badge,\n.sqs-editing\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure:empty:after {\n  opacity: 0;\n  visibility: hidden;\n}\n\nhtml.squarespace-damask\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure\n  .sqs-blockStatus-alert-badge,\nhtml.squarespace-damask\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure:empty:after {\n  cursor: pointer;\n}\n\nhtml.squarespace-damask\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-disclosure:hover\n  + .sqs-blockStatus-box,\nhtml.squarespace-damask\n  .sqs-blockStatus--overlayMode\n  .sqs-blockStatus-box:hover {\n  opacity: 1;\n  visibility: visible;\n}\n\n.sqs-block-audio\n  .sqs-audio-embed.sqs-block-is-placeholder\n  .sqs-widgets-audio-player\n  .action {\n  cursor: default;\n  pointer-events: none;\n}\n\n.sqs-block-audio\n  .sqs-audio-embed.sqs-block-is-placeholder\n  .sqs-widgets-audio-player\n  .action\n  .play {\n  opacity: 0.1;\n}\n\n.sqs-block-newsletter.sqs-block-focused .sqs-blockStatus,\n.sqs-block-form.sqs-block-focused .sqs-blockStatus,\n.sqs-block-opentable.sqs-block-focused .sqs-blockStatus,\n.sqs-block-newsletter.sqs-block-editing .sqs-blockStatus,\n.sqs-block-form.sqs-block-editing .sqs-blockStatus,\n.sqs-block-opentable.sqs-block-editing .sqs-blockStatus {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.fluid-engine.is-editing\n  .sqs-block-pricing-plan\n  .sqs-blockStatus[data-state=\"invalid\"]\n  .sqs-blockStatus-alert-badge,\n.sqs-editing\n  .sqs-block-pricing-plan\n  .sqs-blockStatus[data-state=\"invalid\"]\n  .sqs-blockStatus-alert-badge {\n  opacity: 1;\n  visibility: visible;\n}\n\nhtml.squarespace-damask.is-expanded\n  .sqs-is-page-editing\n  .sqs-block-newsletter\n  [data-block-state=\"invalid\"],\nhtml.squarespace-damask.is-expanded\n  .sqs-catalog\n  .sqs-block-newsletter\n  [data-block-state=\"invalid\"],\nhtml.squarespace-damask.is-expanded\n  .sqs-is-page-editing\n  .sqs-block-form\n  [data-block-state=\"invalid\"],\nhtml.squarespace-damask.is-expanded\n  .sqs-catalog\n  .sqs-block-form\n  [data-block-state=\"invalid\"] {\n  display: block;\n}\n\n.sqs-block-summary-v2:hover\n  .sqs-block-is-placeholder[data-block-state=\"invalid\"]\n  .summary-heading {\n  width: calc(100% - 80px);\n}\n\n.sqs-block-summary-v2:hover\n  .sqs-block-is-placeholder[data-block-state=\"invalid\"]\n  .summary-carousel-pager {\n  width: 80px;\n  padding-right: 30px;\n}\n\n.sqs-block-summary-v2 .sqsSummaryBlockThumbnailPlaceholder {\n  position: absolute;\n  top: 0;\n}\n\n.sqs-block-twitter .tweet-list.sqs-block-is-placeholder .tweet-avatar {\n  width: 48px;\n  height: 48px;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder {\n  position: relative;\n  width: 100%;\n  height: auto;\n  padding-bottom: 65%;\n  background: #f6f6f6;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder[data-block-state=\"invalid\"] {\n  display: none;\n}\n\nhtml.squarespace-damask\n  .sqsSummaryBlockThumbnailPlaceholder[data-block-state=\"invalid\"] {\n  display: block;\n}\n\nhtml.squarespace-damask.is-expanded\n  .sqsSummaryBlockThumbnailPlaceholder[data-block-state=\"invalid\"] {\n  display: none;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder-play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -41px;\n  margin-left: -31px;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder-timeline {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 50px;\n  width: 100%;\n  border-width: 23px 75px;\n  border-style: solid;\n  border-color: #e9e9e9;\n  background: #b4b4b4;\n  box-sizing: border-box;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder-timeline:before,\n.sqsSummaryBlockThumbnailPlaceholder-timeline:after {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder-timeline:before {\n  top: 0;\n  left: 0;\n  width: 50px;\n  height: 100%;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder-timeline:after {\n  top: 50%;\n  left: 48px;\n  margin-top: -6px;\n  height: 12px;\n  width: 12px;\n  border-radius: 100%;\n}\n\n.sqsSummaryBlockThumbnailPlaceholder + iframe {\n  display: none;\n}\n\n.sqs-block-video-placeholder {\n  padding-bottom: 65%;\n  background-image: linear-gradient(\n    0deg,\n    rgba(0, 0, 0, 0.9) 0%,\n    rgba(0, 0, 0, 0.4) 33%,\n    rgba(0, 0, 0, 0) 100%\n  );\n  background-color: #313131;\n  position: relative;\n}\n\n.sqs-block-video-placeholder + iframe {\n  display: none;\n}\n\n.sqs-block-video-placeholder__ui {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.sqs-block-video-placeholder--empty .sqs-block-video-placeholder__icon {\n  width: 26px;\n}\n\n.sqs-block-video-placeholder--in-progress .sqs-block-video-placeholder__icon {\n  background-color: transparent;\n  width: 80px;\n  height: 80px;\n}\n\n@keyframes loading-indicator-rotate-spinner {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loading-indicator-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35;\n  }\n\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124;\n  }\n}\n\n.sqs-block-video-placeholder .loading-indicator {\n  line-height: 0;\n  display: block;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  padding: 15px;\n}\n\n.sqs-block-video-placeholder .loading-indicator__spinner {\n  animation: loading-indicator-rotate-spinner 2s linear infinite;\n  height: 100%;\n  transform-origin: center center;\n  width: 100%;\n}\n\n.sqs-block-video-placeholder .loading-indicator__path {\n  fill: transparent;\n  stroke-dasharray: 150, 200;\n  stroke-dashoffset: -10;\n  animation: loading-indicator-dash 1.5s ease-in-out infinite;\n}\n\n.sqs-block {\n  position: relative;\n  height: auto;\n}\n\n.sqs-block:not(.sqs-block-html):not(.sqs-block-markdown) {\n  clear: both;\n}\n\n.sqs-block iframe.embedded-scripts-preview {\n  display: block;\n  position: relative;\n  border: 0;\n}\n\n.sqs-block .removed-script {\n  display: block;\n  opacity: 0.6;\n  font-style: italic;\n}\n\n.sqs-block-code img {\n  max-width: 100%;\n}\n\n.sqs-block-code .gm-style img {\n  max-width: none;\n}\n\n.sqs-block-hidden {\n  height: 0;\n  overflow: hidden;\n}\n\n.sqs-block[class*=\"float\"] {\n  z-index: 10 !important;\n  box-sizing: border-box;\n  clear: none;\n}\n\n.sqs-block[class*=\"float-left\"] {\n  float: left;\n  margin-right: 25px;\n}\n\n.sqs-block[class*=\"float-left\"] + .sqs-block[class*=\"float-left\"] {\n  clear: left;\n}\n\n.sqs-block[class*=\"float-right\"] {\n  float: right;\n  margin-left: 25px;\n}\n\n.sqs-block[class*=\"float-right\"] + .sqs-block[class*=\"float-right\"] {\n  clear: right;\n}\n\n.sqs-block .sqs-intrinsic {\n  position: relative !important;\n}\n\n.sqs-block .sqs-intrinsic .sqs-intrinsic-content {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  height: 100%;\n  max-width: none;\n  width: 100%;\n}\n\n@media screen and (max-width: 767px) {\n  .sqs-gallery-design-grid-slide {\n    width: 50% !important;\n    clear: none !important;\n  }\n}\n\nbody.squarespace-config .sqs-block-image .sqs-image-caption {\n  color: #999;\n}\n\nbody.squarespace-config .sqs-block-image .sqs-image-caption p {\n  margin-bottom: 0;\n}\n\nbody.squarespace-config\n  .sqs-block-image\n  .sqs-image-caption.sqs-placeholder-show {\n  margin-top: 1em;\n}\n\nbody.squarespace-config .sqs-block-image .sqs-image-caption .sqs-html-content {\n  min-height: 23px;\n}\n\n.sqs-block-image .sqs-html {\n  transition: max-height 0.3s ease-in-out, min-height 0.3s ease-in-out;\n  margin: auto;\n}\n\n.sqs-block-image .sqs-html.sqs-empty {\n  min-height: 0;\n  max-height: 0;\n  overflow: hidden;\n}\n\n.sqs-block-image.sqs-block-focused .sqs-html.sqs-empty {\n  max-height: none;\n  overflow: visible;\n}\n\n.sqs-block-image .sqs-editing-overlay {\n  z-index: 1;\n}\n\n.sqs-block-image:not(.sqs-block-focused)\n  .image-block-outer-wrapper.layout-caption-below\n  .image-caption-wrapper.sqs-empty {\n  padding-top: 0px;\n}\n\n.sqs-block-image .layout-caption-overlay .sqs-image-caption,\n.sqs-block-image .layout-caption-overlay-hover .sqs-image-caption {\n  z-index: 2;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper.sqs-html-focused {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.sqs-block-image .rte .rte-placeholder {\n  color: #999 !important;\n}\n\n[data-fluid-engine] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.fluid-engine .sqs-block {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.dd-drag-hidden {\n  display: none;\n}\n\n.dd-drag-grouped-item {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n}\n\n.yui3-dd-dragging {\n  z-index: 1;\n}\n\n.dd-reorder-items-count {\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: #d0d0d0;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 12px;\n  line-height: 22px;\n  color: #fff;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n\n.sqs-ui-font-family {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n[class^=\"sqs-ui-font-\"]:before,\n[class*=\" sqs-ui-font-\"]:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n[data-icon]:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: attr(data-icon);\n}\n\n.sqs-gallery-container iframe {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  display: block;\n}\n\n.sqs-gallery-controls .previous,\n.sqs-gallery-controls .next {\n  position: absolute;\n  top: 50%;\n  color: #fff !important;\n  z-index: 999;\n  font-size: 14px;\n  line-height: 40px;\n  margin-top: -30px;\n  background-color: rgba(0, 0, 0, 0.12);\n  display: inline-block;\n  padding: 10px;\n  transition: background-color 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.sqs-gallery-controls .previous:hover,\n.sqs-gallery-controls .next:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.sqs-gallery-controls .previous:focus:not([data-focus-visible-added]),\n.sqs-gallery-controls .next:focus:not([data-focus-visible-added]) {\n  outline: none;\n}\n\n.sqs-gallery-controls .previous {\n  left: 0px;\n}\n\n.sqs-gallery-controls .previous:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02C\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-gallery-controls .previous:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.sqs-gallery-controls .next {\n  right: 0px;\n}\n\n.sqs-gallery-controls .next:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02D\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-gallery-controls .next:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.sqs-gallery-controls .next:before,\n.sqs-gallery-controls .previous:before {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n\n.sqs-gallery-design-stacked {\n  position: relative;\n  text-align: left;\n}\n\n.sqs-gallery-design-stacked-slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-gallery-design-stacked-slide img {\n  box-shadow: #000 0em 0em 0em;\n}\n\n.sqs-gallery-design-stacked-slide.normal img {\n  height: 100%;\n}\n\n.sqs-gallery-design-stacked-slide:only-child {\n  cursor: default;\n}\n\n.sqs-gallery-design-stacked-scrollHorz,\n.sqs-gallery-design-stacked-swipe {\n  overflow: hidden;\n}\n\n.sqs-gallery-design-stacked-scrollHorz .sqs-gallery-design-stacked-slide,\n.sqs-gallery-design-stacked-swipe .sqs-gallery-design-stacked-slide {\n  position: relative;\n  float: left;\n}\n\n.sqs-gallery-design-stacked-swipe-wrapper {\n  overflow-x: scroll;\n  -webkit-transform: translatez(0);\n  -ms-overflow-style: none;\n  -ms-scroll-chaining: none;\n  -ms-scroll-snap-type: mandatory;\n  -ms-scroll-snap-points-x: snapinterval(0%, 100%);\n}\n\n.sqs-gallery-design-strip {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n}\n\n.sqs-gallery-design-strip .sqs-wrapper {\n  position: relative;\n  height: 100%;\n}\n\n.sqs-gallery-design-strip-slide {\n  float: left;\n  height: 100% !important;\n  max-width: none !important;\n  width: auto !important;\n  cursor: pointer;\n  position: relative;\n}\n\n.sqs-gallery-design-strip-slide img,\n.sqs-gallery-design-strip-slide .sqs-video-wrapper {\n  height: 100% !important;\n}\n\n.sqs-gallery-design-strip-slide:only-child {\n  cursor: default;\n}\n\n.sqs-gallery-design-autocolumns {\n  position: relative;\n}\n\n.sqs-gallery-design-autocolumns-slide {\n  position: absolute;\n}\n\n.sqs-gallery-design-autocolumns-slide img {\n  width: 100%;\n  display: inline-block;\n  transition: opacity 0.2s;\n  opacity: 1;\n}\n\n.sqs-gallery-design-autocolumns-slide img.loading {\n  opacity: 0;\n}\n\n.sqs-gallery-design-autocolumns-slide.content-fit img,\n.sqs-gallery-design-autocolumns-slide .content-fit img {\n  width: auto;\n}\n\n.sqs-gallery-design-autocolumns-slide.slide-stretched img {\n  height: 100%;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls {\n  overflow: hidden;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .next,\n.sqs-gallery-design-carousel .sqs-gallery-controls .previous {\n  display: block;\n  float: right;\n  position: relative;\n  top: auto;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  margin: 0 0 15px 0;\n  padding: 0;\n  background-color: transparent;\n  color: inherit !important;\n  font-size: 16px;\n  line-height: 16px;\n  cursor: pointer;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02D\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .next:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .previous {\n  margin-right: 10px;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02C\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .previous:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .sqs-disabled {\n  cursor: default;\n  opacity: 0.4;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-controls .sqs-hidden {\n  display: none;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery {\n  margin: 0 0 0 -1%;\n  white-space: nowrap;\n  vertical-align: top;\n  font-size: 0;\n  transition: -webkit-transform ease 0.4s;\n  transition: transform ease 0.4s;\n  transition: transform ease 0.4s, -webkit-transform ease 0.4s;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide {\n  display: inline-block;\n  width: 33.66666667%;\n  padding: 0 1%;\n  white-space: nowrap;\n  vertical-align: top;\n  font-size: 0;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide img {\n  width: 100%;\n  height: auto;\n}\n\n.sqs-gallery-design-carousel .sqs-gallery-design-carousel-slide * {\n  white-space: normal;\n}\n\n.sqs-gallery-design-list .sqs-gallery-design-list-slide {\n  overflow: hidden;\n  margin-bottom: 17px !important;\n  padding-bottom: 17px !important;\n}\n\n.sqs-gallery-design-list .sqs-gallery-image-container {\n  float: left;\n  width: 25%;\n  padding-right: 20px;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.sqs-gallery-design-list .sqs-gallery-meta-container {\n  float: left;\n  width: 75%;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.sqs-gallery-design-list\n  .sqs-gallery-design-list-slide.no-image\n  .sqs-gallery-image-container {\n  width: 0 !important;\n}\n\n.sqs-gallery-design-list\n  .sqs-gallery-design-list-slide.no-image\n  .sqs-gallery-meta-container {\n  width: 100% !important;\n}\n\n@media screen and (max-width: 480px) {\n  .sqs-gallery-design-list\n    .sqs-gallery-design-list-slide:not(.no-image)\n    .sqs-gallery-image-container {\n    width: 35% !important;\n  }\n\n  .sqs-gallery-design-list\n    .sqs-gallery-design-list-slide:not(.no-image)\n    .sqs-gallery-meta-container {\n    width: 65% !important;\n  }\n}\n\n.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide {\n  float: left;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide img {\n  height: 100%;\n}\n\n.sqs-gallery-design-autorows .sqs-gallery-design-autorows-slide .meta {\n  display: none;\n}\n\n.sqs-gallery-design-autogrid {\n  zoom: 1;\n}\n\n.sqs-gallery-design-autogrid:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-gallery-design-autogrid-slide {\n  position: relative;\n  float: left;\n}\n\n.sqs-gallery-design-autogrid-slide .img-wrapper {\n  height: 0;\n}\n\n.sqs-gallery-design-autogrid-slide img {\n  width: 100%;\n}\n\n.yui3-lightbox2 {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.yui3-lightbox2 .yui3-lightbox2-content {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  width: 100%;\n  overflow: hidden;\n}\n\n.yui3-lightbox2 .sqs-lightbox-slideshow {\n  height: 100%;\n  opacity: 0;\n  z-index: 100000001;\n}\n\n.yui3-lightbox2 .sqs-lightbox-slideshow .sqs-lightbox-padder {\n  position: absolute;\n  text-align: left;\n  top: 2%;\n  left: 2%;\n  bottom: 2%;\n  right: 2%;\n}\n\n.yui3-lightbox2 .sqs-lightbox-overlay {\n  position: absolute;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  background: #000;\n  height: 100%;\n  width: 100%;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta {\n  position: absolute;\n  padding: 20px;\n  color: #fff;\n  z-index: 100000001;\n  margin: 20px auto 0;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  opacity: 0;\n  transition: opacity ease-out 0.2s;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta.overlay-description-visible {\n  background: #000;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\n  background: rgba(0, 0, 0, 0.7);\n  opacity: 1 !important;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta p:first-child {\n  margin-top: 0;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta p:last-child {\n  margin-bottom: 0;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta h1 {\n  font-size: 1em;\n  color: #fff;\n  margin: 0 0 10px;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta p a {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.yui3-lightbox2 .sqs-lightbox-close,\n.yui3-lightbox2 .sqs-lightbox-previous,\n.yui3-lightbox2 .sqs-lightbox-next,\n.yui3-lightbox2 .sqs-lightbox-meta-trigger {\n  position: absolute;\n  z-index: 100000002;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ccc;\n  height: 20px;\n  width: 20px;\n  font-size: 26px;\n  cursor: pointer;\n  outline-color: currentColor;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next,\n.yui3-lightbox2 .sqs-lightbox-previous {\n  padding: 12px;\n  opacity: 0;\n  top: 50%;\n  margin-top: -22px;\n  transition: opacity 0.2s;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next.mouseover,\n.yui3-lightbox2 .sqs-lightbox-previous.mouseover,\n.yui3-lightbox2 .sqs-lightbox-next:focus,\n.yui3-lightbox2 .sqs-lightbox-previous:focus {\n  opacity: 1;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next {\n  right: 2%;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02D\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.yui3-lightbox2 .sqs-lightbox-previous {\n  left: 2%;\n}\n\n.yui3-lightbox2 .sqs-lightbox-previous:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02C\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.yui3-lightbox2 .sqs-lightbox-previous:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.yui3-lightbox2 .sqs-lightbox-next::before,\n.yui3-lightbox2 .sqs-lightbox-previous::before {\n  font-size: 22px;\n}\n\n.yui3-lightbox2 .sqs-lightbox-close {\n  padding: 2px;\n  right: 2%;\n  top: 2%;\n  text-align: right;\n}\n\n.yui3-lightbox2 .sqs-lightbox-close:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\E02E\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.yui3-lightbox2 .sqs-lightbox-close:before {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.yui3-lightbox2 .sqs-lightbox-meta-trigger {\n  bottom: 0;\n  right: 0;\n  padding: 2%;\n  text-align: center;\n  font-size: 26px;\n  line-height: 0.5;\n  text-align: right;\n}\n\nbody.sqs-lightbox-open {\n  position: static !important;\n  overflow-y: hidden;\n}\n\n.sqs-gallery img:not([src]) {\n  opacity: 0;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n\n.sqs-ui-font-family {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n[class^=\"sqs-ui-font-\"]:before,\n[class*=\" sqs-ui-font-\"]:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n[data-icon]:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: attr(data-icon);\n}\n\n#list-paging a,\n#item-paging a {\n  text-decoration: none;\n}\n\n#list-paging a.newer .pagination-icon:before,\n#item-paging a.newer .pagination-icon:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e000\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n#list-paging a.newer .pagination-icon:before,\n#item-paging a.newer .pagination-icon:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n#list-paging a.newer .pagination-icon:before,\n#item-paging a.newer .pagination-icon:before {\n  font-size: inherit;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n#list-paging a.older .pagination-icon:after,\n#item-paging a.older .pagination-icon:after {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e003\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n#list-paging a.older .pagination-icon:after,\n#item-paging a.older .pagination-icon:after {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n#list-paging a.older .pagination-icon:after,\n#item-paging a.older .pagination-icon:after {\n  font-size: inherit;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n#list-paging,\n#item-paging {\n  border-top: 1px solid #e3e3e3;\n  border-bottom: 1px solid #e3e3e3;\n  margin: 3em 0 0 0;\n}\n\n#list-paging a,\n#item-paging a {\n  padding: 1.5em 0;\n  display: inline-block;\n  width: 48%;\n}\n\n#list-paging a.newer .pagination-icon,\n#item-paging a.newer .pagination-icon {\n  margin-right: 0.5em;\n}\n\n#list-paging a.newer:after,\n#item-paging a.newer:after {\n  content: \"Newer\";\n}\n\n#list-paging a.older,\n#item-paging a.older {\n  float: right;\n  text-align: right;\n}\n\n#list-paging a.older .pagination-icon,\n#item-paging a.older .pagination-icon {\n  margin-left: 0.5em;\n}\n\n#list-paging a.older:before,\n#item-paging a.older:before {\n  content: \"Older\";\n}\n\n#list-paging a.disabled,\n#item-paging a.disabled {\n  color: #ddd;\n}\n\n.like-share {\n  float: right;\n}\n\n.like-share .sqs-simple-like {\n  display: inline-block;\n  margin-right: 0.5em;\n}\n\n.like-share .sqs-simple-like .like-icon {\n  float: none;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.like-share .squarespace-social-buttons {\n  display: inline-block;\n  margin-right: 0.5em;\n}\n\n.like-share .squarespace-social-buttons .ss-social-button-icon {\n  float: none;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.like-share.empty {\n  display: none;\n}\n\n.sqs-audio-playlist {\n  zoom: 1;\n}\n\n.sqs-audio-playlist.loading {\n  visibility: hidden;\n}\n\n.sqs-audio-playlist:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-audio-playlist.hidden {\n  display: none;\n}\n\n.sqs-audio-playlist .album-info {\n  width: 33%;\n  float: left;\n  zoom: 1;\n}\n\n.sqs-audio-playlist .album-info:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-audio-playlist .album-cover-wrapper {\n  position: relative;\n  width: 90px;\n  height: 90px;\n  margin-bottom: 30px;\n}\n\n.sqs-audio-playlist .album-controls {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n}\n\n.sqs-audio-playlist .album-controls .button {\n  transition: 0.25s all linear;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n  display: block;\n  width: 90px;\n  height: 90px;\n  margin-bottom: -45px;\n  margin-left: -45px;\n  background: #000;\n}\n\n.sqs-audio-playlist .album-controls .icon {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  margin-top: -20px;\n  margin-left: -10px;\n  width: 0px;\n  height: 0px;\n  border-top: 18px solid transparent;\n  border-bottom: 18px solid transparent;\n  border-left: 30px solid #fff;\n  transform: translatez();\n}\n\n.sqs-audio-playlist .album-title {\n  font-size: 1.5em;\n  margin: 0;\n}\n\n.sqs-audio-playlist .album-title a {\n  text-decoration: none;\n}\n\n.sqs-audio-playlist.playing .album-controls .button .icon {\n  border-width: 0px;\n  margin-top: -15px;\n  margin-left: -13px;\n}\n\n.sqs-audio-playlist.playing .album-controls .button .icon,\n.sqs-audio-playlist.playing .album-controls .button .icon:before {\n  height: 30px;\n  width: 10px;\n  background-color: #fff;\n}\n\n.sqs-audio-playlist.playing .album-controls .button .icon:before {\n  content: \"\";\n  display: block;\n  margin-left: 16px;\n}\n\n.sqs-audio-playlist.has-album-cover .album-cover-wrapper {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  margin-bottom: 20px;\n}\n\n.sqs-audio-playlist.has-album-cover .album-cover {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.sqs-audio-playlist.has-album-cover .button {\n  background: rgba(0, 0, 0, 0.7);\n  opacity: 0.9;\n}\n\n.sqs-audio-playlist.has-album-cover:hover .button {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.sqs-audio-playlist.has-album-cover.playing .album-controls .button {\n  margin: -15px;\n  bottom: 0;\n  left: 0;\n  transform: scale(0.4, 0.4);\n}\n\n.sqs-audio-playlist.has-album-cover.playing .album-controls .button .icon {\n  border-width: 0px;\n  margin-top: -15px;\n  margin-left: -13px;\n}\n\n.sqs-audio-playlist.has-album-cover.playing .album-controls .button .icon,\n.sqs-audio-playlist.has-album-cover.playing\n  .album-controls\n  .button\n  .icon:before {\n  height: 30px;\n  width: 10px;\n  background-color: #fff;\n}\n\n.sqs-audio-playlist.has-album-cover.playing\n  .album-controls\n  .button\n  .icon:before {\n  content: \"\";\n  display: block;\n  margin-left: 16px;\n}\n\n.sqs-audio-playlist.has-album-cover.playing .track {\n  opacity: 0.4;\n}\n\n.sqs-audio-playlist.has-album-cover.playing .track:hover,\n.sqs-audio-playlist.has-album-cover.playing .track.selected {\n  opacity: 1;\n}\n\n.sqs-audio-playlist .tracks {\n  float: right;\n  width: 60%;\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-audio-playlist .track {\n  list-style-type: none;\n  padding: 0;\n  margin: 0 0 5%;\n  cursor: pointer;\n  zoom: 1;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0;\n  text-transform: none;\n  font-size: 13px;\n  line-height: 1.4em;\n}\n\n.sqs-audio-playlist .track:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-audio-playlist .track-progress-bar {\n  clear: both;\n  height: 2px;\n  position: relative;\n  cursor: pointer;\n  padding-bottom: 2.5%;\n}\n\n.sqs-audio-playlist .track-progress-bar .bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 2px;\n  width: 0%;\n}\n\n.sqs-audio-playlist .track-progress-bar .bar.bg {\n  width: 100%;\n}\n\n.sqs-audio-playlist .track-progress-bar .bar.play-bar {\n  position: relative;\n}\n\n.sqs-audio-playlist .track-meta {\n  float: right;\n  text-align: right;\n}\n\n.sqs-audio-playlist .track-info .title a {\n  font-size: 16px;\n}\n\n.sqs-audio-playlist.tablet .album-info,\n.sqs-audio-playlist.tablet .tracks {\n  width: 100%;\n  float: none;\n}\n\n.sqs-audio-playlist.tablet .album-info {\n  padding-bottom: 8%;\n}\n\n.sqs-audio-playlist.tablet .album-cover-wrapper {\n  float: left;\n  margin-right: 30px;\n}\n\n.sqs-audio-playlist.tablet.has-album-cover .album-cover-wrapper {\n  width: 40%;\n  padding-bottom: 40%;\n}\n\n.sqs-audio-playlist.tablet.no-main-image .album-description {\n  margin-left: 120px;\n}\n\n.sqs-audio-playlist.phone .album-info,\n.sqs-audio-playlist.phone .tracks {\n  width: 100%;\n  float: none;\n}\n\n.sqs-audio-playlist.phone .tracks {\n  margin-top: 30px;\n}\n\n.sqs-audio-playlist.phone .tracks .track {\n  margin-bottom: 10%;\n}\n\n.sqs-audio-playlist.phone .album-info {\n  padding-bottom: 0;\n}\n\n.sqs-audio-playlist.phone .album-cover-wrapper {\n  float: none;\n  margin-right: 0;\n  margin-bottom: 20px;\n}\n\n.sqs-audio-playlist.phone.has-album-cover .album-cover-wrapper {\n  width: 100%;\n  padding-bottom: 100%;\n}\n\n.sqs-audio-playlist.phone.no-main-image .album-description {\n  margin-left: 0;\n}\n\n.sqs-audio-playlist .track-progress-bar {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);\n}\n\n.sqs-audio-playlist .track-progress-bar .bar {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);\n}\n\n.sqs-audio-playlist .track-progress-bar .bar.bg {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.sqs-audio-playlist .track-progress-bar .bar.load-bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.sqs-audio-playlist .track-progress-bar .bar.play-bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.sqs-audio-playlist .track-meta .track-time {\n  color: #000;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.sqs-audio-playlist .track-meta .actions {\n  color: #000;\n  color: rgba(0, 0, 0, 0.2);\n}\n\n.sqs-audio-playlist .track-meta .actions a {\n  color: #000;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.sqs-audio-playlist .track-meta .actions a:hover {\n  color: #000;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.sqs-audio-playlist .track-info .title a {\n  color: #000;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.sqs-audio-playlist .track-info .artist {\n  color: #000;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.hide-album-share-link .sqs-audio-playlist .squarespace-social-buttons {\n  display: none;\n}\n\nbody:not(.event-show-past-events) .eventlist.eventlist--past {\n  display: none;\n}\n\n.eventlist-event {\n  position: relative;\n  margin: 68px 0 0 0;\n  padding: 0;\n}\n\n.eventlist-event:first-of-type {\n  margin: 0;\n}\n\n.eventlist-column-thumbnail {\n  display: block;\n  float: left;\n  width: 35%;\n  height: 0;\n  padding-bottom: 23.33333333%;\n  text-decoration: none !important;\n  background: rgba(110, 110, 110, 0.05);\n}\n\n.eventlist-column-thumbnail img {\n  transition: opacity 0.3s ease-in;\n}\n\n.eventlist-column-thumbnail img:not(.loaded) {\n  opacity: 0;\n}\n\nbody:not(.event-thumbnails) .eventlist-column-thumbnail {\n  display: none;\n}\n\n.event-disable-item-pages .eventlist-column-thumbnail {\n  cursor: default;\n  pointer-events: none;\n}\n\n.event-thumbnail-size-11-square .eventlist-column-thumbnail {\n  padding-bottom: 35%;\n}\n\n.event-thumbnail-size-32-standard .eventlist-column-thumbnail {\n  padding-bottom: 23.33333333%;\n}\n\n.event-thumbnail-size-23-standard-vertical .eventlist-column-thumbnail {\n  padding-bottom: 52.5%;\n}\n\n.event-thumbnail-size-43-four-thirds .eventlist-column-thumbnail {\n  padding-bottom: 26.25%;\n}\n\n.event-thumbnail-size-169-widescreen .eventlist-column-thumbnail {\n  padding-bottom: 19.6875%;\n}\n\n.event-thumbnail-size-2401-anamorphic-widescreen .eventlist-column-thumbnail {\n  padding-bottom: 14.58333333%;\n}\n\n.eventlist-column-thumbnail:empty {\n  height: auto;\n  min-height: 100px;\n  padding-bottom: 0 !important;\n  background: transparent;\n}\n\n.eventlist-column-date {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 35%;\n  margin: 0;\n  padding: 0;\n  color: #333 !important;\n  text-decoration: none !important;\n}\n\n.event-disable-item-pages .eventlist-column-date {\n  cursor: default;\n  pointer-events: none;\n}\n\nbody:not(.event-date-label) .eventlist-column-date {\n  display: none;\n}\n\nbody:not(.event-thumbnails) .eventlist-column-date {\n  position: static;\n  float: left;\n  width: 70px;\n}\n\n.eventlist-datetag {\n  display: table;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: auto;\n  min-height: 70px;\n  width: 70px;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  color: #333;\n  font-size: 14px;\n  line-height: 14px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\nbody:not(.event-thumbnails) .eventlist-datetag {\n  position: static;\n  background: #e8ecec;\n}\n\n.eventlist-event:not(.eventlist-event--hasimg) .eventlist-datetag {\n  top: 0;\n  background: #e8ecec;\n}\n\n.eventlist-datetag-inner {\n  display: table-cell;\n  vertical-align: middle;\n  margin: 0;\n  padding: 6px;\n  color: inherit;\n  font-size: 0;\n  line-height: 0;\n  letter-spacing: 0;\n}\n\n.eventlist-datetag-startdate--month,\n.eventlist-datetag-startdate--day,\n.eventlist-datetag-time,\n.eventlist-datetag-enddate {\n  margin: 3px 0;\n  line-height: 1em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.eventlist-event--past .eventlist-datetag-startdate--month,\n.eventlist-event--past .eventlist-datetag-startdate--day,\n.eventlist-event--past .eventlist-datetag-time,\n.eventlist-event--past .eventlist-datetag-enddate {\n  opacity: 0.3;\n}\n\n.eventlist-datetag-time,\n.eventlist-datetag-enddate {\n  border-top: 1px solid #ddd;\n  margin: 6px 0 0 0;\n  padding-top: 6px;\n  font-size: 11px;\n}\n\n.eventlist-datetag-startdate--month {\n  font-size: 14px;\n  margin-top: 6px;\n}\n\n.eventlist-datetag-startdate--day {\n  font-size: 26px;\n}\n\nbody:not(.event-date-label-time) .eventlist-datetag-time {\n  display: none;\n}\n\n.eventlist-datetag-status {\n  display: none;\n  position: absolute;\n  top: 0px;\n  left: 35px;\n  width: 1px;\n  height: 70px;\n  background: #000;\n  transform: rotate(45deg);\n}\n\n.eventlist-event--past .eventlist-datetag-status {\n  display: block;\n}\n\n.eventlist-event--past.eventlist-event--multiday .eventlist-datetag-status,\nbody.event-date-label-time .eventlist-event--past .eventlist-datetag-status {\n  top: 0px;\n  height: 85px;\n  transform: rotate(38deg);\n}\n\n.eventlist-column-info {\n  float: left;\n  width: 65%;\n  padding: 0 0 0 34px;\n  box-sizing: border-box;\n}\n\nbody:not(.event-thumbnails) .eventlist-column-info {\n  width: calc(100% - 70px);\n}\n\nbody:not(.event-thumbnails):not(.event-date-label) .eventlist-column-info {\n  width: 100%;\n  padding-left: 0;\n}\n\n.eventlist-cats {\n  margin: 0 0 4.25px 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.4em;\n}\n\n.eventlist-cats a {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\nbody:not(.event-list-show-cats) .eventlist-cats {\n  display: none;\n}\n\n.eventlist-title {\n  margin: 0 0 17px 0 !important;\n  padding: 0 !important;\n  font-size: 28px !important;\n  line-height: 1.2em !important;\n}\n\n.eventlist-title .eventlist-title-link {\n  margin: 0 !important;\n  padding: 0 !important;\n  color: inherit !important;\n  text-decoration: none !important;\n  font-size: inherit !important;\n  line-height: inherit !important;\n}\n\n.event-disable-item-pages .eventlist-title .eventlist-title-link {\n  cursor: default;\n  pointer-events: none;\n}\n\n.eventlist-meta {\n  list-style-type: none;\n  margin: 0 0 17px 0;\n  padding: 0;\n}\n\n.eventlist-meta-item {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n\n.event-icons .eventlist-meta-item {\n  position: relative;\n  padding-left: 25.5px;\n}\n\n.event-icons .eventlist-meta-item:before {\n  opacity: 0.5;\n  position: absolute;\n  top: 3px;\n  left: -2px;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-date:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e015\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-date:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-time:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e00c\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-time:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-address:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e02f\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.event-icons .eventlist-meta-item.eventlist-meta-address:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\nbody:not(.event-list-date) .eventlist-meta-date,\nbody:not(.event-list-time) .eventlist-meta-time,\nbody:not(.event-list-address) .eventlist-meta-address {\n  display: none;\n}\n\n.event-list-time\n  .eventlist-event--multiday\n  .eventlist-meta-date\n  .event-date:after {\n  content: \", \";\n}\n\n.event-list-time .eventlist-event--multiday .eventlist-meta-time {\n  display: inline-block;\n}\n\n.eventlist-meta-address-line:after {\n  content: \", \";\n}\n\n.eventlist-meta-address-line:last-of-type:after {\n  content: none;\n}\n\nbody:not(.event-list-icalgcal-links) .eventlist-meta-export {\n  display: none;\n}\n\n.eventlist-meta-export-divider {\n  margin: 0 4px;\n}\n\n.eventlist-meta-export-divider:before {\n  content: \"\\00B7\";\n}\n\nbody:not(.event-excerpts) .eventlist-description,\nbody:not(.event-excerpts) .eventlist-excerpt {\n  display: none;\n}\n\n.eventlist-excerpt {\n  margin: 0 0 17px 0;\n}\n\n.eventlist a.eventlist-button {\n  margin: 5.66666667px 0 25.5px 0;\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\nbody:not(.event-list-cta-button) .eventlist a.eventlist-button,\nbody.event-disable-item-pages .eventlist a.eventlist-button {\n  display: none !important;\n}\n\nbody:not(.event-list-like-and-share-buttons) .eventlist-actions {\n  display: none;\n}\n\n.eventlist-actions .sqs-simple-like {\n  line-height: inherit;\n}\n\n.eventlist-actions .sqs-simple-like .like-count {\n  margin-right: 1.2em;\n}\n\n.eventlist-actions .sqs-simple-like .like-count:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e012\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.eventlist-actions .sqs-simple-like .like-count:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.eventlist-actions .sqs-simple-like .like-count:before {\n  margin-right: 0.2em;\n  position: relative;\n  top: 0.13em;\n  font-size: 1.2em;\n  width: auto;\n  height: auto;\n  line-height: inherit;\n  text-align: left;\n  vertical-align: initial;\n}\n\n.eventlist-actions .sqs-simple-like .like-icon {\n  display: none;\n}\n\n.eventlist-actions .ss-social-button:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e02b\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.eventlist-actions .ss-social-button:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.eventlist-actions .ss-social-button:before {\n  margin-right: 0.4em;\n  font-size: 0.85em;\n  width: auto;\n  height: auto;\n  line-height: inherit;\n  text-align: left;\n  vertical-align: initial;\n}\n\n.eventlist-actions .ss-social-button div {\n  display: inline-block;\n}\n\n.eventlist-actions .ss-social-button-icon {\n  display: none !important;\n}\n\n.eventlist-filter {\n  font-size: 18px;\n  line-height: 1em;\n  margin: 0 0 51px 0;\n}\n\n.eventlist-past-upcoming-divider {\n  display: none;\n  height: 0;\n  border: none;\n  border-top: 1px solid rgba(230, 230, 230, 0.8);\n  font-size: 68px;\n  line-height: 68px;\n}\n\n.eventlist--upcoming + .eventlist--past .eventlist-past-upcoming-divider {\n  display: block;\n}\n\n.event-datetime-divider:before {\n  content: \" \\2013 \";\n}\n\n.eventitem-backlink {\n  display: inline-block;\n  margin: 0 0 51px 0;\n  text-transform: uppercase;\n}\n\n.eventitem-backlink:before {\n  content: \"\\2190\\0020 \";\n}\n\nbody:not(.event-item-back-link) .eventitem-backlink {\n  display: none;\n}\n\n.eventitem {\n  position: relative;\n}\n\n.eventitem-column-meta {\n  float: left;\n  width: 30%;\n  box-sizing: border-box;\n}\n\n.eventitem-title {\n  margin: 0 0 34px 0 !important;\n  padding: 0 !important;\n  font-size: 28px !important;\n  line-height: 1.2em !important;\n  word-break: break-word;\n  word-wrap: break-word;\n}\n\n.eventitem-meta {\n  list-style-type: none;\n  margin: 0 0 17px 0;\n  padding: 0;\n}\n\n.eventitem-meta-item {\n  margin: 0;\n  padding: 0;\n  font-size: 0.9em;\n  line-height: 1.6em;\n}\n\n.eventitem--multiday .eventitem-meta-date .event-date:after {\n  content: \", \";\n}\n\n.eventitem--multiday .eventitem-meta-time {\n  display: inline-block;\n}\n\n.eventitem-meta-address-line:after {\n  content: \", \";\n}\n\n.eventitem-meta-address-line:last-of-type:after {\n  content: none;\n}\n\n.eventitem-meta-address-line.eventitem-meta-address-line--title {\n  display: block;\n}\n\n.eventitem-meta-address-line.eventitem-meta-address-line--title:after {\n  content: none;\n}\n\nbody:not(.event-icalgcal-links) .event-meta-addtocalendar-container {\n  display: none;\n}\n\n.eventitem-meta-export-divider {\n  margin: 0 4px;\n}\n\n.eventitem-meta-export-divider:before {\n  content: \"\\00B7\";\n}\n\n.event-meta-socialicon-container .sqs-simple-like {\n  line-height: inherit;\n}\n\n.event-meta-socialicon-container .sqs-simple-like .like-count {\n  margin-right: 1.2em;\n}\n\n.event-meta-socialicon-container .sqs-simple-like .like-count:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e012\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.event-meta-socialicon-container .sqs-simple-like .like-count:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.event-meta-socialicon-container .sqs-simple-like .like-count:before {\n  margin-right: 0.2em;\n  position: relative;\n  top: 0.13em;\n  font-size: 1.2em;\n  width: auto;\n  height: auto;\n  line-height: inherit;\n  text-align: left;\n  vertical-align: initial;\n}\n\n.event-meta-socialicon-container .sqs-simple-like .like-icon {\n  display: none;\n}\n\n.event-meta-socialicon-container .ss-social-button:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e02b\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.event-meta-socialicon-container .ss-social-button:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.event-meta-socialicon-container .ss-social-button:before {\n  margin-right: 0.4em;\n  font-size: 0.85em;\n  width: auto;\n  height: auto;\n  line-height: inherit;\n  text-align: left;\n  vertical-align: initial;\n}\n\n.event-meta-socialicon-container .ss-social-button div {\n  display: inline-block;\n}\n\n.event-meta-socialicon-container .ss-social-button-icon {\n  display: none !important;\n}\n\nbody:not(.event-like-and-share-buttons) .event-meta-socialicon-container {\n  display: none;\n}\n\n.eventitem-column-content {\n  float: left;\n  width: 70%;\n  padding-left: 34px;\n  box-sizing: border-box;\n}\n\n.eventitem-content-footer {\n  margin: 17px 0 0 0;\n}\n\n.eventitem-content-footer .eventitem-sourceurl {\n  margin: 0 0 8.5px 0;\n}\n\n.eventitem-content-footer .eventitem-meta {\n  margin: 0 0 8.5px 0;\n}\n\n.eventitem-content-footer .eventitem-meta > * {\n  font-size: inherit;\n}\n\n.eventitem-pager {\n  margin: 170px 0 0 0;\n}\n\n.eventitem-pager-newer,\n.eventitem-pager-older {\n  float: left;\n  display: inline-block;\n  text-decoration: none;\n  box-sizing: border-box;\n}\n\n.eventitem-pager-newer {\n  float: right;\n  text-align: right;\n}\n\n.eventitem-pager-disabled {\n  opacity: 0.4;\n}\n\n.event-list-compact-view .eventlist-column-thumbnail,\n.event-list-compact-view .eventlist-column-date,\n.event-list-compact-view .eventlist-column-info {\n  width: 100% !important;\n}\n\n.event-list-compact-view .eventlist-column-thumbnail:empty {\n  min-height: 0;\n}\n\n.event-list-compact-view.event-thumbnail-size-11-square\n  .eventlist-column-thumbnail {\n  padding-bottom: 100%;\n}\n\n.event-list-compact-view.event-thumbnail-size-32-standard\n  .eventlist-column-thumbnail {\n  padding-bottom: 66.666%;\n}\n\n.event-list-compact-view.event-thumbnail-size-23-standard-vertical\n  .eventlist-column-thumbnail {\n  padding-bottom: 150%;\n}\n\n.event-list-compact-view.event-thumbnail-size-43-four-thirds\n  .eventlist-column-thumbnail {\n  padding-bottom: 75%;\n}\n\n.event-list-compact-view.event-thumbnail-size-169-widescreen\n  .eventlist-column-thumbnail {\n  padding-bottom: 56.25%;\n}\n\n.event-list-compact-view.event-thumbnail-size-2401-anamorphic-widescreen\n  .eventlist-column-thumbnail {\n  padding-bottom: 41.666%;\n}\n\n.event-list-compact-view .eventlist-datetag {\n  left: 0;\n  right: auto;\n}\n\n.event-list-compact-view.event-thumbnails\n  .eventlist-event--hasimg\n  .eventlist-datetag {\n  left: 10px;\n}\n\n.event-list-compact-view.event-thumbnails\n  .eventlist-event:not(.eventlist-event--hasimg)\n  .eventlist-column-date {\n  position: static;\n  float: left;\n  width: 70px;\n}\n\n.event-list-compact-view.event-thumbnails\n  .eventlist-event:not(.eventlist-event--hasimg)\n  .eventlist-column-date\n  .eventlist-datetag {\n  position: static;\n}\n\n.event-list-compact-view .eventlist-column-info {\n  margin: 25.5px 0 0 0;\n  padding: 0;\n}\n\n.event-list-compact-viewbody:not(.event-thumbnails):not(.event-date-label)\n  .eventlist-event {\n  margin-top: 34px;\n}\n\n.event-list-compact-viewbody:not(.event-thumbnails):not(.event-date-label)\n  .eventlist-column-info {\n  margin-top: 0;\n}\n\n.event-list-compact-view .eventitem-title {\n  margin-bottom: 17px !important;\n}\n\n.event-list-compact-view .eventitem-column-meta {\n  margin-bottom: 34px;\n}\n\n.event-list-compact-view .eventitem-column-meta,\n.event-list-compact-view .eventitem-column-content {\n  float: none;\n  width: auto;\n  padding: 0;\n}\n\n.event-item-compact-view .eventitem-title {\n  margin-bottom: 17px !important;\n}\n\n.event-item-compact-view .eventitem-column-meta {\n  margin-bottom: 34px;\n}\n\n.event-item-compact-view .eventitem-column-meta,\n.event-item-compact-view .eventitem-column-content {\n  float: none;\n  width: auto;\n  padding: 0;\n}\n\n@media only screen and (max-width: 639px) {\n  .eventlist-column-thumbnail,\n  .eventlist-column-date,\n  .eventlist-column-info {\n    width: 100% !important;\n  }\n\n  .eventlist-column-thumbnail:empty {\n    min-height: 0;\n  }\n\n  .event-thumbnail-size-11-square .eventlist-column-thumbnail {\n    padding-bottom: 100%;\n  }\n\n  .event-thumbnail-size-32-standard .eventlist-column-thumbnail {\n    padding-bottom: 66.666%;\n  }\n\n  .event-thumbnail-size-23-standard-vertical .eventlist-column-thumbnail {\n    padding-bottom: 150%;\n  }\n\n  .event-thumbnail-size-43-four-thirds .eventlist-column-thumbnail {\n    padding-bottom: 75%;\n  }\n\n  .event-thumbnail-size-169-widescreen .eventlist-column-thumbnail {\n    padding-bottom: 56.25%;\n  }\n\n  .event-thumbnail-size-2401-anamorphic-widescreen .eventlist-column-thumbnail {\n    padding-bottom: 41.666%;\n  }\n\n  .eventlist-datetag {\n    left: 0;\n    right: auto;\n  }\n\n  .event-thumbnails .eventlist-event--hasimg .eventlist-datetag {\n    left: 10px;\n  }\n\n  .event-thumbnails\n    .eventlist-event:not(.eventlist-event--hasimg)\n    .eventlist-column-date {\n    position: static;\n    float: left;\n    width: 70px;\n  }\n\n  .event-thumbnails\n    .eventlist-event:not(.eventlist-event--hasimg)\n    .eventlist-column-date\n    .eventlist-datetag {\n    position: static;\n  }\n\n  .eventlist-column-info {\n    margin: 25.5px 0 0 0;\n    padding: 0;\n  }\n\n  body:not(.event-thumbnails):not(.event-date-label) .eventlist-event {\n    margin-top: 34px;\n  }\n\n  body:not(.event-thumbnails):not(.event-date-label) .eventlist-column-info {\n    margin-top: 0;\n  }\n\n  .eventitem-title {\n    margin-bottom: 17px !important;\n  }\n\n  .eventitem-column-meta {\n    margin-bottom: 34px;\n  }\n\n  .eventitem-column-meta,\n  .eventitem-column-content {\n    float: none;\n    width: auto;\n    padding: 0;\n  }\n\n  .eventitem-title {\n    margin-bottom: 17px !important;\n  }\n\n  .eventitem-column-meta {\n    margin-bottom: 34px;\n  }\n\n  .eventitem-column-meta,\n  .eventitem-column-content {\n    float: none;\n    width: auto;\n    padding: 0;\n  }\n}\n\n.event-time-24hr {\n  display: none;\n}\n\n.event-time-format .event-time-12hr {\n  display: none;\n}\n\n.event-time-format .event-time-24hr {\n  display: inline;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .arrow.previous-slide:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e000\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .arrow.previous-slide:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .arrow.previous-slide:before {\n  font-size: 16px;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e003\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .arrow.next-slide:before {\n  font-size: 16px;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.collection-type-gallery.gallery-design-grid .dots,\n.collection-type-gallery.gallery-design-grid .thumbnail-wrapper,\n.collection-type-gallery.gallery-design-grid .circles,\n.collection-type-gallery.gallery-design-grid .numbers,\n.collection-type-gallery.gallery-design-grid .simple {\n  display: none;\n}\n\n.collection-type-gallery.gallery-design-grid .slide {\n  cursor: pointer;\n}\n\n.collection-type-gallery.gallery-design-grid .slide .slide-meta {\n  display: none;\n}\n\n.collection-type-gallery.gallery-design-grid .slide > a {\n  display: block;\n  height: 100%;\n}\n\n.collection-type-gallery.gallery-design-grid.lightbox-style-light\n  .yui3-lightbox2\n  .sqs-lightbox-overlay {\n  background: #fff;\n}\n\n.collection-type-gallery.gallery-design-grid.lightbox-style-light\n  .yui3-lightbox2\n  .sqs-lightbox-close,\n.collection-type-gallery.gallery-design-grid.lightbox-style-light\n  .yui3-lightbox2\n  .sqs-lightbox-previous,\n.collection-type-gallery.gallery-design-grid.lightbox-style-light\n  .yui3-lightbox2\n  .sqs-lightbox-next,\n.collection-type-gallery.gallery-design-grid.lightbox-style-light\n  .yui3-lightbox2\n  .sqs-lightbox-meta-trigger {\n  color: #111;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery {\n  cursor: pointer;\n  opacity: 0;\n  zoom: 1;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  transition: opacity 0.2s ease-out;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .arrow,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .icons\n  span {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .gallery-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .gallery-wrapper\n  .slides {\n  display: block;\n  width: 100%;\n  height: 100% !important;\n  transition: opacity 0.2s ease-out;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .gallery-wrapper\n  .slides\n  .slide {\n  opacity: 0;\n  zoom: 1;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  height: 100% !important;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .gallery-wrapper\n  .slides\n  .slide\n  > a {\n  display: block;\n  height: 100%;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slides-controls {\n  position: relative;\n  z-index: 991;\n  overflow: hidden;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .arrow {\n  z-index: 997;\n  position: absolute;\n  width: 100%;\n  height: 40px;\n  margin-top: -20px;\n  text-align: center;\n  line-height: 40px;\n  font-weight: bold;\n  color: #fff;\n  background: #222;\n  transition: opacity 0.1s ease-in;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .arrow.previous-slide {\n  left: 0;\n  margin-left: 2%;\n  width: 40px;\n  height: 40px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .arrow.next-slide {\n  right: 0;\n  margin-right: 2%;\n  float: right;\n  width: 40px;\n  height: 40px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .arrow.sqs-disabled {\n  opacity: 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .dots,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .thumbnail-wrapper,\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .circles,\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .numbers,\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .simple {\n  display: none;\n  margin: 20px 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .dots.sqs-gallery-controls-disabled,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .thumbnail-wrapper.sqs-gallery-controls-disabled,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .circles.sqs-gallery-controls-disabled,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .numbers.sqs-gallery-controls-disabled,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple.sqs-gallery-controls-disabled {\n  display: none;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .dots {\n  text-align: center;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .dots\n  .dot {\n  font-size: 30px;\n  margin: 0 5px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .dots\n  .dot:after {\n  content: \"·\";\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .numbers {\n  text-align: center;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .numbers\n  .number {\n  font-size: 12px;\n  margin: 0 0.5em;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .circles {\n  font-size: 0;\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  z-index: 999;\n  width: 100%;\n  height: 16px;\n  margin: 40px 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .circles\n  .circle {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border: 2px solid #fff;\n  margin: 0 5px;\n  border-radius: 100%;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .circles\n  .circle.sqs-active-slide {\n  background: #fff;\n}\n\n.collection-type-gallery:not(.gallery-design-grid) .sqs-system-gallery .simple {\n  text-align: center;\n  font-size: 12px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .previous.sqs-disabled,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .next.sqs-disabled {\n  opacity: 0.5;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .current-index {\n  letter-spacing: 2px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .current-index:after {\n  content: \" / \";\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .previous {\n  float: left;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .previous\n  .navigation-text {\n  display: inline;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .next {\n  float: right;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .simple\n  .next\n  .navigation-text {\n  display: inline;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .next\n  .navigation-text,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .previous\n  .navigation-text {\n  display: none;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .dots\n  .dot,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .numbers\n  .number,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .thumbnail-wrapper\n  .thumbnail {\n  opacity: 0.5;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .dots\n  .dot.sqs-active-slide,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .numbers\n  .number.sqs-active-slide,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .thumbnail-wrapper\n  .thumbnail.sqs-active-slide {\n  opacity: 1;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .thumbnail-wrapper\n  .thumbnail {\n  width: 100px !important;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta {\n  display: none;\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  z-index: 996;\n  height: auto;\n  background: rgba(0, 0, 0, 0.7);\n  padding: 24px 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .title {\n  margin: 0;\n  font-size: 14px;\n  color: #fff;\n  padding: 0 2%;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .description {\n  margin-top: 0.5em;\n  display: inline-block;\n  padding: 0 2%;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .description\n  p,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .clickthrough\n  a {\n  font-size: 13px;\n  line-height: 1.4em;\n  color: #999;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .description\n  p,\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .clickthrough {\n  margin: 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .description\n  p\n  a {\n  color: #999;\n  text-decoration: underline;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .clickthrough {\n  display: inline-block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .clickthrough\n  a {\n  border-bottom: 1px solid;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery\n  .slide-meta\n  .clickthrough\n  a:before {\n  content: \"Read more\";\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-init {\n  position: relative;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-init\n  > * {\n  display: none;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-ready {\n  opacity: 0.01;\n  opacity: 1;\n  zoom: 1;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=10)\";\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-interaction\n  .arrow {\n  opacity: 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-interaction.sqs-system-gallery-hover-slides-left\n  .arrow.previous-slide:not(.sqs-disabled),\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-video-iframe\n  .arrow.previous-slide:not(.sqs-disabled) {\n  opacity: 1;\n}\n\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-interaction.sqs-system-gallery-hover-slides-right\n  .arrow.next-slide:not(.sqs-disabled),\n.collection-type-gallery:not(.gallery-design-grid)\n  .sqs-system-gallery.sqs-system-gallery-video-iframe\n  .arrow.next-slide:not(.sqs-disabled) {\n  opacity: 1;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).dialog-open\n  .arrow.previous-slide:not(.sqs-disabled) {\n  opacity: 1;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).dialog-open\n  .arrow.next-slide:not(.sqs-disabled) {\n  opacity: 1;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-thumbnails\n  .sqs-system-gallery\n  .thumbnail-wrapper {\n  display: block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-bullets\n  .sqs-system-gallery\n  .dots {\n  display: block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-numbers\n  .sqs-system-gallery\n  .numbers {\n  display: block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-circles\n  .sqs-system-gallery\n  .slide-meta {\n  bottom: auto;\n  top: 0;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-circles\n  .sqs-system-gallery\n  .circles {\n  display: block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-navigation-simple\n  .sqs-system-gallery\n  .simple {\n  display: block;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-info-overlay-always-show\n  .sqs-system-gallery\n  .slide-meta.show {\n  display: block;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-info-overlay-show-on-hover\n  .slide:hover\n  .slide-meta.show {\n  display: block;\n}\n\n.collection-type-gallery:not(.gallery-design-grid):not(.gallery-show-arrows)\n  .sqs-system-gallery\n  .arrow {\n  opacity: 0 !important;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-11-square\n  .sqs-system-gallery.sqs-system-gallery-init {\n  padding-bottom: 100%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-11-square\n  .thumbnail-wrapper {\n  height: 100px;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-32-standard\n  .sqs-system-gallery.sqs-system-gallery-init {\n  padding-bottom: 66.66%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-32-standard\n  .thumbnail-wrapper {\n  height: 66px;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-43-four-thirds\n  .sqs-system-gallery.sqs-system-gallery-init {\n  padding-bottom: 75%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-43-four-thirds\n  .thumbnail-wrapper {\n  height: 75px;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-169-widescreen\n  .sqs-system-gallery.sqs-system-gallery-init {\n  padding-bottom: 56.25%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-aspect-ratio-169-widescreen\n  .thumbnail-wrapper {\n  height: 56.25px;\n}\n\n.collection-type-gallery:not(.gallery-design-grid).gallery-arrow-style-circular\n  .sqs-system-gallery\n  .arrow {\n  border-radius: 100%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-arrow-style-round-corners\n  .sqs-system-gallery\n  .arrow {\n  border-radius: 10%;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-arrow-style-rectangular\n  .sqs-system-gallery\n  .arrow {\n  border-radius: 0;\n}\n\n.collection-type-gallery:not(\n    .gallery-design-grid\n  ).gallery-arrow-style-no-background\n  .sqs-system-gallery\n  .arrow {\n  border-radius: 0;\n  background: none;\n}\n\n@media screen and (max-width: 480px) {\n  .collection-type-gallery .sqs-system-gallery .slide-meta {\n    display: none !important;\n  }\n}\n\n.tweak-product-list-scarcity-font {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 12px;\n  letter-spacing: 1px;\n  text-transform: none;\n}\n\n.tweak-product-details-scarcity-font {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 16px;\n  letter-spacing: 1px;\n  text-transform: none;\n}\n\n.tweak-product-details-restock-notification-font {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n\n#productList {\n  clear: both;\n  margin-left: -3%;\n  margin-top: -3%;\n  width: 103%;\n}\n\n#productList .product {\n  cursor: pointer;\n  float: left;\n  margin-left: 2.91262136%;\n  margin-top: 3%;\n  position: relative;\n  width: 22.08737864%;\n}\n\n#productList .product .product-image {\n  transition: opacity 0.14s ease-out;\n}\n\n#productList .product .product-image .intrinsic {\n  padding-bottom: 100%;\n  line-height: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n#productList .product .product-image .intrinsic > div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n#productList .product .product-image img {\n  transition: opacity 0.3s ease-out;\n}\n\n#productList .product .product-mark {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  background: #222;\n  padding: 6px 8px;\n  color: #fff;\n  line-height: 1em;\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n}\n\n#productList .product .product-title {\n  font-size: 15px;\n  line-height: 1.5em;\n  margin-top: 1em;\n}\n\n#productList .product .product-price {\n  font-size: 12px;\n  display: none;\n  line-height: 1.5em;\n}\n\n#productList .product .product-price .original-price {\n  text-decoration: line-through;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n}\n\n#productList .product .product-price .strikeout {\n  text-decoration: line-through;\n}\n\n#productList .product .product-scarcity {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 12px;\n  letter-spacing: 1px;\n  text-transform: none;\n  color: #1d1d1d;\n}\n\n#productList .product .product-image img {\n  will-change: opacity;\n}\n\n#productList .product:hover .product-image img {\n  opacity: 0.8;\n  filter: alpha(opacity=80);\n}\n\n#productList .product .product-quick-view-button-hover-zone {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n}\n\n#productList .product:hover .product-quick-view-button-hover-zone {\n  opacity: 1;\n}\n\n#productList .product .product-quick-view-button-container {\n  position: absolute;\n  top: auto;\n  bottom: 10%;\n  width: 100%;\n  text-align: center;\n}\n\n#productList .product:nth-child(4n + 1) {\n  clear: left;\n}\n\n#productList ul.pagination {\n  clear: both;\n  margin-top: 15px;\n  margin-left: 2.91262136%;\n}\n\n#productList ul.pagination li {\n  display: inline-block;\n}\n\n#productList ul.pagination li.previous-page {\n  text-align: left;\n}\n\n#productList ul.pagination li.next-page {\n  text-align: right;\n}\n\n.product-list-alignment-center #productList .product-title,\n.product-list-alignment-center #productList .product-price,\n.product-list-alignment-center #productList .product-scarcity {\n  text-align: center;\n}\n\n.product-item-size-11-square #productList .product .product-image .intrinsic,\n.product-item-size-11-square\n  #productList\n  .product\n  .product-quick-view-button-hover-zone {\n  padding-bottom: 100%;\n}\n\n.product-item-size-32-standard #productList .product .product-image .intrinsic,\n.product-item-size-32-standard\n  #productList\n  .product\n  .product-quick-view-button-hover-zone {\n  padding-bottom: 66.666%;\n}\n\n.product-item-size-23-standard-vertical\n  #productList\n  .product\n  .product-image\n  .intrinsic,\n.product-item-size-23-standard-vertical\n  #productList\n  .product\n  .product-quick-view-button-hover-zone {\n  padding-bottom: 150%;\n}\n\n.product-item-size-43-four-thirds\n  #productList\n  .product\n  .product-image\n  .intrinsic,\n.product-item-size-43-four-thirds\n  #productList\n  .product\n  .product-quick-view-button-hover-zone {\n  padding-bottom: 75%;\n}\n\n.product-item-size-169-widescreen\n  #productList\n  .product\n  .product-image\n  .intrinsic,\n.product-item-size-169-widescreen\n  #productList\n  .product\n  .product-quick-view-button-hover-zone {\n  padding-bottom: 56.25%;\n}\n\n@media only screen and (min-width: 700px) {\n  .no-touch .product-list-titles-overlay #productList .product .product-image {\n    margin: 0;\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product\n    .product-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(255, 255, 255, 0.6);\n    color: #fff;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-mark {\n    font-size: 12px;\n    line-height: normal;\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-meta {\n    position: absolute;\n    width: 80%;\n    margin: 0 10%;\n    top: 50%;\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-title {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5em;\n    color: #000;\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-price {\n    font-size: 13px;\n    line-height: normal;\n    color: #000;\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product\n    .product-overlay {\n    opacity: 0;\n    transition: opacity 0.3s ease-out;\n    filter: alpha(opacity=0);\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-mark {\n    opacity: 1;\n    transition: opacity 0.3s ease-out;\n    filter: alpha(opacity=100);\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-meta {\n    opacity: 0;\n    transition: opacity 0.35s cubic-bezier(0, 0, 1, 1);\n    filter: alpha(opacity=0);\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-title {\n    margin-top: 5px;\n    transition: margin 0.3s cubic-bezier(0, 0, 0.28, 1);\n  }\n\n  .no-touch .product-list-titles-overlay #productList .product .product-title,\n  .no-touch .product-list-titles-overlay #productList .product .product-price {\n    text-align: center;\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product:hover\n    .product-overlay {\n    opacity: 1;\n    filter: alpha(opacity=100);\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product:hover\n    .product-mark {\n    opacity: 0;\n    filter: alpha(opacity=0);\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product:hover\n    .product-meta {\n    opacity: 1;\n    filter: alpha(opacity=100);\n  }\n\n  .no-touch\n    .product-list-titles-overlay\n    #productList\n    .product:hover\n    .product-title {\n    margin-top: 0;\n  }\n}\n\n.product-list-titles-under .product-meta {\n  margin-top: 0 !important;\n}\n\n.show-product-price #productList .product .product-price {\n  display: block;\n}\n\n.sqs-style-mode .product-overlay {\n  opacity: 1 !important;\n}\n\n.sqs-style-mode .product-mark {\n  opacity: 0 !important;\n}\n\n.sqs-style-mode .product-meta {\n  opacity: 1 !important;\n}\n\n#productNav {\n  text-transform: uppercase;\n  margin-bottom: 30px;\n  display: none;\n}\n\n.product-title.mobile {\n  display: none;\n}\n\n#productDetails {\n  position: relative;\n  float: right;\n  width: 48.5%;\n}\n\n#productDetails .product-title {\n  margin: 0 0 0.5em;\n}\n\n#productDetails .product-mark {\n  float: right;\n  background: #222;\n  padding: 6px 8px;\n  color: #fff;\n  line-height: 1em;\n  text-transform: uppercase;\n  -webkit-font-smoothing: subpixel-antialiased;\n  font-size: 12px;\n}\n\n#productDetails .product-price {\n  margin: 1em 0;\n  font-size: 16px;\n  line-height: 1.5em;\n}\n\n#productDetails .product-price input {\n  width: 130px;\n  height: 30px;\n  padding-left: 5px;\n}\n\n#productDetails .product-price .minimum-price {\n  margin-top: 3px;\n  margin-left: 10px;\n}\n\n#productDetails .product-price .original-price {\n  text-decoration: line-through;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n}\n\n#productDetails .product-price .strikeout {\n  text-decoration: line-through;\n}\n\n#productDetails .product-variants .variant-option {\n  margin: 1.2em 0;\n}\n\n#productDetails .product-variants .variant-option select {\n  font-family: initial;\n}\n\n#productDetails .product-variants .variant-out-of-stock {\n  color: #c00;\n}\n\n#productDetails .product-variants .variant-radiobtn-wrapper {\n  display: none;\n}\n\n#productDetails .product-quantity-select {\n  margin-top: 1.2em 0;\n}\n\n#productDetails .product-scarcity {\n  margin-top: 1em;\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 16px;\n  letter-spacing: 1px;\n  text-transform: none;\n  color: #1d1d1d;\n}\n\n#productDetails .product-restock-notification:not([hidden]) {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\n\n#productDetails\n  .product-restock-notification:not([hidden])\n  ~ .sqs-add-to-cart-button-wrapper {\n  display: none;\n}\n\n#productDetails\n  .product-restock-notification:not([hidden])\n  .product-restock-cta {\n  color: #1d1d1d;\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n\n#productDetails\n  .product-restock-notification:not([hidden])\n  .product-restock-form {\n  display: flex;\n}\n\n#productDetails\n  .product-restock-notification:not([hidden])\n  .product-restock-form\n  > input[type=\"text\"] {\n  margin-right: 22px;\n}\n\n#productDetails\n  .product-restock-notification:not([hidden])\n  .product-restock-form\n  > input[type=\"submit\"] {\n  font-size: 13px;\n}\n\n#productDetails input:not([type=\"submit\"]) {\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n\n.product-sharing {\n  display: none;\n}\n\n.product-social-sharing .product-sharing {\n  display: block;\n}\n\n#productGallery {\n  width: 48.5%;\n  float: left;\n}\n\n#productGallery .intrinsic {\n  max-width: 100%;\n}\n\n#productGallery .wrapper {\n  padding-bottom: 100%;\n  position: relative;\n}\n\n#productGallery #productSlideshow {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n#productGallery #productSlideshow .slide {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n#productGallery #productThumbnails {\n  margin-left: -5px;\n  visibility: hidden;\n  overflow: hidden;\n}\n\n#productGallery #productThumbnails .slide {\n  width: 50px;\n  height: 50px;\n  margin: 5px 0 0 5px;\n  font-size: 0;\n  cursor: pointer;\n  float: left;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.product-gallery-size-11-square #productGallery .intrinsic .wrapper {\n  padding-bottom: 100%;\n}\n\n.product-gallery-size-32-standard #productGallery .intrinsic .wrapper {\n  padding-bottom: 66.666%;\n}\n\n.product-gallery-size-23-standard-vertical #productGallery .intrinsic .wrapper {\n  padding-bottom: 150%;\n}\n\n.product-gallery-size-43-four-thirds #productGallery .intrinsic .wrapper {\n  padding-bottom: 75%;\n}\n\n.product-gallery-size-169-widescreen #productGallery .intrinsic .wrapper {\n  padding-bottom: 56.25%;\n}\n\n.product-description {\n  clear: both;\n  margin-top: 24px;\n}\n\n#productWrapper .ProductItem-relatedProducts-label {\n  margin-top: 50px;\n  margin-bottom: 22px;\n}\n\n#productWrapper .relatedProducts #productList {\n  margin: 0 -50px -50px 0;\n  width: calc(100% + -50px);\n  display: flex;\n}\n\n#productWrapper .relatedProducts-item {\n  position: relative;\n  box-sizing: border-box;\n  width: calc(33.33333333% - 50px);\n  margin: 0 50px 0 0;\n  cursor: pointer;\n}\n\n#productWrapper .relatedProducts-item:nth-child(n + 4) {\n  display: none;\n}\n\n.tweak-v1-related-products-image-aspect-ratio-11-square\n  #productWrapper\n  .relatedProducts-item\n  .intrinsic {\n  padding-bottom: 100% !important;\n}\n\n.tweak-v1-related-products-image-aspect-ratio-32-standard\n  #productWrapper\n  .relatedProducts-item\n  .intrinsic {\n  padding-bottom: 66.666% !important;\n}\n\n.tweak-v1-related-products-image-aspect-ratio-23-standard-vertical\n  #productWrapper\n  .relatedProducts-item\n  .intrinsic {\n  padding-bottom: 150% !important;\n}\n\n.tweak-v1-related-products-image-aspect-ratio-43-four-three\n  #productWrapper\n  .relatedProducts-item\n  .intrinsic {\n  padding-bottom: 75% !important;\n}\n\n.tweak-v1-related-products-image-aspect-ratio-169-widescreen\n  #productWrapper\n  .relatedProducts-item\n  .intrinsic {\n  padding-bottom: 56.25% !important;\n}\n\n.tweak-v1-related-products-details-alignment-left\n  #productWrapper\n  .relatedProducts-item\n  .product-meta\n  > * {\n  text-align: left;\n}\n\n.tweak-v1-related-products-details-alignment-center\n  #productWrapper\n  .relatedProducts-item\n  .product-meta\n  > * {\n  text-align: center;\n}\n\n.show-product-item-nav #productWrapper #productNav {\n  display: block;\n}\n\n.sqs-add-to-cart-button-wrapper {\n  visibility: hidden;\n}\n\n.sqs-add-to-cart-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  font-size: 13px;\n}\n\n.sqs-add-to-cart-button-inner {\n  position: relative;\n}\n\n.sqs-add-to-cart-button.cart-adding .sqs-spin {\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n}\n\n.sqs-add-to-cart-button.cart-adding .status-text {\n  display: inline-block;\n}\n\n.sqs-add-to-cart-button.cart-added .status-text {\n  margin-left: 0;\n}\n\n.collection-type-products .sqs-add-to-cart-button-wrapper {\n  margin: 20px 0;\n}\n\n.collection-type-products .sqs-add-to-cart-button {\n  padding: 1.5em 4em !important;\n}\n\n.sqs-donate-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n@media only screen and (max-width: 700px) {\n  #productSummary .product-title {\n    display: none;\n  }\n\n  #productSummary .product-title.mobile {\n    display: block;\n  }\n\n  .product-meta {\n    margin-top: 0 !important;\n  }\n\n  #productDetails,\n  #productGallery {\n    width: 100%;\n    float: none;\n  }\n\n  #productList {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 0;\n  }\n\n  #productList .product {\n    float: left;\n    margin-left: 0;\n    margin-top: 0;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 3%;\n  }\n\n  #productList .product .product-image {\n    margin-bottom: 3%;\n  }\n\n  #productList .product .product-image .content-fit {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n\n  #productList .product .product-image img {\n    transition: opacity 0.3s ease-out;\n  }\n\n  .product-quick-view {\n    display: none;\n  }\n}\n\n.captcha-container.rendered {\n  margin-bottom: 24px;\n  width: 304px;\n}\n\n.captcha-container.rendered.align-center {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.captcha-container.rendered.align-right {\n  margin-left: auto;\n}\n\n.newsletter-block {\n  transition: opacity 0.2s ease-out;\n}\n\n.newsletter-block * {\n  box-sizing: border-box;\n}\n\n.newsletter-block:not(.rendered) {\n  opacity: 0;\n}\n\n.newsletter-block .newsletter-form-wrapper {\n  width: 100%;\n  padding: 34px 34px;\n  background: rgba(0, 0, 0, 0.05);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 15px;\n}\n\n.newsletter-block .newsletter-form-wrapper.hidden,\n.newsletter-block .newsletter-form-wrapper .hidden {\n  display: none;\n}\n\n.newsletter-block .newsletter-form {\n  text-align: center;\n}\n\n.newsletter-block .newsletter-form-wrapper--alignLeft .newsletter-form {\n  text-align: left;\n}\n\n.newsletter-block .newsletter-form-wrapper--alignRight .newsletter-form {\n  text-align: right;\n}\n\n.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container,\n.newsletter-block .newsletter-form-wrapper--layoutStack .newsletter-form-body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container {\n  margin-bottom: 12px;\n  margin-top: 12px;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack\n  .newsletter-form-button-wrapper.submit-wrapper {\n  margin-top: 0;\n  order: 999999;\n}\n\n.newsletter-block .newsletter-form-wrapper--layoutStack .captcha-container,\n.newsletter-block .newsletter-form-wrapper--layoutStack .newsletter-form-body {\n  align-items: center;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignLeft\n  .captcha-container,\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignLeft\n  .newsletter-form-body {\n  align-items: flex-start;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignRight\n  .captcha-container,\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack.newsletter-form-wrapper--alignRight\n  .newsletter-form-body {\n  align-items: flex-end;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--alignCenter.newsletter-form-wrapper {\n  padding: 34px 17px;\n}\n\n.newsletter-block .newsletter-form-header {\n  width: 85%;\n  margin: 0 auto;\n}\n\n.newsletter-block .newsletter-form-wrapper--alignLeft .newsletter-form-header,\n.newsletter-block .newsletter-form-wrapper--alignRight .newsletter-form-header {\n  width: 100%;\n  margin: 0;\n}\n\n.newsletter-block .newsletter-form-header-title {\n  margin: 0 0 17px 0;\n  padding: 0;\n  color: #272727;\n  font-size: 30px;\n  line-height: 1.2em;\n  text-align: inherit;\n}\n\n.newsletter-block .newsletter-form-header-title a {\n  text-decoration: underline;\n}\n\n.newsletter-block .newsletter-form-header-description {\n  color: #272727;\n}\n\n.newsletter-block .newsletter-form-header-description p {\n  margin: 17px 0;\n  padding: 0;\n  font-size: 15px;\n  line-height: 1.6em;\n}\n\n.newsletter-block .newsletter-form-header-description a {\n  text-decoration: underline;\n}\n\n.newsletter-block .newsletter-form-body {\n  padding: 0 0 12px 0;\n}\n\n.newsletter-block .newsletter-form-body > .field-error {\n  display: block;\n  max-width: 270px;\n}\n\n.newsletter-block .newsletter-form-fields-wrapper {\n  display: inline-block;\n  width: auto;\n  margin: 12px 0 0 0;\n}\n\n.newsletter-block .newsletter-form-name-fieldset {\n  display: inline-block;\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack\n  .newsletter-form-name-fieldset {\n  display: block;\n  width: 100%;\n  max-width: 250px;\n}\n\n.newsletter-block .newsletter-form-field-wrapper {\n  display: inline-block;\n  width: auto;\n  min-width: 250px;\n  padding: 6px 3px;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--alignLeft\n  .newsletter-form-field-wrapper {\n  padding: 6px 3px 6px 0;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--alignRight\n  .newsletter-form-field-wrapper {\n  padding: 6px 0 6px 3px;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack\n  .newsletter-form-field-wrapper {\n  display: block;\n  width: 100%;\n  max-width: 250px;\n  padding: 6px 0;\n}\n\n.newsletter-block .newsletter-form-field-label {\n  display: none;\n}\n\n.newsletter-block .newsletter-form-field-element {\n  transition: \"background 0.3s ease-out, border 0.3s ease-out\";\n  width: 100%;\n  padding: 1em;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  font-family: inherit;\n  font-size: 15px;\n  line-height: normal;\n  outline: none;\n}\n\n.newsletter-block .newsletter-form-field-element:focus {\n  background: #fff;\n}\n\n.newsletter-block .newsletter-form-field-element::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.newsletter-block .newsletter-form-field-element:-moz-placeholder {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.newsletter-block .newsletter-form-field-element::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.newsletter-block .newsletter-form-field-element:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.newsletter-block .newsletter-form-field-wrapper .field-error {\n  display: block;\n  margin-bottom: 12px;\n  padding: 6px;\n  background: #fed9db;\n  color: #f23d3d;\n  font-size: 12px;\n  line-height: normal;\n}\n\n.newsletter-block .newsletter-form-button-wrapper {\n  display: inline-block;\n  width: auto;\n  margin: 12px 0 0 0;\n  padding: 6px 3px;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--alignLeft\n  .newsletter-form-button-wrapper {\n  padding: 6px 3px 6px 0;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--alignRight\n  .newsletter-form-button-wrapper {\n  padding: 6px 0 6px 3px;\n}\n\n.newsletter-block\n  .newsletter-form-wrapper--layoutStack\n  .newsletter-form-button-wrapper {\n  display: block;\n  padding: 6px 0;\n}\n\n.newsletter-block .newsletter-form-button {\n  position: relative;\n  width: auto;\n  padding: 1em 2.25em;\n  color: #fff;\n  background-color: #272727;\n  border: 1px solid #272727 !important;\n  font-family: inherit;\n  font-size: 15px;\n  line-height: normal;\n  font-weight: normal;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n}\n\n.newsletter-block .newsletter-form-spinner.sqs-spin.light.large {\n  visibility: hidden;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 22px;\n  width: 22px;\n  margin-top: -11px;\n  margin-left: -11px;\n}\n\n.newsletter-block\n  .newsletter-form:not(.submitting)\n  .newsletter-form-spinner.sqs-spin.light.large {\n  animation: none;\n}\n\n.newsletter-block\n  .newsletter-form.submitting\n  .newsletter-form-spinner.sqs-spin.light.large {\n  visibility: visible;\n}\n\n.newsletter-block .newsletter-form.submitting .newsletter-form-button-label {\n  visibility: hidden;\n}\n\n.newsletter-block .newsletter-form-footnote {\n  color: #272727;\n}\n\n.newsletter-block .newsletter-form-footnote p {\n  opacity: 0.8;\n  margin: 17px 0;\n  padding: 0;\n  font-size: 12px !important;\n  line-height: normal;\n}\n\n.newsletter-block .newsletter-form-footnote p:last-child {\n  margin-bottom: 0;\n}\n\n.newsletter-block .newsletter-form-footnote a {\n  text-decoration: underline;\n}\n\n.newsletter-block .form-submission-text {\n  color: #272727;\n}\n\n.newsletter-block .form-submission-text p {\n  margin: 17px 0;\n  padding: 0;\n  font-size: 15px;\n  line-height: 1.6em;\n}\n\n.newsletter-block .form-submission-text p:first-child {\n  margin-top: 0;\n}\n\n.newsletter-block .form-submission-text p:last-child {\n  margin-bottom: 0;\n}\n\n.newsletter-block .form-submission-text a {\n  text-decoration: underline;\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper {\n  padding: 0px;\n  background: rgba(0, 0, 0, 0);\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper.newsletter-form-wrapper--alignCenter.newsletter-form-wrapper {\n  padding: 0px 0px;\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .newsletter-form-header-title {\n  color: #fff;\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .newsletter-form-header-description,\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .newsletter-form-footnote,\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .form-submission-text {\n  color: #fff;\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .newsletter-form-field-element {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-wrapper\n  .newsletter-form-button {\n  color: #fff;\n  background-color: #272727;\n  border: 1px solid #272727 !important;\n}\n\n.newsletter-block .form-submission-text:focus:not(:focus-visible),\n.newsletter-block .form-submission-html:focus:not(:focus-visible),\n.newsletter-block .field-error:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.newsletter-style-dark .newsletter-block .newsletter-form-wrapper,\n.newsletter-style-dark .newsletter-block .newsletter-form-header-title,\n.newsletter-style-dark .newsletter-block .newsletter-form-header-description p,\n.newsletter-style-dark .newsletter-block .newsletter-form-footnote p,\n.newsletter-style-dark .newsletter-block .form-submission-text p {\n  color: #272727;\n}\n\n.newsletter-style-dark .newsletter-block .newsletter-form-header-title a,\n.newsletter-style-dark .newsletter-block .newsletter-form-header-description a,\n.newsletter-style-dark .newsletter-block .newsletter-form-footnote a,\n.newsletter-style-dark .newsletter-block .form-submission-text a {\n  color: #272727;\n}\n\n.newsletter-style-light .newsletter-block .newsletter-form-wrapper,\n.newsletter-style-light .newsletter-block .newsletter-form-header-title,\n.newsletter-style-light .newsletter-block .newsletter-form-header-description p,\n.newsletter-style-light .newsletter-block .newsletter-form-footnote p,\n.newsletter-style-light .newsletter-block .form-submission-text p {\n  color: #fff;\n}\n\n.newsletter-style-light .newsletter-block .newsletter-form-header-title a,\n.newsletter-style-light .newsletter-block .newsletter-form-header-description a,\n.newsletter-style-light .newsletter-block .newsletter-form-footnote a,\n.newsletter-style-light .newsletter-block .form-submission-text a {\n  color: #fff;\n}\n\n.newsletter-style-light .newsletter-block .newsletter-form-field-element {\n  color: #272727;\n}\n\n.newsletter-form-small-mode .newsletter-form-header {\n  width: 100%;\n}\n\n.newsletter-form-small-mode .newsletter-form-header-title {\n  font-size: 27px !important;\n  margin: 0 0 14px 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-header-description p {\n  margin: 0 0 14px 0;\n  line-height: normal;\n}\n\n.newsletter-form-small-mode .newsletter-form-body {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 6px 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-fields-wrapper {\n  display: block;\n  order: 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-name-fieldset {\n  width: 100%;\n}\n\n.newsletter-form-small-mode .newsletter-form-field-wrapper,\n.newsletter-form-small-mode .newsletter-form-button-wrapper {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  padding: 5px 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-button-wrapper {\n  margin: 6px 0 0 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-button-wrapper {\n  order: 2;\n}\n\n.newsletter-form-small-mode .newsletter-form-body .captcha-container.rendered {\n  order: 1;\n  margin-bottom: 0;\n  width: auto;\n}\n\n.newsletter-form-small-mode .newsletter-form-footnote p {\n  margin: 14px 0;\n}\n\n.newsletter-form-small-mode .newsletter-form-footnote p:last-child {\n  margin-bottom: 0;\n}\n\n.newsletter-form-small-mode .disclaimer-container {\n  font-size: 14px;\n}\n\n.newsletter-form-small-mode .form-submission-text p {\n  margin: 14px 0;\n  line-height: normal;\n}\n\n.newsletter-form-small-mode .form-submission-text p:first-child {\n  margin-top: 0;\n}\n\n.newsletter-form-small-mode .form-submission-text p:last-child {\n  margin-bottom: 0;\n}\n\n@media screen and (max-width: 320px) {\n  .newsletter-block .newsletter-form-header {\n    width: 100%;\n  }\n\n  .newsletter-block .newsletter-form-header-title {\n    font-size: 27px !important;\n    margin: 0 0 14px 0;\n  }\n\n  .newsletter-block .newsletter-form-header-description p {\n    margin: 0 0 14px 0;\n    line-height: normal;\n  }\n\n  .newsletter-block .newsletter-form-body {\n    display: flex;\n    flex-direction: column;\n    padding: 0 0 6px 0;\n  }\n\n  .newsletter-block .newsletter-form-fields-wrapper {\n    display: block;\n    order: 0;\n  }\n\n  .newsletter-block .newsletter-form-name-fieldset {\n    width: 100%;\n  }\n\n  .newsletter-block .newsletter-form-field-wrapper,\n  .newsletter-block .newsletter-form-button-wrapper {\n    display: block;\n    width: 100%;\n    min-width: 0;\n    padding: 5px 0;\n  }\n\n  .newsletter-block .newsletter-form-button-wrapper {\n    margin: 6px 0 0 0;\n  }\n\n  .newsletter-block .newsletter-form-button-wrapper {\n    order: 2;\n  }\n\n  .newsletter-block .newsletter-form-body .captcha-container.rendered {\n    order: 1;\n    margin-bottom: 0;\n    width: auto;\n  }\n\n  .newsletter-block .newsletter-form-footnote p {\n    margin: 14px 0;\n  }\n\n  .newsletter-block .newsletter-form-footnote p:last-child {\n    margin-bottom: 0;\n  }\n\n  .newsletter-block .disclaimer-container {\n    font-size: 14px;\n  }\n\n  .newsletter-block .form-submission-text p {\n    margin: 14px 0;\n    line-height: normal;\n  }\n\n  .newsletter-block .form-submission-text p:first-child {\n    margin-top: 0;\n  }\n\n  .newsletter-block .form-submission-text p:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.newsletter-block.newsletter-form-has-small-container .newsletter-form-header {\n  width: 100%;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-header-title {\n  font-size: 27px !important;\n  margin: 0 0 14px 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-header-description\n  p {\n  margin: 0 0 14px 0;\n  line-height: normal;\n}\n\n.newsletter-block.newsletter-form-has-small-container .newsletter-form-body {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 6px 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-fields-wrapper {\n  display: block;\n  order: 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-name-fieldset {\n  width: 100%;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-field-wrapper,\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-button-wrapper {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  padding: 5px 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-button-wrapper {\n  margin: 6px 0 0 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-button-wrapper {\n  order: 2;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-body\n  .captcha-container.rendered {\n  order: 1;\n  margin-bottom: 0;\n  width: auto;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-footnote\n  p {\n  margin: 14px 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .newsletter-form-footnote\n  p:last-child {\n  margin-bottom: 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container .disclaimer-container {\n  font-size: 14px;\n}\n\n.newsletter-block.newsletter-form-has-small-container .form-submission-text p {\n  margin: 14px 0;\n  line-height: normal;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .form-submission-text\n  p:first-child {\n  margin-top: 0;\n}\n\n.newsletter-block.newsletter-form-has-small-container\n  .form-submission-text\n  p:last-child {\n  margin-bottom: 0;\n}\n\n.source-code {\n  white-space: pre;\n  overflow: auto;\n}\n\n.cm-keyword {\n  color: #708;\n}\n\n.cm-atom {\n  color: #219;\n}\n\n.cm-number {\n  color: #164;\n}\n\n.cm-def {\n  color: blue;\n}\n\n.cm-variable-2 {\n  color: #05a;\n}\n\n.cm-variable-3 {\n  color: #085;\n}\n\n.cm-comment {\n  color: #aaa;\n}\n\n.cm-string {\n  color: #1a1;\n}\n\n.cm-string-2 {\n  color: #5f0;\n}\n\n.cm-meta {\n  color: #555;\n}\n\n.cm-error {\n  color: red;\n}\n\n.cm-qualifier {\n  color: #555;\n}\n\n.cm-builtin {\n  color: #30a;\n}\n\n.cm-bracket {\n  color: #cc7;\n}\n\n.cm-tag {\n  color: #170;\n}\n\n.cm-attribute {\n  color: #00c;\n}\n\n.cm-header {\n  color: #000;\n}\n\n.cm-quote {\n  color: #900;\n}\n\n.cm-hr {\n  color: #999;\n}\n\n.cm-link {\n  color: #00c;\n}\n\n.dark .cm-comment {\n  color: #75715e;\n}\n\n.dark .cm-atom {\n  color: #ae81ff;\n}\n\n.dark .cm-number {\n  color: #ae81ff;\n}\n\n.dark .cm-property,\n.dark .cm-attribute {\n  color: #a6e22e;\n}\n\n.dark .cm-keyword {\n  color: #f92672;\n}\n\n.dark .cm-string {\n  color: #e6db74;\n}\n\n.dark .cm-variable-2 {\n  color: #9effff;\n}\n\n.dark .cm-def {\n  color: #fd971f;\n}\n\n.dark .cm-error {\n  background: #f92672;\n  color: #f8f8f0;\n}\n\n.dark .cm-bracket {\n  color: #f8f8f2;\n}\n\n.dark .cm-tag {\n  color: #f92672;\n}\n\n.dark .cm-link {\n  color: #ae81ff;\n}\n\n.code-block .state-message:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n.foursquare-block ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  line-height: 1.4em;\n}\n\n.foursquare-block ul .foursquare-checkin {\n  margin-bottom: 12px;\n}\n\n.foursquare-block ul .foursquare-checkin a {\n  border: 0;\n}\n\n.foursquare-block ul .foursquare-checkin .foursquare-icon-wrapper {\n  float: left;\n}\n\n.foursquare-block ul .foursquare-checkin .foursquare-text {\n  margin-left: 42px;\n  font-size: 12px;\n}\n\n.foursquare-block ul .foursquare-checkin .foursquare-venue {\n  font-weight: bold;\n}\n\n.foursquare-block ul .foursquare-checkin .foursquare-location {\n  display: inline-block;\n  padding-left: 4px;\n}\n\n.foursquare-block ul .foursquare-checkin .foursquare-timestamp {\n  font-size: 10px;\n}\n\n.sqs-block-soundcloud .sqs-intrinsic iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n@media screen and (max-width: 640px) {\n  .sqs-block-soundcloud.isPlaylist .sqs-intrinsic {\n    padding-bottom: 0 !important;\n    height: 400px !important;\n  }\n}\n\n.sqs-block-opentable-hidden {\n  display: none !important;\n}\n\n.sqs-block-opentable-hide-title .OT_title {\n  display: none;\n}\n\n.sqs-block-opentable iframe {\n  visibility: hidden;\n  position: absolute;\n}\n\n.sqs-block-opentable * {\n  box-sizing: border-box;\n}\n\n.sqs-block-opentable #OT_form {\n  padding: 0;\n  margin: 0;\n  width: 165px;\n  width: auto;\n}\n\n.sqs-block-opentable .OT_wrapper {\n  border: none;\n  border-radius: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  font-family: inherit;\n  width: 100%;\n  margin: 0;\n  padding: 34px 17px 40px;\n  background: rgba(0, 0, 0, 0.5);\n  color: #272727;\n  font-size: 15px;\n  line-height: 1em;\n  text-align: center;\n  position: relative;\n}\n\n.sqs-block-opentable .OT_header {\n  width: 85%;\n  margin: 0 auto;\n  position: relative;\n}\n\n.sqs-block-opentable .OT_title {\n  position: relative;\n  width: 100%;\n  margin: 0 0 17px 0;\n  padding: 0;\n  font-size: 30px;\n  color: #272727;\n  color: rgba(0, 0, 0, 0.95);\n  font-weight: normal;\n  text-align: center;\n  line-height: 1em;\n}\n\n.sqs-block-opentable .OT_subtitle {\n  margin: 0;\n  padding: 0;\n  font-size: 10px;\n  letter-spacing: 0.15em;\n  color: #272727;\n  color: rgba(0, 0, 0, 0.8);\n  text-transform: uppercase;\n  font-weight: normal;\n  white-space: nowrap;\n  width: auto;\n  line-height: 1em;\n}\n\n.sqs-block-opentable .OT_list {\n  list-style: none;\n  margin: 28px 0 0 0;\n  padding: 0;\n  width: auto;\n  display: inline-block;\n  line-height: 1em;\n}\n\n.sqs-block-opentable .OT_day,\n.sqs-block-opentable .OT_time,\n.sqs-block-opentable .OT_party {\n  margin: 0 12px;\n  padding: 6px 0 6px 35px;\n  height: auto;\n  /* background-image: url(\"/universal/images-v6/icons/opentable-icons.svg\"); */\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  width: 33%;\n  min-width: 150px;\n  max-width: 180px;\n  position: relative;\n  border: none !important;\n  list-style: none;\n  display: inline-block;\n  line-height: 1em;\n}\n\n.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_day,\n.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_time,\n.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_party {\n  display: none;\n}\n\n.sqs-block-opentable.sqs-block-opentable-hide-fields .OT_submit {\n  margin: 0;\n}\n\n.sqs-block-opentable .OT_day {\n  margin: 0 12px;\n  padding: 6px 0 6px 35px;\n  background-position: -18px -7px;\n  border: none;\n  list-style: none;\n  background-size: 123px;\n}\n\n.sqs-block-opentable .OT_time {\n  background-position: -18px -55px;\n  border: none;\n}\n\n.sqs-block-opentable .OT_party {\n  background-position: -18px -102px;\n  border: none;\n}\n\n.sqs-block-opentable .OT_searchTimeField,\n.sqs-block-opentable .OT_searchDateField,\n.sqs-block-opentable .OT_searchPartyField {\n  font-family: inherit;\n  /* background: #fff url(\"/universal/images-v6/icons/opentable-icons.svg\")\n    no-repeat; */\n  color: #272727;\n  font-weight: normal;\n  margin: 0;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  width: 100%;\n  height: auto;\n  font-size: 13px;\n  font-style: normal;\n  padding: 0.7em 1.1em;\n  border-radius: 0px;\n  cursor: pointer;\n  line-height: normal;\n  outline: none;\n  background-position: right -14px top -75px;\n  background-size: 43px;\n  -webkit-background-clip: padding;\n  background-clip: padding-box;\n}\n\n.sqs-block-opentable #OT_timeList,\n.sqs-block-opentable #OT_partyList {\n  max-height: 195px;\n  overflow: auto;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  position: absolute;\n  width: auto;\n  top: 100%;\n  left: 35px;\n  right: 0;\n  display: none;\n  margin-top: -7px;\n  text-align: left;\n  -webkit-background-clip: padding;\n  background-clip: padding-box;\n}\n\n.sqs-block-opentable .OT_navList {\n  list-style: none;\n  padding: 0;\n  margin: -6px 0 0 0;\n  float: none;\n  position: absolute;\n  background-color: #fff;\n  z-index: 200;\n  width: auto;\n  top: 100%;\n  left: 35px;\n  right: 0;\n}\n\n.sqs-block-opentable .OT_navListItem {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  float: none;\n  line-height: 1em;\n  width: auto;\n  list-style: none;\n}\n\n.sqs-block-opentable #OT_timeList .OT_navListItem,\n.sqs-block-opentable #OT_partyList .OT_navListItem {\n  width: auto;\n}\n\n.sqs-block-opentable #OT_timeList li a.OT_navLink,\n.sqs-block-opentable #OT_partyList li a.OT_navLink {\n  border: 0;\n  width: auto;\n}\n\n.sqs-block-opentable a.OT_navLink:link,\n.sqs-block-opentable a.OT_navLink:visited,\n.sqs-block-opentable a.OT_navLink:hover,\n.sqs-block-opentable a.OT_navLink:active {\n  font-family: inherit;\n  color: #272727;\n  text-decoration: none;\n  font-size: 13px;\n  line-height: 1em;\n  width: auto;\n  display: block;\n  padding: 0.7em 1.1em;\n  border: none;\n}\n\n.sqs-block-opentable a.OT_navLink:hover,\n.sqs-block-opentable a.OT_navLink.selected,\n.sqs-block-opentable a.OT_navLink:active {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #272727;\n  opacity: 1;\n}\n\n.sqs-block-opentable a.OT_navLink.selected,\n.sqs-block-opentable a.OT_navLink:active {\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.sqs-block-opentable .OT_submit {\n  margin: 24px 0 0 0;\n  padding: 0;\n  width: auto;\n  height: auto;\n  list-style: none;\n  display: block;\n}\n\n.sqs-block-opentable .OTButton,\n.sqs-block-opentable #OTButton {\n  width: auto;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-block-opentable a.OT_Find_a_Table:link,\n.sqs-block-opentable a.OT_Find_a_Table:visited,\n.sqs-block-opentable a.OT_Find_a_Table:hover,\n.sqs-block-opentable a.OT_Find_a_Table:active {\n  background-image: none;\n  background-repeat: repeat;\n  background-position: 0 0;\n  background-color: #272727;\n  background-color: rgba(0, 0, 0, 0.95);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: normal;\n  text-decoration: none;\n  color: #fff;\n  text-align: center;\n  height: auto;\n  display: inline-block;\n  padding: 1.1em 2.3em;\n  line-height: normal;\n  text-shadow: none;\n  opacity: 0.8;\n  position: relative;\n  width: auto;\n  border: none;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  transition: opacity 0.3s ease-out, background 0.3s ease-out;\n}\n\n.opentable-style-light .OT_wrapper {\n  color: #fff;\n}\n\n.opentable-style-light .OT_title {\n  color: #fff;\n}\n\n.opentable-style-light .OT_subtitle {\n  color: #fff;\n}\n\n.opentable-style-light a.OT_Find_a_Table:link,\n.opentable-style-light a.OT_Find_a_Table:visited,\n.opentable-style-light a.OT_Find_a_Table:hover,\n.opentable-style-light a.OT_Find_a_Table:active {\n  background-color: #272727;\n  background-color: rgba(0, 0, 0, 0.3);\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.opentable-style-light a.OT_Find_a_Table:link:hover,\n.opentable-style-light a.OT_Find_a_Table:visited:hover,\n.opentable-style-light a.OT_Find_a_Table:hover:hover,\n.opentable-style-light a.OT_Find_a_Table:active:hover {\n  background-color: #272727;\n  background-color: rgba(0, 0, 0, 0.8);\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.opentable-style-light .OT_day {\n  background-position: -80px -7px;\n}\n\n.opentable-style-light .OT_time {\n  background-position: -80px -55px;\n}\n\n.opentable-style-light .OT_party {\n  background-position: -80px -102px;\n}\n\n.hide-opentable-icons .OT_day,\n.hide-opentable-icons .OT_time,\n.hide-opentable-icons .OT_party {\n  margin: 0;\n  padding: 6px;\n  background: none;\n}\n\n.hide-opentable-icons #OT_timeList,\n.hide-opentable-icons #OT_partyList,\n.hide-opentable-icons .OT_navList {\n  left: 6px;\n  right: 6px;\n}\n\n.no-svg .OT_day,\n.no-svg .OT_time,\n.no-svg .OT_party,\n.no-svg .OT_searchTimeField,\n.no-svg .OT_searchDateField,\n.no-svg .OT_searchPartyField {\n  /* background-image: url(\"/universal/images-v6/icons/opentable-icons.png\"); */\n}\n\n.small-button-block-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.medium-button-block-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.large-button-block-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.sqs-block-button.sqs-stretched .sqs-block-content,\n.sqs-block-button.sqs-stretched .sqs-block-button-element {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  height: 100%;\n  display: flex;\n}\n\n.sqs-block-button.sqs-stretched .sqs-block-button-container {\n  flex: 1;\n}\n\n.sqs-block-button.sqs-stretched .sqs-block-button-element {\n  align-items: center;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n.sqs-block-button .sqs-block-button-container--left {\n  text-align: left;\n}\n\n.sqs-block-button .sqs-block-button-container--center {\n  text-align: center;\n}\n\n.sqs-block-button .sqs-block-button-container--right {\n  text-align: right;\n}\n\n.sqs-block-button .sqs-block-button-element {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  line-height: normal;\n}\n\n.sqs-block-button .sqs-block-button-element:hover {\n  opacity: 1;\n}\n\n.sqs-block-button .sqs-block-button-element--small {\n  padding: 13px 26px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small {\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.sqs-block-button .sqs-block-button-element--medium {\n  padding: 21px 34px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium {\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.sqs-block-button .sqs-block-button-element--large {\n  padding: 25px 46px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 20px;\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large {\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\n.small-button-style-solid .sqs-block-button .sqs-block-button-element--small,\n.medium-button-style-solid .sqs-block-button .sqs-block-button-element--medium,\n.large-button-style-solid .sqs-block-button .sqs-block-button-element--large {\n  transition: 0.1s opacity linear;\n  -webkit-backface-visibility: hidden;\n}\n\n.small-button-style-solid\n  .sqs-block-button\n  .sqs-block-button-element--small:hover,\n.medium-button-style-solid\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover,\n.large-button-style-solid\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  opacity: 0.8;\n}\n\n.small-button-style-outline .sqs-block-button .sqs-block-button-element--small,\n.medium-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--medium,\n.large-button-style-outline .sqs-block-button .sqs-block-button-element--large,\n.small-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small,\n.medium-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium,\n.large-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large {\n  border-width: 2px;\n  border-style: solid;\n  background-color: transparent;\n  transition: 0.1s background-color linear, 0.1s color linear;\n}\n\n.small-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--small:hover,\n.medium-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover,\n.large-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--large:hover,\n.small-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small:hover,\n.medium-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover,\n.large-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  color: #fff;\n}\n\n.small-button-style-outline .sqs-block-button .sqs-block-button-element--small {\n  color: #272727;\n}\n\n.small-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--small:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.small-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small {\n  color: #272727;\n}\n\n.small-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.medium-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--medium {\n  color: #272727;\n}\n\n.medium-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.medium-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium {\n  color: #272727;\n}\n\n.medium-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.large-button-style-outline .sqs-block-button .sqs-block-button-element--large {\n  color: #272727;\n}\n\n.large-button-style-outline\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.large-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large {\n  color: #272727;\n}\n\n.large-button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\n.small-button-style-raised .sqs-block-button .sqs-block-button-element--small,\n.medium-button-style-raised .sqs-block-button .sqs-block-button-element--medium,\n.large-button-style-raised .sqs-block-button .sqs-block-button-element--large {\n  position: relative;\n  transition: 0.1s background-color linear;\n}\n\n.small-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--small:active,\n.medium-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--medium:active,\n.large-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--large:active {\n  top: 1px;\n}\n\n.small-button-style-raised .sqs-block-button .sqs-block-button-element--small {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\n.small-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--small:hover {\n  background-color: #2f2f2f;\n}\n\n.small-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--small:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.small-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\n.small-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small:hover {\n  background-color: #2f2f2f;\n}\n\n.small-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--small:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.medium-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--medium {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\n.medium-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover {\n  background-color: #2f2f2f;\n}\n\n.medium-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--medium:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.medium-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\n.medium-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium:hover {\n  background-color: #2f2f2f;\n}\n\n.medium-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--medium:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.large-button-style-raised .sqs-block-button .sqs-block-button-element--large {\n  box-shadow: 0 3px 0 0 #131313;\n}\n\n.large-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  background-color: #2f2f2f;\n}\n\n.large-button-style-raised\n  .sqs-block-button\n  .sqs-block-button-element--large:active {\n  top: 2px;\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.large-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large {\n  box-shadow: 0 3px 0 0 #131313;\n}\n\n.large-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large:hover {\n  background-color: #2f2f2f;\n}\n\n.large-button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-block-button\n  .sqs-block-button-element--large:active {\n  top: 2px;\n  box-shadow: 0 1px 0 0 #131313;\n}\n\n.small-button-shape-rounded .sqs-block-button .sqs-block-button-element--small,\n.medium-button-shape-rounded\n  .sqs-block-button\n  .sqs-block-button-element--medium,\n.large-button-shape-rounded .sqs-block-button .sqs-block-button-element--large {\n  border-radius: 3px;\n}\n\n.small-button-shape-pill .sqs-block-button .sqs-block-button-element--small,\n.medium-button-shape-pill .sqs-block-button .sqs-block-button-element--medium,\n.large-button-shape-pill .sqs-block-button .sqs-block-button-element--large {\n  border-radius: 300px;\n}\n\n@media screen and (max-width: 640px) {\n  .sqs-block-button .sqs-block-button-element--large {\n    padding: 21px 34px;\n    font-size: 15px;\n  }\n}\n\n.sqs-search-ui-button-wrapper {\n  position: relative;\n}\n\n.sqs-search-ui-button-wrapper.color-dark .search-input {\n  /* background-image: url(/universal/images-v6/icons/icon-searchqueries-20-dark.png); */\n  border: 1px solid #aaa;\n}\n\n.sqs-search-ui-button-wrapper.color-dark::-webkit-input-placeholder {\n  color: #666;\n}\n\n.sqs-search-ui-button-wrapper.color-dark:-moz-placeholder {\n  color: #666;\n}\n\n.sqs-search-ui-button-wrapper.color-dark::-moz-placeholder {\n  color: #666;\n}\n\n.sqs-search-ui-button-wrapper.color-dark:-ms-input-placeholder {\n  color: #666;\n}\n\n.sqs-search-ui-button-wrapper.color-light .search-input {\n  /* background-image: url(/universal/images-v6/icons/icon-searchqueries-20-light.png); */\n  color: #f7f7f7;\n  border: 1px solid #eee;\n}\n\n.sqs-search-ui-button-wrapper.color-light::-webkit-input-placeholder {\n  color: #ddd;\n}\n\n.sqs-search-ui-button-wrapper.color-light:-moz-placeholder {\n  color: #ddd;\n}\n\n.sqs-search-ui-button-wrapper.color-light::-moz-placeholder {\n  color: #ddd;\n}\n\n.sqs-search-ui-button-wrapper.color-light:-ms-input-placeholder {\n  color: #ddd;\n}\n\n.sqs-search-ui-button-wrapper .search-input {\n  opacity: 0.7;\n  transition: opacity 0.2s ease-out;\n  transition: background-image 0.2s ease-out;\n  padding: 12px 12px 12px 45px;\n  background: no-repeat 15px 50%;\n  width: 100%;\n  min-height: 20px;\n  display: block;\n  box-sizing: border-box;\n}\n\n.sqs-search-ui-button-wrapper .search-input.loading {\n  background-image: none;\n}\n\n.sqs-search-ui-button-wrapper .search-input.disabled {\n  cursor: pointer;\n}\n\n.sqs-search-ui-button-wrapper .search-input.hover-effect:hover,\n.sqs-search-ui-button-wrapper .search-input.hover-effect:focus {\n  opacity: 1;\n}\n\n.sqs-search-ui-button-wrapper .search-input:hover::-webkit-input-placeholder {\n  font-style: normal;\n}\n\n.sqs-search-ui-button-wrapper .search-input:hover:-moz-placeholder {\n  font-style: normal;\n}\n\n.sqs-search-ui-button-wrapper .search-input:hover::-moz-placeholder {\n  font-style: normal;\n}\n\n.sqs-search-ui-button-wrapper .search-input:hover:-ms-input-placeholder {\n  font-style: normal;\n}\n\n.sqs-search-ui-button-wrapper .spinner-wrapper {\n  position: absolute;\n  top: 50%;\n  transform: translatey(-50%);\n  left: 18px;\n}\n\n.sqs-search-ui-button-wrapper .spinner-wrapper .sqs-spin {\n  display: block;\n  vertical-align: middle;\n}\n\n.sqs-search-preview-ui {\n  position: absolute;\n  top: 100%;\n  z-index: 999999;\n  background-color: #fff;\n  width: 100%;\n}\n\n.sqs-search-preview-ui .sqs-search-ui-result {\n  border-top: none;\n  /* border: 1px solid #ddd; */\n}\n\n.sqs-search-preview-ui .sqs-search-ui-result .search-result-notice {\n  background-color: #fff;\n  font-weight: 200;\n  font-size: 12px;\n  padding: 6px 12px;\n}\n\n.sqs-search-preview-ui .sqs-search-ui-result .search-result-notice.hide {\n  display: none;\n}\n\n.sqs-search-preview-ui .sqs-search-ui-result .sqs-search-ui-list {\n  max-height: 500px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result {\n  padding: 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #ddd;\n  transition: background-color 0.2s ease-out;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result:last-child {\n  border-bottom: none;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result.selected,\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result:hover {\n  background-color: #f5f5f5;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result.selected {\n  outline-color: #333;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item {\n  border-top: none;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  em {\n  color: #222;\n  font-style: italic;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  .sqs-main-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  .sqs-main-image-container {\n  width: 50px;\n  float: right;\n  margin-left: 5px;\n  box-shadow: #ddd 1px -1px 5px;\n  -moz-box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;\n  -o-box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;\n  -webkit-box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;\n  box-shadow: 0 0 5px 0 #ddd 1px -1px 5px;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  .sqs-main-image-intrinsic {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  .sqs-title {\n  font-size: 16px;\n  line-height: 1.2em;\n  margin-bottom: 0.5em;\n  color: #333;\n}\n\n.sqs-search-preview-ui\n  .sqs-search-ui-result\n  .sqs-search-ui-list\n  .search-result\n  .sqs-search-ui-item\n  .sqs-content {\n  font-size: 12px;\n  line-height: 1.4em;\n}\n\n.sqs-search-preview-ui.no-image .sqs-main-image-container {\n  display: none;\n}\n\n.twitter-block .tweet-list {\n  list-style-type: none;\n  margin: 0 0 2.2em 0;\n  padding: 0;\n}\n\n.twitter-block .tweet {\n  margin: 0 0 2.2em 0;\n}\n\n.twitter-block .tweet a {\n  border: 0;\n}\n\n.twitter-block .tweet .tweet-avatar-wrapper {\n  float: left;\n}\n\n.twitter-block .tweet .tweet-avatar {\n  border-radius: 2px;\n}\n\n.twitter-block .tweet .tweet-text-wrapper {\n  margin-left: 60px;\n}\n\n.twitter-block .tweet.no-avatar .tweet-text-wrapper {\n  margin-left: 0px;\n}\n\n.twitter-block .tweet .tweet-from {\n  font-size: 1.1em;\n  margin: 0 0 0.5em 0;\n  line-height: 1em;\n  font-weight: bold;\n}\n\n.twitter-block .tweet .tweet-timestamp a {\n  font-size: 0.8em;\n}\n\n.sqs-block-quote figure {\n  margin: 1em 0;\n}\n\n.sqs-block-quote blockquote {\n  margin: 0;\n}\n\n.sqs-block-quote .source {\n  text-align: right;\n}\n\n.sqs-block-quote .sqs-block-content .block-animation.animation-disabled,\n.sqs-block-quote .sqs-block-content .block-animation.animation-loaded {\n  transform: translatez(0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-fade-in,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-fade-in {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-fade-in.animation-loaded,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-fade-in.animation-loaded,\n.sqs-block-quote .sqs-block-content .block-animation-fade-in.animation-loaded {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-slide-up,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-slide-up {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 20);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-slide-up.animation-loaded,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-slide-up.animation-loaded,\n.sqs-block-quote .sqs-block-content .block-animation-slide-up.animation-loaded {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-reveal,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-reveal {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-reveal.animation-loaded,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-reveal.animation-loaded,\n.sqs-block-quote .sqs-block-content .block-animation-reveal.animation-loaded {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-focus-in,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-focus-in {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0, 0, 0.92, 0, 0);\n}\n\n:not(.sqs-edit-mode)\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-focus-in.animation-loaded,\n.sqs-edit-mode.sqs-edit-mode-active\n  .sqs-block-quote\n  .sqs-block-content\n  .block-animation-focus-in.animation-loaded,\n.sqs-block-quote .sqs-block-content .block-animation-focus-in.animation-loaded {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.sqs-block-quote .sqs-block-content .block-animation.animation-disabled {\n  transition: none !important;\n}\n\n.rss-block .social-rss:before,\n.rss-block .social-rss-square:before,\n.rss-block .social-rss-round:before {\n  font-family: \"social-icon-font\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  font-size: 0.7em;\n}\n\n.rss-block .social-rss:before {\n  content: \"\\e630\";\n  position: relative;\n  top: -0.05em;\n  margin-right: 0.4em;\n  font-size: 0.7em;\n}\n\n.rss-block .sqs-blockStatus + .social-rss {\n  display: none;\n}\n\n.sqs-block-zola .sqs-block-content {\n  transition: opacity 0.3s ease-in;\n}\n\n.sqs-block-zola .sqs-block-content.is-rendering {\n  opacity: 0.1;\n}\n\n.sqs-block-zola .zola-block-wrapper {\n  background: #fff;\n}\n\n.sqs-block-zola .zola-block-wrapper.zola-block-setting-inset {\n  padding: 0 20px;\n}\n\n.sqs-block-acuity .sqs-block-content {\n  transition: opacity 0.3s ease-in;\n}\n\n.sqs-block-acuity .sqs-block-content.is-rendering {\n  opacity: 0.1;\n}\n\n.sqs-block-acuity .sqs-block-content iframe {\n  min-height: 1000px;\n}\n\n.sqs-block-acuity .sqs-block-content iframe[style] {\n  min-height: 0;\n}\n\n.tock-flex-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.tock-align-left {\n  justify-content: flex-start;\n}\n\n.tock-align-center {\n  justify-content: center;\n}\n\n.tock-align-right {\n  justify-content: flex-end;\n}\n\n.hide-tock-logo\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockLogo-container,\n.hide-tock-logo\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockSearchBar-tockIcon {\n  display: none;\n}\n\n.sqs-use--icon,\n.sqs-use--mask {\n  fill: transparent;\n  transition: fill 170ms ease-in-out;\n}\n\n.sqs-svg-icon--wrapper {\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 170ms ease-in-out;\n  z-index: 0;\n}\n\n.sqs-svg-icon--wrapper > div,\n.sqs-svg-icon--wrapper svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.social-icons-shape-circle .sqs-svg-icon--wrapper {\n  border-radius: 50%;\n}\n\n.social-icons-shape-rounded .sqs-svg-icon--wrapper {\n  border-radius: 15%;\n}\n\n.social-icons-style-border .sqs-svg-icon--wrapper {\n  border: 2px solid;\n  box-sizing: border-box;\n}\n\n.social-icons-style-regular .sqs-svg-icon--wrapper {\n  border-radius: 0;\n}\n\n.social-icons-style-regular .sqs-svg-icon--wrapper > div {\n  transform: scale(2);\n}\n\n.social-icons-size-extra-small.social-icons-style-regular\n  .sqs-svg-icon--wrapper {\n  width: 16px;\n  height: 16px;\n}\n\n.social-icons-size-small.social-icons-style-regular .sqs-svg-icon--wrapper {\n  width: 20px;\n  height: 20px;\n}\n\n.social-icons-size-medium.social-icons-style-regular .sqs-svg-icon--wrapper,\n.social-icons-size-extra-small:not(.social-icons-style-regular)\n  .sqs-svg-icon--wrapper {\n  width: 24px;\n  height: 24px;\n}\n\n.social-icons-size-large.social-icons-style-regular .sqs-svg-icon--wrapper,\n.social-icons-size-small:not(.social-icons-style-regular)\n  .sqs-svg-icon--wrapper {\n  width: 28px;\n  height: 28px;\n}\n\n.social-icons-size-extra-large.social-icons-style-regular\n  .sqs-svg-icon--wrapper,\n.social-icons-size-medium:not(.social-icons-style-regular)\n  .sqs-svg-icon--wrapper {\n  width: 32px;\n  height: 32px;\n}\n\n.social-icons-size-large:not(.social-icons-style-regular)\n  .sqs-svg-icon--wrapper {\n  width: 36px;\n  height: 36px;\n}\n\n.social-icons-size-extra-large:not(.social-icons-style-regular)\n  .sqs-svg-icon--wrapper {\n  width: 48px;\n  height: 48px;\n}\n\n.social-icon-alignment-left .sqs-svg-icon--list {\n  text-align: left;\n}\n\n.social-icon-alignment-right .sqs-svg-icon--list {\n  text-align: right;\n}\n\n.social-icon-alignment-center .sqs-svg-icon--list {\n  text-align: center;\n}\n\n.social-icons-size-extra-small.social-icon-alignment-left\n  .sqs-svg-icon--wrapper {\n  margin: 0 6px 0 0;\n}\n\n.social-icons-size-extra-small.social-icon-alignment-right\n  .sqs-svg-icon--wrapper {\n  margin: 0 0 0 6px;\n}\n\n.social-icons-size-extra-small.social-icon-alignment-center\n  .sqs-svg-icon--wrapper {\n  margin: 0 3px;\n}\n\n.social-icons-size-small.social-icon-alignment-left .sqs-svg-icon--wrapper {\n  margin: 0 8px 0 0;\n}\n\n.social-icons-size-small.social-icon-alignment-right .sqs-svg-icon--wrapper {\n  margin: 0 0 0 8px;\n}\n\n.social-icons-size-small.social-icon-alignment-center .sqs-svg-icon--wrapper {\n  margin: 0 4px;\n}\n\n.social-icons-size-medium.social-icon-alignment-left .sqs-svg-icon--wrapper {\n  margin: 0 8px 0 0;\n}\n\n.social-icons-size-medium.social-icon-alignment-right .sqs-svg-icon--wrapper {\n  margin: 0 0 0 8px;\n}\n\n.social-icons-size-medium.social-icon-alignment-center .sqs-svg-icon--wrapper {\n  margin: 0 4px;\n}\n\n.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-left\n  .sqs-svg-icon--wrapper,\n.social-icons-size-large.social-icon-alignment-left .sqs-svg-icon--wrapper {\n  margin: 0 10px 0 0;\n}\n\n.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-right\n  .sqs-svg-icon--wrapper,\n.social-icons-size-large.social-icon-alignment-right .sqs-svg-icon--wrapper {\n  margin: 0 0 0 10px;\n}\n\n.social-icons-size-extra-small.social-icons-style-regular.social-icon-alignment-center\n  .sqs-svg-icon--wrapper,\n.social-icons-size-large.social-icon-alignment-center .sqs-svg-icon--wrapper {\n  margin: 0 5px;\n}\n\n.social-icons-size-small.social-icons-style-regular.social-icon-alignment-left\n  .sqs-svg-icon--wrapper,\n.social-icons-size-extra-large.social-icon-alignment-left\n  .sqs-svg-icon--wrapper {\n  margin: 0 12px 0 0;\n}\n\n.social-icons-size-small.social-icons-style-regular.social-icon-alignment-right\n  .sqs-svg-icon--wrapper,\n.social-icons-size-extra-large.social-icon-alignment-right\n  .sqs-svg-icon--wrapper {\n  margin: 0 0 0 12px;\n}\n\n.social-icons-size-small.social-icons-style-regular.social-icon-alignment-center\n  .sqs-svg-icon--wrapper,\n.social-icons-size-extra-large.social-icon-alignment-center\n  .sqs-svg-icon--wrapper {\n  margin: 0 6px;\n}\n\n.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-left\n  .sqs-svg-icon--wrapper {\n  margin: 0 14px 0 0;\n}\n\n.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-right\n  .sqs-svg-icon--wrapper {\n  margin: 0 0 0 14px;\n}\n\n.social-icons-size-medium.social-icons-style-regular.social-icon-alignment-center\n  .sqs-svg-icon--wrapper {\n  margin: 0 7px;\n}\n\n.social-icons-size-large.social-icons-style-regular.social-icon-alignment-left\n  .sqs-svg-icon--wrapper {\n  margin: 0 16px 0 0;\n}\n\n.social-icons-size-large.social-icons-style-regular.social-icon-alignment-right\n  .sqs-svg-icon--wrapper {\n  margin: 0 0 0 16px;\n}\n\n.social-icons-size-large.social-icons-style-regular.social-icon-alignment-center\n  .sqs-svg-icon--wrapper {\n  margin: 0 8px;\n}\n\n.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-left\n  .sqs-svg-icon--wrapper {\n  margin: 0 18px 0 0;\n}\n\n.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-right\n  .sqs-svg-icon--wrapper {\n  margin: 0 0 0 18px;\n}\n\n.social-icons-size-extra-large.social-icons-style-regular.social-icon-alignment-center\n  .sqs-svg-icon--wrapper {\n  margin: 0 9px;\n}\n\n.social-icons-color-black.social-icons-style-regular .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-black.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .sqs-use--icon {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-black.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-black.social-icons-style-border .sqs-svg-icon--wrapper {\n  border-color: #222;\n}\n\n.social-icons-color-black.social-icons-style-border .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-black.social-icons-style-border\n  .sqs-svg-icon--wrapper:hover {\n  background-color: #222;\n}\n\n.social-icons-color-black.social-icons-style-border\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-black.social-icons-style-knockout .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-black.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-black.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-black.social-icons-style-solid .sqs-svg-icon--wrapper {\n  background-color: #222;\n}\n\n.social-icons-color-black.social-icons-style-solid .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-black.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-black.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-use--icon {\n  fill: rgba(255, 255, 255, 0.4);\n}\n\n.social-icons-color-black.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover {\n  background-color: #222;\n}\n\n.social-icons-color-black.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-regular .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .sqs-use--icon {\n  fill: rgba(255, 255, 255, 0.4);\n}\n\n.social-icons-color-white.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-border .sqs-svg-icon--wrapper {\n  border-color: #fff;\n}\n\n.social-icons-color-white.social-icons-style-border .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-border\n  .sqs-svg-icon--wrapper:hover {\n  background-color: #fff;\n}\n\n.social-icons-color-white.social-icons-style-border\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-white.social-icons-style-knockout .sqs-use--mask {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .sqs-use--mask {\n  fill: rgba(255, 255, 255, 0.4);\n}\n\n.social-icons-color-white.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--mask {\n  fill: #fff;\n}\n\n.social-icons-color-white.social-icons-style-solid .sqs-svg-icon--wrapper {\n  background-color: #fff;\n}\n\n.social-icons-color-white.social-icons-style-solid .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-white.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.social-icons-color-white.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-use--icon {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-white.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover {\n  background-color: #fff;\n}\n\n.social-icons-color-white.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #222;\n}\n\n.social-icons-color-standard.social-icons-style-border\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--wrapper\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-svg-icon--wrapper:hover\n  .sqs-use--icon {\n  fill: #fff;\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .sqs-use--icon {\n  fill: rgba(255, 255, 255, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--wrapper\n  .sqs-use--mask,\n.social-icons-color-standard.social-icons-style-border\n  .sqs-svg-icon--wrapper\n  .sqs-use--mask,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--wrapper\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--wrapper\n  .sqs-use--mask {\n  fill: transparent;\n}\n\n.social-icons-color-standard.social-icons-style-regular .sqs-svg-icon--wrapper,\n.social-icons-color-standard.social-icons-style-knockout .sqs-svg-icon--wrapper,\n.social-icons-color-standard.social-icons-style-border\n  .sqs-svg-icon--wrapper:not(:hover) {\n  background-color: transparent;\n}\n\n.social-icons-color-standard .applepodcast .sqs-use--icon,\n.social-icons-color-standard .applepodcast .sqs-use--mask {\n  fill: #000;\n}\n\n.social-icons-color-standard .applepodcast {\n  border-color: #000;\n  background-color: #000;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .applepodcast:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .applepodcast:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 0, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .applepodcast:not(:hover) {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.social-icons-color-standard .bandsintown .sqs-use--icon,\n.social-icons-color-standard .bandsintown .sqs-use--mask {\n  fill: #00b4b3;\n}\n\n.social-icons-color-standard .bandsintown {\n  border-color: #00b4b3;\n  background-color: #00b4b3;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .bandsintown:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .bandsintown:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 180, 179, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .bandsintown:not(:hover) {\n  background-color: rgba(0, 180, 179, 0.4);\n}\n\n.social-icons-color-standard .behance .sqs-use--icon,\n.social-icons-color-standard .behance .sqs-use--mask {\n  fill: #1769ff;\n}\n\n.social-icons-color-standard .behance {\n  border-color: #1769ff;\n  background-color: #1769ff;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .behance:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .behance:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(23, 105, 255, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .behance:not(:hover) {\n  background-color: rgba(23, 105, 255, 0.4);\n}\n\n.social-icons-color-standard .chownow .sqs-use--icon,\n.social-icons-color-standard .chownow .sqs-use--mask {\n  fill: #dc5d54;\n}\n\n.social-icons-color-standard .chownow {\n  border-color: #dc5d54;\n  background-color: #dc5d54;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .chownow:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .chownow:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(220, 93, 84, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .chownow:not(:hover) {\n  background-color: rgba(220, 93, 84, 0.4);\n}\n\n.social-icons-color-standard .codepen .sqs-use--icon,\n.social-icons-color-standard .codepen .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .codepen {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .codepen:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .codepen:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .codepen:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .dribbble .sqs-use--icon,\n.social-icons-color-standard .dribbble .sqs-use--mask {\n  fill: #ea4c89;\n}\n\n.social-icons-color-standard .dribbble {\n  border-color: #ea4c89;\n  background-color: #ea4c89;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .dribbble:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .dribbble:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(234, 76, 137, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .dribbble:not(:hover) {\n  background-color: rgba(234, 76, 137, 0.4);\n}\n\n.social-icons-color-standard .dropbox .sqs-use--icon,\n.social-icons-color-standard .dropbox .sqs-use--mask {\n  fill: #007ee5;\n}\n\n.social-icons-color-standard .dropbox {\n  border-color: #007ee5;\n  background-color: #007ee5;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .dropbox:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .dropbox:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 126, 229, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .dropbox:not(:hover) {\n  background-color: rgba(0, 126, 229, 0.4);\n}\n\n.social-icons-color-standard .email .sqs-use--icon,\n.social-icons-color-standard .email .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .email {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .email:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .email:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .email:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .facebook .sqs-use--icon,\n.social-icons-color-standard .facebook .sqs-use--mask {\n  fill: #3b5998;\n}\n\n.social-icons-color-standard .facebook {\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .facebook:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .facebook:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(59, 89, 152, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .facebook:not(:hover) {\n  background-color: rgba(59, 89, 152, 0.4);\n}\n\n.social-icons-color-standard .facebook-unauth .sqs-use--icon,\n.social-icons-color-standard .facebook-unauth .sqs-use--mask {\n  fill: #3b5998;\n}\n\n.social-icons-color-standard .facebook-unauth {\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .facebook-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .facebook-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(59, 89, 152, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .facebook-unauth:not(:hover) {\n  background-color: rgba(59, 89, 152, 0.4);\n}\n\n.social-icons-color-standard .fivehundredpix .sqs-use--icon,\n.social-icons-color-standard .fivehundredpix .sqs-use--mask {\n  fill: #0099e5;\n}\n\n.social-icons-color-standard .fivehundredpix {\n  border-color: #0099e5;\n  background-color: #0099e5;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .fivehundredpix:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .fivehundredpix:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 153, 229, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .fivehundredpix:not(:hover) {\n  background-color: rgba(0, 153, 229, 0.4);\n}\n\n.social-icons-color-standard .fivehundredpix-unauth .sqs-use--icon,\n.social-icons-color-standard .fivehundredpix-unauth .sqs-use--mask {\n  fill: #0099e5;\n}\n\n.social-icons-color-standard .fivehundredpix-unauth {\n  border-color: #0099e5;\n  background-color: #0099e5;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .fivehundredpix-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .fivehundredpix-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 153, 229, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .fivehundredpix-unauth:not(:hover) {\n  background-color: rgba(0, 153, 229, 0.4);\n}\n\n.social-icons-color-standard .flickr .sqs-use--icon,\n.social-icons-color-standard .flickr .sqs-use--mask {\n  fill: #0063dc;\n}\n\n.social-icons-color-standard .flickr {\n  border-color: #0063dc;\n  background-color: #0063dc;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .flickr:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .flickr:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 99, 220, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .flickr:not(:hover) {\n  background-color: rgba(0, 99, 220, 0.4);\n}\n\n.social-icons-color-standard .flickr-unauth .sqs-use--icon,\n.social-icons-color-standard .flickr-unauth .sqs-use--mask {\n  fill: #0063dc;\n}\n\n.social-icons-color-standard .flickr-unauth {\n  border-color: #0063dc;\n  background-color: #0063dc;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .flickr-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .flickr-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 99, 220, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .flickr-unauth:not(:hover) {\n  background-color: rgba(0, 99, 220, 0.4);\n}\n\n.social-icons-color-standard .foursquare .sqs-use--icon,\n.social-icons-color-standard .foursquare .sqs-use--mask {\n  fill: #f94877;\n}\n\n.social-icons-color-standard .foursquare {\n  border-color: #f94877;\n  background-color: #f94877;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .foursquare:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .foursquare:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(249, 72, 119, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .foursquare:not(:hover) {\n  background-color: rgba(249, 72, 119, 0.4);\n}\n\n.social-icons-color-standard .foursquare-unauth .sqs-use--icon,\n.social-icons-color-standard .foursquare-unauth .sqs-use--mask {\n  fill: #f94877;\n}\n\n.social-icons-color-standard .foursquare-unauth {\n  border-color: #f94877;\n  background-color: #f94877;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .foursquare-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .foursquare-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(249, 72, 119, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .foursquare-unauth:not(:hover) {\n  background-color: rgba(249, 72, 119, 0.4);\n}\n\n.social-icons-color-standard .github .sqs-use--icon,\n.social-icons-color-standard .github .sqs-use--mask {\n  fill: #4183c4;\n}\n\n.social-icons-color-standard .github {\n  border-color: #4183c4;\n  background-color: #4183c4;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .github:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .github:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(65, 131, 196, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .github:not(:hover) {\n  background-color: rgba(65, 131, 196, 0.4);\n}\n\n.social-icons-color-standard .github-unauth .sqs-use--icon,\n.social-icons-color-standard .github-unauth .sqs-use--mask {\n  fill: #4183c4;\n}\n\n.social-icons-color-standard .github-unauth {\n  border-color: #4183c4;\n  background-color: #4183c4;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .github-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .github-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(65, 131, 196, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .github-unauth:not(:hover) {\n  background-color: rgba(65, 131, 196, 0.4);\n}\n\n.social-icons-color-standard .goodreads .sqs-use--icon,\n.social-icons-color-standard .goodreads .sqs-use--mask {\n  fill: #382110;\n}\n\n.social-icons-color-standard .goodreads {\n  border-color: #382110;\n  background-color: #382110;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .goodreads:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .goodreads:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(56, 33, 16, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .goodreads:not(:hover) {\n  background-color: rgba(56, 33, 16, 0.4);\n}\n\n.social-icons-color-standard .googleplay .sqs-use--icon,\n.social-icons-color-standard .googleplay .sqs-use--mask {\n  fill: #5adfcb;\n}\n\n.social-icons-color-standard .googleplay {\n  border-color: #5adfcb;\n  background-color: #5adfcb;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .googleplay:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .googleplay:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(90, 223, 203, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .googleplay:not(:hover) {\n  background-color: rgba(90, 223, 203, 0.4);\n}\n\n.social-icons-color-standard .google .sqs-use--icon,\n.social-icons-color-standard .google .sqs-use--mask {\n  fill: #dc4e41;\n}\n\n.social-icons-color-standard .google {\n  border-color: #dc4e41;\n  background-color: #dc4e41;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .google:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .google:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(220, 78, 65, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .google:not(:hover) {\n  background-color: rgba(220, 78, 65, 0.4);\n}\n\n.social-icons-color-standard .houzz .sqs-use--icon,\n.social-icons-color-standard .houzz .sqs-use--mask {\n  fill: #7ac143;\n}\n\n.social-icons-color-standard .houzz {\n  border-color: #7ac143;\n  background-color: #7ac143;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .houzz:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .houzz:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(122, 193, 67, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .houzz:not(:hover) {\n  background-color: rgba(122, 193, 67, 0.4);\n}\n\n.social-icons-color-standard .imdb .sqs-use--icon,\n.social-icons-color-standard .imdb .sqs-use--mask {\n  fill: #e6b91e;\n}\n\n.social-icons-color-standard .imdb {\n  border-color: #e6b91e;\n  background-color: #e6b91e;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .imdb:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .imdb:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(230, 185, 30, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .imdb:not(:hover) {\n  background-color: rgba(230, 185, 30, 0.4);\n}\n\n.social-icons-color-standard .instagram .sqs-use--icon,\n.social-icons-color-standard .instagram .sqs-use--mask {\n  fill: #e4405f;\n}\n\n.social-icons-color-standard .instagram {\n  border-color: #e4405f;\n  background-color: #e4405f;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .instagram:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .instagram:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(228, 64, 95, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .instagram:not(:hover) {\n  background-color: rgba(228, 64, 95, 0.4);\n}\n\n.social-icons-color-standard .instagram-unauth .sqs-use--icon,\n.social-icons-color-standard .instagram-unauth .sqs-use--mask {\n  fill: #e4405f;\n}\n\n.social-icons-color-standard .instagram-unauth {\n  border-color: #e4405f;\n  background-color: #e4405f;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .instagram-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .instagram-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(228, 64, 95, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .instagram-unauth:not(:hover) {\n  background-color: rgba(228, 64, 95, 0.4);\n}\n\n.social-icons-color-standard .itunes .sqs-use--icon,\n.social-icons-color-standard .itunes .sqs-use--mask {\n  fill: #ec4652;\n}\n\n.social-icons-color-standard .itunes {\n  border-color: #ec4652;\n  background-color: #ec4652;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .itunes:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .itunes:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(236, 70, 82, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .itunes:not(:hover) {\n  background-color: rgba(236, 70, 82, 0.4);\n}\n\n.social-icons-color-standard .linkedin .sqs-use--icon,\n.social-icons-color-standard .linkedin .sqs-use--mask {\n  fill: #0976b4;\n}\n\n.social-icons-color-standard .linkedin {\n  border-color: #0976b4;\n  background-color: #0976b4;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .linkedin:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .linkedin:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(9, 118, 180, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .linkedin:not(:hover) {\n  background-color: rgba(9, 118, 180, 0.4);\n}\n\n.social-icons-color-standard .linkedin-unauth .sqs-use--icon,\n.social-icons-color-standard .linkedin-unauth .sqs-use--mask {\n  fill: #0976b4;\n}\n\n.social-icons-color-standard .linkedin-unauth {\n  border-color: #0976b4;\n  background-color: #0976b4;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .linkedin-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .linkedin-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(9, 118, 180, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .linkedin-unauth:not(:hover) {\n  background-color: rgba(9, 118, 180, 0.4);\n}\n\n.social-icons-color-standard .medium .sqs-use--icon,\n.social-icons-color-standard .medium .sqs-use--mask {\n  fill: #00ab6c;\n}\n\n.social-icons-color-standard .medium {\n  border-color: #00ab6c;\n  background-color: #00ab6c;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .medium:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .medium:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 171, 108, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .medium:not(:hover) {\n  background-color: rgba(0, 171, 108, 0.4);\n}\n\n.social-icons-color-standard .meetup .sqs-use--icon,\n.social-icons-color-standard .meetup .sqs-use--mask {\n  fill: #e0393e;\n}\n\n.social-icons-color-standard .meetup {\n  border-color: #e0393e;\n  background-color: #e0393e;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .meetup:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .meetup:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(224, 57, 62, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .meetup:not(:hover) {\n  background-color: rgba(224, 57, 62, 0.4);\n}\n\n.social-icons-color-standard .pinterest .sqs-use--icon,\n.social-icons-color-standard .pinterest .sqs-use--mask {\n  fill: #cc2127;\n}\n\n.social-icons-color-standard .pinterest {\n  border-color: #cc2127;\n  background-color: #cc2127;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .pinterest:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .pinterest:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(204, 33, 39, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .pinterest:not(:hover) {\n  background-color: rgba(204, 33, 39, 0.4);\n}\n\n.social-icons-color-standard .pinterest-unauth .sqs-use--icon,\n.social-icons-color-standard .pinterest-unauth .sqs-use--mask {\n  fill: #cc2127;\n}\n\n.social-icons-color-standard .pinterest-unauth {\n  border-color: #cc2127;\n  background-color: #cc2127;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .pinterest-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .pinterest-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(204, 33, 39, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .pinterest-unauth:not(:hover) {\n  background-color: rgba(204, 33, 39, 0.4);\n}\n\n.social-icons-color-standard .rdio .sqs-use--icon,\n.social-icons-color-standard .rdio .sqs-use--mask {\n  fill: #006ed2;\n}\n\n.social-icons-color-standard .rdio {\n  border-color: #006ed2;\n  background-color: #006ed2;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .rdio:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .rdio:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 110, 210, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .rdio:not(:hover) {\n  background-color: rgba(0, 110, 210, 0.4);\n}\n\n.social-icons-color-standard .reddit .sqs-use--icon,\n.social-icons-color-standard .reddit .sqs-use--mask {\n  fill: #ff4500;\n}\n\n.social-icons-color-standard .reddit {\n  border-color: #ff4500;\n  background-color: #ff4500;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .reddit:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .reddit:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(255, 69, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .reddit:not(:hover) {\n  background-color: rgba(255, 69, 0, 0.4);\n}\n\n.social-icons-color-standard .rss .sqs-use--icon,\n.social-icons-color-standard .rss .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .rss {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .rss:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .rss:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .rss:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .smugmug .sqs-use--icon,\n.social-icons-color-standard .smugmug .sqs-use--mask {\n  fill: #7dbb00;\n}\n\n.social-icons-color-standard .smugmug {\n  border-color: #7dbb00;\n  background-color: #7dbb00;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .smugmug:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .smugmug:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(125, 187, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .smugmug:not(:hover) {\n  background-color: rgba(125, 187, 0, 0.4);\n}\n\n.social-icons-color-standard .smugmug-unauth .sqs-use--icon,\n.social-icons-color-standard .smugmug-unauth .sqs-use--mask {\n  fill: #7dbb00;\n}\n\n.social-icons-color-standard .smugmug-unauth {\n  border-color: #7dbb00;\n  background-color: #7dbb00;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .smugmug-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .smugmug-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(125, 187, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .smugmug-unauth:not(:hover) {\n  background-color: rgba(125, 187, 0, 0.4);\n}\n\n.social-icons-color-standard .snapchat .sqs-use--icon,\n.social-icons-color-standard .snapchat .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .snapchat {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .snapchat:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .snapchat:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .snapchat:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .soundcloud .sqs-use--icon,\n.social-icons-color-standard .soundcloud .sqs-use--mask {\n  fill: #f60;\n}\n\n.social-icons-color-standard .soundcloud {\n  border-color: #f60;\n  background-color: #f60;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .soundcloud:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .soundcloud:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(255, 102, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .soundcloud:not(:hover) {\n  background-color: rgba(255, 102, 0, 0.4);\n}\n\n.social-icons-color-standard .soundcloud-unauth .sqs-use--icon,\n.social-icons-color-standard .soundcloud-unauth .sqs-use--mask {\n  fill: #f60;\n}\n\n.social-icons-color-standard .soundcloud-unauth {\n  border-color: #f60;\n  background-color: #f60;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .soundcloud-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .soundcloud-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(255, 102, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .soundcloud-unauth:not(:hover) {\n  background-color: rgba(255, 102, 0, 0.4);\n}\n\n.social-icons-color-standard .spotify .sqs-use--icon,\n.social-icons-color-standard .spotify .sqs-use--mask {\n  fill: #84bd00;\n}\n\n.social-icons-color-standard .spotify {\n  border-color: #84bd00;\n  background-color: #84bd00;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .spotify:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .spotify:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(132, 189, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .spotify:not(:hover) {\n  background-color: rgba(132, 189, 0, 0.4);\n}\n\n.social-icons-color-standard .spotify-unauth .sqs-use--icon,\n.social-icons-color-standard .spotify-unauth .sqs-use--mask {\n  fill: #84bd00;\n}\n\n.social-icons-color-standard .spotify-unauth {\n  border-color: #84bd00;\n  background-color: #84bd00;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .spotify-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .spotify-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(132, 189, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .spotify-unauth:not(:hover) {\n  background-color: rgba(132, 189, 0, 0.4);\n}\n\n.social-icons-color-standard .squarespace .sqs-use--icon,\n.social-icons-color-standard .squarespace .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .squarespace {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .squarespace:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .squarespace:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .squarespace:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .stitcher .sqs-use--icon,\n.social-icons-color-standard .stitcher .sqs-use--mask {\n  fill: #1ea9e1;\n}\n\n.social-icons-color-standard .stitcher {\n  border-color: #1ea9e1;\n  background-color: #1ea9e1;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .stitcher:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .stitcher:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(30, 169, 225, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .stitcher:not(:hover) {\n  background-color: rgba(30, 169, 225, 0.4);\n}\n\n.social-icons-color-standard .stumbleupon .sqs-use--icon,\n.social-icons-color-standard .stumbleupon .sqs-use--mask {\n  fill: #eb4924;\n}\n\n.social-icons-color-standard .stumbleupon {\n  border-color: #eb4924;\n  background-color: #eb4924;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .stumbleupon:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .stumbleupon:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(235, 73, 36, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .stumbleupon:not(:hover) {\n  background-color: rgba(235, 73, 36, 0.4);\n}\n\n.social-icons-color-standard .thedots .sqs-use--icon,\n.social-icons-color-standard .thedots .sqs-use--mask {\n  fill: #8c8070;\n}\n\n.social-icons-color-standard .thedots {\n  border-color: #8c8070;\n  background-color: #8c8070;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .thedots:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .thedots:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(140, 128, 112, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .thedots:not(:hover) {\n  background-color: rgba(140, 128, 112, 0.4);\n}\n\n.social-icons-color-standard .tidal .sqs-use--icon,\n.social-icons-color-standard .tidal .sqs-use--mask {\n  fill: #222;\n}\n\n.social-icons-color-standard .tidal {\n  border-color: #222;\n  background-color: #222;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .tidal:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .tidal:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .tidal:not(:hover) {\n  background-color: rgba(34, 34, 34, 0.4);\n}\n\n.social-icons-color-standard .tripadvisor .sqs-use--icon,\n.social-icons-color-standard .tripadvisor .sqs-use--mask {\n  fill: #00b087;\n}\n\n.social-icons-color-standard .tripadvisor {\n  border-color: #00b087;\n  background-color: #00b087;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .tripadvisor:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .tripadvisor:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 176, 135, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .tripadvisor:not(:hover) {\n  background-color: rgba(0, 176, 135, 0.4);\n}\n\n.social-icons-color-standard .tumblr .sqs-use--icon,\n.social-icons-color-standard .tumblr .sqs-use--mask {\n  fill: #35465d;\n}\n\n.social-icons-color-standard .tumblr {\n  border-color: #35465d;\n  background-color: #35465d;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .tumblr:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .tumblr:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(53, 70, 93, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .tumblr:not(:hover) {\n  background-color: rgba(53, 70, 93, 0.4);\n}\n\n.social-icons-color-standard .tumblr-unauth .sqs-use--icon,\n.social-icons-color-standard .tumblr-unauth .sqs-use--mask {\n  fill: #35465d;\n}\n\n.social-icons-color-standard .tumblr-unauth {\n  border-color: #35465d;\n  background-color: #35465d;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .tumblr-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .tumblr-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(53, 70, 93, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .tumblr-unauth:not(:hover) {\n  background-color: rgba(53, 70, 93, 0.4);\n}\n\n.social-icons-color-standard .twitch .sqs-use--icon,\n.social-icons-color-standard .twitch .sqs-use--mask {\n  fill: #6441a5;\n}\n\n.social-icons-color-standard .twitch {\n  border-color: #6441a5;\n  background-color: #6441a5;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .twitch:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .twitch:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(100, 65, 165, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .twitch:not(:hover) {\n  background-color: rgba(100, 65, 165, 0.4);\n}\n\n.social-icons-color-standard .twitter .sqs-use--icon,\n.social-icons-color-standard .twitter .sqs-use--mask {\n  fill: #55acee;\n}\n\n.social-icons-color-standard .twitter {\n  border-color: #55acee;\n  background-color: #55acee;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .twitter:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .twitter:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(85, 172, 238, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .twitter:not(:hover) {\n  background-color: rgba(85, 172, 238, 0.4);\n}\n\n.social-icons-color-standard .twitter-unauth .sqs-use--icon,\n.social-icons-color-standard .twitter-unauth .sqs-use--mask {\n  fill: #55acee;\n}\n\n.social-icons-color-standard .twitter-unauth {\n  border-color: #55acee;\n  background-color: #55acee;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .twitter-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .twitter-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(85, 172, 238, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .twitter-unauth:not(:hover) {\n  background-color: rgba(85, 172, 238, 0.4);\n}\n\n.social-icons-color-standard .url .sqs-use--icon,\n.social-icons-color-standard .url .sqs-use--mask {\n  fill: #000;\n}\n\n.social-icons-color-standard .url {\n  border-color: #000;\n  background-color: #000;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .url:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .url:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 0, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .url:not(:hover) {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.social-icons-color-standard .vevo .sqs-use--icon,\n.social-icons-color-standard .vevo .sqs-use--mask {\n  fill: #ff0031;\n}\n\n.social-icons-color-standard .vevo {\n  border-color: #ff0031;\n  background-color: #ff0031;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .vevo:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .vevo:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(255, 0, 49, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .vevo:not(:hover) {\n  background-color: rgba(255, 0, 49, 0.4);\n}\n\n.social-icons-color-standard .vimeo .sqs-use--icon,\n.social-icons-color-standard .vimeo .sqs-use--mask {\n  fill: #1ab7ea;\n}\n\n.social-icons-color-standard .vimeo {\n  border-color: #1ab7ea;\n  background-color: #1ab7ea;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .vimeo:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .vimeo:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(26, 183, 234, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .vimeo:not(:hover) {\n  background-color: rgba(26, 183, 234, 0.4);\n}\n\n.social-icons-color-standard .vimeo-unauth .sqs-use--icon,\n.social-icons-color-standard .vimeo-unauth .sqs-use--mask {\n  fill: #1ab7ea;\n}\n\n.social-icons-color-standard .vimeo-unauth {\n  border-color: #1ab7ea;\n  background-color: #1ab7ea;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .vimeo-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .vimeo-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(26, 183, 234, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .vimeo-unauth:not(:hover) {\n  background-color: rgba(26, 183, 234, 0.4);\n}\n\n.social-icons-color-standard .vine .sqs-use--icon,\n.social-icons-color-standard .vine .sqs-use--mask {\n  fill: #00b488;\n}\n\n.social-icons-color-standard .vine {\n  border-color: #00b488;\n  background-color: #00b488;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .vine:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .vine:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(0, 180, 136, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .vine:not(:hover) {\n  background-color: rgba(0, 180, 136, 0.4);\n}\n\n.social-icons-color-standard .vsco .sqs-use--icon,\n.social-icons-color-standard .vsco .sqs-use--mask {\n  fill: #ae995a;\n}\n\n.social-icons-color-standard .vsco {\n  border-color: #ae995a;\n  background-color: #ae995a;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .vsco:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .vsco:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(174, 153, 90, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .vsco:not(:hover) {\n  background-color: rgba(174, 153, 90, 0.4);\n}\n\n.social-icons-color-standard .yelp .sqs-use--icon,\n.social-icons-color-standard .yelp .sqs-use--mask {\n  fill: #c41200;\n}\n\n.social-icons-color-standard .yelp {\n  border-color: #c41200;\n  background-color: #c41200;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .yelp:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .yelp:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(196, 18, 0, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .yelp:not(:hover) {\n  background-color: rgba(196, 18, 0, 0.4);\n}\n\n.social-icons-color-standard .youtube .sqs-use--icon,\n.social-icons-color-standard .youtube .sqs-use--mask {\n  fill: #e52d27;\n}\n\n.social-icons-color-standard .youtube {\n  border-color: #e52d27;\n  background-color: #e52d27;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .youtube:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .youtube:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(229, 45, 39, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .youtube:not(:hover) {\n  background-color: rgba(229, 45, 39, 0.4);\n}\n\n.social-icons-color-standard .youtube-unauth .sqs-use--icon,\n.social-icons-color-standard .youtube-unauth .sqs-use--mask {\n  fill: #e52d27;\n}\n\n.social-icons-color-standard .youtube-unauth {\n  border-color: #e52d27;\n  background-color: #e52d27;\n}\n\n.social-icons-color-standard.social-icons-style-regular\n  .sqs-svg-icon--list:hover\n  .youtube-unauth:not(:hover)\n  .sqs-use--icon,\n.social-icons-color-standard.social-icons-style-knockout\n  .sqs-svg-icon--list:hover\n  .youtube-unauth:not(:hover)\n  .sqs-use--mask {\n  fill: rgba(229, 45, 39, 0.4);\n}\n\n.social-icons-color-standard.social-icons-style-solid\n  .sqs-svg-icon--list:hover\n  .youtube-unauth:not(:hover) {\n  background-color: rgba(229, 45, 39, 0.4);\n}\n\n.sqs-block-markdown {\n  clear: none;\n}\n\n.sqs-block-markdown .sqs-block-content {\n  position: relative;\n}\n\n.sqs-block-markdown .sqs-block-content *:first-child {\n  margin-top: 0;\n}\n\n.sqs-block-markdown .sqs-block-content *:last-child {\n  margin-bottom: 0;\n}\n\n.sqs-block-markdown .sqs-placeholder {\n  color: #999;\n}\n\n.sqs-block-markdown .sqs-editing-overlay {\n  display: none;\n}\n\n.sqs-block-markdown hr {\n  border: none;\n  border-bottom: 1px solid #ccc;\n  width: 75%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sqs-block-markdown textarea {\n  position: absolute;\n  top: 17px;\n  bottom: 0;\n  left: 25px;\n  right: 25px;\n  width: calc(100% - 50px);\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  resize: none;\n  overflow: hidden;\n  color: #333;\n}\n\n.sqs-block-markdown .textarea-clone {\n  margin: 0;\n  min-height: 18px;\n  visibility: hidden;\n}\n\n.sqs-block-markdown textarea,\n.sqs-block-markdown .textarea-clone {\n  font: 15px/18px \"Courier New\", monospace !important;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.sqs-block-markdown img {\n  max-width: 100%;\n  height: auto;\n}\n\n.donation-block .sqs-donate-button-wrapper {\n  display: block;\n}\n\n.donation-block .sqs-donate-button-wrapper--align-left {\n  text-align: left;\n}\n\n.donation-block .sqs-donate-button-wrapper--align-center {\n  text-align: center;\n}\n\n.donation-block .sqs-donate-button-wrapper--align-right {\n  text-align: right;\n}\n\n.donation-block .sqs-donate-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.sqs-block-html {\n  clear: none;\n}\n\n.sqs-block-html .sqs-block-content,\n.sqs-block-html .sqs-html-content {\n  outline: none;\n}\n\n.sqs-block-html .sqs-block-content *:not(h1):not(h2):not(h3),\n.sqs-block-html .sqs-html-content *:not(h1):not(h2):not(h3) {\n  word-wrap: break-word;\n}\n\n.sqs-block-html .sqs-block-content > *:first-child,\n.sqs-block-html .sqs-html-content > *:first-child {\n  margin-top: 0;\n}\n\n.sqs-block-html .sqs-block-content > *:last-child,\n.sqs-block-html .sqs-html-content > *:last-child {\n  margin-bottom: 0;\n}\n\n.sqs-block-html\n  .sqs-block-content.sqs-background-enabled\n  .sqs-block-content\n  > *:nth-last-child(2),\n.sqs-block-html\n  .sqs-html-content.sqs-background-enabled\n  .sqs-block-content\n  > *:nth-last-child(2) {\n  margin-bottom: 0;\n}\n\n.sqs-block-html .sqs-block-content .sqsrte-scaled-text-container,\n.sqs-block-html .sqs-html-content .sqsrte-scaled-text-container {\n  height: auto;\n}\n\n.sqs-block-html .sqs-block-content .sqsrte-scaled-text-container:not(.loaded) *,\n.sqs-block-html .sqs-html-content .sqsrte-scaled-text-container:not(.loaded) * {\n  white-space: normal !important;\n  transform: none !important;\n  max-width: none !important;\n  height: auto !important;\n}\n\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h1,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h1,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h2,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h2,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h3,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h3,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h4,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  h4,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  p,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  p,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  a,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  a,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  pre,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  pre,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  code,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container.loaded\n  .sqsrte-scaled-text\n  code {\n  position: relative;\n  left: initial;\n  white-space: nowrap !important;\n  margin: 0;\n}\n\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text {\n  transform-origin: 0 0;\n  position: relative;\n  display: inline-block;\n  word-break: break-all;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  left: -10000px;\n}\n\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  a,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  a {\n  display: inline-block;\n}\n\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h1,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h1,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h2,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h2,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h3,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h3,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h4,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  h4,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  p,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  p,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  a,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  a,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  pre,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  pre,\n.sqs-block-html\n  .sqs-block-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  code,\n.sqs-block-html\n  .sqs-html-content\n  .sqsrte-scaled-text-container\n  > .sqsrte-scaled-text\n  code {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  font-size: inherit !important;\n}\n\n.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:link,\n.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:link,\n.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:visited,\n.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:visited,\n.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:hover,\n.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:hover,\n.sqs-block-html .sqs-block-content .sqsrte-text-highlight a:active,\n.sqs-block-html .sqs-html-content .sqsrte-text-highlight a:active {\n  text-decoration: none;\n  background-image: none;\n}\n\n.sqs-block-html .TextShape {\n  text-decoration: none !important;\n}\n\n.sqs-block-html .TextShape-node {\n  --stroke: currentcolor;\n  --stroke-width: 1px;\n  --stroke-linecap: square;\n  --stroke-linejoin: square;\n  --opacity: 1;\n  --blend: none;\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  z-index: -1;\n  user-select: none;\n  -webkit-user-select: none;\n  opacity: 1;\n  visibility: visible;\n  transition: opacity 0.25s ease-out, visibility 0.25s ease-out;\n  mix-blend-mode: var(--blend);\n}\n\n.sqs-block-html .TextShape-node[data-is-front=\"true\"] {\n  z-index: 1;\n}\n\n.sqs-block-html .TextShape-node svg {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  stroke: var(--stroke);\n  stroke-width: var(--stroke-width);\n  stroke-width: max(1px, var(--stroke-width));\n  stroke-linecap: var(--stroke-linecap);\n  stroke-linejoin: var(--stroke-linejoin);\n  fill: none;\n  opacity: var(--opacity);\n}\n\n.embed-block .intrinsic,\n.video-block .intrinsic,\n.embed-block .sqs-block-content .intrinsic,\n.video-block .sqs-block-content .intrinsic {\n  position: relative;\n}\n\n.embed-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),\n.video-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),\n.embed-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud),\n.video-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud) {\n  position: relative;\n}\n\n.embed-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .sqs-video-wrapper,\n.video-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .sqs-video-wrapper,\n.embed-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .sqs-video-wrapper,\n.video-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .sqs-video-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.embed-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  iframe,\n.video-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  iframe,\n.embed-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  iframe,\n.video-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.embed-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .flickr-oembed,\n.video-block\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .flickr-oembed,\n.embed-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .flickr-oembed,\n.video-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-wrapper:not(.embed-block-provider-SoundCloud)\n  .flickr-oembed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.embed-block .intrinsic .embed-block-provider-SoundCloud,\n.video-block .intrinsic .embed-block-provider-SoundCloud,\n.embed-block .sqs-block-content .intrinsic .embed-block-provider-SoundCloud,\n.video-block .sqs-block-content .intrinsic .embed-block-provider-SoundCloud {\n  padding-bottom: 0 !important;\n}\n\n.embed-block .intrinsic .embed-block-provider-SoundCloud iframe,\n.video-block .intrinsic .embed-block-provider-SoundCloud iframe,\n.embed-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-provider-SoundCloud\n  iframe,\n.video-block\n  .sqs-block-content\n  .intrinsic\n  .embed-block-provider-SoundCloud\n  iframe {\n  width: 100%;\n}\n\n.sqs-stretched.sqs-block-audio .sqs-block-content,\n.sqs-stretched.sqs-block-audio .sqs-block-audio-content,\n.sqs-stretched.sqs-block-audio .sqs-audio-embed,\n.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player,\n.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player-content,\n.sqs-stretched.sqs-block-audio .player {\n  height: 100%;\n}\n\n.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player .player .play {\n  display: flex;\n  align-items: center;\n}\n\n.sqs-stretched.sqs-block-audio .sqs-widgets-audio-player.playing .player .play {\n  display: none;\n}\n\n.sqs-stretched.sqs-block-audio\n  .sqs-widgets-audio-player.playing\n  .player\n  .pause {\n  display: block;\n}\n\n.fluid-engine .sqs-block-map.vsize-12 .sqs-block-content {\n  height: 100%;\n}\n\n.sqs-block-map .sqs-block-map-content {\n  position: relative;\n}\n\n.sqs-block-map .sqs-block-map-content .sqs-map-wrapper {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  height: 100%;\n  max-width: none;\n  width: 100%;\n}\n\n.sqs-gallery-block-stacked {\n  padding: 0;\n  margin: 0;\n}\n\n.sqs-gallery-block-stacked a {\n  border: 0;\n}\n\n.sqs-gallery-block-stacked .image-wrapper {\n  margin: 0 0 1px 0;\n  line-height: 1px;\n}\n\n.sqs-gallery-block-stacked .image-wrapper img {\n  width: 100%;\n}\n\n.sqs-gallery-block-stacked .meta {\n  display: none;\n}\n\n.sqs-gallery-block-stacked.sqs-gallery-block-show-meta .meta {\n  display: block;\n}\n\n.sqs-gallery-block-stacked .meta-inside {\n  margin-bottom: 28px;\n  margin-top: 14px;\n}\n\n.sqs-gallery-block-stacked .meta-title {\n  margin-bottom: 0.3em;\n}\n\n.sqs-gallery-block-stacked .meta-description {\n  font-size: 0.9em;\n  line-height: 1.5em;\n}\n\n.sqs-gallery-block-stacked .meta-description p {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.sqs-gallery-block-slideshow {\n  position: relative;\n  background-color: rgba(175, 175, 175, 0.1);\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-transparent-background {\n  background-color: transparent;\n}\n\n.sqs-gallery-block-slideshow .slide > a {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.sqs-gallery-block-slideshow .slide .meta {\n  opacity: 0;\n}\n\n.sqs-gallery-block-slideshow .meta {\n  position: absolute;\n  opacity: 0;\n  background-color: #111;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n.sqs-gallery-block-slideshow .meta .meta-title {\n  color: #fff;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-title {\n  font-size: 18px;\n  line-height: 1.2em;\n  letter-spacing: 1px;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-title + .meta-description {\n  margin-top: 0.3em;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-description,\n.sqs-gallery-block-slideshow .meta .meta-description p {\n  color: #ddd;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 14px;\n  line-height: 1.5em;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-description strong {\n  color: inherit;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-description *:first-child {\n  margin-top: 0;\n}\n\n.sqs-gallery-block-slideshow .meta .meta-description *:last-child {\n  margin-bottom: 0;\n}\n\n.sqs-gallery-block-slideshow .meta-inside {\n  padding: 25px;\n}\n\n.sqs-gallery-block-slideshow .meta a,\n.sqs-gallery-block-slideshow .meta a:hover {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.sqs-gallery-block-slideshow .meta.overflow {\n  overflow-y: auto;\n}\n\n.sqs-gallery-block-slideshow .slide.loaded .meta {\n  opacity: 1;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover .meta {\n  opacity: 0 !important;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover .slide:hover .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover\n  .slide\n  :focus\n  ~ .meta {\n  opacity: 1 !important;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\n}\n\n.sqs-gallery-block-slideshow .meta {\n  display: none;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .sqs-active-slide\n  .meta {\n  display: block;\n  opacity: 1;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  > a {\n  line-height: 0;\n  height: auto;\n  position: static;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .sqs-video-wrapper {\n  position: static;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta {\n  background-color: transparent;\n  color: inherit;\n  padding: 20px 0 10px 0;\n  margin: 0;\n  max-width: none !important;\n  opacity: 1 !important;\n  position: static !important;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-inside {\n  padding: 0;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-title,\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-description,\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-description\n  p {\n  color: inherit;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-title {\n  font-size: 0.9em;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-description {\n  font-size: 0.9em;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-show-meta\n  .mobile-view\n  .slide.loaded\n  .meta\n  .meta-description\n  p {\n  font-size: 1em;\n  line-height: 1.3em;\n}\n\n.sqs-gallery-block-slideshow .slide.video-playing .meta {\n  display: none;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-left .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-right .meta {\n  top: 0px;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-left .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-top-right .meta {\n  max-width: 50%;\n  margin: 20px;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-center .meta {\n  max-width: 50%;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-left .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-right\n  .meta {\n  bottom: 0px;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom .meta {\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(30, 30, 30, 0.3) 100%\n  );\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom\n  .meta-inside {\n  padding: 30px 20px 15px;\n}\n\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-left .meta,\n.sqs-gallery-block-slideshow.sqs-gallery-block-meta-position-bottom-right\n  .meta {\n  max-width: 50%;\n  margin: 20px;\n}\n\n.sqs-gallery-block-slider {\n  position: relative;\n  height: 100%;\n}\n\n.sqs-gallery-block-grid {\n  overflow: hidden;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-1\n  .sqs-gallery-design-grid-slide {\n  width: 100% !important;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-1\n  .sqs-gallery-design-grid-slide:nth-child(1n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-2\n  .sqs-gallery-design-grid-slide {\n  width: 50%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-2\n  .sqs-gallery-design-grid-slide:nth-child(2n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-3\n  .sqs-gallery-design-grid-slide {\n  width: 33.33333333%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-3\n  .sqs-gallery-design-grid-slide:nth-child(3n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-4\n  .sqs-gallery-design-grid-slide {\n  width: 25%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-4\n  .sqs-gallery-design-grid-slide:nth-child(4n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-5\n  .sqs-gallery-design-grid-slide {\n  width: 20%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-5\n  .sqs-gallery-design-grid-slide:nth-child(5n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-6\n  .sqs-gallery-design-grid-slide {\n  width: 16.66666667%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-6\n  .sqs-gallery-design-grid-slide:nth-child(6n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-7\n  .sqs-gallery-design-grid-slide {\n  width: 14.28571429%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-7\n  .sqs-gallery-design-grid-slide:nth-child(7n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-8\n  .sqs-gallery-design-grid-slide {\n  width: 12.5%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-8\n  .sqs-gallery-design-grid-slide:nth-child(8n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-9\n  .sqs-gallery-design-grid-slide {\n  width: 11.11111111%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-9\n  .sqs-gallery-design-grid-slide:nth-child(9n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-10\n  .sqs-gallery-design-grid-slide {\n  width: 10%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-thumbnails-per-row-10\n  .sqs-gallery-design-grid-slide:nth-child(10n + 1) {\n  clear: left;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-square\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 100%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 66.666%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-standard-vertical\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 150%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-four-three\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 75%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-three-four-vertical\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 133.333%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-widescreen\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 56.25%;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen\n  .slide\n  .margin-wrapper\n  a.image-slide-anchor,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen\n  .slide\n  .margin-wrapper\n  .content-wrapper,\n.sqs-gallery-block-grid.sqs-gallery-aspect-ratio-anamorphic-widescreen\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  padding-bottom: 41.666%;\n}\n\n.sqs-gallery-block-grid .slide {\n  float: left;\n  width: 25%;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper {\n  position: relative;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor {\n  padding-bottom: 100%;\n  width: 100%;\n  height: 0;\n  display: block;\n  cursor: default;\n  border-bottom: none;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor img {\n  display: inline-block;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper a.image-slide-anchor[href] img {\n  cursor: pointer;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper .content-wrapper {\n  padding-bottom: 100%;\n  width: 100%;\n  display: block;\n}\n\n.sqs-gallery-block-grid\n  .slide\n  .margin-wrapper\n  .content-wrapper.content-fill\n  .sqs-video-wrapper {\n  height: 0;\n  padding-bottom: 100%;\n}\n\n.sqs-gallery-block-grid\n  .slide\n  .margin-wrapper\n  .content-wrapper.video-lightbox-wrapper {\n  cursor: pointer;\n}\n\n.sqs-gallery-block-grid\n  .slide\n  .margin-wrapper\n  .content-wrapper.video-lightbox-wrapper\n  .sqs-video-wrapper\n  .intrinsic {\n  pointer-events: none;\n}\n\n.sqs-gallery-block-grid .slide .margin-wrapper .image-slide-title {\n  text-align: center;\n  display: none;\n}\n\n.sqs-gallery-block-grid .slide .meta {\n  position: relative;\n}\n\n.sqs-gallery-block-grid .slide .meta h1 {\n  font-size: 12px;\n  letter-spacing: normal;\n  margin: 0;\n}\n\n.sqs-gallery-block-grid.sqs-gallery-block-meta-only-title\n  .margin-wrapper\n  .image-slide-title {\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  margin-top: 0.5em;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sqs-block .sqs-gallery-thumbnails .sqs-video-thumbnail {\n  position: relative;\n}\n\n.sqs-block .sqs-gallery-thumbnails .sqs-video-thumbnail img {\n  height: 100%;\n}\n\n.sqs-block\n  .sqs-gallery-thumbnails\n  .sqs-video-thumbnail\n  .sqs-video-thumbnail-icon {\n  opacity: 1;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  /* background-image: url(\"//assets.squarespace.com/universal/images-v6/icons/icon-video-24-light-solid.png\"); */\n  background-position: center center;\n  height: 24px;\n  width: 24px;\n  margin-left: -12px;\n  margin-top: -12px;\n}\n\n.sqs-block\n  .sqs-gallery-thumbnails\n  .sqs-video-thumbnail.no-image\n  .sqs-video-thumbnail-inner {\n  /* background-image: url(\"//assets.squarespace.com/universal/images-v6/icons/icon-video-24-light-solid.png\"); */\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.sqs-block\n  .sqs-gallery-thumbnails\n  .sqs-video-thumbnail:not(.no-image).loading\n  .sqs-video-thumbnail-icon {\n  opacity: 0;\n}\n\n.sqs-block\n  .sqs-gallery-thumbnails\n  .sqs-video-thumbnail\n  .sqs-video-thumbnail-inner {\n  height: 100%;\n  background: #000;\n}\n\n.sqs-block .sqs-gallery-thumbnails .sqs-gallery-design-strip-slide {\n  opacity: 0.5;\n}\n\n.sqs-block\n  .sqs-gallery-thumbnails\n  .sqs-gallery-design-strip-slide.sqs-active-slide {\n  opacity: 1;\n}\n\n.sqs-gallery-design-strip-slide img,\n.sqs-gallery-design-strip-slide .sqs-video-wrapper {\n  width: auto;\n  height: 100%;\n}\n\n.sqs-gallery-block-stacked .image-wrapper img {\n  width: 100%;\n  height: auto;\n}\n\n.sqs-gallery-block-grid img {\n  transition: opacity 1s;\n}\n\n.sqs-gallery-block-grid img:not(.loaded) {\n  opacity: 0;\n}\n\n.sqs-gallery-block-grid img.loaded {\n  opacity: 1 !important;\n}\n\n@media only screen and (max-width: 480px) {\n  .sqs-gallery-block-slideshow .meta {\n    display: none !important;\n  }\n}\n\n@media only screen and (device-width: 768px) {\n  .sqs-gallery-block-slideshow.sqs-gallery-block-show-meta .meta {\n    opacity: 1 !important;\n  }\n}\n\n.sqs-block.gallery-block .sqs-helper .sqs-handle-bottom {\n  display: none;\n}\n\n.sqs-block.gallery-block.sized .sqs-helper .sqs-handle-bottom {\n  display: block;\n}\n\n.sqs-layout.editing\n  .sqs-block.gallery-block:hover\n  .sqs-gallery-block-slideshow.sqs-gallery-block-meta-hover\n  .meta {\n  opacity: 1 !important;\n}\n\n.sqs-gallery-dummy-images {\n  background-color: transparent;\n}\n\n.sqs-gallery-dummy-images img,\n.sqs-gallery-dummy-images + .sqs-gallery-thumbnails img {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n/*! WARNING: block .less requested, but unable to resolve css from system cache: calendar */\n.summary-block ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.summary-block .summary-item:not(:last-child) {\n  margin-bottom: 24px;\n}\n\n.summary-block .summary-collection-title {\n  display: none;\n}\n\n.summary-block .summary-thumbnail {\n  overflow: hidden;\n  height: 150px;\n}\n\n.summary-block .summary-title {\n  font-size: 1.2em;\n}\n\n.summary-block .summary-content-below-thumbnail .summary-title {\n  margin: 1em 0 0 0;\n}\n\n.summary-block .summary-excerpt {\n  margin: 0.75em 0;\n}\n\n.summary-block .summary-excerpt p {\n  font-size: 0.9em;\n}\n\n.summary-block .timestamp {\n  display: block;\n  font-size: 0.8em;\n  text-transform: uppercase;\n}\n\n.summary-block .summary-more-link {\n  display: none;\n  margin-left: 3px;\n}\n\n.sqs-block-horizontalrule hr {\n  border: none;\n  color: #bbb;\n  background-color: #bbb;\n  height: 1px;\n}\n\n.sqs-block-image .sqs-block-image-figure {\n  margin: 0;\n}\n\n.sqs-block-image .sqs-block-image-link {\n  display: block;\n}\n\n.sqs-block-image .sqs-block-image-button {\n  display: block;\n  width: 100%;\n  border: none;\n  padding: 0;\n  background: none;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 {\n  position: relative;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 p {\n  font-size: inherit;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .intrinsic {\n  position: relative;\n  max-width: initial !important;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-inset {\n  position: relative;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .intrinsic img {\n  display: block;\n  width: 100%;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .sqs-image-content::after,\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-overlay {\n  content: \"\";\n  display: block;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card-wrapper {\n  z-index: 2;\n  pointer-events: none;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card {\n  pointer-events: auto;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a {\n  display: inline;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a,\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-card a:hover {\n  text-decoration: none;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .image-card\n  .sqs-editing {\n  pointer-events: auto;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 a.image-inset,\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  a.image-title-wrapper {\n  display: block;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 a.image-inset:hover,\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  a.image-title-wrapper:hover {\n  text-decoration: none;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-title p,\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-subtitle p {\n  white-space: pre-wrap;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-title p {\n  display: inline;\n  margin: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .image-subtitle p {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .image-subtitle\n  p:first-child {\n  margin-top: 0;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .image-subtitle\n  p:last-child {\n  margin-bottom: 0;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .sqs-image.stretch {\n  margin: 0 !important;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  + .image-caption-wrapper,\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .image-caption-wrapper {\n  display: none;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2\n  .sqs-editing-overlay {\n  z-index: 1;\n}\n\n.sqs-block-image .image-block-outer-wrapper.image-block-v2 .upload-indicator {\n  display: none !important;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.image-block-v2:not(.design-layout-poster)\n  ~ .yui3-resize-handles-wrapper {\n  display: none;\n}\n\n.sqs-image-min-height {\n  min-height: 1px;\n}\n\n.sqs-block-image .design-layout-poster .image-card-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.sqs-block-image .design-layout-poster .image-card-wrapper,\n.sqs-block-image .design-layout-poster .image-card {\n  pointer-events: none !important;\n}\n\n.sqs-block-image .design-layout-poster .image-card-wrapper a {\n  pointer-events: auto;\n  display: inline-block;\n}\n\n.sqs-block-image .design-layout-poster .intrinsic img {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.sqs-block-image .design-layout-poster .image-card {\n  width: 75%;\n}\n\n.sqs-block-image .design-layout-poster .sqs-image-content::after,\n.sqs-block-image .design-layout-poster .image-overlay {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.sqs-block-image .design-layout-poster .image-title a,\n.sqs-block-image .design-layout-poster .image-subtitle a {\n  color: #fff;\n}\n\n.sqs-block-image .design-layout-poster .image-title a:hover,\n.sqs-block-image .design-layout-poster .image-subtitle a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image .design-layout-poster .image-title p {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0);\n  box-shadow: 0.25em 0 0 rgba(255, 255, 255, 0),\n    -0.25em 0 0 rgba(255, 255, 255, 0);\n}\n\n.sqs-block-image .design-layout-poster .image-subtitle p {\n  color: #fff;\n}\n\n.sqs-block-image\n  .design-layout-poster\n  .image-title-wrapper\n  + .image-subtitle-wrapper\n  .image-subtitle {\n  margin-top: 3%;\n}\n\n.sqs-block-image .design-layout-card .sqs-image-content::after,\n.sqs-block-image .design-layout-card .image-overlay {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.sqs-block-image .design-layout-card .image-card-wrapper {\n  background-color: #fff;\n}\n\n.sqs-block-image .design-layout-card .image-card {\n  padding: 10% 0;\n}\n\n.sqs-block-image .design-layout-card .image-title-wrapper,\n.sqs-block-image .design-layout-card .image-subtitle-wrapper,\n.sqs-block-image .design-layout-card .image-button-wrapper {\n  padding: 0 10%;\n}\n\n.sqs-block-image .design-layout-card .image-title-wrapper a,\n.sqs-block-image .design-layout-card .image-subtitle-wrapper a {\n  color: #000;\n}\n\n.sqs-block-image .design-layout-card .image-title-wrapper a:hover,\n.sqs-block-image .design-layout-card .image-subtitle-wrapper a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image .design-layout-card .image-title p {\n  background-color: rgba(255, 255, 255, 0);\n  color: #000;\n  box-shadow: 0.5em 0 0 rgba(255, 255, 255, 0),\n    -0.5em 0 0 rgba(255, 255, 255, 0);\n}\n\n.sqs-block-image .design-layout-card .image-subtitle p {\n  color: #000;\n}\n\n.sqs-block-image\n  .design-layout-card\n  .image-title-wrapper\n  + .image-subtitle-wrapper\n  .image-subtitle {\n  margin-top: 4%;\n}\n\n.sqs-block-image .design-layout-card.sqs-narrow-width .image-card-wrapper {\n  margin-top: 2%;\n}\n\n.sqs-block-image .design-layout-card:not(.sqs-narrow-width) {\n  display: flex;\n  justify-content: space-between;\n}\n\n.sqs-block-image\n  .design-layout-card:not(.sqs-narrow-width).image-position-right {\n  flex-direction: row-reverse;\n}\n\n.sqs-block-image .design-layout-card:not(.sqs-narrow-width) > :first-child {\n  width: calc(50% - 1%);\n}\n\n.sqs-block-image\n  .design-layout-card:not(.sqs-narrow-width)\n  .image-card-wrapper {\n  position: relative;\n  width: calc(50% - 1%);\n}\n\n.sqs-block-image\n  .design-layout-card:not(.sqs-narrow-width)\n  .image-card-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100%;\n}\n\n.sqs-block-image .design-layout-card:not(.sqs-narrow-width) .image-card {\n  position: relative;\n  width: 100%;\n}\n\n.sqs-block-image\n  .design-layout-card:not(.sqs-narrow-width).image-position-left\n  .image-card-wrapper {\n  margin-left: 2%;\n}\n\n.sqs-block-image\n  .design-layout-card:not(.sqs-narrow-width).image-position-right\n  .image-card-wrapper {\n  margin-right: 2%;\n}\n\n.sqs-block-image .design-layout-card:not(.sqs-narrow-width):after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.sqs-block-image .design-layout-overlap .sqs-image-content::after,\n.sqs-block-image .design-layout-overlap .image-overlay {\n  background-color: rgba(150, 150, 150, 0);\n}\n\n.sqs-block-image .design-layout-overlap .image-card-wrapper {\n  position: relative;\n}\n\n.sqs-block-image .design-layout-overlap .image-title a,\n.sqs-block-image .design-layout-overlap .image-subtitle a {\n  color: #000;\n}\n\n.sqs-block-image .design-layout-overlap .image-title a:hover,\n.sqs-block-image .design-layout-overlap .image-subtitle a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image .design-layout-overlap .image-title p {\n  color: #000;\n  background-color: #fff;\n  box-shadow: 0.2em 0 0 #fff, -0.2em 0 0 #fff;\n}\n\n.sqs-block-image .design-layout-overlap .image-subtitle p {\n  color: #000;\n  text-align: left;\n  margin-bottom: 0;\n}\n\n.sqs-block-image\n  .design-layout-overlap\n  .image-title-wrapper\n  + .image-subtitle-wrapper\n  .image-subtitle {\n  margin-top: 4%;\n}\n\n.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-card-wrapper {\n  padding: 0 4%;\n}\n\n.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-card {\n  width: 75%;\n}\n\n.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-title {\n  margin-top: calc(-1em - 2%);\n}\n\n.sqs-block-image .design-layout-overlap.sqs-narrow-width .image-title-wrapper,\n.sqs-block-image\n  .design-layout-overlap.sqs-narrow-width\n  .image-subtitle-wrapper {\n  width: 133.33333333%;\n}\n\n.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) {\n  display: flex;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-card-wrapper,\n.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) > :first-child {\n  width: 50%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-card-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-right {\n  flex-direction: row-reverse;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-right\n  .image-card-wrapper {\n  justify-content: flex-start;\n}\n\n.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) .image-card {\n  width: 100%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-left\n  .image-card {\n  margin-left: -100%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-right\n  .image-card {\n  margin-right: -100%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-title-wrapper,\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-subtitle-wrapper,\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-button-wrapper {\n  box-sizing: border-box;\n  padding: 0 5%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-subtitle-wrapper {\n  padding-top: 0;\n}\n\n.sqs-block-image .design-layout-overlap:not(.sqs-narrow-width) .image-subtitle {\n  width: 100%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  > :first-child\n  > * {\n  width: 100%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width)\n  .image-title-wrapper {\n  width: 150%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-left\n  .image-title-wrapper {\n  margin-left: -50%;\n}\n\n.sqs-block-image\n  .design-layout-overlap:not(.sqs-narrow-width).image-position-right\n  > :first-child\n  > * {\n  left: 0%;\n}\n\n.sqs-block-image .design-layout-collage .sqs-image-content::after,\n.sqs-block-image .design-layout-collage .image-overlay {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.sqs-block-image .design-layout-collage .image-card {\n  background-color: #000;\n  padding: 10%;\n  box-sizing: border-box;\n}\n\n.sqs-block-image .design-layout-collage .image-title a,\n.sqs-block-image .design-layout-collage .image-subtitle a {\n  color: #fff;\n}\n\n.sqs-block-image .design-layout-collage .image-title a:hover,\n.sqs-block-image .design-layout-collage .image-subtitle a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image .design-layout-collage .image-title p {\n  color: #fff;\n}\n\n.sqs-block-image .design-layout-collage .image-subtitle-wrapper {\n  width: 100%;\n}\n\n.sqs-block-image .design-layout-collage .image-subtitle p {\n  color: #9b9b9b;\n}\n\n.sqs-block-image\n  .design-layout-collage\n  .image-title-wrapper\n  + .image-subtitle-wrapper\n  .image-subtitle {\n  margin-top: 4%;\n}\n\n.sqs-block-image .design-layout-collage.sqs-narrow-width .intrinsic {\n  width: 90%;\n}\n\n.sqs-block-image .design-layout-collage.sqs-narrow-width .image-card-wrapper {\n  width: 90%;\n  margin-top: calc(-10% - 10%);\n  position: relative;\n}\n\n.sqs-block-image\n  .design-layout-collage.sqs-narrow-width.image-position-left:after {\n  content: \" \";\n  display: block;\n  clear: both;\n}\n\n.sqs-block-image\n  .design-layout-collage.sqs-narrow-width.image-position-left\n  .image-card-wrapper {\n  float: right;\n}\n\n.sqs-block-image\n  .design-layout-collage.sqs-narrow-width.image-position-right\n  .intrinsic {\n  left: 10%;\n}\n\n.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) {\n  display: flex;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width).image-position-right {\n  flex-direction: row-reverse;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width)\n  .image-card-wrapper,\n.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) > :first-child {\n  width: 50%;\n}\n\n.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .intrinsic {\n  overflow: visible;\n}\n\n.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .sqs-intrinsic {\n  width: 100%;\n}\n\n.sqs-block-image .design-layout-collage:not(.sqs-narrow-width) .image-inset,\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width)\n  .sqs-image-content {\n  position: relative !important;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width)\n  .image-card-wrapper {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.image-block-collage-content-position-top\n  .sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width)\n  .image-card {\n  margin-top: 10%;\n}\n\n.image-block-collage-content-position-bottom\n  .sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width)\n  .image-card {\n  margin-bottom: 10%;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width).image-position-left\n  > :first-child\n  > * {\n  width: 140%;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width).image-position-left\n  .image-card {\n  width: 90%;\n  margin-left: 10%;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width).image-position-right\n  > :first-child\n  > * {\n  width: 140%;\n  left: -40%;\n}\n\n.sqs-block-image\n  .design-layout-collage:not(.sqs-narrow-width).image-position-right\n  .image-card {\n  width: 90%;\n  margin-right: 10%;\n}\n\n.sqs-block-image .design-layout-stack .intrinsic img {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.sqs-block-image .design-layout-stack .sqs-image-content::after,\n.sqs-block-image .design-layout-stack .image-overlay {\n  background-color: rgba(255, 255, 255, 0);\n}\n\n.sqs-block-image .design-layout-stack .image-card-wrapper {\n  background-color: rgba(255, 255, 255, 0);\n  margin-top: 5%;\n}\n\n.sqs-block-image .design-layout-stack .image-title a,\n.sqs-block-image .design-layout-stack .image-subtitle a {\n  color: #000;\n}\n\n.sqs-block-image .design-layout-stack .image-title a:hover,\n.sqs-block-image .design-layout-stack .image-subtitle a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image .design-layout-stack .image-card {\n  padding: 0px;\n}\n\n.sqs-block-image .design-layout-stack .image-title p {\n  color: #000;\n}\n\n.sqs-block-image .design-layout-stack .image-subtitle p {\n  color: #000;\n}\n\n.sqs-block-image\n  .design-layout-stack\n  .image-title-wrapper\n  + .image-subtitle-wrapper\n  .image-subtitle {\n  margin-top: 4%;\n}\n\n.sqs-block-image .design-layout-card .intrinsic img,\n.sqs-block-image .design-layout-overlap .intrinsic img,\n.sqs-block-image .design-layout-collage .intrinsic img,\n.sqs-block-image .design-layout-stack .intrinsic img {\n  width: 100% !important;\n  height: auto !important;\n  position: static !important;\n}\n\n.sqs-block-image\n  .design-layout-card\n  .sqs-image:not(.sqs-empty)\n  .sqs-image-content,\n.sqs-block-image\n  .design-layout-overlap\n  .sqs-image:not(.sqs-empty)\n  .sqs-image-content,\n.sqs-block-image\n  .design-layout-collage\n  .sqs-image:not(.sqs-empty)\n  .sqs-image-content,\n.sqs-block-image\n  .design-layout-stack\n  .sqs-image:not(.sqs-empty)\n  .sqs-image-content {\n  padding-bottom: 0 !important;\n}\n\n.image-block-outer-wrapper.animation-disabled,\n.image-block-outer-wrapper.animation-loaded {\n  transform: translatez(0);\n}\n\n.image-block-outer-wrapper.animation-disabled .image-inset,\n.image-block-outer-wrapper.animation-disabled .image-block-wrapper,\n.image-block-outer-wrapper.animation-disabled .sqs-image-content,\n.image-block-outer-wrapper.animation-disabled .image-caption-wrapper,\n.image-block-outer-wrapper.animation-disabled .sqs-dynamic-text-container {\n  transition: none !important;\n}\n\n.image-block-outer-wrapper.combination-animation-fade-in .image-inset,\n.image-block-outer-wrapper.combination-animation-fade-in .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-fade-in .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-fade-in .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-fade-in\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-fade-in.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-slide-up .image-inset,\n.image-block-outer-wrapper.combination-animation-slide-up .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-slide-up .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-slide-up\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-slide-up\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-slide-up.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-horizontal-clip .image-inset,\n.image-block-outer-wrapper.combination-animation-horizontal-clip\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-horizontal-clip\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-horizontal-clip\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-horizontal-clip\n  .sqs-dynamic-text-container {\n  transition: -webkit-clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: -webkit-clip-path, clip-path;\n  -webkit-clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    0% 100%,\n    0% 50%,\n    100% 50%,\n    100% 0%,\n    100% 0%,\n    100% 50%,\n    100% 50%,\n    100% 50%\n  );\n  clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    0% 100%,\n    0% 50%,\n    100% 50%,\n    100% 0%,\n    100% 0%,\n    100% 50%,\n    100% 50%,\n    100% 50%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-horizontal-clip.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  -webkit-clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    100% 100%,\n    100% 50%,\n    100% 50%,\n    100% 0%,\n    0% 0%,\n    0% 50%,\n    100% 50%,\n    100% 50%\n  );\n  clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    100% 100%,\n    100% 50%,\n    100% 50%,\n    100% 0%,\n    0% 0%,\n    0% 50%,\n    100% 50%,\n    100% 50%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-vertical-clip .image-inset,\n.image-block-outer-wrapper.combination-animation-vertical-clip\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-vertical-clip\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-vertical-clip\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-vertical-clip\n  .sqs-dynamic-text-container {\n  transition: -webkit-clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: -webkit-clip-path, clip-path;\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 0%,\n    50% 0%,\n    50% 100%,\n    0% 100%,\n    0% 100%,\n    50% 100%,\n    50% 100%,\n    50% 100%\n  );\n  clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 0%,\n    50% 0%,\n    50% 100%,\n    0% 100%,\n    0% 100%,\n    50% 100%,\n    50% 100%,\n    50% 100%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-vertical-clip.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 100%,\n    50% 100%,\n    50% 100%,\n    0% 100%,\n    0% 0%,\n    50% 0%,\n    50% 100%,\n    50% 100%\n  );\n  clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 100%,\n    50% 100%,\n    50% 100%,\n    0% 100%,\n    0% 0%,\n    50% 0%,\n    50% 100%,\n    50% 100%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-tilt-up .image-inset,\n.image-block-outer-wrapper.combination-animation-tilt-up .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-up .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-tilt-up .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-up\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0.03, 0, 0.92, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-up.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-tilt-down .image-inset,\n.image-block-outer-wrapper.combination-animation-tilt-down .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-down .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-tilt-down\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-down\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, -0.03, 0, 0.92, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-tilt-down.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-collide .image-inset,\n.image-block-outer-wrapper.combination-animation-collide .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-collide .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-collide .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-collide\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-collide.image-position-right\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-collide.image-position-right\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-collide.image-position-right\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-collide.image-position-right\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-collide.image-position-right\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-collide.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-collide.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-collide.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-collide.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-collide.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-reveal .image-inset,\n.image-block-outer-wrapper.combination-animation-reveal .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-reveal .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-reveal.image-position-right\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-reveal.image-position-right\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal.image-position-right\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-reveal.image-position-right\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal.image-position-right\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-reveal.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-reveal.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-reveal.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-reveal.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-focus-in .image-inset,\n.image-block-outer-wrapper.combination-animation-focus-in .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-focus-in .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-focus-in\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-focus-in\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0, 0, 0.92, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded\n  .sqs-image-content,\n.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-focus-in.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom {\n  transform: translatez(0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-fade-in.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-up.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, -20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-down.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-left.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-slide-from-right.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip\n  .sqs-image-content {\n  transition: -webkit-clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: -webkit-clip-path, clip-path;\n  -webkit-clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    0% 100%,\n    0% 50%,\n    100% 50%,\n    100% 0%,\n    100% 0%,\n    100% 50%,\n    100% 50%,\n    100% 50%\n  );\n  clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    0% 100%,\n    0% 50%,\n    100% 50%,\n    100% 0%,\n    100% 0%,\n    100% 50%,\n    100% 50%,\n    100% 50%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-horizontal-clip.animation-loaded\n  .sqs-image-content {\n  -webkit-clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    100% 100%,\n    100% 50%,\n    100% 50%,\n    100% 0%,\n    0% 0%,\n    0% 50%,\n    100% 50%,\n    100% 50%\n  );\n  clip-path: polygon(\n    0% 50%,\n    0% 100%,\n    100% 100%,\n    100% 50%,\n    100% 50%,\n    100% 0%,\n    0% 0%,\n    0% 50%,\n    100% 50%,\n    100% 50%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip\n  .sqs-image-content {\n  transition: -webkit-clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    clip-path 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: -webkit-clip-path, clip-path;\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 0%,\n    50% 0%,\n    50% 100%,\n    0% 100%,\n    0% 100%,\n    50% 100%,\n    50% 100%,\n    50% 100%\n  );\n  clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 0%,\n    50% 0%,\n    50% 100%,\n    0% 100%,\n    0% 100%,\n    50% 100%,\n    50% 100%,\n    50% 100%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-vertical-clip.animation-loaded\n  .sqs-image-content {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 100%,\n    50% 100%,\n    50% 100%,\n    0% 100%,\n    0% 0%,\n    50% 0%,\n    50% 100%,\n    50% 100%\n  );\n  clip-path: polygon(\n    50% 0%,\n    100% 0%,\n    100% 100%,\n    50% 100%,\n    50% 100%,\n    0% 100%,\n    0% 0%,\n    50% 0%,\n    50% 100%,\n    50% 100%\n  );\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, -0.03, 0, 0.92, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-down.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0.03, 0, 0.92, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-tilt-up.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in\n  .sqs-image-content {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0, 0, 0.92, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded\n  .image-inset,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded\n  .image-block-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-animation-focus-in.animation-loaded\n  .sqs-image-content {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-fade-in.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, 20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-up.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 0, -20);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-down.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, -20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-left.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(1, 0, 0, 1, 20, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-slide-from-right.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in\n  .sqs-dynamic-text-container {\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1),\n    transform 800ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  opacity: 0;\n  transform: matrix(0.92, 0, 0, 0.92, 0, 0);\n}\n\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in.animation-loaded\n  .image-caption-wrapper,\n.image-block-outer-wrapper.combination-animation-custom.individual-text-animation-focus-in.animation-loaded.sqs-text-ready\n  .sqs-dynamic-text-container {\n  opacity: 1;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n}\n\n.image-block-poster-text-alignment-left\n  .sqs-block-image\n  .design-layout-poster\n  .image-card\n  > * {\n  text-align: left !important;\n}\n\n.image-block-poster-text-alignment-center\n  .sqs-block-image\n  .design-layout-poster\n  .image-card\n  > * {\n  text-align: center !important;\n}\n\n.image-block-poster-text-alignment-right\n  .sqs-block-image\n  .design-layout-poster\n  .image-card\n  > *,\n.image-block-poster-text-alignment-match\n  .sqs-block-image\n  .design-layout-poster.image-position-right\n  .image-card\n  > *,\n.image-block-poster-text-alignment-opposite\n  .sqs-block-image\n  .design-layout-poster.image-position-left\n  .image-card\n  > * {\n  text-align: right !important;\n}\n\n.image-block-card-text-alignment-left\n  .sqs-block-image\n  .design-layout-card\n  .image-card\n  > * {\n  text-align: left !important;\n}\n\n.image-block-card-text-alignment-center\n  .sqs-block-image\n  .design-layout-card\n  .image-card\n  > * {\n  text-align: center !important;\n}\n\n.image-block-card-text-alignment-right\n  .sqs-block-image\n  .design-layout-card\n  .image-card\n  > *,\n.image-block-card-text-alignment-match\n  .sqs-block-image\n  .design-layout-card.image-position-right\n  .image-card\n  > *,\n.image-block-card-text-alignment-opposite\n  .sqs-block-image\n  .design-layout-card.image-position-left\n  .image-card\n  > * {\n  text-align: right !important;\n}\n\n.image-block-overlap-text-alignment-left\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card\n  > * {\n  text-align: left !important;\n}\n\n.image-block-overlap-text-alignment-center\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card\n  > * {\n  text-align: center !important;\n}\n\n.image-block-overlap-text-alignment-right\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card\n  > *,\n.image-block-overlap-text-alignment-match\n  .sqs-block-image\n  .design-layout-overlap.image-position-right\n  .image-card\n  > *,\n.image-block-overlap-text-alignment-opposite\n  .sqs-block-image\n  .design-layout-overlap.image-position-left\n  .image-card\n  > * {\n  text-align: right !important;\n}\n\n.image-block-collage-text-alignment-left\n  .sqs-block-image\n  .design-layout-collage\n  .image-card\n  > * {\n  text-align: left !important;\n}\n\n.image-block-collage-text-alignment-center\n  .sqs-block-image\n  .design-layout-collage\n  .image-card\n  > * {\n  text-align: center !important;\n}\n\n.image-block-collage-text-alignment-right\n  .sqs-block-image\n  .design-layout-collage\n  .image-card\n  > *,\n.image-block-collage-text-alignment-match\n  .sqs-block-image\n  .design-layout-collage.image-position-right\n  .image-card\n  > *,\n.image-block-collage-text-alignment-opposite\n  .sqs-block-image\n  .design-layout-collage.image-position-left\n  .image-card\n  > * {\n  text-align: right !important;\n}\n\n.image-block-stack-text-alignment-left\n  .sqs-block-image\n  .design-layout-stack\n  .image-card\n  > * {\n  text-align: left !important;\n}\n\n.image-block-stack-text-alignment-center\n  .sqs-block-image\n  .design-layout-stack\n  .image-card\n  > * {\n  text-align: center !important;\n}\n\n.image-block-stack-text-alignment-right\n  .sqs-block-image\n  .design-layout-stack\n  .image-card\n  > *,\n.image-block-stack-text-alignment-match\n  .sqs-block-image\n  .design-layout-stack.image-position-right\n  .image-card\n  > *,\n.image-block-stack-text-alignment-opposite\n  .sqs-block-image\n  .design-layout-stack.image-position-left\n  .image-card\n  > * {\n  text-align: right !important;\n}\n\n.sqs-dynamic-text {\n  min-width: 100%;\n  line-height: 1em;\n}\n\n.min-font-set,\n.min-font-set ~ * {\n  font-size: 13px !important;\n}\n\n.image-block-v2:not([class*=\"-animation-\"]) {\n  opacity: 0;\n  transition: opacity 1s ease-out;\n  transition-delay: 1s;\n}\n\n.sqs-text-ready .image-block-v2:not([class*=\"-animation-\"]),\n.sqs-text-ready.image-block-v2:not([class*=\"-animation-\"]) {\n  opacity: 1;\n}\n\n.image-block-card-content-position-top\n  .sqs-block-image\n  .design-layout-card\n  .image-card-wrapper {\n  align-items: flex-start;\n}\n\n.image-block-card-content-position-center\n  .sqs-block-image\n  .design-layout-card\n  .image-card-wrapper {\n  align-items: center;\n}\n\n.image-block-card-content-position-bottom\n  .sqs-block-image\n  .design-layout-card\n  .image-card-wrapper {\n  align-items: flex-end;\n}\n\n.image-block-overlap-content-position-top\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card-wrapper {\n  align-items: flex-start;\n}\n\n.image-block-overlap-content-position-center\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card-wrapper {\n  align-items: center;\n}\n\n.image-block-overlap-content-position-bottom\n  .sqs-block-image\n  .design-layout-overlap\n  .image-card-wrapper {\n  align-items: flex-end;\n}\n\n.image-block-collage-content-position-top\n  .sqs-block-image\n  .design-layout-collage\n  .image-card-wrapper {\n  align-items: flex-start;\n}\n\n.image-block-collage-content-position-center\n  .sqs-block-image\n  .design-layout-collage\n  .image-card-wrapper {\n  align-items: center;\n}\n\n.image-block-collage-content-position-bottom\n  .sqs-block-image\n  .design-layout-collage\n  .image-card-wrapper {\n  align-items: flex-end;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-poster\n  .image-button-wrapper {\n  margin-top: 6%;\n  font-size: 2.25vw;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-poster\n  .image-button\n  a {\n  display: inline-block;\n  padding: 0.7em 1.75em;\n  border: 0px solid #fff;\n  background-color: #fff;\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n  font-size: inherit !important;\n  color: #000;\n  border-radius: 5em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-poster\n  .image-button\n  a:hover {\n  opacity: 0.8;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-card\n  .image-button-wrapper {\n  margin-top: 6%;\n  font-size: 4vw;\n}\n\n.sqs-block-image .image-block-outer-wrapper.design-layout-card .image-button a {\n  display: inline-block;\n  padding: 1em 2.5em;\n  border: 0px solid #000;\n  background-color: #000;\n  font-family: Arial;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  line-height: 1.1em;\n  text-transform: none;\n  color: #fff;\n  border-radius: 0.2em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-card\n  .image-button\n  a:hover {\n  opacity: 0.8;\n}\n\nbody.image-block-card-dynamic-font-sizing\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-card\n  a {\n  font-size: inherit !important;\n}\n\nbody:not(.image-block-card-dynamic-font-sizing)\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-card\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-overlap\n  .image-button-wrapper {\n  margin-top: 5%;\n  font-size: 3.6vw;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-overlap\n  .image-button\n  a {\n  display: inline-block;\n  padding: 0.7em 1.75em;\n  border: 0px solid #000;\n  background-color: #000;\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n  color: #fff;\n  border-radius: 0em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-overlap\n  .image-button\n  a:hover {\n  opacity: 0.8;\n}\n\nbody.image-block-overlap-dynamic-font-sizing\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-overlap\n  a {\n  font-size: inherit !important;\n}\n\nbody:not(.image-block-overlap-dynamic-font-sizing)\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-overlap\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-collage\n  .image-button-wrapper {\n  margin-top: 6%;\n  font-size: 4vw;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-collage\n  .image-button-wrapper\n  .image-button\n  a {\n  display: inline-block;\n  padding: 1em 2.5em;\n  border: 0px solid #fff;\n  background-color: #fff;\n  font-family: Arial;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n  color: #000;\n  border-radius: 0em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-collage\n  .image-button-wrapper\n  .image-button\n  a:hover {\n  opacity: 0.8;\n}\n\nbody.image-block-collage-dynamic-font-sizing\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-collage\n  .image-button-wrapper\n  a {\n  font-size: inherit !important;\n}\n\nbody:not(.image-block-collage-dynamic-font-sizing)\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-collage\n  .image-button-wrapper\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-stack\n  .image-button-wrapper {\n  margin-top: 4%;\n  font-size: 2.25vw;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-stack\n  .image-button-wrapper\n  .image-button\n  a {\n  display: inline-block;\n  padding: 1em 2.5em;\n  border: 0px solid #000;\n  background-color: #000;\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  line-height: 1.1em;\n  text-transform: none;\n  color: #fff;\n  border-radius: 5em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.design-layout-stack\n  .image-button-wrapper\n  .image-button\n  a:hover {\n  opacity: 0.8;\n}\n\nbody.image-block-stack-dynamic-font-sizing\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-stack\n  .image-button-wrapper\n  a {\n  font-size: inherit !important;\n}\n\nbody:not(.image-block-stack-dynamic-font-sizing)\n  .sqs-block-image\n  .image-block-outer-wrapper.design-layout-stack\n  .image-button-wrapper\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\n.image-block-outer-wrapper:not(.sqs-text-ready) .sqs-dynamic-text {\n  visibility: hidden;\n}\n\n.sqs-block-image .design-layout-poster .image-title-wrapper {\n  font-size: 11vw;\n}\n\n.sqs-block-image .design-layout-poster .image-title p {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.image-block-card-dynamic-font-sizing\n  .sqs-block-image\n  .design-layout-card\n  .image-title-wrapper {\n  font-size: 10vw;\n}\n\n.image-block-card-dynamic-font-sizing\n  .sqs-block-image\n  .design-layout-card\n  .image-title\n  p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.1em;\n}\n\nbody:not(.image-block-card-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-card\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\nbody:not(.image-block-card-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-card\n  .image-title\n  p {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 60px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.1em;\n}\n\n.sqs-block-image .design-layout-overlap .image-title-wrapper {\n  font-size: 9vw;\n}\n\n.sqs-block-image .design-layout-overlap .image-title p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-overlap-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-overlap\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\nbody:not(.image-block-overlap-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-overlap\n  .image-title\n  p {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 40px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.sqs-block-image .design-layout-collage .image-title-wrapper {\n  font-size: 12vw;\n}\n\n.sqs-block-image .design-layout-collage .image-title p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-collage-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-collage\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\nbody:not(.image-block-collage-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-collage\n  .image-title\n  p {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 50px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.sqs-block-image .design-layout-stack .image-title-wrapper {\n  font-size: 3.75vw;\n}\n\n.sqs-block-image .design-layout-stack .image-title p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-stack-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-stack\n  .sqs-dynamic-text {\n  font-size: initial !important;\n}\n\nbody:not(.image-block-stack-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-stack\n  .image-title\n  p {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 60px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.sqs-block-image .design-layout-poster .image-subtitle-wrapper {\n  font-size: 3.75vw;\n}\n\n.sqs-block-image .design-layout-poster .image-subtitle p {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.image-block-card-dynamic-font-sizing\n  .sqs-block-image\n  .design-layout-card\n  .image-subtitle-wrapper {\n  font-size: 3.2vw;\n}\n\n.image-block-card-dynamic-font-sizing\n  .sqs-block-image\n  .design-layout-card\n  .image-subtitle\n  p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-card-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-card\n  .image-subtitle\n  p {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 22px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.sqs-block-image .design-layout-overlap .image-subtitle-wrapper {\n  font-size: 3.2vw;\n}\n\n.sqs-block-image .design-layout-overlap .image-subtitle p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-overlap-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-overlap\n  .image-subtitle\n  p {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 20px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.sqs-block-image .design-layout-collage .image-subtitle-wrapper {\n  font-size: 3.2vw;\n}\n\n.sqs-block-image .design-layout-collage .image-subtitle p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-collage-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-collage\n  .image-subtitle\n  p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 22px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.sqs-block-image .design-layout-stack .image-subtitle-wrapper {\n  font-size: 2vw;\n}\n\n.sqs-block-image .design-layout-stack .image-subtitle p {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.image-block-stack-dynamic-font-sizing)\n  .sqs-block-image\n  .design-layout-stack\n  .image-subtitle\n  p {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 25px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-poster-title-font {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 88px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.tweak-image-block-poster-subtitle-font {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 30px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-poster-button-font {\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n}\n\n.tweak-image-block-card-title-font {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 60px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.1em;\n}\n\n.tweak-image-block-card-subtitle-font {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 22px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-card-button-font {\n  font-family: Arial;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  line-height: 1.1em;\n  text-transform: none;\n}\n\n.tweak-image-block-overlap-title-font {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 40px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.tweak-image-block-overlap-subtitle-font {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 20px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-overlap-button-font {\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n}\n\n.tweak-image-block-collage-title-font {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 50px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.tweak-image-block-collage-subtitle-font {\n  font-family: Arial;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 22px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-collage-button-font {\n  font-family: Arial;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  line-height: 1.1em;\n  text-transform: none;\n}\n\n.tweak-image-block-stack-title-font {\n  font-family: Arial;\n  font-weight: 700;\n  font-style: normal;\n  font-size: 60px;\n  letter-spacing: 0em;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\n.tweak-image-block-stack-subtitle-font {\n  font-family: Arial;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 25px;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  line-height: 1.5em;\n}\n\n.tweak-image-block-stack-button-font {\n  font-family: Arial;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  letter-spacing: 0em;\n  line-height: 1.1em;\n  text-transform: none;\n}\n\n.sqs-block-image .sqs-image-caption p,\n.sqs-block-image .image-caption p {\n  font-size: 12px;\n  line-height: 1.68em;\n}\n\n.sqs-block-image .sqs-image-caption p:first-child,\n.sqs-block-image .image-caption p:first-child {\n  margin-top: 0;\n}\n\n.sqs-block-image .sqs-image-caption p a,\n.sqs-block-image .image-caption p a {\n  display: inline;\n}\n\n.sqs-block-image:not(.sqs-block-focused)\n  .sqs-image-caption.sqs-placeholder-show {\n  display: none;\n}\n\n.sqs-block-image .sqs-placeholder p {\n  margin: 0;\n  margin-top: 0.7em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper\n  img {\n  max-width: none;\n}\n\n.sqs-block-image .image-block-lightbox {\n  cursor: pointer;\n  display: block;\n}\n\n.sqs-block-image .lightbox img {\n  cursor: pointer;\n}\n\n.sqs-block-image.sized\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper {\n  overflow: hidden;\n  padding-bottom: inherit !important;\n}\n\n.sqs-block-image.sized\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper\n  img {\n  text-align: inherit;\n  max-width: none;\n}\n\n.sqs-block-image img {\n  display: block;\n}\n\n.sqs-block-image .image-block-wrapper.sqs-default-image {\n  text-align: center;\n}\n\n.sqs-block-image .image-block-wrapper.sqs-default-image img {\n  display: inline-block;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-card-wrapper {\n  display: none;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-below\n  .image-caption-wrapper {\n  padding-top: 18px;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-hidden\n  .image-caption-wrapper {\n  height: 0;\n  overflow: hidden;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-caption-overlay .intrinsic,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .intrinsic {\n  position: relative;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper {\n  position: absolute;\n  top: auto;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 18px;\n  background: rgba(0, 0, 0, 0.7);\n  max-height: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  h1,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  h1,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  h2,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  h2,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  h3,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  h3,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  strong,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  strong {\n  color: #eee;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  p,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  p {\n  color: #bbb;\n  line-height: 1.68em;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay\n  .image-caption-wrapper\n  p\n  a,\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper\n  p\n  a {\n  color: #bbb;\n  text-decoration: underline;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover:hover\n  .image-caption-wrapper {\n  max-height: 75%;\n  opacity: 1;\n  visibility: visible;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption-wrapper {\n  opacity: 0;\n  transition: opacity 0.1s ease-out;\n  visibility: hidden;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover:hover\n  .image-caption {\n  margin-bottom: 0;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-caption-overlay-hover\n  .image-caption {\n  transition: margin-bottom 0.1s ease-out;\n  margin-bottom: -5px;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-left {\n  zoom: 1;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-left:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-left:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-left\n  .image-block-wrapper {\n  float: left;\n  width: 50%;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-left\n  .image-caption-wrapper {\n  float: left;\n  width: 50%;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-left .image-caption {\n  padding-left: 15px;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-left\n  .image-caption\n  h1 {\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-right {\n  zoom: 1;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-right:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-right:after {\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  content: \".\";\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-right\n  .image-block-wrapper {\n  float: right;\n  width: 50%;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-right\n  .image-caption-wrapper {\n  float: right;\n  width: 50%;\n  text-align: right;\n}\n\n.sqs-block-image .image-block-outer-wrapper.layout-image-right .image-caption {\n  padding-right: 15px;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper.layout-image-right\n  .image-caption\n  h1 {\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper {\n  line-height: 0;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper\n  img {\n  max-width: 100%;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper\n  img.block-stretch {\n  width: 100%;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .image-block-wrapper.float-right\n  .image-block-wrapper {\n  text-align: right;\n}\n\n.sqs-block-image .image-block-outer-wrapper:not(.image-block-v2) .intrinsic {\n  margin: auto;\n}\n\n.sqs-block-image\n  .image-block-outer-wrapper:not(.image-block-v2)\n  .intrinsic\n  .image-block-wrapper\n  img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-width: none;\n  width: 100%;\n}\n\n.sqs-block-image .sqs-action-overlay {\n  z-index: 1000;\n}\n\n.sqs-block-image .processing {\n  background: #ccc;\n  text-align: center;\n}\n\n.sqs-block-image .processing .progress-container {\n  background: #ccc;\n  top: 15px;\n}\n\n.sqs-block-image .processing-failed {\n  background: #ccc;\n  text-align: center;\n  position: relative;\n  height: 100%;\n}\n\n.sqs-block-image .sqs-empty .sqs-image-content {\n  padding-bottom: 75%;\n  background: rgba(62, 62, 62, 0.06);\n}\n\n.sqs-block-image .sqs-empty .sqs-image-content:empty::before {\n  content: \"\";\n  width: 64px;\n  height: 56px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -28px;\n  margin-left: -32px;\n  /* background: url(\"/universal/images-v6/damask/image-inside-64-dark.png\")\n    no-repeat center; */\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 1.5dppx) {\n  .sqs-block-image .sqs-empty .sqs-image-content:empty::before {\n    /* background-image: url(\"/universal/images-v6/damask/image-inside-128-dark.png\"); */\n    background-size: 64px;\n  }\n}\n\n.sqs-block-image.vsize-1 .image-block-wrapper {\n  height: 34px;\n}\n\n.sqs-block-image.vsize-2 .image-block-wrapper {\n  height: 68px;\n}\n\n.sqs-block-image.vsize-3 .image-block-wrapper {\n  height: 102px;\n}\n\n.sqs-block-image.vsize-4 .image-block-wrapper {\n  height: 136px;\n}\n\n.sqs-block-image.vsize-5 .image-block-wrapper {\n  height: 170px;\n}\n\n.sqs-block-image.vsize-6 .image-block-wrapper {\n  height: 204px;\n}\n\n.sqs-block-image.vsize-7 .image-block-wrapper {\n  height: 238px;\n}\n\n.sqs-block-image.vsize-8 .image-block-wrapper {\n  height: 272px;\n}\n\n.sqs-block-image.vsize-9 .image-block-wrapper {\n  height: 306px;\n}\n\n.sqs-block-image.vsize-10 .image-block-wrapper {\n  height: 340px;\n}\n\n.sqs-block-image.vsize-11 .image-block-wrapper {\n  height: 374px;\n}\n\n.sqs-block-image.vsize-12 .image-block-wrapper {\n  height: 408px;\n}\n\n.sqs-block-image.vsize-13 .image-block-wrapper {\n  height: 442px;\n}\n\n.sqs-block-image.vsize-14 .image-block-wrapper {\n  height: 476px;\n}\n\n.sqs-block-image.vsize-15 .image-block-wrapper {\n  height: 510px;\n}\n\n.sqs-block-image.vsize-16 .image-block-wrapper {\n  height: 544px;\n}\n\n.sqs-block-image.vsize-17 .image-block-wrapper {\n  height: 578px;\n}\n\n.sqs-block-image.vsize-18 .image-block-wrapper {\n  height: 612px;\n}\n\n.sqs-block-image.vsize-19 .image-block-wrapper {\n  height: 646px;\n}\n\n.sqs-block-image.vsize-20 .image-block-wrapper {\n  height: 680px;\n}\n\n.sqs-block-image.vsize-21 .image-block-wrapper {\n  height: 714px;\n}\n\n.sqs-block-image.vsize-22 .image-block-wrapper {\n  height: 748px;\n}\n\n.sqs-block-image.vsize-23 .image-block-wrapper {\n  height: 782px;\n}\n\n.sqs-block-image.vsize-24 .image-block-wrapper {\n  height: 816px;\n}\n\n.sqs-block-image.vsize-25 .image-block-wrapper {\n  height: 850px;\n}\n\n.sqs-block-image.vsize-26 .image-block-wrapper {\n  height: 884px;\n}\n\n.sqs-block-image.vsize-27 .image-block-wrapper {\n  height: 918px;\n}\n\n.sqs-block-image.vsize-28 .image-block-wrapper {\n  height: 952px;\n}\n\n.sqs-block-image.vsize-29 .image-block-wrapper {\n  height: 986px;\n}\n\n.sqs-block-image.vsize-30 .image-block-wrapper {\n  height: 1020px;\n}\n\n.sqs-block-image[class*=\"vsize-\"] .sqs-block-content {\n  height: auto;\n  overflow: visible;\n}\n\n.product-block .image-container {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.product-block .image-container a {\n  display: block;\n  width: 100%;\n  line-height: 0;\n}\n\n.product-block .image-container img {\n  width: 100%;\n  max-width: 100%;\n}\n\n.product-block\n  .image-container\n  img:not(.loaded)\n  .sqs-product-mark-wrapper\n  .sqs-product-quick-view-button-wrapper {\n  opacity: 0 !important;\n}\n\n.product-block .image-container .product-mark {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  background: #222;\n  padding: 6px 8px;\n  color: #fff;\n  line-height: 1em;\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n}\n\n.product-block .image-container .sqs-product-block-variant-image {\n  display: none;\n  width: 100%;\n  line-height: 0;\n}\n\n.product-block .image-container .sqs-product-block-variant-image.shown {\n  display: block;\n}\n\n.product-block\n  .image-container\n  .sqs-product-block-variant-image.shown\n  ~ .sqs-product-block-main-image {\n  display: none;\n}\n\n.sqs-style-mode-active\n  .product-block.is-product-quick-view-enabled.is-first-product-block\n  .sqs-product-quick-view-button-wrapper {\n  opacity: 1;\n}\n\n.sqs-style-mode-active\n  .product-block.is-product-quick-view-enabled.is-first-product-block\n  .sqs-product-mark-wrapper {\n  opacity: 0;\n}\n\n.product-block .productDetails.center {\n  text-align: center;\n}\n\n.product-block .productDetails.center .sqs-add-to-cart-button-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.product-block .productDetails.right {\n  text-align: right;\n}\n\n.product-block .productDetails.right .sqs-add-to-cart-button-wrapper {\n  margin-left: auto;\n}\n\n.product-block .productDetails .product-title {\n  font-size: 1.3em;\n  line-height: 1em;\n  margin: 1em 0 0.2em 0;\n  display: inline-block;\n}\n\n.product-block .productDetails .product-price {\n  font-size: 1.1em;\n  margin: 0 0 1em 0;\n}\n\n.product-block .productDetails .product-price input {\n  width: 130px;\n  height: 30px;\n  padding-left: 5px;\n}\n\n.product-block .productDetails .product-price .minimum-price {\n  margin-top: 3px;\n  margin-left: 10px;\n}\n\n.product-block .productDetails .product-price .original-price {\n  text-decoration: line-through;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n}\n\n.product-block .productDetails .product-price .strikeout {\n  text-decoration: line-through;\n}\n\n.product-block .productDetails .product-variants .variant-option {\n  margin: 0 0 1em 0;\n}\n\n.product-block .productDetails .product-variants .variant-out-of-stock {\n  color: #c00;\n  margin-top: 8px;\n}\n\n.product-block .productDetails .product-variants .variant-radiobtn-wrapper {\n  display: none;\n}\n\n.product-block .productDetails .product-quantity-input input {\n  background-color: #fff;\n  color: #222;\n}\n\n.product-block .productDetails .product-scarcity {\n  margin-top: 1em;\n  font-size: 1.1em;\n  color: #000;\n}\n\n.product-block .buy-button,\n.product-block .sqs-add-to-cart-button-wrapper {\n  margin: 20px 0;\n  display: block;\n}\n\n.product-block .buy-button:hover,\n.product-block .sqs-add-to-cart-button-wrapper:hover {\n  opacity: 1;\n}\n\n.product-block .sqs-add-to-cart-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.product-block .sqs-amazon-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  text-transform: none;\n}\n\n.product-block .center .sqs-amazon-button {\n  text-align: center;\n}\n\n.product-block .right .sqs-amazon-button {\n  text-align: right;\n}\n\n.sqs-block-accordion .accordion-items-container {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.sqs-block-accordion .accordion-item {\n  padding: 0;\n  margin: 0;\n  position: relative;\n}\n\n.sqs-block-accordion .accordion-divider {\n  background-color: currentColor;\n}\n\n.sqs-block-accordion\n  .accordion-items-container:not([data-is-last-divider-visible=\"true\"])\n  .accordion-item:last-of-type\n  .accordion-divider {\n  display: none;\n}\n\n.sqs-block-accordion .accordion-item__title-wrapper {\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-block-accordion .accordion-item__title {\n  flex: 1;\n}\n\n.sqs-block-accordion\n  [data-accordion-title-alignment=\"center\"]\n  .accordion-item__title {\n  text-align: center;\n}\n\n.sqs-block-accordion\n  [data-accordion-title-alignment=\"right\"]\n  .accordion-item__title {\n  text-align: right;\n}\n\n.sqs-block-accordion .accordion-item__click-target {\n  box-sizing: border-box;\n  width: 100%;\n  background: transparent;\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  -webkit-appearance: none;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  font-style: inherit;\n  text-transform: inherit;\n  letter-spacing: inherit;\n  color: inherit;\n  touch-action: manipulation;\n}\n\n.sqs-block-accordion\n  [data-accordion-icon-placement=\"left\"]\n  .accordion-item__click-target {\n  flex-direction: row-reverse;\n}\n\n.sqs-block-accordion .accordion-item__click-target > * {\n  margin: 0;\n}\n\n.sqs-block-accordion .accordion-item__dropdown {\n  box-sizing: border-box;\n  display: none;\n  overflow: hidden;\n}\n\n.sqs-block-accordion .accordion-item__dropdown--pre-open {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: block;\n  visibility: hidden;\n  width: 100%;\n  transition: none;\n  height: auto;\n}\n\n.sqs-block-accordion .accordion-item__dropdown--open {\n  display: block;\n}\n\n.sqs-block-accordion .accordion-item__description {\n  box-sizing: border-box;\n}\n\n.sqs-block-accordion\n  [data-accordion-description-placement=\"center\"]\n  .accordion-item__description {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sqs-block-accordion\n  [data-accordion-description-placement=\"right\"]\n  .accordion-item__description {\n  margin-left: auto;\n}\n\n.sqs-block-accordion\n  [data-accordion-description-alignment=\"center\"]\n  .accordion-item__description {\n  text-align: center;\n}\n\n.sqs-block-accordion\n  [data-accordion-description-alignment=\"right\"]\n  .accordion-item__description {\n  text-align: right;\n}\n\n.sqs-block-accordion .accordion-item__title > :first-of-type,\n.sqs-block-accordion .accordion-item__description > :first-of-type {\n  margin-top: 0;\n}\n\n.sqs-block-accordion .accordion-item__title > :last-of-type,\n.sqs-block-accordion .accordion-item__description > :last-of-type {\n  margin-bottom: 0;\n}\n\n.sqs-block-accordion .accordion-icon-container {\n  position: relative;\n}\n\n.sqs-block-accordion .accordion-icon-container > * {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sqs-block-accordion .plus__horizontal-line,\n.sqs-block-accordion .plus__vertical-line {\n  display: block;\n  width: 100%;\n  background-color: currentColor;\n  transition: transform 0.2s;\n  position: absolute;\n}\n\n.sqs-block-accordion .plus__vertical-line {\n  transform: rotate(90deg);\n}\n\n.sqs-block-accordion .accordion-item[data-is-open=\"true\"] .plus__vertical-line {\n  transform: rotate(0deg);\n}\n\n.sqs-block-accordion .arrow-container {\n  transition: transform 0.2s;\n}\n\n.sqs-block-accordion .accordion-item[data-is-open=\"true\"] .arrow-container {\n  transform: rotate(-180deg);\n}\n\n.sqs-block-accordion .arrow {\n  border-color: currentColor;\n  border-style: solid;\n  border-top: none;\n  border-left: none;\n  box-sizing: border-box;\n  transform: translatey(-25%) rotate(45deg);\n  width: 70.71067%;\n  height: 70.71067%;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sqs-block-accordion .accordion-item__dropdown,\n  .sqs-block-accordion .plus__vertical-line,\n  .sqs-block-accordion .arrow-container {\n    transition: none !important;\n  }\n}\n\n.sqs-block-archive .archive-group-list,\n.sqs-block-archive .archive-item-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-block-archive .archive-group-count::before {\n  content: \"(\";\n}\n\n.sqs-block-archive .archive-group-count::after {\n  content: \")\";\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-list.archive-block-setting-text-alignment-center,\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-text-alignment-center {\n  text-align: center;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-list.archive-block-setting-text-alignment-right,\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-text-alignment-right {\n  text-align: right;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-list.archive-block-setting-multicolumns\n  .archive-group-list {\n  columns: 140px;\n  column-gap: 60px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index\n  .archive-group-name-link {\n  font-size: 1.4em;\n  line-height: 1.4em;\n  text-decoration: none;\n}\n\n.sqs-block-archive .archive-block-setting-layout-index .archive-item-list {\n  display: block;\n  margin: 1.4em 0 2.8em 0;\n  font-size: 1em;\n  line-height: 1.4em;\n}\n\n.sqs-block-archive .archive-block-setting-layout-index .archive-item {\n  margin: 0 0 0.7em 0;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index\n  .archive-item.archive-item--show-date {\n  margin: 0 0 1.4em 0;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index\n  .archive-item-date-before {\n  display: none;\n  opacity: 0.7;\n  margin-right: 5px;\n}\n\n.sqs-block-archive .archive-block-setting-layout-index .archive-item-link {\n  display: block;\n  margin-right: 5px;\n  color: inherit !important;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index\n  .archive-item-link--untitled::before {\n  content: \"Untitled\";\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index\n  .archive-item-date-after {\n  display: block;\n  opacity: 0.7;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-group-list {\n  columns: 200px;\n  column-gap: 60px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-group {\n  -webkit-column-break-inside: avoid;\n  page-break-inside: avoid;\n  break-inside: avoid;\n  display: block;\n  overflow: hidden;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-group-name-link {\n  display: block;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-group-name-list {\n  display: inline-block;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-group-name-link,\n.sqs-block-archive\n  .archive-block-setting-layout-index.archive-block-setting-multicolumns\n  .archive-item-list {\n  min-width: 225px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown.archive-block-wrapper {\n  max-width: 300px;\n  background: rgba(110, 110, 110, 0.05);\n  border-radius: 1px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-label {\n  display: block;\n  padding: 12px 18px;\n  font-size: 1em;\n  line-height: 1.6em;\n  cursor: pointer;\n  overflow: hidden;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  list-style: none;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-label::-webkit-details-marker {\n  display: none;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-title {\n  float: left;\n  width: 90%;\n  padding-right: 5px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-icon {\n  position: relative;\n  bottom: 1px;\n  float: right;\n  width: 10%;\n  text-align: right;\n  box-sizing: border-box;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-icon:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e009\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-icon:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-dropdown-toggle-icon:before {\n  font-size: 1em;\n  width: 1em;\n  height: 1em;\n  line-height: 1em;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown[open]\n  .archive-dropdown-toggle-icon:before {\n  font-family: \"squarespace-ui-font\";\n  font-style: normal;\n  speak: none;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\e006\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown[open]\n  .archive-dropdown-toggle-icon:before {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.sqs-block-archive .archive-block-setting-layout-dropdown .archive-group-list {\n  padding: 0 18px 12px;\n}\n\n.sqs-block-archive\n  .archive-block-setting-layout-dropdown\n  .archive-group-name-link {\n  text-decoration: none;\n}\n\n@media only screen and (max-width: 400px) {\n  .sqs-block-archive\n    .archive-block-setting-layout-dropdown.archive-block-wrapper {\n    max-width: none;\n  }\n}\n\n.sqs-block-archive.sqs-edit-dialog-open .sqs-editing-overlay,\n.sqs-block-archive.sqs-edit-dialog-open .sqs-block-editor-button-container {\n  z-index: 1;\n}\n\n.sqs-block-archive.sqs-edit-dialog-open .sqs-block-archive-content {\n  position: relative;\n  z-index: 1000;\n}\n\n.sqs-block-archive.sqs-edit-dialog-open .archive-group-list {\n  pointer-events: none;\n}\n\n.tagcloud-block ul {\n  list-style-type: none;\n  margin: 0;\n  padding-left: 0;\n}\n\n.tagcloud-block ul li {\n  display: inline-block;\n}\n\n.sqs-block-shape .sqs-block-content,\n.sqs-block-shape .sqs-block-alignment-wrapper {\n  height: 100%;\n}\n\n.sqs-block-shape .sqs-block-alignment-wrapper {\n  display: flex;\n}\n\n.sqs-block-shape .sqs-shape {\n  display: block;\n  position: absolute;\n  overflow: visible;\n}\n\n.sqs-block-shape .sqs-shape-block-container {\n  position: relative;\n}\n\n/*! WARNING: block .less requested, but unable to resolve css from system cache: album */\n.sqs-block-postsbycategory ul,\n.sqs-block-postsbyauthor ul,\n.sqs-block-postsbytag ul,\n.sqs-block-postsbymonth ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-block-postsbycategory ul li,\n.sqs-block-postsbyauthor ul li,\n.sqs-block-postsbytag ul li,\n.sqs-block-postsbymonth ul li {\n  margin: 0 0 1rem 0;\n  padding: 0;\n}\n\n.sqs-block-postsbycategory ul {\n  display: grid;\n  gap: 1.35rem 1rem;\n  grid-auto-rows: 1fr;\n}\n\n.sqs-block-postsbycategory ul li {\n  min-height: 100px;\n}\n\n.sqs-block-postsbycategory ul li a {\n  height: 100%;\n  /* border: 1px solid #15508a; */\n}\n\n.sqs-block-postsbycategory ul li a div {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.sqs-block-postsbycategory ul li a div img {\n  max-width: 100%;\n  max-height: 80px;\n  object-fit: contain;\n}\n\n.sqs-block-postsbycategory ul li a div div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.sqs-block-postsbycategory .count,\n.sqs-block-postsbyauthor .count,\n.sqs-block-postsbytag .count,\n.sqs-block-postsbymonth .count {\n  display: none;\n}\n\n.Marquee {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  overflow: hidden;\n  z-index: auto;\n  background-color: transparent;\n}\n\n.Marquee h1,\n.Marquee p {\n  margin: 0;\n  min-height: 0;\n  line-height: 1.4 !important;\n}\n\n.Marquee-svg {\n  display: block;\n  width: 100%;\n  font-size: inherit;\n}\n\n.Marquee-hitbox {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.Marquee-hitbox:focus .Marquee-path-hitbox-focus-outline {\n  stroke: currentColor;\n}\n\n.Marquee-hitbox:focus:not(:focus-visible) .Marquee-path-hitbox-focus-outline {\n  stroke: initial;\n}\n\n.Marquee-display {\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n\n.Marquee-display.fade-edges {\n  mask-image: linear-gradient(\n    to right,\n    transparent 0%,\n    #000 15%,\n    #000 85%,\n    transparent 100%\n  );\n  -webkit-mask-image: linear-gradient(\n    to right,\n    transparent 0%,\n    #000 15%,\n    #000 85%,\n    transparent 100%\n  );\n}\n\n.Marquee-measure {\n  display: inline-flex;\n  align-items: center;\n  width: max-content;\n  min-height: 1em;\n  visibility: hidden;\n  position: absolute;\n}\n\n.Marquee-group {\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.Marquee-measure,\n.Marquee-group {\n  min-width: 50px;\n}\n\n.Marquee-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.Marquee-track {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.Marquee-track {\n  pointer-events: none;\n}\n\n.Marquee-track .Marquee-track-item {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 0;\n}\n\n.Marquee-track-item .Marquee-item {\n  padding: 0;\n  transform: translate3d(-50%, calc(-50% - 0.4em), 0);\n}\n\n.menu-block .menu-selector {\n  margin-bottom: 3em;\n}\n\n.menu-block .menu-selector label {\n  display: inline-block;\n  padding: 0 0.5em;\n  font-size: 1.1em;\n  cursor: pointer;\n}\n\n.menu-block .menu-selector label.menu-select-labels--active {\n  text-decoration: underline;\n}\n\n.menu-block .menu-select-button {\n  display: none;\n}\n\n.menu-block .menus--has-multiple .menu {\n  display: none;\n}\n\n.menu-block .menu-header {\n  margin-bottom: 3em;\n}\n\n.menu-block .menu-section {\n  margin-top: 1em;\n}\n\n.menu-block .menu-section + .menu-section {\n  margin-top: 5em;\n}\n\n.menu-block .menu-section-header {\n  margin-bottom: 2em;\n  padding-bottom: 1em;\n}\n\n.menu-block .menu-section-title {\n  font-size: 1.5em;\n}\n\n.menu-block .menu-section-description {\n  font-size: 0.85em;\n  line-height: 1.4em;\n}\n\n.menu-block .menu-item {\n  margin-bottom: 0;\n  padding-bottom: 2em;\n  margin-top: 0;\n  line-height: 1.2em;\n}\n\n.menu-block .menu-item-title {\n  font-size: 1.1em;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n\n.menu-block .menu-item-description {\n  line-height: 1.3em;\n  margin-top: 5px;\n}\n\n.menu-block .menu-item-price-bottom {\n  margin: 0.5em 0;\n}\n\n.menu-block .menu-item-option {\n  font-size: 0.8em;\n  font-style: italic;\n}\n\n.menu-block .menu-style-classic .menu-selector,\n.menu-block .menu-style-classic .menu-header,\n.menu-block .menu-style-classic .menu-section-title,\n.menu-block .menu-style-classic .menu-section-description {\n  text-align: center;\n}\n\n.menu-block .menu-style-classic .menu-items {\n  column-width: 18em;\n  column-gap: 3em;\n}\n\n.menu-block .menu-style-classic .menu-item {\n  -webkit-column-break-inside: avoid;\n  page-break-inside: avoid;\n  break-inside: avoid;\n  width: 100%;\n}\n\n.menu-block .menu-style-classic .menu-item-description {\n  margin-right: 3em;\n}\n\n.menu-block .menu-style-classic .menu-item-price-top {\n  float: right;\n  padding-left: 20px;\n}\n\n.menu-block .menu-style-classic .menu-item-price-bottom {\n  display: none;\n}\n\n.menu-block .menu-style-simple .menu-selector,\n.menu-block .menu-style-simple .menu {\n  text-align: center;\n}\n\n.menu-block .menu-style-simple .menu-item-price-top {\n  display: none;\n}\n\n.pricing-plan-block {\n  min-height: 44px;\n}\n\n.pricing-plan-block .sqs-editable-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.pricing-plan-block .pricing-plan-pricing-toggle-wrapper {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.hide {\n  display: none;\n}\n\n.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-left {\n  justify-content: flex-start;\n}\n\n.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-center {\n  justify-content: center;\n}\n\n.pricing-plan-block .pricing-plan-pricing-toggle-wrapper.toggle-right {\n  justify-content: flex-end;\n}\n\n.pricing-plan-block .pricing-plan-pricing-options {\n  display: grid;\n  display: -ms-grid;\n  grid-template-columns: repeat(2, 1fr);\n  -ms-grid-columns: 1fr 1fr;\n  list-style-type: none;\n  padding: 0px;\n  margin: 0px;\n}\n\n.pricing-plan-block\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  width: 100%;\n  height: 100%;\n  padding: 0.6em 1.1em !important;\n  text-align: center;\n  border-radius: 0px;\n  color: #272727;\n  border: 1px solid #272727;\n  background-color: transparent;\n}\n\n@media (hover: hover) {\n  .pricing-plan-block\n    .pricing-plan-pricing-options\n    .sqs-editable-button.pricing-plan-pricing-option-button:hover {\n    opacity: 1;\n    color: #fff;\n    background-color: #272727;\n  }\n}\n\n.pricing-plan-block\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-selected {\n  color: #fff;\n  background-color: #272727;\n}\n\n.pricing-plan-block .pricing-plan-pricing-options .left-option {\n  -ms-grid-column: 1;\n}\n\n.pricing-plan-block .pricing-plan-pricing-options .right-option {\n  -ms-grid-column: 2;\n}\n\n.pricing-plan-block .hide,\n.pricing-plan-block .join-button.hide {\n  display: none;\n}\n\n.pricing-plan-block .below-pricing-toggle {\n  margin-top: 33px;\n}\n\nbody\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.left-button {\n  border-radius: 300px 0px 0px 300px;\n}\n\nbody\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.right-button {\n  border-radius: 0px 300px 300px 0px;\n}\n\n.primary-button-style-outline\n  .sqs-block-pricing-plan\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  border-width: 2px;\n}\n\n.product-block .productDetails div.product-title.pricing-plan-title {\n  font-size: 1.5em;\n  margin-top: 33px;\n  margin-bottom: 11px;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  line-height: normal;\n}\n\n.pricing-plan-price-amount {\n  font-size: 2em;\n  margin-top: 11px;\n  line-height: 90%;\n}\n\n.pricing-plan-price-billing-period {\n  font-size: 1em;\n  opacity: 0.75;\n  margin-bottom: 22px;\n  margin-top: 11px;\n}\n\n.product-block .productDetails .product-price.pricing-plan-product-price {\n  margin: 0 0 12px 0;\n  line-height: normal;\n}\n\n.product-block\n  .productDetails\n  .product-price.pricing-plan-product-price.below-pricing-toggle {\n  margin-top: 33px;\n}\n\n.pricing-plan-description {\n  margin: 0 0 22px 0;\n  line-height: normal;\n  font-size: 1em;\n}\n\n.pricing-plan-benefits-divider {\n  margin-top: 22px;\n  margin-bottom: 22px;\n}\n\n.pricing-plan-benefit-description:not(:last-child) {\n  margin-bottom: 6px;\n}\n\n.sqs-block-summary-v2 * {\n  box-sizing: border-box;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-outer-container {\n  position: relative;\n}\n\n.sqs-block-summary-v2 .summary-heading {\n  display: none;\n  margin: 0 0 15px 0;\n  padding-right: 10px;\n  font-size: 14px;\n  line-height: normal;\n}\n\n.sqs-block-summary-v2 .summary-carousel-pager {\n  display: none;\n}\n\n.sqs-block-summary-v2 .summary-item-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sqs-block-summary-v2 .summary-item {\n  visibility: hidden;\n  overflow: hidden;\n}\n\n.sqs-block-summary-v2 .summary-item.positioned {\n  visibility: visible;\n}\n\n.sqs-style-mode-active\n  .sqs-block-summary-v2\n  .is-product-quick-view-enabled\n  .summary-item:first-child\n  .sqs-product-quick-view-button-wrapper {\n  opacity: 1;\n}\n\n.sqs-style-mode-active\n  .sqs-block-summary-v2\n  .is-product-quick-view-enabled\n  .summary-item:first-child\n  .sqs-product-mark-wrapper {\n  opacity: 0;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-container {\n  position: relative;\n  display: block;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-container:hover {\n  opacity: 1 !important;\n}\n\n.sqs-block-summary-v2 .img-wrapper,\n.sqs-block-summary-v2 .sqs-video-wrapper {\n  position: relative;\n  width: 100%;\n  height: auto;\n}\n\n.sqs-block-summary-v2 .img-wrapper img,\n.sqs-block-summary-v2 .sqs-video-wrapper img {\n  opacity: 0;\n  display: block;\n  width: 100%;\n  height: auto;\n  font-size: 13px;\n  line-height: normal;\n  transition: 0.6s opacity;\n}\n\n.sqs-block-summary-v2 .img-wrapper img.loaded,\n.sqs-block-summary-v2 .sqs-video-wrapper img.loaded {\n  opacity: 1;\n}\n\n.sqs-block-summary-v2\n  .img-wrapper\n  img:not(.loaded)\n  .sqs-product-mark-wrapper\n  .sqs-product-quick-view-button-wrapper,\n.sqs-block-summary-v2\n  .sqs-video-wrapper\n  img:not(.loaded)\n  .sqs-product-mark-wrapper\n  .sqs-product-quick-view-button-wrapper {\n  opacity: 0 !important;\n}\n\n.sqs-block-summary-v2 .summary-product-status .product-mark {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  padding: 6px 8px;\n  background: #222;\n  color: #fff;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: content-box;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-event-date {\n  display: none;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 50px;\n  width: 50px;\n  padding: 3px;\n  background: #fff;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-event-date-inner {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-event-date-month {\n  display: block;\n  color: #333;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-event-date-day {\n  display: block;\n  color: #333;\n  font-size: 26px;\n  line-height: 26px;\n}\n\n.sqs-block-summary-v2 .summary-content {\n  text-align: left;\n}\n\n.sqs-block-summary-v2 .summary-title {\n  margin: 0 0 10px 0;\n  font-size: 20px;\n  line-height: 1.2em;\n  text-align: left;\n}\n\n.sqs-block-summary-v2 .summary-price {\n  margin: 0 0 10px 0;\n}\n\n.sqs-block-summary-v2 .summary-price .product-price {\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n}\n\n.sqs-block-summary-v2 .summary-price .product-price .original-price {\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n  text-decoration: line-through;\n}\n\n.sqs-block-summary-v2 .product-scarcity {\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n  margin: 0 0 10px 0;\n  color: #000;\n}\n\n.sqs-block-summary-v2 .summary-excerpt {\n  margin: 0 0 10px 0;\n}\n\n.sqs-block-summary-v2 .summary-excerpt p,\n.sqs-block-summary-v2 .summary-excerpt ul,\n.sqs-block-summary-v2 .summary-excerpt li {\n  font-size: 14px;\n  line-height: 1.4em;\n  margin: 0 0 10px 0;\n  text-align: left;\n}\n\n.sqs-block-summary-v2 .summary-excerpt p:first-of-type,\n.sqs-block-summary-v2 .summary-excerpt ul:first-of-type,\n.sqs-block-summary-v2 .summary-excerpt li:first-of-type {\n  margin-top: 0 !important;\n}\n\n.sqs-block-summary-v2 .summary-excerpt p:last-of-type,\n.sqs-block-summary-v2 .summary-excerpt ul:last-of-type,\n.sqs-block-summary-v2 .summary-excerpt li:last-of-type {\n  margin-bottom: 0 !important;\n}\n\n.sqs-block-summary-v2 .summary-excerpt > blockquote p {\n  font-size: inherit;\n  line-height: inherit;\n  margin: inherit;\n  text-align: inherit;\n}\n\n.sqs-block-summary-v2 .summary-excerpt > blockquote p:first-of-type {\n  margin-top: inherit;\n}\n\n.sqs-block-summary-v2 .summary-excerpt > blockquote p:last-of-type {\n  margin-bottom: inherit;\n}\n\n.sqs-block-summary-v2 .summary-block-collection-type-lessons .summary-excerpt {\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n}\n\n.sqs-block-summary-v2 .summary-read-more-link {\n  display: none;\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n}\n\n.sqs-block-summary-v2 .summary-metadata-container {\n  display: none;\n  font-size: 13px;\n  line-height: normal;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title\n  .summary-metadata-container--above-title,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title\n  .summary-metadata-container--below-title,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-content\n  .summary-metadata-container--below-content {\n  display: block;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container {\n  margin: 0 0 10px 0;\n}\n\n.sqs-block-summary-v2 .summary-metadata {\n  display: none;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-date\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-event-time\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata--primary,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata--primary {\n  display: inline-block;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-date\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-event-time\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata--secondary,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata--secondary {\n  display: inline-block;\n}\n\n.sqs-block-summary-v2 .summary-metadata-item {\n  display: none;\n  opacity: 0.7;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4em;\n  text-transform: none;\n}\n\n.sqs-block-summary-v2 .summary-metadata-item a,\n.sqs-block-summary-v2 .summary-metadata-item a:hover {\n  opacity: 1;\n  text-decoration: none;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-date\n  .summary-metadata--primary\n  .summary-metadata-item--date,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-event-time\n  .summary-metadata--primary\n  .summary-metadata-item--event-time,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata--primary\n  .summary-metadata-item--cats,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata--primary\n  .summary-metadata-item--tags,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata--primary\n  .summary-metadata-item--author,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata--primary\n  .summary-metadata-item--comments,\n.sqs-block-summary-v2\n  .summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata--primary\n  .summary-metadata-item--location {\n  display: inline-block;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-date\n  .summary-metadata--secondary\n  .summary-metadata-item--date,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-event-time\n  .summary-metadata--secondary\n  .summary-metadata-item--event-time,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata--secondary\n  .summary-metadata-item--cats,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata--secondary\n  .summary-metadata-item--tags,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata--secondary\n  .summary-metadata-item--author,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata--secondary\n  .summary-metadata-item--comments,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata--secondary\n  .summary-metadata-item--location {\n  display: inline-block;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-date\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-event-time\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata--primary\n  .summary-metadata-item:after,\n.sqs-block-summary-v2\n  .summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata--primary\n  .summary-metadata-item:after {\n  content: \" ·\";\n  margin: 0 0.3em;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-text-size-extralarge\n  .summary-title {\n  font-size: 54px;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-text-size-extralarge\n  .summary-excerpt\n  p {\n  font-size: 16px;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-text-size-large .summary-title {\n  font-size: 30px;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-text-size-medium .summary-title {\n  font-size: 20px;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-text-size-small .summary-title {\n  font-size: 14px;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-text-align-center .summary-title,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-center\n  .summary-price\n  .product-price,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-center\n  .summary-excerpt\n  p,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-center\n  .summary-read-more-link,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-center\n  .summary-content {\n  text-align: center;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-text-align-right .summary-title,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-right\n  .summary-price\n  .product-price,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-right\n  .summary-excerpt\n  p,\n.sqs-block-summary-v2\n  .summary-block-setting-text-align-right\n  .summary-read-more-link,\n.sqs-block-summary-v2 .summary-block-setting-text-align-right .summary-content {\n  text-align: right;\n}\n\n.sqs-block-summary-v2 .summary-item-record-type-text .summary-read-more-link {\n  display: block;\n}\n\n.sqs-block-summary-v2\n  .summary-item-record-type-event\n  .summary-thumbnail-event-date {\n  display: table;\n}\n\n.sqs-block-summary-v2 .event-time-localized {\n  display: none;\n}\n\n.sqs-block-summary-v2 .summary-thumbnail-container {\n  margin: 0;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-show-title\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-setting-show-price\n  .summary-item-record-type-store-item\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-setting-show-excerpt\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(.summary-block-setting-primary-metadata-none)\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(.summary-block-setting-secondary-metadata-none)\n  .summary-thumbnail-container {\n  margin: 0 0 15px 0;\n}\n\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(.summary-block-setting-show-excerpt)\n  .summary-title,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(.summary-block-setting-show-excerpt)\n  .summary-price {\n  margin: 0 0 2px 0;\n}\n\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-date\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-event-time\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-cats\n  .summary-item-has-cats\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-tags\n  .summary-item-has-tags\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-author\n  .summary-item-has-author\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-comments\n  .summary-item-has-comments-enabled\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-primary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-above-title.summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container,\n.sqs-block-summary-v2\n  .summary-block-wrapper:not(\n    .summary-block-setting-show-excerpt\n  ).summary-block-setting-metadata-position-below-title.summary-block-setting-secondary-metadata-location\n  .summary-item-has-location\n  .summary-metadata-container {\n  margin: 0 0 2px 0;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-design-list .summary-item {\n  visibility: visible !important;\n  margin-bottom: 17px !important;\n  padding-bottom: 17px !important;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item.summary-item-show-thumbnail {\n  margin-bottom: 17px !important;\n  padding-bottom: 17px !important;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item\n  .summary-thumbnail-container {\n  margin: 0 !important;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item:not(.summary-item-record-type-video)\n  .summary-thumbnail-container {\n  width: 100% !important;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item.summary-item-record-type-video\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-thumbnail-outer-container {\n  float: left;\n}\n\n@media screen and (max-width: 480px) {\n  .sqs-block-summary-v2\n    .summary-block-setting-design-list\n    .summary-item.summary-item-record-type-video\n    .summary-thumbnail-container,\n  .sqs-block-summary-v2\n    .summary-block-setting-design-list\n    .summary-thumbnail-outer-container {\n    width: 35% !important;\n  }\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item\n  .summary-thumbnail-container\n  .sqs-video-wrapper\n  img {\n  max-width: 100%;\n  object-fit: contain;\n  position: static !important;\n}\n\n@media screen and (max-width: 480px) {\n  .sqs-block-summary-v2\n    .summary-block-setting-design-list\n    .summary-item\n    .summary-thumbnail-container\n    .sqs-video-wrapper\n    img {\n    height: auto;\n    position: static;\n    width: 100% !important;\n    width: auto;\n  }\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .sqs-product-quick-view-button-wrapper {\n  padding-right: 20px;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right\n  .summary-item-record-type-video\n  .summary-thumbnail-container,\n.sqs-block-summary-v2\n  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right\n  .summary-thumbnail-outer-container {\n  float: right;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right\n  .summary-thumbnail-container {\n  padding: 0 0 0 20px;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right\n  .sqs-product-quick-view-button-wrapper {\n  padding-left: 20px;\n  padding-right: 0px;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list.summary-block-setting-design-list-thumbnail-right\n  .summary-item-record-type-store-item\n  .product-mark {\n  right: 0;\n  left: auto;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item-record-type-store-item\n  .product-mark {\n  left: 0;\n  right: auto;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-list\n  .summary-item-record-type-event\n  .summary-thumbnail-event-date {\n  display: none;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-carousel\n  .summary-carousel-pager {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-carousel\n  .summary-block-header {\n  overflow: hidden;\n}\n\n.sqs-block-summary-v2 .summary-block-setting-design-carousel .summary-heading {\n  display: block;\n  float: left;\n  width: calc(100% - 50px);\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-carousel\n  .summary-collection-title {\n  display: none;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-carousel\n  .summary-carousel-pager {\n  float: right;\n  width: 50px;\n}\n\n.sqs-block-summary-v2\n  .summary-block-setting-design-carousel\n  .summary-item:not(.positioned) {\n  visibility: visible;\n}\n\n@media only screen and (max-width: 700px) {\n  .sqs-block-summary-v2 .summary-product-quick-view {\n    display: none;\n  }\n}\n\ndiv.sqs-block-opentable-v2 {\n  word-wrap: break-word;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker {\n  margin: auto;\n  width: auto;\n  background: none;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker-selector {\n  background: rgba(0, 0, 0, 0.12);\n  border: none;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker-selector,\ndiv.sqs-block-opentable-v2 .ot-dtp-picker-button {\n  width: 100% !important;\n  max-width: 200px;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker form.ot-dtp-picker-form {\n  border: none;\n  background: none;\n  height: auto !important;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker.wide {\n  margin: auto;\n  width: auto;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker.wide .ot-powered-by {\n  background-size: contain;\n  background-position: center;\n  margin: 20px 0 0;\n}\n\ndiv.sqs-block-opentable-v2 .ot-dtp-picker-selector-link {\n  background: #fff;\n  color: #000;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\ndiv.sqs-block-opentable-v2 .oc-loading {\n  text-align: center;\n  font-family: sans-serif;\n  line-height: 180px;\n}\n\ndiv.sqs-block-opentable-v2 a {\n  text-decoration: none !important;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper {\n  background: rgba(153, 153, 153, 0.15);\n  padding: 30px;\n  opacity: 0;\n  transition: opacity 0.3s ease-out;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper iframe {\n  display: block;\n  margin: 0 auto;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper h1 {\n  font-weight: normal;\n  text-align: center;\n  line-height: 1em;\n  margin: 0;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper.loading {\n  min-height: 270px;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-new-age-wrapper.loaded {\n  opacity: 1;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-button-wrapper\n  .ot-dtp-picker-button {\n  color: #fff;\n  background: #000;\n}\n\ndiv.sqs-block-opentable-v2 h1 {\n  color: #111;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-picker-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: 10px 0;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-picker-wrapper\n  .ot-dtp-picker-selector {\n  margin: 10px;\n  border-left: none !important;\n}\n\n@media only screen and (max-width: 650px) {\n  div.sqs-block-opentable-v2 .squarespace-opentable-picker-wrapper {\n    display: block;\n    margin: 0;\n  }\n\n  div.sqs-block-opentable-v2\n    .squarespace-opentable-picker-wrapper\n    .ot-dtp-picker-selector {\n    margin: 20px auto;\n    float: none !important;\n  }\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-button-wrapper {\n  text-align: center;\n  display: block;\n}\n\ndiv.sqs-block-opentable-v2 .squarespace-opentable-button-wrapper .ot-button {\n  float: none !important;\n  line-height: 1em;\n  display: inline;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-button-wrapper\n  .ot-dtp-picker-button {\n  border-radius: 0px !important;\n  box-shadow: none;\n  border: none;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-new-age-wrapper.opentable-block-hide-icons\n  .ot-dtp-picker-selector-link {\n  padding-left: 0.875rem;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-new-age-wrapper.opentable-block-hide-icons\n  .ot-dtp-picker-selector-link:before {\n  display: none;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-new-age-wrapper.opentable-block-hide-title\n  .squarespace-ot-title {\n  display: none !important;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-new-age-wrapper.opentable-block-hide-title\n  .squarespace-opentable-picker-wrapper {\n  margin-top: -10px;\n}\n\ndiv.sqs-block-opentable-v2\n  .squarespace-opentable-new-age-wrapper.opentable-block-hide-logo\n  .ot-powered-by {\n  display: none;\n}\n\n.field-error {\n  border-radius: 2px;\n  background: #cc3b3b\n    /* url(\"//assets.squarespace.com/universal/images-v6/standard/icon_close_7_light.png\") */\n    no-repeat 9px 50%;\n  color: #fff;\n  display: inline-block;\n  font-size: 13px;\n  line-height: 23px;\n  margin: 12px 0;\n  padding: 5px 15px 3px 25px;\n}\n\n.form-wrapper .form-submission-text:focus:not(:focus-visible),\n.form-wrapper .form-submission-html:focus:not(:focus-visible),\n.form-wrapper .field-error:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.form-wrapper .field-list {\n  line-height: normal;\n}\n\n.form-wrapper .field-list fieldset,\n.form-wrapper .field-list legend {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.form-wrapper .field-list textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.form-wrapper .field-list textarea.medium {\n  min-height: 200px;\n}\n\n.form-wrapper .field-list textarea.large {\n  min-height: 300px;\n}\n\n.form-wrapper .field-list .section {\n  margin: 2em 0;\n  padding-bottom: 0.3em;\n  font-size: 0.9em;\n}\n\n.form-wrapper .field-list .section.underline {\n  border-bottom: 1px solid #999;\n}\n\n.form-wrapper .field-list .section:nth-child(1) {\n  margin: 0 0 2em 0;\n}\n\n.form-wrapper .field-list .title {\n  display: block;\n}\n\n.form-wrapper .field-list .description {\n  padding: 0.5em 0 0.5em;\n  font-size: 12px;\n  opacity: 0.7;\n  display: block;\n  white-space: pre-wrap;\n}\n\n.form-wrapper .field-list .field {\n  position: relative;\n  margin: 0 0 24px;\n}\n\n.form-wrapper .field-list .field .caption {\n  font-size: 12px;\n}\n\n.form-wrapper .field-list .field .caption .field-element {\n  font-size: 14px;\n}\n\n.form-wrapper .field-list .field .field-element {\n  width: 100%;\n  padding: 12px;\n  margin: 6px 0 4px;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  color: #000;\n  font-family: sans-serif;\n  font-size: 12px;\n  line-height: normal;\n  box-sizing: border-box;\n  border-radius: 2px;\n}\n\n.form-wrapper .field-list .field .field-element:focus {\n  background: #fff;\n  transition: background 0.1s ease-in;\n}\n\n.form-wrapper .field-list .field select {\n  margin: 6px 0 4px;\n  max-width: 100%;\n}\n\n.form-wrapper .field-list .field .prefix {\n  position: absolute;\n  bottom: 16px;\n  left: 8px;\n  color: #aaa;\n  font-family: sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.form-wrapper .field-list .field.twitter .field-element {\n  padding-left: 22px;\n}\n\n.form-wrapper .field-list .field.currency.hassymbol .field-element {\n  padding-left: 20px;\n}\n\n.form-wrapper .field-list .field.website .field-element {\n  padding-left: 45px;\n}\n\n.form-wrapper .field-list .field.checkbox label,\n.form-wrapper .field-list .field.radio label {\n  cursor: pointer;\n}\n\n.form-wrapper .field-list .field.checkbox input,\n.form-wrapper .field-list .field.radio input {\n  margin-right: 5px;\n}\n\n.form-wrapper .field-list .field .option {\n  margin: 6px 0 4px;\n  font-size: 13px;\n}\n\n.form-wrapper .field-list .field.likert .item {\n  margin: 1.6em 0 1.6em 0;\n}\n\n.form-wrapper .field-list .field.likert .question {\n  margin: 0 0 0.5em 0;\n  font-size: 0.9em;\n}\n\n.form-wrapper .field-list .field.likert .option {\n  width: 20%;\n  float: left;\n  text-align: left;\n  border-top: 1px solid #ddd;\n}\n\n.form-wrapper .field-list .field.likert .option label {\n  margin: 0;\n  padding: 0 0 0 1px;\n  font-size: 0.9em;\n  display: block;\n  cursor: pointer;\n}\n\n.form-wrapper .field-list .field.likert .option input {\n  margin: 10px 0;\n  display: block;\n}\n\n.form-wrapper .field-list .field.likert .option:last-of-type {\n  border-right: none;\n}\n\n.form-wrapper .field-list .fields {\n  margin: 0 0 0 -2%;\n}\n\n.form-wrapper .field-list .fields .title,\n.form-wrapper .field-list .fields .description,\n.form-wrapper .field-list .fields .field,\n.form-wrapper .field-list .fields .field-error {\n  margin-left: 2%;\n}\n\n.form-wrapper .field-list .fields .field {\n  float: left;\n}\n\n.form-wrapper .field-list .fields .field.two-digits {\n  width: 3.5em;\n}\n\n.form-wrapper .field-list .fields .field.three-digits {\n  width: 4.2em;\n}\n\n.form-wrapper .field-list .fields .field.four-digits {\n  width: 4.8em;\n}\n\n.form-wrapper .field-list .fields .field.ampm {\n  width: 4.5em;\n}\n\n.form-wrapper .field-list .fields.name .field {\n  width: 48%;\n}\n\n.form-wrapper .field-list .fields.address .field.address1,\n.form-wrapper .field-list .fields.address .field.address2 {\n  width: 98%;\n}\n\n.form-wrapper .field-list .fields.address .field.city {\n  width: 70%;\n}\n\n.form-wrapper .field-list .fields.address .field.state-province {\n  width: 26%;\n}\n\n.form-wrapper .field-list .fields.address .field.zip {\n  width: 36%;\n}\n\n.form-wrapper .field-list .fields.address .field.country {\n  width: 98%;\n}\n\n.form-wrapper .field-list .fields.payment .field.card-expiry-month {\n  width: 40%;\n}\n\n.form-wrapper .field-list .fields.payment .field.card-expiry-year {\n  width: 40%;\n}\n\n.form-wrapper .field-list .form-item.error,\n.form-wrapper .field-list .form-item.error .caption,\n.form-wrapper .field-list .form-item.error .title,\n.form-wrapper .field-list .form-item.error .description {\n  color: #bd0000;\n}\n\n.form-wrapper .field-list .form-item.error input,\n.form-wrapper .field-list .form-item.error textarea {\n  border: 1px solid #e99292;\n}\n\n.form-wrapper .form-button-wrapper--align-left {\n  text-align: left;\n}\n\n.form-wrapper .form-button-wrapper--align-center {\n  text-align: center;\n}\n\n.form-wrapper .form-button-wrapper--align-right {\n  text-align: right;\n}\n\n.form-wrapper input[type=\"submit\"] {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  font-size: 14px;\n  text-transform: none;\n}\n\n.form-wrapper .form-submission-text {\n  margin-top: 20px;\n}\n\n.form-wrapper .field .field-error {\n  margin-bottom: 0.5em;\n}\n\n.form-wrapper .submitting .field-list {\n  opacity: 0.7;\n}\n\n.form-wrapper .hidden,\n.form-wrapper.hidden {\n  display: none;\n}\n\n.form-block .lightbox-handle-wrapper--align-left {\n  text-align: left;\n}\n\n.form-block .lightbox-handle-wrapper--align-center {\n  text-align: center;\n}\n\n.form-block .lightbox-handle-wrapper--align-right {\n  text-align: right;\n}\n\n.form-block .lightbox-handle {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  font-size: 14px;\n  text-transform: none;\n}\n\n.sqs-modal-lightbox {\n  width: 100%;\n  font-size: 14px;\n  text-transform: none;\n  font-style: normal;\n  text-decoration: none;\n}\n\n.sqs-modal-lightbox-content {\n  z-index: 100000000;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n}\n\n.sqs-modal-lightbox-content .lightbox-background {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.4;\n}\n\n.sqs-modal-lightbox-content .lightbox-inner {\n  position: fixed;\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  top: 0;\n}\n\n.sqs-modal-lightbox-content .lightbox-inner .lightbox-content {\n  max-width: 600px;\n  margin: 0 auto;\n  position: relative;\n  padding: 40px;\n  background: #fff;\n}\n\n.sqs-modal-lightbox-content .lightbox-inner .lightbox-content .form-wrapper {\n  color: #222;\n  font-family: inherit;\n}\n\n.sqs-modal-lightbox-content\n  .lightbox-inner\n  .lightbox-content\n  .form-wrapper\n  .form-title {\n  font-size: 22px;\n  line-height: 1.2em;\n  margin-right: 22px;\n  color: #333;\n}\n\n.sqs-modal-lightbox-content\n  .lightbox-inner\n  .lightbox-content\n  .form-wrapper\n  .form-inner-wrapper\n  form {\n  margin-top: 55px;\n}\n\n.sqs-modal-lightbox-content\n  .lightbox-inner\n  .lightbox-content\n  .form-wrapper\n  .form-inner-wrapper\n  form\n  .radio\n  .option {\n  margin-left: 1px;\n}\n\n.sqs-modal-lightbox-content .lightbox-inner .lightbox-content .lightbox-close {\n  position: absolute;\n  color: #333;\n  font-size: 22px;\n  font-family: Arial, Helvetica, sans-serif;\n  font-style: normal;\n  width: 22px;\n  line-height: 22px;\n  top: 40px;\n  right: 40px;\n  text-align: center;\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 600px) {\n  .sqs-modal-lightbox .sqs-modal-lightbox-content {\n    height: 100vh;\n  }\n\n  .sqs-modal-lightbox .lightbox-inner {\n    background: #fff;\n  }\n\n  .sqs-modal-lightbox .lightbox-inner .lightbox-content {\n    margin-top: 0 !important;\n  }\n\n  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper input,\n  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper select,\n  .sqs-modal-lightbox .lightbox-inner .lightbox-content .form-wrapper textarea {\n    font-size: 16px !important;\n    font-size: max(16px, 1rem) !important;\n  }\n}\n\nhtml.sqs-modal-lightbox-open,\nhtml.sqs-modal-lightbox-open body {\n  overflow: hidden;\n}\n\n.sqs-block-accordion .accordion-divider {\n  color: #000;\n}\n\n.sqs-block-accordion .accordion-icon-container {\n  color: #000;\n}\n\n.sqs-block-collectionlink .collectionlink-thumbnail,\n.link-block .collectionlink-thumbnail {\n  overflow: hidden;\n  height: 150px;\n}\n\n.sqs-block-collectionlink .collectionlink-thumbnail a,\n.link-block .collectionlink-thumbnail a {\n  display: block;\n  height: 100%;\n}\n\n.sqs-block-collectionlink .collectionlink-title,\n.link-block .collectionlink-title {\n  font-size: 1.2em;\n}\n\n.sqs-block-collectionlink .collectionlink-title a,\n.link-block .collectionlink-title a {\n  display: block;\n}\n\n.sqs-block-collectionlink\n  .collectionlink-content-below-thumbnail\n  .collectionlink-title,\n.link-block .collectionlink-content-below-thumbnail .collectionlink-title {\n  margin: 1em 0 0 0;\n}\n\n.sqs-block-collectionlink .collectionlink-description,\n.link-block .collectionlink-description {\n  margin: 0.75em 0;\n}\n\n.sqs-block-collectionlink .collectionlink-description p,\n.link-block .collectionlink-description p {\n  font-size: 0.9em;\n}\n\n.sqs-block-collectionlink .collection-more-link,\n.link-block .collection-more-link {\n  display: none;\n  margin-left: 3px;\n}\n\n.sqs-block-collectionlink .sqs-blockStatus + .collectionlink-content,\n.link-block .sqs-blockStatus + .collectionlink-content {\n  display: none;\n}\n\n.sqs-block-tourdates .sqs-spin {\n  position: absolute;\n  top: 50px;\n  left: 50%;\n  margin-left: -15px;\n}\n\n.sqs-widget.sqs-tourdates-bandsintown-list.loading .sqs-tourdates {\n  min-height: 150px;\n}\n\n.sqs-tourdates__item:not(:last-of-type) {\n  border-bottom: 1px solid rgba(130, 130, 130, 0.15);\n}\n\n.sqs-tourdates__item {\n  padding: 17px 0;\n}\n\n.sqs-tourdates__item:first-of-type {\n  padding-top: 0;\n}\n\n.sqs-tourdates__item,\n.sqs-tourdates__venuelocation {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.sqs-tourdates--info--column .sqs-tourdates__info,\n.sqs-tourdates--venuelocation--column .sqs-tourdates__venuelocation {\n  flex-direction: column;\n}\n\n.sqs-tourdates__info {\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n}\n\n.sqs-tourdates__timeframe,\n.sqs-tourdates__venue,\n.sqs-tourdates__location {\n  box-sizing: border-box;\n  padding-right: 1em;\n}\n\n.sqs-tourdates__date {\n  margin-right: 5px;\n}\n\n.sqs-tourdates__timeframe {\n  min-width: 9em;\n}\n\n.sqs-tourdates__venuelocation {\n  flex-grow: 1;\n  flex-wrap: wrap;\n  min-width: 10em;\n}\n\n.sqs-tourdates__venue,\n.sqs-tourdates__location {\n  min-width: 50%;\n}\n\n.sqs-tourdates__venueLink {\n  display: block;\n}\n\n.sqs-tourdates {\n  font-size: 16px;\n  line-height: 28px;\n}\n\n.sqs-tourdates__timeframe {\n  white-space: nowrap;\n  font-size: 13px !important;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n}\n\n.sqs-tourdates__date,\n.sqs-tourdates__weekday {\n  display: inline-block;\n  text-transform: uppercase;\n}\n\n.sqs-tourdates__venue-link,\n.sqs-tourdates__location-link {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\n.sqs-tourdates__lineup {\n  font-size: 14px;\n  line-height: 18px;\n  margin-right: 1em;\n  margin-top: 2px;\n  opacity: 0.6;\n}\n\n.sqs-tourdates__lineup-item {\n  display: inline;\n}\n\n.sqs-tourdates__lineup-item:first-child::before {\n  content: \"w/ \";\n}\n\n.sqs-tourdates__lineup-item:not(:last-of-type):after {\n  content: \", \";\n}\n\n.sqs-tourdates__actions {\n  min-width: 150px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.sqs-tourdates__button {\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  display: inline-block;\n  padding: 0 12px !important;\n  font-size: 11px !important;\n  line-height: 28px;\n}\n\n.sqs-tourdates__button:empty {\n  display: none;\n}\n\n.sqs-tourdates__button--disabled.sqs-tourdates__button,\n.sqs-tourdates__button--soldout.sqs-tourdates__button,\n.sqs-tourdates__button--disabled.sqs-tourdates__button:hover,\n.sqs-tourdates__button--soldout.sqs-tourdates__button:hover {\n  opacity: 0.3;\n  cursor: default;\n  pointer-events: none;\n}\n\n.social-summary-block .state-message.synchronizing {\n  background-image: none;\n  padding-left: 15px;\n}\n\n.social-summary-block .state-message.synchronizing .sync-text {\n  float: left;\n  margin-left: 10px;\n}\n\n.social-summary-block .state-message.synchronizing .spinner {\n  float: left;\n  /* background: transparent\n    url(\"//assets.squarespace.com/universal/images-v6/icons/icon-settings-16-light.png\")\n    center center no-repeat; */\n  height: 19px;\n  width: 19px;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  animation-name: spin-frames;\n}\n\n.sqs-block-spacer .sqs-block-content {\n  visibility: hidden;\n}\n\nh1[data-rte-preserve-empty]:empty::before,\nh2[data-rte-preserve-empty]:empty::before,\nh3[data-rte-preserve-empty]:empty::before,\nh4[data-rte-preserve-empty]:empty::before,\nh5[data-rte-preserve-empty]:empty::before,\nh6[data-rte-preserve-empty]:empty::before,\np[data-rte-preserve-empty]:empty::before {\n  content: \"\";\n  display: inline-block;\n}\n\nol[data-rte-list] li {\n  counter-increment: rte-list;\n}\n\nol[data-rte-list] li:first-child {\n  counter-reset: rte-list;\n}\n\nul[data-rte-list] li,\nol[data-rte-list] li {\n  list-style-type: none;\n}\n\nul[data-rte-list] li > *,\nol[data-rte-list] li > * {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\nul[data-rte-list] li > *:first-child::before,\nol[data-rte-list] li > *:first-child::before {\n  display: inline-block;\n  margin-left: -40px;\n  min-width: 40px;\n  text-align: right;\n  box-sizing: border-box;\n}\n\nli > *:first-child::before {\n  white-space: pre;\n}\n\nol[data-rte-list] li > *:first-child::before {\n  content: \"  \" counter(rte-list) \". \";\n}\n\nol[data-rte-list=\"upper-roman\"] li > *:first-child::before {\n  content: \"  \" counter(rte-list, upper-roman) \". \";\n}\n\nol[data-rte-list=\"upper-alpha\"] li > *:first-child::before {\n  content: \"  \" counter(rte-list, upper-alpha) \". \";\n}\n\nol[data-rte-list=\"lower-alpha\"] li > *:first-child::before {\n  content: \"  \" counter(rte-list, lower-alpha) \". \";\n}\n\nol[data-rte-list=\"lower-roman\"] li > *:first-child::before {\n  content: \"  \" counter(rte-list, lower-roman) \". \";\n}\n\nol[data-rte-list=\"decimal\"] li > *:first-child::before {\n  content: \"  \" counter(rte-list, decimal) \". \";\n}\n\nul[data-rte-list] li > *:first-child::before {\n  padding-right: 10px;\n  content: \"\\2022\";\n}\n\nul[data-rte-list=\"disc\"] li > *:first-child::before {\n  content: \"\\2022\";\n}\n\nul[data-rte-list=\"circle\"] li > *:first-child::before,\nul[data-rte-list] ul[data-rte-list=\"default\"] li > *:first-child::before {\n  content: \"\\25CB\";\n}\n\nul[data-rte-list=\"square\"] li > *:first-child::before,\nul[data-rte-list]\n  ul[data-rte-list]\n  ul[data-rte-list=\"default\"]\n  li\n  > *:first-child::before {\n  content: \"\\25A0\";\n}\n\nul[data-rte-list=\"dash\"] li > *:first-child::before {\n  content: \"-\";\n}\n\n.system-button-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\nbody:not(.button-style-default) .sqs-editable-button,\nbody:not(.button-style-default) .sqs-editable-button-layout {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  border-width: 0;\n  text-align: center;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\nbody:not(.button-style-default) .sqs-editable-button:hover,\nbody:not(.button-style-default) .sqs-editable-button-layout:hover {\n  opacity: 1;\n}\n\nbody:not(.button-style-default) .sqs-editable-button,\nbody:not(.button-style-default) .sqs-editable-button-color,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  color: #fff;\n  background-color: #f0b128;\n  border-color: #f0b128;\n}\n\nbody:not(.button-style-default)\n  .sqs-alternate-block-style-container\n  .sqs-editable-button,\nbody:not(.button-style-default)\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color,\nbody:not(.button-style-default)\n  .sqs-alternate-block-style-container\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  color: #fff;\n  background-color: #272727;\n  border-color: #272727;\n}\n\nbody:not(.button-style-default) .sqs-editable-button,\nbody:not(.button-style-default) .sqs-editable-button-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: proxima-nova;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\nbody:not(.button-style-default).button-style-solid .sqs-editable-button,\nbody:not(.button-style-default).button-style-solid .sqs-editable-button-style,\nbody:not(.button-style-default).button-style-solid\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  transition: 0.1s opacity linear;\n  -webkit-backface-visibility: hidden;\n}\n\nbody:not(.button-style-default).button-style-solid .sqs-editable-button:hover,\nbody:not(.button-style-default).button-style-solid\n  .sqs-editable-button-style:hover,\nbody:not(.button-style-default).button-style-solid\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:hover {\n  opacity: 0.8;\n}\n\nbody:not(.button-style-default).button-style-outline .sqs-editable-button,\nbody:not(.button-style-default).button-style-outline .sqs-editable-button-style,\nbody:not(.button-style-default).button-style-outline\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  border-width: 2px;\n  border-style: solid;\n  transition: 0.1s background-color linear, 0.1s color linear;\n}\n\nbody:not(.button-style-default).button-style-outline .sqs-editable-button,\nbody:not(.button-style-default).button-style-outline .sqs-editable-button-color,\nbody:not(.button-style-default).button-style-outline\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  background-color: transparent;\n  color: #f0b128;\n}\n\nbody:not(.button-style-default).button-style-outline .sqs-editable-button:hover,\nbody:not(.button-style-default).button-style-outline\n  .sqs-editable-button-color:hover,\nbody:not(.button-style-default).button-style-outline\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:hover {\n  background-color: #f0b128;\n  color: #1d1d1d;\n  color: #fff;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-editable-button,\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color {\n  color: #272727;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-editable-button:hover,\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\nbody:not(.button-style-default).button-style-raised .sqs-editable-button,\nbody:not(.button-style-default).button-style-raised .sqs-editable-button-style,\nbody:not(.button-style-default).button-style-raised\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  position: relative;\n  transition: 0.1s background-color linear;\n}\n\nbody:not(.button-style-default).button-style-raised .sqs-editable-button:active,\nbody:not(.button-style-default).button-style-raised\n  .sqs-editable-button-style:active,\nbody:not(.button-style-default).button-style-raised\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:active {\n  top: 1px;\n}\n\nbody:not(.button-style-default).button-style-raised .sqs-editable-button,\nbody:not(.button-style-default).button-style-raised .sqs-editable-button-color,\nbody:not(.button-style-default).button-style-raised\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  box-shadow: 0 2px 0 0 #e09e10;\n}\n\nbody:not(.button-style-default).button-style-raised .sqs-editable-button:hover,\nbody:not(.button-style-default).button-style-raised\n  .sqs-editable-button-color:hover,\nbody:not(.button-style-default).button-style-raised\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:hover {\n  background-color: #f1b636;\n}\n\nbody:not(.button-style-default).button-style-raised .sqs-editable-button:active,\nbody:not(.button-style-default).button-style-raised\n  .sqs-editable-button-color:active,\nbody:not(.button-style-default).button-style-raised\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:active {\n  box-shadow: 0 1px 0 0 #e09e10;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button:hover,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color:hover,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:hover {\n  background-color: #2f2f2f;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button:active,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .sqs-editable-button-color:active,\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\nbody:not(.button-style-default).button-corner-style-square .sqs-editable-button,\nbody:not(.button-style-default).button-corner-style-square\n  .sqs-editable-button-shape,\nbody:not(.button-style-default).button-corner-style-square\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  border-radius: 0;\n}\n\nbody:not(.button-style-default).button-corner-style-rounded\n  .sqs-editable-button,\nbody:not(.button-style-default).button-corner-style-rounded\n  .sqs-editable-button-shape,\nbody:not(.button-style-default).button-corner-style-rounded\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  border-radius: 3px;\n}\n\nbody:not(.button-style-default).button-corner-style-pill .sqs-editable-button,\nbody:not(.button-style-default).button-corner-style-pill\n  .sqs-editable-button-shape,\nbody:not(.button-style-default).button-corner-style-pill\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  border-radius: 300px;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .newsletter-block\n  .newsletter-form-button {\n  border-width: 1px;\n  box-shadow: inset 0px 0px 0px 1px #272727;\n  background: transparent;\n  color: #272727;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .newsletter-block\n  .newsletter-form-button:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-button {\n  box-shadow: inset 0px 0px 0px 1px #272727;\n  color: #272727;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-button:hover {\n  background-color: #272727;\n  color: #fff;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .newsletter-block\n  .newsletter-form-button {\n  border-width: 0 !important;\n  top: -1px;\n  box-shadow: 0 2px 0 0 #131313;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .newsletter-block\n  .newsletter-form-button:hover {\n  background-color: #2f2f2f;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .newsletter-block\n  .newsletter-form-button:active {\n  top: 0px;\n  box-shadow: 0 1px 0 0 #131313;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-button {\n  box-shadow: 0 2px 0 0 #131313;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-button:hover {\n  background-color: #2f2f2f;\n}\n\nbody:not(.button-style-default).button-style-raised\n  .sqs-alternate-block-style-container\n  .newsletter-block\n  .newsletter-form-button:active {\n  box-shadow: 0 1px 0 0 #131313;\n}\n\nbody:not(.button-style-default) .opentable-block .OT_Find_a_Table {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: proxima-nova;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\nbody:not(.button-style-default).button-corner-style-rounded\n  .opentable-block\n  .OT_Find_a_Table {\n  border-radius: 3px;\n}\n\nbody:not(.button-style-default).button-corner-style-pill\n  .opentable-block\n  .OT_Find_a_Table {\n  border-radius: 300px;\n}\n\nbody:not(.button-style-default) #productDetails .ProductItem-view-cart a,\nbody:not(.button-style-default) .productDetails .ProductItem-view-cart a {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: proxima-nova;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  display: block !important;\n  border: none !important;\n}\n\nbody:not(.button-style-default) #productDetails .ProductItem-view-cart a,\nbody:not(.button-style-default) .productDetails .ProductItem-view-cart a {\n  color: #fff !important;\n  background-color: rgba(240, 177, 40, 0.5) !important;\n}\n\nbody:not(.button-style-default) #productDetails .ProductItem-view-cart a:hover,\nbody:not(.button-style-default) .productDetails .ProductItem-view-cart a:hover {\n  opacity: 0.8;\n}\n\nbody:not(.button-style-default) #productDetails .ProductItem-view-cart,\nbody:not(.button-style-default) .productDetails .ProductItem-view-cart {\n  display: block !important;\n  opacity: 0;\n  max-height: 0;\n  transition: opacity 0.5s ease-out, max-height 0.5s ease-out,\n    margin 0.25s ease-out;\n}\n\nbody:not(.button-style-default)\n  #productDetails\n  .cart-added\n  + .ProductItem-view-cart,\nbody:not(.button-style-default)\n  .productDetails\n  .cart-added\n  + .ProductItem-view-cart {\n  margin-top: 10px;\n  opacity: 1;\n  max-height: 200px;\n}\n\nbody:not(.button-style-default)\n  .sqs-alternate-block-style-container\n  .ProductItem-view-cart\n  a {\n  color: #fff !important;\n  background-color: rgba(39, 39, 39, 0.1) !important;\n  color: #272727 !important;\n}\n\nbody:not(.button-style-default).button-corner-style-rounded\n  #productDetails\n  .ProductItem-view-cart\n  a,\nbody:not(.button-style-default).button-corner-style-rounded\n  .productDetails\n  .ProductItem-view-cart\n  a {\n  border-radius: 3px;\n}\n\nbody:not(.button-style-default).button-corner-style-pill\n  #productDetails\n  .ProductItem-view-cart\n  a,\nbody:not(.button-style-default).button-corner-style-pill\n  .productDetails\n  .ProductItem-view-cart\n  a {\n  border-radius: 300px;\n}\n\nbody:not(.button-style-default)\n  .ma-pricing-toggle-wrapper\n  .ma-pricing-options\n  .left-button {\n  border-radius: 300px 0px 0px 300px;\n}\n\nbody:not(.button-style-default)\n  .ma-pricing-toggle-wrapper\n  .ma-pricing-options\n  .right-button {\n  border-radius: 0px 300px 300px 0px;\n}\n\nbody:not(.button-style-default)\n  .ma-pricing-toggle-wrapper\n  .ma-pricing-options\n  .sqs-editable-button.ma-pricing-option-button {\n  color: #f0b128;\n  border: 1px solid #f0b128;\n  background-color: transparent;\n}\n\n@media (hover: hover) {\n  body:not(.button-style-default)\n    .ma-pricing-toggle-wrapper\n    .ma-pricing-options\n    .sqs-editable-button.ma-pricing-option-button:hover {\n    color: #fff;\n    background-color: #f0b128;\n  }\n}\n\nbody:not(.button-style-default)\n  .ma-pricing-toggle-wrapper\n  .ma-pricing-options\n  .sqs-editable-button.ma-pricing-option-selected {\n  color: #fff;\n  background-color: #f0b128;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .ma-pricing-toggle-wrapper\n  .ma-pricing-options\n  .sqs-editable-button.ma-pricing-option-button {\n  border-width: 2px;\n}\n\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockButton-blue {\n  border-width: 0;\n}\n\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .InlineWidgetDropDown-option,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .InlineWidgetDropDown-optionLabel,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .InlineWidgetDropDown-sectionDropdownContent\n  span,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .InlineWidgetDropDown-span,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .MainLabelSpan,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .TockWidget-B2,\nbody:not(.button-style-default)\n  .tock-block\n  div#Tock_widget_container\n  > div.TockWidgetWrapper\n  .InlineWidgetConsumerCalendar-monthHeadingSpan {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n  font-family: proxima-nova !important;\n  font-weight: 600 !important;\n  font-style: normal !important;\n  text-transform: uppercase !important;\n  letter-spacing: 1px !important;\n}\n\nbody:not(.button-style-default)\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .left-button {\n  border-radius: 300px 0px 0px 300px;\n}\n\nbody:not(.button-style-default)\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .right-button {\n  border-radius: 0px 300px 300px 0px;\n}\n\nbody:not(.button-style-default)\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  color: #f0b128;\n  border: 1px solid #f0b128;\n  background-color: transparent;\n}\n\n@media (hover: hover) {\n  body:not(.button-style-default)\n    .pricing-plan-pricing-toggle-wrapper\n    .pricing-plan-pricing-options\n    .sqs-editable-button.pricing-plan-pricing-option-button:hover {\n    color: #fff;\n    background-color: #f0b128;\n  }\n}\n\nbody:not(.button-style-default)\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-selected {\n  color: #fff;\n  background-color: #f0b128;\n}\n\nbody:not(.button-style-default).button-style-outline\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  border-width: 2px;\n}\n\n.announcement-bar-font {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  font-style: normal;\n  letter-spacing: 1px;\n  text-transform: none;\n}\n\n.sqs-announcement-bar {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  text-align: center;\n}\n\n.sqs-announcement-bar-url {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-announcement-bar-text {\n  padding: 0.8em 3em;\n}\n\n.sqs-announcement-bar-text p {\n  margin: 0;\n}\n\n.sqs-announcement-bar-text a {\n  position: relative;\n  text-decoration: underline !important;\n}\n\n.sqs-announcement-bar-close {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 2.8em;\n  height: 2.78em;\n  background: rgba(0, 0, 0, 0.15);\n  color: #fff;\n}\n\n.sqs-announcement-bar-close:after {\n  content: \"×\";\n  display: block;\n  font-family: helvetica, arial, sans-serif;\n  font-size: 1em;\n  font-weight: 100;\n  line-height: 2.7em;\n  letter-spacing: normal;\n  padding: 0;\n}\n\n.sqs-announcement-bar-hidden {\n  display: none;\n}\n\nbody:not(.sqs-seven-one) .sqs-announcement-bar {\n  background: #222;\n}\n\nbody:not(.sqs-seven-one) .sqs-announcement-bar-text {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: \"proxima-nova\", arial, sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  font-style: normal;\n  letter-spacing: 1px;\n  text-transform: none;\n  line-height: 1.2em;\n}\n\nbody:not(.sqs-seven-one) .sqs-announcement-bar-text a {\n  color: #fff !important;\n}\n\nbody:not(.sqs-seven-one) .sqs-announcement-bar-text p {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: \"proxima-nova\", arial, sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  font-style: normal;\n  letter-spacing: 1px;\n  text-transform: none;\n  color: #fff;\n  line-height: inherit;\n}\n\nbody:not(.sqs-seven-one) .sqs-announcement-bar-close {\n  background: rgba(0, 0, 0, 0.15);\n  color: #fff;\n}\n\n@media screen and (max-width: 1024px) {\n  .sqs-announcement-bar-text,\n  .sqs-announcement-bar-text p {\n    font-size: 13px;\n  }\n}\n\nhtml.touch .sqs-product-quick-view-button-wrapper {\n  display: none !important;\n}\n\n.sqs-product-quick-view-button-wrapper {\n  display: flex;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  z-index: auto;\n  box-sizing: border-box;\n}\n\n.tweak-product-quick-view-button-position-top\n  .sqs-product-quick-view-button-wrapper {\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.tweak-product-quick-view-button-position-center\n  .sqs-product-quick-view-button-wrapper {\n  align-items: center;\n  justify-content: center;\n}\n\n.tweak-product-quick-view-button-position-bottom\n  .sqs-product-quick-view-button-wrapper {\n  align-items: flex-end;\n  justify-content: center;\n  bottom: -1px;\n}\n\n.tweak-product-quick-view-button-style-floating.tweak-product-quick-view-button-position-top\n  .sqs-product-quick-view-button-wrapper {\n  padding-top: 1em;\n}\n\n.tweak-product-quick-view-button-style-floating.tweak-product-quick-view-button-position-bottom\n  .sqs-product-quick-view-button-wrapper {\n  padding-bottom: 1em;\n}\n\n.no-touch\n  .sqs-product-quick-view-button-hover-area:hover\n  .sqs-product-quick-view-button-wrapper\n  .sqs-product-quick-view-button {\n  opacity: 1;\n}\n\n.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button {\n  opacity: 0;\n  display: inline-block;\n  position: relative;\n  z-index: 6;\n  width: auto;\n  height: auto;\n  padding: 1.5em;\n  color: #fff;\n  background-color: #1d1d1d;\n  border-width: 0;\n  line-height: 1em;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: opacity 0.3s ease-in;\n}\n\n.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button:focus {\n  opacity: 1;\n}\n\n.sqs-product-quick-view-button-wrapper .sqs-product-quick-view-button:focus {\n  outline-offset: -4px;\n  outline-color: #fff;\n}\n\n.sqs-product-quick-view-button-wrapper\n  .sqs-product-quick-view-button:focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.tweak-product-quick-view-button-style-bar\n  .sqs-product-quick-view-button-wrapper\n  .sqs-product-quick-view-button {\n  width: 100%;\n}\n\n.sqs-product-quick-view-lightbox .sqs-product-quick-view-content {\n  padding: 15px;\n}\n\n.tweak-product-item-gallery-position-left\n  .sqs-product-quick-view-lightbox\n  .sqs-product-quick-view-content\n  .ProductItem-details {\n  padding: 30px 30px 30px 45px;\n}\n\n.tweak-product-item-gallery-position-right\n  .sqs-product-quick-view-lightbox\n  .sqs-product-quick-view-content\n  .ProductItem-details {\n  padding: 30px 45px 30px 30px;\n}\n\n.sqs-product-quick-view-lightbox .ProductItem-gallery {\n  width: 60%;\n}\n\n.sqs-product-quick-view-lightbox .ProductItem-details {\n  width: 40%;\n}\n\n.sqs-product-quick-view-lightbox a.ProductItem-details-title-link {\n  border: none;\n  color: inherit;\n  text-decoration: none;\n}\n\n.tweak-product-quick-view-lightbox-excerpt-display-hide\n  .sqs-product-quick-view-lightbox\n  .ProductItem-details-excerpt {\n  display: none;\n}\n\n.sqs-product-quick-view-lightbox-next-button,\n.sqs-product-quick-view-lightbox-prev-button,\n.sqs-product-quick-view-lightbox-close-button {\n  display: block;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  position: fixed;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sqs-product-quick-view-lightbox-next-button svg,\n.sqs-product-quick-view-lightbox-prev-button svg,\n.sqs-product-quick-view-lightbox-close-button svg {\n  width: 100%;\n  height: 100%;\n}\n\n.sqs-product-quick-view-lightbox-next-button line,\n.sqs-product-quick-view-lightbox-prev-button line,\n.sqs-product-quick-view-lightbox-close-button line,\n.sqs-product-quick-view-lightbox-next-button polyline,\n.sqs-product-quick-view-lightbox-prev-button polyline,\n.sqs-product-quick-view-lightbox-close-button polyline {\n  stroke: #1d1d1d;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-next-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-prev-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-close-button\n  polyline {\n  stroke-width: 2;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-next-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-prev-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-close-button\n  polyline {\n  stroke-width: 4;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-next-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-prev-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-close-button\n  polyline {\n  stroke-width: 6;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-next-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-prev-button\n  polyline,\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-close-button\n  polyline {\n  stroke-width: 8;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-next-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-prev-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-hairline\n  .sqs-product-quick-view-lightbox-close-button\n  line {\n  stroke-width: 0.83333333;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-next-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-prev-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-light\n  .sqs-product-quick-view-lightbox-close-button\n  line {\n  stroke-width: 1.66666667;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-next-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-prev-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-medium\n  .sqs-product-quick-view-lightbox-close-button\n  line {\n  stroke-width: 2.5;\n}\n\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-next-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-prev-button\n  line,\n.tweak-product-quick-view-lightbox-controls-weight-heavy\n  .sqs-product-quick-view-lightbox-close-button\n  line {\n  stroke-width: 3.33333333;\n}\n\n.sqs-product-quick-view-lightbox-next-button {\n  top: 50%;\n  transform: translatey(-50%);\n  right: 12.5px;\n}\n\nbody:not(.tweak-product-quick-view-lightbox-show-arrows)\n  .sqs-product-quick-view-lightbox-next-button {\n  opacity: 0;\n}\n\n.sqs-product-quick-view-lightbox-prev-button {\n  top: 50%;\n  transform: translatey(-50%);\n  left: 12.5px;\n}\n\nbody:not(.tweak-product-quick-view-lightbox-show-arrows)\n  .sqs-product-quick-view-lightbox-prev-button {\n  opacity: 0;\n}\n\n.sqs-product-quick-view-lightbox-close-button {\n  top: 12.5px;\n  right: 12.5px;\n  width: 25px;\n  z-index: 100000001;\n}\n\n.sqs-product-quick-view-lightbox-close-button svg {\n  width: 80%;\n  height: 80%;\n}\n\nbody:not(.tweak-product-quick-view-lightbox-show-close-button)\n  .sqs-product-quick-view-lightbox-close-button {\n  opacity: 0;\n}\n\n.sqs-product-quick-view-lightbox-element-hidden {\n  opacity: 0;\n  visibility: hidden;\n  cursor: default;\n}\n\n.sqs-style-mode-active\n  .sqs-product-quick-view-lightbox\n  .sqs-product-quick-view {\n  pointer-events: none;\n  cursor: not-allowed;\n  cursor: no-drop;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox {\n  visibility: visible;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox\n  .sqs-modal-lightbox-content\n  .lightbox-background {\n  background: rgba(240, 240, 240, 0.6) !important;\n  opacity: 1;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox\n  .sqs-modal-lightbox-content\n  .lightbox-inner\n  .lightbox-content {\n  width: 85%;\n  max-width: 900px;\n  padding: 0px;\n  background: #fff !important;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox\n  .sqs-modal-lightbox-content\n  .lightbox-inner\n  .lightbox-content\n  .lightbox-close {\n  display: none;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox\n  ~ .sqs-widgets-confirmation {\n  z-index: 100000001;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox[hidden] {\n  visibility: hidden;\n  display: block !important;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox[hidden]\n  .sqs-modal-lightbox-content {\n  left: -9999px;\n  opacity: 0;\n  transition: none;\n}\n\n.sqs-product-quick-view-lightbox.sqs-modal-lightbox\n  .sqs-modal-lightbox-content {\n  transition: opacity 0.15s ease-out;\n}\n\n.sqs-layout .html-block.sqs-block img {\n  max-width: 100%;\n  height: auto;\n}\n\n.sqs-layout .html-block.sqs-block img[align=\"left\"] {\n  margin-right: 50px;\n}\n\n.sqs-layout .html-block.sqs-block img[align=\"right\"] {\n  margin-left: 50px;\n}\n\n.sqs-layout .html-block.sqs-block img[align=\"top\"] {\n  vertical-align: top;\n}\n\n.sqs-layout .html-block.sqs-block img[align=\"middle\"] {\n  vertical-align: middle;\n}\n\n.sqs-layout .html-block.sqs-block img[align=\"bottom\"] {\n  vertical-align: bottom;\n}\n\n.sqs-layout .html-block.sqs-block .full-image-float-left,\n.sqs-layout .html-block.sqs-block .thumbnail-image-float-left {\n  float: left;\n  margin-right: 50px;\n}\n\n.sqs-layout .html-block.sqs-block .full-image-float-right,\n.sqs-layout .html-block.sqs-block .thumbnail-image-float-right {\n  float: right;\n  margin-left: 50px;\n}\n\n.sqs-layout .html-block.sqs-block .full-image-block {\n  display: block;\n  margin-bottom: 34px;\n}\n\n.sqs-layout .html-block.sqs-block div[data-src=\"v5\"] img {\n  max-width: 100%;\n}\n\n.sqs-layout .html-block.sqs-block .thumbnail-caption {\n  display: block;\n}\n\n.sqs-layout .html-block.sqs-block .entry-content img {\n  margin: 0 0 34px 0;\n}\n\n.sqs-layout .html-block.sqs-block .alignleft,\n.sqs-layout .html-block.sqs-block img.alignleft {\n  margin-right: 50px;\n  display: inline;\n  float: left;\n  width: auto;\n}\n\n.sqs-layout .html-block.sqs-block .alignright,\n.sqs-layout .html-block.sqs-block img.alignright {\n  margin-left: 50px;\n  display: inline;\n  float: right;\n  width: auto;\n}\n\n.sqs-layout .html-block.sqs-block .aligncenter,\n.sqs-layout .html-block.sqs-block img.aligncenter {\n  margin-right: auto;\n  margin-left: auto;\n  display: block;\n  clear: both;\n  width: auto;\n}\n\n.sqs-layout .html-block.sqs-block blockquote.left {\n  margin-right: 50px;\n  text-align: right;\n  margin-left: 0;\n  width: 33%;\n  float: left;\n}\n\n.sqs-layout .html-block.sqs-block blockquote.right {\n  margin-left: 50px;\n  text-align: left;\n  margin-right: 0;\n  width: 33%;\n  float: right;\n}\n\n[data-test=\"paywall-page-root\"] {\n  text-align: center;\n  margin: auto;\n}\n\n[data-test=\"paywall-page-root\"] .paywall-preview-hidden {\n  visibility: hidden;\n}\n\n[data-test=\"paywall-page-root\"] #headline {\n  margin: 11px;\n  overflow-wrap: break-spaces;\n}\n\n[data-test=\"paywall-page-root\"] #description {\n  margin: 0;\n}\n\n[data-test=\"paywall-page-root\"] #error {\n  margin-top: 44px;\n}\n\n[data-test=\"paywall-page-root\"] .product-blocks-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 28px;\n}\n\n[data-test=\"paywall-page-root\"] .product-blocks-container:has(> :nth-child(4)) {\n  justify-content: flex-start;\n}\n\n[data-test=\"paywall-page-root\"] .product-blocks-container .product-block {\n  min-height: 44px;\n  width: 380px;\n  margin: 16px;\n  padding: 22px;\n  border: 1px solid;\n  border-radius: 10px;\n}\n\n[data-test=\"paywall-page-root\"] .product-blocks-container .product-block .hide,\n[data-test=\"paywall-page-root\"]\n  .product-blocks-container\n  .product-block\n  .join-button.hide {\n  display: none;\n}\n\n[data-test=\"paywall-page-root\"] .see-more-text,\n[data-test=\"paywall-page-root\"] .see-less-text {\n  text-align: left;\n  display: none;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n[data-test=\"paywall-page-root\"] .see-more-node .see-more-text,\n[data-test=\"paywall-page-root\"] .see-less-node .see-less-text {\n  display: block;\n}\n\n[data-test=\"paywall-page-root\"] .sign-in-button {\n  display: inline-block;\n  margin: 11px 0 5px 0;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  color: inherit;\n  background-color: transparent;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-pricing-toggle-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-pricing-options {\n  display: grid;\n  display: -ms-grid;\n  grid-template-columns: repeat(2, 1fr);\n  -ms-grid-columns: 1fr 1fr;\n  list-style-type: none;\n  padding: 0px;\n  margin: 0px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  width: 100%;\n  height: 100%;\n  padding: 0.6em 1.1em !important;\n  text-align: center;\n  border-radius: 0px;\n  color: #272727;\n  border: 1px solid #272727;\n  background-color: transparent;\n}\n\n@media (hover: hover) {\n  [data-test=\"paywall-page-root\"]\n    .pricing-plan-pricing-options\n    .sqs-editable-button.pricing-plan-pricing-option-button:hover {\n    opacity: 1;\n    color: #fff;\n    background-color: #272727;\n  }\n}\n\n[data-test=\"paywall-page-root\"]\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-selected {\n  color: #fff;\n  background-color: #272727;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-pricing-options .left-option {\n  -ms-grid-column: 1;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-pricing-options .right-option {\n  -ms-grid-column: 2;\n}\n\n[data-test=\"paywall-page-root\"] .below-pricing-toggle {\n  margin-top: 33px;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-benefits-divider {\n  margin-top: 22px;\n  margin-bottom: 22px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .pricing-plan-benefit-description:not(:last-child) {\n  margin-bottom: 6px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.left-button {\n  border-radius: 300px 0px 0px 300px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .pricing-plan-pricing-toggle-wrapper\n  .pricing-plan-pricing-options\n  .pricing-plan-pricing-option-button.sqs-editable-button.sqs-system-button.right-button {\n  border-radius: 0px 300px 300px 0px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .primary-button-style-outline\n  .sqs-block-pricing-plan\n  .pricing-plan-pricing-options\n  .sqs-editable-button.pricing-plan-pricing-option-button {\n  border-width: 2px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .productDetails\n  div.product-title.pricing-plan-title {\n  font-size: 1.5em;\n  margin-top: 0;\n  margin-bottom: 11px;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  line-height: normal;\n}\n\n[data-test=\"paywall-page-root\"]\n  .paywall-pricing-aligner\n  .no-pricing-options-aligner {\n  height: 48px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .paywall-pricing-aligner\n  .productDetails\n  div.product-title.pricing-plan-title {\n  margin-top: 33px;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-price-amount {\n  font-size: 2em;\n  margin-top: 11px;\n  line-height: 90%;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-price-amount.non-paywalled {\n  margin-bottom: 61px;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-price-billing-period {\n  font-size: 1em;\n  opacity: 0.75;\n  margin-bottom: 22px;\n  margin-top: 11px;\n}\n\n[data-test=\"paywall-page-root\"]\n  .product-block\n  .productDetails\n  .product-price.pricing-plan-product-price {\n  margin: 0 0 12px 0;\n  line-height: normal;\n}\n\n[data-test=\"paywall-page-root\"]\n  .product-block\n  .productDetails\n  .product-price.pricing-plan-product-price.below-pricing-toggle {\n  margin-top: 33px;\n}\n\n[data-test=\"paywall-page-root\"] .pricing-plan-description {\n  margin: 22px 0 0 0;\n  line-height: normal;\n  font-size: 1em;\n  text-align: left;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n}\n\n[data-test=\"paywall-page-root\"] .see-less-node .pricing-plan-description {\n  -webkit-line-clamp: inherit;\n  display: block;\n}\n\n.product-block .sqs-editable-button {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  padding: 1em 2.5em;\n  color: #fff;\n  background-color: #272727;\n  border-width: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 0px;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n@media all and (max-width: 414px) {\n  [data-test=\"paywall-page-root\"] {\n    width: 350px;\n  }\n}\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Ysabeau Office\";\n  src: url(\"/src/assets/fonts/Ysabeau_Office/YsabeauOffice-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n\n.social-smugmug:before,\n.social-dribbble:before,\n.social-youtube:before,\n.social-vimeo:before,\n.social-twitter:before,\n.social-tumblr:before,\n.social-pinterest:before,\n.social-linkedin:before,\n.social-instagram:before,\n.social-google:before,\n.social-foursquare:before,\n.social-flickr:before,\n.social-facebook:before,\n.social-fivehundredpix:before,\n.social-fivehundredpx:before,\n.social-email:before,\n.social-github:before,\n.social-rss:before,\n.social-spotify:before,\n.social-soundcloud:before,\n.social-itunes:before,\n.social-googleplay:before,\n.social-dropbox:before,\n.social-dropbox2017:before,\n.social-bandsintown:before,\n.social-behance:before,\n.social-codepen:before,\n.social-medium:before,\n.social-rdio:before,\n.social-squarespace:before,\n.social-vine:before,\n.social-yelp:before,\n.social-vevo:before,\n.social-meetup:before,\n.social-twitch:before,\n.social-vsco:before,\n.social-smugmug-square:before,\n.social-dribbble-square:before,\n.social-youtube-square:before,\n.social-vimeo-square:before,\n.social-twitter-square:before,\n.social-tumblr-square:before,\n.social-pinterest-square:before,\n.social-linkedin-square:before,\n.social-instagram-square:before,\n.social-google-square:before,\n.social-foursquare-square:before,\n.social-flickr-square:before,\n.social-facebook-square:before,\n.social-fivehundredpix-square:before,\n.social-fivehundredpx-square:before,\n.social-email-square:before,\n.social-github-square:before,\n.social-rss-square:before,\n.social-spotify-square:before,\n.social-soundcloud-square:before,\n.social-itunes-square:before,\n.social-googleplay-square:before,\n.social-dropbox-square:before,\n.social-dropbox2017-square:before,\n.social-bandsintown-square:before,\n.social-behance-square:before,\n.social-codepen-square:before,\n.social-medium-square:before,\n.social-rdio-square:before,\n.social-squarespace-square:before,\n.social-vine-square:before,\n.social-yelp-square:before,\n.social-vevo-square:before,\n.social-meetup-square:before,\n.social-twitch-square:before,\n.social-vsco-square:before,\n.social-smugmug-round:before,\n.social-dribbble-round:before,\n.social-youtube-round:before,\n.social-vimeo-round:before,\n.social-twitter-round:before,\n.social-tumblr-round:before,\n.social-pinterest-round:before,\n.social-linkedin-round:before,\n.social-instagram-round:before,\n.social-google-round:before,\n.social-foursquare-round:before,\n.social-flickr-round:before,\n.social-facebook-round:before,\n.social-fivehundredpix-round:before,\n.social-fivehundredpx-round:before,\n.social-email-round:before,\n.social-github-round:before,\n.social-rss-round:before,\n.social-spotify-round:before,\n.social-soundcloud-round:before,\n.social-itunes-round:before,\n.social-googleplay-round:before,\n.social-dropbox-round:before,\n.social-dropbox2017-round:before,\n.social-bandsintown-round:before,\n.social-behance-round:before,\n.social-codepen-round:before,\n.social-medium-round:before,\n.social-rdio-round:before,\n.social-squarespace-round:before,\n.social-vine-round:before,\n.social-yelp-round:before,\n.social-vevo-round:before,\n.social-meetup-round:before,\n.social-twitch-round:before,\n.social-vsco-round:before {\n  font-family: \"social-icon-font\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.social-smugmug:before {\n  content: \"\\e600\";\n}\n\n.social-icon-style-square .social-smugmug:before {\n  content: \"\\e601\";\n}\n\n.social-icon-style-round .social-smugmug:before {\n  content: \"\\e602\";\n}\n\n.social-dribbble:before {\n  content: \"\\e603\";\n}\n\n.social-icon-style-square .social-dribbble:before {\n  content: \"\\e604\";\n}\n\n.social-icon-style-round .social-dribbble:before {\n  content: \"\\e605\";\n}\n\n.social-youtube:before {\n  content: \"\\e606\";\n}\n\n.social-icon-style-square .social-youtube:before {\n  content: \"\\e607\";\n}\n\n.social-icon-style-round .social-youtube:before {\n  content: \"\\e608\";\n}\n\n.social-vimeo:before {\n  content: \"\\e609\";\n}\n\n.social-icon-style-square .social-vimeo:before {\n  content: \"\\e60a\";\n}\n\n.social-icon-style-round .social-vimeo:before {\n  content: \"\\e60b\";\n}\n\n.social-twitter:before {\n  content: \"\\e60c\";\n}\n\n.social-icon-style-square .social-twitter:before {\n  content: \"\\e60d\";\n}\n\n.social-icon-style-round .social-twitter:before {\n  content: \"\\e60e\";\n}\n\n.social-tumblr:before {\n  content: \"\\e60f\";\n}\n\n.social-icon-style-square .social-tumblr:before {\n  content: \"\\e610\";\n}\n\n.social-icon-style-round .social-tumblr:before {\n  content: \"\\e611\";\n}\n\n.social-pinterest:before {\n  content: \"\\e612\";\n}\n\n.social-icon-style-square .social-pinterest:before {\n  content: \"\\e613\";\n}\n\n.social-icon-style-round .social-pinterest:before {\n  content: \"\\e614\";\n}\n\n.social-linkedin:before {\n  content: \"\\e615\";\n}\n\n.social-icon-style-square .social-linkedin:before {\n  content: \"\\e616\";\n}\n\n.social-icon-style-round .social-linkedin:before {\n  content: \"\\e617\";\n}\n\n.social-instagram:before {\n  content: \"\\e618\";\n}\n\n.social-icon-style-square .social-instagram:before {\n  content: \"\\e619\";\n}\n\n.social-icon-style-round .social-instagram:before {\n  content: \"\\e61a\";\n}\n\n.social-foursquare:before {\n  content: \"\\e61e\";\n}\n\n.social-icon-style-square .social-foursquare:before {\n  content: \"\\e61f\";\n}\n\n.social-icon-style-round .social-foursquare:before {\n  content: \"\\e620\";\n}\n\n.social-flickr:before {\n  content: \"\\e621\";\n}\n\n.social-icon-style-square .social-flickr:before {\n  content: \"\\e622\";\n}\n\n.social-icon-style-round .social-flickr:before {\n  content: \"\\e623\";\n}\n\n.social-facebook:before {\n  content: \"\\e624\";\n}\n\n.social-icon-style-square .social-facebook:before {\n  content: \"\\e625\";\n}\n\n.social-icon-style-round .social-facebook:before {\n  content: \"\\e626\";\n}\n\n.social-fivehundredpix:before {\n  content: \"\\e627\";\n}\n\n.social-icon-style-square .social-fivehundredpix:before {\n  content: \"\\e628\";\n}\n\n.social-icon-style-round .social-fivehundredpix:before {\n  content: \"\\e629\";\n}\n\n.social-fivehundredpx:before {\n  content: \"\\e627\";\n}\n\n.social-icon-style-square .social-fivehundredpx:before {\n  content: \"\\e628\";\n}\n\n.social-icon-style-round .social-fivehundredpx:before {\n  content: \"\\e629\";\n}\n\n.social-email:before {\n  content: \"\\e62a\";\n}\n\n.social-icon-style-square .social-email:before {\n  content: \"\\e62b\";\n}\n\n.social-icon-style-round .social-email:before {\n  content: \"\\e62c\";\n}\n\n.social-github:before {\n  content: \"\\e62d\";\n}\n\n.social-icon-style-square .social-github:before {\n  content: \"\\e62e\";\n}\n\n.social-icon-style-round .social-github:before {\n  content: \"\\e62f\";\n}\n\n.social-rss:before {\n  content: \"\\e630\";\n}\n\n.social-icon-style-square .social-rss:before {\n  content: \"\\e631\";\n}\n\n.social-icon-style-round .social-rss:before {\n  content: \"\\e632\";\n}\n\n.social-spotify:before {\n  content: \"\\e633\";\n}\n\n.social-icon-style-square .social-spotify:before {\n  content: \"\\e634\";\n}\n\n.social-icon-style-round .social-spotify:before {\n  content: \"\\e635\";\n}\n\n.social-soundcloud:before {\n  content: \"\\e636\";\n}\n\n.social-icon-style-square .social-soundcloud:before {\n  content: \"\\e637\";\n}\n\n.social-icon-style-round .social-soundcloud:before {\n  content: \"\\e638\";\n}\n\n.social-itunes:before {\n  content: \"\\e639\";\n}\n\n.social-icon-style-square .social-itunes:before {\n  content: \"\\e63a\";\n}\n\n.social-icon-style-round .social-itunes:before {\n  content: \"\\e63b\";\n}\n\n.social-googleplay:before {\n  content: \"\\e63c\";\n}\n\n.social-icon-style-square .social-googleplay:before {\n  content: \"\\e63d\";\n}\n\n.social-icon-style-round .social-googleplay:before {\n  content: \"\\e63e\";\n}\n\n.social-dropbox:before {\n  content: \"\\e63f\";\n}\n\n.social-icon-style-square .social-dropbox:before {\n  content: \"\\e640\";\n}\n\n.social-icon-style-round .social-dropbox:before {\n  content: \"\\e641\";\n}\n\n.social-dropbox2017:before {\n  content: \"\\e63f\";\n}\n\n.social-icon-style-square .social-dropbox2017:before {\n  content: \"\\e640\";\n}\n\n.social-icon-style-round .social-dropbox2017:before {\n  content: \"\\e641\";\n}\n\n.social-bandsintown:before {\n  content: \"\\e642\";\n}\n\n.social-icon-style-square .social-bandsintown:before {\n  content: \"\\e643\";\n}\n\n.social-icon-style-round .social-bandsintown:before {\n  content: \"\\e644\";\n}\n\n.social-behance:before {\n  content: \"\\e645\";\n}\n\n.social-icon-style-square .social-behance:before {\n  content: \"\\e646\";\n}\n\n.social-icon-style-round .social-behance:before {\n  content: \"\\e647\";\n}\n\n.social-codepen:before {\n  content: \"\\e648\";\n}\n\n.social-icon-style-square .social-codepen:before {\n  content: \"\\e649\";\n}\n\n.social-icon-style-round .social-codepen:before {\n  content: \"\\e64a\";\n}\n\n.social-medium:before {\n  content: \"\\e64b\";\n}\n\n.social-icon-style-square .social-medium:before {\n  content: \"\\e64c\";\n}\n\n.social-icon-style-round .social-medium:before {\n  content: \"\\e64d\";\n}\n\n.social-rdio:before {\n  content: \"\\e64e\";\n}\n\n.social-icon-style-square .social-rdio:before {\n  content: \"\\e64f\";\n}\n\n.social-icon-style-round .social-rdio:before {\n  content: \"\\e650\";\n}\n\n.social-squarespace:before {\n  content: \"\\e651\";\n}\n\n.social-icon-style-square .social-squarespace:before {\n  content: \"\\e652\";\n}\n\n.social-icon-style-round .social-squarespace:before {\n  content: \"\\e653\";\n}\n\n.social-vine:before {\n  content: \"\\e654\";\n}\n\n.social-icon-style-square .social-vine:before {\n  content: \"\\e655\";\n}\n\n.social-icon-style-round .social-vine:before {\n  content: \"\\e656\";\n}\n\n.social-yelp:before {\n  content: \"\\e657\";\n}\n\n.social-icon-style-square .social-yelp:before {\n  content: \"\\e658\";\n}\n\n.social-icon-style-round .social-yelp:before {\n  content: \"\\e659\";\n}\n\n.social-meetup:before {\n  content: \"\\e65a\";\n}\n\n.social-icon-style-square .social-meetup:before {\n  content: \"\\e65b\";\n}\n\n.social-icon-style-round .social-meetup:before {\n  content: \"\\e65c\";\n}\n\n.social-vevo:before {\n  content: \"\\e65d\";\n}\n\n.social-icon-style-square .social-vevo:before {\n  content: \"\\e65e\";\n}\n\n.social-icon-style-round .social-vevo:before {\n  content: \"\\e65f\";\n}\n\n.social-twitch:before {\n  content: \"\\e660\";\n}\n\n.social-icon-style-square .social-twitch:before {\n  content: \"\\e661\";\n}\n\n.social-icon-style-round .social-twitch:before {\n  content: \"\\e662\";\n}\n\n.social-vsco:before {\n  content: \"\\e663\";\n}\n\n.social-icon-style-square .social-vsco:before {\n  content: \"\\e664\";\n}\n\n.social-icon-style-round .social-vsco:before {\n  content: \"\\e665\";\n}\n\n.tweak-product-quick-view-button-font {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 12px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.sqs-product-quick-view-button-wrapper {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 12px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.logo-font {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 50px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: none;\n}\n\n.site-tagline-font {\n  font-family: georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: none;\n}\n\n.nav-font {\n  font-family: \"Varela\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 2px;\n  line-height: 5em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.header-bg {\n  background-image: url(\"http://static.squarespace.com/static/508475bee4b0f4598aa96c7c/t/5182d0e6e4b065e39b3b546a/1367527654606/devlin-header.jpg\");\n  background-position: top center;\n  background-size: cover;\n  background-attachment: scroll;\n  background-repeat: no-repeat;\n}\n\n.h1-font {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1.25em;\n  text-transform: none;\n}\n\n.h2-font {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 21px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1.25em;\n  text-transform: none;\n}\n\n.h3-font {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1.25em;\n  text-transform: none;\n}\n\n.body-font {\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 2em;\n  text-align: left;\n  text-transform: none;\n}\n\n.quote-font {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1.75em;\n  text-transform: none;\n}\n\n.summary-heading-font {\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.antialiased {\n  -moz-font-smoothing: antialiased;\n  -o-font-smoothing: antialiased;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n}\n\n.beat-none {\n  -moz-animation: none;\n  -moz-animation-timing-function: none;\n  -o-animation: none;\n  -o-animation-timing-function: none;\n  -webkit-animation: none;\n  -webkit-animation-timing-function: none;\n  animation: none;\n  animation-timing-function: none;\n}\n\n.box-shadow-none {\n  -moz-box-shadow: none;\n  -o-box-shadow: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.display-inline-block {\n  display: inline-block;\n  display: inline;\n  zoom: 1;\n}\n\n.ease-dropdown {\n  -moz-transition: max-height 0.1s ease-in;\n  -o-transition: max-height 0.1s ease-in;\n  -webkit-transition: max-height 0.1s ease-in;\n  transition: max-height 0.1s ease-in;\n}\n\n.ease-none {\n  -moz-transition: none;\n  -o-transition: none;\n  -webkit-transition: none;\n  transition: none;\n}\n\n.flip-horizontal {\n  -moz-transform: scalex(-1);\n  -webkit-transform: scalex(-1);\n  -o-transform: scalex(-1);\n  transform: scalex(-1);\n  filter: fliph;\n}\n\n.form-font {\n  font-family: verdana, helvetica, arial, sans-serif;\n}\n\n.radius-none {\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n}\n\n.txtarea {\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 2em;\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n  -moz-box-shadow: none;\n  -o-box-shadow: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 8px;\n  border: 1px solid #f0b128;\n}\n\nbody {\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 2em;\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n  color: #666;\n}\n\nbody .standard-dialog-wrapper,\nbody .font-family-list-container {\n  text-align: left;\n}\n\nbody.no-scroll {\n  width: 100%;\n}\n\n#header > .wrapper {\n  position: relative;\n}\n\n#header > .wrapper .primary-image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: -1px;\n  left: 0;\n  z-index: -1;\n  background-color: #333;\n}\n\n#header > .wrapper .primary-image.default {\n  background-image: url(\"http://static.squarespace.com/static/508475bee4b0f4598aa96c7c/t/5182d0e6e4b065e39b3b546a/1367527654606/devlin-header.jpg\");\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-image: url(\"https://static.squarespace.com/static/5416a926e4b09de8832655bc/t/5453261fe4b00dd647c7386b/1414735391913/Wafer1-Wide-Grey.png\");\n  background-position: center center;\n  background-size: cover;\n  background-attachment: scroll;\n  background-repeat: repeat;\n}\n\n#header #logo {\n  display: block;\n  padding: 46px 50px;\n  margin: 0 auto;\n  max-width: 1020px;\n}\n\n#header #logo h1.site-title {\n  margin-bottom: 0;\n  text-align: center;\n}\n\n#header #logo .site-title-border {\n  height: 10px;\n}\n\n#header #logo .site-title-span {\n  border-top: 6px solid rgba(0, 0, 0, 0);\n  color: #fff;\n  display: inline-block;\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 50px;\n  font-weight: normal;\n  letter-spacing: 0px;\n  text-transform: none;\n  font-family: Raleway;\n  font-size: 100px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 4px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n#header #logo .site-title-span:hover {\n  color: #f4f4f3;\n}\n\n#header #logo .site-tagline h2 {\n  font-family: georgia, serif;\n  font-size: 18px;\n  font-weight: normal;\n  letter-spacing: 0px;\n  font-family: Raleway;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: 1px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: none;\n  color: #fff;\n  margin-bottom: 0;\n}\n\n#header #logo .site-tagline .spacer {\n  height: 18px;\n}\n\n#header #logo.logo-image .site-title-span {\n  display: none;\n}\n\n#header #logo.logo-image img {\n  height: 55px;\n  line-height: 0;\n}\n\n.mobile-nav,\n.show-nav {\n  display: none;\n}\n\n.primary-nav {\n  background-color: #fff;\n}\n\n.primary-nav .nav {\n  font-family: \"Varela\";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 5em;\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 2px;\n  line-height: 3.4em;\n  text-align: center;\n  text-transform: uppercase;\n  margin: 0 auto;\n  padding: 0 50px;\n  max-width: 1020px;\n}\n\n.primary-nav .nav li {\n  display: inline-block;\n  display: inline;\n  position: relative;\n  zoom: 1;\n  margin: 0 12px;\n}\n\n.primary-nav .nav li a {\n  color: #636363;\n  font-weight: 400;\n}\n\n.primary-nav .nav li a:hover {\n  color: #27c7ff;\n}\n\n.primary-nav .nav li a.active {\n  color: #27c7ff;\n}\n\n.primary-nav .folder-wrapper {\n  cursor: pointer;\n}\n\n.primary-nav .folder-links-wrapper {\n  -moz-transition: max-height 0.1s ease-in;\n  -o-transition: max-height 0.1s ease-in;\n  -webkit-transition: max-height 0.1s ease-in;\n  transition: max-height 0.1s ease-in;\n  top: -18px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  max-height: 0;\n  padding: 0 2em;\n  margin: 3.4em 0 0 -2em;\n  background-color: #fff;\n  z-index: 9999;\n}\n\n.primary-nav .folder-links-wrapper li {\n  display: block;\n  text-align: left;\n  line-height: 1em;\n  margin: 0;\n  padding-bottom: 2em;\n}\n\n.primary-nav .folder-links-wrapper li:first-child {\n  padding-top: 1em;\n}\n\n.primary-nav .folder-wrapper:hover .folder-links-wrapper,\n.primary-nav .folder-wrapper:active .folder-links-wrapper {\n  max-height: 9999px;\n}\n\n.mobile-nav .folder-links-wrapper {\n  display: none;\n}\n\n.folder-nav,\n.category-nav {\n  background-color: #f5f5f5;\n}\n\n.folder-nav .nav,\n.category-nav .nav {\n  font-family: \"Varela\";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 5em;\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 2px;\n  line-height: 3.4em;\n  text-align: center;\n  text-transform: uppercase;\n  margin: 0 auto;\n  padding: 0 50px;\n  max-width: 1020px;\n}\n\n.folder-nav .nav li,\n.category-nav .nav li {\n  display: inline-block;\n  display: inline;\n  zoom: 1;\n  margin: 0 12px;\n}\n\n.folder-nav .nav li a,\n.category-nav .nav li a {\n  color: #000;\n  font-weight: 400;\n}\n\n.folder-nav .nav li a:hover,\n.category-nav .nav li a:hover {\n  color: #15508a;\n}\n\n.folder-nav .nav li a.active,\n.category-nav .nav li a.active {\n  color: #27c7ff;\n}\n\n#site {\n  background-color: #fff;\n  padding: 25px 0;\n}\n\n#site > .wrapper {\n  max-width: 1020px;\n  padding: 0 50px;\n  margin: 0 auto;\n  position: relative;\n}\n\na {\n  text-decoration: none;\n}\n\na:link,\na:visited {\n  color: #15508a;\n}\n\na:hover {\n  color: #555;\n}\n\nb,\nstrong {\n  font-weight: 600;\n}\n\nblockquote,\n.quote-block blockquote {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-weight: normal;\n  line-height: 1.75em;\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0px;\n  line-height: 1.4px;\n  text-transform: none;\n  color: #777;\n  padding: 0 0 0 50px;\n  margin: 50px 0;\n  border-left: 1px solid #f0b128;\n}\n\nblockquote span,\n.quote-block blockquote span {\n  display: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0 0 0.5em;\n}\n\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a {\n  font-weight: normal;\n}\n\nh1 {\n   font-family: \"Ysabeau Office\", sans-serif;\n  font-size: 24px;\n  font-weight: normal;\n  line-height: 1.25em;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0px;\n  line-height: 1.2em;\n  text-transform: none;\n  color: #000;\n}\n\nh2 {\n  font-family: \"Ysabeau Office\", sans-serif;\n  font-size: 21px;\n  font-weight: normal;\n  letter-spacing: 0px;\n  line-height: 1.25em;\n  text-transform: none;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: 1px;\n  line-height: 1em;\n  text-transform: uppercase;\n  color: #f0b128;\n}\n\nh3,\nh4,\nh5,\nh6 {\n   font-family: \"Ysabeau Office\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.25em;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.4em;\n  text-transform: none;\n  color: #444;\n}\n\nul,\nol {\n  margin-bottom: 1em;\n}\n\nul li,\nol li {\n  margin-left: 30px;\n}\n\n.homepage .sqs-block.image-block .image-caption-wrapper p {\n  font-size: 17px;\n}\n\n.homepage .sqs-block.image-block .sqs-block-content a {\n  color: #666;\n}\n\n.homepage\n  .sqs-block.image-block\n  .image-block-outer-wrapper.layout-caption-below\n  .image-caption-wrapper {\n  margin: 1em 0 0;\n}\n\n.calendar-block .date-has-event {\n  color: #15508a;\n}\n\n.sqs-block-horizontalrule hr {\n  border-style: none;\n  border-width: 0;\n  border-top: 1px solid #f0b128;\n  background-color: transparent;\n  height: 0;\n}\n\n.image-block {\n  position: relative;\n}\n\n.image-block .image-caption-wrapper p {\n  font-size: 15px;\n  line-height: 1.5em;\n}\n\n.quote-block blockquote {\n  padding: 0;\n  margin: 0;\n  border-left: 0;\n}\n\n.quote-block .source {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-weight: normal;\n  line-height: 1.75em;\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0px;\n  line-height: 1.4px;\n  text-transform: none;\n  margin: 0;\n  text-align: right;\n}\n\n.link-block .sqs-link a,\n.postsbytag-block li a,\n.postsbymonth-block li a,\n.postsbyauthor-block li a,\n.postsbycategory-block li a,\n.collectionlink-block .collectionlink-title a {\n  padding: 0.25rem 0.4rem;\n  display: block;\n  line-height: 2.5em;\n  font-size: 15px;\n  border-bottom: 1px solid #e3e3e3;\n}\n\nli.gridRendering {\n  border: 1px solid #aaa;\n}\n\nli.gridRendering div.name {\n  line-height: 1.4em;\n}\n\n.link-block .sqs-link a:hover,\n.postsbytag-block li a:hover,\n.postsbymonth-block li a:hover,\n.postsbyauthor-block li a:hover,\n.postsbycategory-block li a:hover,\n.collectionlink-block .collectionlink-title a:hover,\nli.gridRendering a:hover {\n  border: 1px solid #f7f7f7;\n  background-color: #e0e0e0;\n  color: #555;\n}\n\n.collectionlink-block .collectionlink-title {\n  font-family: Bitter;\n  margin-bottom: 0;\n  border-bottom: 1px solid #f0b128;\n}\n\n.collectionlink-block .collectionlink-title a {\n  font-weight: 600;\n  line-height: 1.5em;\n}\n\n.collectionlink-block .collectionlink-title:hover {\n  border-color: #f7f7f7;\n  background-color: #f7f7f7;\n}\n\n.collectionlink-block .collectionlink-title:hover a {\n  color: #555;\n}\n\n.postsbytag-block li a {\n  text-transform: lowercase;\n}\n\n.postsbytag-block li a:before {\n  content: \"#\";\n}\n\n.summary-block .summary-item {\n  margin-bottom: 36px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #f0b128;\n}\n\n.summary-block .summary-item:last-child {\n  padding-bottom: 0;\n  margin-bottom: 0;\n  border-bottom: none;\n}\n\n.summary-block .summary-title {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.25em;\n  font-family: \"Georgia\", \"serif\";\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.4em;\n  text-transform: none;\n}\n\n.summary-block .timestamp {\n  font-size: 14px;\n  text-transform: none;\n}\n\n.tagcloud-block ul li {\n  margin-left: 0;\n  margin-right: 1em;\n}\n\n.tagcloud-block ul li a {\n  font-weight: normal;\n  font-weight: 400;\n}\n\n.category-nav {\n  display: none;\n}\n\n.collection-type-products.show-products-category-navigation .category-nav {\n  display: block;\n}\n\n.absolute-cart-box {\n  top: auto;\n  right: 15px;\n  bottom: 75px;\n}\n\n.absolute-cart-box .sqs-pill-shopping-cart .cart {\n  min-width: 200px;\n}\n\n#productNav {\n  text-transform: capitalize;\n  margin-bottom: 1em;\n}\n\n.sqs-pill-shopping-cart-content {\n  text-align: left;\n}\n\n#productList .product .product-title {\n  font-size: inherit;\n}\n\n.collection-type-blog h1.post-title {\n  margin-bottom: 1em;\n}\n\n.collection-type-blog h1.post-title a {\n  color: #f0b128;\n  font-weight: 500;\n}\n\n.collection-type-blog .item .entry {\n  padding-bottom: 50px;\n}\n\n.collection-type-blog .list .entry {\n  margin-bottom: 30px;\n  padding-bottom: 30px;\n  border-bottom: 1px solid #f0b128;\n}\n\n.collection-type-blog .list .entry:last-of-type {\n  margin-bottom: 0;\n  border-bottom: none;\n}\n\n.collection-type-blog .list.no-pagination .entry:last-of-type {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.collection-type-blog .entry-content {\n  clear: both;\n}\n\n.collection-type-blog .entry-source {\n  margin-top: 1em;\n}\n\n.collection-type-blog .entry .details {\n  color: #999;\n}\n\n.collection-type-blog .entry .details a:link,\n.collection-type-blog .entry .details a:visited {\n  color: #999;\n}\n\n.collection-type-blog .entry .details a:hover {\n  color: #555;\n}\n\n.collection-type-blog .entry .details .post-tags a {\n  text-transform: lowercase;\n}\n\n.collection-type-blog .entry .details .post-tags a:before {\n  content: \"#\";\n}\n\n.collection-type-blog .entry .details .social {\n  vertical-align: middle;\n  margin-top: 10px;\n}\n\n.collection-type-blog .entry .details .sqs-simple-like {\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 2em;\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n}\n\n.collection-type-blog .entry .details .sqs-simple-like .like-icon {\n  -moz-transition: none;\n  -o-transition: none;\n  -webkit-transition: none;\n  transition: none;\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  width: auto;\n  height: auto;\n  background-image: none;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.collection-type-blog .entry .details .sqs-simple-like .like-icon:before {\n  font-family: FontAwesome;\n  font-size: 18px;\n  line-height: 18px;\n  content: \"\\f08a\";\n}\n\n.collection-type-blog .entry .details .sqs-simple-like:hover .like-icon,\n.collection-type-blog .entry .details .sqs-simple-like.clicked .like-icon {\n  -moz-animation: none;\n  -moz-animation-timing-function: none;\n  -o-animation: none;\n  -o-animation-timing-function: none;\n  -webkit-animation: none;\n  -webkit-animation-timing-function: none;\n  animation: none;\n  animation-timing-function: none;\n  -moz-transition: none;\n  -o-transition: none;\n  -webkit-transition: none;\n  transition: none;\n}\n\n.collection-type-blog\n  .entry\n  .details\n  .squarespace-social-buttons.inline-style\n  .ss-social-button-icon {\n  display: none;\n}\n\n.collection-type-blog .sqs-simple-like.float {\n  display: none !important;\n}\n\n.collection-type-blog .filter {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.25em;\n  font-family: \"Georgia\", \"serif\";\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.4em;\n  text-transform: none;\n  margin-bottom: 30px;\n  padding-bottom: 50px;\n  border-bottom: 1px solid #f0b128;\n}\n\n.collection-type-blog .credit:before,\n.collection-type-blog .sqs-comments:before,\n.collection-type-blog .ss-social-button:before {\n  content: \"\";\n  margin-left: 7.5px;\n  padding-left: 7.5px;\n  border-left: 1px solid #f0b128;\n}\n\n.entry-injection {\n  clear: both;\n}\n\n.pagination {\n  padding: 1.5em 0.5em;\n  border-top: 1px solid #f0b128;\n  border-bottom: 1px solid #f0b128;\n  color: #999;\n}\n\n.pagination a {\n  color: #666;\n}\n\n.list .pagination .index {\n  float: right;\n  width: 50%;\n  text-align: right;\n  color: #999;\n}\n\n.squarespace-comments {\n  clear: both;\n  margin: 0;\n  padding-top: 50px;\n}\n\n.squarespace-comments .header-controls .controls .comment-count {\n  font-size: 15px;\n}\n\n.squarespace-comments .new-comment-area {\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 2em;\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n  -moz-box-shadow: none;\n  -o-box-shadow: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 8px;\n  border: 1px solid #f0b128;\n}\n\n.squarespace-comments .new-comment-area .input form.comment-form textarea {\n  font-family: georgia, serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 2em;\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n}\n\n.squarespace-comments .new-comment-area .input,\n.squarespace-comments .new-comment-area input,\n.squarespace-comments .new-comment-area textarea {\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  border: none;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.squarespace-comments .new-comment-area .comment-btn-wrapper {\n  -moz-border-radius: 0;\n  -o-border-radius: 0;\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  border: none;\n}\n\n.squarespace-comments .comments-content .comment-list .comment {\n  margin: 0 10px;\n  padding: 0;\n  border-top: 1px solid #f0b128;\n}\n\n.squarespace-comments .comments-content .comment-list .comment:first-child {\n  border-top: none;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment:first-child\n  .comment-header {\n  border-top: none;\n}\n\n.squarespace-comments .comments-content .comment-list .comment .comment-header {\n  min-height: 15px;\n  overflow: visible;\n  padding: 62.5px 0 0 55px;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment\n  .comment-header\n  .user-info\n  .avatar {\n  width: 40px;\n  height: 40px;\n  margin-top: 3.75px;\n  margin-left: -55px;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment\n  .comment-header\n  .user-info\n  .author {\n  font-size: 15px;\n  margin-right: 0;\n  line-height: 1em;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment\n  .comment-header\n  .user-info\n  .date {\n  font-size: 15px;\n  line-height: 1em;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment\n  .comment-header\n  .user-info\n  .date:before {\n  content: \"wrote, \";\n}\n\n.squarespace-comments .comments-content .comment-list .comment .comment-body {\n  padding: 1em 0 62.5px 55px;\n  color: grey;\n}\n\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"1\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"2\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"3\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"4\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"5\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"6\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"7\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"8\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"9\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"10\"],\n.squarespace-comments .comments-content .comment-list .comment[data-depth=\"11\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .comment[data-depth=\"12\"] {\n  margin-left: 70px;\n}\n\n.squarespace-comments .comments-content .comment-list .reply-area-wrapper {\n  margin-left: 70px;\n}\n\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"1\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"2\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"3\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"4\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"5\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"6\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"7\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"8\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"9\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"10\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"11\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"12\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"13\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"14\"],\n.squarespace-comments\n  .comments-content\n  .comment-list\n  .reply-area-wrapper[data-depth=\"15\"] {\n  margin-left: 125px;\n}\n\n.collection-type-album {\n  text-align: left;\n}\n\n#footer {\n  margin-top: auto;\n  clear: both;\n  border-top: 1px solid rgba(0, 0, 0, 0);\n  background-color: #131313;\n}\n\n#footer > .wrapper {\n  color: #ccc;\n  padding: 45px 50px;\n  max-width: 1020px;\n  margin: 0 auto;\n}\n\n#footer a:link,\n#footer a:visited {\n  color: rgba(240, 177, 40, 0.78);\n}\n\n#footer a:hover {\n  color: #f0b128;\n}\n\n#footer .sqs-block-horizontalrule hr {\n  border-color: #202020;\n}\n\n#footer h1,\n#footer h2,\n#footer h3,\n#footer h4,\n#footer h5,\n#footer h6 {\n  color: #b8b8b8;\n}\n\n.hide-blog-post-author .post-author {\n  display: none !important;\n}\n\n#site .ls #content {\n  max-width: 740px;\n  margin-left: 280px;\n}\n\n#site .ls #sidebar {\n  float: left;\n  left: 50px;\n}\n\n#site .rs #sidebar {\n  float: right;\n  right: 50px;\n}\n\n#site .ls #sidebar,\n#site .rs #sidebar {\n  width: 220px;\n  position: absolute;\n  top: 3px;\n}\n\n#site .ls #sidebar h1,\n#site .rs #sidebar h1,\n#site .ls #sidebar h2,\n#site .rs #sidebar h2,\n#site .ls #sidebar h3,\n#site .rs #sidebar h3,\n#site .ls #sidebar h4,\n#site .rs #sidebar h4,\n#site .ls #sidebar h5,\n#site .rs #sidebar h5,\n#site .ls #sidebar h6,\n#site .rs #sidebar h6 {\n  margin-bottom: 0.5em;\n}\n\n#site .ls #sidebar .form-block .sqs-block-content,\n#site .rs #sidebar .form-block .sqs-block-content {\n  margin-right: 0;\n}\n\n#site .ls #sidebar .form-block .form-wrapper .field-list .section .title,\n#site .rs #sidebar .form-block .form-wrapper .field-list .section .title {\n  font-family: \"Droid Serif\", georgia, serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.25em;\n  font-family: \"Georgia\", \"serif\";\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.4em;\n  text-transform: none;\n  color: #444;\n}\n\n#site .ls #sidebar .image-block .sqs-block-content,\n#site .rs #sidebar .image-block .sqs-block-content {\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n#header .sqs-frontend-edit {\n  top: 0 !important;\n  right: 0;\n}\n\n#logo .sqs-frontend-edit {\n  top: -25px !important;\n  right: 0;\n}\n\n.nav .sqs-frontend-edit {\n  right: -25px !important;\n}\n\n.sqs-block-summary-v2 .summary-title,\n.sqs-block-summary-v2 .summary-heading {\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  text-transform: uppercase;\n  font-family: Bitter;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n  text-transform: capitalize;\n  color: #154f8a;\n}\n\n.sqs-block-summary-v2 .summary-title a,\n.sqs-block-summary-v2 .summary-heading a,\n.sqs-block-summary-v2 .summary-title a:link,\n.sqs-block-summary-v2 .summary-heading a:link,\n.sqs-block-summary-v2 .summary-title a:visited,\n.sqs-block-summary-v2 .summary-heading a:visited {\n  color: #154f8a;\n}\n\n.sqs-block-summary-v2 .summary-title a:hover,\n.sqs-block-summary-v2 .summary-heading a:hover,\n.sqs-block-summary-v2 .summary-title a:link:hover,\n.sqs-block-summary-v2 .summary-heading a:link:hover,\n.sqs-block-summary-v2 .summary-title a:visited:hover,\n.sqs-block-summary-v2 .summary-heading a:visited:hover {\n  color: #555;\n}\n\n.sqs-block-summary-v2 a,\n.sqs-block-summary-v2 a:link,\n.sqs-block-summary-v2 a:visited {\n  color: #15508a;\n}\n\n.sqs-block-summary-v2 a:hover,\n.sqs-block-summary-v2 a:link:hover,\n.sqs-block-summary-v2 a:visited:hover {\n  color: #555;\n}\n\n.sqs-block-summary-v2 .summary-metadata-item {\n  color: rgba(102, 102, 102, 0.7);\n}\n\n.sqs-block-summary-v2 .summary-metadata-item a,\n.sqs-block-summary-v2 .summary-metadata-item a:link,\n.sqs-block-summary-v2 .summary-metadata-item a:visited {\n  color: rgba(102, 102, 102, 0.7);\n}\n\n.sqs-block-summary-v2 .summary-metadata-item a:hover,\n.sqs-block-summary-v2 .summary-metadata-item a:link:hover,\n.sqs-block-summary-v2 .summary-metadata-item a:visited:hover {\n  color: #555;\n}\n\n.full-width {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\n\n.mob-width {\n  width: auto;\n  padding: 40px;\n  margin: 0;\n}\n\n@media all and (max-width: 640px) {\n  body,\n  #site,\n  #header,\n  #footer {\n    padding: 0;\n  }\n\n  h1 {\n    font-size: 30px;\n    line-height: 1.25em;\n  }\n\n  h2 {\n    font-size: 22.5px;\n    line-height: 1.25em;\n  }\n\n  h3 {\n    font-size: 18.75px;\n    line-height: 1.25em;\n  }\n\n  #site > .wrapper,\n  #footer > .wrapper {\n    width: auto;\n    padding: 1rem;\n    margin: 0;\n  }\n\n  .sqs-layout [class*=\"sqs-col\"] {\n    float: none !important;\n    width: auto !important;\n  }\n\n  .sqs-layout .spacer-block {\n    display: none;\n  }\n\n  .sqs-layout .sqs-row .sqs-block:first-child {\n    padding-top: 17px !important;\n  }\n\n  .sqs-layout .sqs-row .sqs-block:last-child {\n    padding-bottom: 17px !important;\n  }\n\n  .sqs-layout .sqs-row + .sqs-row,\n  .sqs-layout .sqs-row + .sqs-block {\n    margin-top: 0 !important;\n  }\n\n  .sqs-gallery-design-grid-slide {\n    width: 50% !important;\n    clear: none !important;\n  }\n\n  .sqsp-chrome-badge {\n    display: none !important;\n  }\n\n  .folder-nav,\n  .primary-nav {\n    display: none;\n  }\n\n  .mobile-nav {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    display: block;\n    font-size: 1em;\n    line-height: 2em;\n    background-color: #fff;\n  }\n\n  .mobile-nav .show-nav {\n    font-family: \"Varela\";\n    font-size: 12px;\n    font-weight: normal;\n    line-height: 5em;\n    font-family: Raleway;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2px;\n    line-height: 3.4em;\n    text-align: center;\n    text-transform: uppercase;\n    text-align: left;\n    display: block;\n    padding: 1em 40px;\n    color: #666;\n    cursor: pointer;\n    border-bottom: 1px solid #e8e8e8;\n  }\n\n  .mobile-nav .show-nav:before {\n    content: \"Menu\";\n  }\n\n  .mobile-nav .show-nav:after {\n    position: absolute;\n    top: 1em;\n    right: 40px;\n    content: \"+\";\n  }\n\n  .mobile-nav .nav {\n    font-family: \"Varela\";\n    font-size: 12px;\n    font-weight: normal;\n    line-height: 5em;\n    font-family: Raleway;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2px;\n    line-height: 3.4em;\n    text-align: center;\n    text-transform: uppercase;\n    -moz-transition: padding 0.1s ease-in, max-height 0.1s ease-in;\n    -o-transition: padding 0.1s ease-in, max-height 0.1s ease-in;\n    -webkit-transition: padding 0.1s ease-in, max-height 0.1s ease-in;\n    transition: padding 0.1s ease-in, max-height 0.1s ease-in;\n    text-align: left;\n    padding: 0;\n    margin: 0;\n    max-height: 0;\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  .mobile-nav .nav li {\n    margin: 0;\n    display: block;\n    padding: 1em 40px;\n    text-decoration: none;\n    border-bottom: 1px solid #e8e8e8;\n  }\n\n  .mobile-nav .nav li a:link,\n  .mobile-nav .nav li a:visited,\n  .mobile-nav .nav li a:hover {\n    color: #666;\n    background-color: transparent;\n    font-weight: 400;\n  }\n\n  .mobile-nav .nav .folder-links-wrapper {\n    -moz-transition: padding-bottom 0.1s ease-in, max-height 0.1s ease-in;\n    -o-transition: padding-bottom 0.1s ease-in, max-height 0.1s ease-in;\n    -webkit-transition: padding-bottom 0.1s ease-in, max-height 0.1s ease-in;\n    transition: padding-bottom 0.1s ease-in, max-height 0.1s ease-in;\n    margin: 0;\n    padding: 0;\n    /* max-height: 0; */\n    overflow: hidden;\n  }\n\n  .mobile-nav .nav .folder-links-wrapper li {\n    margin: 1em 0 0 1em;\n    padding: 0;\n    border-bottom: none;\n  }\n\n  .mobile-nav .nav .folder-links-wrapper li a {\n    margin: 0;\n    padding: 0;\n  }\n\n  .mobile-nav .nav .folder-wrapper > a {\n    display: block;\n    position: relative;\n    border-bottom: none;\n    cursor: pointer;\n    color: #666;\n    background-color: transparent;\n  }\n\n  .mobile-nav .nav .folder-wrapper > a:after {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    content: \"+\";\n  }\n\n  .mobile-nav .nav .folder-wrapper.show .show-folder:after {\n    content: \"-\";\n  }\n\n  .mobile-nav .nav .folder-wrapper.show .folder-links-wrapper {\n    max-height: 9999px;\n    padding-bottom: 1.5em;\n  }\n\n  .mobile-nav.show .nav {\n    max-height: 9999px;\n  }\n\n  .mobile-nav.show .show-nav:before {\n    opacity: 0.5;\n  }\n\n  .mobile-nav.show .show-nav:after {\n    opacity: 0.5;\n    content: \"-\";\n  }\n\n  #header {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  #header #logo {\n    width: auto;\n    padding: 40px;\n    margin: 0;\n  }\n\n  #header #logo.logo-image img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  #site .ls,\n  #site .rs {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  #site .ls #content,\n  #site .rs #content {\n    width: auto;\n    padding: 1rem;\n    margin: 0;\n  }\n\n  #site .ls #sidebar,\n  #site .rs #sidebar {\n    width: auto;\n    padding: 40px;\n    margin: 0;\n    float: none;\n    top: auto;\n    right: auto;\n    left: auto;\n    position: static;\n    border-top: 1px dotted #f0b128;\n  }\n\n  #site .ls #sidebar .sqs-layout > .sqs-row,\n  #site .rs #sidebar .sqs-layout > .sqs-row {\n    margin-right: -15px;\n  }\n\n  .collection-type-blog #site > .wrapper {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  .collection-type-blog #site .ls #content,\n  .collection-type-blog #site .rs #content {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  .collection-type-blog .entry {\n    width: auto;\n    padding: 40px;\n    margin: 0;\n  }\n\n  .collection-type-blog .list .entry {\n    margin-bottom: 0;\n    padding-bottom: 40px;\n  }\n\n  .collection-type-blog .list.no-pagination .entry:last-of-type {\n    padding-bottom: 40px;\n  }\n\n  .collection-type-blog h1.post-title {\n    margin-bottom: 15px;\n    font-size: 30px;\n    line-height: 1.25em;\n  }\n\n  .collection-type-blog .pagination {\n    width: auto;\n    padding: 40px;\n    margin: 0;\n    border-top: none;\n    border-bottom: none;\n  }\n\n  .collection-type-blog .squarespace-comments {\n    padding-top: 40px;\n  }\n\n  .collection-type-blog .squarespace-comments .avatar,\n  .collection-type-blog .squarespace-comments .header-controls {\n    display: none;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .top-level-comment-area {\n    margin-bottom: 40px;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment {\n    margin: 0 -5% 40px;\n    padding: 40px 5% 0;\n    border-top: 1px dotted #f0b128;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-header {\n    padding: 0;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-header\n    .controls {\n    display: none !important;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-header\n    .user-info {\n    margin-right: 0;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-header\n    .user-info\n    .date {\n    display: inline;\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-header\n    .user-info\n    .date:after {\n    content: \" :\";\n  }\n\n  .collection-type-blog\n    .squarespace-comments\n    .comments-content\n    .comment-list\n    .comment\n    .comment-body {\n    padding: 0;\n  }\n}\n\n.logo-font {\n  font-family: Raleway;\n  font-size: 100px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 4px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.site-tagline-font {\n  font-family: Raleway;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: 1px;\n  line-height: 1em;\n  text-align: center;\n  text-transform: none;\n}\n\n.nav-font {\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 2px;\n  line-height: 3.4em;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.header-bg {\n  background-image: url(\"https://static.squarespace.com/static/5416a926e4b09de8832655bc/t/5453261fe4b00dd647c7386b/1414735391913/Wafer1-Wide-Grey.png\");\n  background-position: center center;\n  background-size: cover;\n  background-attachment: scroll;\n  background-repeat: repeat;\n}\n\n.h1-font {\n  font-family: Raleway;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0px;\n  line-height: 1.2em;\n  text-transform: none;\n}\n\n.h2-font {\n  font-family: Raleway;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: 1px;\n  line-height: 1em;\n  text-transform: uppercase;\n}\n\n.h3-font {\n  font-family: \"Georgia\", \"serif\";\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.4em;\n  text-transform: none;\n}\n\n.body-font {\n  font-family: Bitter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0px;\n  line-height: 1.5em;\n  text-align: left;\n  text-transform: none;\n}\n\n.quote-font {\n  font-family: Raleway;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0px;\n  line-height: 1.4px;\n  text-transform: none;\n}\n\n.summary-heading-font {\n  font-family: Bitter;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n  text-transform: capitalize;\n}\n\n.small-button-block-font {\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.medium-button-block-font {\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.large-button-block-font {\n  font-family: \"proxima-nova\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.system-button-font {\n  font-family: proxima-nova;\n  font-weight: 600;\n  font-style: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.announcement-bar-font {\n  font-family: \"proxima-nova\", arial, sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  font-style: normal;\n  letter-spacing: 1px;\n  text-transform: none;\n}\n\n/*! Squarespace LESS Compiler  (less.js language v1.3.3)  */\nh2 a {\n  color: #f0b128 !important;\n}\n\nh2 a:hover {\n  color: #555 !important;\n}\n\n.folder-links-wrapper a {\n  border-bottom: solid 1px #ccc;\n  font-size: 14px !important;\n}\n\n#logo {\n  padding: 80px;\n}\n\n.collection-type-products #logo {\n  padding: 30px;\n}\n\n.collection-type-blog #logo div {\n  display: none;\n}\n\n.collection-type-blog #logo h1 {\n  display: none;\n}\n\n[class*=\"sqs-col\"] .sqs-block {\n  /* padding: 4px 17px 7px 17px; */\n}\n\n#collection-5429503be4b0e1ecd7f5fd93 input {\n  line-height: 2;\n}\n\n.folder-nav .nav {\n  font-size: 14px;\n}\n\n.folder-nav .nav li a {\n  font-weight: 500;\n  color: #777;\n}\n\n.folder-nav .nav li a.active {\n  font-weight: 600;\n}\n\n.category-nav {\n  background-color: #27c7ff;\n}\n\n.category-nav .nav {\n  font-size: 14px;\n}\n\n.category-nav .nav li a {\n  color: #fff;\n  font-weight: 500;\n}\n\n.category-nav .nav li a.active {\n  color: #15508a;\n  font-weight: 600;\n}\n\n.product-price {\n  display: none !important;\n}\n\n.product-variants {\n  display: none !important;\n}\n\n.product-quantity-input {\n  display: none !important;\n}\n\n.sqs-add-to-cart-button-wrapper {\n  display: none !important;\n}\n\n.product-sharing {\n  display: none !important;\n}\n\n#productSummary {\n  border-bottom: solid 1px #f0b128;\n}\n\n.collection-type-blog #block-98725074aa7bcf225f98,\n.collection-type-blog #block-yui_3_17_2_10_1413534870359_9006,\n.collection-type-blog #block-yui_3_17_2_10_1413534870359_21920,\n.collection-type-blog #block-8822b803a555c7d462ad,\n.collection-type-blog #block-20b5f3143d3fcdf61862,\n.collection-type-blog #block-yui_3_17_2_1_1413532087177_7402,\n.collection-type-blog #block-161688358dde6a56e873 {\n  display: none;\n}\n\n.collection-type-products #block-yui_3_17_2_16_1416047625247_27154,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_7606,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_17455,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_8203,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_18341,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_10272,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_8567,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_18545,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_10893,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_8933,\n.collection-type-products #block-yui_3_17_2_15_1416047625247_18735 {\n  display: none;\n}\n\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_16_1416047625247_27154,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_7606,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_17455,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8203,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18341,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_10272,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8567,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18545,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_10893,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_8933,\n.collection-544f8939e4b05ebdf7f8bccc #block-yui_3_17_2_15_1416047625247_18735 {\n  display: none;\n}\n\n.collection-type-blog .social {\n  display: none;\n}\n\n.collection-type-blog h1 a {\n  color: #15508a !important;\n}\n\n.collection-type-blog h1 a:hover {\n  color: #555 !important;\n}\n\n#block-yui_3_17_2_16_1416047625247_27154 {\n  background-color: #444;\n  padding-top: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_7606 {\n  background-color: #444;\n  padding-bottom: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_17455 {\n  background-color: #ffff8c;\n  padding-top: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_8203 {\n  background-color: #ffff8c;\n  padding-bottom: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_10272 {\n  background-color: #abff93;\n  padding-top: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_8567 {\n  background-color: #abff93;\n  padding-bottom: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_10893 {\n  background-color: #e88c8a;\n  padding-top: 15px;\n}\n\n#block-yui_3_17_2_15_1416047625247_8933 {\n  background-color: #e88c8a;\n  padding-bottom: 15px;\n}\n\n#block-yui_3_17_2_42_1414753045025_4291 {\n  display: none;\n}\n\n.primary-nav .sqs-block-search {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.primary-nav .search-input {\n  max-width: 200px;\n}\n\n.primary-nav .sqs-search-ui-button-wrapper.color-dark .search-input {\n  border: none !important;\n  border-bottom: solid 2px #888 !important;\n  height: 35px;\n}\n\n#mobile-navigation > ul > li:nth-last-child(1) a:before {\n  /* content: url(/universal/images-v6/icons/icon-searchqueries-20-light.png); */\n  vertical-align: -15%;\n}\n\n#mobile-navigation ul > li:nth-last-child(1) a {\n  margin-left: -5px;\n}\n\n#mobile-navigation ul li {\n  vertical-align: middle;\n}\n\n.primary-nav li {\n  vertical-align: middle;\n}\n\n.sqs-block-summary-v2 .summary-title,\n.sqs-block-summary-v2 .summary-heading {\n  letter-spacing: 0px;\n  text-transform: capitalize;\n}\n\n/* // here */\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n\n  70% {\n    transform: scale(0.9);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes bounceOut {\n  0% {\n    transform: scale(1);\n  }\n\n  25% {\n    transform: scale(0.95);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .mobile-hidden,\n  .subDesktop-hidden {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 433px) {\n  .desktop-hidden {\n    display: none;\n  }\n}\n\n.sqs-licensed-asset-preview-bar {\n  background-color: #3e3e3e;\n  bottom: 0;\n  color: #fff;\n  height: 88px;\n  left: 0;\n  position: fixed;\n  right: 0;\n  z-index: 9999;\n}\n\n.sqs-licensed-asset-preview-bar-content {\n  box-sizing: border-box;\n  padding: 11px;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n}\n\n.sqs-licensed-asset-preview-bar-content span {\n  font-family: helvetica, sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.squarespace-damask .sqs-mobile-info-bar a[href*=\"tel\"] {\n  pointer-events: none;\n}\n\n.sqs-mobile-info-bar-triggers {\n  font-size: 0;\n  padding: 0 20px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.sqs-mobile-info-bar {\n  background: #ebebeb;\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  transition: all 0.2s cubic-bezier(0.23, 0.47, 0.32, 1);\n  width: 100%;\n  z-index: 10000;\n}\n\n.sqs-mobile-info-bar :focus {\n  outline-color: #222;\n}\n\n.sqs-mobile-info-bar :focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-mobile-info-bar-content {\n  -webkit-backface-visibility: hidden;\n}\n\n.sqs-mobile-info-bar-trigger {\n  cursor: pointer;\n  display: inline-block;\n  padding: 15px 0;\n  text-align: center;\n  width: 25%;\n}\n\n.sqs-mobile-info-bar-trigger a {\n  display: block;\n}\n\n.sqs-mobile-info-bar-trigger-icon {\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: block;\n  height: 16px;\n  margin: 0 auto 8px;\n  width: 16px;\n}\n\n.sqs-mobile-info-bar-trigger-label {\n  color: #222;\n  display: block;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 10px;\n  letter-spacing: 0.5px;\n  line-height: 1em;\n  text-transform: uppercase;\n}\n\n.sqs-mobile-info-bar-trigger[data-type=\"location\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/map.png);\n}\n\n.sqs-mobile-info-bar-trigger[data-type=\"contactEmail\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/email.png);\n}\n\n.sqs-mobile-info-bar-trigger[data-type=\"contactPhoneNumber\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/call.png);\n}\n\n.sqs-mobile-info-bar-trigger[data-type=\"businessHours\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/hours.png);\n}\n\n.sqs-mobile-info-bar-overlay {\n  align-items: center;\n  background: #ebebeb;\n  color: #222;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  position: fixed;\n  top: 0;\n  transition: opacity 0.2s cubic-bezier(0.23, 0.47, 0.32, 1);\n  visibility: hidden;\n  width: 100%;\n}\n\n.sqs-mobile-info-bar-overlay-content {\n  margin: auto;\n  width: 100%;\n  z-index: 1;\n}\n\n.sqs-mobile-info-bar-overlay-content > div {\n  display: none;\n}\n\n.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map {\n  flex: auto;\n}\n\n.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-map :focus {\n  outline-color: #000;\n}\n\n.sqs-mobile-info-bar-overlay-content\n  .sqs-mobile-info-bar-map\n  :focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-address {\n  background: #ebebeb;\n  box-sizing: border-box;\n  color: #aaa;\n  flex: none;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  height: auto;\n  line-height: 19px;\n  padding: 20px;\n  position: relative;\n  width: 100%;\n}\n\n.sqs-mobile-info-bar-overlay-content\n  .sqs-mobile-info-bar-address\n  [data-type=\"addressTitle\"] {\n  color: #222;\n  font-size: 14px;\n  line-height: 14px;\n  margin: 2px 0 7px;\n}\n\n.sqs-mobile-info-bar-overlay-content .sqs-mobile-info-bar-address-link {\n  background: url(//assets.squarespace.com/universal/images-v6/icons/icon-external-link-18-dark.png)\n    no-repeat;\n  height: 18px;\n  margin-top: -9px;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  width: 18px;\n}\n\n.sqs-mobile-info-bar-overlay-close {\n  background: #ebebeb;\n  cursor: pointer;\n  padding: 13px;\n  position: fixed;\n  right: 10px;\n  top: 10px;\n  z-index: 2;\n}\n\n.sqs-mobile-info-bar-overlay-close:after {\n  color: #222;\n  content: \"×\";\n  display: block;\n  font-family: helvetica, arial, sans-serif;\n  font-size: 19px;\n  font-weight: 100;\n  line-height: 15px;\n  padding: 0;\n}\n\n.sqs-mobile-info-bar-show-overlay {\n  z-index: 12000;\n}\n\n.sqs-mobile-info-bar-show-overlay .sqs-mobile-info-bar-overlay {\n  opacity: 1;\n  visibility: visible;\n}\n\n.sqs-mobile-info-bar-dark {\n  background: #222;\n}\n\n.sqs-mobile-info-bar-dark :focus {\n  outline-color: #fff;\n}\n\n.sqs-mobile-info-bar-dark :focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay {\n  background: #222;\n  color: #fff;\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-address {\n  background: #222;\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-address\n  [data-type=\"addressTitle\"] {\n  color: #fff;\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-address-link {\n  background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-external-link-18-light.png);\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-trigger-label {\n  color: #fff;\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-trigger[data-type=\"location\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/map-light.png);\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-trigger[data-type=\"contactEmail\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/email-light.png);\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-trigger[data-type=\"contactPhoneNumber\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/call-light.png);\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-trigger[data-type=\"businessHours\"]\n  .sqs-mobile-info-bar-trigger-icon {\n  background-image: url(//assets.squarespace.com/universal/images-v6/mobile-info-bar/hours-light.png);\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close,\n.sqs-mobile-info-bar-overlay-close-dark {\n  background: #222;\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close:focus,\n.sqs-mobile-info-bar-overlay-close-dark:focus {\n  outline-color: #fff;\n}\n\n.sqs-mobile-info-bar-dark\n  .sqs-mobile-info-bar-overlay-close:focus:not(:focus-visible),\n.sqs-mobile-info-bar-overlay-close-dark:focus:not(:focus-visible) {\n  outline-color: transparent;\n}\n\n.sqs-mobile-info-bar-dark .sqs-mobile-info-bar-overlay-close:after,\n.sqs-mobile-info-bar-overlay-close-dark:after {\n  color: #fff;\n}\n\n.sqs-mobile-info-bar-hide,\n.sqs-style-mode .sqs-mobile-info-bar {\n  transform: translate3d(0, 100px, 0);\n}\n\n.sqs-business-hours {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sqs-business-hours-day {\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  letter-spacing: 1px;\n  line-height: 1.4;\n  margin: 0.5em 0;\n}\n\n.sqs-business-hours-day-label {\n  color: #aaa;\n  float: left;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n  margin-right: 10%;\n  position: relative;\n  text-align: right;\n  text-transform: uppercase;\n  top: 2px;\n  width: 35%;\n}\n\n.sqs-business-hours-day-hours {\n  float: right;\n  width: 55%;\n}\n\n.sqs-business-hours-day .closed {\n  color: #999;\n}\n\n.sqs-business-hours-day:after {\n  clear: both;\n  content: \".\";\n  display: block;\n  font-size: 0;\n  height: 0;\n  visibility: hidden;\n}\n\n.sqs-business-hours-store {\n  color: #aaa;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.65;\n  margin: 1em 0 3em;\n  text-align: center;\n}\n\n.sqs-business-hours-store span {\n  color: #222;\n  font-size: 20px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.sqs-business-hours-dark .sqs-business-hours-store span {\n  color: #fff;\n}\n\n.sqs-ss-badge {\n  background: #000;\n  border-radius: 44px;\n  cursor: pointer;\n  height: 44px;\n  opacity: 0;\n  overflow: hidden;\n  position: fixed;\n  width: 44px;\n  z-index: 10001;\n}\n\n.sqs-ss-badge-content {\n  white-space: nowrap;\n}\n\n.sqs-ss-badge .badge-closed,\n.sqs-ss-badge .badge-open {\n  display: inline-block;\n  height: 44px;\n  transform: scale(1) translatez(0);\n  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n  vertical-align: top;\n}\n\n.sqs-ss-badge .badge-closed {\n  background: transparent\n    url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-16-light.png?20170201)\n    50% no-repeat;\n  width: 44px;\n}\n\n.sqs-ss-badge .badge-open {\n  opacity: 0;\n  width: 0;\n}\n\n.sqs-ss-badge .badge-open .badge-open-inner {\n  white-space: nowrap;\n}\n\n.sqs-ss-badge .badge-open .badge-open-inner h2 {\n  color: #e2e2e2 !important;\n  font: 300 10px proxima-nova, HelveticaNeue-Light, Helvetica Neue Light,\n    Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif !important;\n  letter-spacing: 0.75px;\n  line-height: 44px !important;\n  margin: 0 !important;\n  text-transform: uppercase;\n}\n\n.sqs-ss-badge[data-position=\"top-left\"] {\n  left: 22px;\n  top: 44px;\n}\n\n.sqs-ss-badge[data-position=\"top-center\"] {\n  left: 0;\n  margin: auto;\n  right: 0;\n  top: 44px;\n}\n\n.sqs-ss-badge[data-position=\"top-right\"] {\n  right: 22px;\n  top: 44px;\n}\n\n.sqs-ss-badge[data-position=\"bottom-left\"] {\n  bottom: 22px;\n  left: 22px;\n}\n\n.sqs-ss-badge[data-position=\"bottom-center\"] {\n  bottom: 20px;\n  left: 0;\n  margin: auto;\n  right: 0;\n}\n\n.sqs-ss-badge[data-position=\"bottom-right\"] {\n  bottom: 22px;\n  right: 22px;\n}\n\n.sqs-ss-badge.badge-auto-hide[data-position=\"top-center\"],\n.sqs-ss-badge.badge-auto-hide[data-position=\"top-left\"],\n.sqs-ss-badge.badge-auto-hide[data-position=\"top-right\"] {\n  transform: translatey(-88px);\n  transition: opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1),\n    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.sqs-ss-badge.badge-auto-hide[data-position=\"bottom-center\"],\n.sqs-ss-badge.badge-auto-hide[data-position=\"bottom-left\"],\n.sqs-ss-badge.badge-auto-hide[data-position=\"bottom-right\"] {\n  transform: translatey(88px);\n  transition: opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1),\n    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.sqs-ss-badge.is-mobile[data-devices=\"desktop-only\"] {\n  display: none;\n}\n\n.sqs-ss-badge[data-type=\"white\"] {\n  background: #fff;\n}\n\n.sqs-ss-badge[data-type=\"white\"] .badge-open .badge-open-inner h2 {\n  color: #111 !important;\n}\n\n.sqs-ss-badge[data-type=\"white\"] .badge-closed {\n  background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-16-dark.png?20170201);\n}\n\n.sqs-ss-badge.badge-visible {\n  opacity: 1;\n  transform: translate3d(0, -22px, 0) !important;\n  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.sqs-ss-badge:not(.is-mobile):hover {\n  border-radius: 0;\n  width: 220px;\n}\n\n.sqs-ss-badge:not(.is-mobile):hover .badge-open {\n  opacity: 1;\n  transform: none;\n}\n\n.sqs-ss-badge-mobile-info-bar-present[data-position=\"bottom-center\"],\n.sqs-ss-badge-mobile-info-bar-present[data-position=\"bottom-left\"],\n.sqs-ss-badge-mobile-info-bar-present[data-position=\"bottom-right\"] {\n  bottom: 72px;\n}\n\n.sqs-ss-badge:not(.is-mobile):hover + .sqs-ss-badge-cover {\n  opacity: 1;\n  visibility: visible;\n}\n\n.sqs-ss-badge[data-position=\"top-left\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at top left,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\n.sqs-ss-badge[data-position=\"top-center\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at top center,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\n.sqs-ss-badge[data-position=\"top-right\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at top right,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\n.sqs-ss-badge[data-position=\"bottom-left\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at bottom left,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\n.sqs-ss-badge[data-position=\"bottom-center\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at bottom center,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\n.sqs-ss-badge[data-position=\"bottom-right\"] + .sqs-ss-badge-cover {\n  background: radial-gradient(\n    circle at bottom right,\n    rgba(0, 0, 0, 0.1) 0,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n}\n\nbody.sqs-style-mode[data-position=\"top-left\"] {\n  left: 242px;\n  top: 22px;\n}\n\nbody.sqs-style-mode[data-position=\"bottom-left\"] {\n  bottom: 22px;\n  left: 242px;\n}\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dppx) {\n  .sqs-ss-badge .badge-closed {\n    background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-32-light.png?20170201);\n    background-size: 16px;\n  }\n\n  .sqs-ss-badge[data-type=\"white\"] .badge-closed {\n    background-image: url(//assets.squarespace.com/universal/images-v6/icons/icon-squarespace-32-dark.png?20170201);\n  }\n}\n\n.sqs-ss-badge-cover {\n  background-color: rgba(0, 0, 0, 0.6);\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease;\n  visibility: hidden;\n  width: 100%;\n  z-index: 10000;\n}\n\n.sqs-block.html-block.sqs-block-html {\n  padding: 0;\n}\n\n@media (min-width: 480px) {\n  .sqs-block-postsbycategory ul,\n  .sqs-block-postsbycategory #homeUL {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .sqs-search-preview-ui {\n    top: 100%;\n  }\n}\n\n@media (min-width: 640px) {\n  .sqs-search-preview-ui {\n    top: 100%;\n  }\n}\n\n@media (min-width: 648px) {\n  .sqs-block-postsbycategory ul {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 900px) {\n  .sqs-block-postsbycategory ul {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n#typeGridDiv {\n  margin-top: 4rem;\n}\n\n.sqs-block-postsbycategory #homeUL li {\n  border: 1px solid #aaa;\n}\n\n.remove-scrolling {\n  height: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
